/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 107);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeComponent;
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addStylesClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listToStyles__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listToStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__listToStyles__);
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = __WEBPACK_IMPORTED_MODULE_0__listToStyles___default()(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = __WEBPACK_IMPORTED_MODULE_0__listToStyles___default()(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory(__webpack_require__(7));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["VueLoading"] = factory(require("vue"));else root["VueLoading"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE__0__) {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
          /******/
        }
        /******/
      };
      /******/
      /******/ // define __esModule on exports
      /******/__webpack_require__.r = function (exports) {
        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
          /******/
        }
        /******/Object.defineProperty(exports, '__esModule', { value: true });
        /******/
      };
      /******/
      /******/ // create a fake namespace object
      /******/ // mode & 1: value is a module id, require it
      /******/ // mode & 2: merge all properties of value into the ns
      /******/ // mode & 4: return value when already ns object
      /******/ // mode & 8|1: behave like require
      /******/__webpack_require__.t = function (value, mode) {
        /******/if (mode & 1) value = __webpack_require__(value);
        /******/if (mode & 8) return value;
        /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
        /******/var ns = Object.create(null);
        /******/__webpack_require__.r(ns);
        /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
        /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        } /******/return ns;
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = 1);
      /******/
    }(
    /************************************************************************/
    /******/[
    /* 0 */
    /***/function (module, exports) {

      module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

      /***/
    },
    /* 1 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";

      __webpack_require__.r(__webpack_exports__);

      // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/js/Component.vue?vue&type=template&id=48345599
      var render = function render() {
        var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('transition', { attrs: { "name": _vm.animation } }, [_vm.isActive ? _c('div', { staticClass: "loading-overlay is-active", class: { 'is-full-page': _vm.isFullPage }, attrs: { "aria-busy": _vm.isActive } }, [_c('div', { staticClass: "loading-background", on: { "click": function click($event) {
              $event.preventDefault();return _vm.cancel($event);
            } } }), _vm._v(" "), _c('div', { staticClass: "loading-icon" })]) : _vm._e()]);
      };
      var staticRenderFns = [];

      // CONCATENATED MODULE: ./src/js/Component.vue?vue&type=template&id=48345599

      // CONCATENATED MODULE: ./src/js/util.js
      var removeElement = function removeElement(el) {
        if (typeof el.remove !== 'undefined') {
          el.remove();
        } else {
          el.parentNode.removeChild(el);
        }
      };

      var hasWindow = function hasWindow() {
        return typeof window !== 'undefined';
      };

      var HTMLElement = !hasWindow ? Object : window.HTMLElement;

      // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/js/Component.vue?vue&type=script&lang=js
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //


      /* harmony default export */var Componentvue_type_script_lang_js = {
        name: 'vue-loading',
        props: {
          active: Boolean,
          programmatic: Boolean,
          container: [Object, Function, HTMLElement],
          isFullPage: {
            type: Boolean,
            default: true
          },
          animation: {
            type: String,
            default: 'fade'
          },
          /**
           * Allow user to hide the loader
           */
          canCancel: {
            type: Boolean,
            default: false
          },
          /**
           * Do something on cancel
           */
          onCancel: {
            type: Function,
            default: function _default() {}
          }
        },
        data: function data() {
          return {
            // Mutable property
            isActive: this.active || false
          };
        },
        created: function created() {
          hasWindow && document.addEventListener('keyup', this.escape);
        },
        beforeMount: function beforeMount() {
          if (hasWindow && this.programmatic) {
            if (!this.container) {
              document.body.appendChild(this.$el);
            } else {
              this.isFullPage = false;
              this.container.appendChild(this.$el);
            }
          }
        },
        mounted: function mounted() {
          if (this.programmatic) this.isActive = true;
        },

        methods: {
          /**
           * Hide the Loader if canCancel is set to true.
           */
          cancel: function cancel() {
            if (!this.canCancel) return;
            if (!this.isActive) return;

            this.hide();
          },

          /**
           * Emit events, and destroy component if it's programmatic.
           */
          hide: function hide() {
            var _this = this;

            this.onCancel.apply(null, arguments);
            this.$emit('close');
            this.$emit('update:active', false);

            // Timeout for the animation complete before destroying
            if (this.programmatic) {
              this.isActive = false;
              setTimeout(function () {
                _this.$destroy();
                removeElement(_this.$el);
              }, 150);
            }
          },

          /**
           * Keypress event that is bound to the document.
           */
          escape: function escape(event) {
            // Esc key
            if (event.keyCode === 27) this.cancel();
          }
        },
        watch: {
          active: function active(value) {
            this.isActive = value;
          }
        },
        beforeDestroy: function beforeDestroy() {
          hasWindow && document.removeEventListener('keyup', this.escape);
        }
      };
      // CONCATENATED MODULE: ./src/js/Component.vue?vue&type=script&lang=js
      /* harmony default export */var js_Componentvue_type_script_lang_js = Componentvue_type_script_lang_js;
      // CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
      /* globals __VUE_SSR_CONTEXT__ */

      // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
      // This module is a runtime utility for cleaner component module output and will
      // be included in the final webpack user bundle.

      function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
      shadowMode /* vue-cli only */
      ) {
        // Vue.extend constructor export interop
        var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

        // render functions
        if (render) {
          options.render = render;
          options.staticRenderFns = staticRenderFns;
          options._compiled = true;
        }

        // functional template
        if (functionalTemplate) {
          options.functional = true;
        }

        // scopedId
        if (scopeId) {
          options._scopeId = 'data-v-' + scopeId;
        }

        var hook;
        if (moduleIdentifier) {
          // server build
          hook = function hook(context) {
            // 2.3 injection
            context = context || // cached call
            this.$vnode && this.$vnode.ssrContext || // stateful
            this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
              context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyles) {
              injectStyles.call(this, context);
            }
            // register component module identifier for async chunk inferrence
            if (context && context._registeredComponents) {
              context._registeredComponents.add(moduleIdentifier);
            }
          };
          // used by ssr in case component is cached and beforeCreate
          // never gets called
          options._ssrRegister = hook;
        } else if (injectStyles) {
          hook = shadowMode ? function () {
            injectStyles.call(this, this.$root.$options.shadowRoot);
          } : injectStyles;
        }

        if (hook) {
          if (options.functional) {
            // for template-only hot-reload because in that case the render fn doesn't
            // go through the normalizer
            options._injectStyles = hook;
            // register for functioal component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
              hook.call(context);
              return originalRender(h, context);
            };
          } else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
          }
        }

        return {
          exports: scriptExports,
          options: options
        };
      }

      // CONCATENATED MODULE: ./src/js/Component.vue


      /* normalize component */

      var component = normalizeComponent(js_Componentvue_type_script_lang_js, render, staticRenderFns, false, null, null, null);

      /* harmony default export */var Component = component.exports;
      // EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","amd":"vue","root":"Vue"}
      var external_commonjs_vue_commonjs2_vue_amd_vue_root_Vue_ = __webpack_require__(0);
      var external_commonjs_vue_commonjs2_vue_amd_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_amd_vue_root_Vue_);

      // CONCATENATED MODULE: ./src/js/api.js


      var LoadingProgrammatic = {
        show: function show() {
          var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var defaultParam = {
            programmatic: true
          };
          var propsData = Object.assign(defaultParam, params);
          var LoadingComponent = external_commonjs_vue_commonjs2_vue_amd_vue_root_Vue_default.a.extend(Component);

          return new LoadingComponent({
            el: document.createElement('div'),
            propsData: propsData
          });
        }
      };

      /* harmony default export */var api = LoadingProgrammatic;
      // EXTERNAL MODULE: ./src/scss/index.scss
      var scss = __webpack_require__(3);

      // CONCATENATED MODULE: ./src/index.js


      var src_Plugin = function Plugin(Vue) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        Vue.$loading = api;
        Vue.prototype.$loading = api;
      };

      Component.install = src_Plugin;

      /* harmony default export */var src = __webpack_exports__["default"] = Component;

      /***/
    },,
    /* 2 */
    /* 3 */
    /***/function (module, exports, __webpack_require__) {

      // extracted by mini-css-extract-plugin

      /***/}]
    /******/)["default"]
  );
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(164);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("4eb3e500", content, true, {});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var bind = __webpack_require__(25);
var isBuffer = __webpack_require__(119);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (_typeof(result[key]) === 'object' && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalWindow_Vue_vue_type_template_id_77790124__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalWindow_Vue_vue_type_script_lang_js__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ModalWindow_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ModalWindow_Vue_vue_type_template_id_77790124__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ModalWindow_Vue_vue_type_template_id_77790124__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Vue.js v2.5.16
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef(v) {
  return v === undefined || v === null;
}

function isDef(v) {
  return v !== undefined && v !== null;
}

function isTrue(v) {
  return v === true;
}

function isFalse(v) {
  return v === false;
}

/**
 * Check if value is primitive
 */
function isPrimitive(value) {
  return typeof value === 'string' || typeof value === 'number' ||
  // $flow-disable-line
  (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol' || typeof value === 'boolean';
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType(value) {
  return _toString.call(value).slice(8, -1);
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject(obj) {
  return _toString.call(obj) === '[object Object]';
}

function isRegExp(v) {
  return _toString.call(v) === '[object RegExp]';
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex(val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val);
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString(val) {
  return val == null ? '' : (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' ? JSON.stringify(val, null, 2) : String(val);
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber(val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n;
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap(str, expectsLowerCase) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase ? function (val) {
    return map[val.toLowerCase()];
  } : function (val) {
    return map[val];
  };
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove(arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1);
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}

/**
 * Create a cached version of a pure function.
 */
function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) {
    return c ? c.toUpperCase() : '';
  });
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase();
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind(fn, ctx) {
  function boundFn(a) {
    var l = arguments.length;
    return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
  }

  boundFn._length = fn.length;
  return boundFn;
}

function nativeBind(fn, ctx) {
  return fn.bind(ctx);
}

var bind = Function.prototype.bind ? nativeBind : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray(list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret;
}

/**
 * Mix properties into target object.
 */
function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop(a, b, c) {}

/**
 * Always return false.
 */
var no = function no(a, b, c) {
  return false;
};

/**
 * Return same value
 */
var identity = function identity(_) {
  return _;
};

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys(modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || []);
  }, []).join(',');
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual(a, b) {
  if (a === b) {
    return true;
  }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i]);
        });
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key]);
        });
      } else {
        /* istanbul ignore next */
        return false;
      }
    } catch (e) {
      /* istanbul ignore next */
      return false;
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
}

function looseIndexOf(arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) {
      return i;
    }
  }
  return -1;
}

/**
 * Ensure a function is called only once.
 */
function once(fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  };
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = ['component', 'directive', 'filter'];

var LIFECYCLE_HOOKS = ['beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeUpdate', 'updated', 'beforeDestroy', 'destroyed', 'activated', 'deactivated', 'errorCaptured'];

/*  */

var config = {
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
};

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved(str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F;
}

/**
 * Define a property.
 */
function def(obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath(path) {
  if (bailRE.test(path)) {
    return;
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) {
        return;
      }
      obj = obj[segments[i]];
    }
    return obj;
  };
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0 || weexPlatform === 'android';
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA) || weexPlatform === 'ios';
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = {}.watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', {
      get: function get() {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    }); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function isServerRendering() {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer;
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative(Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}

var hasSymbol = typeof Symbol !== 'undefined' && isNative(Symbol) && typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = function () {
    function Set() {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has(key) {
      return this.set[key] === true;
    };
    Set.prototype.add = function add(key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear() {
      this.set = Object.create(null);
    };

    return Set;
  }();
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = noop; // work around flow check
var formatComponentName = noop;

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function classify(str) {
    return str.replace(classifyRE, function (c) {
      return c.toUpperCase();
    }).replace(/[-_]/g, '');
  };

  warn = function warn(msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && !config.silent) {
      console.error("[Vue warn]: " + msg + trace);
    }
  };

  tip = function tip(msg, vm) {
    if (hasConsole && !config.silent) {
      console.warn("[Vue tip]: " + msg + (vm ? generateComponentTrace(vm) : ''));
    }
  };

  formatComponentName = function formatComponentName(vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>';
    }
    var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (name ? "<" + classify(name) + ">" : "<Anonymous>") + (file && includeFile !== false ? " at " + file : '');
  };

  var repeat = function repeat(str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) {
        res += str;
      }
      if (n > 1) {
        str += str;
      }
      n >>= 1;
    }
    return res;
  };

  generateComponentTrace = function generateComponentTrace(vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue;
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree.map(function (vm, i) {
        return "" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm) ? formatComponentName(vm[0]) + "... (" + vm[1] + " recursive calls)" : formatComponentName(vm));
      }).join('\n');
    } else {
      return "\n\n(found in " + formatComponentName(vm) + ")";
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep() {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub(sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub(sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend() {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify() {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget(_target) {
  if (Dep.target) {
    targetStack.push(Dep.target);
  }
  Dep.target = _target;
}

function popTarget() {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance;
};

Object.defineProperties(VNode.prototype, prototypeAccessors);

var createEmptyVNode = function createEmptyVNode(text) {
  if (text === void 0) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node;
};

function createTextVNode(val) {
  return new VNode(undefined, undefined, undefined, String(val));
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode(vnode) {
  var cloned = new VNode(vnode.tag, vnode.data, vnode.children, vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned;
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = ['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator() {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break;
      case 'splice':
        inserted = args.slice(2);
        break;
    }
    if (inserted) {
      ob.observeArray(inserted);
    }
    // notify change
    ob.dep.notify();
    return result;
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving(value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer(value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto ? protoAugment : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk(obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray(items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment(target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment(target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe(value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return;
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (shouldObserve && !isServerRendering() && (Array.isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob;
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive(obj, key, val, customSetter, shallow) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return;
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter() {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value;
    },
    set: function reactiveSetter(newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || newVal !== newVal && value !== value) {
        return;
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set(target, key, val) {
  if (false) {
    warn("Cannot set reactive property on undefined, null, or primitive value: " + target);
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val;
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val;
  }
  var ob = target.__ob__;
  if (target._isVue || ob && ob.vmCount) {
    "production" !== 'production' && warn('Avoid adding reactive properties to a Vue instance or its root $data ' + 'at runtime - declare it upfront in the data option.');
    return val;
  }
  if (!ob) {
    target[key] = val;
    return val;
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val;
}

/**
 * Delete a property and trigger change if necessary.
 */
function del(target, key) {
  if (false) {
    warn("Cannot delete reactive property on undefined, null, or primitive value: " + target);
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return;
  }
  var ob = target.__ob__;
  if (target._isVue || ob && ob.vmCount) {
    "production" !== 'production' && warn('Avoid deleting properties on a Vue instance or its root $data ' + '- just set it to null.');
    return;
  }
  if (!hasOwn(target, key)) {
    return;
  }
  delete target[key];
  if (!ob) {
    return;
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray(value) {
  for (var e = void 0, i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn("option \"" + key + "\" can only be used during instance " + 'creation with the `new` keyword.');
    }
    return defaultStrat(parent, child);
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(to, from) {
  if (!from) {
    return to;
  }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to;
}

/**
 * Data
 */
function mergeDataOrFn(parentVal, childVal, vm) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal;
    }
    if (!parentVal) {
      return childVal;
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn() {
      return mergeData(typeof childVal === 'function' ? childVal.call(this, this) : childVal, typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal);
    };
  } else {
    return function mergedInstanceDataFn() {
      // instance merge
      var instanceData = typeof childVal === 'function' ? childVal.call(vm, vm) : childVal;
      var defaultData = typeof parentVal === 'function' ? parentVal.call(vm, vm) : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData);
      } else {
        return defaultData;
      }
    };
  }
}

strats.data = function (parentVal, childVal, vm) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);

      return parentVal;
    }
    return mergeDataOrFn(parentVal, childVal);
  }

  return mergeDataOrFn(parentVal, childVal, vm);
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook(parentVal, childVal) {
  return childVal ? parentVal ? parentVal.concat(childVal) : Array.isArray(childVal) ? childVal : [childVal] : parentVal;
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets(parentVal, childVal, vm, key) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal);
  } else {
    return res;
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal, vm, key) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) {
    parentVal = undefined;
  }
  if (childVal === nativeWatch) {
    childVal = undefined;
  }
  /* istanbul ignore if */
  if (!childVal) {
    return Object.create(parentVal || null);
  }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) {
    return childVal;
  }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent ? parent.concat(child) : Array.isArray(child) ? child : [child];
  }
  return ret;
};

/**
 * Other object hashes.
 */
strats.props = strats.methods = strats.inject = strats.computed = function (parentVal, childVal, vm, key) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) {
    return childVal;
  }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) {
    extend(ret, childVal);
  }
  return ret;
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function defaultStrat(parentVal, childVal) {
  return childVal === undefined ? parentVal : childVal;
};

/**
 * Validate component names
 */
function checkComponents(options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName(name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn('Invalid component name: "' + name + '". Component names ' + 'can only contain alphanumeric characters and the hyphen, ' + 'and must start with a letter.');
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + name);
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps(options, vm) {
  var props = options.props;
  if (!props) {
    return;
  }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val) ? val : { type: val };
    }
  } else if (false) {
    warn("Invalid value for option \"props\": expected an Array or an Object, " + "but got " + toRawType(props) + ".", vm);
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject(options, vm) {
  var inject = options.inject;
  if (!inject) {
    return;
  }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val) ? extend({ from: key }, val) : { from: val };
    }
  } else if (false) {
    warn("Invalid value for option \"inject\": expected an Array or an Object, " + "but got " + toRawType(inject) + ".", vm);
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives(options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType(name, value, vm) {
  if (!isPlainObject(value)) {
    warn("Invalid value for option \"" + name + "\": expected an Object, " + "but got " + toRawType(value) + ".", vm);
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions(parent, child, vm) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField(key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options;
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset(options, type, id, warnMissing) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return;
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) {
    return assets[id];
  }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) {
    return assets[camelizedId];
  }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) {
    return assets[PascalCaseId];
  }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id, options);
  }
  return res;
}

/*  */

function validateProp(key, propOptions, propsData, vm) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (false) {
    assertProp(prop, key, value, vm, absent);
  }
  return value;
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue(vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined;
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn('Invalid default value for prop "' + key + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData && vm.$options.propsData[key] === undefined && vm._props[key] !== undefined) {
    return vm._props[key];
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function' ? def.call(vm) : def;
}

/**
 * Assert whether a prop is valid.
 */
function assertProp(prop, name, value, vm, absent) {
  if (prop.required && absent) {
    warn('Missing required prop: "' + name + '"', vm);
    return;
  }
  if (value == null && !prop.required) {
    return;
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn("Invalid prop: type check failed for prop \"" + name + "\"." + " Expected " + expectedTypes.map(capitalize).join(', ') + ", got " + toRawType(value) + ".", vm);
    return;
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType(value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value === 'undefined' ? 'undefined' : _typeof(value);
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  };
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType(fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : '';
}

function isSameType(a, b) {
  return getType(a) === getType(b);
}

function getTypeIndex(type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1;
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i;
    }
  }
  return -1;
}

/*  */

function handleError(err, vm, info) {
  if (vm) {
    var cur = vm;
    while (cur = cur.$parent) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) {
              return;
            }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError(err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info);
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError(err, vm, info) {
  if (false) {
    warn("Error in " + info + ": \"" + err.toString() + "\"", vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err;
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks() {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function macroTimerFunc() {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (isNative(MessageChannel) ||
// PhantomJS
MessageChannel.toString() === '[object MessageChannelConstructor]')) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function macroTimerFunc() {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function macroTimerFunc() {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function microTimerFunc() {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) {
      setTimeout(noop);
    }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask(fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res;
  });
}

function nextTick(cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    });
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (perf && perf.mark && perf.measure && perf.clearMarks && perf.clearMeasures) {
    mark = function mark(tag) {
      return perf.mark(tag);
    };
    measure = function measure(name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' + 'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' + 'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' + 'require' // for Webpack/Browserify
  );

  var warnNonPresent = function warnNonPresent(target, key) {
    warn("Property or method \"" + key + "\" is not defined on the instance but " + 'referenced during render. Make sure that this property is reactive, ' + 'either in the data option, or for class-based components, by ' + 'initializing the property. ' + 'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
  };

  var hasProxy = typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set(target, key, value) {
        if (isBuiltInModifier(key)) {
          warn("Avoid overwriting built-in modifier in config.keyCodes: ." + key);
          return false;
        } else {
          target[key] = value;
          return true;
        }
      }
    });
  }

  var hasHandler = {
    has: function has(target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed;
    }
  };

  var getHandler = {
    get: function get(target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key];
    }
  };

  initProxy = function initProxy(vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped ? getHandler : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse(val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse(val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if (!isA && !isObject(val) || Object.isFrozen(val) || val instanceof VNode) {
    return;
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return;
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) {
      _traverse(val[i], seen);
    }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) {
      _traverse(val[keys[i]], seen);
    }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  };
});

function createFnInvoker(fns) {
  function invoker() {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments);
    }
  }
  invoker.fns = fns;
  return invoker;
}

function updateListeners(on, oldOn, add, remove$$1, vm) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn("Invalid handler for event \"" + event.name + "\": got " + String(cur), vm);
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook(def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook() {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData(data, Ctor, tag) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return;
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
          tip("Prop \"" + keyInLowerCase + "\" is passed to component " + formatComponentName(tag || Ctor) + ", but the declared prop name is" + " \"" + key + "\". " + "Note that HTML attributes are case-insensitive and camelCased " + "props need to use their kebab-case equivalents when using in-DOM " + "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\".");
        }
      }
      checkProp(res, props, key, altKey, true) || checkProp(res, attrs, key, altKey, false);
    }
  }
  return res;
}

function checkProp(res, hash, key, altKey, preserve) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true;
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true;
    }
  }
  return false;
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren(children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children);
    }
  }
  return children;
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren(children) {
  return isPrimitive(children) ? [createTextVNode(children)] : Array.isArray(children) ? normalizeArrayChildren(children) : undefined;
}

function isTextNode(node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment);
}

function normalizeArrayChildren(children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') {
      continue;
    }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, (nestedIndex || '') + "_" + i);
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + c[0].text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) && isDef(c.tag) && isUndef(c.key) && isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res;
}

/*  */

function ensureCtor(comp, base) {
  if (comp.__esModule || hasSymbol && comp[Symbol.toStringTag] === 'Module') {
    comp = comp.default;
  }
  return isObject(comp) ? base.extend(comp) : comp;
}

function createAsyncPlaceholder(factory, data, context, children, tag) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node;
}

function resolveAsyncComponent(factory, baseCtor, context) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp;
  }

  if (isDef(factory.resolved)) {
    return factory.resolved;
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp;
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function forceRender() {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn("Failed to resolve async component: " + String(factory) + (reason ? "\nReason: " + reason : ''));
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject( false ? "timeout (" + res.timeout + "ms)" : null);
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading ? factory.loadingComp : factory.resolved;
  }
}

/*  */

function isAsyncPlaceholder(node) {
  return node.isComment && node.asyncFactory;
}

/*  */

function getFirstComponentChild(children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c;
      }
    }
  }
}

/*  */

/*  */

function initEvents(vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add(event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1(event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners(vm, listeners, oldListeners) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin(Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm;
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on() {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm;
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm;
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm;
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm;
    }
    if (!fn) {
      vm._events[event] = null;
      return vm;
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break;
        }
      }
    }
    return vm;
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip("Event \"" + lowerCaseEvent + "\" is emitted in component " + formatComponentName(vm) + " but the handler is registered for \"" + event + "\". " + "Note that HTML attributes are case-insensitive and you cannot use " + "v-on to listen to camelCase events when using in-DOM templates. " + "You should probably use \"" + hyphenate(event) + "\" instead of \"" + event + "\".");
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, "event handler for \"" + event + "\"");
        }
      }
    }
    return vm;
  };
}

/*  */

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots(children, context) {
  var slots = {};
  if (!children) {
    return slots;
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) && data && data.slot != null) {
      var name = data.slot;
      var slot = slots[name] || (slots[name] = []);
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots;
}

function isWhitespace(node) {
  return node.isComment && !node.asyncFactory || node.text === ' ';
}

function resolveScopedSlots(fns, // see flow/vnode
res) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res;
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle(vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin(Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */
      , vm.$options._parentElm, vm.$options._refElm);
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return;
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent(vm, el, hydrating) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if (vm.$options.template && vm.$options.template.charAt(0) !== '#' || vm.$options.el || el) {
        warn('You are using the runtime-only build of Vue where the template ' + 'compiler is not available. Either pre-compile the templates into ' + 'render functions, or use the compiler-included build.', vm);
      } else {
        warn('Failed to mount component: template or render function not defined.', vm);
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function updateComponent() {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure("vue " + name + " render", startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure("vue " + name + " patch", startTag, endTag);
    };
  } else {
    updateComponent = function updateComponent() {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm;
}

function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(renderChildren || // has new static slots
  vm.$options._renderChildren || // has old static slots
  parentVnode.data.scopedSlots || // has new scoped slots
  vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) {
    // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree(vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) {
      return true;
    }
  }
  return false;
}

function activateChildComponent(vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return;
    }
  } else if (vm._directInactive) {
    return;
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent(vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return;
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook(vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, hook + " hook");
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState() {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue() {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) {
    return a.id - b.id;
  });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn('You may have an infinite update loop ' + (watcher.user ? "in watcher with expression \"" + watcher.expression + "\"" : "in a component render function."), watcher.vm);
        break;
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks(queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent(vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks(queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher(watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false ? expOrFn.toString() : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn("Failed watching path: \"" + expOrFn + "\" " + 'Watcher only accepts simple dot-delimited paths. ' + 'For full control, use a function instead.', vm);
    }
  }
  this.value = this.lazy ? undefined : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get() {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, "getter for watcher \"" + this.expression + "\"");
    } else {
      throw e;
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value;
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep(dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps() {
  var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update() {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run() {
  if (this.active) {
    var value = this.get();
    if (value !== this.value ||
    // Deep watchers and watchers on Object/Arrays should fire even
    // when the value is the same, because the value may
    // have mutated.
    isObject(value) || this.deep) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, "callback for watcher \"" + this.expression + "\"");
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate() {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend() {
  var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown() {
  var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy(target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter() {
    return this[sourceKey][key];
  };
  sharedPropertyDefinition.set = function proxySetter(val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState(vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) {
    initProps(vm, opts.props);
  }
  if (opts.methods) {
    initMethods(vm, opts.methods);
  }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) {
    initComputed(vm, opts.computed);
  }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps(vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function loop(key) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) || config.isReservedAttr(hyphenatedKey)) {
        warn("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop.", vm);
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn("Avoid mutating a prop directly since the value will be " + "overwritten whenever the parent component re-renders. " + "Instead, use a data or computed property based on the prop's " + "value. Prop being mutated: \"" + key + "\"", vm);
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) {
    loop(key);
  }toggleObserving(true);
}

function initData(vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function' ? getData(data, vm) : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn('data functions should return an object:\n' + 'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn("Method \"" + key + "\" has already been defined as a data property.", vm);
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn("The data property \"" + key + "\" is already declared as a prop. " + "Use prop default value instead.", vm);
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData(data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm);
  } catch (e) {
    handleError(e, vm, "data()");
    return {};
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed(vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn("Getter is missing for computed property \"" + key + "\".", vm);
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn("The computed property \"" + key + "\" is already defined in data.", vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn("The computed property \"" + key + "\" is already defined as a prop.", vm);
      }
    }
  }
}

function defineComputed(target, key, userDef) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache ? createComputedGetter(key) : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get ? shouldCache && userDef.cache !== false ? createComputedGetter(key) : userDef.get : noop;
    sharedPropertyDefinition.set = userDef.set ? userDef.set : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn("Computed property \"" + key + "\" was assigned to but it has no setter.", this);
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter(key) {
  return function computedGetter() {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value;
    }
  };
}

function initMethods(vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn("Method \"" + key + "\" has an undefined value in the component definition. " + "Did you reference the function correctly?", vm);
      }
      if (props && hasOwn(props, key)) {
        warn("Method \"" + key + "\" has already been defined as a prop.", vm);
      }
      if (key in vm && isReserved(key)) {
        warn("Method \"" + key + "\" conflicts with an existing Vue instance method. " + "Avoid defining component methods that start with _ or $.");
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch(vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher(vm, expOrFn, handler, options) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options);
}

function stateMixin(Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () {
    return this._data;
  };
  var propsDef = {};
  propsDef.get = function () {
    return this._props;
  };
  if (false) {
    dataDef.set = function (newData) {
      warn('Avoid replacing instance root $data. ' + 'Use nested data properties instead.', this);
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (expOrFn, cb, options) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options);
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn() {
      watcher.teardown();
    };
  };
}

/*  */

function initProvide(vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function' ? provide.call(vm) : provide;
  }
}

function initInjections(vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn("Avoid mutating an injected value directly since the changes will be " + "overwritten whenever the provided component re-renders. " + "injection being mutated: \"" + key + "\"", vm);
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject(inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol ? Reflect.ownKeys(inject).filter(function (key) {
      /* istanbul ignore next */
      return Object.getOwnPropertyDescriptor(inject, key).enumerable;
    }) : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break;
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function' ? provideDefault.call(vm) : provideDefault;
        } else if (false) {
          warn("Injection \"" + key + "\" not found", vm);
        }
      }
    }
    return result;
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList(val, render) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    ret._isVList = true;
  }
  return ret;
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot(name, fallback, props, bindObject) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) {
    // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn('slot v-bind without argument expects an Object', this);
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn("Duplicate presence of slot \"" + name + "\" found in the same render tree " + "- this will likely cause render errors.", this);
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes);
  } else {
    return nodes;
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter(id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity;
}

/*  */

function isKeyNotMatch(expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1;
  } else {
    return expect !== actual;
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName);
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode);
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key;
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps(data, tag, value, asProp, isSync) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn('v-bind without argument expects an Object or Array value', this);
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function loop(key) {
        if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key) ? data.domProps || (data.domProps = {}) : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on["update:" + key] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) {
        loop(key);
      }
    }
  }
  return data;
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic(index, isInFor) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree;
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, null, this // for render fns generated for functional component templates
  );
  markStatic(tree, "__static__" + index, false);
  return tree;
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce(tree, index, key) {
  markStatic(tree, "__once__" + index + (key ? "_" + key : ""), true);
  return tree;
}

function markStatic(tree, key, isOnce) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], key + "_" + i, isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode(node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners(data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn('v-on without argument expects an Object value', this);
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data;
}

/*  */

function installRenderHelpers(target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext(data, props, children, parent, Ctor) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    return resolveSlots(children, parent);
  };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode;
    };
  } else {
    this._c = function (a, b, c, d) {
      return createElement(contextVm, a, b, c, d, needNormalization);
    };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) {
      mergeProps(props, data.attrs);
    }
    if (isDef(data.props)) {
      mergeProps(props, data.props);
    }
  }

  var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options);
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res;
  }
}

function cloneAndMarkFunctionalResult(vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone;
}

function mergeProps(to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init(vnode, hydrating, parentElm, refElm) {
    if (vnode.componentInstance && !vnode.componentInstance._isDestroyed && vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance, parentElm, refElm);
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch(oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(child, options.propsData, // updated props
    options.listeners, // updated listeners
    vnode, // new parent vnode
    options.children // new children
    );
  },

  insert: function insert(vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy(vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent(Ctor, data, context, children, tag) {
  if (isUndef(Ctor)) {
    return;
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn("Invalid Component definition: " + String(Ctor), context);
    }
    return;
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children);
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode("vue-component-" + Ctor.cid + (name ? "-" + name : ''), data, undefined, undefined, undefined, context, { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }, asyncFactory);

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode;
}

function createComponentInstanceForVnode(vnode, // we know it's MountedComponentVNode but flow doesn't
parent, // activeInstance in lifecycle state
parentElm, refElm) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options);
}

function installComponentHooks(data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel(options, data) {
  var prop = options.model && options.model.prop || 'value';
  var event = options.model && options.model.event || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement(context, tag, data, children, normalizationType, alwaysNormalize) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType);
}

function _createElement(context, tag, data, children, normalizationType) {
  if (isDef(data) && isDef(data.__ob__)) {
    "production" !== 'production' && warn("Avoid using observed data object as vnode data: " + JSON.stringify(data) + "\n" + 'Always create fresh vnode data objects in each render!', context);
    return createEmptyVNode();
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode();
  }
  // warn against non-primitive key
  if (false) {
    {
      warn('Avoid using non-primitive value as key, ' + 'use string/number value instead.', context);
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) && typeof children[0] === 'function') {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = context.$vnode && context.$vnode.ns || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(tag, data, children, undefined, undefined, context);
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode;
  } else if (isDef(vnode)) {
    if (isDef(ns)) {
      applyNS(vnode, ns);
    }
    if (isDef(data)) {
      registerDeepBindings(data);
    }
    return vnode;
  } else {
    return createEmptyVNode();
  }
}

function applyNS(vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force) && child.tag !== 'svg')) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings(data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender(vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) {
    return createElement(vm, a, b, c, d, false);
  };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) {
    return createElement(vm, a, b, c, d, true);
  };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin(Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this);
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (false) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn('Multiple root nodes returned from render function. Render function ' + 'should return a single root node.', vm);
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode;
  };
}

/*  */

var uid$3 = 0;

function initMixin(Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + vm._uid;
      endTag = "vue-perf-end:" + vm._uid;
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure("vue " + vm._name + " init", startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent(vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions(Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options;
}

function resolveModifiedOptions(Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) {
        modified = {};
      }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified;
}

function dedupe(latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res;
  } else {
    return latest;
  }
}

function Vue(options) {
  if (false) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse(Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
    if (installedPlugins.indexOf(plugin) > -1) {
      return this;
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this;
  };
}

/*  */

function initMixin$1(Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this;
  };
}

/*  */

function initExtend(Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId];
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent(options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(Super.options, extendOptions);
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub;
  };
}

function initProps$1(Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1(Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters(Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (id, definition) {
      if (!definition) {
        return this.options[type + 's'][id];
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition;
      }
    };
  });
}

/*  */

function getComponentName(opts) {
  return opts && (opts.Ctor.options.name || opts.tag);
}

function matches(pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1;
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1;
  } else if (isRegExp(pattern)) {
    return pattern.test(name);
  }
  /* istanbul ignore next */
  return false;
}

function pruneCache(keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry(cache, key, keys, current) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created() {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed() {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted() {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) {
        return matches(val, name);
      });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) {
        return !matches(val, name);
      });
    });
  },

  render: function render() {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
      // not included
      include && (!name || !matches(include, name)) ||
      // excluded
      exclude && name && matches(exclude, name)) {
        return vnode;
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
      // same constructor may get registered as different local components
      // so cid alone is not enough (#3269)
      ? componentOptions.Ctor.cid + (componentOptions.tag ? "::" + componentOptions.tag : '') : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || slot && slot[0];
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive

  /*  */

};function initGlobalAPI(Vue) {
  // config
  var configDef = {};
  configDef.get = function () {
    return config;
  };
  if (false) {
    configDef.set = function () {
      warn('Do not replace the Vue.config object, set individual fields instead.');
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get() {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext;
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.16';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function mustUseProp(tag, type, attr) {
  return attr === 'value' && acceptValue(tag) && type !== 'button' || attr === 'selected' && tag === 'option' || attr === 'checked' && tag === 'input' || attr === 'muted' && tag === 'video';
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' + 'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' + 'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' + 'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' + 'required,reversed,scoped,seamless,selected,sortable,translate,' + 'truespeed,typemustmatch,visible');

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function isXlink(name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
};

var getXlinkProp = function getXlinkProp(name) {
  return isXlink(name) ? name.slice(6, name.length) : '';
};

var isFalsyAttrValue = function isFalsyAttrValue(val) {
  return val == null || val === false;
};

/*  */

function genClassForVnode(vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class);
}

function mergeClassData(child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class) ? [child.class, parent.class] : parent.class
  };
}

function renderClass(staticClass, dynamicClass) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass));
  }
  /* istanbul ignore next */
  return '';
}

function concat(a, b) {
  return a ? b ? a + ' ' + b : a : b || '';
}

function stringifyClass(value) {
  if (Array.isArray(value)) {
    return stringifyArray(value);
  }
  if (isObject(value)) {
    return stringifyObject(value);
  }
  if (typeof value === 'string') {
    return value;
  }
  /* istanbul ignore next */
  return '';
}

function stringifyArray(value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) {
        res += ' ';
      }
      res += stringified;
    }
  }
  return res;
}

function stringifyObject(value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) {
        res += ' ';
      }
      res += key;
    }
  }
  return res;
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' + 'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' + 'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' + 'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' + 's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' + 'embed,object,param,source,canvas,script,noscript,del,ins,' + 'caption,col,colgroup,table,thead,tbody,td,th,tr,' + 'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' + 'output,progress,select,textarea,' + 'details,dialog,menu,menuitem,summary,' + 'content,element,shadow,template,blockquote,iframe,tfoot');

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' + 'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' + 'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);

var isPreTag = function isPreTag(tag) {
  return tag === 'pre';
};

var isReservedTag = function isReservedTag(tag) {
  return isHTMLTag(tag) || isSVG(tag);
};

function getTagNamespace(tag) {
  if (isSVG(tag)) {
    return 'svg';
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math';
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement(tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true;
  }
  if (isReservedTag(tag)) {
    return false;
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag];
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return unknownElementCache[tag] = el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
  } else {
    return unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString());
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query(el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn('Cannot find element: ' + el);
      return document.createElement('div');
    }
    return selected;
  } else {
    return el;
  }
}

/*  */

function createElement$1(tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm;
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm;
}

function createElementNS(namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName);
}

function createTextNode(text) {
  return document.createTextNode(text);
}

function createComment(text) {
  return document.createComment(text);
}

function insertBefore(parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild(node, child) {
  node.removeChild(child);
}

function appendChild(node, child) {
  node.appendChild(child);
}

function parentNode(node) {
  return node.parentNode;
}

function nextSibling(node) {
  return node.nextSibling;
}

function tagName(node) {
  return node.tagName;
}

function setTextContent(node, text) {
  node.textContent = text;
}

function setStyleScope(node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create(_, vnode) {
    registerRef(vnode);
  },
  update: function update(oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy(vnode) {
    registerRef(vnode, true);
  }
};

function registerRef(vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) {
    return;
  }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode(a, b) {
  return a.key === b.key && (a.tag === b.tag && a.isComment === b.isComment && isDef(a.data) === isDef(b.data) && sameInputType(a, b) || isTrue(a.isAsyncPlaceholder) && a.asyncFactory === b.asyncFactory && isUndef(b.asyncFactory.error));
}

function sameInputType(a, b) {
  if (a.tag !== 'input') {
    return true;
  }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB);
}

function createKeyToOldIdx(children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) {
      map[key] = i;
    }
  }
  return map;
}

function createPatchFunction(backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt(elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
  }

  function createRmCb(childElm, listeners) {
    function remove() {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove;
  }

  function removeNode(el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1(vnode, inVPre) {
    return !inVPre && !vnode.ns && !(config.ignoredElements.length && config.ignoredElements.some(function (ignore) {
      return isRegExp(ignore) ? ignore.test(vnode.tag) : ignore === vnode.tag;
    })) && config.isUnknownElement(vnode.tag);
  }

  var creatingElmInVPre = 0;

  function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return;
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.', vnode.context);
        }
      }

      vnode.elm = vnode.ns ? nodeOps.createElementNS(vnode.ns, tag) : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true;
      }
    }
  }

  function initComponent(vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break;
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert(parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren(vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable(vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag);
  }

  function invokeCreateHooks(vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) {
        i.create(emptyNode, vnode);
      }
      if (isDef(i.insert)) {
        insertedVnodeQueue.push(vnode);
      }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope(vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) && i !== vnode.context && i !== vnode.fnContext && isDef(i = i.$options._scopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook(vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) {
        i(vnode);
      }
      for (i = 0; i < cbs.destroy.length; ++i) {
        cbs.destroy[i](vnode);
      }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else {
          // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook(vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) {
        // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) {
        // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) {
          oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
        }
        idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) {
          // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys(children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn("Duplicate keys detected: '" + key + "'. This may cause an update error.", vnode.context);
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld(node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) {
        return i;
      }
    }
  }

  function patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return;
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return;
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) && isTrue(oldVnode.isStatic) && vnode.key === oldVnode.key && (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
      vnode.componentInstance = oldVnode.componentInstance;
      return;
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) {
        cbs.update[i](oldVnode, vnode);
      }
      if (isDef(i = data.hook) && isDef(i = i.update)) {
        i(oldVnode, vnode);
      }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) {
          updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
        }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) {
          nodeOps.setTextContent(elm, '');
        }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) {
        i(oldVnode, vnode);
      }
    }
  }

  function invokeInsertHook(vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || data && data.pre;
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true;
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false;
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) {
        i(vnode, true /* hydrating */);
      }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true;
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false;
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break;
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false;
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break;
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true;
  }

  function assertNodeMatch(node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || !isUnknownElement$$1(vnode, inVPre) && vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase());
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3);
    }
  }

  return function patch(oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) {
        invokeDestroyHook(oldVnode);
      }
      return;
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode;
            } else if (false) {
              warn('The client-side rendered virtual DOM tree is not matching ' + 'server-rendered content. This is likely caused by incorrect ' + 'HTML markup, for example nesting block-level elements inside ' + '<p>, or missing <tbody>. Bailing hydration and performing ' + 'full client-side render.');
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(vnode, insertedVnodeQueue,
        // extremely rare edge case: do not insert if old element is in a
        // leaving transition. Only happens when combining transition +
        // keep-alive + HOCs. (#4590)
        oldElm._leaveCb ? null : parentElm$1, nodeOps.nextSibling(oldElm));

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm;
  };
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives(vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives(oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update(oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function callInsert() {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1(dirs, vm) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res;
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res;
}

function getRawDirName(dir) {
  return dir.rawName || dir.name + "." + Object.keys(dir.modifiers || {}).join('.');
}

function callHook$1(dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, "directive " + dir.name + " " + hook + " hook");
    }
  }
}

var baseModules = [ref, directives];

/*  */

function updateAttrs(oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return;
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return;
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr(el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr(el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (isIE && !isIE9 && el.tagName === 'TEXTAREA' && key === 'placeholder' && !el.__ieph) {
      var blocker = function blocker(e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs

  /*  */

};function updateClass(oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (isUndef(data.staticClass) && isUndef(data.class) && (isUndef(oldData) || isUndef(oldData.staticClass) && isUndef(oldData.class))) {
    return;
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass

  /*  */

};var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters(exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) {
        inSingle = false;
      }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) {
        inDouble = false;
      }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) {
        inTemplateString = false;
      }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) {
        inRegex = false;
      }
    } else if (c === 0x7C && // pipe
    exp.charCodeAt(i + 1) !== 0x7C && exp.charCodeAt(i - 1) !== 0x7C && !curly && !square && !paren) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22:
          inDouble = true;break; // "
        case 0x27:
          inSingle = true;break; // '
        case 0x60:
          inTemplateString = true;break; // `
        case 0x28:
          paren++;break; // (
        case 0x29:
          paren--;break; // )
        case 0x5B:
          square++;break; // [
        case 0x5D:
          square--;break; // ]
        case 0x7B:
          curly++;break; // {
        case 0x7D:
          curly--;break; // }
      }
      if (c === 0x2f) {
        // /
        var j = i - 1;
        var p = void 0;
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') {
            break;
          }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter() {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression;
}

function wrapFilter(exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return "_f(\"" + filter + "\")(" + exp + ")";
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return "_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args);
  }
}

/*  */

function baseWarn(msg) {
  console.error("[Vue compiler]: " + msg);
}

function pluckModuleFunction(modules, key) {
  return modules ? modules.map(function (m) {
    return m[key];
  }).filter(function (_) {
    return _;
  }) : [];
}

function addProp(el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr(el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr(el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective(el, name, rawName, value, arg, modifiers) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler(el, name, value, modifiers, important, warn) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (false) {
    warn('passive and prevent can\'t be used together. ' + 'Passive handler can\'t prevent default event.');
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = {
    value: value.trim()
  };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr(el, name, getStatic) {
  var dynamicValue = getAndRemoveAttr(el, ':' + name) || getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue);
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue);
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr(el, name, removeFromMap) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break;
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val;
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel(el, value, modifiers) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression = "(typeof " + baseValueExpression + " === 'string'" + "? " + baseValueExpression + ".trim()" + ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: "(" + value + ")",
    expression: "\"" + value + "\"",
    callback: "function (" + baseValueExpression + ") {" + assignment + "}"
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode(value, assignment) {
  var res = parseModel(value);
  if (res.key === null) {
    return value + "=" + assignment;
  } else {
    return "$set(" + res.exp + ", " + res.key + ", " + assignment + ")";
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;

function parseModel(val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      };
    } else {
      return {
        exp: val,
        key: null
      };
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  };
}

function next() {
  return str.charCodeAt(++index$1);
}

function eof() {
  return index$1 >= len;
}

function isStringStart(chr) {
  return chr === 0x22 || chr === 0x27;
}

function parseBracket(chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue;
    }
    if (chr === 0x5B) {
      inBracket++;
    }
    if (chr === 0x5D) {
      inBracket--;
    }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break;
    }
  }
}

function parseString(chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break;
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model(el, dir, _warn) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1("<" + el.tag + " v-model=\"" + value + "\" type=\"file\">:\n" + "File inputs are read only. Use a v-on:change listener instead.");
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false;
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false;
  } else if (false) {
    warn$1("<" + el.tag + " v-model=\"" + value + "\">: " + "v-model is not supported on this element type. " + 'If you are working with contenteditable, it\'s recommended to ' + 'wrap a library dedicated for that purpose inside a custom component.');
  }

  // ensure runtime directive metadata
  return true;
}

function genCheckboxModel(el, value, modifiers) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked', "Array.isArray(" + value + ")" + "?_i(" + value + "," + valueBinding + ")>-1" + (trueValueBinding === 'true' ? ":(" + value + ")" : ":_q(" + value + "," + trueValueBinding + ")"));
  addHandler(el, 'change', "var $$a=" + value + "," + '$$el=$event.target,' + "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" + 'if(Array.isArray($$a)){' + "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," + '$$i=_i($$a,$$v);' + "if($$el.checked){$$i<0&&(" + genAssignmentCode(value, '$$a.concat([$$v])') + ")}" + "else{$$i>-1&&(" + genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))') + ")}" + "}else{" + genAssignmentCode(value, '$$c') + "}", null, true);
}

function genRadioModel(el, value, modifiers) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? "_n(" + valueBinding + ")" : valueBinding;
  addProp(el, 'checked', "_q(" + value + "," + valueBinding + ")");
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect(el, value, modifiers) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" + ".call($event.target.options,function(o){return o.selected})" + ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" + "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + genAssignmentCode(value, assignment);
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel(el, value, modifiers) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " + 'because the latter already expands to a value binding internally');
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy ? 'change' : type === 'range' ? RANGE_TOKEN : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', "(" + value + ")");
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents(on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler(handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler() {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  };
}

function add$1(event, handler, once$$1, capture, passive) {
  handler = withMacroTask(handler);
  if (once$$1) {
    handler = createOnceHandler(handler, event, capture);
  }
  target$1.addEventListener(event, handler, supportsPassive ? { capture: capture, passive: passive } : capture);
}

function remove$2(event, handler, capture, _target) {
  (_target || target$1).removeEventListener(event, handler._withTask || handler, capture);
}

function updateDOMListeners(oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return;
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners

  /*  */

};function updateDOMProps(oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return;
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) {
        vnode.children.length = 0;
      }
      if (cur === oldProps[key]) {
        continue;
      }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue(elm, checkVal) {
  return !elm.composing && (elm.tagName === 'OPTION' || isNotInFocusAndDirty(elm, checkVal) || isDirtyWithModifiers(elm, checkVal));
}

function isNotInFocusAndDirty(elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try {
    notInFocus = document.activeElement !== elm;
  } catch (e) {}
  return notInFocus && elm.value !== checkVal;
}

function isDirtyWithModifiers(elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false;
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal);
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim();
    }
  }
  return value !== newVal;
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps

  /*  */

};var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res;
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData(data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle ? extend(data.staticStyle, style) : style;
}

// normalize possible array / string values into Object
function normalizeStyleBinding(bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle);
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle);
  }
  return bindingStyle;
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle(vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (childNode && childNode.data && (styleData = normalizeStyleData(childNode.data))) {
        extend(res, styleData);
      }
    }
  }

  if (styleData = normalizeStyleData(vnode.data)) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while (parentNode = parentNode.parent) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res;
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function setProp(el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && prop in emptyStyle) {
    return prop;
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name;
    }
  }
});

function updateStyle(oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) && isUndef(oldData.staticStyle) && isUndef(oldData.style)) {
    return;
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle

  /*  */

  /**
   * Add class with compatibility for SVG since classList is not supported on
   * SVG elements in IE
   */
};function addClass(el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return;
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) {
        return el.classList.add(c);
      });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass(el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return;
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) {
        return el.classList.remove(c);
      });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition(def) {
  if (!def) {
    return;
  }
  /* istanbul ignore else */
  if ((typeof def === 'undefined' ? 'undefined' : _typeof(def)) === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res;
  } else if (typeof def === 'string') {
    return autoCssTransition(def);
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: name + "-enter",
    enterToClass: name + "-enter-to",
    enterActiveClass: name + "-enter-active",
    leaveClass: name + "-leave",
    leaveToClass: name + "-leave-to",
    leaveActiveClass: name + "-leave-active"
  };
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : /* istanbul ignore next */function (fn) {
  return fn();
};

function nextFrame(fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass(el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass(el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds(el, expectedType, cb) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) {
    return cb();
  }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function end() {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function onEnd(e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo(el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
    propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
  }
  var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  };
}

function getTimeout(delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i]);
  }));
}

function toMs(s) {
  return Number(s.slice(0, -1)) * 1000;
}

/*  */

function enter(vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return;
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return;
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return;
  }

  var startClass = isAppear && appearClass ? appearClass : enterClass;
  var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
  var toClass = isAppear && appearToClass ? appearToClass : enterToClass;

  var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
  var enterHook = isAppear ? typeof appear === 'function' ? appear : enter : enter;
  var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
  var enterCancelledHook = isAppear ? appearCancelled || enterCancelled : enterCancelled;

  var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode && pendingNode.tag === vnode.tag && pendingNode.elm._leaveCb) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave(vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm();
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return;
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave() {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return;
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration(val, name, vnode) {
  if (typeof val !== 'number') {
    warn("<transition> explicit " + name + " duration is not a valid number - " + "got " + JSON.stringify(val) + ".", vnode.context);
  } else if (isNaN(val)) {
    warn("<transition> explicit " + name + " duration is NaN - " + 'the duration expression might be incorrect.', vnode.context);
  }
}

function isValidDuration(val) {
  return typeof val === 'number' && !isNaN(val);
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength(fn) {
  if (isUndef(fn)) {
    return false;
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
  } else {
    return (fn._length || fn.length) > 1;
  }
}

function _enter(_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1(vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [attrs, klass, events, domProps, style, transition];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted(el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated(el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) {
        return !looseEqual(o, prevOptions[i]);
      })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple ? binding.value.some(function (v) {
          return hasNoMatchingOption(v, curOptions);
        }) : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected(el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected(el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn("<select multiple v-model=\"" + binding.expression + "\"> " + "expects an Array value for its binding, but got " + Object.prototype.toString.call(value).slice(8, -1), vm);
    return;
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return;
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption(value, options) {
  return options.every(function (o) {
    return !looseEqual(o, value);
  });
}

function getValue(option) {
  return '_value' in option ? option._value : option.value;
}

function onCompositionStart(e) {
  e.target.composing = true;
}

function onCompositionEnd(e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) {
    return;
  }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger(el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode(vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition) ? locateNode(vnode.componentInstance._vnode) : vnode;
}

var show = {
  bind: function bind(el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay = el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update(el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) {
      return;
    }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind(el, binding, vnode, oldVnode, isDestroy) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show

  /*  */

  // Provides transition support for a single element/component.
  // supports transition mode (out-in / in-out)

};var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild(vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children));
  } else {
    return vnode;
  }
}

function extractTransitionData(comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data;
}

function placeholder(h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    });
  }
}

function hasParentTransition(vnode) {
  while (vnode = vnode.parent) {
    if (vnode.data.transition) {
      return true;
    }
  }
}

function isSameChild(child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag;
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render(h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return;
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) {
      return c.tag || isAsyncPlaceholder(c);
    });
    /* istanbul ignore if */
    if (!children.length) {
      return;
    }

    // warn multiple elements
    if (false) {
      warn('<transition> can only be used on a single element. Use ' + '<transition-group> for lists.', this.$parent);
    }

    var mode = this.mode;

    // warn invalid mode
    if (false) {
      warn('invalid <transition> mode: ' + mode, this.$parent);
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild;
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild;
    }

    if (this._leaving) {
      return placeholder(h, rawChild);
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + this._uid + "-";
    child.key = child.key == null ? child.isComment ? id + 'comment' : id + child.tag : isPrimitive(child.key) ? String(child.key).indexOf(id) === 0 ? child.key : id + child.key : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) {
      return d.name === 'show';
    })) {
      child.data.show = true;
    }

    if (oldChild && oldChild.data && !isSameChild(child, oldChild) && !isAsyncPlaceholder(oldChild) &&
    // #6687 component root is a comment node
    !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild);
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild;
        }
        var delayedLeave;
        var performLeave = function performLeave() {
          delayedLeave();
        };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) {
          delayedLeave = leave;
        });
      }
    }

    return rawChild;
  }

  /*  */

  // Provides transition support for list items.
  // supports move transitions using the FLIP technique.

  // Because the vdom's children update algorithm is "unstable" - i.e.
  // it doesn't guarantee the relative positioning of removed elements,
  // we force transition-group to update its children into two passes:
  // in the first pass, we remove all nodes that need to be removed,
  // triggering their leaving transition; in the second pass, we insert/move
  // into the final desired state. This way in the second pass removed
  // nodes will remain where they should be.

};var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render(h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? opts.Ctor.options.name || opts.tag || '' : c.tag;
          warn("<transition-group> children must be keyed: <" + name + ">");
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children);
  },

  beforeUpdate: function beforeUpdate() {
    // force removing pass
    this.__patch__(this._vnode, this.kept, false, // hydrating
    true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated() {
    var children = this.prevChildren;
    var moveClass = this.moveClass || (this.name || 'v') + '-move';
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return;
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb(e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove(el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false;
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove;
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) {
          removeClass(clone, cls);
        });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return this._hasMove = info.hasTransform;
    }
  }
};

function callPendingCbs(c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition(c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation(c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup

  /*  */

  // install platform specific utils
};Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (el, hydrating) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating);
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (false) {
        console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
      }
    }
    if (false) {
      console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" + "Make sure to turn on production mode when deploying for production.\n" + "See more tips at https://vuejs.org/guide/deployment.html");
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g');
});

function parseText(text, delimiters) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return;
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while (match = tagRE.exec(text)) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push("_s(" + exp + ")");
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  };
}

/*  */

function transformNode(el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn("class=\"" + staticClass + "\": " + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div class="{{ val }}">, use <div :class="val">.');
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData(el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + el.staticClass + ",";
  }
  if (el.classBinding) {
    data += "class:" + el.classBinding + ",";
  }
  return data;
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData

  /*  */

};function transformNode$1(el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn("style=\"" + staticStyle + "\": " + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div style="{{ val }}">, use <div :style="val">.');
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1(el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + el.staticStyle + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + el.styleBinding + "),";
  }
  return data;
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1

  /*  */

};var decoder;

var he = {
  decode: function decode(html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent;
  }

  /*  */

};var isUnaryTag = makeMap('area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' + 'link,meta,param,source,track,wbr');

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap('colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source');

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap('address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' + 'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' + 'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' + 'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' + 'title,tr,track');

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp("^<" + qnameCapture);
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp("^<\\/" + qnameCapture + "[^>]*>");
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function shouldIgnoreFirstNewline(tag, html) {
  return tag && isIgnoreNewlineTag(tag) && html[0] === '\n';
};

function decodeAttr(value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) {
    return decodingMap[match];
  });
}

function parseHTML(html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue;
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue;
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue;
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue;
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue;
        }
      }

      var text = void 0,
          rest = void 0,
          next = void 0;
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (!endTag.test(rest) && !startTagOpen.test(rest) && !comment.test(rest) && !conditionalComment.test(rest)) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) {
            break;
          }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text.replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
          .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return '';
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn("Mal-formatted tag at end of template: \"" + html + "\"");
      }
      break;
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance(n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag() {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match;
      }
    }
  }

  function handleStartTag(match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') {
          delete args[3];
        }
        if (args[4] === '') {
          delete args[4];
        }
        if (args[5] === '') {
          delete args[5];
        }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href' ? options.shouldDecodeNewlinesForHref : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag(tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) {
      start = index;
    }
    if (end == null) {
      end = index;
    }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break;
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false) {
          options.warn("tag <" + stack[i].tag + "> has no matching end tag.");
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;

function createASTElement(tag, attrs, parent) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  };
}

/**
 * Convert HTML string to AST.
 */
function parse(template, options) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce(msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement(element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start(tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = currentParent && currentParent.ns || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2('Templates should only be responsible for mapping the state to the ' + 'UI. Avoid placing tags with side-effects in your templates, such as ' + "<" + tag + ">" + ', as they will not be parsed.');
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints(el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce("Cannot use <" + el.tag + "> as component root element because it may " + 'contain multiple nodes.');
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce('Cannot use v-for on stateful component root element because ' + 'it renders multiple elements.');
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce("Component template should contain exactly one root element. " + "If you are using v-if on multiple elements, " + "use v-else-if to chain them instead.");
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) {
          // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end() {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars(text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce('Component template requires a root element, rather than just text.');
          } else if (text = text.trim()) {
            warnOnce("text \"" + text + "\" outside root element will be ignored.");
          }
        }
        return;
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE && currentParent.tag === 'textarea' && currentParent.attrsMap.placeholder === text) {
        return;
      }
      var children = currentParent.children;
      text = inPre || text.trim() ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
      // only preserve whitespace if its not right after a starting tag
      : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment(text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root;
}

function processPre(el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs(el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement(element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey(el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef(el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor(el) {
  var exp;
  if (exp = getAndRemoveAttr(el, 'v-for')) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2("Invalid v-for expression: " + exp);
    }
  }
}

function parseFor(exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) {
    return;
  }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res;
}

function processIf(el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions(el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2("v-" + (el.elseif ? 'else-if="' + el.elseif + '"' : 'else') + " " + "used on element <" + el.tag + "> without corresponding v-if.");
  }
}

function findPrevElement(children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i];
    } else {
      if (false) {
        warn$2("text \"" + children[i].text.trim() + "\" between v-if and v-else(-if) " + "will be ignored.");
      }
      children.pop();
    }
  }
}

function addIfCondition(el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce(el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot(el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2("`key` does not work on <slot> because slots are abstract outlets " + "and can possibly expand into multiple elements. " + "Use the key on a wrapping element instead.");
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2("the \"scope\" attribute for scoped slots have been deprecated and " + "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " + "can also be used on plain elements in addition to <template> to " + "denote scoped slots.", true);
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if (slotScope = getAndRemoveAttr(el, 'slot-scope')) {
      /* istanbul ignore if */
      if (false) {
        warn$2("Ambiguous combined usage of slot-scope and v-for on <" + el.tag + "> " + "(v-for takes higher priority). Use a wrapper <template> for the " + "scoped slot to make it clearer.", true);
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent(el) {
  var binding;
  if (binding = getBindingAttr(el, 'is')) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs(el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) {
        // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') {
              name = 'innerHTML';
            }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(el, "update:" + camelize(name), genAssignmentCode(value, "$event"));
          }
        }
        if (isProp || !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) {
        // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else {
        // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(name + "=\"" + value + "\": " + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div id="{{ val }}">, use <div :id="val">.');
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component && name === 'muted' && platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor(el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true;
    }
    parent = parent.parent;
  }
  return false;
}

function parseModifiers(name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) {
      ret[m.slice(1)] = true;
    });
    return ret;
  }
}

function makeAttrsMap(attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (false) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map;
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag(el) {
  return el.tag === 'script' || el.tag === 'style';
}

function isForbiddenTag(el) {
  return el.tag === 'style' || el.tag === 'script' && (!el.attrsMap.type || el.attrsMap.type === 'text/javascript');
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug(attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res;
}

function checkForAliasModel(el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2("<" + el.tag + " v-model=\"" + value + "\">: " + "You are binding v-model directly to a v-for iteration alias. " + "This will not be able to modify the v-for source array because " + "writing to the alias is like modifying a function local variable. " + "Consider using an array of objects and use v-model on an object property instead.");
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode(el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return;
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + map['v-bind'] + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? "&&(" + ifCondition + ")" : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0;
    }
  }
}

function cloneASTElement(el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent);
}

var model$2 = {
  preTransformNode: preTransformNode
};

var modules$1 = [klass$1, style$1, model$2];

/*  */

function text(el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', "_s(" + dir.value + ")");
  }
}

/*  */

function html(el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', "_s(" + dir.value + ")");
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html

  /*  */

};var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize(root, options) {
  if (!root) {
    return;
  }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1(keys) {
  return makeMap('type,tag,attrsList,attrsMap,plain,parent,children,attrs' + (keys ? ',' + keys : ''));
}

function markStatic$1(node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (!isPlatformReservedTag(node.tag) && node.tag !== 'slot' && node.attrsMap['inline-template'] == null) {
      return;
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots(node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(node.children.length === 1 && node.children[0].type === 3)) {
      node.staticRoot = true;
      return;
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic(node) {
  if (node.type === 2) {
    // expression
    return false;
  }
  if (node.type === 3) {
    // text
    return true;
  }
  return !!(node.pre || !node.hasBindings && // no dynamic bindings
  !node.if && !node.for && // not v-if or v-for or v-else
  !isBuiltInTag(node.tag) && // not a built-in
  isPlatformReservedTag(node.tag) && // not a component
  !isDirectChildOfTemplateFor(node) && Object.keys(node).every(isStaticKey));
}

function isDirectChildOfTemplateFor(node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false;
    }
    if (node.for) {
      return true;
    }
  }
  return false;
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  'delete': ['Backspace', 'Delete']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function genGuard(condition) {
  return "if(" + condition + ")return null;";
};

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers(events, isNative, warn) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + genHandler(name, events[name]) + ",";
  }
  return res.slice(0, -1) + '}';
}

function genHandler(name, handler) {
  if (!handler) {
    return 'function(){}';
  }

  if (Array.isArray(handler)) {
    return "[" + handler.map(function (handler) {
      return genHandler(name, handler);
    }).join(',') + "]";
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value;
    }
    /* istanbul ignore if */
    return "function($event){" + handler.value + "}"; // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = handler.modifiers;
        genModifierCode += genGuard(['ctrl', 'shift', 'alt', 'meta'].filter(function (keyModifier) {
          return !modifiers[keyModifier];
        }).map(function (keyModifier) {
          return "$event." + keyModifier + "Key";
        }).join('||'));
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath ? "return " + handler.value + "($event)" : isFunctionExpression ? "return (" + handler.value + ")($event)" : handler.value;
    /* istanbul ignore if */
    return "function($event){" + code + handlerCode + "}";
  }
}

function genKeyFilter(keys) {
  return "if(!('button' in $event)&&" + keys.map(genFilterCode).join('&&') + ")return null;";
}

function genFilterCode(key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return "$event.keyCode!==" + keyVal;
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return "_k($event.keyCode," + JSON.stringify(key) + "," + JSON.stringify(keyCode) + "," + "$event.key," + "" + JSON.stringify(keyName) + ")";
}

/*  */

function on(el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) {
    return "_g(" + code + "," + dir.value + ")";
  };
}

/*  */

function bind$1(el, dir) {
  el.wrapData = function (code) {
    return "_b(" + code + ",'" + el.tag + "'," + dir.value + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")";
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop

  /*  */

};var CodegenState = function CodegenState(options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) {
    return !isReservedTag(el.tag);
  };
  this.onceId = 0;
  this.staticRenderFns = [];
};

function generate(ast, options) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: "with(this){return " + code + "}",
    staticRenderFns: state.staticRenderFns
  };
}

function genElement(el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state);
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state);
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state);
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state);
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0';
  } else if (el.tag === 'slot') {
    return genSlot(el, state);
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + el.tag + "'" + (data ? "," + data : '') + (children ? "," + children : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code;
  }
}

// hoist static sub-trees out
function genStatic(el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push("with(this){return " + genElement(el, state) + "}");
  return "_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")";
}

// v-once
function genOnce(el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state);
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break;
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn("v-once can only be used inside v-for that is keyed. ");
      return genElement(el, state);
    }
    return "_o(" + genElement(el, state) + "," + state.onceId++ + "," + key + ")";
  } else {
    return genStatic(el, state);
  }
}

function genIf(el, state, altGen, altEmpty) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty);
}

function genIfConditions(conditions, state, altGen, altEmpty) {
  if (!conditions.length) {
    return altEmpty || '_e()';
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return "(" + condition.exp + ")?" + genTernaryExp(condition.block) + ":" + genIfConditions(conditions, state, altGen, altEmpty);
  } else {
    return "" + genTernaryExp(condition.block);
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp(el) {
    return altGen ? altGen(el, state) : el.once ? genOnce(el, state) : genElement(el, state);
  }
}

function genFor(el, state, altGen, altHelper) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? "," + el.iterator1 : '';
  var iterator2 = el.iterator2 ? "," + el.iterator2 : '';

  if (false) {
    state.warn("<" + el.tag + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " + "v-for should have explicit keys. " + "See https://vuejs.org/guide/list.html#key for more info.", true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," + "function(" + alias + iterator1 + iterator2 + "){" + "return " + (altGen || genElement)(el, state) + '})';
}

function genData$2(el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) {
    data += dirs + ',';
  }

  // key
  if (el.key) {
    data += "key:" + el.key + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + el.ref + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + el.tag + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + genProps(el.attrs) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + genProps(el.props) + "},";
  }
  // event handlers
  if (el.events) {
    data += genHandlers(el.events, false, state.warn) + ",";
  }
  if (el.nativeEvents) {
    data += genHandlers(el.nativeEvents, true, state.warn) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + el.slotTarget + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += genScopedSlots(el.scopedSlots, state) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + el.model.value + ",callback:" + el.model.callback + ",expression:" + el.model.expression + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data;
}

function genDirectives(el, state) {
  var dirs = el.directives;
  if (!dirs) {
    return;
  }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + dir.name + "\",rawName:\"" + dir.rawName + "\"" + (dir.value ? ",value:(" + dir.value + "),expression:" + JSON.stringify(dir.value) : '') + (dir.arg ? ",arg:\"" + dir.arg + "\"" : '') + (dir.modifiers ? ",modifiers:" + JSON.stringify(dir.modifiers) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']';
  }
}

function genInlineTemplate(el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return "inlineTemplate:{render:function(){" + inlineRenderFns.render + "},staticRenderFns:[" + inlineRenderFns.staticRenderFns.map(function (code) {
      return "function(){" + code + "}";
    }).join(',') + "]}";
  }
}

function genScopedSlots(slots, state) {
  return "scopedSlots:_u([" + Object.keys(slots).map(function (key) {
    return genScopedSlot(key, slots[key], state);
  }).join(',') + "])";
}

function genScopedSlot(key, el, state) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state);
  }
  var fn = "function(" + String(el.slotScope) + "){" + "return " + (el.tag === 'template' ? el.if ? el.if + "?" + (genChildren(el, state) || 'undefined') + ":undefined" : genChildren(el, state) || 'undefined' : genElement(el, state)) + "}";
  return "{key:" + key + ",fn:" + fn + "}";
}

function genForScopedSlot(key, el, state) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? "," + el.iterator1 : '';
  var iterator2 = el.iterator2 ? "," + el.iterator2 : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," + "function(" + alias + iterator1 + iterator2 + "){" + "return " + genScopedSlot(key, el, state) + '})';
}

function genChildren(el, state, checkSkip, altGenElement, altGenNode) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 && el$1.for && el$1.tag !== 'template' && el$1.tag !== 'slot') {
      return (altGenElement || genElement)(el$1, state);
    }
    var normalizationType = checkSkip ? getNormalizationType(children, state.maybeComponent) : 0;
    var gen = altGenNode || genNode;
    return "[" + children.map(function (c) {
      return gen(c, state);
    }).join(',') + "]" + (normalizationType ? "," + normalizationType : '');
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType(children, maybeComponent) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue;
    }
    if (needsNormalization(el) || el.ifConditions && el.ifConditions.some(function (c) {
      return needsNormalization(c.block);
    })) {
      res = 2;
      break;
    }
    if (maybeComponent(el) || el.ifConditions && el.ifConditions.some(function (c) {
      return maybeComponent(c.block);
    })) {
      res = 1;
    }
  }
  return res;
}

function needsNormalization(el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot';
}

function genNode(node, state) {
  if (node.type === 1) {
    return genElement(node, state);
  }if (node.type === 3 && node.isComment) {
    return genComment(node);
  } else {
    return genText(node);
  }
}

function genText(text) {
  return "_v(" + (text.type === 2 ? text.expression // no need for () because already wrapped in _s()
  : transformSpecialNewlines(JSON.stringify(text.text))) + ")";
}

function genComment(comment) {
  return "_e(" + JSON.stringify(comment.text) + ")";
}

function genSlot(el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? "," + children : '');
  var attrs = el.attrs && "{" + el.attrs.map(function (a) {
    return camelize(a.name) + ":" + a.value;
  }).join(',') + "}";
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')';
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent(componentName, el, state) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return "_c(" + componentName + "," + genData$2(el, state) + (children ? "," + children : '') + ")";
}

function genProps(props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + prop.name + "\":" + transformSpecialNewlines(prop.value) + ",";
    }
  }
  return res.slice(0, -1);
}

// #3895, #4268
function transformSpecialNewlines(text) {
  return text.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + ('do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' + 'super,throw,while,yield,delete,export,import,return,switch,default,' + 'extends,finally,continue,debugger,function,arguments').split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + 'delete,typeof,void'.split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors(ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors;
}

function checkNode(node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, "v-for=\"" + value + "\"", errors);
          } else if (onRE.test(name)) {
            checkEvent(value, name + "=\"" + value + "\"", errors);
          } else {
            checkExpression(value, name + "=\"" + value + "\"", errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent(exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push("avoid using JavaScript unary operator as property name: " + "\"" + keywordMatch[0] + "\" in expression " + text.trim());
  }
  checkExpression(exp, text, errors);
}

function checkFor(node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier(ident, type, text, errors) {
  if (typeof ident === 'string') {
    try {
      new Function("var " + ident + "=_");
    } catch (e) {
      errors.push("invalid " + type + " \"" + ident + "\" in expression: " + text.trim());
    }
  }
}

function checkExpression(exp, text, errors) {
  try {
    new Function("return " + exp);
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push("avoid using JavaScript keyword as property name: " + "\"" + keywordMatch[0] + "\"\n  Raw expression: " + text.trim());
    } else {
      errors.push("invalid expression: " + e.message + " in\n\n" + "    " + exp + "\n\n" + "  Raw expression: " + text.trim() + "\n");
    }
  }
}

/*  */

function createFunction(code, errors) {
  try {
    return new Function(code);
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop;
  }
}

function createCompileToFunctionFn(compile) {
  var cache = Object.create(null);

  return function compileToFunctions(template, options, vm) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1('It seems you are using the standalone build of Vue.js in an ' + 'environment with Content Security Policy that prohibits unsafe-eval. ' + 'The template compiler cannot work in this environment. Consider ' + 'relaxing the policy to allow unsafe-eval or pre-compiling your ' + 'templates into render functions.');
        }
      }
    }

    // check cache
    var key = options.delimiters ? String(options.delimiters) + template : template;
    if (cache[key]) {
      return cache[key];
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1("Error compiling template:\n\n" + template + "\n\n" + compiled.errors.map(function (e) {
          return "- " + e;
        }).join('\n') + '\n', vm);
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) {
          return tip(msg, vm);
        });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors);
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1("Failed to generate render function:\n\n" + fnGenErrors.map(function (ref) {
          var err = ref.err;
          var code = ref.code;

          return err.toString() + " in\n\n" + code + "\n";
        }).join('\n'), vm);
      }
    }

    return cache[key] = res;
  };
}

/*  */

function createCompilerCreator(baseCompile) {
  return function createCompiler(baseOptions) {
    function compile(template, options) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(Object.create(baseOptions.directives || null), options.directives);
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled;
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    };
  };
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile(template, options) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  };
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode(href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0;
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML;
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (el, hydrating) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn("Do not mount Vue to <html> or <body> - mount to normal elements instead.");
    return this;
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn("Template element not found or is empty: " + options.template, this);
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this;
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure("vue " + this._name + " compile", 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating);
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML(el) {
  if (el.outerHTML) {
    return el.outerHTML;
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML;
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11), __webpack_require__(109).setImmediate))

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue_vue_type_template_id_1149e074__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pagination_vue_vue_type_script_lang_js__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pagination_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Pagination_vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Pagination_vue_vue_type_template_id_1149e074__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Pagination_vue_vue_type_template_id_1149e074__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentFilter_Vue_vue_type_template_id_2c1fc8ba__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFilter_Vue_vue_type_script_lang_js__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ContentFilter_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ContentFilter_Vue_vue_type_template_id_2c1fc8ba__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ContentFilter_Vue_vue_type_template_id_2c1fc8ba__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DeleteConfirmer_Vue_vue_type_template_id_5ef23928__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DeleteConfirmer_Vue_vue_type_script_lang_js__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DeleteConfirmer_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__DeleteConfirmer_Vue_vue_type_template_id_5ef23928__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DeleteConfirmer_Vue_vue_type_template_id_5ef23928__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 11 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function webpackUniversalModuleDefinition(e, t) {
  if ("object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module))) module.exports = t();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var r = t();for (var n in r) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : e)[n] = r[n];
    }
  }
}(window, function () {
  return function (e) {
    var t = {};function __webpack_require__(r) {
      if (t[r]) return t[r].exports;var n = t[r] = { i: r, l: !1, exports: {} };return e[r].call(n.exports, n, n.exports, __webpack_require__), n.l = !0, n.exports;
    }return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, r) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r });
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e && e.__esModule) return e;var r = Object.create(null);if (__webpack_require__.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var n in e) {
        __webpack_require__.d(r, n, function (t) {
          return e[t];
        }.bind(null, n));
      }return r;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 45);
  }([function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }();var i = { debug: function debug() {}, info: function info() {}, warn: function warn() {}, error: function error() {} },
        o = void 0,
        s = void 0;(t.Log = function () {
      function Log() {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Log);
      }return Log.reset = function reset() {
        s = 3, o = i;
      }, Log.debug = function debug() {
        if (s >= 4) {
          for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }o.debug.apply(o, Array.from(t));
        }
      }, Log.info = function info() {
        if (s >= 3) {
          for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }o.info.apply(o, Array.from(t));
        }
      }, Log.warn = function warn() {
        if (s >= 2) {
          for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }o.warn.apply(o, Array.from(t));
        }
      }, Log.error = function error() {
        if (s >= 1) {
          for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }o.error.apply(o, Array.from(t));
        }
      }, n(Log, null, [{ key: "NONE", get: function get() {
          return 0;
        } }, { key: "ERROR", get: function get() {
          return 1;
        } }, { key: "WARN", get: function get() {
          return 2;
        } }, { key: "INFO", get: function get() {
          return 3;
        } }, { key: "DEBUG", get: function get() {
          return 4;
        } }, { key: "level", get: function get() {
          return s;
        }, set: function set(e) {
          if (!(0 <= e && e <= 4)) throw new Error("Invalid log level");s = e;
        } }, { key: "logger", get: function get() {
          return o;
        }, set: function set(e) {
          if (!e.debug && e.info && (e.debug = e.info), !(e.debug && e.info && e.warn && e.error)) throw new Error("Invalid logger");o = e;
        } }]), Log;
    }()).reset();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }();var i = { setInterval: function (e) {
        function setInterval(t, r) {
          return e.apply(this, arguments);
        }return setInterval.toString = function () {
          return e.toString();
        }, setInterval;
      }(function (e, t) {
        return setInterval(e, t);
      }), clearInterval: function (e) {
        function clearInterval(t) {
          return e.apply(this, arguments);
        }return clearInterval.toString = function () {
          return e.toString();
        }, clearInterval;
      }(function (e) {
        return clearInterval(e);
      }) },
        o = !1,
        s = null;t.Global = function () {
      function Global() {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Global);
      }return Global._testing = function _testing() {
        o = !0;
      }, Global.setXMLHttpRequest = function setXMLHttpRequest(e) {
        s = e;
      }, n(Global, null, [{ key: "location", get: function get() {
          if (!o) return location;
        } }, { key: "localStorage", get: function get() {
          if (!o && "undefined" != typeof window) return localStorage;
        } }, { key: "sessionStorage", get: function get() {
          if (!o && "undefined" != typeof window) return sessionStorage;
        } }, { key: "XMLHttpRequest", get: function get() {
          if (!o && "undefined" != typeof window) return s || XMLHttpRequest;
        } }, { key: "timer", get: function get() {
          if (!o) return i;
        } }]), Global;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.UrlUtility = void 0;var n = r(0),
        i = r(1);t.UrlUtility = function () {
      function UrlUtility() {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, UrlUtility);
      }return UrlUtility.addQueryParam = function addQueryParam(e, t, r) {
        return e.indexOf("?") < 0 && (e += "?"), "?" !== e[e.length - 1] && (e += "&"), e += encodeURIComponent(t), e += "=", e += encodeURIComponent(r);
      }, UrlUtility.parseUrlFragment = function parseUrlFragment(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#",
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.Global;"string" != typeof e && (e = r.location.href);var o = e.lastIndexOf(t);o >= 0 && (e = e.substr(o + 1));for (var s, a = {}, u = /([^&=]+)=([^&]*)/g, c = 0; s = u.exec(e);) {
          if (a[decodeURIComponent(s[1])] = decodeURIComponent(s[2]), c++ > 50) return n.Log.error("UrlUtility.parseUrlFragment: response exceeded expected number of parameters", e), { error: "Response exceeded expected number of parameters" };
        }for (var h in a) {
          return a;
        }return {};
      }, UrlUtility;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.MetadataService = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0),
        o = r(17);t.MetadataService = function () {
      function MetadataService(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.JsonService;if (function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, MetadataService), !e) throw i.Log.error("MetadataService: No settings passed to MetadataService"), new Error("settings");this._settings = e, this._jsonService = new t(["application/jwk-set+json"]);
      }return MetadataService.prototype.getMetadata = function getMetadata() {
        var e = this;return this._settings.metadata ? (i.Log.debug("MetadataService.getMetadata: Returning metadata from settings"), Promise.resolve(this._settings.metadata)) : this.metadataUrl ? (i.Log.debug("MetadataService.getMetadata: getting metadata from", this.metadataUrl), this._jsonService.getJson(this.metadataUrl).then(function (t) {
          return i.Log.debug("MetadataService.getMetadata: json received"), e._settings.metadata = t, t;
        })) : (i.Log.error("MetadataService.getMetadata: No authority or metadataUrl configured on settings"), Promise.reject(new Error("No authority or metadataUrl configured on settings")));
      }, MetadataService.prototype.getIssuer = function getIssuer() {
        return this._getMetadataProperty("issuer");
      }, MetadataService.prototype.getAuthorizationEndpoint = function getAuthorizationEndpoint() {
        return this._getMetadataProperty("authorization_endpoint");
      }, MetadataService.prototype.getUserInfoEndpoint = function getUserInfoEndpoint() {
        return this._getMetadataProperty("userinfo_endpoint");
      }, MetadataService.prototype.getTokenEndpoint = function getTokenEndpoint() {
        return this._getMetadataProperty("token_endpoint", !0);
      }, MetadataService.prototype.getCheckSessionIframe = function getCheckSessionIframe() {
        return this._getMetadataProperty("check_session_iframe", !0);
      }, MetadataService.prototype.getEndSessionEndpoint = function getEndSessionEndpoint() {
        return this._getMetadataProperty("end_session_endpoint", !0);
      }, MetadataService.prototype.getRevocationEndpoint = function getRevocationEndpoint() {
        return this._getMetadataProperty("revocation_endpoint", !0);
      }, MetadataService.prototype._getMetadataProperty = function _getMetadataProperty(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];return i.Log.debug("MetadataService.getMetadataProperty for: " + e), this.getMetadata().then(function (r) {
          if (i.Log.debug("MetadataService.getMetadataProperty: metadata recieved"), void 0 === r[e]) {
            if (!0 === t) return void i.Log.warn("MetadataService.getMetadataProperty: Metadata does not contain optional property " + e);throw i.Log.error("MetadataService.getMetadataProperty: Metadata does not contain property " + e), new Error("Metadata does not contain property " + e);
          }return r[e];
        });
      }, MetadataService.prototype.getSigningKeys = function getSigningKeys() {
        var e = this;return this._settings.signingKeys ? (i.Log.debug("MetadataService.getSigningKeys: Returning signingKeys from settings"), Promise.resolve(this._settings.signingKeys)) : this._getMetadataProperty("jwks_uri").then(function (t) {
          return i.Log.debug("MetadataService.getSigningKeys: jwks_uri received", t), e._jsonService.getJson(t).then(function (t) {
            if (i.Log.debug("MetadataService.getSigningKeys: key set received", t), !t.keys) throw i.Log.error("MetadataService.getSigningKeys: Missing keys on keyset"), new Error("Missing keys on keyset");return e._settings.signingKeys = t.keys, e._settings.signingKeys;
          });
        });
      }, n(MetadataService, [{ key: "metadataUrl", get: function get() {
          return this._metadataUrl || (this._settings.metadataUrl ? this._metadataUrl = this._settings.metadataUrl : (this._metadataUrl = this._settings.authority, this._metadataUrl && this._metadataUrl.indexOf(".well-known/openid-configuration") < 0 && ("/" !== this._metadataUrl[this._metadataUrl.length - 1] && (this._metadataUrl += "/"), this._metadataUrl += ".well-known/openid-configuration"))), this._metadataUrl;
        } }]), MetadataService;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.State = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0),
        o = function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }(r(14));t.State = function () {
      function State() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.id,
            r = e.data,
            n = e.created;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, State), this._id = t || (0, o.default)(), this._data = r, this._created = "number" == typeof n && n > 0 ? n : parseInt(Date.now() / 1e3);
      }return State.prototype.toStorageString = function toStorageString() {
        return i.Log.debug("State.toStorageString"), JSON.stringify({ id: this.id, data: this.data, created: this.created });
      }, State.fromStorageString = function fromStorageString(e) {
        return i.Log.debug("State.fromStorageString"), new State(JSON.parse(e));
      }, State.clearStaleState = function clearStaleState(e, t) {
        var r = Date.now() / 1e3 - t;return e.getAllKeys().then(function (t) {
          i.Log.debug("State.clearStaleState: got keys", t);for (var n = [], o = function _loop(o) {
            var s = t[o];a = e.get(s).then(function (t) {
              var n = !1;if (t) try {
                var o = State.fromStorageString(t);i.Log.debug("State.clearStaleState: got item from key: ", s, o.created), o.created <= r && (n = !0);
              } catch (e) {
                i.Log.error("State.clearStaleState: Error parsing state for key", s, e.message), n = !0;
              } else i.Log.debug("State.clearStaleState: no item in storage for key: ", s), n = !0;if (n) return i.Log.debug("State.clearStaleState: removed item for key: ", s), e.remove(s);
            }), n.push(a);
          }, s = 0; s < t.length; s++) {
            var a;o(s);
          }return i.Log.debug("State.clearStaleState: waiting on promise count:", n.length), Promise.all(n);
        });
      }, n(State, [{ key: "id", get: function get() {
          return this._id;
        } }, { key: "data", get: function get() {
          return this._data;
        } }, { key: "created", get: function get() {
          return this._created;
        } }]), State;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.WebStorageStateStore = void 0;var n = r(0),
        i = r(1);t.WebStorageStateStore = function () {
      function WebStorageStateStore() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.prefix,
            r = void 0 === t ? "oidc." : t,
            n = e.store,
            o = void 0 === n ? i.Global.localStorage : n;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, WebStorageStateStore), this._store = o, this._prefix = r;
      }return WebStorageStateStore.prototype.set = function set(e, t) {
        return n.Log.debug("WebStorageStateStore.set", e), e = this._prefix + e, this._store.setItem(e, t), Promise.resolve();
      }, WebStorageStateStore.prototype.get = function get(e) {
        n.Log.debug("WebStorageStateStore.get", e), e = this._prefix + e;var t = this._store.getItem(e);return Promise.resolve(t);
      }, WebStorageStateStore.prototype.remove = function remove(e) {
        n.Log.debug("WebStorageStateStore.remove", e), e = this._prefix + e;var t = this._store.getItem(e);return this._store.removeItem(e), Promise.resolve(t);
      }, WebStorageStateStore.prototype.getAllKeys = function getAllKeys() {
        n.Log.debug("WebStorageStateStore.getAllKeys");for (var e = [], t = 0; t < this._store.length; t++) {
          var r = this._store.key(t);0 === r.indexOf(this._prefix) && e.push(r.substr(this._prefix.length));
        }return Promise.resolve(e);
      }, WebStorageStateStore;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.OidcClientSettings = void 0;var n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return typeof e === "undefined" ? "undefined" : _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
    },
        i = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        o = r(0),
        s = r(5),
        a = r(44),
        u = r(3);var c = "id_token",
        h = "openid",
        f = 900,
        l = 300;t.OidcClientSettings = function () {
      function OidcClientSettings() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.authority,
            r = e.metadataUrl,
            i = e.metadata,
            o = e.signingKeys,
            g = e.client_id,
            p = e.client_secret,
            d = e.response_type,
            v = void 0 === d ? c : d,
            y = e.scope,
            m = void 0 === y ? h : y,
            S = e.redirect_uri,
            F = e.post_logout_redirect_uri,
            b = e.prompt,
            _ = e.display,
            w = e.max_age,
            E = e.ui_locales,
            x = e.acr_values,
            C = e.resource,
            P = e.filterProtocolClaims,
            A = void 0 === P || P,
            k = e.loadUserInfo,
            I = void 0 === k || k,
            B = e.staleStateAge,
            R = void 0 === B ? f : B,
            T = e.clockSkew,
            U = void 0 === T ? l : T,
            M = e.stateStore,
            L = void 0 === M ? new s.WebStorageStateStore() : M,
            D = e.ResponseValidatorCtor,
            N = void 0 === D ? a.ResponseValidator : D,
            O = e.MetadataServiceCtor,
            H = void 0 === O ? u.MetadataService : O,
            j = e.extraQueryParams,
            K = void 0 === j ? {} : j;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, OidcClientSettings), this._authority = t, this._metadataUrl = r, this._metadata = i, this._signingKeys = o, this._client_id = g, this._client_secret = p, this._response_type = v, this._scope = m, this._redirect_uri = S, this._post_logout_redirect_uri = F, this._prompt = b, this._display = _, this._max_age = w, this._ui_locales = E, this._acr_values = x, this._resource = C, this._filterProtocolClaims = !!A, this._loadUserInfo = !!I, this._staleStateAge = R, this._clockSkew = U, this._stateStore = L, this._validator = new N(this), this._metadataService = new H(this), this._extraQueryParams = "object" === (void 0 === K ? "undefined" : n(K)) ? K : {};
      }return i(OidcClientSettings, [{ key: "client_id", get: function get() {
          return this._client_id;
        }, set: function set(e) {
          if (this._client_id) throw o.Log.error("OidcClientSettings.set_client_id: client_id has already been assigned."), new Error("client_id has already been assigned.");this._client_id = e;
        } }, { key: "client_secret", get: function get() {
          return this._client_secret;
        } }, { key: "response_type", get: function get() {
          return this._response_type;
        } }, { key: "scope", get: function get() {
          return this._scope;
        } }, { key: "redirect_uri", get: function get() {
          return this._redirect_uri;
        } }, { key: "post_logout_redirect_uri", get: function get() {
          return this._post_logout_redirect_uri;
        } }, { key: "prompt", get: function get() {
          return this._prompt;
        } }, { key: "display", get: function get() {
          return this._display;
        } }, { key: "max_age", get: function get() {
          return this._max_age;
        } }, { key: "ui_locales", get: function get() {
          return this._ui_locales;
        } }, { key: "acr_values", get: function get() {
          return this._acr_values;
        } }, { key: "resource", get: function get() {
          return this._resource;
        } }, { key: "authority", get: function get() {
          return this._authority;
        }, set: function set(e) {
          if (this._authority) throw o.Log.error("OidcClientSettings.set_authority: authority has already been assigned."), new Error("authority has already been assigned.");this._authority = e;
        } }, { key: "metadataUrl", get: function get() {
          return this._metadataUrl || (this._metadataUrl = this.authority, this._metadataUrl && this._metadataUrl.indexOf(".well-known/openid-configuration") < 0 && ("/" !== this._metadataUrl[this._metadataUrl.length - 1] && (this._metadataUrl += "/"), this._metadataUrl += ".well-known/openid-configuration")), this._metadataUrl;
        } }, { key: "metadata", get: function get() {
          return this._metadata;
        }, set: function set(e) {
          this._metadata = e;
        } }, { key: "signingKeys", get: function get() {
          return this._signingKeys;
        }, set: function set(e) {
          this._signingKeys = e;
        } }, { key: "filterProtocolClaims", get: function get() {
          return this._filterProtocolClaims;
        } }, { key: "loadUserInfo", get: function get() {
          return this._loadUserInfo;
        } }, { key: "staleStateAge", get: function get() {
          return this._staleStateAge;
        } }, { key: "clockSkew", get: function get() {
          return this._clockSkew;
        } }, { key: "stateStore", get: function get() {
          return this._stateStore;
        } }, { key: "validator", get: function get() {
          return this._validator;
        } }, { key: "metadataService", get: function get() {
          return this._metadataService;
        } }, { key: "extraQueryParams", get: function get() {
          return this._extraQueryParams;
        }, set: function set(e) {
          "object" === (void 0 === e ? "undefined" : n(e)) ? this._extraQueryParams = e : this._extraQueryParams = {};
        } }]), OidcClientSettings;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.CordovaPopupWindow = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0);var o = "location=no,toolbar=no,zoom=no",
        s = "_blank";t.CordovaPopupWindow = function () {
      function CordovaPopupWindow(e) {
        var t = this;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, CordovaPopupWindow), this._promise = new Promise(function (e, r) {
          t._resolve = e, t._reject = r;
        }), this.features = e.popupWindowFeatures || o, this.target = e.popupWindowTarget || s, this.redirect_uri = e.startUrl, i.Log.debug("CordovaPopupWindow.ctor: redirect_uri: " + this.redirect_uri);
      }return CordovaPopupWindow.prototype._isInAppBrowserInstalled = function _isInAppBrowserInstalled(e) {
        return ["cordova-plugin-inappbrowser", "cordova-plugin-inappbrowser.inappbrowser", "org.apache.cordova.inappbrowser"].some(function (t) {
          return e.hasOwnProperty(t);
        });
      }, CordovaPopupWindow.prototype.navigate = function navigate(e) {
        if (e && e.url) {
          if (!window.cordova) return this._error("cordova is undefined");var t = window.cordova.require("cordova/plugin_list").metadata;if (!1 === this._isInAppBrowserInstalled(t)) return this._error("InAppBrowser plugin not found");this._popup = cordova.InAppBrowser.open(e.url, this.target, this.features), this._popup ? (i.Log.debug("CordovaPopupWindow.navigate: popup successfully created"), this._exitCallbackEvent = this._exitCallback.bind(this), this._loadStartCallbackEvent = this._loadStartCallback.bind(this), this._popup.addEventListener("exit", this._exitCallbackEvent, !1), this._popup.addEventListener("loadstart", this._loadStartCallbackEvent, !1)) : this._error("Error opening popup window");
        } else this._error("No url provided");return this.promise;
      }, CordovaPopupWindow.prototype._loadStartCallback = function _loadStartCallback(e) {
        0 === e.url.indexOf(this.redirect_uri) && this._success({ url: e.url });
      }, CordovaPopupWindow.prototype._exitCallback = function _exitCallback(e) {
        this._error(e);
      }, CordovaPopupWindow.prototype._success = function _success(e) {
        this._cleanup(), i.Log.debug("CordovaPopupWindow: Successful response from cordova popup window"), this._resolve(e);
      }, CordovaPopupWindow.prototype._error = function _error(e) {
        this._cleanup(), i.Log.error(e), this._reject(new Error(e));
      }, CordovaPopupWindow.prototype.close = function close() {
        this._cleanup();
      }, CordovaPopupWindow.prototype._cleanup = function _cleanup() {
        this._popup && (i.Log.debug("CordovaPopupWindow: cleaning up popup"), this._popup.removeEventListener("exit", this._exitCallbackEvent, !1), this._popup.removeEventListener("loadstart", this._loadStartCallbackEvent, !1), this._popup.close()), this._popup = null;
      }, n(CordovaPopupWindow, [{ key: "promise", get: function get() {
          return this._promise;
        } }]), CordovaPopupWindow;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.TokenRevocationClient = void 0;var n = r(0),
        i = r(3),
        o = r(1);t.TokenRevocationClient = function () {
      function TokenRevocationClient(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.Global.XMLHttpRequest,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService;if (function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, TokenRevocationClient), !e) throw n.Log.error("TokenRevocationClient.ctor: No settings provided"), new Error("No settings provided.");this._settings = e, this._XMLHttpRequestCtor = t, this._metadataService = new r(this._settings);
      }return TokenRevocationClient.prototype.revoke = function revoke(e, t) {
        var r = this;if (!e) throw n.Log.error("TokenRevocationClient.revoke: No accessToken provided"), new Error("No accessToken provided.");return this._metadataService.getRevocationEndpoint().then(function (i) {
          if (i) {
            n.Log.error("TokenRevocationClient.revoke: Revoking access token");var o = r._settings.client_id,
                s = r._settings.client_secret;return r._revoke(i, o, s, e);
          }if (t) throw n.Log.error("TokenRevocationClient.revoke: Revocation not supported"), new Error("Revocation not supported");
        });
      }, TokenRevocationClient.prototype._revoke = function _revoke(e, t, r, i) {
        var o = this;return new Promise(function (s, a) {
          var u = new o._XMLHttpRequestCtor();u.open("POST", e), u.onload = function () {
            n.Log.debug("TokenRevocationClient.revoke: HTTP response received, status", u.status), 200 === u.status ? s() : a(Error(u.statusText + " (" + u.status + ")"));
          };var c = "client_id=" + encodeURIComponent(t);r && (c += "&client_secret=" + encodeURIComponent(r)), c += "&token_type_hint=" + encodeURIComponent("access_token"), c += "&token=" + encodeURIComponent(i), u.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), u.send(c);
        });
      }, TokenRevocationClient;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.CheckSessionIFrame = void 0;var n = r(0);var i = 2e3;t.CheckSessionIFrame = function () {
      function CheckSessionIFrame(e, t, r, n) {
        var o = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4];!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, CheckSessionIFrame), this._callback = e, this._client_id = t, this._url = r, this._interval = n || i, this._stopOnError = o;var s = r.indexOf("/", r.indexOf("//") + 2);this._frame_origin = r.substr(0, s), this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "absolute", this._frame.style.display = "none", this._frame.style.width = 0, this._frame.style.height = 0, this._frame.src = r;
      }return CheckSessionIFrame.prototype.load = function load() {
        var e = this;return new Promise(function (t) {
          e._frame.onload = function () {
            t();
          }, window.document.body.appendChild(e._frame), e._boundMessageEvent = e._message.bind(e), window.addEventListener("message", e._boundMessageEvent, !1);
        });
      }, CheckSessionIFrame.prototype._message = function _message(e) {
        e.origin === this._frame_origin && e.source === this._frame.contentWindow && ("error" === e.data ? (n.Log.error("CheckSessionIFrame: error message from check session op iframe"), this._stopOnError && this.stop()) : "changed" === e.data ? (n.Log.debug("CheckSessionIFrame: changed message from check session op iframe"), this.stop(), this._callback()) : n.Log.debug("CheckSessionIFrame: " + e.data + " message from check session op iframe"));
      }, CheckSessionIFrame.prototype.start = function start(e) {
        var t = this;if (this._session_state !== e) {
          n.Log.debug("CheckSessionIFrame.start"), this.stop(), this._session_state = e;var r = function send() {
            t._frame.contentWindow.postMessage(t._client_id + " " + t._session_state, t._frame_origin);
          };r(), this._timer = window.setInterval(r, this._interval);
        }
      }, CheckSessionIFrame.prototype.stop = function stop() {
        this._session_state = null, this._timer && (n.Log.debug("CheckSessionIFrame.stop"), window.clearInterval(this._timer), this._timer = null);
      }, CheckSessionIFrame;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.SessionMonitor = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0),
        o = r(9);t.SessionMonitor = function () {
      function SessionMonitor(e) {
        var t = this,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.CheckSessionIFrame;if (function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, SessionMonitor), !e) throw i.Log.error("SessionMonitor.ctor: No user manager passed to SessionMonitor"), new Error("userManager");this._userManager = e, this._CheckSessionIFrameCtor = r, this._userManager.events.addUserLoaded(this._start.bind(this)), this._userManager.events.addUserUnloaded(this._stop.bind(this)), this._userManager.getUser().then(function (e) {
          e && t._start(e);
        }).catch(function (e) {
          i.Log.error("SessionMonitor ctor: error from getUser:", e.message);
        });
      }return SessionMonitor.prototype._start = function _start(e) {
        var t = this,
            r = e.session_state;r && (this._sub = e.profile.sub, this._sid = e.profile.sid, i.Log.debug("SessionMonitor._start: session_state:", r, ", sub:", this._sub), this._checkSessionIFrame ? this._checkSessionIFrame.start(r) : this._metadataService.getCheckSessionIframe().then(function (e) {
          if (e) {
            i.Log.debug("SessionMonitor._start: Initializing check session iframe");var n = t._client_id,
                o = t._checkSessionInterval,
                s = t._stopCheckSessionOnError;t._checkSessionIFrame = new t._CheckSessionIFrameCtor(t._callback.bind(t), n, e, o, s), t._checkSessionIFrame.load().then(function () {
              t._checkSessionIFrame.start(r);
            });
          } else i.Log.warn("SessionMonitor._start: No check session iframe found in the metadata");
        }).catch(function (e) {
          i.Log.error("SessionMonitor._start: Error from getCheckSessionIframe:", e.message);
        }));
      }, SessionMonitor.prototype._stop = function _stop() {
        this._sub = null, this._sid = null, this._checkSessionIFrame && (i.Log.debug("SessionMonitor._stop"), this._checkSessionIFrame.stop());
      }, SessionMonitor.prototype._callback = function _callback() {
        var e = this;this._userManager.querySessionStatus().then(function (t) {
          var r = !0;t ? t.sub === e._sub ? (r = !1, e._checkSessionIFrame.start(t.session_state), t.sid === e._sid ? i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, restarting check session iframe; session_state:", t.session_state) : (i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:", t.session_state), e._userManager.events._raiseUserSessionChanged())) : i.Log.debug("SessionMonitor._callback: Different subject signed into OP:", t.sub) : i.Log.debug("SessionMonitor._callback: Subject no longer signed into OP"), r && (i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed out event"), e._userManager.events._raiseUserSignedOut());
        }).catch(function (t) {
          i.Log.debug("SessionMonitor._callback: Error calling queryCurrentSigninSession; raising signed out event", t.message), e._userManager.events._raiseUserSignedOut();
        });
      }, n(SessionMonitor, [{ key: "_settings", get: function get() {
          return this._userManager.settings;
        } }, { key: "_metadataService", get: function get() {
          return this._userManager.metadataService;
        } }, { key: "_client_id", get: function get() {
          return this._settings.client_id;
        } }, { key: "_checkSessionInterval", get: function get() {
          return this._settings.checkSessionInterval;
        } }, { key: "_stopCheckSessionOnError", get: function get() {
          return this._settings.stopCheckSessionOnError;
        } }]), SessionMonitor;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.Event = void 0;var n = r(0);t.Event = function () {
      function Event(e) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Event), this._name = e, this._callbacks = [];
      }return Event.prototype.addHandler = function addHandler(e) {
        this._callbacks.push(e);
      }, Event.prototype.removeHandler = function removeHandler(e) {
        var t = this._callbacks.findIndex(function (t) {
          return t === e;
        });t >= 0 && this._callbacks.splice(t, 1);
      }, Event.prototype.raise = function raise() {
        n.Log.debug("Event: Raising event: " + this._name);for (var e = 0; e < this._callbacks.length; e++) {
          var t;(t = this._callbacks)[e].apply(t, arguments);
        }
      }, Event;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.AccessTokenEvents = void 0;var n = r(0),
        i = r(22);var o = 60;t.AccessTokenEvents = function () {
      function AccessTokenEvents() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.accessTokenExpiringNotificationTime,
            r = void 0 === t ? o : t,
            n = e.accessTokenExpiringTimer,
            s = void 0 === n ? new i.Timer("Access token expiring") : n,
            a = e.accessTokenExpiredTimer,
            u = void 0 === a ? new i.Timer("Access token expired") : a;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, AccessTokenEvents), this._accessTokenExpiringNotificationTime = r, this._accessTokenExpiring = s, this._accessTokenExpired = u;
      }return AccessTokenEvents.prototype.load = function load(e) {
        if (e.access_token && void 0 !== e.expires_in) {
          var t = e.expires_in;if (n.Log.debug("AccessTokenEvents.load: access token present, remaining duration:", t), t > 0) {
            var r = t - this._accessTokenExpiringNotificationTime;r <= 0 && (r = 1), n.Log.debug("AccessTokenEvents.load: registering expiring timer in:", r), this._accessTokenExpiring.init(r);
          } else n.Log.debug("AccessTokenEvents.load: canceling existing expiring timer becase we're past expiration."), this._accessTokenExpiring.cancel();var i = t + 1;n.Log.debug("AccessTokenEvents.load: registering expired timer in:", i), this._accessTokenExpired.init(i);
        } else this._accessTokenExpiring.cancel(), this._accessTokenExpired.cancel();
      }, AccessTokenEvents.prototype.unload = function unload() {
        n.Log.debug("AccessTokenEvents.unload: canceling existing access token timers"), this._accessTokenExpiring.cancel(), this._accessTokenExpired.cancel();
      }, AccessTokenEvents.prototype.addAccessTokenExpiring = function addAccessTokenExpiring(e) {
        this._accessTokenExpiring.addHandler(e);
      }, AccessTokenEvents.prototype.removeAccessTokenExpiring = function removeAccessTokenExpiring(e) {
        this._accessTokenExpiring.removeHandler(e);
      }, AccessTokenEvents.prototype.addAccessTokenExpired = function addAccessTokenExpired(e) {
        this._accessTokenExpired.addHandler(e);
      }, AccessTokenEvents.prototype.removeAccessTokenExpired = function removeAccessTokenExpired(e) {
        this._accessTokenExpired.removeHandler(e);
      }, AccessTokenEvents;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.User = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0);t.User = function () {
      function User(e) {
        var t = e.id_token,
            r = e.session_state,
            n = e.access_token,
            i = e.token_type,
            o = e.scope,
            s = e.profile,
            a = e.expires_at,
            u = e.state;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, User), this.id_token = t, this.session_state = r, this.access_token = n, this.token_type = i, this.scope = o, this.profile = s, this.expires_at = a, this.state = u;
      }return User.prototype.toStorageString = function toStorageString() {
        return i.Log.debug("User.toStorageString"), JSON.stringify({ id_token: this.id_token, session_state: this.session_state, access_token: this.access_token, token_type: this.token_type, scope: this.scope, profile: this.profile, expires_at: this.expires_at });
      }, User.fromStorageString = function fromStorageString(e) {
        return i.Log.debug("User.fromStorageString"), new User(JSON.parse(e));
      }, n(User, [{ key: "expires_in", get: function get() {
          if (this.expires_at) {
            var e = parseInt(Date.now() / 1e3);return this.expires_at - e;
          }
        } }, { key: "expired", get: function get() {
          var e = this.expires_in;if (void 0 !== e) return e <= 0;
        } }, { key: "scopes", get: function get() {
          return (this.scope || "").split(" ");
        } }]), User;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default =
    // @preserve Copyright (c) Microsoft Open Technologies, Inc.
    function random() {
      for (var e = "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx", t = "0123456789abcdef", r = 0, n = "", i = 0; i < e.length; i++) {
        "-" !== e[i] && "4" !== e[i] && (r = 16 * Math.random() | 0), "x" === e[i] ? n += t[r] : "y" === e[i] ? (r &= 3, n += t[r |= 8]) : n += e[i];
      }return n;
    }, e.exports = t.default;
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.SigninState = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0),
        o = r(4),
        s = function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }(r(14));t.SigninState = function (e) {
      function SigninState() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = t.nonce,
            n = t.authority,
            i = t.client_id;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, SigninState);var o = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : _typeof(t)) && "function" != typeof t ? e : t;
        }(this, e.call(this, arguments[0]));return !0 === r ? o._nonce = (0, s.default)() : r && (o._nonce = r), o._authority = n, o._client_id = i, o;
      }return function _inherits(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : _typeof(t)));e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(SigninState, e), SigninState.prototype.toStorageString = function toStorageString() {
        return i.Log.debug("SigninState.toStorageString"), JSON.stringify({ id: this.id, data: this.data, created: this.created, nonce: this.nonce, authority: this.authority, client_id: this.client_id });
      }, SigninState.fromStorageString = function fromStorageString(e) {
        return i.Log.debug("SigninState.fromStorageString"), new SigninState(JSON.parse(e));
      }, n(SigninState, [{ key: "nonce", get: function get() {
          return this._nonce;
        } }, { key: "authority", get: function get() {
          return this._authority;
        } }, { key: "client_id", get: function get() {
          return this._client_id;
        } }]), SigninState;
    }(o.State);
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.ErrorResponse = void 0;var n = r(0);t.ErrorResponse = function (e) {
      function ErrorResponse() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = t.error,
            i = t.error_description,
            o = t.error_uri,
            s = t.state;if (function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, ErrorResponse), !r) throw n.Log.error("No error passed to ErrorResponse"), new Error("error");var a = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : _typeof(t)) && "function" != typeof t ? e : t;
        }(this, e.call(this, i || r));return a.name = "ErrorResponse", a.error = r, a.error_description = i, a.error_uri = o, a.state = s, a;
      }return function _inherits(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : _typeof(t)));e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(ErrorResponse, e), ErrorResponse;
    }(Error);
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.JsonService = void 0;var n = r(0),
        i = r(1);t.JsonService = function () {
      function JsonService() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.Global.XMLHttpRequest;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, JsonService), e && Array.isArray(e) ? this._contentTypes = e.slice() : this._contentTypes = [], this._contentTypes.push("application/json"), this._XMLHttpRequest = t;
      }return JsonService.prototype.getJson = function getJson(e, t) {
        var r = this;if (!e) throw n.Log.error("JsonService.getJson: No url passed"), new Error("url");return n.Log.debug("JsonService.getJson, url: ", e), new Promise(function (i, o) {
          var s = new r._XMLHttpRequest();s.open("GET", e);var a = r._contentTypes;s.onload = function () {
            if (n.Log.debug("JsonService.getJson: HTTP response received, status", s.status), 200 === s.status) {
              var t = s.getResponseHeader("Content-Type");if (t) if (a.find(function (e) {
                if (t.startsWith(e)) return !0;
              })) try {
                return void i(JSON.parse(s.responseText));
              } catch (e) {
                return n.Log.error("JsonService.getJson: Error parsing JSON response", e.message), void o(e);
              }o(Error("Invalid response Content-Type: " + t + ", from URL: " + e));
            } else o(Error(s.statusText + " (" + s.status + ")"));
          }, s.onerror = function () {
            n.Log.error("JsonService.getJson: network error"), o(Error("Network Error"));
          }, t && (n.Log.debug("JsonService.getJson: token passed, setting Authorization header"), s.setRequestHeader("Authorization", "Bearer " + t)), s.send();
        });
      }, JsonService;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.OidcClient = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0),
        o = r(6),
        s = r(16),
        a = r(35),
        u = r(34),
        c = r(33),
        h = r(32),
        f = r(15),
        l = r(4);t.OidcClient = function () {
      function OidcClient() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, OidcClient), e instanceof o.OidcClientSettings ? this._settings = e : this._settings = new o.OidcClientSettings(e);
      }return OidcClient.prototype.createSigninRequest = function createSigninRequest() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = t.response_type,
            n = t.scope,
            o = t.redirect_uri,
            s = t.data,
            u = t.state,
            c = t.prompt,
            h = t.display,
            f = t.max_age,
            l = t.ui_locales,
            g = t.id_token_hint,
            p = t.login_hint,
            d = t.acr_values,
            v = t.resource,
            y = t.request,
            m = t.request_uri,
            S = t.extraQueryParams,
            F = arguments[1];i.Log.debug("OidcClient.createSigninRequest");var b = this._settings.client_id;r = r || this._settings.response_type, n = n || this._settings.scope, o = o || this._settings.redirect_uri, c = c || this._settings.prompt, h = h || this._settings.display, f = f || this._settings.max_age, l = l || this._settings.ui_locales, d = d || this._settings.acr_values, v = v || this._settings.resource, S = S || this._settings.extraQueryParams;var _ = this._settings.authority;return this._metadataService.getAuthorizationEndpoint().then(function (t) {
          i.Log.debug("OidcClient.createSigninRequest: Received authorization endpoint", t);var w = new a.SigninRequest({ url: t, client_id: b, redirect_uri: o, response_type: r, scope: n, data: s || u, authority: _, prompt: c, display: h, max_age: f, ui_locales: l, id_token_hint: g, login_hint: p, acr_values: d, resource: v, request: y, request_uri: m, extraQueryParams: S }),
              E = w.state;return (F = F || e._stateStore).set(E.id, E.toStorageString()).then(function () {
            return w;
          });
        });
      }, OidcClient.prototype.processSigninResponse = function processSigninResponse(e, t) {
        var r = this;i.Log.debug("OidcClient.processSigninResponse");var n = new u.SigninResponse(e);return n.state ? (t = t || this._stateStore).remove(n.state).then(function (e) {
          if (!e) throw i.Log.error("OidcClient.processSigninResponse: No matching state found in storage"), new Error("No matching state found in storage");var t = f.SigninState.fromStorageString(e);return i.Log.debug("OidcClient.processSigninResponse: Received state from storage; validating response"), r._validator.validateSigninResponse(t, n);
        }) : (i.Log.error("OidcClient.processSigninResponse: No state in response"), Promise.reject(new Error("No state in response")));
      }, OidcClient.prototype.createSignoutRequest = function createSignoutRequest() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = t.id_token_hint,
            n = t.data,
            o = t.state,
            s = t.post_logout_redirect_uri,
            a = arguments[1];return i.Log.debug("OidcClient.createSignoutRequest"), s = s || this._settings.post_logout_redirect_uri, this._metadataService.getEndSessionEndpoint().then(function (t) {
          if (!t) throw i.Log.error("OidcClient.createSignoutRequest: No end session endpoint url returned"), new Error("no end session endpoint");i.Log.debug("OidcClient.createSignoutRequest: Received end session endpoint", t);var u = new c.SignoutRequest({ url: t, id_token_hint: r, post_logout_redirect_uri: s, data: n || o }),
              h = u.state;return h && (i.Log.debug("OidcClient.createSignoutRequest: Signout request has state to persist"), (a = a || e._stateStore).set(h.id, h.toStorageString())), u;
        });
      }, OidcClient.prototype.processSignoutResponse = function processSignoutResponse(e, t) {
        var r = this;i.Log.debug("OidcClient.processSignoutResponse");var n = new h.SignoutResponse(e);if (!n.state) return i.Log.debug("OidcClient.processSignoutResponse: No state in response"), n.error ? (i.Log.warn("OidcClient.processSignoutResponse: Response was error: ", n.error), Promise.reject(new s.ErrorResponse(n))) : Promise.resolve(n);var o = n.state;return (t = t || this._stateStore).remove(o).then(function (e) {
          if (!e) throw i.Log.error("OidcClient.processSignoutResponse: No matching state found in storage"), new Error("No matching state found in storage");var t = l.State.fromStorageString(e);return i.Log.debug("OidcClient.processSignoutResponse: Received state from storage; validating response"), r._validator.validateSignoutResponse(t, n);
        });
      }, OidcClient.prototype.clearStaleState = function clearStaleState(e) {
        return i.Log.debug("OidcClient.clearStaleState"), e = e || this._stateStore, l.State.clearStaleState(e, this.settings.staleStateAge);
      }, n(OidcClient, [{ key: "_stateStore", get: function get() {
          return this.settings.stateStore;
        } }, { key: "_validator", get: function get() {
          return this.settings.validator;
        } }, { key: "_metadataService", get: function get() {
          return this.settings.metadataService;
        } }, { key: "settings", get: function get() {
          return this._settings;
        } }, { key: "metadataService", get: function get() {
          return this._metadataService;
        } }]), OidcClient;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.CordovaIFrameNavigator = void 0;var n = r(7);t.CordovaIFrameNavigator = function () {
      function CordovaIFrameNavigator() {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, CordovaIFrameNavigator);
      }return CordovaIFrameNavigator.prototype.prepare = function prepare(e) {
        e.popupWindowFeatures = "hidden=yes";var t = new n.CordovaPopupWindow(e);return Promise.resolve(t);
      }, CordovaIFrameNavigator;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.CordovaPopupNavigator = void 0;var n = r(7);t.CordovaPopupNavigator = function () {
      function CordovaPopupNavigator() {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, CordovaPopupNavigator);
      }return CordovaPopupNavigator.prototype.prepare = function prepare(e) {
        var t = new n.CordovaPopupWindow(e);return Promise.resolve(t);
      }, CordovaPopupNavigator;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.SilentRenewService = void 0;var n = r(0);t.SilentRenewService = function () {
      function SilentRenewService(e) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, SilentRenewService), this._userManager = e;
      }return SilentRenewService.prototype.start = function start() {
        this._callback || (this._callback = this._tokenExpiring.bind(this), this._userManager.events.addAccessTokenExpiring(this._callback), this._userManager.getUser().then(function (e) {}).catch(function (e) {
          n.Log.error("SilentRenewService.start: Error from getUser:", e.message);
        }));
      }, SilentRenewService.prototype.stop = function stop() {
        this._callback && (this._userManager.events.removeAccessTokenExpiring(this._callback), delete this._callback);
      }, SilentRenewService.prototype._tokenExpiring = function _tokenExpiring() {
        var e = this;this._userManager.signinSilent().then(function (e) {
          n.Log.debug("SilentRenewService._tokenExpiring: Silent token renewal successful");
        }, function (t) {
          n.Log.error("SilentRenewService._tokenExpiring: Error from signinSilent:", t.message), e._userManager.events._raiseSilentRenewError(t);
        });
      }, SilentRenewService;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.Timer = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0),
        o = r(1),
        s = r(11);t.Timer = function (e) {
      function Timer(t) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.Global.timer,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Timer);var i = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : _typeof(t)) && "function" != typeof t ? e : t;
        }(this, e.call(this, t));return i._timer = r, i._nowFunc = n || function () {
          return Date.now() / 1e3;
        }, i;
      }return function _inherits(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : _typeof(t)));e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(Timer, e), Timer.prototype.init = function init(e) {
        e <= 0 && (e = 1), e = parseInt(e);var t = this.now + e;if (this.expiration === t && this._timerHandle) i.Log.debug("Timer.init timer " + this._name + " skipping initialization since already initialized for expiration:", this.expiration);else {
          this.cancel(), i.Log.debug("Timer.init timer " + this._name + " for duration:", e), this._expiration = t;var r = 5;e < r && (r = e), this._timerHandle = this._timer.setInterval(this._callback.bind(this), 1e3 * r);
        }
      }, Timer.prototype.cancel = function cancel() {
        this._timerHandle && (i.Log.debug("Timer.cancel: ", this._name), this._timer.clearInterval(this._timerHandle), this._timerHandle = null);
      }, Timer.prototype._callback = function _callback() {
        var t = this._expiration - this.now;i.Log.debug("Timer.callback; " + this._name + " timer expires in:", t), this._expiration <= this.now && (this.cancel(), e.prototype.raise.call(this));
      }, n(Timer, [{ key: "now", get: function get() {
          return parseInt(this._nowFunc());
        } }, { key: "expiration", get: function get() {
          return this._expiration;
        } }]), Timer;
    }(s.Event);
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.UserManagerEvents = void 0;var n = r(0),
        i = r(12),
        o = r(11);t.UserManagerEvents = function (e) {
      function UserManagerEvents(t) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, UserManagerEvents);var r = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : _typeof(t)) && "function" != typeof t ? e : t;
        }(this, e.call(this, t));return r._userLoaded = new o.Event("User loaded"), r._userUnloaded = new o.Event("User unloaded"), r._silentRenewError = new o.Event("Silent renew error"), r._userSignedOut = new o.Event("User signed out"), r._userSessionChanged = new o.Event("User session changed"), r;
      }return function _inherits(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : _typeof(t)));e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(UserManagerEvents, e), UserManagerEvents.prototype.load = function load(t) {
        var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];n.Log.debug("UserManagerEvents.load"), e.prototype.load.call(this, t), r && this._userLoaded.raise(t);
      }, UserManagerEvents.prototype.unload = function unload() {
        n.Log.debug("UserManagerEvents.unload"), e.prototype.unload.call(this), this._userUnloaded.raise();
      }, UserManagerEvents.prototype.addUserLoaded = function addUserLoaded(e) {
        this._userLoaded.addHandler(e);
      }, UserManagerEvents.prototype.removeUserLoaded = function removeUserLoaded(e) {
        this._userLoaded.removeHandler(e);
      }, UserManagerEvents.prototype.addUserUnloaded = function addUserUnloaded(e) {
        this._userUnloaded.addHandler(e);
      }, UserManagerEvents.prototype.removeUserUnloaded = function removeUserUnloaded(e) {
        this._userUnloaded.removeHandler(e);
      }, UserManagerEvents.prototype.addSilentRenewError = function addSilentRenewError(e) {
        this._silentRenewError.addHandler(e);
      }, UserManagerEvents.prototype.removeSilentRenewError = function removeSilentRenewError(e) {
        this._silentRenewError.removeHandler(e);
      }, UserManagerEvents.prototype._raiseSilentRenewError = function _raiseSilentRenewError(e) {
        n.Log.debug("UserManagerEvents._raiseSilentRenewError", e.message), this._silentRenewError.raise(e);
      }, UserManagerEvents.prototype.addUserSignedOut = function addUserSignedOut(e) {
        this._userSignedOut.addHandler(e);
      }, UserManagerEvents.prototype.removeUserSignedOut = function removeUserSignedOut(e) {
        this._userSignedOut.removeHandler(e);
      }, UserManagerEvents.prototype._raiseUserSignedOut = function _raiseUserSignedOut(e) {
        n.Log.debug("UserManagerEvents._raiseUserSignedOut"), this._userSignedOut.raise(e);
      }, UserManagerEvents.prototype.addUserSessionChanged = function addUserSessionChanged(e) {
        this._userSessionChanged.addHandler(e);
      }, UserManagerEvents.prototype.removeUserSessionChanged = function removeUserSessionChanged(e) {
        this._userSessionChanged.removeHandler(e);
      }, UserManagerEvents.prototype._raiseUserSessionChanged = function _raiseUserSessionChanged(e) {
        n.Log.debug("UserManagerEvents._raiseUserSessionChanged"), this._userSessionChanged.raise(e);
      }, UserManagerEvents;
    }(i.AccessTokenEvents);
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.IFrameWindow = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0);t.IFrameWindow = function () {
      function IFrameWindow(e) {
        var t = this;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, IFrameWindow), this._promise = new Promise(function (e, r) {
          t._resolve = e, t._reject = r;
        }), this._boundMessageEvent = this._message.bind(this), window.addEventListener("message", this._boundMessageEvent, !1), this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "absolute", this._frame.style.display = "none", this._frame.style.width = 0, this._frame.style.height = 0, window.document.body.appendChild(this._frame);
      }return IFrameWindow.prototype.navigate = function navigate(e) {
        if (e && e.url) {
          var t = e.silentRequestTimeout || 1e4;i.Log.debug("IFrameWindow.navigate: Using timeout of:", t), this._timer = window.setTimeout(this._timeout.bind(this), t), this._frame.src = e.url;
        } else this._error("No url provided");return this.promise;
      }, IFrameWindow.prototype._success = function _success(e) {
        this._cleanup(), i.Log.debug("IFrameWindow: Successful response from frame window"), this._resolve(e);
      }, IFrameWindow.prototype._error = function _error(e) {
        this._cleanup(), i.Log.error(e), this._reject(new Error(e));
      }, IFrameWindow.prototype.close = function close() {
        this._cleanup();
      }, IFrameWindow.prototype._cleanup = function _cleanup() {
        this._frame && (i.Log.debug("IFrameWindow: cleanup"), window.removeEventListener("message", this._boundMessageEvent, !1), window.clearTimeout(this._timer), window.document.body.removeChild(this._frame), this._timer = null, this._frame = null, this._boundMessageEvent = null);
      }, IFrameWindow.prototype._timeout = function _timeout() {
        i.Log.debug("IFrameWindow.timeout"), this._error("Frame window timed out");
      }, IFrameWindow.prototype._message = function _message(e) {
        if (i.Log.debug("IFrameWindow.message"), this._timer && e.origin === this._origin && e.source === this._frame.contentWindow) {
          var t = e.data;t ? this._success({ url: t }) : this._error("Invalid response from frame");
        }
      }, IFrameWindow.notifyParent = function notifyParent(e) {
        i.Log.debug("IFrameWindow.notifyParent"), window.parent && window !== window.parent && (e = e || window.location.href) && (i.Log.debug("IFrameWindow.notifyParent: posting url message to parent"), window.parent.postMessage(e, location.protocol + "//" + location.host));
      }, n(IFrameWindow, [{ key: "promise", get: function get() {
          return this._promise;
        } }, { key: "_origin", get: function get() {
          return location.protocol + "//" + location.host;
        } }]), IFrameWindow;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.IFrameNavigator = void 0;var n = r(0),
        i = r(24);t.IFrameNavigator = function () {
      function IFrameNavigator() {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, IFrameNavigator);
      }return IFrameNavigator.prototype.prepare = function prepare(e) {
        var t = new i.IFrameWindow(e);return Promise.resolve(t);
      }, IFrameNavigator.prototype.callback = function callback(e) {
        n.Log.debug("IFrameNavigator.callback");try {
          return i.IFrameWindow.notifyParent(e), Promise.resolve();
        } catch (e) {
          return Promise.reject(e);
        }
      }, IFrameNavigator;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.PopupWindow = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0),
        o = r(2);var s = 500,
        a = "location=no,toolbar=no,width=500,height=500,left=100,top=100;",
        u = "_blank";t.PopupWindow = function () {
      function PopupWindow(e) {
        var t = this;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, PopupWindow), this._promise = new Promise(function (e, r) {
          t._resolve = e, t._reject = r;
        });var r = e.popupWindowTarget || u,
            n = e.popupWindowFeatures || a;this._popup = window.open("", r, n), this._popup && (i.Log.debug("PopupWindow.ctor: popup successfully created"), this._checkForPopupClosedTimer = window.setInterval(this._checkForPopupClosed.bind(this), s));
      }return PopupWindow.prototype.navigate = function navigate(e) {
        return this._popup ? e && e.url ? (i.Log.debug("PopupWindow.navigate: Setting URL in popup"), this._id = e.id, this._id && (window["popupCallback_" + e.id] = this._callback.bind(this)), this._popup.focus(), this._popup.window.location = e.url) : (this._error("PopupWindow.navigate: no url provided"), this._error("No url provided")) : this._error("PopupWindow.navigate: Error opening popup window"), this.promise;
      }, PopupWindow.prototype._success = function _success(e) {
        i.Log.debug("PopupWindow.callback: Successful response from popup window"), this._cleanup(), this._resolve(e);
      }, PopupWindow.prototype._error = function _error(e) {
        i.Log.error("PopupWindow.error: ", e), this._cleanup(), this._reject(new Error(e));
      }, PopupWindow.prototype.close = function close() {
        this._cleanup(!1);
      }, PopupWindow.prototype._cleanup = function _cleanup(e) {
        i.Log.debug("PopupWindow.cleanup"), window.clearInterval(this._checkForPopupClosedTimer), this._checkForPopupClosedTimer = null, delete window["popupCallback_" + this._id], this._popup && !e && this._popup.close(), this._popup = null;
      }, PopupWindow.prototype._checkForPopupClosed = function _checkForPopupClosed() {
        this._popup && !this._popup.closed || this._error("Popup window closed");
      }, PopupWindow.prototype._callback = function _callback(e, t) {
        this._cleanup(t), e ? (i.Log.debug("PopupWindow.callback success"), this._success({ url: e })) : (i.Log.debug("PopupWindow.callback: Invalid response from popup"), this._error("Invalid response from popup"));
      }, PopupWindow.notifyOpener = function notifyOpener(e, t, r) {
        if (window.opener) {
          if (e = e || window.location.href) {
            var n = o.UrlUtility.parseUrlFragment(e, r);if (n.state) {
              var s = "popupCallback_" + n.state,
                  a = window.opener[s];a ? (i.Log.debug("PopupWindow.notifyOpener: passing url message to opener"), a(e, t)) : i.Log.warn("PopupWindow.notifyOpener: no matching callback found on opener");
            } else i.Log.warn("PopupWindow.notifyOpener: no state found in response url");
          }
        } else i.Log.warn("PopupWindow.notifyOpener: no window.opener. Can't complete notification.");
      }, n(PopupWindow, [{ key: "promise", get: function get() {
          return this._promise;
        } }]), PopupWindow;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.PopupNavigator = void 0;var n = r(0),
        i = r(26);t.PopupNavigator = function () {
      function PopupNavigator() {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, PopupNavigator);
      }return PopupNavigator.prototype.prepare = function prepare(e) {
        var t = new i.PopupWindow(e);return Promise.resolve(t);
      }, PopupNavigator.prototype.callback = function callback(e, t, r) {
        n.Log.debug("PopupNavigator.callback");try {
          return i.PopupWindow.notifyOpener(e, t, r), Promise.resolve();
        } catch (e) {
          return Promise.reject(e);
        }
      }, PopupNavigator;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.RedirectNavigator = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0);t.RedirectNavigator = function () {
      function RedirectNavigator() {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, RedirectNavigator);
      }return RedirectNavigator.prototype.prepare = function prepare() {
        return Promise.resolve(this);
      }, RedirectNavigator.prototype.navigate = function navigate(e) {
        return e && e.url ? (window.location = e.url, Promise.resolve()) : (i.Log.error("RedirectNavigator.navigate: No url provided"), Promise.reject(new Error("No url provided")));
      }, n(RedirectNavigator, [{ key: "url", get: function get() {
          return window.location.href;
        } }]), RedirectNavigator;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.UserManagerSettings = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = (r(0), r(6)),
        o = r(28),
        s = r(27),
        a = r(25),
        u = r(5),
        c = r(1);var h = 60,
        f = 2e3;t.UserManagerSettings = function (e) {
      function UserManagerSettings() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = t.popup_redirect_uri,
            n = t.popup_post_logout_redirect_uri,
            i = t.popupWindowFeatures,
            l = t.popupWindowTarget,
            g = t.silent_redirect_uri,
            p = t.silentRequestTimeout,
            d = t.automaticSilentRenew,
            v = void 0 !== d && d,
            y = t.includeIdTokenInSilentRenew,
            m = void 0 === y || y,
            S = t.monitorSession,
            F = void 0 === S || S,
            b = t.checkSessionInterval,
            _ = void 0 === b ? f : b,
            w = t.stopCheckSessionOnError,
            E = void 0 === w || w,
            x = t.revokeAccessTokenOnSignout,
            C = void 0 !== x && x,
            P = t.accessTokenExpiringNotificationTime,
            A = void 0 === P ? h : P,
            k = t.redirectNavigator,
            I = void 0 === k ? new o.RedirectNavigator() : k,
            B = t.popupNavigator,
            R = void 0 === B ? new s.PopupNavigator() : B,
            T = t.iframeNavigator,
            U = void 0 === T ? new a.IFrameNavigator() : T,
            M = t.userStore,
            L = void 0 === M ? new u.WebStorageStateStore({ store: c.Global.sessionStorage }) : M;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, UserManagerSettings);var D = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : _typeof(t)) && "function" != typeof t ? e : t;
        }(this, e.call(this, arguments[0]));return D._popup_redirect_uri = r, D._popup_post_logout_redirect_uri = n, D._popupWindowFeatures = i, D._popupWindowTarget = l, D._silent_redirect_uri = g, D._silentRequestTimeout = p, D._automaticSilentRenew = !!v, D._includeIdTokenInSilentRenew = m, D._accessTokenExpiringNotificationTime = A, D._monitorSession = F, D._checkSessionInterval = _, D._stopCheckSessionOnError = E, D._revokeAccessTokenOnSignout = C, D._redirectNavigator = I, D._popupNavigator = R, D._iframeNavigator = U, D._userStore = L, D;
      }return function _inherits(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : _typeof(t)));e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(UserManagerSettings, e), n(UserManagerSettings, [{ key: "popup_redirect_uri", get: function get() {
          return this._popup_redirect_uri;
        } }, { key: "popup_post_logout_redirect_uri", get: function get() {
          return this._popup_post_logout_redirect_uri;
        } }, { key: "popupWindowFeatures", get: function get() {
          return this._popupWindowFeatures;
        } }, { key: "popupWindowTarget", get: function get() {
          return this._popupWindowTarget;
        } }, { key: "silent_redirect_uri", get: function get() {
          return this._silent_redirect_uri;
        } }, { key: "silentRequestTimeout", get: function get() {
          return this._silentRequestTimeout;
        } }, { key: "automaticSilentRenew", get: function get() {
          return !(!this.silent_redirect_uri || !this._automaticSilentRenew);
        } }, { key: "includeIdTokenInSilentRenew", get: function get() {
          return this._includeIdTokenInSilentRenew;
        } }, { key: "accessTokenExpiringNotificationTime", get: function get() {
          return this._accessTokenExpiringNotificationTime;
        } }, { key: "monitorSession", get: function get() {
          return this._monitorSession;
        } }, { key: "checkSessionInterval", get: function get() {
          return this._checkSessionInterval;
        } }, { key: "stopCheckSessionOnError", get: function get() {
          return this._stopCheckSessionOnError;
        } }, { key: "revokeAccessTokenOnSignout", get: function get() {
          return this._revokeAccessTokenOnSignout;
        } }, { key: "redirectNavigator", get: function get() {
          return this._redirectNavigator;
        } }, { key: "popupNavigator", get: function get() {
          return this._popupNavigator;
        } }, { key: "iframeNavigator", get: function get() {
          return this._iframeNavigator;
        } }, { key: "userStore", get: function get() {
          return this._userStore;
        } }]), UserManagerSettings;
    }(i.OidcClientSettings);
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.UserManager = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0),
        o = r(18),
        s = r(29),
        a = r(13),
        u = r(23),
        c = r(21),
        h = r(10),
        f = r(8);t.UserManager = function (e) {
      function UserManager() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : c.SilentRenewService,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : h.SessionMonitor,
            o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : f.TokenRevocationClient;!function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, UserManager), t instanceof s.UserManagerSettings || (t = new s.UserManagerSettings(t));var a = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : _typeof(t)) && "function" != typeof t ? e : t;
        }(this, e.call(this, t));return a._events = new u.UserManagerEvents(t), a._silentRenewService = new r(a), a.settings.automaticSilentRenew && (i.Log.debug("UserManager.ctor: automaticSilentRenew is configured, setting up silent renew"), a.startSilentRenew()), a.settings.monitorSession && (i.Log.debug("UserManager.ctor: monitorSession is configured, setting up session monitor"), a._sessionMonitor = new n(a)), a._tokenRevocationClient = new o(a._settings), a;
      }return function _inherits(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : _typeof(t)));e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(UserManager, e), UserManager.prototype.getUser = function getUser() {
        var e = this;return this._loadUser().then(function (t) {
          return t ? (i.Log.info("UserManager.getUser: user loaded"), e._events.load(t, !1), t) : (i.Log.info("UserManager.getUser: user not found in storage"), null);
        });
      }, UserManager.prototype.removeUser = function removeUser() {
        var e = this;return this.storeUser(null).then(function () {
          i.Log.info("UserManager.removeUser: user removed from storage"), e._events.unload();
        });
      }, UserManager.prototype.signinRedirect = function signinRedirect(e) {
        return this._signinStart(e, this._redirectNavigator).then(function () {
          i.Log.info("UserManager.signinRedirect: successful");
        });
      }, UserManager.prototype.signinRedirectCallback = function signinRedirectCallback(e) {
        return this._signinEnd(e || this._redirectNavigator.url).then(function (e) {
          return e && (e.profile && e.profile.sub ? i.Log.info("UserManager.signinRedirectCallback: successful, signed in sub: ", e.profile.sub) : i.Log.info("UserManager.signinRedirectCallback: no sub")), e;
        });
      }, UserManager.prototype.signinPopup = function signinPopup() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.redirect_uri || this.settings.popup_redirect_uri || this.settings.redirect_uri;return t ? (e.redirect_uri = t, e.display = "popup", this._signin(e, this._popupNavigator, { startUrl: t, popupWindowFeatures: e.popupWindowFeatures || this.settings.popupWindowFeatures, popupWindowTarget: e.popupWindowTarget || this.settings.popupWindowTarget }).then(function (e) {
          return e && (e.profile && e.profile.sub ? i.Log.info("UserManager.signinPopup: signinPopup successful, signed in sub: ", e.profile.sub) : i.Log.info("UserManager.signinPopup: no sub")), e;
        })) : (i.Log.error("UserManager.signinPopup: No popup_redirect_uri or redirect_uri configured"), Promise.reject(new Error("No popup_redirect_uri or redirect_uri configured")));
      }, UserManager.prototype.signinPopupCallback = function signinPopupCallback(e) {
        return this._signinCallback(e, this._popupNavigator).then(function (e) {
          return e && (e.profile && e.profile.sub ? i.Log.info("UserManager.signinPopupCallback: successful, signed in sub: ", e.profile.sub) : i.Log.info("UserManager.signinPopupCallback: no sub")), e;
        }).catch(function (e) {
          i.Log.error("UserManager.signinPopupCallback error: " + e && e.message);
        });
      }, UserManager.prototype.signinSilent = function signinSilent() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = t.redirect_uri || this.settings.silent_redirect_uri;if (!r) return i.Log.error("UserManager.signinSilent: No silent_redirect_uri configured"), Promise.reject(new Error("No silent_redirect_uri configured"));t.redirect_uri = r, t.prompt = "none";return (t.id_token_hint || !this.settings.includeIdTokenInSilentRenew ? Promise.resolve() : this._loadUser().then(function (e) {
          t.id_token_hint = e && e.id_token;
        })).then(function () {
          return e._signin(t, e._iframeNavigator, { startUrl: r, silentRequestTimeout: t.silentRequestTimeout || e.settings.silentRequestTimeout });
        }).then(function (e) {
          return e && (e.profile && e.profile.sub ? i.Log.info("UserManager.signinSilent: successful, signed in sub: ", e.profile.sub) : i.Log.info("UserManager.signinSilent: no sub")), e;
        });
      }, UserManager.prototype.signinSilentCallback = function signinSilentCallback(e) {
        return this._signinCallback(e, this._iframeNavigator).then(function (e) {
          return e && (e.profile && e.profile.sub ? i.Log.info("UserManager.signinSilentCallback: successful, signed in sub: ", e.profile.sub) : i.Log.info("UserManager.signinSilentCallback: no sub")), e;
        });
      }, UserManager.prototype.querySessionStatus = function querySessionStatus() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = t.redirect_uri || this.settings.silent_redirect_uri;return r ? (t.redirect_uri = r, t.prompt = "none", t.response_type = "id_token", t.scope = "openid", this._signinStart(t, this._iframeNavigator, { startUrl: r, silentRequestTimeout: t.silentRequestTimeout || this.settings.silentRequestTimeout }).then(function (t) {
          return e.processSigninResponse(t.url).then(function (e) {
            if (i.Log.debug("UserManager.querySessionStatus: got signin response"), e.session_state && e.profile.sub && e.profile.sid) return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for sub: ", e.profile.sub), { session_state: e.session_state, sub: e.profile.sub, sid: e.profile.sid };i.Log.info("querySessionStatus successful, user not authenticated");
          });
        })) : (i.Log.error("UserManager.querySessionStatus: No silent_redirect_uri configured"), Promise.reject(new Error("No silent_redirect_uri configured")));
      }, UserManager.prototype._signin = function _signin(e, t) {
        var r = this,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};return this._signinStart(e, t, n).then(function (e) {
          return r._signinEnd(e.url);
        });
      }, UserManager.prototype._signinStart = function _signinStart(e, t) {
        var r = this,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};return t.prepare(n).then(function (t) {
          return i.Log.debug("UserManager._signinStart: got navigator window handle"), r.createSigninRequest(e).then(function (e) {
            return i.Log.debug("UserManager._signinStart: got signin request"), n.url = e.url, n.id = e.state.id, t.navigate(n);
          }).catch(function (e) {
            throw t.close && (i.Log.debug("UserManager._signinStart: Error after preparing navigator, closing navigator window"), t.close()), e;
          });
        });
      }, UserManager.prototype._signinEnd = function _signinEnd(e) {
        var t = this;return this.processSigninResponse(e).then(function (e) {
          i.Log.debug("UserManager._signinEnd: got signin response");var r = new a.User(e);return t.storeUser(r).then(function () {
            return i.Log.debug("UserManager._signinEnd: user stored"), t._events.load(r), r;
          });
        });
      }, UserManager.prototype._signinCallback = function _signinCallback(e, t) {
        return i.Log.debug("UserManager._signinCallback"), t.callback(e);
      }, UserManager.prototype.signoutRedirect = function signoutRedirect() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.post_logout_redirect_uri || this.settings.post_logout_redirect_uri;return t && (e.post_logout_redirect_uri = t), this._signoutStart(e, this._redirectNavigator).then(function () {
          i.Log.info("UserManager.signoutRedirect: successful");
        });
      }, UserManager.prototype.signoutRedirectCallback = function signoutRedirectCallback(e) {
        return this._signoutEnd(e || this._redirectNavigator.url).then(function (e) {
          return i.Log.info("UserManager.signoutRedirectCallback: successful"), e;
        });
      }, UserManager.prototype.signoutPopup = function signoutPopup() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.post_logout_redirect_uri || this.settings.popup_post_logout_redirect_uri || this.settings.post_logout_redirect_uri;return e.post_logout_redirect_uri = t, e.display = "popup", e.post_logout_redirect_uri && (e.state = e.state || {}), this._signout(e, this._popupNavigator, { startUrl: t, popupWindowFeatures: e.popupWindowFeatures || this.settings.popupWindowFeatures, popupWindowTarget: e.popupWindowTarget || this.settings.popupWindowTarget }).then(function () {
          i.Log.info("UserManager.signinPopup: successful");
        });
      }, UserManager.prototype.signoutPopupCallback = function signoutPopupCallback(e, t) {
        void 0 === t && "boolean" == typeof e && (e = null, t = !0);return this._popupNavigator.callback(e, t, "?").then(function () {
          i.Log.info("UserManager.signoutPopupCallback: successful");
        });
      }, UserManager.prototype._signout = function _signout(e, t) {
        var r = this,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};return this._signoutStart(e, t, n).then(function (e) {
          return r._signoutEnd(e.url);
        });
      }, UserManager.prototype._signoutStart = function _signoutStart() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = this,
            r = arguments[1],
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};return r.prepare(n).then(function (r) {
          return i.Log.debug("UserManager._signoutStart: got navigator window handle"), t._loadUser().then(function (o) {
            return i.Log.debug("UserManager._signoutStart: loaded current user from storage"), (t._settings.revokeAccessTokenOnSignout ? t._revokeInternal(o) : Promise.resolve()).then(function () {
              var s = e.id_token_hint || o && o.id_token;return s && (i.Log.debug("UserManager._signoutStart: Setting id_token into signout request"), e.id_token_hint = s), t.removeUser().then(function () {
                return i.Log.debug("UserManager._signoutStart: user removed, creating signout request"), t.createSignoutRequest(e).then(function (e) {
                  return i.Log.debug("UserManager._signoutStart: got signout request"), n.url = e.url, e.state && (n.id = e.state.id), r.navigate(n);
                });
              });
            });
          }).catch(function (e) {
            throw r.close && (i.Log.debug("UserManager._signoutStart: Error after preparing navigator, closing navigator window"), r.close()), e;
          });
        });
      }, UserManager.prototype._signoutEnd = function _signoutEnd(e) {
        return this.processSignoutResponse(e).then(function (e) {
          return i.Log.debug("UserManager._signoutEnd: got signout response"), e;
        });
      }, UserManager.prototype.revokeAccessToken = function revokeAccessToken() {
        var e = this;return this._loadUser().then(function (t) {
          return e._revokeInternal(t, !0).then(function (r) {
            if (r) return i.Log.debug("UserManager.revokeAccessToken: removing token properties from user and re-storing"), t.access_token = null, t.expires_at = null, t.token_type = null, e.storeUser(t).then(function () {
              i.Log.debug("UserManager.revokeAccessToken: user stored"), e._events.load(t);
            });
          });
        }).then(function () {
          i.Log.info("UserManager.revokeAccessToken: access token revoked successfully");
        });
      }, UserManager.prototype._revokeInternal = function _revokeInternal(e, t) {
        var r = e && e.access_token;return !r || r.indexOf(".") >= 0 ? (i.Log.debug("UserManager.revokeAccessToken: no need to revoke due to no user, token, or JWT format"), Promise.resolve(!1)) : this._tokenRevocationClient.revoke(r, t).then(function () {
          return !0;
        });
      }, UserManager.prototype.startSilentRenew = function startSilentRenew() {
        this._silentRenewService.start();
      }, UserManager.prototype.stopSilentRenew = function stopSilentRenew() {
        this._silentRenewService.stop();
      }, UserManager.prototype._loadUser = function _loadUser() {
        return this._userStore.get(this._userStoreKey).then(function (e) {
          return e ? (i.Log.debug("UserManager._loadUser: user storageString loaded"), a.User.fromStorageString(e)) : (i.Log.debug("UserManager._loadUser: no user storageString"), null);
        });
      }, UserManager.prototype.storeUser = function storeUser(e) {
        if (e) {
          i.Log.debug("UserManager.storeUser: storing user");var t = e.toStorageString();return this._userStore.set(this._userStoreKey, t);
        }return i.Log.debug("storeUser.storeUser: removing user"), this._userStore.remove(this._userStoreKey);
      }, n(UserManager, [{ key: "_redirectNavigator", get: function get() {
          return this.settings.redirectNavigator;
        } }, { key: "_popupNavigator", get: function get() {
          return this.settings.popupNavigator;
        } }, { key: "_iframeNavigator", get: function get() {
          return this.settings.iframeNavigator;
        } }, { key: "_userStore", get: function get() {
          return this.settings.userStore;
        } }, { key: "events", get: function get() {
          return this._events;
        } }, { key: "_userStoreKey", get: function get() {
          return "user:" + this.settings.authority + ":" + this.settings.client_id;
        } }]), UserManager;
    }(o.OidcClient);
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.InMemoryWebStorage = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(0);t.InMemoryWebStorage = function () {
      function InMemoryWebStorage() {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, InMemoryWebStorage), this._data = {};
      }return InMemoryWebStorage.prototype.getItem = function getItem(e) {
        return i.Log.debug("InMemoryWebStorage.getItem", e), this._data[e];
      }, InMemoryWebStorage.prototype.setItem = function setItem(e, t) {
        i.Log.debug("InMemoryWebStorage.setItem", e), this._data[e] = t;
      }, InMemoryWebStorage.prototype.removeItem = function removeItem(e) {
        i.Log.debug("InMemoryWebStorage.removeItem", e), delete this._data[e];
      }, InMemoryWebStorage.prototype.key = function key(e) {
        return Object.getOwnPropertyNames(this._data)[e];
      }, n(InMemoryWebStorage, [{ key: "length", get: function get() {
          return Object.getOwnPropertyNames(this._data).length;
        } }]), InMemoryWebStorage;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.SignoutResponse = void 0;var n = r(2);t.SignoutResponse = function SignoutResponse(e) {
      !function _classCallCheck(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, SignoutResponse);var t = n.UrlUtility.parseUrlFragment(e, "?");this.error = t.error, this.error_description = t.error_description, this.error_uri = t.error_uri, this.state = t.state;
    };
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.SignoutRequest = void 0;var n = r(0),
        i = r(2),
        o = r(4);t.SignoutRequest = function SignoutRequest(e) {
      var t = e.url,
          r = e.id_token_hint,
          s = e.post_logout_redirect_uri,
          a = e.data;if (function _classCallCheck(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, SignoutRequest), !t) throw n.Log.error("SignoutRequest.ctor: No url passed"), new Error("url");r && (t = i.UrlUtility.addQueryParam(t, "id_token_hint", r)), s && (t = i.UrlUtility.addQueryParam(t, "post_logout_redirect_uri", s), a && (this.state = new o.State({ data: a }), t = i.UrlUtility.addQueryParam(t, "state", this.state.id))), this.url = t;
    };
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.SigninResponse = void 0;var n = function () {
      function defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }return function (e, t, r) {
        return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
      };
    }(),
        i = r(2);t.SigninResponse = function () {
      function SigninResponse(e) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, SigninResponse);var t = i.UrlUtility.parseUrlFragment(e, "#");this.error = t.error, this.error_description = t.error_description, this.error_uri = t.error_uri, this.state = t.state, this.id_token = t.id_token, this.session_state = t.session_state, this.access_token = t.access_token, this.token_type = t.token_type, this.scope = t.scope, this.profile = void 0;var r = parseInt(t.expires_in);if ("number" == typeof r && r > 0) {
          var n = parseInt(Date.now() / 1e3);this.expires_at = n + r;
        }
      }return n(SigninResponse, [{ key: "expires_in", get: function get() {
          if (this.expires_at) {
            var e = parseInt(Date.now() / 1e3);return this.expires_at - e;
          }
        } }, { key: "expired", get: function get() {
          var e = this.expires_in;if (void 0 !== e) return e <= 0;
        } }, { key: "scopes", get: function get() {
          return (this.scope || "").split(" ");
        } }, { key: "isOpenIdConnect", get: function get() {
          return this.scopes.indexOf("openid") >= 0 || !!this.id_token;
        } }]), SigninResponse;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.SigninRequest = void 0;var n = r(0),
        i = r(2),
        o = r(15);t.SigninRequest = function () {
      function SigninRequest(e) {
        var t = e.url,
            r = e.client_id,
            s = e.redirect_uri,
            a = e.response_type,
            u = e.scope,
            c = e.authority,
            h = e.data,
            f = e.prompt,
            l = e.display,
            g = e.max_age,
            p = e.ui_locales,
            d = e.id_token_hint,
            v = e.login_hint,
            y = e.acr_values,
            m = e.resource,
            S = e.request,
            F = e.request_uri,
            b = e.extraQueryParams;if (function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, SigninRequest), !t) throw n.Log.error("SigninRequest.ctor: No url passed"), new Error("url");if (!r) throw n.Log.error("SigninRequest.ctor: No client_id passed"), new Error("client_id");if (!s) throw n.Log.error("SigninRequest.ctor: No redirect_uri passed"), new Error("redirect_uri");if (!a) throw n.Log.error("SigninRequest.ctor: No response_type passed"), new Error("response_type");if (!u) throw n.Log.error("SigninRequest.ctor: No scope passed"), new Error("scope");if (!c) throw n.Log.error("SigninRequest.ctor: No authority passed"), new Error("authority");var _ = SigninRequest.isOidc(a);this.state = new o.SigninState({ nonce: _, data: h, client_id: r, authority: c }), t = i.UrlUtility.addQueryParam(t, "client_id", r), t = i.UrlUtility.addQueryParam(t, "redirect_uri", s), t = i.UrlUtility.addQueryParam(t, "response_type", a), t = i.UrlUtility.addQueryParam(t, "scope", u), t = i.UrlUtility.addQueryParam(t, "state", this.state.id), _ && (t = i.UrlUtility.addQueryParam(t, "nonce", this.state.nonce));var w = { prompt: f, display: l, max_age: g, ui_locales: p, id_token_hint: d, login_hint: v, acr_values: y, resource: m, request: S, request_uri: F };for (var E in w) {
          w[E] && (t = i.UrlUtility.addQueryParam(t, E, w[E]));
        }for (var x in b) {
          t = i.UrlUtility.addQueryParam(t, x, b[x]);
        }this.url = t;
      }return SigninRequest.isOidc = function isOidc(e) {
        return !!e.split(/\s+/g).filter(function (e) {
          return "id_token" === e;
        })[0];
      }, SigninRequest.isOAuth = function isOAuth(e) {
        return !!e.split(/\s+/g).filter(function (e) {
          return "token" === e;
        })[0];
      }, SigninRequest;
    }();
  }, function (e, t) {
    var r = {}.toString;e.exports = Array.isArray || function (e) {
      return "[object Array]" == r.call(e);
    };
  }, function (e, t) {
    t.read = function (e, t, r, n, i) {
      var o,
          s,
          a = 8 * i - n - 1,
          u = (1 << a) - 1,
          c = u >> 1,
          h = -7,
          f = r ? i - 1 : 0,
          l = r ? -1 : 1,
          g = e[t + f];for (f += l, o = g & (1 << -h) - 1, g >>= -h, h += a; h > 0; o = 256 * o + e[t + f], f += l, h -= 8) {}for (s = o & (1 << -h) - 1, o >>= -h, h += n; h > 0; s = 256 * s + e[t + f], f += l, h -= 8) {}if (0 === o) o = 1 - c;else {
        if (o === u) return s ? NaN : 1 / 0 * (g ? -1 : 1);s += Math.pow(2, n), o -= c;
      }return (g ? -1 : 1) * s * Math.pow(2, o - n);
    }, t.write = function (e, t, r, n, i, o) {
      var s,
          a,
          u,
          c = 8 * o - i - 1,
          h = (1 << c) - 1,
          f = h >> 1,
          l = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          g = n ? 0 : o - 1,
          p = n ? 1 : -1,
          d = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, s = h) : (s = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (t += s + f >= 1 ? l / u : l * Math.pow(2, 1 - f)) * u >= 2 && (s++, u /= 2), s + f >= h ? (a = 0, s = h) : s + f >= 1 ? (a = (t * u - 1) * Math.pow(2, i), s += f) : (a = t * Math.pow(2, f - 1) * Math.pow(2, i), s = 0)); i >= 8; e[r + g] = 255 & a, g += p, a /= 256, i -= 8) {}for (s = s << i | a, c += i; c > 0; e[r + g] = 255 & s, g += p, s /= 256, c -= 8) {}e[r + g - p] |= 128 * d;
    };
  }, function (e, t, r) {
    "use strict";
    t.byteLength = function byteLength(e) {
      var t = getLens(e),
          r = t[0],
          n = t[1];return 3 * (r + n) / 4 - n;
    }, t.toByteArray = function toByteArray(e) {
      for (var t, r = getLens(e), n = r[0], s = r[1], a = new o(function _byteLength(e, t, r) {
        return 3 * (t + r) / 4 - r;
      }(0, n, s)), u = 0, c = s > 0 ? n - 4 : n, h = 0; h < c; h += 4) {
        t = i[e.charCodeAt(h)] << 18 | i[e.charCodeAt(h + 1)] << 12 | i[e.charCodeAt(h + 2)] << 6 | i[e.charCodeAt(h + 3)], a[u++] = t >> 16 & 255, a[u++] = t >> 8 & 255, a[u++] = 255 & t;
      }2 === s && (t = i[e.charCodeAt(h)] << 2 | i[e.charCodeAt(h + 1)] >> 4, a[u++] = 255 & t);1 === s && (t = i[e.charCodeAt(h)] << 10 | i[e.charCodeAt(h + 1)] << 4 | i[e.charCodeAt(h + 2)] >> 2, a[u++] = t >> 8 & 255, a[u++] = 255 & t);return a;
    }, t.fromByteArray = function fromByteArray(e) {
      for (var t, r = e.length, i = r % 3, o = [], s = 0, a = r - i; s < a; s += 16383) {
        o.push(encodeChunk(e, s, s + 16383 > a ? a : s + 16383));
      }1 === i ? (t = e[r - 1], o.push(n[t >> 2] + n[t << 4 & 63] + "==")) : 2 === i && (t = (e[r - 2] << 8) + e[r - 1], o.push(n[t >> 10] + n[t >> 4 & 63] + n[t << 2 & 63] + "="));return o.join("");
    };for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, u = s.length; a < u; ++a) {
      n[a] = s[a], i[s.charCodeAt(a)] = a;
    }function getLens(e) {
      var t = e.length;if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");var r = e.indexOf("=");return -1 === r && (r = t), [r, r === t ? 0 : 4 - r % 4];
    }function tripletToBase64(e) {
      return n[e >> 18 & 63] + n[e >> 12 & 63] + n[e >> 6 & 63] + n[63 & e];
    }function encodeChunk(e, t, r) {
      for (var n, i = [], o = t; o < r; o += 3) {
        n = (e[o] << 16 & 16711680) + (e[o + 1] << 8 & 65280) + (255 & e[o + 2]), i.push(tripletToBase64(n));
      }return i.join("");
    }i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
  }, function (e, t) {
    var r;r = function () {
      return this;
    }();try {
      r = r || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (r = window);
    }e.exports = r;
  }, function (e, t, r) {
    "use strict";
    (function (e) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
       * @license  MIT
       */
      var n = r(38),
          i = r(37),
          o = r(36);function kMaxLength() {
        return Buffer.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }function createBuffer(e, t) {
        if (kMaxLength() < t) throw new RangeError("Invalid typed array length");return Buffer.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = Buffer.prototype : (null === e && (e = new Buffer(t)), e.length = t), e;
      }function Buffer(e, t, r) {
        if (!(Buffer.TYPED_ARRAY_SUPPORT || this instanceof Buffer)) return new Buffer(e, t, r);if ("number" == typeof e) {
          if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");return allocUnsafe(this, e);
        }return from(this, e, t, r);
      }function from(e, t, r, n) {
        if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function fromArrayBuffer(e, t, r, n) {
          if (t.byteLength, r < 0 || t.byteLength < r) throw new RangeError("'offset' is out of bounds");if (t.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");t = void 0 === r && void 0 === n ? new Uint8Array(t) : void 0 === n ? new Uint8Array(t, r) : new Uint8Array(t, r, n);Buffer.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = Buffer.prototype : e = fromArrayLike(e, t);return e;
        }(e, t, r, n) : "string" == typeof t ? function fromString(e, t, r) {
          "string" == typeof r && "" !== r || (r = "utf8");if (!Buffer.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');var n = 0 | byteLength(t, r),
              i = (e = createBuffer(e, n)).write(t, r);i !== n && (e = e.slice(0, i));return e;
        }(e, t, r) : function fromObject(e, t) {
          if (Buffer.isBuffer(t)) {
            var r = 0 | checked(t.length);return 0 === (e = createBuffer(e, r)).length ? e : (t.copy(e, 0, 0, r), e);
          }if (t) {
            if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || function isnan(e) {
              return e != e;
            }(t.length) ? createBuffer(e, 0) : fromArrayLike(e, t);if ("Buffer" === t.type && o(t.data)) return fromArrayLike(e, t.data);
          }throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(e, t);
      }function assertSize(e) {
        if ("number" != typeof e) throw new TypeError('"size" argument must be a number');if (e < 0) throw new RangeError('"size" argument must not be negative');
      }function allocUnsafe(e, t) {
        if (assertSize(t), e = createBuffer(e, t < 0 ? 0 : 0 | checked(t)), !Buffer.TYPED_ARRAY_SUPPORT) for (var r = 0; r < t; ++r) {
          e[r] = 0;
        }return e;
      }function fromArrayLike(e, t) {
        var r = t.length < 0 ? 0 : 0 | checked(t.length);e = createBuffer(e, r);for (var n = 0; n < r; n += 1) {
          e[n] = 255 & t[n];
        }return e;
      }function checked(e) {
        if (e >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");return 0 | e;
      }function byteLength(e, t) {
        if (Buffer.isBuffer(e)) return e.length;if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;"string" != typeof e && (e = "" + e);var r = e.length;if (0 === r) return 0;for (var n = !1;;) {
          switch (t) {case "ascii":case "latin1":case "binary":
              return r;case "utf8":case "utf-8":case void 0:
              return utf8ToBytes(e).length;case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":
              return 2 * r;case "hex":
              return r >>> 1;case "base64":
              return base64ToBytes(e).length;default:
              if (n) return utf8ToBytes(e).length;t = ("" + t).toLowerCase(), n = !0;}
        }
      }function swap(e, t, r) {
        var n = e[t];e[t] = e[r], e[r] = n;
      }function bidirectionalIndexOf(e, t, r, n, i) {
        if (0 === e.length) return -1;if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
          if (i) return -1;r = e.length - 1;
        } else if (r < 0) {
          if (!i) return -1;r = 0;
        }if ("string" == typeof t && (t = Buffer.from(t, n)), Buffer.isBuffer(t)) return 0 === t.length ? -1 : arrayIndexOf(e, t, r, n, i);if ("number" == typeof t) return t &= 255, Buffer.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : arrayIndexOf(e, [t], r, n, i);throw new TypeError("val must be string, number or Buffer");
      }function arrayIndexOf(e, t, r, n, i) {
        var o,
            s = 1,
            a = e.length,
            u = t.length;if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
          if (e.length < 2 || t.length < 2) return -1;s = 2, a /= 2, u /= 2, r /= 2;
        }function read(e, t) {
          return 1 === s ? e[t] : e.readUInt16BE(t * s);
        }if (i) {
          var c = -1;for (o = r; o < a; o++) {
            if (read(e, o) === read(t, -1 === c ? 0 : o - c)) {
              if (-1 === c && (c = o), o - c + 1 === u) return c * s;
            } else -1 !== c && (o -= o - c), c = -1;
          }
        } else for (r + u > a && (r = a - u), o = r; o >= 0; o--) {
          for (var h = !0, f = 0; f < u; f++) {
            if (read(e, o + f) !== read(t, f)) {
              h = !1;break;
            }
          }if (h) return o;
        }return -1;
      }function hexWrite(e, t, r, n) {
        r = Number(r) || 0;var i = e.length - r;n ? (n = Number(n)) > i && (n = i) : n = i;var o = t.length;if (o % 2 != 0) throw new TypeError("Invalid hex string");n > o / 2 && (n = o / 2);for (var s = 0; s < n; ++s) {
          var a = parseInt(t.substr(2 * s, 2), 16);if (isNaN(a)) return s;e[r + s] = a;
        }return s;
      }function utf8Write(e, t, r, n) {
        return blitBuffer(utf8ToBytes(t, e.length - r), e, r, n);
      }function asciiWrite(e, t, r, n) {
        return blitBuffer(function asciiToBytes(e) {
          for (var t = [], r = 0; r < e.length; ++r) {
            t.push(255 & e.charCodeAt(r));
          }return t;
        }(t), e, r, n);
      }function latin1Write(e, t, r, n) {
        return asciiWrite(e, t, r, n);
      }function base64Write(e, t, r, n) {
        return blitBuffer(base64ToBytes(t), e, r, n);
      }function ucs2Write(e, t, r, n) {
        return blitBuffer(function utf16leToBytes(e, t) {
          for (var r, n, i, o = [], s = 0; s < e.length && !((t -= 2) < 0); ++s) {
            r = e.charCodeAt(s), n = r >> 8, i = r % 256, o.push(i), o.push(n);
          }return o;
        }(t, e.length - r), e, r, n);
      }function base64Slice(e, t, r) {
        return 0 === t && r === e.length ? n.fromByteArray(e) : n.fromByteArray(e.slice(t, r));
      }function utf8Slice(e, t, r) {
        r = Math.min(e.length, r);for (var n = [], i = t; i < r;) {
          var o,
              a,
              u,
              c,
              h = e[i],
              f = null,
              l = h > 239 ? 4 : h > 223 ? 3 : h > 191 ? 2 : 1;if (i + l <= r) switch (l) {case 1:
              h < 128 && (f = h);break;case 2:
              128 == (192 & (o = e[i + 1])) && (c = (31 & h) << 6 | 63 & o) > 127 && (f = c);break;case 3:
              o = e[i + 1], a = e[i + 2], 128 == (192 & o) && 128 == (192 & a) && (c = (15 & h) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (c < 55296 || c > 57343) && (f = c);break;case 4:
              o = e[i + 1], a = e[i + 2], u = e[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & u) && (c = (15 & h) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & u) > 65535 && c < 1114112 && (f = c);}null === f ? (f = 65533, l = 1) : f > 65535 && (f -= 65536, n.push(f >>> 10 & 1023 | 55296), f = 56320 | 1023 & f), n.push(f), i += l;
        }return function decodeCodePointsArray(e) {
          var t = e.length;if (t <= s) return String.fromCharCode.apply(String, e);var r = "",
              n = 0;for (; n < t;) {
            r += String.fromCharCode.apply(String, e.slice(n, n += s));
          }return r;
        }(n);
      }t.Buffer = Buffer, t.SlowBuffer = function SlowBuffer(e) {
        +e != e && (e = 0);return Buffer.alloc(+e);
      }, t.INSPECT_MAX_BYTES = 50, Buffer.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function typedArraySupport() {
        try {
          var e = new Uint8Array(1);return e.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
              return 42;
            } }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
        } catch (e) {
          return !1;
        }
      }(), t.kMaxLength = kMaxLength(), Buffer.poolSize = 8192, Buffer._augment = function (e) {
        return e.__proto__ = Buffer.prototype, e;
      }, Buffer.from = function (e, t, r) {
        return from(null, e, t, r);
      }, Buffer.TYPED_ARRAY_SUPPORT && (Buffer.prototype.__proto__ = Uint8Array.prototype, Buffer.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && Buffer[Symbol.species] === Buffer && Object.defineProperty(Buffer, Symbol.species, { value: null, configurable: !0 })), Buffer.alloc = function (e, t, r) {
        return function alloc(e, t, r, n) {
          return assertSize(t), t <= 0 ? createBuffer(e, t) : void 0 !== r ? "string" == typeof n ? createBuffer(e, t).fill(r, n) : createBuffer(e, t).fill(r) : createBuffer(e, t);
        }(null, e, t, r);
      }, Buffer.allocUnsafe = function (e) {
        return allocUnsafe(null, e);
      }, Buffer.allocUnsafeSlow = function (e) {
        return allocUnsafe(null, e);
      }, Buffer.isBuffer = function isBuffer(e) {
        return !(null == e || !e._isBuffer);
      }, Buffer.compare = function compare(e, t) {
        if (!Buffer.isBuffer(e) || !Buffer.isBuffer(t)) throw new TypeError("Arguments must be Buffers");if (e === t) return 0;for (var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i) {
          if (e[i] !== t[i]) {
            r = e[i], n = t[i];break;
          }
        }return r < n ? -1 : n < r ? 1 : 0;
      }, Buffer.isEncoding = function isEncoding(e) {
        switch (String(e).toLowerCase()) {case "hex":case "utf8":case "utf-8":case "ascii":case "latin1":case "binary":case "base64":case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":
            return !0;default:
            return !1;}
      }, Buffer.concat = function concat(e, t) {
        if (!o(e)) throw new TypeError('"list" argument must be an Array of Buffers');if (0 === e.length) return Buffer.alloc(0);var r;if (void 0 === t) for (t = 0, r = 0; r < e.length; ++r) {
          t += e[r].length;
        }var n = Buffer.allocUnsafe(t),
            i = 0;for (r = 0; r < e.length; ++r) {
          var s = e[r];if (!Buffer.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');s.copy(n, i), i += s.length;
        }return n;
      }, Buffer.byteLength = byteLength, Buffer.prototype._isBuffer = !0, Buffer.prototype.swap16 = function swap16() {
        var e = this.length;if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");for (var t = 0; t < e; t += 2) {
          swap(this, t, t + 1);
        }return this;
      }, Buffer.prototype.swap32 = function swap32() {
        var e = this.length;if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");for (var t = 0; t < e; t += 4) {
          swap(this, t, t + 3), swap(this, t + 1, t + 2);
        }return this;
      }, Buffer.prototype.swap64 = function swap64() {
        var e = this.length;if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");for (var t = 0; t < e; t += 8) {
          swap(this, t, t + 7), swap(this, t + 1, t + 6), swap(this, t + 2, t + 5), swap(this, t + 3, t + 4);
        }return this;
      }, Buffer.prototype.toString = function toString() {
        var e = 0 | this.length;return 0 === e ? "" : 0 === arguments.length ? utf8Slice(this, 0, e) : function slowToString(e, t, r) {
          var n = !1;if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";if ((r >>>= 0) <= (t >>>= 0)) return "";for (e || (e = "utf8");;) {
            switch (e) {case "hex":
                return hexSlice(this, t, r);case "utf8":case "utf-8":
                return utf8Slice(this, t, r);case "ascii":
                return asciiSlice(this, t, r);case "latin1":case "binary":
                return latin1Slice(this, t, r);case "base64":
                return base64Slice(this, t, r);case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":
                return utf16leSlice(this, t, r);default:
                if (n) throw new TypeError("Unknown encoding: " + e);e = (e + "").toLowerCase(), n = !0;}
          }
        }.apply(this, arguments);
      }, Buffer.prototype.equals = function equals(e) {
        if (!Buffer.isBuffer(e)) throw new TypeError("Argument must be a Buffer");return this === e || 0 === Buffer.compare(this, e);
      }, Buffer.prototype.inspect = function inspect() {
        var e = "",
            r = t.INSPECT_MAX_BYTES;return this.length > 0 && (e = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (e += " ... ")), "<Buffer " + e + ">";
      }, Buffer.prototype.compare = function compare(e, t, r, n, i) {
        if (!Buffer.isBuffer(e)) throw new TypeError("Argument must be a Buffer");if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");if (n >= i && t >= r) return 0;if (n >= i) return -1;if (t >= r) return 1;if (t >>>= 0, r >>>= 0, n >>>= 0, i >>>= 0, this === e) return 0;for (var o = i - n, s = r - t, a = Math.min(o, s), u = this.slice(n, i), c = e.slice(t, r), h = 0; h < a; ++h) {
          if (u[h] !== c[h]) {
            o = u[h], s = c[h];break;
          }
        }return o < s ? -1 : s < o ? 1 : 0;
      }, Buffer.prototype.includes = function includes(e, t, r) {
        return -1 !== this.indexOf(e, t, r);
      }, Buffer.prototype.indexOf = function indexOf(e, t, r) {
        return bidirectionalIndexOf(this, e, t, r, !0);
      }, Buffer.prototype.lastIndexOf = function lastIndexOf(e, t, r) {
        return bidirectionalIndexOf(this, e, t, r, !1);
      }, Buffer.prototype.write = function write(e, t, r, n) {
        if (void 0 === t) n = "utf8", r = this.length, t = 0;else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;else {
          if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
        }var i = this.length - t;if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");n || (n = "utf8");for (var o = !1;;) {
          switch (n) {case "hex":
              return hexWrite(this, e, t, r);case "utf8":case "utf-8":
              return utf8Write(this, e, t, r);case "ascii":
              return asciiWrite(this, e, t, r);case "latin1":case "binary":
              return latin1Write(this, e, t, r);case "base64":
              return base64Write(this, e, t, r);case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":
              return ucs2Write(this, e, t, r);default:
              if (o) throw new TypeError("Unknown encoding: " + n);n = ("" + n).toLowerCase(), o = !0;}
        }
      }, Buffer.prototype.toJSON = function toJSON() {
        return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
      };var s = 4096;function asciiSlice(e, t, r) {
        var n = "";r = Math.min(e.length, r);for (var i = t; i < r; ++i) {
          n += String.fromCharCode(127 & e[i]);
        }return n;
      }function latin1Slice(e, t, r) {
        var n = "";r = Math.min(e.length, r);for (var i = t; i < r; ++i) {
          n += String.fromCharCode(e[i]);
        }return n;
      }function hexSlice(e, t, r) {
        var n = e.length;(!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);for (var i = "", o = t; o < r; ++o) {
          i += toHex(e[o]);
        }return i;
      }function utf16leSlice(e, t, r) {
        for (var n = e.slice(t, r), i = "", o = 0; o < n.length; o += 2) {
          i += String.fromCharCode(n[o] + 256 * n[o + 1]);
        }return i;
      }function checkOffset(e, t, r) {
        if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
      }function checkInt(e, t, r, n, i, o) {
        if (!Buffer.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');if (r + n > e.length) throw new RangeError("Index out of range");
      }function objectWriteUInt16(e, t, r, n) {
        t < 0 && (t = 65535 + t + 1);for (var i = 0, o = Math.min(e.length - r, 2); i < o; ++i) {
          e[r + i] = (t & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
        }
      }function objectWriteUInt32(e, t, r, n) {
        t < 0 && (t = 4294967295 + t + 1);for (var i = 0, o = Math.min(e.length - r, 4); i < o; ++i) {
          e[r + i] = t >>> 8 * (n ? i : 3 - i) & 255;
        }
      }function checkIEEE754(e, t, r, n, i, o) {
        if (r + n > e.length) throw new RangeError("Index out of range");if (r < 0) throw new RangeError("Index out of range");
      }function writeFloat(e, t, r, n, o) {
        return o || checkIEEE754(e, 0, r, 4), i.write(e, t, r, n, 23, 4), r + 4;
      }function writeDouble(e, t, r, n, o) {
        return o || checkIEEE754(e, 0, r, 8), i.write(e, t, r, n, 52, 8), r + 8;
      }Buffer.prototype.slice = function slice(e, t) {
        var r,
            n = this.length;if (e = ~~e, t = void 0 === t ? n : ~~t, e < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), t < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), t < e && (t = e), Buffer.TYPED_ARRAY_SUPPORT) (r = this.subarray(e, t)).__proto__ = Buffer.prototype;else {
          var i = t - e;r = new Buffer(i, void 0);for (var o = 0; o < i; ++o) {
            r[o] = this[o + e];
          }
        }return r;
      }, Buffer.prototype.readUIntLE = function readUIntLE(e, t, r) {
        e |= 0, t |= 0, r || checkOffset(e, t, this.length);for (var n = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
          n += this[e + o] * i;
        }return n;
      }, Buffer.prototype.readUIntBE = function readUIntBE(e, t, r) {
        e |= 0, t |= 0, r || checkOffset(e, t, this.length);for (var n = this[e + --t], i = 1; t > 0 && (i *= 256);) {
          n += this[e + --t] * i;
        }return n;
      }, Buffer.prototype.readUInt8 = function readUInt8(e, t) {
        return t || checkOffset(e, 1, this.length), this[e];
      }, Buffer.prototype.readUInt16LE = function readUInt16LE(e, t) {
        return t || checkOffset(e, 2, this.length), this[e] | this[e + 1] << 8;
      }, Buffer.prototype.readUInt16BE = function readUInt16BE(e, t) {
        return t || checkOffset(e, 2, this.length), this[e] << 8 | this[e + 1];
      }, Buffer.prototype.readUInt32LE = function readUInt32LE(e, t) {
        return t || checkOffset(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
      }, Buffer.prototype.readUInt32BE = function readUInt32BE(e, t) {
        return t || checkOffset(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
      }, Buffer.prototype.readIntLE = function readIntLE(e, t, r) {
        e |= 0, t |= 0, r || checkOffset(e, t, this.length);for (var n = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
          n += this[e + o] * i;
        }return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
      }, Buffer.prototype.readIntBE = function readIntBE(e, t, r) {
        e |= 0, t |= 0, r || checkOffset(e, t, this.length);for (var n = t, i = 1, o = this[e + --n]; n > 0 && (i *= 256);) {
          o += this[e + --n] * i;
        }return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
      }, Buffer.prototype.readInt8 = function readInt8(e, t) {
        return t || checkOffset(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
      }, Buffer.prototype.readInt16LE = function readInt16LE(e, t) {
        t || checkOffset(e, 2, this.length);var r = this[e] | this[e + 1] << 8;return 32768 & r ? 4294901760 | r : r;
      }, Buffer.prototype.readInt16BE = function readInt16BE(e, t) {
        t || checkOffset(e, 2, this.length);var r = this[e + 1] | this[e] << 8;return 32768 & r ? 4294901760 | r : r;
      }, Buffer.prototype.readInt32LE = function readInt32LE(e, t) {
        return t || checkOffset(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
      }, Buffer.prototype.readInt32BE = function readInt32BE(e, t) {
        return t || checkOffset(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
      }, Buffer.prototype.readFloatLE = function readFloatLE(e, t) {
        return t || checkOffset(e, 4, this.length), i.read(this, e, !0, 23, 4);
      }, Buffer.prototype.readFloatBE = function readFloatBE(e, t) {
        return t || checkOffset(e, 4, this.length), i.read(this, e, !1, 23, 4);
      }, Buffer.prototype.readDoubleLE = function readDoubleLE(e, t) {
        return t || checkOffset(e, 8, this.length), i.read(this, e, !0, 52, 8);
      }, Buffer.prototype.readDoubleBE = function readDoubleBE(e, t) {
        return t || checkOffset(e, 8, this.length), i.read(this, e, !1, 52, 8);
      }, Buffer.prototype.writeUIntLE = function writeUIntLE(e, t, r, n) {
        (e = +e, t |= 0, r |= 0, n) || checkInt(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);var i = 1,
            o = 0;for (this[t] = 255 & e; ++o < r && (i *= 256);) {
          this[t + o] = e / i & 255;
        }return t + r;
      }, Buffer.prototype.writeUIntBE = function writeUIntBE(e, t, r, n) {
        (e = +e, t |= 0, r |= 0, n) || checkInt(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);var i = r - 1,
            o = 1;for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) {
          this[t + i] = e / o & 255;
        }return t + r;
      }, Buffer.prototype.writeUInt8 = function writeUInt8(e, t, r) {
        return e = +e, t |= 0, r || checkInt(this, e, t, 1, 255, 0), Buffer.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
      }, Buffer.prototype.writeUInt16LE = function writeUInt16LE(e, t, r) {
        return e = +e, t |= 0, r || checkInt(this, e, t, 2, 65535, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : objectWriteUInt16(this, e, t, !0), t + 2;
      }, Buffer.prototype.writeUInt16BE = function writeUInt16BE(e, t, r) {
        return e = +e, t |= 0, r || checkInt(this, e, t, 2, 65535, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : objectWriteUInt16(this, e, t, !1), t + 2;
      }, Buffer.prototype.writeUInt32LE = function writeUInt32LE(e, t, r) {
        return e = +e, t |= 0, r || checkInt(this, e, t, 4, 4294967295, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : objectWriteUInt32(this, e, t, !0), t + 4;
      }, Buffer.prototype.writeUInt32BE = function writeUInt32BE(e, t, r) {
        return e = +e, t |= 0, r || checkInt(this, e, t, 4, 4294967295, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : objectWriteUInt32(this, e, t, !1), t + 4;
      }, Buffer.prototype.writeIntLE = function writeIntLE(e, t, r, n) {
        if (e = +e, t |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);checkInt(this, e, t, r, i - 1, -i);
        }var o = 0,
            s = 1,
            a = 0;for (this[t] = 255 & e; ++o < r && (s *= 256);) {
          e < 0 && 0 === a && 0 !== this[t + o - 1] && (a = 1), this[t + o] = (e / s >> 0) - a & 255;
        }return t + r;
      }, Buffer.prototype.writeIntBE = function writeIntBE(e, t, r, n) {
        if (e = +e, t |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);checkInt(this, e, t, r, i - 1, -i);
        }var o = r - 1,
            s = 1,
            a = 0;for (this[t + o] = 255 & e; --o >= 0 && (s *= 256);) {
          e < 0 && 0 === a && 0 !== this[t + o + 1] && (a = 1), this[t + o] = (e / s >> 0) - a & 255;
        }return t + r;
      }, Buffer.prototype.writeInt8 = function writeInt8(e, t, r) {
        return e = +e, t |= 0, r || checkInt(this, e, t, 1, 127, -128), Buffer.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
      }, Buffer.prototype.writeInt16LE = function writeInt16LE(e, t, r) {
        return e = +e, t |= 0, r || checkInt(this, e, t, 2, 32767, -32768), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : objectWriteUInt16(this, e, t, !0), t + 2;
      }, Buffer.prototype.writeInt16BE = function writeInt16BE(e, t, r) {
        return e = +e, t |= 0, r || checkInt(this, e, t, 2, 32767, -32768), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : objectWriteUInt16(this, e, t, !1), t + 2;
      }, Buffer.prototype.writeInt32LE = function writeInt32LE(e, t, r) {
        return e = +e, t |= 0, r || checkInt(this, e, t, 4, 2147483647, -2147483648), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : objectWriteUInt32(this, e, t, !0), t + 4;
      }, Buffer.prototype.writeInt32BE = function writeInt32BE(e, t, r) {
        return e = +e, t |= 0, r || checkInt(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : objectWriteUInt32(this, e, t, !1), t + 4;
      }, Buffer.prototype.writeFloatLE = function writeFloatLE(e, t, r) {
        return writeFloat(this, e, t, !0, r);
      }, Buffer.prototype.writeFloatBE = function writeFloatBE(e, t, r) {
        return writeFloat(this, e, t, !1, r);
      }, Buffer.prototype.writeDoubleLE = function writeDoubleLE(e, t, r) {
        return writeDouble(this, e, t, !0, r);
      }, Buffer.prototype.writeDoubleBE = function writeDoubleBE(e, t, r) {
        return writeDouble(this, e, t, !1, r);
      }, Buffer.prototype.copy = function copy(e, t, r, n) {
        if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;if (0 === e.length || 0 === this.length) return 0;if (t < 0) throw new RangeError("targetStart out of bounds");if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");if (n < 0) throw new RangeError("sourceEnd out of bounds");n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);var i,
            o = n - r;if (this === e && r < t && t < n) for (i = o - 1; i >= 0; --i) {
          e[i + t] = this[i + r];
        } else if (o < 1e3 || !Buffer.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
          e[i + t] = this[i + r];
        } else Uint8Array.prototype.set.call(e, this.subarray(r, r + o), t);return o;
      }, Buffer.prototype.fill = function fill(e, t, r, n) {
        if ("string" == typeof e) {
          if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === e.length) {
            var i = e.charCodeAt(0);i < 256 && (e = i);
          }if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");if ("string" == typeof n && !Buffer.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
        } else "number" == typeof e && (e &= 255);if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");if (r <= t) return this;var o;if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < r; ++o) {
          this[o] = e;
        } else {
          var s = Buffer.isBuffer(e) ? e : utf8ToBytes(new Buffer(e, n).toString()),
              a = s.length;for (o = 0; o < r - t; ++o) {
            this[o + t] = s[o % a];
          }
        }return this;
      };var a = /[^+\/0-9A-Za-z-_]/g;function toHex(e) {
        return e < 16 ? "0" + e.toString(16) : e.toString(16);
      }function utf8ToBytes(e, t) {
        var r;t = t || 1 / 0;for (var n = e.length, i = null, o = [], s = 0; s < n; ++s) {
          if ((r = e.charCodeAt(s)) > 55295 && r < 57344) {
            if (!i) {
              if (r > 56319) {
                (t -= 3) > -1 && o.push(239, 191, 189);continue;
              }if (s + 1 === n) {
                (t -= 3) > -1 && o.push(239, 191, 189);continue;
              }i = r;continue;
            }if (r < 56320) {
              (t -= 3) > -1 && o.push(239, 191, 189), i = r;continue;
            }r = 65536 + (i - 55296 << 10 | r - 56320);
          } else i && (t -= 3) > -1 && o.push(239, 191, 189);if (i = null, r < 128) {
            if ((t -= 1) < 0) break;o.push(r);
          } else if (r < 2048) {
            if ((t -= 2) < 0) break;o.push(r >> 6 | 192, 63 & r | 128);
          } else if (r < 65536) {
            if ((t -= 3) < 0) break;o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
          } else {
            if (!(r < 1114112)) throw new Error("Invalid code point");if ((t -= 4) < 0) break;o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
          }
        }return o;
      }function base64ToBytes(e) {
        return n.toByteArray(function base64clean(e) {
          if ((e = function stringtrim(e) {
            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
          }(e).replace(a, "")).length < 2) return "";for (; e.length % 4 != 0;) {
            e += "=";
          }return e;
        }(e));
      }function blitBuffer(e, t, r, n) {
        for (var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i) {
          t[i + r] = e[i];
        }return i;
      }
    }).call(this, r(39));
  }, function (e, t, r) {
    "use strict";
    (function (n) {
      var i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return typeof e === "undefined" ? "undefined" : _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
      },
          u = { userAgent: !1 },
          p = {};
      /*!
      Copyright (c) 2011, Yahoo! Inc. All rights reserved.
      Code licensed under the BSD License:
      http://developer.yahoo.com/yui/license.html
      version: 2.9.0
      */
      if (void 0 === v) var v = {};v.lang = { extend: function extend(t, r, n) {
          if (!r || !t) throw new Error("YAHOO.lang.extend failed, please check that all dependencies are included.");var i = function d() {};if (i.prototype = r.prototype, t.prototype = new i(), t.prototype.constructor = t, t.superclass = r.prototype, r.prototype.constructor == Object.prototype.constructor && (r.prototype.constructor = r), n) {
            var o;for (o in n) {
              t.prototype[o] = n[o];
            }var s = function e() {},
                a = ["toString", "valueOf"];try {
              /MSIE/.test(u.userAgent) && (s = function e(t, r) {
                for (o = 0; o < a.length; o += 1) {
                  var n = a[o],
                      i = r[n];"function" == typeof i && i != Object.prototype[n] && (t[n] = i);
                }
              });
            } catch (e) {}s(t.prototype, n);
          }
        } };
      /*! CryptoJS v3.1.2 core-fix.js
       * code.google.com/p/crypto-js
       * (c) 2009-2013 by Jeff Mott. All rights reserved.
       * code.google.com/p/crypto-js/wiki/License
       * THIS IS FIX of 'core.js' to fix Hmac issue.
       * https://code.google.com/p/crypto-js/issues/detail?id=84
       * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
       */
      var y = y || function (e, t) {
        var r = {},
            n = r.lib = {},
            i = n.Base = function () {
          function n() {}return { extend: function extend(e) {
              n.prototype = this;var t = new n();return e && t.mixIn(e), t.hasOwnProperty("init") || (t.init = function () {
                t.$super.init.apply(this, arguments);
              }), t.init.prototype = t, t.$super = this, t;
            }, create: function create() {
              var e = this.extend();return e.init.apply(e, arguments), e;
            }, init: function init() {}, mixIn: function mixIn(e) {
              for (var t in e) {
                e.hasOwnProperty(t) && (this[t] = e[t]);
              }e.hasOwnProperty("toString") && (this.toString = e.toString);
            }, clone: function clone() {
              return this.init.prototype.extend(this);
            } };
        }(),
            o = n.WordArray = i.extend({ init: function init(e, t) {
            e = this.words = e || [], this.sigBytes = void 0 != t ? t : 4 * e.length;
          }, toString: function toString(e) {
            return (e || a).stringify(this);
          }, concat: function concat(e) {
            var t = this.words,
                r = e.words,
                n = this.sigBytes,
                i = e.sigBytes;if (this.clamp(), n % 4) for (var o = 0; o < i; o++) {
              var s = r[o >>> 2] >>> 24 - o % 4 * 8 & 255;t[n + o >>> 2] |= s << 24 - (n + o) % 4 * 8;
            } else for (o = 0; o < i; o += 4) {
              t[n + o >>> 2] = r[o >>> 2];
            }return this.sigBytes += i, this;
          }, clamp: function clamp() {
            var t = this.words,
                r = this.sigBytes;t[r >>> 2] &= 4294967295 << 32 - r % 4 * 8, t.length = e.ceil(r / 4);
          }, clone: function clone() {
            var e = i.clone.call(this);return e.words = this.words.slice(0), e;
          }, random: function random(t) {
            for (var r = [], n = 0; n < t; n += 4) {
              r.push(4294967296 * e.random() | 0);
            }return new o.init(r, t);
          } }),
            s = r.enc = {},
            a = s.Hex = { stringify: function stringify(e) {
            for (var t = e.words, r = e.sigBytes, n = [], i = 0; i < r; i++) {
              var o = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;n.push((o >>> 4).toString(16)), n.push((15 & o).toString(16));
            }return n.join("");
          }, parse: function parse(e) {
            for (var t = e.length, r = [], n = 0; n < t; n += 2) {
              r[n >>> 3] |= parseInt(e.substr(n, 2), 16) << 24 - n % 8 * 4;
            }return new o.init(r, t / 2);
          } },
            u = s.Latin1 = { stringify: function stringify(e) {
            for (var t = e.words, r = e.sigBytes, n = [], i = 0; i < r; i++) {
              var o = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;n.push(String.fromCharCode(o));
            }return n.join("");
          }, parse: function parse(e) {
            for (var t = e.length, r = [], n = 0; n < t; n++) {
              r[n >>> 2] |= (255 & e.charCodeAt(n)) << 24 - n % 4 * 8;
            }return new o.init(r, t);
          } },
            c = s.Utf8 = { stringify: function stringify(e) {
            try {
              return decodeURIComponent(escape(u.stringify(e)));
            } catch (e) {
              throw new Error("Malformed UTF-8 data");
            }
          }, parse: function parse(e) {
            return u.parse(unescape(encodeURIComponent(e)));
          } },
            h = n.BufferedBlockAlgorithm = i.extend({ reset: function reset() {
            this._data = new o.init(), this._nDataBytes = 0;
          }, _append: function _append(e) {
            "string" == typeof e && (e = c.parse(e)), this._data.concat(e), this._nDataBytes += e.sigBytes;
          }, _process: function _process(t) {
            var r = this._data,
                n = r.words,
                i = r.sigBytes,
                s = this.blockSize,
                a = i / (4 * s),
                u = (a = t ? e.ceil(a) : e.max((0 | a) - this._minBufferSize, 0)) * s,
                c = e.min(4 * u, i);if (u) {
              for (var h = 0; h < u; h += s) {
                this._doProcessBlock(n, h);
              }var f = n.splice(0, u);r.sigBytes -= c;
            }return new o.init(f, c);
          }, clone: function clone() {
            var e = i.clone.call(this);return e._data = this._data.clone(), e;
          }, _minBufferSize: 0 }),
            f = (n.Hasher = h.extend({ cfg: i.extend(), init: function init(e) {
            this.cfg = this.cfg.extend(e), this.reset();
          }, reset: function reset() {
            h.reset.call(this), this._doReset();
          }, update: function update(e) {
            return this._append(e), this._process(), this;
          }, finalize: function finalize(e) {
            return e && this._append(e), this._doFinalize();
          }, blockSize: 16, _createHelper: function _createHelper(e) {
            return function (t, r) {
              return new e.init(r).finalize(t);
            };
          }, _createHmacHelper: function _createHmacHelper(e) {
            return function (t, r) {
              return new f.HMAC.init(e, r).finalize(t);
            };
          } }), r.algo = {});return r;
      }(Math);!function (e) {
        var t,
            r = (t = y).lib,
            n = r.Base,
            i = r.WordArray;(t = t.x64 = {}).Word = n.extend({ init: function init(e, t) {
            this.high = e, this.low = t;
          } }), t.WordArray = n.extend({ init: function init(e, t) {
            e = this.words = e || [], this.sigBytes = void 0 != t ? t : 8 * e.length;
          }, toX32: function toX32() {
            for (var e = this.words, t = e.length, r = [], n = 0; n < t; n++) {
              var o = e[n];r.push(o.high), r.push(o.low);
            }return i.create(r, this.sigBytes);
          }, clone: function clone() {
            for (var e = n.clone.call(this), t = e.words = this.words.slice(0), r = t.length, i = 0; i < r; i++) {
              t[i] = t[i].clone();
            }return e;
          } });
      }(), function () {
        var e = y,
            t = e.lib.WordArray;e.enc.Base64 = { stringify: function stringify(e) {
            var t = e.words,
                r = e.sigBytes,
                n = this._map;e.clamp(), e = [];for (var i = 0; i < r; i += 3) {
              for (var o = (t[i >>> 2] >>> 24 - i % 4 * 8 & 255) << 16 | (t[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 255) << 8 | t[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 255, s = 0; 4 > s && i + .75 * s < r; s++) {
                e.push(n.charAt(o >>> 6 * (3 - s) & 63));
              }
            }if (t = n.charAt(64)) for (; e.length % 4;) {
              e.push(t);
            }return e.join("");
          }, parse: function parse(e) {
            var r = e.length,
                n = this._map;(i = n.charAt(64)) && -1 != (i = e.indexOf(i)) && (r = i);for (var i = [], o = 0, s = 0; s < r; s++) {
              if (s % 4) {
                var a = n.indexOf(e.charAt(s - 1)) << s % 4 * 2,
                    u = n.indexOf(e.charAt(s)) >>> 6 - s % 4 * 2;i[o >>> 2] |= (a | u) << 24 - o % 4 * 8, o++;
              }
            }return t.create(i, o);
          }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=" };
      }(), function (e) {
        for (var t = y, r = (i = t.lib).WordArray, n = i.Hasher, i = t.algo, o = [], s = [], a = function u(e) {
          return 4294967296 * (e - (0 | e)) | 0;
        }, u = 2, c = 0; 64 > c;) {
          var h;e: {
            h = u;for (var f = e.sqrt(h), l = 2; l <= f; l++) {
              if (!(h % l)) {
                h = !1;break e;
              }
            }h = !0;
          }h && (8 > c && (o[c] = a(e.pow(u, .5))), s[c] = a(e.pow(u, 1 / 3)), c++), u++;
        }var g = [];i = i.SHA256 = n.extend({ _doReset: function _doReset() {
            this._hash = new r.init(o.slice(0));
          }, _doProcessBlock: function _doProcessBlock(e, t) {
            for (var r = this._hash.words, n = r[0], i = r[1], o = r[2], a = r[3], u = r[4], c = r[5], h = r[6], f = r[7], l = 0; 64 > l; l++) {
              if (16 > l) g[l] = 0 | e[t + l];else {
                var p = g[l - 15],
                    d = g[l - 2];g[l] = ((p << 25 | p >>> 7) ^ (p << 14 | p >>> 18) ^ p >>> 3) + g[l - 7] + ((d << 15 | d >>> 17) ^ (d << 13 | d >>> 19) ^ d >>> 10) + g[l - 16];
              }p = f + ((u << 26 | u >>> 6) ^ (u << 21 | u >>> 11) ^ (u << 7 | u >>> 25)) + (u & c ^ ~u & h) + s[l] + g[l], d = ((n << 30 | n >>> 2) ^ (n << 19 | n >>> 13) ^ (n << 10 | n >>> 22)) + (n & i ^ n & o ^ i & o), f = h, h = c, c = u, u = a + p | 0, a = o, o = i, i = n, n = p + d | 0;
            }r[0] = r[0] + n | 0, r[1] = r[1] + i | 0, r[2] = r[2] + o | 0, r[3] = r[3] + a | 0, r[4] = r[4] + u | 0, r[5] = r[5] + c | 0, r[6] = r[6] + h | 0, r[7] = r[7] + f | 0;
          }, _doFinalize: function _doFinalize() {
            var t = this._data,
                r = t.words,
                n = 8 * this._nDataBytes,
                i = 8 * t.sigBytes;return r[i >>> 5] |= 128 << 24 - i % 32, r[14 + (i + 64 >>> 9 << 4)] = e.floor(n / 4294967296), r[15 + (i + 64 >>> 9 << 4)] = n, t.sigBytes = 4 * r.length, this._process(), this._hash;
          }, clone: function clone() {
            var e = n.clone.call(this);return e._hash = this._hash.clone(), e;
          } });t.SHA256 = n._createHelper(i), t.HmacSHA256 = n._createHmacHelper(i);
      }(Math), function () {
        function a() {
          return r.create.apply(r, arguments);
        }for (var e = y, t = e.lib.Hasher, r = (i = e.x64).Word, n = i.WordArray, i = e.algo, o = [a(1116352408, 3609767458), a(1899447441, 602891725), a(3049323471, 3964484399), a(3921009573, 2173295548), a(961987163, 4081628472), a(1508970993, 3053834265), a(2453635748, 2937671579), a(2870763221, 3664609560), a(3624381080, 2734883394), a(310598401, 1164996542), a(607225278, 1323610764), a(1426881987, 3590304994), a(1925078388, 4068182383), a(2162078206, 991336113), a(2614888103, 633803317), a(3248222580, 3479774868), a(3835390401, 2666613458), a(4022224774, 944711139), a(264347078, 2341262773), a(604807628, 2007800933), a(770255983, 1495990901), a(1249150122, 1856431235), a(1555081692, 3175218132), a(1996064986, 2198950837), a(2554220882, 3999719339), a(2821834349, 766784016), a(2952996808, 2566594879), a(3210313671, 3203337956), a(3336571891, 1034457026), a(3584528711, 2466948901), a(113926993, 3758326383), a(338241895, 168717936), a(666307205, 1188179964), a(773529912, 1546045734), a(1294757372, 1522805485), a(1396182291, 2643833823), a(1695183700, 2343527390), a(1986661051, 1014477480), a(2177026350, 1206759142), a(2456956037, 344077627), a(2730485921, 1290863460), a(2820302411, 3158454273), a(3259730800, 3505952657), a(3345764771, 106217008), a(3516065817, 3606008344), a(3600352804, 1432725776), a(4094571909, 1467031594), a(275423344, 851169720), a(430227734, 3100823752), a(506948616, 1363258195), a(659060556, 3750685593), a(883997877, 3785050280), a(958139571, 3318307427), a(1322822218, 3812723403), a(1537002063, 2003034995), a(1747873779, 3602036899), a(1955562222, 1575990012), a(2024104815, 1125592928), a(2227730452, 2716904306), a(2361852424, 442776044), a(2428436474, 593698344), a(2756734187, 3733110249), a(3204031479, 2999351573), a(3329325298, 3815920427), a(3391569614, 3928383900), a(3515267271, 566280711), a(3940187606, 3454069534), a(4118630271, 4000239992), a(116418474, 1914138554), a(174292421, 2731055270), a(289380356, 3203993006), a(460393269, 320620315), a(685471733, 587496836), a(852142971, 1086792851), a(1017036298, 365543100), a(1126000580, 2618297676), a(1288033470, 3409855158), a(1501505948, 4234509866), a(1607167915, 987167468), a(1816402316, 1246189591)], s = [], u = 0; 80 > u; u++) {
          s[u] = a();
        }i = i.SHA512 = t.extend({ _doReset: function _doReset() {
            this._hash = new n.init([new r.init(1779033703, 4089235720), new r.init(3144134277, 2227873595), new r.init(1013904242, 4271175723), new r.init(2773480762, 1595750129), new r.init(1359893119, 2917565137), new r.init(2600822924, 725511199), new r.init(528734635, 4215389547), new r.init(1541459225, 327033209)]);
          }, _doProcessBlock: function _doProcessBlock(e, t) {
            for (var r = (f = this._hash.words)[0], n = f[1], i = f[2], a = f[3], u = f[4], c = f[5], h = f[6], f = f[7], l = r.high, g = r.low, p = n.high, d = n.low, v = i.high, y = i.low, m = a.high, S = a.low, F = u.high, b = u.low, _ = c.high, w = c.low, E = h.high, x = h.low, C = f.high, P = f.low, A = l, k = g, I = p, B = d, R = v, T = y, U = m, M = S, L = F, D = b, N = _, O = w, H = E, j = x, K = C, q = P, W = 0; 80 > W; W++) {
              var V = s[W];if (16 > W) var J = V.high = 0 | e[t + 2 * W],
                  z = V.low = 0 | e[t + 2 * W + 1];else {
                J = ((z = (J = s[W - 15]).high) >>> 1 | (Y = J.low) << 31) ^ (z >>> 8 | Y << 24) ^ z >>> 7;var Y = (Y >>> 1 | z << 31) ^ (Y >>> 8 | z << 24) ^ (Y >>> 7 | z << 25),
                    G = ((z = (G = s[W - 2]).high) >>> 19 | (X = G.low) << 13) ^ (z << 3 | X >>> 29) ^ z >>> 6,
                    X = (X >>> 19 | z << 13) ^ (X << 3 | z >>> 29) ^ (X >>> 6 | z << 26),
                    Q = (z = s[W - 7]).high,
                    Z = ($ = s[W - 16]).high,
                    $ = $.low;J = (J = (J = J + Q + ((z = Y + z.low) >>> 0 < Y >>> 0 ? 1 : 0)) + G + ((z = z + X) >>> 0 < X >>> 0 ? 1 : 0)) + Z + ((z = z + $) >>> 0 < $ >>> 0 ? 1 : 0);V.high = J, V.low = z;
              }Q = L & N ^ ~L & H, $ = D & O ^ ~D & j, V = A & I ^ A & R ^ I & R;var ee = k & B ^ k & T ^ B & T,
                  te = (Y = (A >>> 28 | k << 4) ^ (A << 30 | k >>> 2) ^ (A << 25 | k >>> 7), G = (k >>> 28 | A << 4) ^ (k << 30 | A >>> 2) ^ (k << 25 | A >>> 7), (X = o[W]).high),
                  re = X.low;Z = (Z = (Z = (Z = K + ((L >>> 14 | D << 18) ^ (L >>> 18 | D << 14) ^ (L << 23 | D >>> 9)) + ((X = q + ((D >>> 14 | L << 18) ^ (D >>> 18 | L << 14) ^ (D << 23 | L >>> 9))) >>> 0 < q >>> 0 ? 1 : 0)) + Q + ((X = X + $) >>> 0 < $ >>> 0 ? 1 : 0)) + te + ((X = X + re) >>> 0 < re >>> 0 ? 1 : 0)) + J + ((X = X + z) >>> 0 < z >>> 0 ? 1 : 0), V = Y + V + ((z = G + ee) >>> 0 < G >>> 0 ? 1 : 0), K = H, q = j, H = N, j = O, N = L, O = D, L = U + Z + ((D = M + X | 0) >>> 0 < M >>> 0 ? 1 : 0) | 0, U = R, M = T, R = I, T = B, I = A, B = k, A = Z + V + ((k = X + z | 0) >>> 0 < X >>> 0 ? 1 : 0) | 0;
            }g = r.low = g + k, r.high = l + A + (g >>> 0 < k >>> 0 ? 1 : 0), d = n.low = d + B, n.high = p + I + (d >>> 0 < B >>> 0 ? 1 : 0), y = i.low = y + T, i.high = v + R + (y >>> 0 < T >>> 0 ? 1 : 0), S = a.low = S + M, a.high = m + U + (S >>> 0 < M >>> 0 ? 1 : 0), b = u.low = b + D, u.high = F + L + (b >>> 0 < D >>> 0 ? 1 : 0), w = c.low = w + O, c.high = _ + N + (w >>> 0 < O >>> 0 ? 1 : 0), x = h.low = x + j, h.high = E + H + (x >>> 0 < j >>> 0 ? 1 : 0), P = f.low = P + q, f.high = C + K + (P >>> 0 < q >>> 0 ? 1 : 0);
          }, _doFinalize: function _doFinalize() {
            var e = this._data,
                t = e.words,
                r = 8 * this._nDataBytes,
                n = 8 * e.sigBytes;return t[n >>> 5] |= 128 << 24 - n % 32, t[30 + (n + 128 >>> 10 << 5)] = Math.floor(r / 4294967296), t[31 + (n + 128 >>> 10 << 5)] = r, e.sigBytes = 4 * t.length, this._process(), this._hash.toX32();
          }, clone: function clone() {
            var e = t.clone.call(this);return e._hash = this._hash.clone(), e;
          }, blockSize: 32 }), e.SHA512 = t._createHelper(i), e.HmacSHA512 = t._createHmacHelper(i);
      }(), function () {
        var e = y,
            t = (i = e.x64).Word,
            r = i.WordArray,
            n = (i = e.algo).SHA512,
            i = i.SHA384 = n.extend({ _doReset: function _doReset() {
            this._hash = new r.init([new t.init(3418070365, 3238371032), new t.init(1654270250, 914150663), new t.init(2438529370, 812702999), new t.init(355462360, 4144912697), new t.init(1731405415, 4290775857), new t.init(2394180231, 1750603025), new t.init(3675008525, 1694076839), new t.init(1203062813, 3204075428)]);
          }, _doFinalize: function _doFinalize() {
            var e = n._doFinalize.call(this);return e.sigBytes -= 16, e;
          } });e.SHA384 = n._createHelper(i), e.HmacSHA384 = n._createHmacHelper(i);
      }();
      /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
       */
      var S,
          F = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
          _ = "=";function hex2b64(e) {
        var t,
            r,
            n = "";for (t = 0; t + 3 <= e.length; t += 3) {
          r = parseInt(e.substring(t, t + 3), 16), n += F.charAt(r >> 6) + F.charAt(63 & r);
        }if (t + 1 == e.length ? (r = parseInt(e.substring(t, t + 1), 16), n += F.charAt(r << 2)) : t + 2 == e.length && (r = parseInt(e.substring(t, t + 2), 16), n += F.charAt(r >> 2) + F.charAt((3 & r) << 4)), _) for (; (3 & n.length) > 0;) {
          n += _;
        }return n;
      }function b64tohex(e) {
        var t,
            r,
            n,
            i = "",
            o = 0;for (t = 0; t < e.length && e.charAt(t) != _; ++t) {
          (n = F.indexOf(e.charAt(t))) < 0 || (0 == o ? (i += int2char(n >> 2), r = 3 & n, o = 1) : 1 == o ? (i += int2char(r << 2 | n >> 4), r = 15 & n, o = 2) : 2 == o ? (i += int2char(r), i += int2char(n >> 2), r = 3 & n, o = 3) : (i += int2char(r << 2 | n >> 4), i += int2char(15 & n), o = 0));
        }return 1 == o && (i += int2char(r << 2)), i;
      }function b64toBA(e) {
        var t,
            r = b64tohex(e),
            n = new Array();for (t = 0; 2 * t < r.length; ++t) {
          n[t] = parseInt(r.substring(2 * t, 2 * t + 2), 16);
        }return n;
      }function BigInteger(e, t, r) {
        null != e && ("number" == typeof e ? this.fromNumber(e, t, r) : null == t && "string" != typeof e ? this.fromString(e, 256) : this.fromString(e, t));
      }function nbi() {
        return new BigInteger(null);
      }"Microsoft Internet Explorer" == u.appName ? (BigInteger.prototype.am = function am2(e, t, r, n, i, o) {
        for (var s = 32767 & t, a = t >> 15; --o >= 0;) {
          var u = 32767 & this[e],
              c = this[e++] >> 15,
              h = a * u + c * s;i = ((u = s * u + ((32767 & h) << 15) + r[n] + (1073741823 & i)) >>> 30) + (h >>> 15) + a * c + (i >>> 30), r[n++] = 1073741823 & u;
        }return i;
      }, S = 30) : "Netscape" != u.appName ? (BigInteger.prototype.am = function am1(e, t, r, n, i, o) {
        for (; --o >= 0;) {
          var s = t * this[e++] + r[n] + i;i = Math.floor(s / 67108864), r[n++] = 67108863 & s;
        }return i;
      }, S = 26) : (BigInteger.prototype.am = function am3(e, t, r, n, i, o) {
        for (var s = 16383 & t, a = t >> 14; --o >= 0;) {
          var u = 16383 & this[e],
              c = this[e++] >> 14,
              h = a * u + c * s;i = ((u = s * u + ((16383 & h) << 14) + r[n] + i) >> 28) + (h >> 14) + a * c, r[n++] = 268435455 & u;
        }return i;
      }, S = 28), BigInteger.prototype.DB = S, BigInteger.prototype.DM = (1 << S) - 1, BigInteger.prototype.DV = 1 << S;BigInteger.prototype.FV = Math.pow(2, 52), BigInteger.prototype.F1 = 52 - S, BigInteger.prototype.F2 = 2 * S - 52;var w,
          E,
          C = "0123456789abcdefghijklmnopqrstuvwxyz",
          P = new Array();for (w = "0".charCodeAt(0), E = 0; E <= 9; ++E) {
        P[w++] = E;
      }for (w = "a".charCodeAt(0), E = 10; E < 36; ++E) {
        P[w++] = E;
      }for (w = "A".charCodeAt(0), E = 10; E < 36; ++E) {
        P[w++] = E;
      }function int2char(e) {
        return C.charAt(e);
      }function intAt(e, t) {
        var r = P[e.charCodeAt(t)];return null == r ? -1 : r;
      }function nbv(e) {
        var t = nbi();return t.fromInt(e), t;
      }function nbits(e) {
        var t,
            r = 1;return 0 != (t = e >>> 16) && (e = t, r += 16), 0 != (t = e >> 8) && (e = t, r += 8), 0 != (t = e >> 4) && (e = t, r += 4), 0 != (t = e >> 2) && (e = t, r += 2), 0 != (t = e >> 1) && (e = t, r += 1), r;
      }function Classic(e) {
        this.m = e;
      }function Montgomery(e) {
        this.m = e, this.mp = e.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << e.DB - 15) - 1, this.mt2 = 2 * e.t;
      }function op_and(e, t) {
        return e & t;
      }function op_or(e, t) {
        return e | t;
      }function op_xor(e, t) {
        return e ^ t;
      }function op_andnot(e, t) {
        return e & ~t;
      }function lbit(e) {
        if (0 == e) return -1;var t = 0;return 0 == (65535 & e) && (e >>= 16, t += 16), 0 == (255 & e) && (e >>= 8, t += 8), 0 == (15 & e) && (e >>= 4, t += 4), 0 == (3 & e) && (e >>= 2, t += 2), 0 == (1 & e) && ++t, t;
      }function cbit(e) {
        for (var t = 0; 0 != e;) {
          e &= e - 1, ++t;
        }return t;
      }function NullExp() {}function nNop(e) {
        return e;
      }function Barrett(e) {
        this.r2 = nbi(), this.q3 = nbi(), BigInteger.ONE.dlShiftTo(2 * e.t, this.r2), this.mu = this.r2.divide(e), this.m = e;
      }Classic.prototype.convert = function cConvert(e) {
        return e.s < 0 || e.compareTo(this.m) >= 0 ? e.mod(this.m) : e;
      }, Classic.prototype.revert = function cRevert(e) {
        return e;
      }, Classic.prototype.reduce = function cReduce(e) {
        e.divRemTo(this.m, null, e);
      }, Classic.prototype.mulTo = function cMulTo(e, t, r) {
        e.multiplyTo(t, r), this.reduce(r);
      }, Classic.prototype.sqrTo = function cSqrTo(e, t) {
        e.squareTo(t), this.reduce(t);
      }, Montgomery.prototype.convert = function montConvert(e) {
        var t = nbi();return e.abs().dlShiftTo(this.m.t, t), t.divRemTo(this.m, null, t), e.s < 0 && t.compareTo(BigInteger.ZERO) > 0 && this.m.subTo(t, t), t;
      }, Montgomery.prototype.revert = function montRevert(e) {
        var t = nbi();return e.copyTo(t), this.reduce(t), t;
      }, Montgomery.prototype.reduce = function montReduce(e) {
        for (; e.t <= this.mt2;) {
          e[e.t++] = 0;
        }for (var t = 0; t < this.m.t; ++t) {
          var r = 32767 & e[t],
              n = r * this.mpl + ((r * this.mph + (e[t] >> 15) * this.mpl & this.um) << 15) & e.DM;for (e[r = t + this.m.t] += this.m.am(0, n, e, t, 0, this.m.t); e[r] >= e.DV;) {
            e[r] -= e.DV, e[++r]++;
          }
        }e.clamp(), e.drShiftTo(this.m.t, e), e.compareTo(this.m) >= 0 && e.subTo(this.m, e);
      }, Montgomery.prototype.mulTo = function montMulTo(e, t, r) {
        e.multiplyTo(t, r), this.reduce(r);
      }, Montgomery.prototype.sqrTo = function montSqrTo(e, t) {
        e.squareTo(t), this.reduce(t);
      }, BigInteger.prototype.copyTo = function bnpCopyTo(e) {
        for (var t = this.t - 1; t >= 0; --t) {
          e[t] = this[t];
        }e.t = this.t, e.s = this.s;
      }, BigInteger.prototype.fromInt = function bnpFromInt(e) {
        this.t = 1, this.s = e < 0 ? -1 : 0, e > 0 ? this[0] = e : e < -1 ? this[0] = e + this.DV : this.t = 0;
      }, BigInteger.prototype.fromString = function bnpFromString(e, t) {
        var r;if (16 == t) r = 4;else if (8 == t) r = 3;else if (256 == t) r = 8;else if (2 == t) r = 1;else if (32 == t) r = 5;else {
          if (4 != t) return void this.fromRadix(e, t);r = 2;
        }this.t = 0, this.s = 0;for (var n = e.length, i = !1, o = 0; --n >= 0;) {
          var s = 8 == r ? 255 & e[n] : intAt(e, n);s < 0 ? "-" == e.charAt(n) && (i = !0) : (i = !1, 0 == o ? this[this.t++] = s : o + r > this.DB ? (this[this.t - 1] |= (s & (1 << this.DB - o) - 1) << o, this[this.t++] = s >> this.DB - o) : this[this.t - 1] |= s << o, (o += r) >= this.DB && (o -= this.DB));
        }8 == r && 0 != (128 & e[0]) && (this.s = -1, o > 0 && (this[this.t - 1] |= (1 << this.DB - o) - 1 << o)), this.clamp(), i && BigInteger.ZERO.subTo(this, this);
      }, BigInteger.prototype.clamp = function bnpClamp() {
        for (var e = this.s & this.DM; this.t > 0 && this[this.t - 1] == e;) {
          --this.t;
        }
      }, BigInteger.prototype.dlShiftTo = function bnpDLShiftTo(e, t) {
        var r;for (r = this.t - 1; r >= 0; --r) {
          t[r + e] = this[r];
        }for (r = e - 1; r >= 0; --r) {
          t[r] = 0;
        }t.t = this.t + e, t.s = this.s;
      }, BigInteger.prototype.drShiftTo = function bnpDRShiftTo(e, t) {
        for (var r = e; r < this.t; ++r) {
          t[r - e] = this[r];
        }t.t = Math.max(this.t - e, 0), t.s = this.s;
      }, BigInteger.prototype.lShiftTo = function bnpLShiftTo(e, t) {
        var r,
            n = e % this.DB,
            i = this.DB - n,
            o = (1 << i) - 1,
            s = Math.floor(e / this.DB),
            a = this.s << n & this.DM;for (r = this.t - 1; r >= 0; --r) {
          t[r + s + 1] = this[r] >> i | a, a = (this[r] & o) << n;
        }for (r = s - 1; r >= 0; --r) {
          t[r] = 0;
        }t[s] = a, t.t = this.t + s + 1, t.s = this.s, t.clamp();
      }, BigInteger.prototype.rShiftTo = function bnpRShiftTo(e, t) {
        t.s = this.s;var r = Math.floor(e / this.DB);if (r >= this.t) t.t = 0;else {
          var n = e % this.DB,
              i = this.DB - n,
              o = (1 << n) - 1;t[0] = this[r] >> n;for (var s = r + 1; s < this.t; ++s) {
            t[s - r - 1] |= (this[s] & o) << i, t[s - r] = this[s] >> n;
          }n > 0 && (t[this.t - r - 1] |= (this.s & o) << i), t.t = this.t - r, t.clamp();
        }
      }, BigInteger.prototype.subTo = function bnpSubTo(e, t) {
        for (var r = 0, n = 0, i = Math.min(e.t, this.t); r < i;) {
          n += this[r] - e[r], t[r++] = n & this.DM, n >>= this.DB;
        }if (e.t < this.t) {
          for (n -= e.s; r < this.t;) {
            n += this[r], t[r++] = n & this.DM, n >>= this.DB;
          }n += this.s;
        } else {
          for (n += this.s; r < e.t;) {
            n -= e[r], t[r++] = n & this.DM, n >>= this.DB;
          }n -= e.s;
        }t.s = n < 0 ? -1 : 0, n < -1 ? t[r++] = this.DV + n : n > 0 && (t[r++] = n), t.t = r, t.clamp();
      }, BigInteger.prototype.multiplyTo = function bnpMultiplyTo(e, t) {
        var r = this.abs(),
            n = e.abs(),
            i = r.t;for (t.t = i + n.t; --i >= 0;) {
          t[i] = 0;
        }for (i = 0; i < n.t; ++i) {
          t[i + r.t] = r.am(0, n[i], t, i, 0, r.t);
        }t.s = 0, t.clamp(), this.s != e.s && BigInteger.ZERO.subTo(t, t);
      }, BigInteger.prototype.squareTo = function bnpSquareTo(e) {
        for (var t = this.abs(), r = e.t = 2 * t.t; --r >= 0;) {
          e[r] = 0;
        }for (r = 0; r < t.t - 1; ++r) {
          var n = t.am(r, t[r], e, 2 * r, 0, 1);(e[r + t.t] += t.am(r + 1, 2 * t[r], e, 2 * r + 1, n, t.t - r - 1)) >= t.DV && (e[r + t.t] -= t.DV, e[r + t.t + 1] = 1);
        }e.t > 0 && (e[e.t - 1] += t.am(r, t[r], e, 2 * r, 0, 1)), e.s = 0, e.clamp();
      }, BigInteger.prototype.divRemTo = function bnpDivRemTo(e, t, r) {
        var n = e.abs();if (!(n.t <= 0)) {
          var i = this.abs();if (i.t < n.t) return null != t && t.fromInt(0), void (null != r && this.copyTo(r));null == r && (r = nbi());var o = nbi(),
              s = this.s,
              a = e.s,
              u = this.DB - nbits(n[n.t - 1]);u > 0 ? (n.lShiftTo(u, o), i.lShiftTo(u, r)) : (n.copyTo(o), i.copyTo(r));var c = o.t,
              h = o[c - 1];if (0 != h) {
            var f = h * (1 << this.F1) + (c > 1 ? o[c - 2] >> this.F2 : 0),
                l = this.FV / f,
                g = (1 << this.F1) / f,
                p = 1 << this.F2,
                d = r.t,
                v = d - c,
                y = null == t ? nbi() : t;for (o.dlShiftTo(v, y), r.compareTo(y) >= 0 && (r[r.t++] = 1, r.subTo(y, r)), BigInteger.ONE.dlShiftTo(c, y), y.subTo(o, o); o.t < c;) {
              o[o.t++] = 0;
            }for (; --v >= 0;) {
              var m = r[--d] == h ? this.DM : Math.floor(r[d] * l + (r[d - 1] + p) * g);if ((r[d] += o.am(0, m, r, v, 0, c)) < m) for (o.dlShiftTo(v, y), r.subTo(y, r); r[d] < --m;) {
                r.subTo(y, r);
              }
            }null != t && (r.drShiftTo(c, t), s != a && BigInteger.ZERO.subTo(t, t)), r.t = c, r.clamp(), u > 0 && r.rShiftTo(u, r), s < 0 && BigInteger.ZERO.subTo(r, r);
          }
        }
      }, BigInteger.prototype.invDigit = function bnpInvDigit() {
        if (this.t < 1) return 0;var e = this[0];if (0 == (1 & e)) return 0;var t = 3 & e;return (t = (t = (t = (t = t * (2 - (15 & e) * t) & 15) * (2 - (255 & e) * t) & 255) * (2 - ((65535 & e) * t & 65535)) & 65535) * (2 - e * t % this.DV) % this.DV) > 0 ? this.DV - t : -t;
      }, BigInteger.prototype.isEven = function bnpIsEven() {
        return 0 == (this.t > 0 ? 1 & this[0] : this.s);
      }, BigInteger.prototype.exp = function bnpExp(e, t) {
        if (e > 4294967295 || e < 1) return BigInteger.ONE;var r = nbi(),
            n = nbi(),
            i = t.convert(this),
            o = nbits(e) - 1;for (i.copyTo(r); --o >= 0;) {
          if (t.sqrTo(r, n), (e & 1 << o) > 0) t.mulTo(n, i, r);else {
            var s = r;r = n, n = s;
          }
        }return t.revert(r);
      }, BigInteger.prototype.toString = function bnToString(e) {
        if (this.s < 0) return "-" + this.negate().toString(e);var t;if (16 == e) t = 4;else if (8 == e) t = 3;else if (2 == e) t = 1;else if (32 == e) t = 5;else {
          if (4 != e) return this.toRadix(e);t = 2;
        }var r,
            n = (1 << t) - 1,
            i = !1,
            o = "",
            s = this.t,
            a = this.DB - s * this.DB % t;if (s-- > 0) for (a < this.DB && (r = this[s] >> a) > 0 && (i = !0, o = int2char(r)); s >= 0;) {
          a < t ? (r = (this[s] & (1 << a) - 1) << t - a, r |= this[--s] >> (a += this.DB - t)) : (r = this[s] >> (a -= t) & n, a <= 0 && (a += this.DB, --s)), r > 0 && (i = !0), i && (o += int2char(r));
        }return i ? o : "0";
      }, BigInteger.prototype.negate = function bnNegate() {
        var e = nbi();return BigInteger.ZERO.subTo(this, e), e;
      }, BigInteger.prototype.abs = function bnAbs() {
        return this.s < 0 ? this.negate() : this;
      }, BigInteger.prototype.compareTo = function bnCompareTo(e) {
        var t = this.s - e.s;if (0 != t) return t;var r = this.t;if (0 != (t = r - e.t)) return this.s < 0 ? -t : t;for (; --r >= 0;) {
          if (0 != (t = this[r] - e[r])) return t;
        }return 0;
      }, BigInteger.prototype.bitLength = function bnBitLength() {
        return this.t <= 0 ? 0 : this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
      }, BigInteger.prototype.mod = function bnMod(e) {
        var t = nbi();return this.abs().divRemTo(e, null, t), this.s < 0 && t.compareTo(BigInteger.ZERO) > 0 && e.subTo(t, t), t;
      }, BigInteger.prototype.modPowInt = function bnModPowInt(e, t) {
        var r;return r = e < 256 || t.isEven() ? new Classic(t) : new Montgomery(t), this.exp(e, r);
      }, BigInteger.ZERO = nbv(0), BigInteger.ONE = nbv(1), NullExp.prototype.convert = nNop, NullExp.prototype.revert = nNop, NullExp.prototype.mulTo = function nMulTo(e, t, r) {
        e.multiplyTo(t, r);
      }, NullExp.prototype.sqrTo = function nSqrTo(e, t) {
        e.squareTo(t);
      }, Barrett.prototype.convert = function barrettConvert(e) {
        if (e.s < 0 || e.t > 2 * this.m.t) return e.mod(this.m);if (e.compareTo(this.m) < 0) return e;var t = nbi();return e.copyTo(t), this.reduce(t), t;
      }, Barrett.prototype.revert = function barrettRevert(e) {
        return e;
      }, Barrett.prototype.reduce = function barrettReduce(e) {
        for (e.drShiftTo(this.m.t - 1, this.r2), e.t > this.m.t + 1 && (e.t = this.m.t + 1, e.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); e.compareTo(this.r2) < 0;) {
          e.dAddOffset(1, this.m.t + 1);
        }for (e.subTo(this.r2, e); e.compareTo(this.m) >= 0;) {
          e.subTo(this.m, e);
        }
      }, Barrett.prototype.mulTo = function barrettMulTo(e, t, r) {
        e.multiplyTo(t, r), this.reduce(r);
      }, Barrett.prototype.sqrTo = function barrettSqrTo(e, t) {
        e.squareTo(t), this.reduce(t);
      };var I = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997],
          R = (1 << 26) / I[I.length - 1];
      /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
       */
      function Arcfour() {
        this.i = 0, this.j = 0, this.S = new Array();
      }BigInteger.prototype.chunkSize = function bnpChunkSize(e) {
        return Math.floor(Math.LN2 * this.DB / Math.log(e));
      }, BigInteger.prototype.toRadix = function bnpToRadix(e) {
        if (null == e && (e = 10), 0 == this.signum() || e < 2 || e > 36) return "0";var t = this.chunkSize(e),
            r = Math.pow(e, t),
            n = nbv(r),
            i = nbi(),
            o = nbi(),
            s = "";for (this.divRemTo(n, i, o); i.signum() > 0;) {
          s = (r + o.intValue()).toString(e).substr(1) + s, i.divRemTo(n, i, o);
        }return o.intValue().toString(e) + s;
      }, BigInteger.prototype.fromRadix = function bnpFromRadix(e, t) {
        this.fromInt(0), null == t && (t = 10);for (var r = this.chunkSize(t), n = Math.pow(t, r), i = !1, o = 0, s = 0, a = 0; a < e.length; ++a) {
          var u = intAt(e, a);u < 0 ? "-" == e.charAt(a) && 0 == this.signum() && (i = !0) : (s = t * s + u, ++o >= r && (this.dMultiply(n), this.dAddOffset(s, 0), o = 0, s = 0));
        }o > 0 && (this.dMultiply(Math.pow(t, o)), this.dAddOffset(s, 0)), i && BigInteger.ZERO.subTo(this, this);
      }, BigInteger.prototype.fromNumber = function bnpFromNumber(e, t, r) {
        if ("number" == typeof t) {
          if (e < 2) this.fromInt(1);else for (this.fromNumber(e, r), this.testBit(e - 1) || this.bitwiseTo(BigInteger.ONE.shiftLeft(e - 1), op_or, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(t);) {
            this.dAddOffset(2, 0), this.bitLength() > e && this.subTo(BigInteger.ONE.shiftLeft(e - 1), this);
          }
        } else {
          var n = new Array(),
              i = 7 & e;n.length = 1 + (e >> 3), t.nextBytes(n), i > 0 ? n[0] &= (1 << i) - 1 : n[0] = 0, this.fromString(n, 256);
        }
      }, BigInteger.prototype.bitwiseTo = function bnpBitwiseTo(e, t, r) {
        var n,
            i,
            o = Math.min(e.t, this.t);for (n = 0; n < o; ++n) {
          r[n] = t(this[n], e[n]);
        }if (e.t < this.t) {
          for (i = e.s & this.DM, n = o; n < this.t; ++n) {
            r[n] = t(this[n], i);
          }r.t = this.t;
        } else {
          for (i = this.s & this.DM, n = o; n < e.t; ++n) {
            r[n] = t(i, e[n]);
          }r.t = e.t;
        }r.s = t(this.s, e.s), r.clamp();
      }, BigInteger.prototype.changeBit = function bnpChangeBit(e, t) {
        var r = BigInteger.ONE.shiftLeft(e);return this.bitwiseTo(r, t, r), r;
      }, BigInteger.prototype.addTo = function bnpAddTo(e, t) {
        for (var r = 0, n = 0, i = Math.min(e.t, this.t); r < i;) {
          n += this[r] + e[r], t[r++] = n & this.DM, n >>= this.DB;
        }if (e.t < this.t) {
          for (n += e.s; r < this.t;) {
            n += this[r], t[r++] = n & this.DM, n >>= this.DB;
          }n += this.s;
        } else {
          for (n += this.s; r < e.t;) {
            n += e[r], t[r++] = n & this.DM, n >>= this.DB;
          }n += e.s;
        }t.s = n < 0 ? -1 : 0, n > 0 ? t[r++] = n : n < -1 && (t[r++] = this.DV + n), t.t = r, t.clamp();
      }, BigInteger.prototype.dMultiply = function bnpDMultiply(e) {
        this[this.t] = this.am(0, e - 1, this, 0, 0, this.t), ++this.t, this.clamp();
      }, BigInteger.prototype.dAddOffset = function bnpDAddOffset(e, t) {
        if (0 != e) {
          for (; this.t <= t;) {
            this[this.t++] = 0;
          }for (this[t] += e; this[t] >= this.DV;) {
            this[t] -= this.DV, ++t >= this.t && (this[this.t++] = 0), ++this[t];
          }
        }
      }, BigInteger.prototype.multiplyLowerTo = function bnpMultiplyLowerTo(e, t, r) {
        var n,
            i = Math.min(this.t + e.t, t);for (r.s = 0, r.t = i; i > 0;) {
          r[--i] = 0;
        }for (n = r.t - this.t; i < n; ++i) {
          r[i + this.t] = this.am(0, e[i], r, i, 0, this.t);
        }for (n = Math.min(e.t, t); i < n; ++i) {
          this.am(0, e[i], r, i, 0, t - i);
        }r.clamp();
      }, BigInteger.prototype.multiplyUpperTo = function bnpMultiplyUpperTo(e, t, r) {
        --t;var n = r.t = this.t + e.t - t;for (r.s = 0; --n >= 0;) {
          r[n] = 0;
        }for (n = Math.max(t - this.t, 0); n < e.t; ++n) {
          r[this.t + n - t] = this.am(t - n, e[n], r, 0, 0, this.t + n - t);
        }r.clamp(), r.drShiftTo(1, r);
      }, BigInteger.prototype.modInt = function bnpModInt(e) {
        if (e <= 0) return 0;var t = this.DV % e,
            r = this.s < 0 ? e - 1 : 0;if (this.t > 0) if (0 == t) r = this[0] % e;else for (var n = this.t - 1; n >= 0; --n) {
          r = (t * r + this[n]) % e;
        }return r;
      }, BigInteger.prototype.millerRabin = function bnpMillerRabin(e) {
        var t = this.subtract(BigInteger.ONE),
            r = t.getLowestSetBit();if (r <= 0) return !1;var n = t.shiftRight(r);(e = e + 1 >> 1) > I.length && (e = I.length);for (var i = nbi(), o = 0; o < e; ++o) {
          i.fromInt(I[Math.floor(Math.random() * I.length)]);var s = i.modPow(n, this);if (0 != s.compareTo(BigInteger.ONE) && 0 != s.compareTo(t)) {
            for (var a = 1; a++ < r && 0 != s.compareTo(t);) {
              if (0 == (s = s.modPowInt(2, this)).compareTo(BigInteger.ONE)) return !1;
            }if (0 != s.compareTo(t)) return !1;
          }
        }return !0;
      }, BigInteger.prototype.clone =
      /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
       */
      function bnClone() {
        var e = nbi();return this.copyTo(e), e;
      }, BigInteger.prototype.intValue = function bnIntValue() {
        if (this.s < 0) {
          if (1 == this.t) return this[0] - this.DV;if (0 == this.t) return -1;
        } else {
          if (1 == this.t) return this[0];if (0 == this.t) return 0;
        }return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
      }, BigInteger.prototype.byteValue = function bnByteValue() {
        return 0 == this.t ? this.s : this[0] << 24 >> 24;
      }, BigInteger.prototype.shortValue = function bnShortValue() {
        return 0 == this.t ? this.s : this[0] << 16 >> 16;
      }, BigInteger.prototype.signum = function bnSigNum() {
        return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this[0] <= 0 ? 0 : 1;
      }, BigInteger.prototype.toByteArray = function bnToByteArray() {
        var e = this.t,
            t = new Array();t[0] = this.s;var r,
            n = this.DB - e * this.DB % 8,
            i = 0;if (e-- > 0) for (n < this.DB && (r = this[e] >> n) != (this.s & this.DM) >> n && (t[i++] = r | this.s << this.DB - n); e >= 0;) {
          n < 8 ? (r = (this[e] & (1 << n) - 1) << 8 - n, r |= this[--e] >> (n += this.DB - 8)) : (r = this[e] >> (n -= 8) & 255, n <= 0 && (n += this.DB, --e)), 0 != (128 & r) && (r |= -256), 0 == i && (128 & this.s) != (128 & r) && ++i, (i > 0 || r != this.s) && (t[i++] = r);
        }return t;
      }, BigInteger.prototype.equals = function bnEquals(e) {
        return 0 == this.compareTo(e);
      }, BigInteger.prototype.min = function bnMin(e) {
        return this.compareTo(e) < 0 ? this : e;
      }, BigInteger.prototype.max = function bnMax(e) {
        return this.compareTo(e) > 0 ? this : e;
      }, BigInteger.prototype.and = function bnAnd(e) {
        var t = nbi();return this.bitwiseTo(e, op_and, t), t;
      }, BigInteger.prototype.or = function bnOr(e) {
        var t = nbi();return this.bitwiseTo(e, op_or, t), t;
      }, BigInteger.prototype.xor = function bnXor(e) {
        var t = nbi();return this.bitwiseTo(e, op_xor, t), t;
      }, BigInteger.prototype.andNot = function bnAndNot(e) {
        var t = nbi();return this.bitwiseTo(e, op_andnot, t), t;
      }, BigInteger.prototype.not = function bnNot() {
        for (var e = nbi(), t = 0; t < this.t; ++t) {
          e[t] = this.DM & ~this[t];
        }return e.t = this.t, e.s = ~this.s, e;
      }, BigInteger.prototype.shiftLeft = function bnShiftLeft(e) {
        var t = nbi();return e < 0 ? this.rShiftTo(-e, t) : this.lShiftTo(e, t), t;
      }, BigInteger.prototype.shiftRight = function bnShiftRight(e) {
        var t = nbi();return e < 0 ? this.lShiftTo(-e, t) : this.rShiftTo(e, t), t;
      }, BigInteger.prototype.getLowestSetBit = function bnGetLowestSetBit() {
        for (var e = 0; e < this.t; ++e) {
          if (0 != this[e]) return e * this.DB + lbit(this[e]);
        }return this.s < 0 ? this.t * this.DB : -1;
      }, BigInteger.prototype.bitCount = function bnBitCount() {
        for (var e = 0, t = this.s & this.DM, r = 0; r < this.t; ++r) {
          e += cbit(this[r] ^ t);
        }return e;
      }, BigInteger.prototype.testBit = function bnTestBit(e) {
        var t = Math.floor(e / this.DB);return t >= this.t ? 0 != this.s : 0 != (this[t] & 1 << e % this.DB);
      }, BigInteger.prototype.setBit = function bnSetBit(e) {
        return this.changeBit(e, op_or);
      }, BigInteger.prototype.clearBit = function bnClearBit(e) {
        return this.changeBit(e, op_andnot);
      }, BigInteger.prototype.flipBit = function bnFlipBit(e) {
        return this.changeBit(e, op_xor);
      }, BigInteger.prototype.add = function bnAdd(e) {
        var t = nbi();return this.addTo(e, t), t;
      }, BigInteger.prototype.subtract = function bnSubtract(e) {
        var t = nbi();return this.subTo(e, t), t;
      }, BigInteger.prototype.multiply = function bnMultiply(e) {
        var t = nbi();return this.multiplyTo(e, t), t;
      }, BigInteger.prototype.divide = function bnDivide(e) {
        var t = nbi();return this.divRemTo(e, t, null), t;
      }, BigInteger.prototype.remainder = function bnRemainder(e) {
        var t = nbi();return this.divRemTo(e, null, t), t;
      }, BigInteger.prototype.divideAndRemainder = function bnDivideAndRemainder(e) {
        var t = nbi(),
            r = nbi();return this.divRemTo(e, t, r), new Array(t, r);
      }, BigInteger.prototype.modPow = function bnModPow(e, t) {
        var r,
            n,
            i = e.bitLength(),
            o = nbv(1);if (i <= 0) return o;r = i < 18 ? 1 : i < 48 ? 3 : i < 144 ? 4 : i < 768 ? 5 : 6, n = i < 8 ? new Classic(t) : t.isEven() ? new Barrett(t) : new Montgomery(t);var s = new Array(),
            a = 3,
            u = r - 1,
            c = (1 << r) - 1;if (s[1] = n.convert(this), r > 1) {
          var h = nbi();for (n.sqrTo(s[1], h); a <= c;) {
            s[a] = nbi(), n.mulTo(h, s[a - 2], s[a]), a += 2;
          }
        }var f,
            l,
            g = e.t - 1,
            p = !0,
            d = nbi();for (i = nbits(e[g]) - 1; g >= 0;) {
          for (i >= u ? f = e[g] >> i - u & c : (f = (e[g] & (1 << i + 1) - 1) << u - i, g > 0 && (f |= e[g - 1] >> this.DB + i - u)), a = r; 0 == (1 & f);) {
            f >>= 1, --a;
          }if ((i -= a) < 0 && (i += this.DB, --g), p) s[f].copyTo(o), p = !1;else {
            for (; a > 1;) {
              n.sqrTo(o, d), n.sqrTo(d, o), a -= 2;
            }a > 0 ? n.sqrTo(o, d) : (l = o, o = d, d = l), n.mulTo(d, s[f], o);
          }for (; g >= 0 && 0 == (e[g] & 1 << i);) {
            n.sqrTo(o, d), l = o, o = d, d = l, --i < 0 && (i = this.DB - 1, --g);
          }
        }return n.revert(o);
      }, BigInteger.prototype.modInverse = function bnModInverse(e) {
        var t = e.isEven();if (this.isEven() && t || 0 == e.signum()) return BigInteger.ZERO;for (var r = e.clone(), n = this.clone(), i = nbv(1), o = nbv(0), s = nbv(0), a = nbv(1); 0 != r.signum();) {
          for (; r.isEven();) {
            r.rShiftTo(1, r), t ? (i.isEven() && o.isEven() || (i.addTo(this, i), o.subTo(e, o)), i.rShiftTo(1, i)) : o.isEven() || o.subTo(e, o), o.rShiftTo(1, o);
          }for (; n.isEven();) {
            n.rShiftTo(1, n), t ? (s.isEven() && a.isEven() || (s.addTo(this, s), a.subTo(e, a)), s.rShiftTo(1, s)) : a.isEven() || a.subTo(e, a), a.rShiftTo(1, a);
          }r.compareTo(n) >= 0 ? (r.subTo(n, r), t && i.subTo(s, i), o.subTo(a, o)) : (n.subTo(r, n), t && s.subTo(i, s), a.subTo(o, a));
        }return 0 != n.compareTo(BigInteger.ONE) ? BigInteger.ZERO : a.compareTo(e) >= 0 ? a.subtract(e) : a.signum() < 0 ? (a.addTo(e, a), a.signum() < 0 ? a.add(e) : a) : a;
      }, BigInteger.prototype.pow = function bnPow(e) {
        return this.exp(e, new NullExp());
      }, BigInteger.prototype.gcd = function bnGCD(e) {
        var t = this.s < 0 ? this.negate() : this.clone(),
            r = e.s < 0 ? e.negate() : e.clone();if (t.compareTo(r) < 0) {
          var n = t;t = r, r = n;
        }var i = t.getLowestSetBit(),
            o = r.getLowestSetBit();if (o < 0) return t;for (i < o && (o = i), o > 0 && (t.rShiftTo(o, t), r.rShiftTo(o, r)); t.signum() > 0;) {
          (i = t.getLowestSetBit()) > 0 && t.rShiftTo(i, t), (i = r.getLowestSetBit()) > 0 && r.rShiftTo(i, r), t.compareTo(r) >= 0 ? (t.subTo(r, t), t.rShiftTo(1, t)) : (r.subTo(t, r), r.rShiftTo(1, r));
        }return o > 0 && r.lShiftTo(o, r), r;
      }, BigInteger.prototype.isProbablePrime = function bnIsProbablePrime(e) {
        var t,
            r = this.abs();if (1 == r.t && r[0] <= I[I.length - 1]) {
          for (t = 0; t < I.length; ++t) {
            if (r[0] == I[t]) return !0;
          }return !1;
        }if (r.isEven()) return !1;for (t = 1; t < I.length;) {
          for (var n = I[t], i = t + 1; i < I.length && n < R;) {
            n *= I[i++];
          }for (n = r.modInt(n); t < i;) {
            if (n % I[t++] == 0) return !1;
          }
        }return r.millerRabin(e);
      }, BigInteger.prototype.square = function bnSquare() {
        var e = nbi();return this.squareTo(e), e;
      }, Arcfour.prototype.init = function ARC4init(e) {
        var t, r, n;for (t = 0; t < 256; ++t) {
          this.S[t] = t;
        }for (r = 0, t = 0; t < 256; ++t) {
          r = r + this.S[t] + e[t % e.length] & 255, n = this.S[t], this.S[t] = this.S[r], this.S[r] = n;
        }this.i = 0, this.j = 0;
      }, Arcfour.prototype.next = function ARC4next() {
        var e;return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, e = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = e, this.S[e + this.S[this.i] & 255];
      };var T,
          U,
          M,
          L = 256;
      /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
       */function rng_seed_time() {
        !function rng_seed_int(e) {
          U[M++] ^= 255 & e, U[M++] ^= e >> 8 & 255, U[M++] ^= e >> 16 & 255, U[M++] ^= e >> 24 & 255, M >= L && (M -= L);
        }(new Date().getTime());
      }if (null == U) {
        var D;if (U = new Array(), M = 0, void 0 !== p && (void 0 !== p.crypto || void 0 !== p.msCrypto)) {
          var N = p.crypto || p.msCrypto;if (N.getRandomValues) {
            var O = new Uint8Array(32);for (N.getRandomValues(O), D = 0; D < 32; ++D) {
              U[M++] = O[D];
            }
          } else if ("Netscape" == u.appName && u.appVersion < "5") {
            var H = p.crypto.random(32);for (D = 0; D < H.length; ++D) {
              U[M++] = 255 & H.charCodeAt(D);
            }
          }
        }for (; M < L;) {
          D = Math.floor(65536 * Math.random()), U[M++] = D >>> 8, U[M++] = 255 & D;
        }M = 0, rng_seed_time();
      }function rng_get_byte() {
        if (null == T) {
          for (rng_seed_time(), (T = function prng_newstate() {
            return new Arcfour();
          }()).init(U), M = 0; M < U.length; ++M) {
            U[M] = 0;
          }M = 0;
        }return T.next();
      }function SecureRandom() {}
      /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
       */
      function parseBigInt(e, t) {
        return new BigInteger(e, t);
      }function oaep_mgf1_arr(e, t, r) {
        for (var n = "", i = 0; n.length < t;) {
          n += r(String.fromCharCode.apply(String, e.concat([(4278190080 & i) >> 24, (16711680 & i) >> 16, (65280 & i) >> 8, 255 & i]))), i += 1;
        }return n;
      }function RSAKey() {
        this.n = null, this.e = 0, this.d = null, this.p = null, this.q = null, this.dmp1 = null, this.dmq1 = null, this.coeff = null;
      }
      /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
       */
      function ECFieldElementFp(e, t) {
        this.x = t, this.q = e;
      }function ECPointFp(e, t, r, n) {
        this.curve = e, this.x = t, this.y = r, this.z = null == n ? BigInteger.ONE : n, this.zinv = null;
      }function ECCurveFp(e, t, r) {
        this.q = e, this.a = this.fromBigInteger(t), this.b = this.fromBigInteger(r), this.infinity = new ECPointFp(this, null, null);
      }SecureRandom.prototype.nextBytes = function rng_get_bytes(e) {
        var t;for (t = 0; t < e.length; ++t) {
          e[t] = rng_get_byte();
        }
      }, RSAKey.prototype.doPublic = function RSADoPublic(e) {
        return e.modPowInt(this.e, this.n);
      }, RSAKey.prototype.setPublic = function RSASetPublic(e, t) {
        if (this.isPublic = !0, this.isPrivate = !1, "string" != typeof e) this.n = e, this.e = t;else {
          if (!(null != e && null != t && e.length > 0 && t.length > 0)) throw "Invalid RSA public key";this.n = parseBigInt(e, 16), this.e = parseInt(t, 16);
        }
      }, RSAKey.prototype.encrypt = function RSAEncrypt(e) {
        var t = function pkcs1pad2(e, t) {
          if (t < e.length + 11) throw "Message too long for RSA";for (var r = new Array(), n = e.length - 1; n >= 0 && t > 0;) {
            var i = e.charCodeAt(n--);i < 128 ? r[--t] = i : i > 127 && i < 2048 ? (r[--t] = 63 & i | 128, r[--t] = i >> 6 | 192) : (r[--t] = 63 & i | 128, r[--t] = i >> 6 & 63 | 128, r[--t] = i >> 12 | 224);
          }r[--t] = 0;for (var o = new SecureRandom(), s = new Array(); t > 2;) {
            for (s[0] = 0; 0 == s[0];) {
              o.nextBytes(s);
            }r[--t] = s[0];
          }return r[--t] = 2, r[--t] = 0, new BigInteger(r);
        }(e, this.n.bitLength() + 7 >> 3);if (null == t) return null;var r = this.doPublic(t);if (null == r) return null;var n = r.toString(16);return 0 == (1 & n.length) ? n : "0" + n;
      }, RSAKey.prototype.encryptOAEP = function RSAEncryptOAEP(e, t, r) {
        var n = function oaep_pad(e, t, r, n) {
          var i = K.crypto.MessageDigest,
              o = K.crypto.Util,
              s = null;if (r || (r = "sha1"), "string" == typeof r && (s = i.getCanonicalAlgName(r), n = i.getHashLength(s), r = function f(e) {
            return hextorstr(o.hashHex(rstrtohex(e), s));
          }), e.length + 2 * n + 2 > t) throw "Message too long for RSA";var a,
              u = "";for (a = 0; a < t - e.length - 2 * n - 2; a += 1) {
            u += "\0";
          }var c = r("") + u + "" + e,
              h = new Array(n);new SecureRandom().nextBytes(h);var l = oaep_mgf1_arr(h, c.length, r),
              g = [];for (a = 0; a < c.length; a += 1) {
            g[a] = c.charCodeAt(a) ^ l.charCodeAt(a);
          }var p = oaep_mgf1_arr(g, h.length, r),
              d = [0];for (a = 0; a < h.length; a += 1) {
            d[a + 1] = h[a] ^ p.charCodeAt(a);
          }return new BigInteger(d.concat(g));
        }(e, this.n.bitLength() + 7 >> 3, t, r);if (null == n) return null;var i = this.doPublic(n);if (null == i) return null;var o = i.toString(16);return 0 == (1 & o.length) ? o : "0" + o;
      }, RSAKey.prototype.type = "RSA", ECFieldElementFp.prototype.equals = function feFpEquals(e) {
        return e == this || this.q.equals(e.q) && this.x.equals(e.x);
      }, ECFieldElementFp.prototype.toBigInteger = function feFpToBigInteger() {
        return this.x;
      }, ECFieldElementFp.prototype.negate = function feFpNegate() {
        return new ECFieldElementFp(this.q, this.x.negate().mod(this.q));
      }, ECFieldElementFp.prototype.add = function feFpAdd(e) {
        return new ECFieldElementFp(this.q, this.x.add(e.toBigInteger()).mod(this.q));
      }, ECFieldElementFp.prototype.subtract = function feFpSubtract(e) {
        return new ECFieldElementFp(this.q, this.x.subtract(e.toBigInteger()).mod(this.q));
      }, ECFieldElementFp.prototype.multiply = function feFpMultiply(e) {
        return new ECFieldElementFp(this.q, this.x.multiply(e.toBigInteger()).mod(this.q));
      }, ECFieldElementFp.prototype.square = function feFpSquare() {
        return new ECFieldElementFp(this.q, this.x.square().mod(this.q));
      }, ECFieldElementFp.prototype.divide = function feFpDivide(e) {
        return new ECFieldElementFp(this.q, this.x.multiply(e.toBigInteger().modInverse(this.q)).mod(this.q));
      }, ECPointFp.prototype.getX = function pointFpGetX() {
        return null == this.zinv && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q));
      }, ECPointFp.prototype.getY = function pointFpGetY() {
        return null == this.zinv && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q));
      }, ECPointFp.prototype.equals = function pointFpEquals(e) {
        return e == this || (this.isInfinity() ? e.isInfinity() : e.isInfinity() ? this.isInfinity() : !!e.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(e.z)).mod(this.curve.q).equals(BigInteger.ZERO) && e.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(e.z)).mod(this.curve.q).equals(BigInteger.ZERO));
      }, ECPointFp.prototype.isInfinity = function pointFpIsInfinity() {
        return null == this.x && null == this.y || this.z.equals(BigInteger.ZERO) && !this.y.toBigInteger().equals(BigInteger.ZERO);
      }, ECPointFp.prototype.negate = function pointFpNegate() {
        return new ECPointFp(this.curve, this.x, this.y.negate(), this.z);
      }, ECPointFp.prototype.add = function pointFpAdd(e) {
        if (this.isInfinity()) return e;if (e.isInfinity()) return this;var t = e.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(e.z)).mod(this.curve.q),
            r = e.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(e.z)).mod(this.curve.q);if (BigInteger.ZERO.equals(r)) return BigInteger.ZERO.equals(t) ? this.twice() : this.curve.getInfinity();var n = new BigInteger("3"),
            i = this.x.toBigInteger(),
            o = this.y.toBigInteger(),
            s = (e.x.toBigInteger(), e.y.toBigInteger(), r.square()),
            a = s.multiply(r),
            u = i.multiply(s),
            c = t.square().multiply(this.z),
            h = c.subtract(u.shiftLeft(1)).multiply(e.z).subtract(a).multiply(r).mod(this.curve.q),
            f = u.multiply(n).multiply(t).subtract(o.multiply(a)).subtract(c.multiply(t)).multiply(e.z).add(t.multiply(a)).mod(this.curve.q),
            l = a.multiply(this.z).multiply(e.z).mod(this.curve.q);return new ECPointFp(this.curve, this.curve.fromBigInteger(h), this.curve.fromBigInteger(f), l);
      }, ECPointFp.prototype.twice = function pointFpTwice() {
        if (this.isInfinity()) return this;if (0 == this.y.toBigInteger().signum()) return this.curve.getInfinity();var e = new BigInteger("3"),
            t = this.x.toBigInteger(),
            r = this.y.toBigInteger(),
            n = r.multiply(this.z),
            i = n.multiply(r).mod(this.curve.q),
            o = this.curve.a.toBigInteger(),
            s = t.square().multiply(e);BigInteger.ZERO.equals(o) || (s = s.add(this.z.square().multiply(o)));var a = (s = s.mod(this.curve.q)).square().subtract(t.shiftLeft(3).multiply(i)).shiftLeft(1).multiply(n).mod(this.curve.q),
            u = s.multiply(e).multiply(t).subtract(i.shiftLeft(1)).shiftLeft(2).multiply(i).subtract(s.square().multiply(s)).mod(this.curve.q),
            c = n.square().multiply(n).shiftLeft(3).mod(this.curve.q);return new ECPointFp(this.curve, this.curve.fromBigInteger(a), this.curve.fromBigInteger(u), c);
      }, ECPointFp.prototype.multiply = function pointFpMultiply(e) {
        if (this.isInfinity()) return this;if (0 == e.signum()) return this.curve.getInfinity();var t,
            r = e,
            n = r.multiply(new BigInteger("3")),
            i = this.negate(),
            o = this;for (t = n.bitLength() - 2; t > 0; --t) {
          o = o.twice();var s = n.testBit(t);s != r.testBit(t) && (o = o.add(s ? this : i));
        }return o;
      }, ECPointFp.prototype.multiplyTwo = function pointFpMultiplyTwo(e, t, r) {
        var n;n = e.bitLength() > r.bitLength() ? e.bitLength() - 1 : r.bitLength() - 1;for (var i = this.curve.getInfinity(), o = this.add(t); n >= 0;) {
          i = i.twice(), e.testBit(n) ? i = r.testBit(n) ? i.add(o) : i.add(this) : r.testBit(n) && (i = i.add(t)), --n;
        }return i;
      }, ECCurveFp.prototype.getQ = function curveFpGetQ() {
        return this.q;
      }, ECCurveFp.prototype.getA = function curveFpGetA() {
        return this.a;
      }, ECCurveFp.prototype.getB = function curveFpGetB() {
        return this.b;
      }, ECCurveFp.prototype.equals = function curveFpEquals(e) {
        return e == this || this.q.equals(e.q) && this.a.equals(e.a) && this.b.equals(e.b);
      }, ECCurveFp.prototype.getInfinity = function curveFpGetInfinity() {
        return this.infinity;
      }, ECCurveFp.prototype.fromBigInteger = function curveFpFromBigInteger(e) {
        return new ECFieldElementFp(this.q, e);
      }, ECCurveFp.prototype.decodePointHex = function curveFpDecodePointHex(e) {
        switch (parseInt(e.substr(0, 2), 16)) {case 0:
            return this.infinity;case 2:case 3:
            return null;case 4:case 6:case 7:
            var t = (e.length - 2) / 2,
                r = e.substr(2, t),
                n = e.substr(t + 2, t);return new ECPointFp(this, this.fromBigInteger(new BigInteger(r, 16)), this.fromBigInteger(new BigInteger(n, 16)));default:
            return null;}
      };
      /*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
       */
      var K,
          q,
          W,
          V = function () {
        var e = new RegExp('(?:false|true|null|[\\{\\}\\[\\]]|(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)|(?:"(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))*"))', "g"),
            t = new RegExp("\\\\(?:([^u])|u(.{4}))", "g"),
            r = { '"': '"', "/": "/", "\\": "\\", b: "\b", f: "\f", n: "\n", r: "\r", t: "\t" };function h(e, t, n) {
          return t ? r[t] : String.fromCharCode(parseInt(n, 16));
        }var n = new String(""),
            o = (Object, Array, Object.hasOwnProperty);return function (r, a) {
          var u,
              c,
              f = r.match(e),
              l = f[0],
              g = !1;"{" === l ? u = {} : "[" === l ? u = [] : (u = [], g = !0);for (var p = [u], d = 1 - g, v = f.length; d < v; ++d) {
            var y;switch ((l = f[d]).charCodeAt(0)) {default:
                (y = p[0])[c || y.length] = +l, c = void 0;break;case 34:
                if (-1 !== (l = l.substring(1, l.length - 1)).indexOf("\\") && (l = l.replace(t, h)), y = p[0], !c) {
                  if (!(y instanceof Array)) {
                    c = l || n;break;
                  }c = y.length;
                }y[c] = l, c = void 0;break;case 91:
                y = p[0], p.unshift(y[c || y.length] = []), c = void 0;break;case 93:
                p.shift();break;case 102:
                (y = p[0])[c || y.length] = !1, c = void 0;break;case 110:
                (y = p[0])[c || y.length] = null, c = void 0;break;case 116:
                (y = p[0])[c || y.length] = !0, c = void 0;break;case 123:
                y = p[0], p.unshift(y[c || y.length] = {}), c = void 0;break;case 125:
                p.shift();}
          }if (g) {
            if (1 !== p.length) throw new Error();u = u[0];
          } else if (p.length) throw new Error();if (a) {
            u = function s(e, t) {
              var r = e[t];if (r && "object" === (void 0 === r ? "undefined" : i(r))) {
                var n = null;for (var u in r) {
                  if (o.call(r, u) && r !== e) {
                    var c = s(r, u);void 0 !== c ? r[u] = c : (n || (n = []), n.push(u));
                  }
                }if (n) for (var h = n.length; --h >= 0;) {
                  delete r[n[h]];
                }
              }return a.call(e, t, r);
            }({ "": u }, "");
          }return u;
        };
      }(),
          J = new function () {}();function stoBA(e) {
        for (var t = new Array(), r = 0; r < e.length; r++) {
          t[r] = e.charCodeAt(r);
        }return t;
      }function BAtos(e) {
        for (var t = "", r = 0; r < e.length; r++) {
          t += String.fromCharCode(e[r]);
        }return t;
      }function BAtohex(e) {
        for (var t = "", r = 0; r < e.length; r++) {
          var n = e[r].toString(16);1 == n.length && (n = "0" + n), t += n;
        }return t;
      }function stohex(e) {
        return BAtohex(stoBA(e));
      }function b64tob64u(e) {
        return e = (e = (e = e.replace(/\=/g, "")).replace(/\+/g, "-")).replace(/\//g, "_");
      }function b64utob64(e) {
        return e.length % 4 == 2 ? e += "==" : e.length % 4 == 3 && (e += "="), e = (e = e.replace(/-/g, "+")).replace(/_/g, "/");
      }function hextob64u(e) {
        return e.length % 2 == 1 && (e = "0" + e), b64tob64u(hex2b64(e));
      }function b64utohex(e) {
        return b64tohex(b64utob64(e));
      }function utf8tohex(e) {
        return uricmptohex(encodeURIComponentAll(e));
      }function hextoutf8(e) {
        return decodeURIComponent(hextouricmp(e));
      }function hextorstr(e) {
        for (var t = "", r = 0; r < e.length - 1; r += 2) {
          t += String.fromCharCode(parseInt(e.substr(r, 2), 16));
        }return t;
      }function rstrtohex(e) {
        for (var t = "", r = 0; r < e.length; r++) {
          t += ("0" + e.charCodeAt(r).toString(16)).slice(-2);
        }return t;
      }function hextob64(e) {
        return hex2b64(e);
      }function hextob64nl(e) {
        var t = hextob64(e).replace(/(.{64})/g, "$1\r\n");return t = t.replace(/\r\n$/, "");
      }function b64nltohex(e) {
        return b64tohex(e.replace(/[^0-9A-Za-z\/+=]*/g, ""));
      }function hextopem(e, t) {
        return "-----BEGIN " + t + "-----\r\n" + hextob64nl(e) + "\r\n-----END " + t + "-----\r\n";
      }function pemtohex(e, t) {
        if (-1 == e.indexOf("-----BEGIN ")) throw "can't find PEM header: " + t;return b64nltohex(e = void 0 !== t ? (e = e.replace("-----BEGIN " + t + "-----", "")).replace("-----END " + t + "-----", "") : (e = e.replace(/-----BEGIN [^-]+-----/, "")).replace(/-----END [^-]+-----/, ""));
      }function zulutomsec(e) {
        var t, r, n, i, o, s, a, u, c, h, f;if (f = e.match(/^(\d{2}|\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(|\.\d+)Z$/)) return u = f[1], t = parseInt(u), 2 === u.length && (50 <= t && t < 100 ? t = 1900 + t : 0 <= t && t < 50 && (t = 2e3 + t)), r = parseInt(f[2]) - 1, n = parseInt(f[3]), i = parseInt(f[4]), o = parseInt(f[5]), s = parseInt(f[6]), a = 0, "" !== (c = f[7]) && (h = (c.substr(1) + "00").substr(0, 3), a = parseInt(h)), Date.UTC(t, r, n, i, o, s, a);throw "unsupported zulu format: " + e;
      }function zulutosec(e) {
        return ~~(zulutomsec(e) / 1e3);
      }function uricmptohex(e) {
        return e.replace(/%/g, "");
      }function hextouricmp(e) {
        return e.replace(/(..)/g, "%$1");
      }function ipv6tohex(e) {
        var t = "malformed IPv6 address";if (!e.match(/^[0-9A-Fa-f:]+$/)) throw t;var r = (e = e.toLowerCase()).split(":").length - 1;if (r < 2) throw t;var n = ":".repeat(7 - r + 2),
            i = (e = e.replace("::", n)).split(":");if (8 != i.length) throw t;for (var o = 0; o < 8; o++) {
          i[o] = ("0000" + i[o]).slice(-4);
        }return i.join("");
      }function hextoipv6(e) {
        if (!e.match(/^[0-9A-Fa-f]{32}$/)) throw "malformed IPv6 address octet";for (var t = (e = e.toLowerCase()).match(/.{1,4}/g), r = 0; r < 8; r++) {
          t[r] = t[r].replace(/^0+/, ""), "" == t[r] && (t[r] = "0");
        }var n = (e = ":" + t.join(":") + ":").match(/:(0:){2,}/g);if (null === n) return e.slice(1, -1);var i = "";for (r = 0; r < n.length; r++) {
          n[r].length > i.length && (i = n[r]);
        }return (e = e.replace(i, "::")).slice(1, -1);
      }function hextoip(e) {
        var t = "malformed hex value";if (!e.match(/^([0-9A-Fa-f][0-9A-Fa-f]){1,}$/)) throw t;if (8 != e.length) return 32 == e.length ? hextoipv6(e) : e;try {
          return parseInt(e.substr(0, 2), 16) + "." + parseInt(e.substr(2, 2), 16) + "." + parseInt(e.substr(4, 2), 16) + "." + parseInt(e.substr(6, 2), 16);
        } catch (e) {
          throw t;
        }
      }function encodeURIComponentAll(e) {
        for (var t = encodeURIComponent(e), r = "", n = 0; n < t.length; n++) {
          "%" == t[n] ? (r += t.substr(n, 3), n += 2) : r = r + "%" + stohex(t[n]);
        }return r;
      }function hextoposhex(e) {
        return e.length % 2 == 1 ? "0" + e : e.substr(0, 1) > "7" ? "00" + e : e;
      }J.getLblen = function (e, t) {
        if ("8" != e.substr(t + 2, 1)) return 1;var r = parseInt(e.substr(t + 3, 1));return 0 == r ? -1 : 0 < r && r < 10 ? r + 1 : -2;
      }, J.getL = function (e, t) {
        var r = J.getLblen(e, t);return r < 1 ? "" : e.substr(t + 2, 2 * r);
      }, J.getVblen = function (e, t) {
        var r;return "" == (r = J.getL(e, t)) ? -1 : ("8" === r.substr(0, 1) ? new BigInteger(r.substr(2), 16) : new BigInteger(r, 16)).intValue();
      }, J.getVidx = function (e, t) {
        var r = J.getLblen(e, t);return r < 0 ? r : t + 2 * (r + 1);
      }, J.getV = function (e, t) {
        var r = J.getVidx(e, t),
            n = J.getVblen(e, t);return e.substr(r, 2 * n);
      }, J.getTLV = function (e, t) {
        return e.substr(t, 2) + J.getL(e, t) + J.getV(e, t);
      }, J.getNextSiblingIdx = function (e, t) {
        return J.getVidx(e, t) + 2 * J.getVblen(e, t);
      }, J.getChildIdx = function (e, t) {
        var r = J,
            n = new Array(),
            i = r.getVidx(e, t);"03" == e.substr(t, 2) ? n.push(i + 2) : n.push(i);for (var o = r.getVblen(e, t), s = i, a = 0;;) {
          var u = r.getNextSiblingIdx(e, s);if (null == u || u - i >= 2 * o) break;if (a >= 200) break;n.push(u), s = u, a++;
        }return n;
      }, J.getNthChildIdx = function (e, t, r) {
        return J.getChildIdx(e, t)[r];
      }, J.getIdxbyList = function (e, t, r, n) {
        var i,
            o,
            s = J;if (0 == r.length) {
          if (void 0 !== n && e.substr(t, 2) !== n) throw "checking tag doesn't match: " + e.substr(t, 2) + "!=" + n;return t;
        }return i = r.shift(), o = s.getChildIdx(e, t), s.getIdxbyList(e, o[i], r, n);
      }, J.getTLVbyList = function (e, t, r, n) {
        var i = J,
            o = i.getIdxbyList(e, t, r);if (void 0 === o) throw "can't find nthList object";if (void 0 !== n && e.substr(o, 2) != n) throw "checking tag doesn't match: " + e.substr(o, 2) + "!=" + n;return i.getTLV(e, o);
      }, J.getVbyList = function (e, t, r, n, i) {
        var o,
            s,
            a = J;if (void 0 === (o = a.getIdxbyList(e, t, r, n))) throw "can't find nthList object";return s = a.getV(e, o), !0 === i && (s = s.substr(2)), s;
      }, J.hextooidstr = function (e) {
        var t = function h(e, t) {
          return e.length >= t ? e : new Array(t - e.length + 1).join("0") + e;
        },
            r = [],
            n = e.substr(0, 2),
            i = parseInt(n, 16);r[0] = new String(Math.floor(i / 40)), r[1] = new String(i % 40);for (var o = e.substr(2), s = [], a = 0; a < o.length / 2; a++) {
          s.push(parseInt(o.substr(2 * a, 2), 16));
        }var u = [],
            c = "";for (a = 0; a < s.length; a++) {
          128 & s[a] ? c += t((127 & s[a]).toString(2), 7) : (c += t((127 & s[a]).toString(2), 7), u.push(new String(parseInt(c, 2))), c = "");
        }var h = r.join(".");return u.length > 0 && (h = h + "." + u.join(".")), h;
      }, J.dump = function (e, t, r, n) {
        var i = J,
            o = i.getV,
            s = i.dump,
            a = i.getChildIdx,
            u = e;e instanceof K.asn1.ASN1Object && (u = e.getEncodedHex());var c = function q(e, t) {
          return e.length <= 2 * t ? e : e.substr(0, t) + "..(total " + e.length / 2 + "bytes).." + e.substr(e.length - t, t);
        };void 0 === t && (t = { ommit_long_octet: 32 }), void 0 === r && (r = 0), void 0 === n && (n = "");var h = t.ommit_long_octet;if ("01" == u.substr(r, 2)) return "00" == (f = o(u, r)) ? n + "BOOLEAN FALSE\n" : n + "BOOLEAN TRUE\n";if ("02" == u.substr(r, 2)) return n + "INTEGER " + c(f = o(u, r), h) + "\n";if ("03" == u.substr(r, 2)) return n + "BITSTRING " + c(f = o(u, r), h) + "\n";if ("04" == u.substr(r, 2)) {
          var f = o(u, r);if (i.isASN1HEX(f)) {
            var l = n + "OCTETSTRING, encapsulates\n";return l += s(f, t, 0, n + "  ");
          }return n + "OCTETSTRING " + c(f, h) + "\n";
        }if ("05" == u.substr(r, 2)) return n + "NULL\n";if ("06" == u.substr(r, 2)) {
          var g = o(u, r),
              p = K.asn1.ASN1Util.oidHexToInt(g),
              d = K.asn1.x509.OID.oid2name(p),
              v = p.replace(/\./g, " ");return "" != d ? n + "ObjectIdentifier " + d + " (" + v + ")\n" : n + "ObjectIdentifier (" + v + ")\n";
        }if ("0c" == u.substr(r, 2)) return n + "UTF8String '" + hextoutf8(o(u, r)) + "'\n";if ("13" == u.substr(r, 2)) return n + "PrintableString '" + hextoutf8(o(u, r)) + "'\n";if ("14" == u.substr(r, 2)) return n + "TeletexString '" + hextoutf8(o(u, r)) + "'\n";if ("16" == u.substr(r, 2)) return n + "IA5String '" + hextoutf8(o(u, r)) + "'\n";if ("17" == u.substr(r, 2)) return n + "UTCTime " + hextoutf8(o(u, r)) + "\n";if ("18" == u.substr(r, 2)) return n + "GeneralizedTime " + hextoutf8(o(u, r)) + "\n";if ("30" == u.substr(r, 2)) {
          if ("3000" == u.substr(r, 4)) return n + "SEQUENCE {}\n";l = n + "SEQUENCE\n";var y = t;if ((2 == (F = a(u, r)).length || 3 == F.length) && "06" == u.substr(F[0], 2) && "04" == u.substr(F[F.length - 1], 2)) {
            d = i.oidname(o(u, F[0]));var m = JSON.parse(JSON.stringify(t));m.x509ExtName = d, y = m;
          }for (var S = 0; S < F.length; S++) {
            l += s(u, y, F[S], n + "  ");
          }return l;
        }if ("31" == u.substr(r, 2)) {
          l = n + "SET\n";var F = a(u, r);for (S = 0; S < F.length; S++) {
            l += s(u, t, F[S], n + "  ");
          }return l;
        }var b = parseInt(u.substr(r, 2), 16);if (0 != (128 & b)) {
          var _ = 31 & b;if (0 != (32 & b)) {
            var l = n + "[" + _ + "]\n";for (F = a(u, r), S = 0; S < F.length; S++) {
              l += s(u, t, F[S], n + "  ");
            }return l;
          }return "68747470" == (f = o(u, r)).substr(0, 8) && (f = hextoutf8(f)), "subjectAltName" === t.x509ExtName && 2 == _ && (f = hextoutf8(f)), l = n + "[" + _ + "] " + f + "\n";
        }return n + "UNKNOWN(" + u.substr(r, 2) + ") " + o(u, r) + "\n";
      }, J.isASN1HEX = function (e) {
        var t = J;if (e.length % 2 == 1) return !1;var r = t.getVblen(e, 0),
            n = e.substr(0, 2),
            i = t.getL(e, 0);return e.length - n.length - i.length == 2 * r;
      }, J.oidname = function (e) {
        var t = K.asn1;K.lang.String.isHex(e) && (e = t.ASN1Util.oidHexToInt(e));var r = t.x509.OID.oid2name(e);return "" === r && (r = e), r;
      }, void 0 !== K && K || (K = {}), void 0 !== K.lang && K.lang || (K.lang = {}), K.lang.String = function () {}, "function" == typeof n ? (q = function utf8tob64u(e) {
        return b64tob64u(new n(e, "utf8").toString("base64"));
      }, W = function b64utoutf8(e) {
        return new n(b64utob64(e), "base64").toString("utf8");
      }) : (q = function utf8tob64u(e) {
        return hextob64u(uricmptohex(encodeURIComponentAll(e)));
      }, W = function b64utoutf8(e) {
        return decodeURIComponent(hextouricmp(b64utohex(e)));
      }), K.lang.String.isInteger = function (e) {
        return !!e.match(/^[0-9]+$/) || !!e.match(/^-[0-9]+$/);
      }, K.lang.String.isHex = function (e) {
        return !(e.length % 2 != 0 || !e.match(/^[0-9a-f]+$/) && !e.match(/^[0-9A-F]+$/));
      }, K.lang.String.isBase64 = function (e) {
        return !(!(e = e.replace(/\s+/g, "")).match(/^[0-9A-Za-z+\/]+={0,3}$/) || e.length % 4 != 0);
      }, K.lang.String.isBase64URL = function (e) {
        return !e.match(/[+/=]/) && (e = b64utob64(e), K.lang.String.isBase64(e));
      }, K.lang.String.isIntegerArray = function (e) {
        return !!(e = e.replace(/\s+/g, "")).match(/^\[[0-9,]+\]$/);
      };void 0 !== K && K || (K = {}), void 0 !== K.crypto && K.crypto || (K.crypto = {}), K.crypto.Util = new function () {
        this.DIGESTINFOHEAD = { sha1: "3021300906052b0e03021a05000414", sha224: "302d300d06096086480165030402040500041c", sha256: "3031300d060960864801650304020105000420", sha384: "3041300d060960864801650304020205000430", sha512: "3051300d060960864801650304020305000440", md2: "3020300c06082a864886f70d020205000410", md5: "3020300c06082a864886f70d020505000410", ripemd160: "3021300906052b2403020105000414" }, this.DEFAULTPROVIDER = { md5: "cryptojs", sha1: "cryptojs", sha224: "cryptojs", sha256: "cryptojs", sha384: "cryptojs", sha512: "cryptojs", ripemd160: "cryptojs", hmacmd5: "cryptojs", hmacsha1: "cryptojs", hmacsha224: "cryptojs", hmacsha256: "cryptojs", hmacsha384: "cryptojs", hmacsha512: "cryptojs", hmacripemd160: "cryptojs", MD5withRSA: "cryptojs/jsrsa", SHA1withRSA: "cryptojs/jsrsa", SHA224withRSA: "cryptojs/jsrsa", SHA256withRSA: "cryptojs/jsrsa", SHA384withRSA: "cryptojs/jsrsa", SHA512withRSA: "cryptojs/jsrsa", RIPEMD160withRSA: "cryptojs/jsrsa", MD5withECDSA: "cryptojs/jsrsa", SHA1withECDSA: "cryptojs/jsrsa", SHA224withECDSA: "cryptojs/jsrsa", SHA256withECDSA: "cryptojs/jsrsa", SHA384withECDSA: "cryptojs/jsrsa", SHA512withECDSA: "cryptojs/jsrsa", RIPEMD160withECDSA: "cryptojs/jsrsa", SHA1withDSA: "cryptojs/jsrsa", SHA224withDSA: "cryptojs/jsrsa", SHA256withDSA: "cryptojs/jsrsa", MD5withRSAandMGF1: "cryptojs/jsrsa", SHA1withRSAandMGF1: "cryptojs/jsrsa", SHA224withRSAandMGF1: "cryptojs/jsrsa", SHA256withRSAandMGF1: "cryptojs/jsrsa", SHA384withRSAandMGF1: "cryptojs/jsrsa", SHA512withRSAandMGF1: "cryptojs/jsrsa", RIPEMD160withRSAandMGF1: "cryptojs/jsrsa" }, this.CRYPTOJSMESSAGEDIGESTNAME = { md5: y.algo.MD5, sha1: y.algo.SHA1, sha224: y.algo.SHA224, sha256: y.algo.SHA256, sha384: y.algo.SHA384, sha512: y.algo.SHA512, ripemd160: y.algo.RIPEMD160 }, this.getDigestInfoHex = function (e, t) {
          if (void 0 === this.DIGESTINFOHEAD[t]) throw "alg not supported in Util.DIGESTINFOHEAD: " + t;return this.DIGESTINFOHEAD[t] + e;
        }, this.getPaddedDigestInfoHex = function (e, t, r) {
          var n = this.getDigestInfoHex(e, t),
              i = r / 4;if (n.length + 22 > i) throw "key is too short for SigAlg: keylen=" + r + "," + t;for (var o = "0001", s = "00" + n, a = "", u = i - o.length - s.length, c = 0; c < u; c += 2) {
            a += "ff";
          }return o + a + s;
        }, this.hashString = function (e, t) {
          return new K.crypto.MessageDigest({ alg: t }).digestString(e);
        }, this.hashHex = function (e, t) {
          return new K.crypto.MessageDigest({ alg: t }).digestHex(e);
        }, this.sha1 = function (e) {
          return new K.crypto.MessageDigest({ alg: "sha1", prov: "cryptojs" }).digestString(e);
        }, this.sha256 = function (e) {
          return new K.crypto.MessageDigest({ alg: "sha256", prov: "cryptojs" }).digestString(e);
        }, this.sha256Hex = function (e) {
          return new K.crypto.MessageDigest({ alg: "sha256", prov: "cryptojs" }).digestHex(e);
        }, this.sha512 = function (e) {
          return new K.crypto.MessageDigest({ alg: "sha512", prov: "cryptojs" }).digestString(e);
        }, this.sha512Hex = function (e) {
          return new K.crypto.MessageDigest({ alg: "sha512", prov: "cryptojs" }).digestHex(e);
        };
      }(), K.crypto.Util.md5 = function (e) {
        return new K.crypto.MessageDigest({ alg: "md5", prov: "cryptojs" }).digestString(e);
      }, K.crypto.Util.ripemd160 = function (e) {
        return new K.crypto.MessageDigest({ alg: "ripemd160", prov: "cryptojs" }).digestString(e);
      }, K.crypto.Util.SECURERANDOMGEN = new SecureRandom(), K.crypto.Util.getRandomHexOfNbytes = function (e) {
        var t = new Array(e);return K.crypto.Util.SECURERANDOMGEN.nextBytes(t), BAtohex(t);
      }, K.crypto.Util.getRandomBigIntegerOfNbytes = function (e) {
        return new BigInteger(K.crypto.Util.getRandomHexOfNbytes(e), 16);
      }, K.crypto.Util.getRandomHexOfNbits = function (e) {
        var t = e % 8,
            r = new Array((e - t) / 8 + 1);return K.crypto.Util.SECURERANDOMGEN.nextBytes(r), r[0] = (255 << t & 255 ^ 255) & r[0], BAtohex(r);
      }, K.crypto.Util.getRandomBigIntegerOfNbits = function (e) {
        return new BigInteger(K.crypto.Util.getRandomHexOfNbits(e), 16);
      }, K.crypto.Util.getRandomBigIntegerZeroToMax = function (e) {
        for (var t = e.bitLength();;) {
          var r = K.crypto.Util.getRandomBigIntegerOfNbits(t);if (-1 != e.compareTo(r)) return r;
        }
      }, K.crypto.Util.getRandomBigIntegerMinToMax = function (e, t) {
        var r = e.compareTo(t);if (1 == r) throw "biMin is greater than biMax";if (0 == r) return e;var n = t.subtract(e);return K.crypto.Util.getRandomBigIntegerZeroToMax(n).add(e);
      }, K.crypto.MessageDigest = function (e) {
        this.setAlgAndProvider = function (e, t) {
          if (null !== (e = K.crypto.MessageDigest.getCanonicalAlgName(e)) && void 0 === t && (t = K.crypto.Util.DEFAULTPROVIDER[e]), -1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(e) && "cryptojs" == t) {
            try {
              this.md = K.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[e].create();
            } catch (t) {
              throw "setAlgAndProvider hash alg set fail alg=" + e + "/" + t;
            }this.updateString = function (e) {
              this.md.update(e);
            }, this.updateHex = function (e) {
              var t = y.enc.Hex.parse(e);this.md.update(t);
            }, this.digest = function () {
              return this.md.finalize().toString(y.enc.Hex);
            }, this.digestString = function (e) {
              return this.updateString(e), this.digest();
            }, this.digestHex = function (e) {
              return this.updateHex(e), this.digest();
            };
          }if (-1 != ":sha256:".indexOf(e) && "sjcl" == t) {
            try {
              this.md = new sjcl.hash.sha256();
            } catch (t) {
              throw "setAlgAndProvider hash alg set fail alg=" + e + "/" + t;
            }this.updateString = function (e) {
              this.md.update(e);
            }, this.updateHex = function (e) {
              var t = sjcl.codec.hex.toBits(e);this.md.update(t);
            }, this.digest = function () {
              var e = this.md.finalize();return sjcl.codec.hex.fromBits(e);
            }, this.digestString = function (e) {
              return this.updateString(e), this.digest();
            }, this.digestHex = function (e) {
              return this.updateHex(e), this.digest();
            };
          }
        }, this.updateString = function (e) {
          throw "updateString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
        }, this.updateHex = function (e) {
          throw "updateHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
        }, this.digest = function () {
          throw "digest() not supported for this alg/prov: " + this.algName + "/" + this.provName;
        }, this.digestString = function (e) {
          throw "digestString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
        }, this.digestHex = function (e) {
          throw "digestHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
        }, void 0 !== e && void 0 !== e.alg && (this.algName = e.alg, void 0 === e.prov && (this.provName = K.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName));
      }, K.crypto.MessageDigest.getCanonicalAlgName = function (e) {
        return "string" == typeof e && (e = (e = e.toLowerCase()).replace(/-/, "")), e;
      }, K.crypto.MessageDigest.getHashLength = function (e) {
        var t = K.crypto.MessageDigest,
            r = t.getCanonicalAlgName(e);if (void 0 === t.HASHLENGTH[r]) throw "not supported algorithm: " + e;return t.HASHLENGTH[r];
      }, K.crypto.MessageDigest.HASHLENGTH = { md5: 16, sha1: 20, sha224: 28, sha256: 32, sha384: 48, sha512: 64, ripemd160: 20 }, K.crypto.Mac = function (e) {
        this.setAlgAndProvider = function (e, t) {
          if (null == (e = e.toLowerCase()) && (e = "hmacsha1"), "hmac" != (e = e.toLowerCase()).substr(0, 4)) throw "setAlgAndProvider unsupported HMAC alg: " + e;void 0 === t && (t = K.crypto.Util.DEFAULTPROVIDER[e]), this.algProv = e + "/" + t;var r = e.substr(4);if (-1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(r) && "cryptojs" == t) {
            try {
              var n = K.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[r];this.mac = y.algo.HMAC.create(n, this.pass);
            } catch (e) {
              throw "setAlgAndProvider hash alg set fail hashAlg=" + r + "/" + e;
            }this.updateString = function (e) {
              this.mac.update(e);
            }, this.updateHex = function (e) {
              var t = y.enc.Hex.parse(e);this.mac.update(t);
            }, this.doFinal = function () {
              return this.mac.finalize().toString(y.enc.Hex);
            }, this.doFinalString = function (e) {
              return this.updateString(e), this.doFinal();
            }, this.doFinalHex = function (e) {
              return this.updateHex(e), this.doFinal();
            };
          }
        }, this.updateString = function (e) {
          throw "updateString(str) not supported for this alg/prov: " + this.algProv;
        }, this.updateHex = function (e) {
          throw "updateHex(hex) not supported for this alg/prov: " + this.algProv;
        }, this.doFinal = function () {
          throw "digest() not supported for this alg/prov: " + this.algProv;
        }, this.doFinalString = function (e) {
          throw "digestString(str) not supported for this alg/prov: " + this.algProv;
        }, this.doFinalHex = function (e) {
          throw "digestHex(hex) not supported for this alg/prov: " + this.algProv;
        }, this.setPassword = function (e) {
          if ("string" == typeof e) {
            var t = e;return e.length % 2 != 1 && e.match(/^[0-9A-Fa-f]+$/) || (t = rstrtohex(e)), void (this.pass = y.enc.Hex.parse(t));
          }if ("object" != (void 0 === e ? "undefined" : i(e))) throw "KJUR.crypto.Mac unsupported password type: " + e;t = null;if (void 0 !== e.hex) {
            if (e.hex.length % 2 != 0 || !e.hex.match(/^[0-9A-Fa-f]+$/)) throw "Mac: wrong hex password: " + e.hex;t = e.hex;
          }if (void 0 !== e.utf8 && (t = utf8tohex(e.utf8)), void 0 !== e.rstr && (t = rstrtohex(e.rstr)), void 0 !== e.b64 && (t = b64tohex(e.b64)), void 0 !== e.b64u && (t = b64utohex(e.b64u)), null == t) throw "KJUR.crypto.Mac unsupported password type: " + e;this.pass = y.enc.Hex.parse(t);
        }, void 0 !== e && (void 0 !== e.pass && this.setPassword(e.pass), void 0 !== e.alg && (this.algName = e.alg, void 0 === e.prov && (this.provName = K.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName)));
      }, K.crypto.Signature = function (e) {
        var t = null;if (this._setAlgNames = function () {
          var e = this.algName.match(/^(.+)with(.+)$/);e && (this.mdAlgName = e[1].toLowerCase(), this.pubkeyAlgName = e[2].toLowerCase());
        }, this._zeroPaddingOfSignature = function (e, t) {
          for (var r = "", n = t / 4 - e.length, i = 0; i < n; i++) {
            r += "0";
          }return r + e;
        }, this.setAlgAndProvider = function (e, t) {
          if (this._setAlgNames(), "cryptojs/jsrsa" != t) throw "provider not supported: " + t;if (-1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName)) {
            try {
              this.md = new K.crypto.MessageDigest({ alg: this.mdAlgName });
            } catch (e) {
              throw "setAlgAndProvider hash alg set fail alg=" + this.mdAlgName + "/" + e;
            }this.init = function (e, t) {
              var r = null;try {
                r = void 0 === t ? z.getKey(e) : z.getKey(e, t);
              } catch (e) {
                throw "init failed:" + e;
              }if (!0 === r.isPrivate) this.prvKey = r, this.state = "SIGN";else {
                if (!0 !== r.isPublic) throw "init failed.:" + r;this.pubKey = r, this.state = "VERIFY";
              }
            }, this.updateString = function (e) {
              this.md.updateString(e);
            }, this.updateHex = function (e) {
              this.md.updateHex(e);
            }, this.sign = function () {
              if (this.sHashHex = this.md.digest(), void 0 !== this.ecprvhex && void 0 !== this.eccurvename) {
                var e = new K.crypto.ECDSA({ curve: this.eccurvename });this.hSign = e.signHex(this.sHashHex, this.ecprvhex);
              } else if (this.prvKey instanceof RSAKey && "rsaandmgf1" === this.pubkeyAlgName) this.hSign = this.prvKey.signWithMessageHashPSS(this.sHashHex, this.mdAlgName, this.pssSaltLen);else if (this.prvKey instanceof RSAKey && "rsa" === this.pubkeyAlgName) this.hSign = this.prvKey.signWithMessageHash(this.sHashHex, this.mdAlgName);else if (this.prvKey instanceof K.crypto.ECDSA) this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);else {
                if (!(this.prvKey instanceof K.crypto.DSA)) throw "Signature: unsupported private key alg: " + this.pubkeyAlgName;this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
              }return this.hSign;
            }, this.signString = function (e) {
              return this.updateString(e), this.sign();
            }, this.signHex = function (e) {
              return this.updateHex(e), this.sign();
            }, this.verify = function (e) {
              if (this.sHashHex = this.md.digest(), void 0 !== this.ecpubhex && void 0 !== this.eccurvename) return new K.crypto.ECDSA({ curve: this.eccurvename }).verifyHex(this.sHashHex, e, this.ecpubhex);if (this.pubKey instanceof RSAKey && "rsaandmgf1" === this.pubkeyAlgName) return this.pubKey.verifyWithMessageHashPSS(this.sHashHex, e, this.mdAlgName, this.pssSaltLen);if (this.pubKey instanceof RSAKey && "rsa" === this.pubkeyAlgName) return this.pubKey.verifyWithMessageHash(this.sHashHex, e);if (void 0 !== K.crypto.ECDSA && this.pubKey instanceof K.crypto.ECDSA) return this.pubKey.verifyWithMessageHash(this.sHashHex, e);if (void 0 !== K.crypto.DSA && this.pubKey instanceof K.crypto.DSA) return this.pubKey.verifyWithMessageHash(this.sHashHex, e);throw "Signature: unsupported public key alg: " + this.pubkeyAlgName;
            };
          }
        }, this.init = function (e, t) {
          throw "init(key, pass) not supported for this alg:prov=" + this.algProvName;
        }, this.updateString = function (e) {
          throw "updateString(str) not supported for this alg:prov=" + this.algProvName;
        }, this.updateHex = function (e) {
          throw "updateHex(hex) not supported for this alg:prov=" + this.algProvName;
        }, this.sign = function () {
          throw "sign() not supported for this alg:prov=" + this.algProvName;
        }, this.signString = function (e) {
          throw "digestString(str) not supported for this alg:prov=" + this.algProvName;
        }, this.signHex = function (e) {
          throw "digestHex(hex) not supported for this alg:prov=" + this.algProvName;
        }, this.verify = function (e) {
          throw "verify(hSigVal) not supported for this alg:prov=" + this.algProvName;
        }, this.initParams = e, void 0 !== e && (void 0 !== e.alg && (this.algName = e.alg, void 0 === e.prov ? this.provName = K.crypto.Util.DEFAULTPROVIDER[this.algName] : this.provName = e.prov, this.algProvName = this.algName + ":" + this.provName, this.setAlgAndProvider(this.algName, this.provName), this._setAlgNames()), void 0 !== e.psssaltlen && (this.pssSaltLen = e.psssaltlen), void 0 !== e.prvkeypem)) {
          if (void 0 !== e.prvkeypas) throw "both prvkeypem and prvkeypas parameters not supported";try {
            t = z.getKey(e.prvkeypem);this.init(t);
          } catch (e) {
            throw "fatal error to load pem private key: " + e;
          }
        }
      }, K.crypto.Cipher = function (e) {}, K.crypto.Cipher.encrypt = function (e, t, r) {
        if (t instanceof RSAKey && t.isPublic) {
          var n = K.crypto.Cipher.getAlgByKeyAndName(t, r);if ("RSA" === n) return t.encrypt(e);if ("RSAOAEP" === n) return t.encryptOAEP(e, "sha1");var i = n.match(/^RSAOAEP(\d+)$/);if (null !== i) return t.encryptOAEP(e, "sha" + i[1]);throw "Cipher.encrypt: unsupported algorithm for RSAKey: " + r;
        }throw "Cipher.encrypt: unsupported key or algorithm";
      }, K.crypto.Cipher.decrypt = function (e, t, r) {
        if (t instanceof RSAKey && t.isPrivate) {
          var n = K.crypto.Cipher.getAlgByKeyAndName(t, r);if ("RSA" === n) return t.decrypt(e);if ("RSAOAEP" === n) return t.decryptOAEP(e, "sha1");var i = n.match(/^RSAOAEP(\d+)$/);if (null !== i) return t.decryptOAEP(e, "sha" + i[1]);throw "Cipher.decrypt: unsupported algorithm for RSAKey: " + r;
        }throw "Cipher.decrypt: unsupported key or algorithm";
      }, K.crypto.Cipher.getAlgByKeyAndName = function (e, t) {
        if (e instanceof RSAKey) {
          if (-1 != ":RSA:RSAOAEP:RSAOAEP224:RSAOAEP256:RSAOAEP384:RSAOAEP512:".indexOf(t)) return t;if (null === t || void 0 === t) return "RSA";throw "getAlgByKeyAndName: not supported algorithm name for RSAKey: " + t;
        }throw "getAlgByKeyAndName: not supported algorithm name: " + t;
      }, K.crypto.OID = new function () {
        this.oidhex2name = { "2a864886f70d010101": "rsaEncryption", "2a8648ce3d0201": "ecPublicKey", "2a8648ce380401": "dsa", "2a8648ce3d030107": "secp256r1", "2b8104001f": "secp192k1", "2b81040021": "secp224r1", "2b8104000a": "secp256k1", "2b81040023": "secp521r1", "2b81040022": "secp384r1", "2a8648ce380403": "SHA1withDSA", "608648016503040301": "SHA224withDSA", "608648016503040302": "SHA256withDSA" };
      }(), void 0 !== K && K || (K = {}), void 0 !== K.crypto && K.crypto || (K.crypto = {}), K.crypto.ECDSA = function (e) {
        var t = new SecureRandom();this.type = "EC", this.isPrivate = !1, this.isPublic = !1, this.getBigRandom = function (e) {
          return new BigInteger(e.bitLength(), t).mod(e.subtract(BigInteger.ONE)).add(BigInteger.ONE);
        }, this.setNamedCurve = function (e) {
          this.ecparams = K.crypto.ECParameterDB.getByName(e), this.prvKeyHex = null, this.pubKeyHex = null, this.curveName = e;
        }, this.setPrivateKeyHex = function (e) {
          this.isPrivate = !0, this.prvKeyHex = e;
        }, this.setPublicKeyHex = function (e) {
          this.isPublic = !0, this.pubKeyHex = e;
        }, this.getPublicKeyXYHex = function () {
          var e = this.pubKeyHex;if ("04" !== e.substr(0, 2)) throw "this method supports uncompressed format(04) only";var t = this.ecparams.keylen / 4;if (e.length !== 2 + 2 * t) throw "malformed public key hex length";var r = {};return r.x = e.substr(2, t), r.y = e.substr(2 + t), r;
        }, this.getShortNISTPCurveName = function () {
          var e = this.curveName;return "secp256r1" === e || "NIST P-256" === e || "P-256" === e || "prime256v1" === e ? "P-256" : "secp384r1" === e || "NIST P-384" === e || "P-384" === e ? "P-384" : null;
        }, this.generateKeyPairHex = function () {
          var e = this.ecparams.n,
              t = this.getBigRandom(e),
              r = this.ecparams.G.multiply(t),
              n = r.getX().toBigInteger(),
              i = r.getY().toBigInteger(),
              o = this.ecparams.keylen / 4,
              s = ("0000000000" + t.toString(16)).slice(-o),
              a = "04" + ("0000000000" + n.toString(16)).slice(-o) + ("0000000000" + i.toString(16)).slice(-o);return this.setPrivateKeyHex(s), this.setPublicKeyHex(a), { ecprvhex: s, ecpubhex: a };
        }, this.signWithMessageHash = function (e) {
          return this.signHex(e, this.prvKeyHex);
        }, this.signHex = function (e, t) {
          var r = new BigInteger(t, 16),
              n = this.ecparams.n,
              i = new BigInteger(e, 16);do {
            var o = this.getBigRandom(n),
                s = this.ecparams.G.multiply(o).getX().toBigInteger().mod(n);
          } while (s.compareTo(BigInteger.ZERO) <= 0);var a = o.modInverse(n).multiply(i.add(r.multiply(s))).mod(n);return K.crypto.ECDSA.biRSSigToASN1Sig(s, a);
        }, this.sign = function (e, t) {
          var r = t,
              n = this.ecparams.n,
              i = BigInteger.fromByteArrayUnsigned(e);do {
            var o = this.getBigRandom(n),
                s = this.ecparams.G.multiply(o).getX().toBigInteger().mod(n);
          } while (s.compareTo(BigInteger.ZERO) <= 0);var a = o.modInverse(n).multiply(i.add(r.multiply(s))).mod(n);return this.serializeSig(s, a);
        }, this.verifyWithMessageHash = function (e, t) {
          return this.verifyHex(e, t, this.pubKeyHex);
        }, this.verifyHex = function (e, t, r) {
          var n,
              i,
              o,
              s = K.crypto.ECDSA.parseSigHex(t);n = s.r, i = s.s, o = ECPointFp.decodeFromHex(this.ecparams.curve, r);var a = new BigInteger(e, 16);return this.verifyRaw(a, n, i, o);
        }, this.verify = function (e, t, r) {
          var n, o, s;if (Bitcoin.Util.isArray(t)) {
            var a = this.parseSig(t);n = a.r, o = a.s;
          } else {
            if ("object" !== (void 0 === t ? "undefined" : i(t)) || !t.r || !t.s) throw "Invalid value for signature";n = t.r, o = t.s;
          }if (r instanceof ECPointFp) s = r;else {
            if (!Bitcoin.Util.isArray(r)) throw "Invalid format for pubkey value, must be byte array or ECPointFp";s = ECPointFp.decodeFrom(this.ecparams.curve, r);
          }var u = BigInteger.fromByteArrayUnsigned(e);return this.verifyRaw(u, n, o, s);
        }, this.verifyRaw = function (e, t, r, n) {
          var i = this.ecparams.n,
              o = this.ecparams.G;if (t.compareTo(BigInteger.ONE) < 0 || t.compareTo(i) >= 0) return !1;if (r.compareTo(BigInteger.ONE) < 0 || r.compareTo(i) >= 0) return !1;var s = r.modInverse(i),
              a = e.multiply(s).mod(i),
              u = t.multiply(s).mod(i);return o.multiply(a).add(n.multiply(u)).getX().toBigInteger().mod(i).equals(t);
        }, this.serializeSig = function (e, t) {
          var r = e.toByteArraySigned(),
              n = t.toByteArraySigned(),
              i = [];return i.push(2), i.push(r.length), (i = i.concat(r)).push(2), i.push(n.length), (i = i.concat(n)).unshift(i.length), i.unshift(48), i;
        }, this.parseSig = function (e) {
          var t;if (48 != e[0]) throw new Error("Signature not a valid DERSequence");if (2 != e[t = 2]) throw new Error("First element in signature must be a DERInteger");var r = e.slice(t + 2, t + 2 + e[t + 1]);if (2 != e[t += 2 + e[t + 1]]) throw new Error("Second element in signature must be a DERInteger");var n = e.slice(t + 2, t + 2 + e[t + 1]);return t += 2 + e[t + 1], { r: BigInteger.fromByteArrayUnsigned(r), s: BigInteger.fromByteArrayUnsigned(n) };
        }, this.parseSigCompact = function (e) {
          if (65 !== e.length) throw "Signature has the wrong length";var t = e[0] - 27;if (t < 0 || t > 7) throw "Invalid signature type";var r = this.ecparams.n;return { r: BigInteger.fromByteArrayUnsigned(e.slice(1, 33)).mod(r), s: BigInteger.fromByteArrayUnsigned(e.slice(33, 65)).mod(r), i: t };
        }, this.readPKCS5PrvKeyHex = function (e) {
          var t,
              r,
              n,
              i = J,
              o = K.crypto.ECDSA.getName,
              s = i.getVbyList;if (!1 === i.isASN1HEX(e)) throw "not ASN.1 hex string";try {
            t = s(e, 0, [2, 0], "06"), r = s(e, 0, [1], "04");try {
              n = s(e, 0, [3, 0], "03").substr(2);
            } catch (e) {}
          } catch (e) {
            throw "malformed PKCS#1/5 plain ECC private key";
          }if (this.curveName = o(t), void 0 === this.curveName) throw "unsupported curve name";this.setNamedCurve(this.curveName), this.setPublicKeyHex(n), this.setPrivateKeyHex(r), this.isPublic = !1;
        }, this.readPKCS8PrvKeyHex = function (e) {
          var t,
              r,
              n,
              i = J,
              o = K.crypto.ECDSA.getName,
              s = i.getVbyList;if (!1 === i.isASN1HEX(e)) throw "not ASN.1 hex string";try {
            s(e, 0, [1, 0], "06"), t = s(e, 0, [1, 1], "06"), r = s(e, 0, [2, 0, 1], "04");try {
              n = s(e, 0, [2, 0, 2, 0], "03").substr(2);
            } catch (e) {}
          } catch (e) {
            throw "malformed PKCS#8 plain ECC private key";
          }if (this.curveName = o(t), void 0 === this.curveName) throw "unsupported curve name";this.setNamedCurve(this.curveName), this.setPublicKeyHex(n), this.setPrivateKeyHex(r), this.isPublic = !1;
        }, this.readPKCS8PubKeyHex = function (e) {
          var t,
              r,
              n = J,
              i = K.crypto.ECDSA.getName,
              o = n.getVbyList;if (!1 === n.isASN1HEX(e)) throw "not ASN.1 hex string";try {
            o(e, 0, [0, 0], "06"), t = o(e, 0, [0, 1], "06"), r = o(e, 0, [1], "03").substr(2);
          } catch (e) {
            throw "malformed PKCS#8 ECC public key";
          }if (this.curveName = i(t), null === this.curveName) throw "unsupported curve name";this.setNamedCurve(this.curveName), this.setPublicKeyHex(r);
        }, this.readCertPubKeyHex = function (e, t) {
          5 !== t && (t = 6);var r,
              n,
              i = J,
              o = K.crypto.ECDSA.getName,
              s = i.getVbyList;if (!1 === i.isASN1HEX(e)) throw "not ASN.1 hex string";try {
            r = s(e, 0, [0, t, 0, 1], "06"), n = s(e, 0, [0, t, 1], "03").substr(2);
          } catch (e) {
            throw "malformed X.509 certificate ECC public key";
          }if (this.curveName = o(r), null === this.curveName) throw "unsupported curve name";this.setNamedCurve(this.curveName), this.setPublicKeyHex(n);
        }, void 0 !== e && void 0 !== e.curve && (this.curveName = e.curve), void 0 === this.curveName && (this.curveName = "secp256r1"), this.setNamedCurve(this.curveName), void 0 !== e && (void 0 !== e.prv && this.setPrivateKeyHex(e.prv), void 0 !== e.pub && this.setPublicKeyHex(e.pub));
      }, K.crypto.ECDSA.parseSigHex = function (e) {
        var t = K.crypto.ECDSA.parseSigHexInHexRS(e);return { r: new BigInteger(t.r, 16), s: new BigInteger(t.s, 16) };
      }, K.crypto.ECDSA.parseSigHexInHexRS = function (e) {
        var t = J,
            r = t.getChildIdx,
            n = t.getV;if ("30" != e.substr(0, 2)) throw "signature is not a ASN.1 sequence";var i = r(e, 0);if (2 != i.length) throw "number of signature ASN.1 sequence elements seem wrong";var o = i[0],
            s = i[1];if ("02" != e.substr(o, 2)) throw "1st item of sequene of signature is not ASN.1 integer";if ("02" != e.substr(s, 2)) throw "2nd item of sequene of signature is not ASN.1 integer";return { r: n(e, o), s: n(e, s) };
      }, K.crypto.ECDSA.asn1SigToConcatSig = function (e) {
        var t = K.crypto.ECDSA.parseSigHexInHexRS(e),
            r = t.r,
            n = t.s;if ("00" == r.substr(0, 2) && r.length % 32 == 2 && (r = r.substr(2)), "00" == n.substr(0, 2) && n.length % 32 == 2 && (n = n.substr(2)), r.length % 32 == 30 && (r = "00" + r), n.length % 32 == 30 && (n = "00" + n), r.length % 32 != 0) throw "unknown ECDSA sig r length error";if (n.length % 32 != 0) throw "unknown ECDSA sig s length error";return r + n;
      }, K.crypto.ECDSA.concatSigToASN1Sig = function (e) {
        if (e.length / 2 * 8 % 128 != 0) throw "unknown ECDSA concatinated r-s sig  length error";var t = e.substr(0, e.length / 2),
            r = e.substr(e.length / 2);return K.crypto.ECDSA.hexRSSigToASN1Sig(t, r);
      }, K.crypto.ECDSA.hexRSSigToASN1Sig = function (e, t) {
        var r = new BigInteger(e, 16),
            n = new BigInteger(t, 16);return K.crypto.ECDSA.biRSSigToASN1Sig(r, n);
      }, K.crypto.ECDSA.biRSSigToASN1Sig = function (e, t) {
        var r = K.asn1,
            n = new r.DERInteger({ bigint: e }),
            i = new r.DERInteger({ bigint: t });return new r.DERSequence({ array: [n, i] }).getEncodedHex();
      }, K.crypto.ECDSA.getName = function (e) {
        return "2a8648ce3d030107" === e ? "secp256r1" : "2b8104000a" === e ? "secp256k1" : "2b81040022" === e ? "secp384r1" : -1 !== "|secp256r1|NIST P-256|P-256|prime256v1|".indexOf(e) ? "secp256r1" : -1 !== "|secp256k1|".indexOf(e) ? "secp256k1" : -1 !== "|secp384r1|NIST P-384|P-384|".indexOf(e) ? "secp384r1" : null;
      }, void 0 !== K && K || (K = {}), void 0 !== K.crypto && K.crypto || (K.crypto = {}), K.crypto.ECParameterDB = new function () {
        var e = {},
            t = {};function a(e) {
          return new BigInteger(e, 16);
        }this.getByName = function (r) {
          var n = r;if (void 0 !== t[n] && (n = t[r]), void 0 !== e[n]) return e[n];throw "unregistered EC curve name: " + n;
        }, this.regist = function (r, n, i, o, s, u, c, h, f, l, g, p) {
          e[r] = {};var d = a(i),
              v = a(o),
              y = a(s),
              m = a(u),
              S = a(c),
              F = new ECCurveFp(d, v, y),
              b = F.decodePointHex("04" + h + f);e[r].name = r, e[r].keylen = n, e[r].curve = F, e[r].G = b, e[r].n = m, e[r].h = S, e[r].oid = g, e[r].info = p;for (var _ = 0; _ < l.length; _++) {
            t[l[_]] = r;
          }
        };
      }(), K.crypto.ECParameterDB.regist("secp128r1", 128, "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC", "E87579C11079F43DD824993C2CEE5ED3", "FFFFFFFE0000000075A30D1B9038A115", "1", "161FF7528B899B2D0C28607CA52C5B86", "CF5AC8395BAFEB13C02DA292DDED7A83", [], "", "secp128r1 : SECG curve over a 128 bit prime field"), K.crypto.ECParameterDB.regist("secp160k1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73", "0", "7", "0100000000000000000001B8FA16DFAB9ACA16B6B3", "1", "3B4C382CE37AA192A4019E763036F4F5DD4D7EBB", "938CF935318FDCED6BC28286531733C3F03C4FEE", [], "", "secp160k1 : SECG curve over a 160 bit prime field"), K.crypto.ECParameterDB.regist("secp160r1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC", "1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45", "0100000000000000000001F4C8F927AED3CA752257", "1", "4A96B5688EF573284664698968C38BB913CBFC82", "23A628553168947D59DCC912042351377AC5FB32", [], "", "secp160r1 : SECG curve over a 160 bit prime field"), K.crypto.ECParameterDB.regist("secp192k1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37", "0", "3", "FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D", "1", "DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D", "9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D", []), K.crypto.ECParameterDB.regist("secp192r1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC", "64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1", "FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831", "1", "188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012", "07192B95FFC8DA78631011ED6B24CDD573F977A11E794811", []), K.crypto.ECParameterDB.regist("secp224r1", 224, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE", "B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4", "FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D", "1", "B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21", "BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34", []), K.crypto.ECParameterDB.regist("secp256k1", 256, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F", "0", "7", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "1", "79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798", "483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8", []), K.crypto.ECParameterDB.regist("secp256r1", 256, "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC", "5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B", "FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551", "1", "6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296", "4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5", ["NIST P-256", "P-256", "prime256v1"]), K.crypto.ECParameterDB.regist("secp384r1", 384, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC", "B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973", "1", "AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7", "3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f", ["NIST P-384", "P-384"]), K.crypto.ECParameterDB.regist("secp521r1", 521, "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC", "051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409", "1", "C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66", "011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650", ["NIST P-521", "P-521"]);var z = function () {
        var t = function d(e, t, n) {
          return r(y.AES, e, t, n);
        },
            r = function k(e, t, r, n) {
          var i = y.enc.Hex.parse(t),
              o = y.enc.Hex.parse(r),
              s = y.enc.Hex.parse(n),
              a = {};a.key = o, a.iv = s, a.ciphertext = i;var u = e.decrypt(a, o, { iv: s });return y.enc.Hex.stringify(u);
        },
            n = function l(e, t, r) {
          return i(y.AES, e, t, r);
        },
            i = function g(e, t, r, n) {
          var i = y.enc.Hex.parse(t),
              o = y.enc.Hex.parse(r),
              s = y.enc.Hex.parse(n),
              a = e.encrypt(i, o, { iv: s }),
              u = y.enc.Hex.parse(a.toString());return y.enc.Base64.stringify(u);
        },
            s = { "AES-256-CBC": { proc: t, eproc: n, keylen: 32, ivlen: 16 }, "AES-192-CBC": { proc: t, eproc: n, keylen: 24, ivlen: 16 }, "AES-128-CBC": { proc: t, eproc: n, keylen: 16, ivlen: 16 }, "DES-EDE3-CBC": { proc: function e(t, n, i) {
              return r(y.TripleDES, t, n, i);
            }, eproc: function o(e, t, r) {
              return i(y.TripleDES, e, t, r);
            }, keylen: 24, ivlen: 8 }, "DES-CBC": { proc: function a(e, t, n) {
              return r(y.DES, e, t, n);
            }, eproc: function f(e, t, r) {
              return i(y.DES, e, t, r);
            }, keylen: 8, ivlen: 8 } },
            u = function n(e) {
          var t = {},
              r = e.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)", "m"));r && (t.cipher = r[1], t.ivsalt = r[2]);var i = e.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"));i && (t.type = i[1]);var o = -1,
              s = 0;-1 != e.indexOf("\r\n\r\n") && (o = e.indexOf("\r\n\r\n"), s = 2), -1 != e.indexOf("\n\n") && (o = e.indexOf("\n\n"), s = 1);var a = e.indexOf("-----END");if (-1 != o && -1 != a) {
            var u = e.substring(o + 2 * s, a - s);u = u.replace(/\s+/g, ""), t.data = u;
          }return t;
        },
            c = function j(e, t, r) {
          for (var n = r.substring(0, 16), i = y.enc.Hex.parse(n), o = y.enc.Utf8.parse(t), a = s[e].keylen + s[e].ivlen, u = "", c = null;;) {
            var h = y.algo.MD5.create();if (null != c && h.update(c), h.update(o), h.update(i), c = h.finalize(), (u += y.enc.Hex.stringify(c)).length >= 2 * a) break;
          }var f = {};return f.keyhex = u.substr(0, 2 * s[e].keylen), f.ivhex = u.substr(2 * s[e].keylen, 2 * s[e].ivlen), f;
        },
            g = function b(e, t, r, n) {
          var i = y.enc.Base64.parse(e),
              o = y.enc.Hex.stringify(i);return (0, s[t].proc)(o, r, n);
        };return { version: "1.0.0", parsePKCS5PEM: function parsePKCS5PEM(e) {
            return u(e);
          }, getKeyAndUnusedIvByPasscodeAndIvsalt: function getKeyAndUnusedIvByPasscodeAndIvsalt(e, t, r) {
            return c(e, t, r);
          }, decryptKeyB64: function decryptKeyB64(e, t, r, n) {
            return g(e, t, r, n);
          }, getDecryptedKeyHex: function getDecryptedKeyHex(e, t) {
            var r = u(e),
                n = (r.type, r.cipher),
                i = r.ivsalt,
                o = r.data,
                s = c(n, t, i).keyhex;return g(o, n, s, i);
          }, getEncryptedPKCS5PEMFromPrvKeyHex: function getEncryptedPKCS5PEMFromPrvKeyHex(e, t, r, n, i) {
            var o = "";if (void 0 !== n && null != n || (n = "AES-256-CBC"), void 0 === s[n]) throw "KEYUTIL unsupported algorithm: " + n;void 0 !== i && null != i || (i = function m(e) {
              var t = y.lib.WordArray.random(e);return y.enc.Hex.stringify(t);
            }(s[n].ivlen).toUpperCase());var a = function h(e, t, r, n) {
              return (0, s[t].eproc)(e, r, n);
            }(t, n, c(n, r, i).keyhex, i);o = "-----BEGIN " + e + " PRIVATE KEY-----\r\n";return o += "Proc-Type: 4,ENCRYPTED\r\n", o += "DEK-Info: " + n + "," + i + "\r\n", o += "\r\n", o += a.replace(/(.{64})/g, "$1\r\n"), o += "\r\n-----END " + e + " PRIVATE KEY-----\r\n";
          }, parseHexOfEncryptedPKCS8: function parseHexOfEncryptedPKCS8(e) {
            var t = J,
                r = t.getChildIdx,
                n = t.getV,
                i = {},
                o = r(e, 0);if (2 != o.length) throw "malformed format: SEQUENCE(0).items != 2: " + o.length;i.ciphertext = n(e, o[1]);var s = r(e, o[0]);if (2 != s.length) throw "malformed format: SEQUENCE(0.0).items != 2: " + s.length;if ("2a864886f70d01050d" != n(e, s[0])) throw "this only supports pkcs5PBES2";var a = r(e, s[1]);if (2 != s.length) throw "malformed format: SEQUENCE(0.0.1).items != 2: " + a.length;var u = r(e, a[1]);if (2 != u.length) throw "malformed format: SEQUENCE(0.0.1.1).items != 2: " + u.length;if ("2a864886f70d0307" != n(e, u[0])) throw "this only supports TripleDES";i.encryptionSchemeAlg = "TripleDES", i.encryptionSchemeIV = n(e, u[1]);var c = r(e, a[0]);if (2 != c.length) throw "malformed format: SEQUENCE(0.0.1.0).items != 2: " + c.length;if ("2a864886f70d01050c" != n(e, c[0])) throw "this only supports pkcs5PBKDF2";var h = r(e, c[1]);if (h.length < 2) throw "malformed format: SEQUENCE(0.0.1.0.1).items < 2: " + h.length;i.pbkdf2Salt = n(e, h[0]);var f = n(e, h[1]);try {
              i.pbkdf2Iter = parseInt(f, 16);
            } catch (e) {
              throw "malformed format pbkdf2Iter: " + f;
            }return i;
          }, getPBKDF2KeyHexFromParam: function getPBKDF2KeyHexFromParam(e, t) {
            var r = y.enc.Hex.parse(e.pbkdf2Salt),
                n = e.pbkdf2Iter,
                i = y.PBKDF2(t, r, { keySize: 6, iterations: n });return y.enc.Hex.stringify(i);
          }, _getPlainPKCS8HexFromEncryptedPKCS8PEM: function _getPlainPKCS8HexFromEncryptedPKCS8PEM(e, t) {
            var r = pemtohex(e, "ENCRYPTED PRIVATE KEY"),
                n = this.parseHexOfEncryptedPKCS8(r),
                i = z.getPBKDF2KeyHexFromParam(n, t),
                o = {};o.ciphertext = y.enc.Hex.parse(n.ciphertext);var s = y.enc.Hex.parse(i),
                a = y.enc.Hex.parse(n.encryptionSchemeIV),
                u = y.TripleDES.decrypt(o, s, { iv: a });return y.enc.Hex.stringify(u);
          }, getKeyFromEncryptedPKCS8PEM: function getKeyFromEncryptedPKCS8PEM(e, t) {
            var r = this._getPlainPKCS8HexFromEncryptedPKCS8PEM(e, t);return this.getKeyFromPlainPrivatePKCS8Hex(r);
          }, parsePlainPrivatePKCS8Hex: function parsePlainPrivatePKCS8Hex(e) {
            var t = J,
                r = t.getChildIdx,
                n = t.getV,
                i = { algparam: null };if ("30" != e.substr(0, 2)) throw "malformed plain PKCS8 private key(code:001)";var o = r(e, 0);if (3 != o.length) throw "malformed plain PKCS8 private key(code:002)";if ("30" != e.substr(o[1], 2)) throw "malformed PKCS8 private key(code:003)";var s = r(e, o[1]);if (2 != s.length) throw "malformed PKCS8 private key(code:004)";if ("06" != e.substr(s[0], 2)) throw "malformed PKCS8 private key(code:005)";if (i.algoid = n(e, s[0]), "06" == e.substr(s[1], 2) && (i.algparam = n(e, s[1])), "04" != e.substr(o[2], 2)) throw "malformed PKCS8 private key(code:006)";return i.keyidx = t.getVidx(e, o[2]), i;
          }, getKeyFromPlainPrivatePKCS8PEM: function getKeyFromPlainPrivatePKCS8PEM(e) {
            var t = pemtohex(e, "PRIVATE KEY");return this.getKeyFromPlainPrivatePKCS8Hex(t);
          }, getKeyFromPlainPrivatePKCS8Hex: function getKeyFromPlainPrivatePKCS8Hex(e) {
            var t,
                r = this.parsePlainPrivatePKCS8Hex(e);if ("2a864886f70d010101" == r.algoid) t = new RSAKey();else if ("2a8648ce380401" == r.algoid) t = new K.crypto.DSA();else {
              if ("2a8648ce3d0201" != r.algoid) throw "unsupported private key algorithm";t = new K.crypto.ECDSA();
            }return t.readPKCS8PrvKeyHex(e), t;
          }, _getKeyFromPublicPKCS8Hex: function _getKeyFromPublicPKCS8Hex(e) {
            var t,
                r = J.getVbyList(e, 0, [0, 0], "06");if ("2a864886f70d010101" === r) t = new RSAKey();else if ("2a8648ce380401" === r) t = new K.crypto.DSA();else {
              if ("2a8648ce3d0201" !== r) throw "unsupported PKCS#8 public key hex";t = new K.crypto.ECDSA();
            }return t.readPKCS8PubKeyHex(e), t;
          }, parsePublicRawRSAKeyHex: function parsePublicRawRSAKeyHex(e) {
            var t = J,
                r = t.getChildIdx,
                n = t.getV,
                i = {};if ("30" != e.substr(0, 2)) throw "malformed RSA key(code:001)";var o = r(e, 0);if (2 != o.length) throw "malformed RSA key(code:002)";if ("02" != e.substr(o[0], 2)) throw "malformed RSA key(code:003)";if (i.n = n(e, o[0]), "02" != e.substr(o[1], 2)) throw "malformed RSA key(code:004)";return i.e = n(e, o[1]), i;
          }, parsePublicPKCS8Hex: function parsePublicPKCS8Hex(e) {
            var t = J,
                r = t.getChildIdx,
                n = t.getV,
                i = { algparam: null },
                o = r(e, 0);if (2 != o.length) throw "outer DERSequence shall have 2 elements: " + o.length;var s = o[0];if ("30" != e.substr(s, 2)) throw "malformed PKCS8 public key(code:001)";var a = r(e, s);if (2 != a.length) throw "malformed PKCS8 public key(code:002)";if ("06" != e.substr(a[0], 2)) throw "malformed PKCS8 public key(code:003)";if (i.algoid = n(e, a[0]), "06" == e.substr(a[1], 2) ? i.algparam = n(e, a[1]) : "30" == e.substr(a[1], 2) && (i.algparam = {}, i.algparam.p = t.getVbyList(e, a[1], [0], "02"), i.algparam.q = t.getVbyList(e, a[1], [1], "02"), i.algparam.g = t.getVbyList(e, a[1], [2], "02")), "03" != e.substr(o[1], 2)) throw "malformed PKCS8 public key(code:004)";return i.key = n(e, o[1]).substr(2), i;
          } };
      }();z.getKey = function (e, t, r) {
        var n = (v = J).getChildIdx,
            i = (v.getV, v.getVbyList),
            o = K.crypto,
            s = o.ECDSA,
            a = o.DSA,
            u = RSAKey,
            c = pemtohex,
            h = z;if (void 0 !== u && e instanceof u) return e;if (void 0 !== s && e instanceof s) return e;if (void 0 !== a && e instanceof a) return e;if (void 0 !== e.curve && void 0 !== e.xy && void 0 === e.d) return new s({ pub: e.xy, curve: e.curve });if (void 0 !== e.curve && void 0 !== e.d) return new s({ prv: e.d, curve: e.curve });if (void 0 === e.kty && void 0 !== e.n && void 0 !== e.e && void 0 === e.d) return (P = new u()).setPublic(e.n, e.e), P;if (void 0 === e.kty && void 0 !== e.n && void 0 !== e.e && void 0 !== e.d && void 0 !== e.p && void 0 !== e.q && void 0 !== e.dp && void 0 !== e.dq && void 0 !== e.co && void 0 === e.qi) return (P = new u()).setPrivateEx(e.n, e.e, e.d, e.p, e.q, e.dp, e.dq, e.co), P;if (void 0 === e.kty && void 0 !== e.n && void 0 !== e.e && void 0 !== e.d && void 0 === e.p) return (P = new u()).setPrivate(e.n, e.e, e.d), P;if (void 0 !== e.p && void 0 !== e.q && void 0 !== e.g && void 0 !== e.y && void 0 === e.x) return (P = new a()).setPublic(e.p, e.q, e.g, e.y), P;if (void 0 !== e.p && void 0 !== e.q && void 0 !== e.g && void 0 !== e.y && void 0 !== e.x) return (P = new a()).setPrivate(e.p, e.q, e.g, e.y, e.x), P;if ("RSA" === e.kty && void 0 !== e.n && void 0 !== e.e && void 0 === e.d) return (P = new u()).setPublic(b64utohex(e.n), b64utohex(e.e)), P;if ("RSA" === e.kty && void 0 !== e.n && void 0 !== e.e && void 0 !== e.d && void 0 !== e.p && void 0 !== e.q && void 0 !== e.dp && void 0 !== e.dq && void 0 !== e.qi) return (P = new u()).setPrivateEx(b64utohex(e.n), b64utohex(e.e), b64utohex(e.d), b64utohex(e.p), b64utohex(e.q), b64utohex(e.dp), b64utohex(e.dq), b64utohex(e.qi)), P;if ("RSA" === e.kty && void 0 !== e.n && void 0 !== e.e && void 0 !== e.d) return (P = new u()).setPrivate(b64utohex(e.n), b64utohex(e.e), b64utohex(e.d)), P;if ("EC" === e.kty && void 0 !== e.crv && void 0 !== e.x && void 0 !== e.y && void 0 === e.d) {
          var f = (C = new s({ curve: e.crv })).ecparams.keylen / 4,
              l = "04" + ("0000000000" + b64utohex(e.x)).slice(-f) + ("0000000000" + b64utohex(e.y)).slice(-f);return C.setPublicKeyHex(l), C;
        }if ("EC" === e.kty && void 0 !== e.crv && void 0 !== e.x && void 0 !== e.y && void 0 !== e.d) {
          f = (C = new s({ curve: e.crv })).ecparams.keylen / 4, l = "04" + ("0000000000" + b64utohex(e.x)).slice(-f) + ("0000000000" + b64utohex(e.y)).slice(-f);var g = ("0000000000" + b64utohex(e.d)).slice(-f);return C.setPublicKeyHex(l), C.setPrivateKeyHex(g), C;
        }if ("pkcs5prv" === r) {
          var p,
              d = e,
              v = J;if (9 === (p = n(d, 0)).length) (P = new u()).readPKCS5PrvKeyHex(d);else if (6 === p.length) (P = new a()).readPKCS5PrvKeyHex(d);else {
            if (!(p.length > 2 && "04" === d.substr(p[1], 2))) throw "unsupported PKCS#1/5 hexadecimal key";(P = new s()).readPKCS5PrvKeyHex(d);
          }return P;
        }if ("pkcs8prv" === r) return P = h.getKeyFromPlainPrivatePKCS8Hex(e);if ("pkcs8pub" === r) return h._getKeyFromPublicPKCS8Hex(e);if ("x509pub" === r) return X509.getPublicKeyFromCertHex(e);if (-1 != e.indexOf("-END CERTIFICATE-", 0) || -1 != e.indexOf("-END X509 CERTIFICATE-", 0) || -1 != e.indexOf("-END TRUSTED CERTIFICATE-", 0)) return X509.getPublicKeyFromCertPEM(e);if (-1 != e.indexOf("-END PUBLIC KEY-")) {
          var y = pemtohex(e, "PUBLIC KEY");return h._getKeyFromPublicPKCS8Hex(y);
        }if (-1 != e.indexOf("-END RSA PRIVATE KEY-") && -1 == e.indexOf("4,ENCRYPTED")) {
          var m = c(e, "RSA PRIVATE KEY");return h.getKey(m, null, "pkcs5prv");
        }if (-1 != e.indexOf("-END DSA PRIVATE KEY-") && -1 == e.indexOf("4,ENCRYPTED")) {
          var S = i(I = c(e, "DSA PRIVATE KEY"), 0, [1], "02"),
              F = i(I, 0, [2], "02"),
              b = i(I, 0, [3], "02"),
              _ = i(I, 0, [4], "02"),
              w = i(I, 0, [5], "02");return (P = new a()).setPrivate(new BigInteger(S, 16), new BigInteger(F, 16), new BigInteger(b, 16), new BigInteger(_, 16), new BigInteger(w, 16)), P;
        }if (-1 != e.indexOf("-END PRIVATE KEY-")) return h.getKeyFromPlainPrivatePKCS8PEM(e);if (-1 != e.indexOf("-END RSA PRIVATE KEY-") && -1 != e.indexOf("4,ENCRYPTED")) {
          var E = h.getDecryptedKeyHex(e, t),
              x = new RSAKey();return x.readPKCS5PrvKeyHex(E), x;
        }if (-1 != e.indexOf("-END EC PRIVATE KEY-") && -1 != e.indexOf("4,ENCRYPTED")) {
          var C,
              P = i(I = h.getDecryptedKeyHex(e, t), 0, [1], "04"),
              A = i(I, 0, [2, 0], "06"),
              k = i(I, 0, [3, 0], "03").substr(2);if (void 0 === K.crypto.OID.oidhex2name[A]) throw "undefined OID(hex) in KJUR.crypto.OID: " + A;return (C = new s({ curve: K.crypto.OID.oidhex2name[A] })).setPublicKeyHex(k), C.setPrivateKeyHex(P), C.isPublic = !1, C;
        }if (-1 != e.indexOf("-END DSA PRIVATE KEY-") && -1 != e.indexOf("4,ENCRYPTED")) {
          var I;S = i(I = h.getDecryptedKeyHex(e, t), 0, [1], "02"), F = i(I, 0, [2], "02"), b = i(I, 0, [3], "02"), _ = i(I, 0, [4], "02"), w = i(I, 0, [5], "02");return (P = new a()).setPrivate(new BigInteger(S, 16), new BigInteger(F, 16), new BigInteger(b, 16), new BigInteger(_, 16), new BigInteger(w, 16)), P;
        }if (-1 != e.indexOf("-END ENCRYPTED PRIVATE KEY-")) return h.getKeyFromEncryptedPKCS8PEM(e, t);throw "not supported argument";
      }, z.generateKeypair = function (e, t) {
        if ("RSA" == e) {
          var r = t;(s = new RSAKey()).generate(r, "10001"), s.isPrivate = !0, s.isPublic = !0;var n = new RSAKey(),
              i = s.n.toString(16),
              o = s.e.toString(16);return n.setPublic(i, o), n.isPrivate = !1, n.isPublic = !0, (a = {}).prvKeyObj = s, a.pubKeyObj = n, a;
        }if ("EC" == e) {
          var s,
              a,
              u = t,
              c = new K.crypto.ECDSA({ curve: u }).generateKeyPairHex();return (s = new K.crypto.ECDSA({ curve: u })).setPublicKeyHex(c.ecpubhex), s.setPrivateKeyHex(c.ecprvhex), s.isPrivate = !0, s.isPublic = !1, (n = new K.crypto.ECDSA({ curve: u })).setPublicKeyHex(c.ecpubhex), n.isPrivate = !1, n.isPublic = !0, (a = {}).prvKeyObj = s, a.pubKeyObj = n, a;
        }throw "unknown algorithm: " + e;
      }, z.getPEM = function (e, t, r, n, i, s) {
        var a = K,
            u = a.asn1,
            c = u.DERObjectIdentifier,
            h = u.DERInteger,
            f = u.ASN1Util.newObject,
            l = u.x509.SubjectPublicKeyInfo,
            g = a.crypto,
            p = g.DSA,
            d = g.ECDSA,
            v = RSAKey;function A(e) {
          return f({ seq: [{ int: 0 }, { int: { bigint: e.n } }, { int: e.e }, { int: { bigint: e.d } }, { int: { bigint: e.p } }, { int: { bigint: e.q } }, { int: { bigint: e.dmp1 } }, { int: { bigint: e.dmq1 } }, { int: { bigint: e.coeff } }] });
        }function B(e) {
          return f({ seq: [{ int: 1 }, { octstr: { hex: e.prvKeyHex } }, { tag: ["a0", !0, { oid: { name: e.curveName } }] }, { tag: ["a1", !0, { bitstr: { hex: "00" + e.pubKeyHex } }] }] });
        }function x(e) {
          return f({ seq: [{ int: 0 }, { int: { bigint: e.p } }, { int: { bigint: e.q } }, { int: { bigint: e.g } }, { int: { bigint: e.y } }, { int: { bigint: e.x } }] });
        }if ((void 0 !== v && e instanceof v || void 0 !== p && e instanceof p || void 0 !== d && e instanceof d) && 1 == e.isPublic && (void 0 === t || "PKCS8PUB" == t)) return hextopem(b = new l(e).getEncodedHex(), "PUBLIC KEY");if ("PKCS1PRV" == t && void 0 !== v && e instanceof v && (void 0 === r || null == r) && 1 == e.isPrivate) return hextopem(b = A(e).getEncodedHex(), "RSA PRIVATE KEY");if ("PKCS1PRV" == t && void 0 !== d && e instanceof d && (void 0 === r || null == r) && 1 == e.isPrivate) {
          var m = new c({ name: e.curveName }).getEncodedHex(),
              S = B(e).getEncodedHex(),
              F = "";return F += hextopem(m, "EC PARAMETERS"), F += hextopem(S, "EC PRIVATE KEY");
        }if ("PKCS1PRV" == t && void 0 !== p && e instanceof p && (void 0 === r || null == r) && 1 == e.isPrivate) return hextopem(b = x(e).getEncodedHex(), "DSA PRIVATE KEY");if ("PKCS5PRV" == t && void 0 !== v && e instanceof v && void 0 !== r && null != r && 1 == e.isPrivate) {
          var b = A(e).getEncodedHex();return void 0 === n && (n = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA", b, r, n, s);
        }if ("PKCS5PRV" == t && void 0 !== d && e instanceof d && void 0 !== r && null != r && 1 == e.isPrivate) {
          b = B(e).getEncodedHex();return void 0 === n && (n = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("EC", b, r, n, s);
        }if ("PKCS5PRV" == t && void 0 !== p && e instanceof p && void 0 !== r && null != r && 1 == e.isPrivate) {
          b = x(e).getEncodedHex();return void 0 === n && (n = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA", b, r, n, s);
        }var _ = function o(e, t) {
          var r = w(e, t);return new f({ seq: [{ seq: [{ oid: { name: "pkcs5PBES2" } }, { seq: [{ seq: [{ oid: { name: "pkcs5PBKDF2" } }, { seq: [{ octstr: { hex: r.pbkdf2Salt } }, { int: r.pbkdf2Iter }] }] }, { seq: [{ oid: { name: "des-EDE3-CBC" } }, { octstr: { hex: r.encryptionSchemeIV } }] }] }] }, { octstr: { hex: r.ciphertext } }] }).getEncodedHex();
        },
            w = function c(e, t) {
          var r = y.lib.WordArray.random(8),
              n = y.lib.WordArray.random(8),
              i = y.PBKDF2(t, r, { keySize: 6, iterations: 100 }),
              o = y.enc.Hex.parse(e),
              s = y.TripleDES.encrypt(o, i, { iv: n }) + "",
              a = {};return a.ciphertext = s, a.pbkdf2Salt = y.enc.Hex.stringify(r), a.pbkdf2Iter = 100, a.encryptionSchemeAlg = "DES-EDE3-CBC", a.encryptionSchemeIV = y.enc.Hex.stringify(n), a;
        };if ("PKCS8PRV" == t && void 0 != v && e instanceof v && 1 == e.isPrivate) {
          var E = A(e).getEncodedHex();b = f({ seq: [{ int: 0 }, { seq: [{ oid: { name: "rsaEncryption" } }, { null: !0 }] }, { octstr: { hex: E } }] }).getEncodedHex();return void 0 === r || null == r ? hextopem(b, "PRIVATE KEY") : hextopem(S = _(b, r), "ENCRYPTED PRIVATE KEY");
        }if ("PKCS8PRV" == t && void 0 !== d && e instanceof d && 1 == e.isPrivate) {
          E = new f({ seq: [{ int: 1 }, { octstr: { hex: e.prvKeyHex } }, { tag: ["a1", !0, { bitstr: { hex: "00" + e.pubKeyHex } }] }] }).getEncodedHex(), b = f({ seq: [{ int: 0 }, { seq: [{ oid: { name: "ecPublicKey" } }, { oid: { name: e.curveName } }] }, { octstr: { hex: E } }] }).getEncodedHex();return void 0 === r || null == r ? hextopem(b, "PRIVATE KEY") : hextopem(S = _(b, r), "ENCRYPTED PRIVATE KEY");
        }if ("PKCS8PRV" == t && void 0 !== p && e instanceof p && 1 == e.isPrivate) {
          E = new h({ bigint: e.x }).getEncodedHex(), b = f({ seq: [{ int: 0 }, { seq: [{ oid: { name: "dsa" } }, { seq: [{ int: { bigint: e.p } }, { int: { bigint: e.q } }, { int: { bigint: e.g } }] }] }, { octstr: { hex: E } }] }).getEncodedHex();return void 0 === r || null == r ? hextopem(b, "PRIVATE KEY") : hextopem(S = _(b, r), "ENCRYPTED PRIVATE KEY");
        }throw "unsupported object nor format";
      }, z.getKeyFromCSRPEM = function (e) {
        var t = pemtohex(e, "CERTIFICATE REQUEST");return z.getKeyFromCSRHex(t);
      }, z.getKeyFromCSRHex = function (e) {
        var t = z.parseCSRHex(e);return z.getKey(t.p8pubkeyhex, null, "pkcs8pub");
      }, z.parseCSRHex = function (e) {
        var t = J,
            r = t.getChildIdx,
            n = t.getTLV,
            i = {},
            o = e;if ("30" != o.substr(0, 2)) throw "malformed CSR(code:001)";var s = r(o, 0);if (s.length < 1) throw "malformed CSR(code:002)";if ("30" != o.substr(s[0], 2)) throw "malformed CSR(code:003)";var a = r(o, s[0]);if (a.length < 3) throw "malformed CSR(code:004)";return i.p8pubkeyhex = n(o, a[2]), i;
      }, z.getJWKFromKey = function (e) {
        var t = {};if (e instanceof RSAKey && e.isPrivate) return t.kty = "RSA", t.n = hextob64u(e.n.toString(16)), t.e = hextob64u(e.e.toString(16)), t.d = hextob64u(e.d.toString(16)), t.p = hextob64u(e.p.toString(16)), t.q = hextob64u(e.q.toString(16)), t.dp = hextob64u(e.dmp1.toString(16)), t.dq = hextob64u(e.dmq1.toString(16)), t.qi = hextob64u(e.coeff.toString(16)), t;if (e instanceof RSAKey && e.isPublic) return t.kty = "RSA", t.n = hextob64u(e.n.toString(16)), t.e = hextob64u(e.e.toString(16)), t;if (e instanceof K.crypto.ECDSA && e.isPrivate) {
          if ("P-256" !== (n = e.getShortNISTPCurveName()) && "P-384" !== n) throw "unsupported curve name for JWT: " + n;var r = e.getPublicKeyXYHex();return t.kty = "EC", t.crv = n, t.x = hextob64u(r.x), t.y = hextob64u(r.y), t.d = hextob64u(e.prvKeyHex), t;
        }if (e instanceof K.crypto.ECDSA && e.isPublic) {
          var n;if ("P-256" !== (n = e.getShortNISTPCurveName()) && "P-384" !== n) throw "unsupported curve name for JWT: " + n;r = e.getPublicKeyXYHex();return t.kty = "EC", t.crv = n, t.x = hextob64u(r.x), t.y = hextob64u(r.y), t;
        }throw "not supported key object";
      }, RSAKey.getPosArrayOfChildrenFromHex = function (e) {
        return J.getChildIdx(e, 0);
      }, RSAKey.getHexValueArrayOfChildrenFromHex = function (e) {
        var t,
            r = J.getV,
            n = r(e, (t = RSAKey.getPosArrayOfChildrenFromHex(e))[0]),
            i = r(e, t[1]),
            o = r(e, t[2]),
            s = r(e, t[3]),
            a = r(e, t[4]),
            u = r(e, t[5]),
            c = r(e, t[6]),
            h = r(e, t[7]),
            f = r(e, t[8]);return (t = new Array()).push(n, i, o, s, a, u, c, h, f), t;
      }, RSAKey.prototype.readPrivateKeyFromPEMString = function (e) {
        var t = pemtohex(e),
            r = RSAKey.getHexValueArrayOfChildrenFromHex(t);this.setPrivateEx(r[1], r[2], r[3], r[4], r[5], r[6], r[7], r[8]);
      }, RSAKey.prototype.readPKCS5PrvKeyHex = function (e) {
        var t = RSAKey.getHexValueArrayOfChildrenFromHex(e);this.setPrivateEx(t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8]);
      }, RSAKey.prototype.readPKCS8PrvKeyHex = function (e) {
        var t,
            r,
            n,
            i,
            o,
            s,
            a,
            u,
            c = J,
            h = c.getVbyList;if (!1 === c.isASN1HEX(e)) throw "not ASN.1 hex string";try {
          t = h(e, 0, [2, 0, 1], "02"), r = h(e, 0, [2, 0, 2], "02"), n = h(e, 0, [2, 0, 3], "02"), i = h(e, 0, [2, 0, 4], "02"), o = h(e, 0, [2, 0, 5], "02"), s = h(e, 0, [2, 0, 6], "02"), a = h(e, 0, [2, 0, 7], "02"), u = h(e, 0, [2, 0, 8], "02");
        } catch (e) {
          throw "malformed PKCS#8 plain RSA private key";
        }this.setPrivateEx(t, r, n, i, o, s, a, u);
      }, RSAKey.prototype.readPKCS5PubKeyHex = function (e) {
        var t = J,
            r = t.getV;if (!1 === t.isASN1HEX(e)) throw "keyHex is not ASN.1 hex string";var n = t.getChildIdx(e, 0);if (2 !== n.length || "02" !== e.substr(n[0], 2) || "02" !== e.substr(n[1], 2)) throw "wrong hex for PKCS#5 public key";var i = r(e, n[0]),
            o = r(e, n[1]);this.setPublic(i, o);
      }, RSAKey.prototype.readPKCS8PubKeyHex = function (e) {
        var t = J;if (!1 === t.isASN1HEX(e)) throw "not ASN.1 hex string";if ("06092a864886f70d010101" !== t.getTLVbyList(e, 0, [0, 0])) throw "not PKCS8 RSA public key";var r = t.getTLVbyList(e, 0, [1, 0]);this.readPKCS5PubKeyHex(r);
      }, RSAKey.prototype.readCertPubKeyHex = function (e, t) {
        var r, n;(r = new X509()).readCertHex(e), n = r.getPublicKeyHex(), this.readPKCS8PubKeyHex(n);
      };var Y = new RegExp("");function _zeroPaddingOfSignature(e, t) {
        for (var r = "", n = t / 4 - e.length, i = 0; i < n; i++) {
          r += "0";
        }return r + e;
      }function pss_mgf1_str(e, t, r) {
        for (var n = "", i = 0; n.length < t;) {
          n += hextorstr(r(rstrtohex(e + String.fromCharCode.apply(String, [(4278190080 & i) >> 24, (16711680 & i) >> 16, (65280 & i) >> 8, 255 & i])))), i += 1;
        }return n;
      }function _rsasign_getAlgNameAndHashFromHexDisgestInfo(e) {
        for (var t in K.crypto.Util.DIGESTINFOHEAD) {
          var r = K.crypto.Util.DIGESTINFOHEAD[t],
              n = r.length;if (e.substring(0, n) == r) return [t, e.substring(n)];
        }return [];
      }function X509() {
        var e = J,
            t = e.getChildIdx,
            r = e.getV,
            n = e.getTLV,
            i = e.getVbyList,
            o = e.getTLVbyList,
            s = e.getIdxbyList,
            a = e.getVidx,
            u = e.oidname,
            c = X509,
            h = pemtohex;this.hex = null, this.version = 0, this.foffset = 0, this.aExtInfo = null, this.getVersion = function () {
          return null === this.hex || 0 !== this.version ? this.version : "a003020102" !== o(this.hex, 0, [0, 0]) ? (this.version = 1, this.foffset = -1, 1) : (this.version = 3, 3);
        }, this.getSerialNumberHex = function () {
          return i(this.hex, 0, [0, 1 + this.foffset], "02");
        }, this.getSignatureAlgorithmField = function () {
          return u(i(this.hex, 0, [0, 2 + this.foffset, 0], "06"));
        }, this.getIssuerHex = function () {
          return o(this.hex, 0, [0, 3 + this.foffset], "30");
        }, this.getIssuerString = function () {
          return c.hex2dn(this.getIssuerHex());
        }, this.getSubjectHex = function () {
          return o(this.hex, 0, [0, 5 + this.foffset], "30");
        }, this.getSubjectString = function () {
          return c.hex2dn(this.getSubjectHex());
        }, this.getNotBefore = function () {
          var e = i(this.hex, 0, [0, 4 + this.foffset, 0]);return e = e.replace(/(..)/g, "%$1"), e = decodeURIComponent(e);
        }, this.getNotAfter = function () {
          var e = i(this.hex, 0, [0, 4 + this.foffset, 1]);return e = e.replace(/(..)/g, "%$1"), e = decodeURIComponent(e);
        }, this.getPublicKeyHex = function () {
          return e.getTLVbyList(this.hex, 0, [0, 6 + this.foffset], "30");
        }, this.getPublicKeyIdx = function () {
          return s(this.hex, 0, [0, 6 + this.foffset], "30");
        }, this.getPublicKeyContentIdx = function () {
          var e = this.getPublicKeyIdx();return s(this.hex, e, [1, 0], "30");
        }, this.getPublicKey = function () {
          return z.getKey(this.getPublicKeyHex(), null, "pkcs8pub");
        }, this.getSignatureAlgorithmName = function () {
          return u(i(this.hex, 0, [1, 0], "06"));
        }, this.getSignatureValueHex = function () {
          return i(this.hex, 0, [2], "03", !0);
        }, this.verifySignature = function (e) {
          var t = this.getSignatureAlgorithmName(),
              r = this.getSignatureValueHex(),
              n = o(this.hex, 0, [0], "30"),
              i = new K.crypto.Signature({ alg: t });return i.init(e), i.updateHex(n), i.verify(r);
        }, this.parseExt = function () {
          if (3 !== this.version) return -1;var r = s(this.hex, 0, [0, 7, 0], "30"),
              n = t(this.hex, r);this.aExtInfo = new Array();for (var o = 0; o < n.length; o++) {
            var u = { critical: !1 },
                c = 0;3 === t(this.hex, n[o]).length && (u.critical = !0, c = 1), u.oid = e.hextooidstr(i(this.hex, n[o], [0], "06"));var h = s(this.hex, n[o], [1 + c]);u.vidx = a(this.hex, h), this.aExtInfo.push(u);
          }
        }, this.getExtInfo = function (e) {
          var t = this.aExtInfo,
              r = e;if (e.match(/^[0-9.]+$/) || (r = K.asn1.x509.OID.name2oid(e)), "" !== r) for (var n = 0; n < t.length; n++) {
            if (t[n].oid === r) return t[n];
          }
        }, this.getExtBasicConstraints = function () {
          var e = this.getExtInfo("basicConstraints");if (void 0 === e) return e;var t = r(this.hex, e.vidx);if ("" === t) return {};if ("0101ff" === t) return { cA: !0 };if ("0101ff02" === t.substr(0, 8)) {
            var n = r(t, 6);return { cA: !0, pathLen: parseInt(n, 16) };
          }throw "basicConstraints parse error";
        }, this.getExtKeyUsageBin = function () {
          var e = this.getExtInfo("keyUsage");if (void 0 === e) return "";var t = r(this.hex, e.vidx);if (t.length % 2 != 0 || t.length <= 2) throw "malformed key usage value";var n = parseInt(t.substr(0, 2)),
              i = parseInt(t.substr(2), 16).toString(2);return i.substr(0, i.length - n);
        }, this.getExtKeyUsageString = function () {
          for (var e = this.getExtKeyUsageBin(), t = new Array(), r = 0; r < e.length; r++) {
            "1" == e.substr(r, 1) && t.push(X509.KEYUSAGE_NAME[r]);
          }return t.join(",");
        }, this.getExtSubjectKeyIdentifier = function () {
          var e = this.getExtInfo("subjectKeyIdentifier");return void 0 === e ? e : r(this.hex, e.vidx);
        }, this.getExtAuthorityKeyIdentifier = function () {
          var e = this.getExtInfo("authorityKeyIdentifier");if (void 0 === e) return e;for (var i = {}, o = n(this.hex, e.vidx), s = t(o, 0), a = 0; a < s.length; a++) {
            "80" === o.substr(s[a], 2) && (i.kid = r(o, s[a]));
          }return i;
        }, this.getExtExtKeyUsageName = function () {
          var e = this.getExtInfo("extKeyUsage");if (void 0 === e) return e;var i = new Array(),
              o = n(this.hex, e.vidx);if ("" === o) return i;for (var s = t(o, 0), a = 0; a < s.length; a++) {
            i.push(u(r(o, s[a])));
          }return i;
        }, this.getExtSubjectAltName = function () {
          for (var e = this.getExtSubjectAltName2(), t = new Array(), r = 0; r < e.length; r++) {
            "DNS" === e[r][0] && t.push(e[r][1]);
          }return t;
        }, this.getExtSubjectAltName2 = function () {
          var e,
              i,
              o,
              s = this.getExtInfo("subjectAltName");if (void 0 === s) return s;for (var a = new Array(), u = n(this.hex, s.vidx), c = t(u, 0), h = 0; h < c.length; h++) {
            o = u.substr(c[h], 2), e = r(u, c[h]), "81" === o && (i = hextoutf8(e), a.push(["MAIL", i])), "82" === o && (i = hextoutf8(e), a.push(["DNS", i])), "84" === o && (i = X509.hex2dn(e, 0), a.push(["DN", i])), "86" === o && (i = hextoutf8(e), a.push(["URI", i])), "87" === o && (i = hextoip(e), a.push(["IP", i]));
          }return a;
        }, this.getExtCRLDistributionPointsURI = function () {
          var e = this.getExtInfo("cRLDistributionPoints");if (void 0 === e) return e;for (var r = new Array(), n = t(this.hex, e.vidx), o = 0; o < n.length; o++) {
            try {
              var s = hextoutf8(i(this.hex, n[o], [0, 0, 0], "86"));r.push(s);
            } catch (e) {}
          }return r;
        }, this.getExtAIAInfo = function () {
          var e = this.getExtInfo("authorityInfoAccess");if (void 0 === e) return e;for (var r = { ocsp: [], caissuer: [] }, n = t(this.hex, e.vidx), o = 0; o < n.length; o++) {
            var s = i(this.hex, n[o], [0], "06"),
                a = i(this.hex, n[o], [1], "86");"2b06010505073001" === s && r.ocsp.push(hextoutf8(a)), "2b06010505073002" === s && r.caissuer.push(hextoutf8(a));
          }return r;
        }, this.getExtCertificatePolicies = function () {
          var e = this.getExtInfo("certificatePolicies");if (void 0 === e) return e;for (var o = n(this.hex, e.vidx), s = [], a = t(o, 0), c = 0; c < a.length; c++) {
            var h = {},
                f = t(o, a[c]);if (h.id = u(r(o, f[0])), 2 === f.length) for (var l = t(o, f[1]), g = 0; g < l.length; g++) {
              var p = i(o, l[g], [0], "06");"2b06010505070201" === p ? h.cps = hextoutf8(i(o, l[g], [1])) : "2b06010505070202" === p && (h.unotice = hextoutf8(i(o, l[g], [1, 0])));
            }s.push(h);
          }return s;
        }, this.readCertPEM = function (e) {
          this.readCertHex(h(e));
        }, this.readCertHex = function (e) {
          this.hex = e, this.getVersion();try {
            s(this.hex, 0, [0, 7], "a3"), this.parseExt();
          } catch (e) {}
        }, this.getInfo = function () {
          var e, t, r;if (e = "Basic Fields\n", e += "  serial number: " + this.getSerialNumberHex() + "\n", e += "  signature algorithm: " + this.getSignatureAlgorithmField() + "\n", e += "  issuer: " + this.getIssuerString() + "\n", e += "  notBefore: " + this.getNotBefore() + "\n", e += "  notAfter: " + this.getNotAfter() + "\n", e += "  subject: " + this.getSubjectString() + "\n", e += "  subject public key info: \n", e += "    key algorithm: " + (t = this.getPublicKey()).type + "\n", "RSA" === t.type && (e += "    n=" + hextoposhex(t.n.toString(16)).substr(0, 16) + "...\n", e += "    e=" + hextoposhex(t.e.toString(16)) + "\n"), void 0 !== (r = this.aExtInfo) && null !== r) {
            e += "X509v3 Extensions:\n";for (var n = 0; n < r.length; n++) {
              var i = r[n],
                  o = K.asn1.x509.OID.oid2name(i.oid);"" === o && (o = i.oid);var s = "";if (!0 === i.critical && (s = "CRITICAL"), e += "  " + o + " " + s + ":\n", "basicConstraints" === o) {
                var a = this.getExtBasicConstraints();void 0 === a.cA ? e += "    {}\n" : (e += "    cA=true", void 0 !== a.pathLen && (e += ", pathLen=" + a.pathLen), e += "\n");
              } else if ("keyUsage" === o) e += "    " + this.getExtKeyUsageString() + "\n";else if ("subjectKeyIdentifier" === o) e += "    " + this.getExtSubjectKeyIdentifier() + "\n";else if ("authorityKeyIdentifier" === o) {
                var u = this.getExtAuthorityKeyIdentifier();void 0 !== u.kid && (e += "    kid=" + u.kid + "\n");
              } else {
                if ("extKeyUsage" === o) e += "    " + this.getExtExtKeyUsageName().join(", ") + "\n";else if ("subjectAltName" === o) e += "    " + this.getExtSubjectAltName2() + "\n";else if ("cRLDistributionPoints" === o) e += "    " + this.getExtCRLDistributionPointsURI() + "\n";else if ("authorityInfoAccess" === o) {
                  var c = this.getExtAIAInfo();void 0 !== c.ocsp && (e += "    ocsp: " + c.ocsp.join(",") + "\n"), void 0 !== c.caissuer && (e += "    caissuer: " + c.caissuer.join(",") + "\n");
                } else if ("certificatePolicies" === o) for (var h = this.getExtCertificatePolicies(), f = 0; f < h.length; f++) {
                  void 0 !== h[f].id && (e += "    policy oid: " + h[f].id + "\n"), void 0 !== h[f].cps && (e += "    cps: " + h[f].cps + "\n");
                }
              }
            }
          }return e += "signature algorithm: " + this.getSignatureAlgorithmName() + "\n", e += "signature: " + this.getSignatureValueHex().substr(0, 16) + "...\n";
        };
      }Y.compile("[^0-9a-f]", "gi"), RSAKey.prototype.sign = function (e, t) {
        var r = function b(e) {
          return K.crypto.Util.hashString(e, t);
        }(e);return this.signWithMessageHash(r, t);
      }, RSAKey.prototype.signWithMessageHash = function (e, t) {
        var r = parseBigInt(K.crypto.Util.getPaddedDigestInfoHex(e, t, this.n.bitLength()), 16);return _zeroPaddingOfSignature(this.doPrivate(r).toString(16), this.n.bitLength());
      }, RSAKey.prototype.signPSS = function (e, t, r) {
        var n = function c(e) {
          return K.crypto.Util.hashHex(e, t);
        }(rstrtohex(e));return void 0 === r && (r = -1), this.signWithMessageHashPSS(n, t, r);
      }, RSAKey.prototype.signWithMessageHashPSS = function (e, t, r) {
        var n,
            i = hextorstr(e),
            s = i.length,
            a = this.n.bitLength() - 1,
            u = Math.ceil(a / 8),
            c = function o(e) {
          return K.crypto.Util.hashHex(e, t);
        };if (-1 === r || void 0 === r) r = s;else if (-2 === r) r = u - s - 2;else if (r < -2) throw "invalid salt length";if (u < s + r + 2) throw "data too long";var h = "";r > 0 && (h = new Array(r), new SecureRandom().nextBytes(h), h = String.fromCharCode.apply(String, h));var f = hextorstr(c(rstrtohex("\0\0\0\0\0\0\0\0" + i + h))),
            l = [];for (n = 0; n < u - r - s - 2; n += 1) {
          l[n] = 0;
        }var g = String.fromCharCode.apply(String, l) + "" + h,
            p = pss_mgf1_str(f, g.length, c),
            d = [];for (n = 0; n < g.length; n += 1) {
          d[n] = g.charCodeAt(n) ^ p.charCodeAt(n);
        }var v = 65280 >> 8 * u - a & 255;for (d[0] &= ~v, n = 0; n < s; n++) {
          d.push(f.charCodeAt(n));
        }return d.push(188), _zeroPaddingOfSignature(this.doPrivate(new BigInteger(d)).toString(16), this.n.bitLength());
      }, RSAKey.prototype.verify = function (e, t) {
        var r = parseBigInt(t = (t = t.replace(Y, "")).replace(/[ \n]+/g, ""), 16);if (r.bitLength() > this.n.bitLength()) return 0;var n = _rsasign_getAlgNameAndHashFromHexDisgestInfo(this.doPublic(r).toString(16).replace(/^1f+00/, ""));if (0 == n.length) return !1;var i = n[0];return n[1] == function a(e) {
          return K.crypto.Util.hashString(e, i);
        }(e);
      }, RSAKey.prototype.verifyWithMessageHash = function (e, t) {
        var r = parseBigInt(t = (t = t.replace(Y, "")).replace(/[ \n]+/g, ""), 16);if (r.bitLength() > this.n.bitLength()) return 0;var n = _rsasign_getAlgNameAndHashFromHexDisgestInfo(this.doPublic(r).toString(16).replace(/^1f+00/, ""));if (0 == n.length) return !1;n[0];return n[1] == e;
      }, RSAKey.prototype.verifyPSS = function (t, r, n, i) {
        var o = function e(t) {
          return K.crypto.Util.hashHex(t, n);
        }(rstrtohex(t));return void 0 === i && (i = -1), this.verifyWithMessageHashPSS(o, r, n, i);
      }, RSAKey.prototype.verifyWithMessageHashPSS = function (e, t, n, i) {
        var o = new BigInteger(t, 16);if (o.bitLength() > this.n.bitLength()) return !1;var s,
            a = function r(e) {
          return K.crypto.Util.hashHex(e, n);
        },
            u = hextorstr(e),
            c = u.length,
            h = this.n.bitLength() - 1,
            f = Math.ceil(h / 8);if (-1 === i || void 0 === i) i = c;else if (-2 === i) i = f - c - 2;else if (i < -2) throw "invalid salt length";if (f < c + i + 2) throw "data too long";var l = this.doPublic(o).toByteArray();for (s = 0; s < l.length; s += 1) {
          l[s] &= 255;
        }for (; l.length < f;) {
          l.unshift(0);
        }if (188 !== l[f - 1]) throw "encoded message does not end in 0xbc";var g = (l = String.fromCharCode.apply(String, l)).substr(0, f - c - 1),
            p = l.substr(g.length, c),
            d = 65280 >> 8 * f - h & 255;if (0 != (g.charCodeAt(0) & d)) throw "bits beyond keysize not zero";var v = pss_mgf1_str(p, g.length, a),
            y = [];for (s = 0; s < g.length; s += 1) {
          y[s] = g.charCodeAt(s) ^ v.charCodeAt(s);
        }y[0] &= ~d;var m = f - c - i - 2;for (s = 0; s < m; s += 1) {
          if (0 !== y[s]) throw "leftmost octets not zero";
        }if (1 !== y[m]) throw "0x01 marker not found";return p === hextorstr(a(rstrtohex("\0\0\0\0\0\0\0\0" + u + String.fromCharCode.apply(String, y.slice(-i)))));
      }, RSAKey.SALT_LEN_HLEN = -1, RSAKey.SALT_LEN_MAX = -2, RSAKey.SALT_LEN_RECOVER = -2, X509.hex2dn = function (e, t) {
        if (void 0 === t && (t = 0), "30" !== e.substr(t, 2)) throw "malformed DN";for (var r = new Array(), n = J.getChildIdx(e, t), i = 0; i < n.length; i++) {
          r.push(X509.hex2rdn(e, n[i]));
        }return "/" + (r = r.map(function (e) {
          return e.replace("/", "\\/");
        })).join("/");
      }, X509.hex2rdn = function (e, t) {
        if (void 0 === t && (t = 0), "31" !== e.substr(t, 2)) throw "malformed RDN";for (var r = new Array(), n = J.getChildIdx(e, t), i = 0; i < n.length; i++) {
          r.push(X509.hex2attrTypeValue(e, n[i]));
        }return (r = r.map(function (e) {
          return e.replace("+", "\\+");
        })).join("+");
      }, X509.hex2attrTypeValue = function (e, t) {
        var r = J,
            n = r.getV;if (void 0 === t && (t = 0), "30" !== e.substr(t, 2)) throw "malformed attribute type and value";var i = r.getChildIdx(e, t);2 !== i.length || e.substr(i[0], 2);var o = n(e, i[0]),
            s = K.asn1.ASN1Util.oidHexToInt(o);return K.asn1.x509.OID.oid2atype(s) + "=" + hextorstr(n(e, i[1]));
      }, X509.getPublicKeyFromCertHex = function (e) {
        var t = new X509();return t.readCertHex(e), t.getPublicKey();
      }, X509.getPublicKeyFromCertPEM = function (e) {
        var t = new X509();return t.readCertPEM(e), t.getPublicKey();
      }, X509.getPublicKeyInfoPropOfCertPEM = function (e) {
        var t,
            r,
            n = J.getVbyList,
            i = {};return i.algparam = null, (t = new X509()).readCertPEM(e), r = t.getPublicKeyHex(), i.keyhex = n(r, 0, [1], "03").substr(2), i.algoid = n(r, 0, [0, 0], "06"), "2a8648ce3d0201" === i.algoid && (i.algparam = n(r, 0, [0, 1], "06")), i;
      }, X509.KEYUSAGE_NAME = ["digitalSignature", "nonRepudiation", "keyEncipherment", "dataEncipherment", "keyAgreement", "keyCertSign", "cRLSign", "encipherOnly", "decipherOnly"], void 0 !== K && K || (K = {}), void 0 !== K.jws && K.jws || (K.jws = {}), K.jws.JWS = function () {
        var e = K.jws.JWS.isSafeJSONString;this.parseJWS = function (t, r) {
          if (void 0 === this.parsedJWS || !r && void 0 === this.parsedJWS.sigvalH) {
            var n = t.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);if (null == n) throw "JWS signature is not a form of 'Head.Payload.SigValue'.";var i = n[1],
                o = n[2],
                s = n[3],
                a = i + "." + o;if (this.parsedJWS = {}, this.parsedJWS.headB64U = i, this.parsedJWS.payloadB64U = o, this.parsedJWS.sigvalB64U = s, this.parsedJWS.si = a, !r) {
              var u = b64utohex(s),
                  c = parseBigInt(u, 16);this.parsedJWS.sigvalH = u, this.parsedJWS.sigvalBI = c;
            }var h = W(i),
                f = W(o);if (this.parsedJWS.headS = h, this.parsedJWS.payloadS = f, !e(h, this.parsedJWS, "headP")) throw "malformed JSON string for JWS Head: " + h;
          }
        };
      }, K.jws.JWS.sign = function (e, t, r, n, o) {
        var s,
            a,
            u,
            c = K,
            h = c.jws.JWS,
            f = h.readSafeJSONString,
            l = h.isSafeJSONString,
            g = c.crypto,
            p = (g.ECDSA, g.Mac),
            d = g.Signature,
            v = JSON;if ("string" != typeof t && "object" != (void 0 === t ? "undefined" : i(t))) throw "spHeader must be JSON string or object: " + t;if ("object" == (void 0 === t ? "undefined" : i(t)) && (a = t, s = v.stringify(a)), "string" == typeof t) {
          if (!l(s = t)) throw "JWS Head is not safe JSON string: " + s;a = f(s);
        }if (u = r, "object" == (void 0 === r ? "undefined" : i(r)) && (u = v.stringify(r)), "" != e && null != e || void 0 === a.alg || (e = a.alg), "" != e && null != e && void 0 === a.alg && (a.alg = e, s = v.stringify(a)), e !== a.alg) throw "alg and sHeader.alg doesn't match: " + e + "!=" + a.alg;var y = null;if (void 0 === h.jwsalg2sigalg[e]) throw "unsupported alg name: " + e;y = h.jwsalg2sigalg[e];var m = q(s) + "." + q(u),
            S = "";if ("Hmac" == y.substr(0, 4)) {
          if (void 0 === n) throw "mac key shall be specified for HS* alg";var F = new p({ alg: y, prov: "cryptojs", pass: n });F.updateString(m), S = F.doFinal();
        } else {
          var b;if (-1 != y.indexOf("withECDSA")) (b = new d({ alg: y })).init(n, o), b.updateString(m), hASN1Sig = b.sign(), S = K.crypto.ECDSA.asn1SigToConcatSig(hASN1Sig);else if ("none" != y) (b = new d({ alg: y })).init(n, o), b.updateString(m), S = b.sign();
        }return m + "." + hextob64u(S);
      }, K.jws.JWS.verify = function (e, t, r) {
        var n,
            o = K,
            s = o.jws.JWS,
            a = s.readSafeJSONString,
            u = o.crypto,
            c = u.ECDSA,
            h = u.Mac,
            f = u.Signature;void 0 !== i(RSAKey) && (n = RSAKey);var l = e.split(".");if (3 !== l.length) return !1;var g = l[0] + "." + l[1],
            p = b64utohex(l[2]),
            d = a(W(l[0])),
            v = null,
            y = null;if (void 0 === d.alg) throw "algorithm not specified in header";if ((y = (v = d.alg).substr(0, 2), null != r && "[object Array]" === Object.prototype.toString.call(r) && r.length > 0) && -1 == (":" + r.join(":") + ":").indexOf(":" + v + ":")) throw "algorithm '" + v + "' not accepted in the list";if ("none" != v && null === t) throw "key shall be specified to verify.";if ("string" == typeof t && -1 != t.indexOf("-----BEGIN ") && (t = z.getKey(t)), !("RS" != y && "PS" != y || t instanceof n)) throw "key shall be a RSAKey obj for RS* and PS* algs";if ("ES" == y && !(t instanceof c)) throw "key shall be a ECDSA obj for ES* algs";var m = null;if (void 0 === s.jwsalg2sigalg[d.alg]) throw "unsupported alg name: " + v;if ("none" == (m = s.jwsalg2sigalg[v])) throw "not supported";if ("Hmac" == m.substr(0, 4)) {
          if (void 0 === t) throw "hexadecimal key shall be specified for HMAC";var S = new h({ alg: m, pass: t });return S.updateString(g), p == S.doFinal();
        }if (-1 != m.indexOf("withECDSA")) {
          var F,
              b = null;try {
            b = c.concatSigToASN1Sig(p);
          } catch (e) {
            return !1;
          }return (F = new f({ alg: m })).init(t), F.updateString(g), F.verify(b);
        }return (F = new f({ alg: m })).init(t), F.updateString(g), F.verify(p);
      }, K.jws.JWS.parse = function (e) {
        var t,
            r,
            n,
            i = e.split("."),
            o = {};if (2 != i.length && 3 != i.length) throw "malformed sJWS: wrong number of '.' splitted elements";return t = i[0], r = i[1], 3 == i.length && (n = i[2]), o.headerObj = K.jws.JWS.readSafeJSONString(W(t)), o.payloadObj = K.jws.JWS.readSafeJSONString(W(r)), o.headerPP = JSON.stringify(o.headerObj, null, "  "), null == o.payloadObj ? o.payloadPP = W(r) : o.payloadPP = JSON.stringify(o.payloadObj, null, "  "), void 0 !== n && (o.sigHex = b64utohex(n)), o;
      }, K.jws.JWS.verifyJWT = function (e, t, r) {
        var n = K.jws,
            o = n.JWS,
            s = o.readSafeJSONString,
            a = o.inArray,
            u = o.includedArray,
            c = e.split("."),
            h = c[0],
            f = c[1],
            l = (b64utohex(c[2]), s(W(h))),
            g = s(W(f));if (void 0 === l.alg) return !1;if (void 0 === r.alg) throw "acceptField.alg shall be specified";if (!a(l.alg, r.alg)) return !1;if (void 0 !== g.iss && "object" === i(r.iss) && !a(g.iss, r.iss)) return !1;if (void 0 !== g.sub && "object" === i(r.sub) && !a(g.sub, r.sub)) return !1;if (void 0 !== g.aud && "object" === i(r.aud)) if ("string" == typeof g.aud) {
          if (!a(g.aud, r.aud)) return !1;
        } else if ("object" == i(g.aud) && !u(g.aud, r.aud)) return !1;var p = n.IntDate.getNow();return void 0 !== r.verifyAt && "number" == typeof r.verifyAt && (p = r.verifyAt), void 0 !== r.gracePeriod && "number" == typeof r.gracePeriod || (r.gracePeriod = 0), !(void 0 !== g.exp && "number" == typeof g.exp && g.exp + r.gracePeriod < p) && !(void 0 !== g.nbf && "number" == typeof g.nbf && p < g.nbf - r.gracePeriod) && !(void 0 !== g.iat && "number" == typeof g.iat && p < g.iat - r.gracePeriod) && (void 0 === g.jti || void 0 === r.jti || g.jti === r.jti) && !!o.verify(e, t, r.alg);
      }, K.jws.JWS.includedArray = function (e, t) {
        var r = K.jws.JWS.inArray;if (null === e) return !1;if ("object" !== (void 0 === e ? "undefined" : i(e))) return !1;if ("number" != typeof e.length) return !1;for (var n = 0; n < e.length; n++) {
          if (!r(e[n], t)) return !1;
        }return !0;
      }, K.jws.JWS.inArray = function (e, t) {
        if (null === t) return !1;if ("object" !== (void 0 === t ? "undefined" : i(t))) return !1;if ("number" != typeof t.length) return !1;for (var r = 0; r < t.length; r++) {
          if (t[r] == e) return !0;
        }return !1;
      }, K.jws.JWS.jwsalg2sigalg = { HS256: "HmacSHA256", HS384: "HmacSHA384", HS512: "HmacSHA512", RS256: "SHA256withRSA", RS384: "SHA384withRSA", RS512: "SHA512withRSA", ES256: "SHA256withECDSA", ES384: "SHA384withECDSA", PS256: "SHA256withRSAandMGF1", PS384: "SHA384withRSAandMGF1", PS512: "SHA512withRSAandMGF1", none: "none" }, K.jws.JWS.isSafeJSONString = function (e, t, r) {
        var n = null;try {
          return "object" != (void 0 === (n = V(e)) ? "undefined" : i(n)) ? 0 : n.constructor === Array ? 0 : (t && (t[r] = n), 1);
        } catch (e) {
          return 0;
        }
      }, K.jws.JWS.readSafeJSONString = function (e) {
        var t = null;try {
          return "object" != (void 0 === (t = V(e)) ? "undefined" : i(t)) ? null : t.constructor === Array ? null : t;
        } catch (e) {
          return null;
        }
      }, K.jws.JWS.getEncodedSignatureValueFromJWS = function (e) {
        var t = e.match(/^[^.]+\.[^.]+\.([^.]+)$/);if (null == t) throw "JWS signature is not a form of 'Head.Payload.SigValue'.";return t[1];
      }, K.jws.JWS.getJWKthumbprint = function (e) {
        if ("RSA" !== e.kty && "EC" !== e.kty && "oct" !== e.kty) throw "unsupported algorithm for JWK Thumprint";var t = "{";if ("RSA" === e.kty) {
          if ("string" != typeof e.n || "string" != typeof e.e) throw "wrong n and e value for RSA key";t += '"e":"' + e.e + '",', t += '"kty":"' + e.kty + '",', t += '"n":"' + e.n + '"}';
        } else if ("EC" === e.kty) {
          if ("string" != typeof e.crv || "string" != typeof e.x || "string" != typeof e.y) throw "wrong crv, x and y value for EC key";t += '"crv":"' + e.crv + '",', t += '"kty":"' + e.kty + '",', t += '"x":"' + e.x + '",', t += '"y":"' + e.y + '"}';
        } else if ("oct" === e.kty) {
          if ("string" != typeof e.k) throw "wrong k value for oct(symmetric) key";t += '"kty":"' + e.kty + '",', t += '"k":"' + e.k + '"}';
        }var r = rstrtohex(t);return hextob64u(K.crypto.Util.hashHex(r, "sha256"));
      }, K.jws.IntDate = {}, K.jws.IntDate.get = function (e) {
        var t = K.jws.IntDate,
            r = t.getNow,
            n = t.getZulu;if ("now" == e) return r();if ("now + 1hour" == e) return r() + 3600;if ("now + 1day" == e) return r() + 86400;if ("now + 1month" == e) return r() + 2592e3;if ("now + 1year" == e) return r() + 31536e3;if (e.match(/Z$/)) return n(e);if (e.match(/^[0-9]+$/)) return parseInt(e);throw "unsupported format: " + e;
      }, K.jws.IntDate.getZulu = function (e) {
        return zulutosec(e);
      }, K.jws.IntDate.getNow = function () {
        return ~~(new Date() / 1e3);
      }, K.jws.IntDate.intDate2UTCString = function (e) {
        return new Date(1e3 * e).toUTCString();
      }, K.jws.IntDate.intDate2Zulu = function (e) {
        var t = new Date(1e3 * e);return ("0000" + t.getUTCFullYear()).slice(-4) + ("00" + (t.getUTCMonth() + 1)).slice(-2) + ("00" + t.getUTCDate()).slice(-2) + ("00" + t.getUTCHours()).slice(-2) + ("00" + t.getUTCMinutes()).slice(-2) + ("00" + t.getUTCSeconds()).slice(-2) + "Z";
      }, t.SecureRandom = SecureRandom, t.rng_seed_time = rng_seed_time, t.BigInteger = BigInteger, t.RSAKey = RSAKey, t.ECDSA = K.crypto.ECDSA, t.DSA = K.crypto.DSA, t.Signature = K.crypto.Signature, t.MessageDigest = K.crypto.MessageDigest, t.Mac = K.crypto.Mac, t.Cipher = K.crypto.Cipher, t.KEYUTIL = z, t.ASN1HEX = J, t.X509 = X509, t.CryptoJS = y, t.b64tohex = b64tohex, t.b64toBA = b64toBA, t.stoBA = stoBA, t.BAtos = BAtos, t.BAtohex = BAtohex, t.stohex = stohex, t.stob64 = function stob64(e) {
        return hex2b64(stohex(e));
      }, t.stob64u = function stob64u(e) {
        return b64tob64u(hex2b64(stohex(e)));
      }, t.b64utos = function b64utos(e) {
        return BAtos(b64toBA(b64utob64(e)));
      }, t.b64tob64u = b64tob64u, t.b64utob64 = b64utob64, t.hex2b64 = hex2b64, t.hextob64u = hextob64u, t.b64utohex = b64utohex, t.utf8tob64u = q, t.b64utoutf8 = W, t.utf8tob64 = function utf8tob64(e) {
        return hex2b64(uricmptohex(encodeURIComponentAll(e)));
      }, t.b64toutf8 = function b64toutf8(e) {
        return decodeURIComponent(hextouricmp(b64tohex(e)));
      }, t.utf8tohex = utf8tohex, t.hextoutf8 = hextoutf8, t.hextorstr = hextorstr, t.rstrtohex = rstrtohex, t.hextob64 = hextob64, t.hextob64nl = hextob64nl, t.b64nltohex = b64nltohex, t.hextopem = hextopem, t.pemtohex = pemtohex, t.hextoArrayBuffer = function hextoArrayBuffer(e) {
        if (e.length % 2 != 0) throw "input is not even length";if (null == e.match(/^[0-9A-Fa-f]+$/)) throw "input is not hexadecimal";for (var t = new ArrayBuffer(e.length / 2), r = new DataView(t), n = 0; n < e.length / 2; n++) {
          r.setUint8(n, parseInt(e.substr(2 * n, 2), 16));
        }return t;
      }, t.ArrayBuffertohex = function ArrayBuffertohex(e) {
        for (var t = "", r = new DataView(e), n = 0; n < e.byteLength; n++) {
          t += ("00" + r.getUint8(n).toString(16)).slice(-2);
        }return t;
      }, t.zulutomsec = zulutomsec, t.zulutosec = zulutosec, t.zulutodate = function zulutodate(e) {
        return new Date(zulutomsec(e));
      }, t.datetozulu = function datetozulu(e, t, r) {
        var n,
            i = e.getUTCFullYear();if (t) {
          if (i < 1950 || 2049 < i) throw "not proper year for UTCTime: " + i;n = ("" + i).slice(-2);
        } else n = ("000" + i).slice(-4);if (n += ("0" + (e.getUTCMonth() + 1)).slice(-2), n += ("0" + e.getUTCDate()).slice(-2), n += ("0" + e.getUTCHours()).slice(-2), n += ("0" + e.getUTCMinutes()).slice(-2), n += ("0" + e.getUTCSeconds()).slice(-2), r) {
          var o = e.getUTCMilliseconds();0 !== o && (n += "." + (o = (o = ("00" + o).slice(-3)).replace(/0+$/g, "")));
        }return n += "Z";
      }, t.uricmptohex = uricmptohex, t.hextouricmp = hextouricmp, t.ipv6tohex = ipv6tohex, t.hextoipv6 = hextoipv6, t.hextoip = hextoip, t.iptohex = function iptohex(e) {
        var t = "malformed IP address";if (!(e = e.toLowerCase(e)).match(/^[0-9.]+$/)) {
          if (e.match(/^[0-9a-f:]+$/) && -1 !== e.indexOf(":")) return ipv6tohex(e);throw t;
        }var r = e.split(".");if (4 !== r.length) throw t;var n = "";try {
          for (var i = 0; i < 4; i++) {
            n += ("0" + parseInt(r[i]).toString(16)).slice(-2);
          }return n;
        } catch (e) {
          throw t;
        }
      }, t.encodeURIComponentAll = encodeURIComponentAll, t.newline_toUnix = function newline_toUnix(e) {
        return e = e.replace(/\r\n/gm, "\n");
      }, t.newline_toDos = function newline_toDos(e) {
        return e = (e = e.replace(/\r\n/gm, "\n")).replace(/\n/gm, "\r\n");
      }, t.hextoposhex = hextoposhex, t.intarystrtohex = function intarystrtohex(e) {
        e = (e = (e = e.replace(/^\s*\[\s*/, "")).replace(/\s*\]\s*$/, "")).replace(/\s*/g, "");try {
          return e.split(/,/).map(function (e, t, r) {
            var n = parseInt(e);if (n < 0 || 255 < n) throw "integer not in range 0-255";return ("00" + n.toString(16)).slice(-2);
          }).join("");
        } catch (e) {
          throw "malformed integer array string: " + e;
        }
      }, t.strdiffidx = function strdiffidx(e, t) {
        var r = e.length;e.length > t.length && (r = t.length);for (var n = 0; n < r; n++) {
          if (e.charCodeAt(n) != t.charCodeAt(n)) return n;
        }return e.length != t.length ? r : -1;
      }, t.KJUR = K, t.crypto = K.crypto, t.asn1 = K.asn1, t.jws = K.jws, t.lang = K.lang;
    }).call(this, r(40).Buffer);
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.JoseUtil = void 0;var n = r(41),
        i = r(0);var o = ["RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512"];t.JoseUtil = function () {
      function JoseUtil() {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, JoseUtil);
      }return JoseUtil.parseJwt = function parseJwt(e) {
        i.Log.debug("JoseUtil.parseJwt");try {
          var t = n.jws.JWS.parse(e);return { header: t.headerObj, payload: t.payloadObj };
        } catch (e) {
          i.Log.error(e);
        }
      }, JoseUtil.validateJwt = function validateJwt(e, t, r, o, s, a) {
        i.Log.debug("JoseUtil.validateJwt");try {
          if ("RSA" === t.kty) {
            if (t.e && t.n) t = n.KEYUTIL.getKey(t);else {
              if (!t.x5c || !t.x5c.length) return i.Log.error("JoseUtil.validateJwt: RSA key missing key material", t), Promise.reject(new Error("RSA key missing key material"));var u = (0, n.b64tohex)(t.x5c[0]);t = n.X509.getPublicKeyFromCertHex(u);
            }
          } else {
            if ("EC" !== t.kty) return i.Log.error("JoseUtil.validateJwt: Unsupported key type", t && t.kty), Promise.reject(new Error("Unsupported key type: " + t && t.kty));if (!(t.crv && t.x && t.y)) return i.Log.error("JoseUtil.validateJwt: EC key missing key material", t), Promise.reject(new Error("EC key missing key material"));t = n.KEYUTIL.getKey(t);
          }return JoseUtil._validateJwt(e, t, r, o, s, a);
        } catch (e) {
          return i.Log.error(e && e.message || e), Promise.reject("JWT validation failed");
        }
      }, JoseUtil._validateJwt = function _validateJwt(e, t, r, s, a, u) {
        a || (a = 0), u || (u = parseInt(Date.now() / 1e3));var c = JoseUtil.parseJwt(e).payload;if (!c.iss) return i.Log.error("JoseUtil._validateJwt: issuer was not provided"), Promise.reject(new Error("issuer was not provided"));if (c.iss !== r) return i.Log.error("JoseUtil._validateJwt: Invalid issuer in token", c.iss), Promise.reject(new Error("Invalid issuer in token: " + c.iss));if (!c.aud) return i.Log.error("JoseUtil._validateJwt: aud was not provided"), Promise.reject(new Error("aud was not provided"));if (!(c.aud === s || Array.isArray(c.aud) && c.aud.indexOf(s) >= 0)) return i.Log.error("JoseUtil._validateJwt: Invalid audience in token", c.aud), Promise.reject(new Error("Invalid audience in token: " + c.aud));var h = u + a,
            f = u - a;if (!c.iat) return i.Log.error("JoseUtil._validateJwt: iat was not provided"), Promise.reject(new Error("iat was not provided"));if (h < c.iat) return i.Log.error("JoseUtil._validateJwt: iat is in the future", c.iat), Promise.reject(new Error("iat is in the future: " + c.iat));if (c.nbf && h < c.nbf) return i.Log.error("JoseUtil._validateJwt: nbf is in the future", c.nbf), Promise.reject(new Error("nbf is in the future: " + c.nbf));if (!c.exp) return i.Log.error("JoseUtil._validateJwt: exp was not provided"), Promise.reject(new Error("exp was not provided"));if (c.exp < f) return i.Log.error("JoseUtil._validateJwt: exp is in the past", c.exp), Promise.reject(new Error("exp is in the past:" + c.exp));try {
          if (!n.jws.JWS.verify(e, t, o)) return i.Log.error("JoseUtil._validateJwt: signature validation failed"), Promise.reject(new Error("signature validation failed"));
        } catch (e) {
          return i.Log.error(e && e.message || e), Promise.reject(new Error("signature validation failed"));
        }return Promise.resolve();
      }, JoseUtil.hashString = function hashString(e, t) {
        try {
          return n.crypto.Util.hashString(e, t);
        } catch (e) {
          i.Log.error(e);
        }
      }, JoseUtil.hexToBase64Url = function hexToBase64Url(e) {
        try {
          return (0, n.hextob64u)(e);
        } catch (e) {
          i.Log.error(e);
        }
      }, JoseUtil;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.UserInfoService = void 0;var n = r(17),
        i = r(3),
        o = r(0);t.UserInfoService = function () {
      function UserInfoService(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.JsonService,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService;if (function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, UserInfoService), !e) throw o.Log.error("UserInfoService.ctor: No settings passed"), new Error("settings");this._settings = e, this._jsonService = new t(), this._metadataService = new r(this._settings);
      }return UserInfoService.prototype.getClaims = function getClaims(e) {
        var t = this;return e ? this._metadataService.getUserInfoEndpoint().then(function (r) {
          return o.Log.debug("UserInfoService.getClaims: received userinfo url", r), t._jsonService.getJson(r, e).then(function (e) {
            return o.Log.debug("UserInfoService.getClaims: claims received", e), e;
          });
        }) : (o.Log.error("UserInfoService.getClaims: No token passed"), Promise.reject(new Error("A token is required")));
      }, UserInfoService;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.ResponseValidator = void 0;var n = r(0),
        i = r(3),
        o = r(43),
        s = r(16),
        a = r(42);var u = ["nonce", "at_hash", "iat", "nbf", "exp", "aud", "iss", "c_hash"];t.ResponseValidator = function () {
      function ResponseValidator(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.MetadataService,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : o.UserInfoService,
            s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : a.JoseUtil;if (function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, ResponseValidator), !e) throw n.Log.error("ResponseValidator.ctor: No settings passed to ResponseValidator"), new Error("settings");this._settings = e, this._metadataService = new t(this._settings), this._userInfoService = new r(this._settings), this._joseUtil = s;
      }return ResponseValidator.prototype.validateSigninResponse = function validateSigninResponse(e, t) {
        var r = this;return n.Log.debug("ResponseValidator.validateSigninResponse"), this._processSigninParams(e, t).then(function (t) {
          return n.Log.debug("ResponseValidator.validateSigninResponse: state processed"), r._validateTokens(e, t).then(function (e) {
            return n.Log.debug("ResponseValidator.validateSigninResponse: tokens validated"), r._processClaims(e).then(function (e) {
              return n.Log.debug("ResponseValidator.validateSigninResponse: claims processed"), e;
            });
          });
        });
      }, ResponseValidator.prototype.validateSignoutResponse = function validateSignoutResponse(e, t) {
        return e.id !== t.state ? (n.Log.error("ResponseValidator.validateSignoutResponse: State does not match"), Promise.reject(new Error("State does not match"))) : (n.Log.debug("ResponseValidator.validateSignoutResponse: state validated"), t.state = e.data, t.error ? (n.Log.warn("ResponseValidator.validateSignoutResponse: Response was error", t.error), Promise.reject(new s.ErrorResponse(t))) : Promise.resolve(t));
      }, ResponseValidator.prototype._processSigninParams = function _processSigninParams(e, t) {
        if (e.id !== t.state) return n.Log.error("ResponseValidator._processSigninParams: State does not match"), Promise.reject(new Error("State does not match"));if (!e.client_id) return n.Log.error("ResponseValidator._processSigninParams: No client_id on state"), Promise.reject(new Error("No client_id on state"));if (!e.authority) return n.Log.error("ResponseValidator._processSigninParams: No authority on state"), Promise.reject(new Error("No authority on state"));if (this._settings.authority) {
          if (this._settings.authority && this._settings.authority !== e.authority) return n.Log.error("ResponseValidator._processSigninParams: authority mismatch on settings vs. signin state"), Promise.reject(new Error("authority mismatch on settings vs. signin state"));
        } else this._settings.authority = e.authority;if (this._settings.client_id) {
          if (this._settings.client_id && this._settings.client_id !== e.client_id) return n.Log.error("ResponseValidator._processSigninParams: client_id mismatch on settings vs. signin state"), Promise.reject(new Error("client_id mismatch on settings vs. signin state"));
        } else this._settings.client_id = e.client_id;return n.Log.debug("ResponseValidator._processSigninParams: state validated"), t.state = e.data, t.error ? (n.Log.warn("ResponseValidator._processSigninParams: Response was error", t.error), Promise.reject(new s.ErrorResponse(t))) : e.nonce && !t.id_token ? (n.Log.error("ResponseValidator._processSigninParams: Expecting id_token in response"), Promise.reject(new Error("No id_token in response"))) : !e.nonce && t.id_token ? (n.Log.error("ResponseValidator._processSigninParams: Not expecting id_token in response"), Promise.reject(new Error("Unexpected id_token in response"))) : Promise.resolve(t);
      }, ResponseValidator.prototype._processClaims = function _processClaims(e) {
        var t = this;if (e.isOpenIdConnect) {
          if (n.Log.debug("ResponseValidator._processClaims: response is OIDC, processing claims"), e.profile = this._filterProtocolClaims(e.profile), this._settings.loadUserInfo && e.access_token) return n.Log.debug("ResponseValidator._processClaims: loading user info"), this._userInfoService.getClaims(e.access_token).then(function (r) {
            return n.Log.debug("ResponseValidator._processClaims: user info claims received from user info endpoint"), r.sub !== e.profile.sub ? (n.Log.error("ResponseValidator._processClaims: sub from user info endpoint does not match sub in access_token"), Promise.reject(new Error("sub from user info endpoint does not match sub in access_token"))) : (e.profile = t._mergeClaims(e.profile, r), n.Log.debug("ResponseValidator._processClaims: user info claims received, updated profile:", e.profile), e);
          });n.Log.debug("ResponseValidator._processClaims: not loading user info");
        } else n.Log.debug("ResponseValidator._processClaims: response is not OIDC, not processing claims");return Promise.resolve(e);
      }, ResponseValidator.prototype._mergeClaims = function _mergeClaims(e, t) {
        var r = Object.assign({}, e);for (var n in t) {
          var i = t[n];Array.isArray(i) || (i = [i]);for (var o = 0; o < i.length; o++) {
            var s = i[o];r[n] ? Array.isArray(r[n]) ? r[n].indexOf(s) < 0 && r[n].push(s) : r[n] !== s && (r[n] = [r[n], s]) : r[n] = s;
          }
        }return r;
      }, ResponseValidator.prototype._filterProtocolClaims = function _filterProtocolClaims(e) {
        n.Log.debug("ResponseValidator._filterProtocolClaims, incoming claims:", e);var t = Object.assign({}, e);return this._settings._filterProtocolClaims ? (u.forEach(function (e) {
          delete t[e];
        }), n.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims filtered", t)) : n.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims not filtered"), t;
      }, ResponseValidator.prototype._validateTokens = function _validateTokens(e, t) {
        return t.id_token ? t.access_token ? (n.Log.debug("ResponseValidator._validateTokens: Validating id_token and access_token"), this._validateIdTokenAndAccessToken(e, t)) : (n.Log.debug("ResponseValidator._validateTokens: Validating id_token"), this._validateIdToken(e, t)) : (n.Log.debug("ResponseValidator._validateTokens: No id_token to validate"), Promise.resolve(t));
      }, ResponseValidator.prototype._validateIdTokenAndAccessToken = function _validateIdTokenAndAccessToken(e, t) {
        var r = this;return this._validateIdToken(e, t).then(function (e) {
          return r._validateAccessToken(e);
        });
      }, ResponseValidator.prototype._validateIdToken = function _validateIdToken(e, t) {
        var r = this;if (!e.nonce) return n.Log.error("ResponseValidator._validateIdToken: No nonce on state"), Promise.reject(new Error("No nonce on state"));var i = this._joseUtil.parseJwt(t.id_token);if (!i || !i.header || !i.payload) return n.Log.error("ResponseValidator._validateIdToken: Failed to parse id_token", i), Promise.reject(new Error("Failed to parse id_token"));if (e.nonce !== i.payload.nonce) return n.Log.error("ResponseValidator._validateIdToken: Invalid nonce in id_token"), Promise.reject(new Error("Invalid nonce in id_token"));var o = i.header.kid;return this._metadataService.getIssuer().then(function (s) {
          return n.Log.debug("ResponseValidator._validateIdToken: Received issuer"), r._metadataService.getSigningKeys().then(function (a) {
            if (!a) return n.Log.error("ResponseValidator._validateIdToken: No signing keys from metadata"), Promise.reject(new Error("No signing keys from metadata"));n.Log.debug("ResponseValidator._validateIdToken: Received signing keys");var u = void 0;if (o) u = a.filter(function (e) {
              return e.kid === o;
            })[0];else {
              if ((a = r._filterByAlg(a, i.header.alg)).length > 1) return n.Log.error("ResponseValidator._validateIdToken: No kid found in id_token and more than one key found in metadata"), Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));u = a[0];
            }if (!u) return n.Log.error("ResponseValidator._validateIdToken: No key matching kid or alg found in signing keys"), Promise.reject(new Error("No key matching kid or alg found in signing keys"));var c = e.client_id,
                h = r._settings.clockSkew;return n.Log.debug("ResponseValidator._validateIdToken: Validaing JWT; using clock skew (in seconds) of: ", h), r._joseUtil.validateJwt(t.id_token, u, s, c, h).then(function () {
              return n.Log.debug("ResponseValidator._validateIdToken: JWT validation successful"), i.payload.sub ? (t.profile = i.payload, t) : (n.Log.error("ResponseValidator._validateIdToken: No sub present in id_token"), Promise.reject(new Error("No sub present in id_token")));
            });
          });
        });
      }, ResponseValidator.prototype._filterByAlg = function _filterByAlg(e, t) {
        var r = null;if (t.startsWith("RS")) r = "RSA";else if (t.startsWith("PS")) r = "PS";else {
          if (!t.startsWith("ES")) return n.Log.debug("ResponseValidator._filterByAlg: alg not supported: ", t), [];r = "EC";
        }return n.Log.debug("ResponseValidator._filterByAlg: Looking for keys that match kty: ", r), e = e.filter(function (e) {
          return e.kty === r;
        }), n.Log.debug("ResponseValidator._filterByAlg: Number of keys that match kty: ", r, e.length), e;
      }, ResponseValidator.prototype._validateAccessToken = function _validateAccessToken(e) {
        if (!e.profile) return n.Log.error("ResponseValidator._validateAccessToken: No profile loaded from id_token"), Promise.reject(new Error("No profile loaded from id_token"));if (!e.profile.at_hash) return n.Log.error("ResponseValidator._validateAccessToken: No at_hash in id_token"), Promise.reject(new Error("No at_hash in id_token"));if (!e.id_token) return n.Log.error("ResponseValidator._validateAccessToken: No id_token"), Promise.reject(new Error("No id_token"));var t = this._joseUtil.parseJwt(e.id_token);if (!t || !t.header) return n.Log.error("ResponseValidator._validateAccessToken: Failed to parse id_token", t), Promise.reject(new Error("Failed to parse id_token"));var r = t.header.alg;if (!r || 5 !== r.length) return n.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", r), Promise.reject(new Error("Unsupported alg: " + r));var i = r.substr(2, 3);if (!i) return n.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", r, i), Promise.reject(new Error("Unsupported alg: " + r));if (256 !== (i = parseInt(i)) && 384 !== i && 512 !== i) return n.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", r, i), Promise.reject(new Error("Unsupported alg: " + r));var o = "sha" + i,
            s = this._joseUtil.hashString(e.access_token, o);if (!s) return n.Log.error("ResponseValidator._validateAccessToken: access_token hash failed:", o), Promise.reject(new Error("Failed to validate at_hash"));var a = s.substr(0, s.length / 2),
            u = this._joseUtil.hexToBase64Url(a);return u !== e.profile.at_hash ? (n.Log.error("ResponseValidator._validateAccessToken: Failed to validate at_hash", u, e.profile.at_hash), Promise.reject(new Error("Failed to validate at_hash"))) : (n.Log.debug("ResponseValidator._validateAccessToken: success"), Promise.resolve(e));
      }, ResponseValidator;
    }();
  }, function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = r(0),
        i = r(18),
        o = r(6),
        s = r(5),
        a = r(31),
        u = r(30),
        c = r(12),
        h = r(3),
        f = r(20),
        l = r(19),
        g = r(9),
        p = r(8),
        d = r(10),
        v = r(1),
        y = r(13);t.default = { Log: n.Log, OidcClient: i.OidcClient, OidcClientSettings: o.OidcClientSettings, WebStorageStateStore: s.WebStorageStateStore, InMemoryWebStorage: a.InMemoryWebStorage, UserManager: u.UserManager, AccessTokenEvents: c.AccessTokenEvents, MetadataService: h.MetadataService, CordovaPopupNavigator: f.CordovaPopupNavigator, CordovaIFrameNavigator: l.CordovaIFrameNavigator, CheckSessionIFrame: g.CheckSessionIFrame, TokenRevocationClient: p.TokenRevocationClient, SessionMonitor: d.SessionMonitor, Global: v.Global, User: y.User }, e.exports = t.default;
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)(module)))

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppBreadcrumb_Vue_vue_type_template_id_45010efe__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppBreadcrumb_Vue_vue_type_script_lang_js__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AppBreadcrumb_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__AppBreadcrumb_Vue_vue_type_template_id_45010efe__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AppBreadcrumb_Vue_vue_type_template_id_45010efe__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(5);
var normalizeHeaderName = __webpack_require__(121);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(26);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(26);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideMenu_Vue_vue_type_template_id_129dd008__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideMenu_Vue_vue_type_script_lang_js__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SideMenu_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SideMenu_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SideMenu_Vue_vue_type_template_id_129dd008__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SideMenu_Vue_vue_type_template_id_129dd008__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getVersionText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVersionDestructor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getVersionDestructorArr; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getVersionText = function getVersionText(version) {
  if (Math.abs(version.major - 0x7FFFFFFF) < 0.1) return "Current version";
  return '' + version.major + '.' + version.minor + '.' + version.build;
};

var getVersionDestructor = function getVersionDestructor(version) {
  return _extends({}, version, { text: getVersionText(version) });
};

var getVersionDestructorArr = function getVersionDestructorArr(versions) {
  var result = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = versions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var version = _step.value;

      result.push(getVersionDestructor(version));
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
};

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//download.js v4.2, by dandavis; 2008-2016. [CCBY2] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
	if (typeof define === 'function' && __webpack_require__(178)) {
		// AMD. Register as an anonymous module.
		define([], factory);
	} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.download = factory();
	}
})(this, function () {

	return function download(data, strFileName, strMimeType) {

		var self = window,
		    // this script is only for browsers anyway...
		defaultMime = "application/octet-stream",
		    // this default mime also triggers iframe downloads
		mimeType = strMimeType || defaultMime,
		    payload = data,
		    url = !strFileName && !strMimeType && payload,
		    anchor = document.createElement("a"),
		    toString = function toString(a) {
			return String(a);
		},
		    myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
		    fileName = strFileName || "download",
		    blob,
		    reader;
		myBlob = myBlob.call ? myBlob.bind(self) : Blob;

		if (String(this) === "true") {
			//reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
			payload = [payload, mimeType];
			mimeType = payload[0];
			payload = payload[1];
		}

		if (url && url.length < 2048) {
			// if no filename and no mime, assume a url was passed as the only argument
			fileName = url.split("/").pop().split("?")[0];
			anchor.href = url; // assign href prop to temp anchor
			if (anchor.href.indexOf(url) !== -1) {
				// if the browser determines that it's a potentially valid url path:
				var ajax = new XMLHttpRequest();
				ajax.open("GET", url, true);
				ajax.responseType = 'blob';
				ajax.onload = function (e) {
					download(e.target.response, fileName, defaultMime);
				};
				setTimeout(function () {
					ajax.send();
				}, 0); // allows setting custom ajax headers using the return:
				return ajax;
			} // end if valid url?
		} // end if url?


		//go ahead and download dataURLs right away
		if (/^data\:[\w+\-]+\/[\w+\-]+[,;]/.test(payload)) {

			if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
				payload = dataUrlToBlob(payload);
				mimeType = payload.type || defaultMime;
			} else {
				return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
				navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
			}
		} //end if dataURL passed?

		blob = payload instanceof myBlob ? payload : new myBlob([payload], { type: mimeType });

		function dataUrlToBlob(strUrl) {
			var parts = strUrl.split(/[:;,]/),
			    type = parts[1],
			    decoder = parts[2] == "base64" ? atob : decodeURIComponent,
			    binData = decoder(parts.pop()),
			    mx = binData.length,
			    i = 0,
			    uiArr = new Uint8Array(mx);

			for (i; i < mx; ++i) {
				uiArr[i] = binData.charCodeAt(i);
			}return new myBlob([uiArr], { type: type });
		}

		function saver(url, winMode) {

			if ('download' in anchor) {
				//html5 A[download]
				anchor.href = url;
				anchor.setAttribute("download", fileName);
				anchor.className = "download-js-link";
				anchor.innerHTML = "downloading...";
				anchor.style.display = "none";
				document.body.appendChild(anchor);
				setTimeout(function () {
					anchor.click();
					document.body.removeChild(anchor);
					if (winMode === true) {
						setTimeout(function () {
							self.URL.revokeObjectURL(anchor.href);
						}, 250);
					}
				}, 66);
				return true;
			}

			// handle non-a[download] safari as best we can:
			if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
				url = url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				if (!window.open(url)) {
					// popup blocked, offer direct download:
					if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
						location.href = url;
					}
				}
				return true;
			}

			//do iframe dataURL download (old ch+FF):
			var f = document.createElement("iframe");
			document.body.appendChild(f);

			if (!winMode) {
				// force a mime that will download:
				url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
			}
			f.src = url;
			setTimeout(function () {
				document.body.removeChild(f);
			}, 333);
		} //end saver


		if (navigator.msSaveBlob) {
			// IE10+ : (has Blob, but not a[download] or URL)
			return navigator.msSaveBlob(blob, fileName);
		}

		if (self.URL) {
			// simple fast and modern way using Blob and URL:
			saver(self.URL.createObjectURL(blob), true);
		} else {
			// handle non-Blob()+non-URL browsers:
			if (typeof blob === "string" || blob.constructor === toString) {
				try {
					return saver("data:" + mimeType + ";base64," + self.btoa(blob));
				} catch (y) {
					return saver("data:" + mimeType + "," + encodeURIComponent(blob));
				}
			}

			// Blob but not URL support:
			reader = new FileReader();
			reader.onload = function (e) {
				saver(this.result);
			};
			reader.readAsDataURL(blob);
		}
		return true;
	}; /* end download() */
});

/* unused harmony default export */ var _unused_webpack_default_export = (this);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(177)(module)))

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js__ = __webpack_require__(21);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppHeader__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Http__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  components: { AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_AppHeader__["a" /* default */] },
  data: function data() {
    return {
      username: "a"
    };
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppHeader_Vue_vue_type_script_lang_js__ = __webpack_require__(23);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppHeader_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import this.HTTP from "./Http";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-header",
  data: function data() {
    return {
      isMobile: false,
      selectedItem: this.$route.path.toLowerCase(),
      dropdownActive: false
    };
  },

  // computed: {
  //   profile: function() {
  //     return this.$userName;
  //   }
  // },
  methods: {
    logout: function logout() {
      this.HTTP.deleteUserProfile();
      this.HTTP.logout();
    },
    goToSettings: function goToSettings() {
      this.$router.push("ProfileSettings");
    },
    onMouseOutListener: function onMouseOutListener(e) {
      var header = document.getElementById("appheader");
      if (header != undefined && header.contains(e.target)) {} else {
        this.isMobile = false;
      }
      var profileMenu = document.getElementById("profileMenu");
      if (profileMenu != undefined && !document.getElementById("profileMenu").contains(e.target)) {
        this.dropdownActive = false;
      }
    }
  },
  created: function created() {
    window.addEventListener("mouseout", this.onMouseOutListener);
    this.HTTP.load();
    //if (this.HTTP.getToken()) {
    //this.profile = "Sign Out";
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("mouseout", this.onMouseOutListener);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_oidc_client__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_oidc_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_oidc_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_path__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_path__);
var _MagicHttp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Axios Client with defaults parameters
 */



var tokenKey = "ChangeLoggerAccessToken";

var axiosInstanse = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "https://changelogger.fast-report.com/api/"
  // timeout: 1000,
});

var mgr = new __WEBPACK_IMPORTED_MODULE_1_oidc_client__["UserManager"]({
  userStore: new __WEBPACK_IMPORTED_MODULE_1_oidc_client__["WebStorageStateStore"]({ store: window.localStorage }),
  authority: "https://id.fast-report.com",
  client_id: "change.logger",
  redirect_uri: "https://changelogger.fast-report.com/#/callback#",
  response_type: "id_token token",
  scope: "openid profile email change.logger.roles fr.id.role fr.cloud.role",
  post_logout_redirect_uri: "https://changelogger.fast-report.com",
  loadUserInfo: true,
  //accessTokenExpiringNotificationTime: 3540,
  includeIdTokenInSilentRenew: true,
  // silent renew will get a new access_token via an iframe 
  // just prior to the old access_token expiring (60 seconds prior)
  silent_redirect_uri: "https://changelogger.fast-report.com/#/Silent#", //window.location.protocol + "//" + window.location.host + "/silent",
  automaticSilentRenew: true,

  // will revoke (reference) access tokens at logout time
  revokeAccessTokenOnSignout: true,

  // this will allow all the OIDC protocol claims to be visible in the window. normally a client app 
  // wouldn't care about them or want them taking up space
  filterProtocolClaims: false
});

mgr.events.addAccessTokenExpiring(function () {
  console.log("Access token expiring...");
});

mgr.events.addSilentRenewError(function (err) {
  console.log("Silent renew error: " + err.message);
});

var setHeaderInternal = function setHeaderInternal() {
  return new Promise(function (resolve, reject) {

    mgr.getUser().then(function (user) {
      if (user) {
        if (user.expired) {

          mgr.signinSilent().then(function () {
            axiosInstanse.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token;
            resolve();
          }).catch(function (ex) {
            mgr.signinRedirect();
          });
        } else {
          axiosInstanse.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token;
          resolve();
        }
      }
    }).catch(function (e) {
      reject();
      console.log(e);
    });
  });
};

var deleteHeader = function deleteHeader() {
  axiosInstanse.defaults.headers.common['Authorization'] = null;
};

var MagicHttp = (_MagicHttp = {
  get: function get() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new Promise(function (resolve, reject) {

      MagicHttp.setHeader().then(function () {

        resolve(axiosInstanse.get.apply(axiosInstanse, args));
      });
    });
  },
  post: function post() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return new Promise(function (resolve, reject) {

      MagicHttp.setHeader().then(function () {

        resolve(axiosInstanse.post.apply(axiosInstanse, args));
      });
    });
  },
  put: function put() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return new Promise(function (resolve, reject) {

      MagicHttp.setHeader().then(function () {

        resolve(axiosInstanse.put.apply(axiosInstanse, args));
      });
    });
  },
  delete: function _delete() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return new Promise(function (resolve, reject) {

      MagicHttp.setHeader().then(function () {

        resolve(axiosInstanse.delete.apply(axiosInstanse, args));
      });
    });
  },
  load: function load() {

    return MagicHttp.setHeader();
  },
  logout: function logout() {
    mgr.signoutRedirect();
    deleteHeader();
  },
  setHeader: function setHeader() {
    return setHeaderInternal();
  },

  signinRedirect: function signinRedirect() {
    return mgr.signinRedirect.apply(mgr, arguments);
  },
  signinRedirectCallback: function signinRedirectCallback() {
    return mgr.signinRedirectCallback.apply(mgr, arguments);
  },
  getUser: function getUser() {
    return mgr.getUser.apply(mgr, arguments);
  },
  removeUser: function removeUser() {
    return mgr.removeUser.apply(mgr, arguments);
  },
  signinSilentCallback: function signinSilentCallback() {
    return mgr.signinSilentCallback.apply(mgr, arguments);
  }
}, _defineProperty(_MagicHttp, 'getUser', function getUser() {
  return mgr.getUser();
}), _defineProperty(_MagicHttp, 'setUserProfile', function setUserProfile(userProfile) {
  localStorage.setItem("userProfile", JSON.stringify(userProfile));
}), _defineProperty(_MagicHttp, 'getUserProfile', function getUserProfile() {
  return JSON.parse(localStorage.getItem("userProfile"));
}), _defineProperty(_MagicHttp, 'deleteUserProfile', function deleteUserProfile() {
  localStorage.removeItem("userProfile");
}), _MagicHttp);

/* harmony default export */ __webpack_exports__["a"] = (MagicHttp);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var settle = __webpack_require__(122);
var buildURL = __webpack_require__(124);
var parseHeaders = __webpack_require__(125);
var isURLSameOrigin = __webpack_require__(126);
var createError = __webpack_require__(27);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(127);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(123);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(137);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("05607176", content, true, {});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Changes_Vue_vue_type_script_lang_js__ = __webpack_require__(32);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Changes_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideMenu__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppBreadcrumb__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChangesContentFilter__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeCard__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChangeEditor__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DeleteConfirmer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_pagination_src_Pagination__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChangesSaver__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_min_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import AppHeader from "./components/AppHeader";












//import this.HTTP from "../Http";
String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.replace(new RegExp(search, 'g'), replacement);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "changes-view",
  components: {
    SideMenu: __WEBPACK_IMPORTED_MODULE_0__SideMenu__["a" /* default */],
    AppBreadcrumb: __WEBPACK_IMPORTED_MODULE_1__AppBreadcrumb__["a" /* default */],
    ChangesContentFilter: __WEBPACK_IMPORTED_MODULE_2__ChangesContentFilter__["a" /* default */],
    ChangeCard: __WEBPACK_IMPORTED_MODULE_3__ChangeCard__["a" /* default */],
    ChangeEditor: __WEBPACK_IMPORTED_MODULE_4__ChangeEditor__["a" /* default */],
    DeleteConfirmer: __WEBPACK_IMPORTED_MODULE_5__DeleteConfirmer__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_pagination_src_Pagination__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default.a,
    ChangesSaver: __WEBPACK_IMPORTED_MODULE_7__ChangesSaver__["a" /* default */]
  },
  data: function data() {
    return {
      products: [],
      changes: [],
      productsHeader: "Products",
      isEditorVisible: false,
      isDeleteModalVisible: false,
      deleteHeader: "Are you sure that you wanna delete this change?",
      deleteMsg: "This change will be losted forever!!!(",
      productId: -1,
      changeId: -1,
      changeEditorHeader: "",

      //change filter params
      filterGroups: ["All", "Public", "Private"],
      filterType: "All",

      //pagination
      page: {
        pageNumber: 1,
        totalPages: 13,
        pageSize: 10,
        totalItems: -1
      },

      searchingText: "",
      loading: false,

      isSaveDialogVisible: false,
      saveType: "All",
      language: "english",
      fileType: "txt",
      mustExpandCards: false
    };
  },

  computed: {
    filterMsg: function filterMsg() {
      if (this.page.totalItems > 0) return "<strong>" + this.page.totalItems + "</strong> changes";else return "";
    }
  },
  methods: {
    getProducts: function getProducts() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.HTTP.get("products/" + 1 + "/" + 100).then(function (response) {
          resolve(response);
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    getChanges: function getChanges() {
      var _this2 = this;

      this.loading = true;
      var query = "changes/product/";
      if (this.searchingText.length > 0) {
        query += "search/";
      }
      query += this.productId + "/" + this.page.pageNumber + "/" + this.page.pageSize + "/" + this.filterType;
      if (this.searchingText !== null && this.searchingText !== undefined && this.searchingText.length > 0) {
        query += "/" + this.searchingText;
      }
      this.HTTP.get(query.replaceAll("#", "%23")).then(function (response) {
        _this2.changes = response.data.entities;
        _this2.page = response.data.page;
        _this2.loading = false;
      }).catch(function (e) {
        console.log(e);
      });
    },
    toggleChanges: function toggleChanges(productId) {
      this.productId = productId;
      this.page.pageNumber = 1;
      this.searchingText = "";
    },
    createChange: function createChange() {
      this.isEditorVisible = true;
      this.changeId = -1; //shouldn't edit
      this.changeEditorHeader = "Create new change";
    },
    editChange: function editChange(id) {
      this.isEditorVisible = true;
      this.changeId = id;
      this.changeEditorHeader = "Edit change";
    },
    deleteChangeModal: function deleteChangeModal(id) {
      this.isDeleteModalVisible = true;
      this.changeId = id;
    },
    deleteChange: function deleteChange() {
      var _this3 = this;

      this.HTTP.delete("changes/" + this.changeId).then(function (response) {
        _this3.closeChangeDeleteWindow();
      }).catch(function (e) {
        console.log(e);
      });
    },
    closeChangeEditor: function closeChangeEditor() {
      this.isEditorVisible = false;
      this.getChanges(); //should be optimized!
    },
    closeChangeDeleteWindow: function closeChangeDeleteWindow() {
      this.isDeleteModalVisible = false;
      this.getChanges(); //should be optimized!
    },
    filtrateChanges: function filtrateChanges(filterType) {
      this.filterType = filterType;
    },


    //pagination

    urlBuilder: function urlBuilder(page) {
      return { query: _extends({}, this.$route.query, { page: page }) }; // Changing page in location query
    },
    searchHandler: function searchHandler(searchingText) {
      this.searchingText = searchingText;
    },
    clearSearch: function clearSearch() {
      this.searchingText = "";
      this.page.pageNumber = 1;
    },
    pushUrl: function pushUrl() {
      this.$router.push({
        path: "Changes",
        query: {
          productId: this.productId,
          page: this.page.pageNumber,
          search: this.searchingText,
          filterType: this.filterType
        }
      });
    },
    saveClick: function saveClick() {
      this.isSaveDialogVisible = true;
    },
    closeSaveChangesWindow: function closeSaveChangesWindow() {
      this.isSaveDialogVisible = false;
    },
    saveChanges: function saveChanges(saveType, language, fileType, groupingType, tagsList) {
      console.log(saveType, language);
      this.saveType = saveType;
      this.fileType = fileType;
      this.language = fileType == "json" ? "" : language;
      this.isSaveDialogVisible = false;

      this.$router.push({
        path: "ChangesSaving",
        query: {
          productId: this.productId,
          search: this.searchingText,
          filterType: this.filterType,
          saveType: this.saveType,
          language: this.language,
          fileType: this.fileType,
          grouping: groupingType,
          tags: tagsList
        }
      });
    },
    expandAllCards: function expandAllCards(mustExpand) {
      this.mustExpandCards = mustExpand;
    }
  },
  created: function created() {
    var _this4 = this;

    if (this.cardsCount) {
      this.page.pageSize = this.cardsCount;
    }
    console.log("http here!!!");
    console.log(this.userName);
    this.loading = true;
    this.HTTP.load(); //.then(() => {
    this.getProducts().then(function (response) {
      _this4.products = response.data.entities;
      if (response.data.entities.length > 0 && (_this4.$route.query.productId == null || _this4.$route.query.productId < 0)) _this4.productId = !isNaN(_this4.selectedProductId) ? _this4.selectedProductId : response.data.entities[0].id;else _this4.productId = parseInt(_this4.$route.query.productId);
      //this.pushUrl();
      _this4.getChanges();
      //})
      // .catch(e => {
      //   console.log(e);
      // });
    });
  },

  watch: {
    $route: function $route(to, from) {
      if (to.query.page != null && to.query.page != undefined) {
        this.page.pageNumber = parseInt(to.query.page);
        this.productId = parseInt(to.query.productId);
        this.searchingText = to.query.search;
        this.filterType = to.query.filterType;
      }
      // this.HTTP.setHeader().then(() => {})
      this.getChanges();
    },

    productId: function productId(val) {
      if (!isNaN(val)) this.selectedProductId = val;
      this.pushUrl();
    },
    searchingText: function searchingText(val) {
      this.pushUrl();
    },
    filterType: function filterType(val) {
      this.pushUrl();
    },
    page: function page(val) {
      this.pushUrl();
    }
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SideMenu_Vue_vue_type_script_lang_js__ = __webpack_require__(34);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SideMenu_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "side-menu",
  props: {
    header: String,
    items: Array,
    selectedItemId: Number
  },
  data: function data() {
    return {
      selectedItemIdPriv: -1 // for indication
    };
  },

  methods: {
    elementClick: function elementClick(id) {
      this.$emit("elementClick", id);
    }
  }
  // computed: {
  //   selectedItemId: {
  //     get: function() {
  //       if (this.selectedItemIdPriv == -1) {
  //         return this.items[0].id;
  //       } else {
  //         return this.selectedItemIdPriv;
  //       }
  //     },
  //     set: function(newVal) {
  //       this.selectedItemIdPriv = newVal;
  //     }
  //   }
  // }
});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(147);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("6d5d75a3", content, true, {});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppBreadcrumb_Vue_vue_type_script_lang_js__ = __webpack_require__(37);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppBreadcrumb_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-breadcrumd",
  props: {
    breadcrumbItems: Array
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesContentFilter_Vue_vue_type_script_lang_js__ = __webpack_require__(39);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesContentFilter_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentFilter__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "changes-content-filter",
  components: { ContentFilter: __WEBPACK_IMPORTED_MODULE_0__ContentFilter__["a" /* default */] },
  props: {
    createNewItem: Function,
    saveClick: Function,
    filterGroups: Array, //one item -> name
    infoMsg: String //HTML, e.g. count of the items
  },
  data: function data() {
    return {
      curFilter: "",
      expanded: "collapsed"
    };
  },

  methods: {
    //return filtration type to the parent
    filtrate: function filtrate(groupName) {
      this.curFilter = groupName;
      this.$emit("filtrate", groupName);
    },
    searchClick: function searchClick(searchingText) {
      this.$emit("searchClick", searchingText);
    }
  },
  watch: {
    expanded: function expanded(newExpanded) {
      var isExpended = newExpanded == "expanded" ? true : false;
      this.$emit("expand", isExpended);
    }
  },
  created: function created() {
    if (this.filterGroups !== null && this.filterGroups != undefined && this.filterGroups.length > 0) this.curFilter = this.filterGroups[0];
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentFilter_Vue_vue_type_script_lang_js__ = __webpack_require__(41);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentFilter_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "content-filter",
  props: {
    createNewItem: Function,
    filterGroups: Array, //one item -> name
    infoMsg: String //HTML, e.g. count of the items
  },
  data: function data() {
    return {
      curFilter: "",
      searchingText: ""
    };
  },

  methods: {
    //return filtration type to the parent
    filtrate: function filtrate(groupName) {
      this.curFilter = groupName;
      this.$emit("filtrate", groupName);
    },
    searchClick: function searchClick() {
      this.$emit("searchClick", this.searchingText);
      this.searchingText = "";
    }
  },
  created: function created() {
    if (this.filterGroups !== null && this.filterGroups != undefined && this.filterGroups.length > 0) this.curFilter = this.filterGroups[0];
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChangeCard_Vue_vue_type_template_id_668ec952__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangeCard_Vue_vue_type_script_lang_js__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChangeCard_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ChangeCard_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ChangeCard_Vue_vue_type_template_id_668ec952__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ChangeCard_Vue_vue_type_template_id_668ec952__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeCard_Vue_vue_type_script_lang_js__ = __webpack_require__(44);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeCard_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import this.HTTP from "./Http";



var groupKey = {
  name: "default"
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "change-card",
  props: {
    action1: String, //Edit
    action2: String, //Delete
    action3: String, //search
    change: Object,
    isExpandedCard: Boolean
  },
  data: function data() {
    return {
      userName: "Johnessa",
      userFamilyName: "Doe"
    };
  },

  computed: {
    id: function id() {
      return this.change.id;
    },
    date: function date() {
      var date = new Date(this.change.createDate);
      return date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
    },
    version: function version() {
      return this.change.version;
    },
    type: function type() {
      return this.change.type;
    },
    group: function group() {
      return (this.change.group || groupKey).name;
    },
    userFullName: function userFullName() {
      if (this.change.user != null) return this.change.user.name + " " + (this.change.user.familyName ? this.change.user.familyName : ""); // + " " + this.change.user.familyName;
      else return "John Doe";
    },
    documentationLink: function documentationLink() {
      return this.change.translations[0].documentationLink;
    },
    translation: function translation() {
      var translations = this.change.translations;
      console.log(translations);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = translations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var translation = _step.value;

          if (translation.language == "English") return translation;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = translations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _translation = _step2.value;

          return _translation;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    },
    translations: function translations() {
      return this.change.translations;
    },
    isPrivate: function isPrivate() {
      return this.change.isPrivate;
    },
    taskLink: function taskLink() {
      return this.change.taskLink;
    },
    mergeRequestLink: function mergeRequestLink() {
      return this.change.mergeRequestLink;
    },
    userLink: function userLink() {
      return "https://id.fast-report.com" + "/Profile/Index/" + this.change.userId;
    },
    versionText: function versionText() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* getVersionText */])(this.change.version);
    }
  },
  methods: {
    runAction1: function runAction1() {
      this.$emit(this.action1, this.id);
    },
    runAction2: function runAction2() {
      this.$emit(this.action2, this.id);
    },
    runAction3: function runAction3(searchingText) {
      this.$emit(this.action3, searchingText);
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(158);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("65ff2d37", content, true, {});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEditor_Vue_vue_type_script_lang_js__ = __webpack_require__(47);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEditor_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalWindow__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "change-editor",
  components: { ModalWindow: __WEBPACK_IMPORTED_MODULE_0__ModalWindow__["a" /* default */] },
  props: {
    changeId: Number,
    productId: Number,
    header: String
  },
  data: function data() {
    return {
      tags: ["Auckland", "Wellington", "Very long string that would overflow"],
      newChangeText: "",
      newChangeAnnotation: "",
      newChangeDocLink: "",

      newChangeTextRu: "",
      newChangeAnnotationRu: "",
      newChangeDocLinkRu: "",

      newChangeTaskLink: "",
      newChangeMergeLink: "",

      newChangeIsPrivate: 0,
      newTags: [],
      tagsIds: [],
      allTags: [],
      filteredTags: [],

      versions: [],
      currentVersion: { id: 1 },
      selectedVersion: 1,

      changeTypes: [],
      selectedChangeType: "Added",
      changeGroups: [],
      selectedChangeGroupId: -1,

      //form validation data
      textIsValid: true,
      saveClicked: false,

      recordProcessing: false, //should prevent record duplicate creating
      loading: false,

      enIsOpen: false,
      ruIsOpen: false,
      collapseText: "Less",
      expandText: "More"
    };
  },

  computed: {
    userId: function userId() {
      return this.HTTP.getUserProfile().id;
    },
    tagsArray: function tagsArray() {
      var _this = this;

      if (this.newTags != null && this.newTags.length > 0) {
        var parts = this.newTags.split(",");
        var partsObj = void 0;
        var partsArray = [];
        parts.forEach(function (element) {
          if (element.trim().length > 0) {
            partsObj = {
              productId: _this.productId,
              group: {
                name: element.trim()
              }
            };
            partsArray.push(partsObj);
          }
        });
        return partsArray;
      } else return null;
    }
  },
  methods: {
    createChange: function createChange() {
      var _this2 = this;

      this.HTTP.post("changes", {
        versionId: this.selectedVersion,
        documentationLink: this.newChangeDocLink,
        taskLink: this.newChangeTaskLink,
        mergeRequestLink: this.newChangeMergeLink,
        isPrivate: this.newChangeIsPrivate,
        translations: [{
          language: "English",
          text: this.newChangeText,
          annotation: this.newChangeAnnotation,
          documentationLink: this.newChangeDocLink
        }, {
          language: "Russian",
          text: this.newChangeTextRu,
          annotation: this.newChangeAnnotationRu,
          documentationLink: this.newChangeDocLinkRu
        }],
        type: this.selectedChangeType,
        groupId: this.selectedChangeGroupId,
        changeTagRels: this.newTags.map(function (t) {
          return {
            tag: { name: t }
          };
        })
      }).then(function (response) {
        _this2.recordProcessing = false;
        _this2.$emit("closeChangeEditor");
      }).catch(function (e) {
        _this2.recordProcessing = false;
        console.log(e.text);
      });
    },
    editChange: function editChange(changeId) {
      var _this3 = this;

      this.HTTP.put("changes/" + changeId, {
        id: changeId,
        versionId: this.selectedVersion,
        taskLink: this.newChangeTaskLink,
        mergeRequestLink: this.newChangeMergeLink,
        documentationLink: this.newChangeDocLink,
        isPrivate: this.newChangeIsPrivate,
        translations: [{
          language: "English",
          text: this.newChangeText,
          annotation: this.newChangeAnnotation,
          documentationLink: this.newChangeDocLink
        }, {
          language: "russian",
          text: this.newChangeTextRu,
          annotation: this.newChangeAnnotationRu,
          documentationLink: this.newChangeDocLinkRu
        }],
        type: this.selectedChangeType,
        groupId: this.selectedChangeGroupId,
        changeTagRels: this.newTags.map(function (t) {
          return {
            tag: { name: t },
            changeId: changeId
          };
        })
      }).then(function (response) {
        _this3.recordProcessing = false;
        _this3.$emit("closeChangeEditor");
      }).catch(function (e) {
        _this3.recordProcessing = false;
        console.log(e.text);
      });
    },
    getChange: function getChange(id) {
      var _this4 = this;

      this.loading = true;
      this.HTTP.get("changes/" + id).then(function (response) {
        if (response.data.translations != null && response.data.translations.length > 0) {
          response.data.translations.forEach(function (translation) {
            if (translation.language.toLowerCase() == "english") {
              _this4.newChangeText = translation.text;
              _this4.newChangeAnnotation = translation.annotation;
              _this4.newChangeDocLink = translation.documentationLink;
            } else if (translation.language.toLowerCase() == "russian") {
              _this4.newChangeTextRu = translation.text;
              _this4.newChangeAnnotationRu = translation.annotation;
              _this4.newChangeDocLinkRu = translation.documentationLink;
            }
          });
        }

        _this4.newChangeTaskLink = response.data.taskLink;
        _this4.newChangeMergeLink = response.data.mergeRequestLink;
        _this4.newChangeIsPrivate = response.data.isPrivate;
        _this4.selectedVersion = response.data.versionId;

        _this4.selectedChangeType = response.data.type;
        _this4.selectedChangeGroupId = response.data.groupId;

        var tagsIds = [];
        if (response.data.changeTagRels != null) {
          response.data.changeTagRels.forEach(function (tag) {
            tagsIds.push(tag.tagId);
          });
        }
        _this4.tagsIds = tagsIds;
        _this4.getTagNames();
        _this4.loading = false;
        console.log(response.data);
      }).catch(function (e) {
        _this4.loading = false;
        console.log(e);
      });
    },
    submit: function submit() {
      console.log("recordProcessing - " + this.recordProcessing);
      if (!this.recordProcessing) {
        this.saveClicked = true;

        if (this.newChangeText.length >= 5) {
          this.recordProcessing = true;
          if (this.changeId <= 0) this.createChange();else this.editChange(this.changeId);
        }
      }
    },


    //versions
    getVersions: function getVersions() {
      var _this5 = this;

      this.HTTP.get("productVersions/product/" + this.productId + "/1/10000").then(function (response) {
        _this5.versions = Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["b" /* getVersionDestructorArr */])(response.data.entities);
      }).catch(function (e) {
        console.log(e);
      });
    },
    getCurrentVersion: function getCurrentVersion() {
      var _this6 = this;

      this.loading = true;
      this.HTTP.get("productVersions/current/" + this.productId).then(function (response) {
        _this6.currentVersion = Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getVersionDestructor */])(response.data);
        _this6.selectedVersion = response.data.id;
        var flag = true;
        for (var i = 0; i < _this6.versions.length; i++) {
          if (_this6.versions[i].id === _this6.selectedVersion) {
            flag = false;
          }
        }
        if (flag) {
          // Added by Detrav
          console.log("unshift");
          _this6.versions.unshift(Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* getVersionDestructor */])(response.data));
          //console.log(this.versions);
        }
        _this6.loading = false;
      }).catch(function (e) {
        _this6.loading = false;
        console.log(e);
      });
    },

    //end versions

    getChangeTypes: function getChangeTypes() {
      var _this7 = this;

      this.HTTP.get("changes/changeTypes").then(function (response) {
        _this7.changeTypes = response.data;
      }).catch(function (e) {
        console.log(e);
      });
    },
    getChangeGroups: function getChangeGroups() {
      var _this8 = this;

      this.HTTP.get("ChangeGroups/product/" + this.productId).then(function (response) {
        _this8.changeGroups = response.data;
        //if create new change
        if (_this8.changeId <= 0) {
          _this8.selectedChangeGroupId = response.data[0].id;
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    getTagNames: function getTagNames() {
      var _this9 = this;

      this.HTTP.get("changes/tags/" + this.changeId).then(function (response) {
        _this9.newTags = response.data.map(function (t) {
          return t.name;
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    getAllTagNames: function getAllTagNames() {
      var _this10 = this;

      this.HTTP.get("changes/tags/").then(function (response) {
        _this10.allTags = response.data.map(function (t) {
          return t.name;
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    getFilteredTags: function getFilteredTags(text) {
      this.filteredTags = this.allTags.filter(function (option) {
        return option.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    beforeTagAdding: function beforeTagAdding(tag) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.newTags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var k = _step.value;

          if (tag.toLowerCase() == k.toLowerCase()) return false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    }
  },

  created: function created() {
    this.loading = true;
    //add listeners
    document.addEventListener("keydown", this.keyDownListener);
    // end add listeners
    this.getChangeTypes();
    this.getChangeGroups();
    this.getAllTagNames();
    this.getVersions();

    //if edit change
    if (this.changeId > 0) {
      this.getChange(this.changeId);
    } else {
      this.getCurrentVersion();
    }
  },

  destroyed: function destroyed() {
    document.removeEventListener("keydown", this.keyDownListener);
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalWindow_Vue_vue_type_script_lang_js__ = __webpack_require__(49);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalWindow_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "modal-window",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a },
  props: {
    loading: Boolean
  },
  methods: {
    mouseClickListener: function mouseClickListener(evt) {
      if (document.getElementById("modalWindow").contains(evt.target)) {
        // Clicked in box
        console.log("click in modal");
      } else if (evt.target.className !== "download-js-link") {
        // Clicked outside the box
        var areYouShure = confirm("Are you sure that you want to close window?");
        if (areYouShure) {
          this.$emit("close");
        }
      }
    },
    keyDownListener: function keyDownListener(evt) {
      if (evt.keyCode === 27) {
        var areYouShure = confirm("Are you sure that you want to close window?");
        if (areYouShure) {
          this.$emit("close");
        }
      }
    }
  },
  created: function created() {
    document.addEventListener("click", this.mouseClickListener);
    document.addEventListener("keydown", this.keyDownListener);
  },
  destroyed: function destroyed() {
    document.removeEventListener("click", this.mouseClickListener);
    document.removeEventListener("keydown", this.keyDownListener);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(166);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("d08a731a", content, true, {});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DeleteConfirmer_Vue_vue_type_script_lang_js__ = __webpack_require__(52);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DeleteConfirmer_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalWindow__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import this.HTTP from "./Http";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "delete-confirmer",
  components: { ModalWindow: __WEBPACK_IMPORTED_MODULE_0__ModalWindow__["a" /* default */] },
  props: {
    header: String,
    text: String
  },
  methods: {
    close: function close() {
      this.$emit("close");
    },
    keyDownListener: function keyDownListener(evt) {
      if (evt.keyCode === 13) this.$emit('delete');
    }
  },
  created: function created() {
    document.addEventListener("keydown", this.keyDownListener);
  },
  destroyed: function destroyed() {
    document.removeEventListener("keydown", this.keyDownListener);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_lib_index_js_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_script_lang_js__ = __webpack_require__(54);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__babel_loader_lib_index_js_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__paging_js__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__paging_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__paging_js__);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-bulma-pagination',
  props: {
    urlPrefix: {
      type: String,
      default: '/'
    },
    urlBuilder: {
      type: Function,
      default: function _default(page) {
        return this.normalize(this.urlPrefix + '/' + page);
      }
    },
    currentPage: {
      type: Number,
      default: 1
    },
    lastPage: Number,
    displayPage: {
      type: Number,
      default: 4
    },
    modifiers: {
      type: String,
      default: ''
    },
    prev: {
      type: String,
      default: 'Prev'
    },
    next: {
      type: String,
      default: 'Next'
    }
  },
  methods: {
    getNavClassName: function getNavClassName() {
      var optional = ['', 'is-centered', 'is-right'];
      if (['', 'is-centered', 'is-right'].indexOf(this.modifiers.trim()) >= 0) {
        return 'pagination ' + this.modifiers;
      } else {
        console.warn(" modifiers %s is not within the options ", this.modifiers, optional, '\n see more detail https://github.com/vue-bulma/vue-bulma-pagination#doc');
        return 'pagination';
      }
    },
    getPagingClassName: function getPagingClassName(item) {
      return this.currentPage !== item ? 'pagination-link' : 'pagination-link is-current';
    },
    outOfRegion: function outOfRegion(page) {
      return page < 1 || page > this.lastPage;
    },
    normalize: function normalize(path) {
      return path.replace(/\/+/g, '/');
    }
  },
  computed: {
    pagingList: function pagingList() {
      return __WEBPACK_IMPORTED_MODULE_0__paging_js___default()(this.currentPage, this.lastPage, this.displayPage);
    },
    formatCurrentPage: function formatCurrentPage() {
      var currentPage = Number(this.currentPage);
      return currentPage > 0 ? currentPage : 1;
    },
    prevPage: function prevPage() {
      return Math.max(this.formatCurrentPage - 1, 1);
    },
    nextPage: function nextPage() {
      return Math.min(this.formatCurrentPage + 1, this.lastPage);
    }
  }
});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(173);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("a6ff1396", content, true, {});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesSaver_Vue_vue_type_script_lang_js__ = __webpack_require__(57);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesSaver_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalWindow__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__download__ = __webpack_require__(19);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "change-saver",
  components: { ModalWindow: __WEBPACK_IMPORTED_MODULE_0__ModalWindow__["a" /* default */], Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a },
  props: {
    productId: Number,
    filterType: String
  },
  data: function data() {
    return {
      saveType: "all",
      language: "english",
      fileType: "txt",
      grouping: "minor",
      version: -1,

      fileLink: "",
      filename: "",
      tags: [],
      loading: false
    };
  },

  computed: {
    isGroupingDisabled: function isGroupingDisabled() {
      return this.saveType == "lastVersion" || this.saveType == "currentVersion";
    },
    isValidTags: function isValidTags() {
      return true;
      // (
      //     this.tags.length == 0 ||
      //     (this.tags.match(/[a-zA-Z0-9_]+/g) || "").length ==
      //       (this.tags.split(/[\s,;]/) || "").length
      //   );
    }
  },
  methods: {
    preview: function preview() {
      if (this.isValidTags) {
        this.$emit("saveChanges", this.saveType, this.language, this.fileType, this.grouping, this.tags);
      }
    },
    getCurrentVersion: function getCurrentVersion() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.loading = true;
        _this.HTTP.get("productVersions/current/" + _this.productId).then(function (response) {
          _this.loading = false;
          _this.version = response.data.id;
          resolve();
        }).catch(function (e) {
          _this.loading = false;
          console.log(e);
          reject();
        });
      });
    },
    getLastVersion: function getLastVersion() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.loading = true;
        _this2.HTTP.get("productVersions/last/" + _this2.productId).then(function (response) {
          _this2.loading = false;
          _this2.version = response.data.id;
          resolve();
        }).catch(function (e) {
          _this2.loading = false;
          console.log(e);
          reject();
        });
      });
    },
    downloadChanges: function downloadChanges() {
      var _HTTP$post,
          _this3 = this;

      this.loading = true;
      this.HTTP.post("changes/product/file_v2", (_HTTP$post = {
        productId: this.productId,
        fileType: this.fileType,
        grouping: this.grouping,
        filterType: this.filterType,
        tags: this.tags
      }, _defineProperty(_HTTP$post, "fileType", this.fileType), _defineProperty(_HTTP$post, "language", this.language), _defineProperty(_HTTP$post, "VersionId", this.saveType == "currentVersion" || this.saveType == "lastVersion" ? this.version : null), _HTTP$post)).then(function (response) {
        var downloadingTxt = void 0;
        var chgs = response.data;
        if (chgs.length == 0) chgs += "\nThere is no any changes in version " + _this3.version + "!";
        var btype = "text/plain";
        if (_this3.fileType == "txt" || _this3.fileType == "markdown") {
          _this3.filename = _this3.fileType == "markdown" ? "changes.md" : "changes.txt";
          btype = "text/plain";
          downloadingTxt = chgs;
        } else {
          _this3.filename = "changes.json";
          btype = "application/json";
          downloadingTxt = JSON.stringify(chgs);
        }
        var blob = new Blob([downloadingTxt]);
        __WEBPACK_IMPORTED_MODULE_3__download__["download"](blob, _this3.filename, btype);

        _this3.loading = false;
        _this3.$emit("closeSaveChangesWindow");
      }).catch(function (e) {
        console.log(e);
      });
    },
    download: function download() {
      var _this4 = this;

      if (this.isValidTags) {
        if (this.saveType == "currentVersion") {
          this.getCurrentVersion().then(function () {
            _this4.downloadChanges();
          });
        } else if (this.saveType == "lastVersion") {
          this.getLastVersion().then(function () {
            _this4.downloadChanges();
          });
        } else {
          this.downloadChanges();
        }
      }
    }
  },
  created: function created() {},

  watch: {
    saveType: function saveType(newVal) {
      if (newVal == "lastVersion" || newVal == "currentVersion") this.grouping = "minor";
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(180);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("2624f9c2", content, true, {});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Auth_Vue_vue_type_script_lang_js__ = __webpack_require__(60);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Auth_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_oidc_client__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_oidc_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_oidc_client__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import this.HTTP from "../Http";


console.log("https://changelogger.fast-report.com/api/" == null);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "auth-view",
  data: function data() {
    return {
      needSignUp: false,
      username: "",
      email: "",
      password: "",
      errors: []

    };
  },

  methods: {
    signin: function signin() {
      console.log(this.HTTP.signinRedirect);
      this.HTTP.signinRedirect().catch(function (e) {});
    }
  },
  created: function created() {
    this.HTTP.load();
    console.log(this.$route);

    // if (
    //   this.$route.query.id_token !== null &&
    //   this.$route.query.id_token !== undefined &&
    //   this.$route.query.id_token !== "undefined" &&
    //   this.$route.query.id_token.length > 0 &&
    //   this.$route.query.id_token.indexOf(".") !== -1
    // ) {
    //   this.$router.push("Changes");
    // }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Products_Vue_vue_type_script_lang_js__ = __webpack_require__(62);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Products_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductCard__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFilter__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppBreadcrumb__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductEditor__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DeleteConfirmer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_pagination_src_Pagination__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_min_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











//import this.HTTP from "../Http";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "products-vue",
  components: {
    ProductCard: __WEBPACK_IMPORTED_MODULE_0__ProductCard__["a" /* default */],
    AppBreadcrumb: __WEBPACK_IMPORTED_MODULE_2__AppBreadcrumb__["a" /* default */],
    ContentFilter: __WEBPACK_IMPORTED_MODULE_1__ContentFilter__["a" /* default */],
    ProductEditor: __WEBPACK_IMPORTED_MODULE_3__ProductEditor__["a" /* default */],
    DeleteConfirmer: __WEBPACK_IMPORTED_MODULE_4__DeleteConfirmer__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_pagination_src_Pagination__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      products: [],
      isEditorVisible: false,
      isDeleteModalVisible: false,
      deleteHeader: "Are you sure that you wanna delete this product?",
      deleteMsg: "This product will be losted forever!!!(",
      productId: -1,
      productEditorHeader: "",
      filterGroups: [],

      //pagination
      page: {
        pageNumber: 1,
        totalPages: 13,
        pageSize: 10,
        totalItems: -1
      },

      searchingText: "",
      loading: false
    };
  },

  computed: {
    filterMsg: function filterMsg() {
      if (this.page.totalItems > 0) return "<strong>" + this.page.totalItems + "</strong> products";else return "";
    }
  },
  methods: {
    getProducts: function getProducts() {
      var _this = this;

      this.loading = true;
      var query = "products/";
      if (this.searchingText.length > 0) {
        query += "search/";
      }
      query += this.page.pageNumber + "/" + this.page.pageSize + "/";
      if (this.searchingText !== null && this.searchingText !== undefined && this.searchingText.length > 0) {
        query += this.searchingText;
      }

      this.HTTP.get(query).then(function (response) {
        _this.products = response.data.entities;
        _this.page = response.data.page;
        _this.loading = false;
      }).catch(function (e) {
        console.log(e);
      });
    },
    createProduct: function createProduct() {
      this.isEditorVisible = true;
      this.productId = -1; //shouldn't edit
      this.productEditorHeader = "Add new product";
    },
    editProduct: function editProduct(id) {
      this.isEditorVisible = true;
      this.productId = id;
      this.productEditorHeader = "Edit product";
    },
    deleteProductModal: function deleteProductModal(id) {
      this.isDeleteModalVisible = true;
      this.productId = id;
    },
    deleteProduct: function deleteProduct() {
      var _this2 = this;

      this.HTTP.delete("products/" + this.productId).then(function (response) {
        _this2.closeProductDeleteWindow();
      }).catch(function (e) {
        console.log(e);
      });
    },
    closeProductEditor: function closeProductEditor() {
      this.isEditorVisible = false;
      this.getProducts(); //should be optimized!
    },
    closeProductDeleteWindow: function closeProductDeleteWindow() {
      this.isDeleteModalVisible = false;
      this.getProducts(); //should be optimized!
    },


    //pagination

    urlBuilder: function urlBuilder(page) {
      return { query: _extends({}, this.$route.query, { page: page }) }; // Changing page in location query
    },
    searchHandler: function searchHandler(searchingText) {
      this.searchingText = searchingText;
    },
    clearSearch: function clearSearch() {
      this.searchingText = "";
      this.page.pageNumber = 1;
    },
    pushUrl: function pushUrl() {
      this.$router.push({
        path: "Products",
        query: {
          page: this.page.pageNumber,
          search: this.searchingText
        }
      });
    }
  },
  created: function created() {
    if (this.cardsCount) {
      this.page.pageSize = this.cardsCount;
    }
    this.HTTP.load(); //.then(() => {
    this.getProducts();
    // });
  },


  watch: {
    $route: function $route(to, from) {
      if (to.query.page != null && to.query.page != undefined) {
        this.page.pageNumber = parseInt(to.query.page);
        this.searchingText = to.query.search;
      } else {
        //this.pushUrl();
      }

      this.getProducts();
    },

    searchingText: function searchingText(val) {
      this.pushUrl();
    },
    page: function page(val) {
      this.pushUrl();
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductCard_Vue_vue_type_template_id_67c917ea__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductCard_Vue_vue_type_script_lang_js__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductCard_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ProductCard_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ProductCard_Vue_vue_type_template_id_67c917ea__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ProductCard_Vue_vue_type_template_id_67c917ea__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_Vue_vue_type_script_lang_js__ = __webpack_require__(65);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import this.HTTP from "./Http";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "product-card",
  props: {
    product: Object,
    action1: String, //Edit
    action2: String //Delete
  },
  data: function data() {
    return {
      userName: "Johnessa",
      userFamilyName: "Doe"
    };
  },

  computed: {
    id: function id() {
      return this.product.id;
    },
    name: function name() {
      return this.product.name;
    },
    description: function description() {
      return this.product.description;
    },
    productUrl: function productUrl() {
      return this.product.productUrl;
    },
    repositoryUrl: function repositoryUrl() {
      return this.product.repositoryUrl;
    },
    tag: function tag() {
      return this.product.tag;
    },
    avgBuildTime: function avgBuildTime() {
      return this.product.avgBuildTime;
    },
    versions: function versions() {
      return this.product.versions;
    },
    userFullName: function userFullName() {
      if (this.product.user != null) return this.product.user.name + " " + (this.product.user.familyName ? this.product.user.familyName : "");else return "John Doe";
    },
    userLink: function userLink() {
      return "https://id.fast-report.com" + "/Profile/Index/" + this.product.userId;
    }
  },
  methods: {
    runAction1: function runAction1() {
      this.$emit(this.action1, this.id);
    },
    runAction2: function runAction2() {
      this.$emit(this.action2, this.id);
    }
  },
  created: function created() {
    this.HTTP.load();
    var serviceId = 3;
    // this.HTTP.getUser()
    //   .then(user => {
    //     const token = user.access_token;
    //     const header = { Authorization: `Bearer ${token}` };
    //     this.HTTP.get(
    //       process.env.PASSPORT_URI +
    //         "/api/ServiceUserInfo/" +
    //         serviceId +
    //         "/User/" +
    //         this.change.userId,
    //       { headers: { header } }
    //     ).then(response => {
    //       this.userName = response.name;
    //       this.userFamilyName = response.familyName;
    //     });
    //   })
    //   .catch(ex => {
    //     console.log(ex);
    //   });
  }
});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(190);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("63c6a79a", content, true, {});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductEditor_Vue_vue_type_script_lang_js__ = __webpack_require__(68);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductEditor_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalWindow__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import this.HTTP from "./Http";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "product-editor",
  components: { ModalWindow: __WEBPACK_IMPORTED_MODULE_0__ModalWindow__["a" /* default */] },
  props: {
    productId: Number,
    header: String
  },
  data: function data() {
    return {
      inherited: false,
      baseProductId: 0,
      newProductName: "",
      newProductDescription: "",
      newProductUrl: "",
      newProductRepoUrl: "",
      newProductTag: "",
      newProductAvgBuildTime: 0,
      newProductMajor: 2019,
      newProductMinor: 1,
      newProductBuild: 0,

      saveClicked: false,
      recordProcessing: false, //should prevent record duplicate creating
      errors: [],

      productParts: [],
      allProductParts: [],
      filteredProductParts: [],
      loading: false
    };
  },

  computed: {
    productPartsArray: function productPartsArray() {
      var _this = this;

      if (this.productParts != null && this.productParts.length > 0) {
        var partsObj = void 0;
        var partsArray = [];
        this.productParts.forEach(function (element) {
          if (element.trim().length > 0) {
            partsObj = {
              productId: _this.productId,
              group: {
                name: element.trim()
              }
            };
            partsArray.push(partsObj);
          }
        });
        return partsArray;
      } else return null;
    }
  },
  methods: {
    createInheritedProduct: function createInheritedProduct() {
      var _this2 = this;

      this.HTTP.post('Products/' + this.productId + '/inherit', {
        name: this.newProductName,
        description: this.newProductDescription,
        productChangeGroups: this.productPartsArray,
        tag: this.newProductTag,
        avgBuildTime: this.newProductAvgBuildTime,
        productUrl: this.newProductUrl,
        repositoryUrl: this.newProductRepoUrl
      }).then(function (response) {
        _this2.recordProcessing = false;
        _this2.$emit("closeProductEditor");
      }).catch(function (e) {
        _this2.recordProcessing = false;
        _this2.errors = e.response.data.description;
      });
    },
    createProduct: function createProduct() {
      var _this3 = this;

      this.HTTP.post("products", {
        name: this.newProductName,
        description: this.newProductDescription,
        productUrl: this.newProductUrl,
        repositoryUrl: this.newProductRepoUrl,
        tag: this.newProductTag,
        avgBuildTime: this.newProductAvgBuildTime,
        versions: [{
          name: "Initial Version",
          major: this.newProductMajor,
          minor: this.newProductMinor,
          build: this.newProductBuild,
          state: "Success"
        }],
        productChangeGroups: this.productPartsArray
      }).then(function (response) {
        _this3.recordProcessing = false;
        _this3.$emit("closeProductEditor");
      }).catch(function (e) {
        _this3.recordProcessing = false;
        _this3.errors = e.response.data.description;
      });
    },
    editProduct: function editProduct(productId) {
      var _this4 = this;

      this.HTTP.put("products/" + productId, {
        id: productId,
        name: this.newProductName,
        description: this.newProductDescription,
        productUrl: this.newProductUrl,
        repositoryUrl: this.newProductRepoUrl,
        tag: this.newProductTag,
        avgBuildTime: this.newProductAvgBuildTime,
        productChangeGroups: this.productPartsArray
      }).then(function (response) {
        _this4.recordProcessing = false;
        _this4.$emit("closeProductEditor");
      }).catch(function (e) {
        _this4.recordProcessing = false;
        _this4.errors = e.response.data.description;
      });
    },
    getProduct: function getProduct(id) {
      var _this5 = this;

      this.loading = true;
      this.HTTP.get("products/" + id).then(function (response) {
        _this5.newProductName = response.data.name;
        _this5.newProductDescription = response.data.description;
        _this5.newProductUrl = response.data.productUrl;
        _this5.newProductRepoUrl = response.data.repositoryUrl;
        _this5.newProductTag = response.data.tag;
        _this5.newProductAvgBuildTime = response.data.avgBuildTime;

        if (response.data.productChangeGroups != null && response.data.productChangeGroups.length > 0) {
          _this5.productParts = [];
          response.data.productChangeGroups.forEach(function (element) {
            _this5.productParts.push(element.group.name);
          });
          // this.productParts = this.productParts.substring(
          //   0,
          //   this.productParts.length - 2
          // );
        }
        _this5.loading = false;
      }).catch(function (e) {
        _this5.loading = false;
        console.log(e);
      });
    },
    submit: function submit() {
      console.log("recordProcessing - " + this.recordProcessing);
      if (!this.recordProcessing) {
        this.saveClicked = true;
        if (this.newProductMajor >= 0 && this.newProductMinor >= 0 && this.newProductBuild >= 0 && this.isInteger(this.newProductMajor) && this.isInteger(this.newProductMinor) && this.isInteger(this.newProductBuild)) {
          if (this.newProductName.length >= 2 && this.productParts.length > 0) {
            this.recordProcessing = true;
            if (this.productId <= 0) this.createProduct();else this.editProduct(this.productId);
          }
        }
      }
    },
    getProductParts: function getProductParts() {
      var _this6 = this;

      this.HTTP.get("ChangeGroups/1/9999").then(function (response) {
        _this6.allProductParts = response.data.entities.map(function (p) {
          return p.name;
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    getFilteredParts: function getFilteredParts(text) {
      this.filteredProductParts = this.allProductParts.filter(function (option) {
        return option.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    isInteger: function isInteger(num) {
      return (num ^ 0) === num;
    },
    beforeTagAdding: function beforeTagAdding(tag) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.productParts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var k = _step.value;

          if (tag.toLowerCase() == k.toLowerCase()) return false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    }

    // keyDownListener(evt) {
    //   if (evt.keyCode === 27) this.$emit("closeProductEditor");
    //   else if (evt.keyCode === 13) this.submit();
    // }

  },

  created: function created() {
    document.addEventListener("keydown", this.keyDownListener);
    this.getProductParts();
    if (this.productId > 0) {
      this.getProduct(this.productId);
    }
  },

  destroyed: function destroyed() {
    document.removeEventListener("keydown", this.keyDownListener);
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductGroups_Vue_vue_type_script_lang_js__ = __webpack_require__(70);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductGroups_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductsGroupCard__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFilter__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppBreadcrumb__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductsGroupEditor__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DeleteConfirmer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CombinedChangesSaver__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_pagination_src_Pagination__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_min_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












//import this.HTTP from "../Http";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "product-groups-vue",
  components: {
    ProductCard: __WEBPACK_IMPORTED_MODULE_0__ProductsGroupCard__["a" /* default */],
    AppBreadcrumb: __WEBPACK_IMPORTED_MODULE_2__AppBreadcrumb__["a" /* default */],
    ContentFilter: __WEBPACK_IMPORTED_MODULE_1__ContentFilter__["a" /* default */],
    ProductEditor: __WEBPACK_IMPORTED_MODULE_3__ProductsGroupEditor__["a" /* default */],
    DeleteConfirmer: __WEBPACK_IMPORTED_MODULE_4__DeleteConfirmer__["a" /* default */],
    ChangesSaver: __WEBPACK_IMPORTED_MODULE_5__CombinedChangesSaver__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_pagination_src_Pagination__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      groups: [],
      isEditorVisible: false,
      isDeleteModalVisible: false,
      isSaverVisible: false,
      deleteHeader: "Are you sure that you want to delete this group?",
      deleteMsg: "This group will be lost forever",
      groupId: -1,
      productEditorHeader: "",
      filterType: "All",
      filterGroups: [],

      //pagination
      page: {
        pageNumber: 1,
        totalPages: 13,
        pageSize: 10,
        totalItems: -1
      },

      searchingText: "",
      loading: false
    };
  },

  computed: {
    filterMsg: function filterMsg() {
      if (this.page.totalItems > 0) return "<strong>" + this.page.totalItems + "</strong> groups";else return "";
    }
  },
  methods: {
    getGroups: function getGroups() {
      var _this = this;

      this.loading = true;
      var query = "productGroups/";
      if (this.searchingText.length > 0) {
        query += "search/";
      }
      query += this.page.pageNumber + "/" + this.page.pageSize + "/";
      if (this.searchingText !== null && this.searchingText !== undefined && this.searchingText.length > 0) {
        query += this.searchingText;
      }

      this.HTTP.get(query).then(function (response) {
        _this.groups = response.data.entities;
        _this.page = response.data.page;
        _this.loading = false;
      }).catch(function (e) {
        console.log(e);
      });
    },
    createProduct: function createProduct() {
      this.isEditorVisible = true;
      this.groupId = -1; //shouldn't edit
      this.productEditorHeader = "Add new product group";
    },
    editProduct: function editProduct(id) {
      this.isEditorVisible = true;
      this.groupId = id;
      this.productEditorHeader = "Edit product group";
    },
    deleteGroupModal: function deleteGroupModal(id) {
      this.isDeleteModalVisible = true;
      this.groupId = id;
    },
    saveFileModal: function saveFileModal(id) {
      this.isSaverVisible = true;
      this.groupId = id;
    },
    deleteGroup: function deleteGroup() {
      var _this2 = this;

      this.HTTP.delete("productGroups/" + this.groupId).then(function (response) {
        _this2.closeProductDeleteWindow();
      }).catch(function (e) {
        console.log(e);
      });
    },
    closeProductEditor: function closeProductEditor() {
      this.isEditorVisible = false;
      this.getGroups(); //should be optimized!
    },
    closeProductDeleteWindow: function closeProductDeleteWindow() {
      this.isDeleteModalVisible = false;
      this.getGroups(); //should be optimized!
    },
    closeFileSaver: function closeFileSaver() {
      this.isSaverVisible = false;
    },

    //pagination

    urlBuilder: function urlBuilder(page) {
      return { query: _extends({}, this.$route.query, { page: page }) }; // Changing page in location query
    },
    searchHandler: function searchHandler(searchingText) {
      this.searchingText = searchingText;
    },
    clearSearch: function clearSearch() {
      this.searchingText = "";
      this.page.pageNumber = 1;
    },
    pushUrl: function pushUrl() {
      this.$router.push({
        path: "ProductGroups",
        query: {
          page: this.page.pageNumber,
          search: this.searchingText
        }
      });
    }
  },
  created: function created() {
    console.log("I HAVE BEEN CREATED");
    if (this.cardsCount) {
      this.page.pageSize = this.cardsCount;
    }
    this.HTTP.load(); //.then(() => {
    this.getGroups();
    // });
  },


  watch: {
    $route: function $route(to, from) {
      if (to.query.page != null && to.query.page != undefined) {
        this.page.pageNumber = parseInt(to.query.page);
        this.searchingText = to.query.search;
      } else {
        //this.pushUrl();
      }

      this.getGroups();
    },

    searchingText: function searchingText(val) {
      this.pushUrl();
    },
    page: function page(val) {
      this.pushUrl();
    }
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupCard_Vue_vue_type_script_lang_js__ = __webpack_require__(72);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupCard_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "products-group-card",
  props: {
    product: Object,
    action1: String, //Edit
    action2: String, //Delete
    action3: String //Changes file
  },
  data: function data() {
    return {
      userName: "Johnessa",
      userFamilyName: "Doe"
    };
  },

  computed: {
    id: function id() {
      return this.product.id;
    },
    name: function name() {
      return this.product.name;
    },
    userFullName: function userFullName() {
      if (this.product.user != null) return this.product.user.name + " " + (this.product.user.familyName ? this.product.user.familyName : "");else return "John Doe";
    },
    userLink: function userLink() {
      return "https://id.fast-report.com" + "/Profile/Index/" + this.product.userId;
    }
  },
  methods: {
    runAction1: function runAction1() {
      this.$emit(this.action1, this.id);
    },
    runAction2: function runAction2() {
      this.$emit(this.action2, this.id);
    },
    runAction3: function runAction3() {
      this.$emit(this.action3, this.id);
    }
  },
  created: function created() {
    this.HTTP.load();
    var serviceId = 3;
  }
});

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(201);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("442781f3", content, true, {});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupEditor_vue_vue_type_script_lang_js__ = __webpack_require__(75);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupEditor_vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalWindow__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//import this.HTTP from "./Http";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "products-group-editor",
  components: { ModalWindow: __WEBPACK_IMPORTED_MODULE_1__ModalWindow__["a" /* default */], Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a },
  props: {
    groupId: Number,
    header: String
  },
  data: function data() {
    return {
      baseGroupId: 0,
      newGroupName: "",

      saveClicked: false,
      recordProcessing: false, //should prevent record duplicate creating
      errors: [],

      products: [],
      allProducts: [],
      loading: false
    };
  },

  methods: {
    createProductsGroup: function createProductsGroup() {
      var _this = this;

      this.HTTP.post("productGroups", {
        name: this.newGroupName,
        productIds: this.products.map(function (x) {
          return x.id;
        })
      }).then(function (response) {
        _this.recordProcessing = false;
        _this.$emit("closeProductEditor");
      }).catch(function (e) {
        _this.recordProcessing = false;
        _this.errors = e.response.data.description;
      });
    },
    editProduct: function editProduct(groupId) {
      var _this2 = this;

      this.HTTP.put("productGroups/" + groupId, {
        id: groupId,
        name: this.newGroupName,
        productIds: this.products.map(function (x) {
          return x.id;
        })
      }).then(function (response) {
        _this2.recordProcessing = false;
        _this2.$emit("closeProductEditor");
      }).catch(function (e) {
        _this2.recordProcessing = false;
        _this2.errors = e.response.data.description;
      });
    },
    getGroup: function getGroup(id) {
      var _this3 = this;

      this.loading = true;
      this.HTTP.get("productGroups/" + id).then(function (response) {
        _this3.newGroupName = response.data.name;
        if (response.data.products != null && response.data.products.length > 0) {
          _this3.products = [];
          response.data.products.forEach(function (element) {
            _this3.products.push({ id: element.id, name: element.name });
          });
        }
        _this3.loading = false;
      }).catch(function (e) {
        _this3.loading = false;
        console.log(e);
      });
    },
    submit: function submit() {
      console.log("recordProcessing - " + this.recordProcessing);
      if (!this.recordProcessing) {
        this.saveClicked = true;
        if (this.newGroupName.length >= 2 && this.products.length > 0) {
          this.recordProcessing = true;
          if (this.groupId <= 0) this.createProductsGroup();else this.editProduct(this.groupId);
        }
      }
    },
    getProducts: function getProducts() {
      var _this4 = this;

      this.HTTP.get("Products/1/9999").then(function (response) {
        _this4.allProducts = response.data.entities.map(function (x) {
          return { id: x.id, name: x.name };
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    isInteger: function isInteger(num) {
      return (num ^ 0) === num;
    }
  },

  created: function created() {
    document.addEventListener("keydown", this.keyDownListener);
    this.getProducts();
    if (this.groupId > 0) {
      this.getGroup(this.groupId);
    }
  },

  destroyed: function destroyed() {
    document.removeEventListener("keydown", this.keyDownListener);
  }
});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(207);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("48229eac", content, true, {});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CombinedChangesSaver_Vue_vue_type_script_lang_js__ = __webpack_require__(78);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CombinedChangesSaver_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalWindow__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__download__ = __webpack_require__(19);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: "combined-change-saver",
    components: { ModalWindow: __WEBPACK_IMPORTED_MODULE_0__ModalWindow__["a" /* default */], Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a },
    props: {
        groupId: Number,
        filterType: String
    },
    data: function data() {
        return {
            versionDepth: 0,
            language: "english",
            fileType: "txt",
            grouping: "build",
            version: -1,
            includePrivate: false,

            fileLink: "",
            filename: "",
            tags: [],
            loading: false
        };
    },

    methods: {
        downloadChanges: function downloadChanges() {
            var _HTTP$post,
                _this = this;

            this.loading = true;
            this.HTTP.post("changes/group/file", (_HTTP$post = {
                groupId: this.groupId,
                fileType: this.fileType,
                grouping: this.grouping,
                filterType: this.includePrivate ? "all" : "public"
            }, _defineProperty(_HTTP$post, "fileType", this.fileType), _defineProperty(_HTTP$post, "language", this.language), _defineProperty(_HTTP$post, "versionDepth", this.versionDepth), _HTTP$post)).then(function (response) {
                var downloadingTxt = void 0;
                var chgs = response.data;
                if (chgs.length == 0) chgs += "\nThere is no changes!";
                var btype = "text/plain";
                if (_this.fileType == "txt" || _this.fileType == "markdown") {
                    _this.filename = _this.fileType == "markdown" ? "changes.md" : "changes.txt";
                    btype = "text/plain";
                    downloadingTxt = chgs;
                } else {
                    _this.filename = "changes.json";
                    btype = "application/json";
                    downloadingTxt = JSON.stringify(chgs);
                }
                var blob = new Blob([downloadingTxt]);
                __WEBPACK_IMPORTED_MODULE_3__download__["download"](blob, _this.filename, btype);

                _this.loading = false;
                _this.$emit("closeSaveChangesWindow");
            }).catch(function (e) {
                console.log(e);
            });
        }
    },
    created: function created() {}
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Versions_Vue_vue_type_script_lang_js__ = __webpack_require__(80);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Versions_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideMenu__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppBreadcrumb__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContentFilter__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VersionCard__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VersionEditor__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GroupVersionCreator__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DeleteConfirmer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_pagination_src_Pagination__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_min_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import AppHeader from "./components/AppHeader";








//import this.HTTP from "../Http";




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "version-view",
  components: {
    SideMenu: __WEBPACK_IMPORTED_MODULE_0__SideMenu__["a" /* default */],
    AppBreadcrumb: __WEBPACK_IMPORTED_MODULE_1__AppBreadcrumb__["a" /* default */],
    ContentFilter: __WEBPACK_IMPORTED_MODULE_2__ContentFilter__["a" /* default */],
    VersionCard: __WEBPACK_IMPORTED_MODULE_3__VersionCard__["a" /* default */],
    VersionEditor: __WEBPACK_IMPORTED_MODULE_4__VersionEditor__["a" /* default */],
    GroupVersionCreator: __WEBPACK_IMPORTED_MODULE_5__GroupVersionCreator__["a" /* default */],
    DeleteConfirmer: __WEBPACK_IMPORTED_MODULE_6__DeleteConfirmer__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_7_vue_bulma_pagination_src_Pagination__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      products: [],
      groups: [],
      versions: [],
      versionsHeader: "Products",
      groupsHeader: "Groups",
      isEditorVisible: false,
      isUpdatingGroup: false,
      isDeleteModalVisible: false,
      deleteHeader: "Are you sure that you wanna delete this version?",
      deleteMsg: "This version will be lost forever!",
      productId: -1,
      versionId: -1,
      groupId: -1,
      VersionEditorHeader: "",
      filterGroups: [],
      viewingGroups: false,

      //pagination
      page: {
        pageNumber: 1,
        totalPages: 13,
        pageSize: 10,
        totalItems: -1
      },

      searchingText: "",
      loading: false
    };
  },

  methods: {
    getProducts: function getProducts() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.HTTP.get("products/" + 1 + "/" + 100).then(function (response) {
          resolve(response);
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    getGroups: function getGroups() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.HTTP.get("productGroups/" + 1 + '/' + 100).then(function (response) {
          resolve(response);
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    getVersions: function getVersions() {
      var _this3 = this;

      this.loading = true;
      var query = this.viewingGroups ? "ProductVersions/group/" : "ProductVersions/product/";
      query += (this.viewingGroups ? this.groupId : this.productId) + "/" + this.page.pageNumber + "/" + this.page.pageSize;
      if (this.searchingText !== null && this.searchingText !== undefined && this.searchingText.length > 0 && !this.viewingGroups) {
        query += "/" + this.searchingText;
      }
      this.HTTP.get(query).then(function (response) {
        _this3.versions = response.data.entities;
        _this3.page = response.data.page;
        _this3.loading = false;
        console.log(response.data.entities);
      }).catch(function (e) {
        console.log(e);
      });
    },
    toggleVersion: function toggleVersion(productId) {
      this.productId = productId;
      this.groupId = -1;
      this.page.pageNumber = 1;
      this.searchingText = "";
      this.viewingGroups = false;
    },
    toggleGroup: function toggleGroup(groupId) {
      this.groupId = groupId;
      this.productId = -1;
      this.page.pageNumber = 1;
      this.searchingText = "";
      this.viewingGroups = true;
    },
    createChange: function createChange() {
      if (this.viewingGroups) {
        this.isUpdatingGroup = true;
        this.versionId = -1;
        this.VersionEditorHeader = "Update a version for a group";
      } else {
        this.isEditorVisible = true;
        this.versionId = -1; //shouldn't edit
        this.VersionEditorHeader = "Creare new version";
      }
    },
    editChange: function editChange(id) {
      this.isEditorVisible = true;
      this.versionId = id;
      this.VersionEditorHeader = "Edit version";
    },
    deleteVersionModal: function deleteVersionModal(id) {
      this.isDeleteModalVisible = true;
      this.versionId = id;
    },
    deleteVersion: function deleteVersion() {
      var _this4 = this;

      this.HTTP.delete("productversions/" + this.versionId).then(function (response) {
        _this4.closeChangeDeleteWindow();
      }).catch(function (e) {
        console.log(e);
      });
    },
    closeVersionEditor: function closeVersionEditor() {
      this.isEditorVisible = false;
      this.getVersions(); //should be optimized!
    },
    closeGroupVersionEditor: function closeGroupVersionEditor() {
      this.isUpdatingGroup = false;
      this.getVersions(); //should be optimized!
    },
    closeChangeDeleteWindow: function closeChangeDeleteWindow() {
      this.isDeleteModalVisible = false;
      this.getVersions(); //should be optimized!
    },


    //pagination

    urlBuilder: function urlBuilder(page) {
      return { query: _extends({}, this.$route.query, { page: page }) }; // Changing page in location query
    },
    searchHandler: function searchHandler(searchingText) {
      this.searchingText = searchingText;
    },
    clearSearch: function clearSearch() {
      this.searchingText = "";
      this.page.pageNumber = 1;
    },
    pushUrl: function pushUrl() {
      this.$router.push({
        path: "Versions",
        query: {
          productId: this.productId,
          groupId: this.groupId,
          page: this.page.pageNumber,
          search: this.searchingText
        }
      });
    }
  },
  computed: {
    filterMsg: function filterMsg() {
      if (this.page.totalItems > 0) return "<strong>" + this.page.totalItems + "</strong> versions";else return "";
    }
  },
  created: function created() {
    var _this5 = this;

    if (this.cardsCount) {
      this.page.pageSize = this.cardsCount;
    }
    this.loading = true;
    this.HTTP.load(); //.then(() => {
    this.getGroups().then(function (response) {
      _this5.groups = response.data.entities;
      _this5.groupId = !isNaN(_this5.selectedGroupId) && viewingGroups ? _this5.selectedGroupId : -1;
      //this.getVersions();
      //this.loading = false;
    }).catch(function (e) {
      console.log(e);
    });
    this.getProducts().then(function (response) {
      _this5.products = response.data.entities;
      _this5.productId = !isNaN(_this5.selectedProductId) || _this5.selectedProductId != -1 ? _this5.selectedProductId : response.data.entities[0].id;
      //this.pushUrl();
      _this5.getVersions();
      _this5.loading = false;
    }).catch(function (e) {
      console.log(e);
    });
  },


  watch: {
    $route: function $route(to, from) {
      if (to.query.page != null && to.query.page != undefined) {
        this.page.pageNumber = parseInt(to.query.page);
        this.productId = parseInt(to.query.productId);
        this.groupId = parseInt(to.query.groupId);
        this.searchingText = to.query.search;
      } else {
        //this.pushUrl();
      }

      this.getVersions();
    },

    productId: function productId(val) {
      if (!isNaN(val)) this.selectedProductId = val;
      this.pushUrl();
    },
    groupId: function groupId(val) {
      if (!isNaN(val)) this.selectedGroupId = val;
      this.pushUrl();
    },
    searchingText: function searchingText(val) {
      this.pushUrl();
    },
    page: function page(val) {
      this.pushUrl();
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VersionCard_Vue_vue_type_template_id_274bfe68__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VersionCard_Vue_vue_type_script_lang_js__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VersionCard_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__VersionCard_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__VersionCard_Vue_vue_type_template_id_274bfe68__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__VersionCard_Vue_vue_type_template_id_274bfe68__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionCard_Vue_vue_type_script_lang_js__ = __webpack_require__(83);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionCard_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "version-card",
  props: {
    version: Object,
    action1: String, //Edit
    action2: String //Delete
  },
  computed: {
    versionText: function versionText() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* getVersionText */])(this.version);
    }
  },
  methods: {
    runAction1: function runAction1() {
      this.$emit(this.action1, this.version.id);
    },
    runAction2: function runAction2() {
      this.$emit(this.action2, this.version.id);
    }
  },
  created: function created() {
    console.log("vers -" + this.version);
  }
});

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(217);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("2d2b445a", content, true, {});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionEditor_Vue_vue_type_script_lang_js__ = __webpack_require__(86);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionEditor_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalWindow__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import this.HTTP from "./Http";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "product-editor",
  components: { ModalWindow: __WEBPACK_IMPORTED_MODULE_0__ModalWindow__["a" /* default */] },
  props: {
    versionId: Number,
    productId: Number,
    header: String
  },
  data: function data() {
    return {
      newVersionName: "",
      selectedType: "None",
      newVersionMajor: 2019,
      newVersionMinor: 1,
      newVersionBuild: 0,

      states: [],
      types: [],
      selectedState: "Success",

      saveClicked: false,
      recordProcessing: false, //should prevent record duplicate creating
      errors: [],
      loading: false
    };
  },

  methods: {
    createVersion: function createVersion() {
      var _this = this;

      this.HTTP.post("productversions", {
        name: this.newVersionName,
        type: this.selectedType,
        state: this.selectedState,
        major: this.newVersionMajor,
        minor: this.newVersionMinor,
        build: this.newVersionBuild,
        productId: this.productId
      }).then(function (response) {
        _this.recordProcessing = false;
        _this.$emit("closeVersionEditor");
      }).catch(function (e) {
        _this.recordProcessing = false;
        _this.errors = e.response.data.description;
        console.log(e.text);
      });
    },
    editVersion: function editVersion(versionId) {
      var _this2 = this;

      this.HTTP.put("productversions/" + versionId, {
        id: versionId,
        name: this.newVersionName,
        type: this.selectedType,
        state: this.selectedState,
        major: this.newVersionMajor,
        minor: this.newVersionMinor,
        build: this.newVersionBuild,
        productId: this.productId
      }).then(function (response) {
        _this2.recordProcessing = false;
        _this2.$emit("closeVersionEditor");
      }).catch(function (e) {
        _this2.recordProcessing = false;
        _this2.errors = e.response.data.description;
        console.log(e.text);
      });
    },
    getVersion: function getVersion(id) {
      var _this3 = this;

      this.loading = true;
      this.HTTP.get("productversions/" + id).then(function (response) {
        _this3.newVersionName = response.data.name;
        _this3.selectedType = response.data.type;
        _this3.selectedState = response.data.state;
        _this3.newVersionMajor = response.data.major;
        _this3.newVersionMinor = response.data.minor;
        _this3.newVersionBuild = response.data.build;

        _this3.loading = false;
      }).catch(function (e) {
        _this3.loading = false;
        console.log(e);
      });
    },
    getCurrentVersion: function getCurrentVersion() {
      var _this4 = this;

      this.loading = true;
      this.HTTP.get("productVersions/current/" + this.productId).then(function (response) {
        _this4.newVersionMajor = response.data.major;
        _this4.newVersionMinor = response.data.minor + 1;

        _this4.loading = false;
      }).catch(function (e) {
        _this4.loading = false;
        console.log(e);
      });
    },
    getStates: function getStates() {
      var _this5 = this;

      this.loading = true;
      this.HTTP.get("productversions/states").then(function (response) {
        _this5.states = response.data;

        _this5.loading = false;
      }).catch(function (e) {
        _this5.loading = false;
        console.log(e);
      });
    },
    getTypes: function getTypes() {
      var _this6 = this;

      this.loading = true;
      this.HTTP.get("productversions/types").then(function (response) {
        _this6.types = response.data;

        _this6.loading = false;
      }).catch(function (e) {
        _this6.loading = false;
        console.log(e);
      });
    },
    submit: function submit() {
      console.log("recordProcessing - " + this.recordProcessing);
      if (!this.recordProcessing) {
        this.saveClicked = true;
        if (this.newVersionMajor >= 0 && this.newVersionMinor >= 0 && this.newVersionBuild >= 0 && this.isInteger(this.newVersionMajor) && this.isInteger(this.newVersionMinor) && this.isInteger(this.newVersionBuild)) {
          this.recordProcessing = true;
          if (this.versionId <= 0) this.createVersion();else this.editVersion(this.versionId);
        }
      }
    },
    isInteger: function isInteger(num) {
      return (num ^ 0) === num;
    }
    // keyDownListener(evt) {
    //   if (evt.keyCode === 27) this.$emit("closeVersionEditor");
    //   else if (evt.keyCode === 13) this.submit();
    // }

  },

  created: function created() {
    this.loading = true;
    document.addEventListener("keydown", this.keyDownListener);
    //if edit
    if (this.versionId > 0) {
      this.getVersion(this.versionId);
    } else {
      this.getCurrentVersion();
    }
    this.getStates();
    this.getTypes();
  },

  destroyed: function destroyed() {
    document.removeEventListener("keydown", this.keyDownListener);
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GroupVersionCreator_vue_vue_type_script_lang_js__ = __webpack_require__(88);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GroupVersionCreator_vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalWindow__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import this.HTTP from "./Http";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "group-version-editor",
  components: { ModalWindow: __WEBPACK_IMPORTED_MODULE_0__ModalWindow__["a" /* default */] },
  props: {
    groupId: Number,
    header: String
  },
  data: function data() {
    return {
      newVersionName: "",
      selectedType: "None",
      newVersionMajor: 2025,
      newVersionMinor: 1,
      newVersionBuild: 0,

      states: [],
      types: [],
      selectedState: "Success",

      saveClicked: false,
      recordProcessing: false, //should prevent record duplicate creating
      errors: [],
      loading: false
    };
  },

  methods: {
    createVersion: function createVersion() {
      var _this = this;

      this.HTTP.post("productversions/group", {
        name: this.newVersionName,
        type: this.selectedType,
        state: this.selectedState,
        major: this.newVersionMajor,
        minor: this.newVersionMinor,
        build: this.newVersionBuild,
        productGroupId: this.groupId
      }).then(function (response) {
        _this.recordProcessing = false;
        _this.$emit("closeGroupVersionEditor");
      }).catch(function (e) {
        _this.recordProcessing = false;
        _this.errors = e.response.data.description;
        console.log(e.text);
      });
    },
    getStates: function getStates() {
      var _this2 = this;

      this.loading = true;
      this.HTTP.get("productversions/states").then(function (response) {
        _this2.states = response.data;

        _this2.loading = false;
      }).catch(function (e) {
        _this2.loading = false;
        console.log(e);
      });
    },
    getTypes: function getTypes() {
      var _this3 = this;

      this.loading = true;
      this.HTTP.get("productversions/types").then(function (response) {
        _this3.types = response.data;

        _this3.loading = false;
      }).catch(function (e) {
        _this3.loading = false;
        console.log(e);
      });
    },
    submit: function submit() {
      console.log("recordProcessing - " + this.recordProcessing);
      if (!this.recordProcessing) {
        this.saveClicked = true;
        if (this.newVersionMajor >= 0 && this.newVersionMinor >= 0 && this.newVersionBuild >= 0 && this.isInteger(this.newVersionMajor) && this.isInteger(this.newVersionMinor) && this.isInteger(this.newVersionBuild)) {
          this.recordProcessing = true;
          this.createVersion();
        }
      }
    },
    isInteger: function isInteger(num) {
      return (num ^ 0) === num;
    }
    // keyDownListener(evt) {
    //   if (evt.keyCode === 27) this.$emit("closeVersionEditor");
    //   else if (evt.keyCode === 13) this.submit();
    // }

  },
  created: function created() {
    this.loading = true;
    document.addEventListener("keydown", this.keyDownListener);
    this.getStates();
    this.getTypes();
  },

  destroyed: function destroyed() {
    document.removeEventListener("keydown", this.keyDownListener);
  }
});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(225);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("6402cdc4", content, true, {});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Callback_Vue_vue_type_script_lang_js__ = __webpack_require__(91);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Callback_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__);
//
//
//
//
//
//
//
//

//import this.HTTP from "../Http";



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "auth-view",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a },
  data: function data() {
    return {
      loading: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    // if (
    //   this.$route.query.id_token !== null &&
    //   this.$route.query.id_token !== undefined &&
    //   this.$route.query.id_token !== "undefined" &&
    //   this.$route.query.id_token.length > 0 &&
    //   this.$route.query.id_token.indexOf(".") !== -1
    // ) {
    //   this.HTTP.updateHeader(this.$route.query.id_token);
    //   this.$router.push("Changes");
    // }

    console.log(this.HTTP);
    this.HTTP.signinRedirectCallback().then(function (user) {
      _this.HTTP.load().then(function () {

        _this.HTTP.post("Users/UpdateUser", {
          idToken: user.id_token,
          accessToken: user.access_token
        }).then(function (userProfile) {
          console.log(userProfile);
          _this.HTTP.setUserProfile(userProfile.data);
          _this.$userName = userProfile.data.name;
          window.location.href = "../#/Changes";
        }).catch(function (ex) {});
      });

      //this.$router.push("Changes");
    }).catch(function (err) {
      console.log(err);
    });
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Silent_Vue_vue_type_script_lang_js__ = __webpack_require__(93);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Silent_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_oidc_client__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_oidc_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_oidc_client__);
//
//
//
//
//
//

//import this.HTTP from "../Http";




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "silent-view",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a },
  data: function data() {
    return {
      loading: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.HTTP.signinSilentCallback().then(function () {
      _this.HTTP.setHeader().then(function () {
        console.log("header settled");
      });
    });
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_History_Vue_vue_type_script_lang_js__ = __webpack_require__(95);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_History_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_oidc_client__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_oidc_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_oidc_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_pagination_src_Pagination__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContentFilter__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DeleteConfirmer__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import this.HTTP from "../Http";








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "history-view",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_pagination_src_Pagination__["a" /* default */], ContentFilter: __WEBPACK_IMPORTED_MODULE_4__ContentFilter__["a" /* default */], DeleteConfirmer: __WEBPACK_IMPORTED_MODULE_5__DeleteConfirmer__["a" /* default */] },
  data: function data() {
    return {
      logs: null,
      selectedRowsIds: [],
      //delete
      isDeleteModalVisible: false,
      deleteHeader: "Are you sure that you wanna delete this part of history?",
      deleteMsg: "This part of history will be losted forever!!!(. Rly",
      deleting: false, //indicating that deleting logs in progress now
      //pagination
      page: {
        pageNumber: 1,
        totalPages: 13,
        pageSize: 10,
        totalItems: -1
      },

      searchingText: "",
      loading: false,

      //change filter params
      filterGroups: [],
      filterType: ""
    };
  },
  computed: {
    filterMsg: function filterMsg() {
      if (this.page.totalItems > 0) return "<strong>" + this.page.totalItems + "</strong> logs";else return "";
    }
  },
  methods: {
    getLogs: function getLogs() {
      var _this = this;

      this.loading = true;
      var query = "logs/";
      if (this.searchingText.length > 0) {
        query += "search/";
      }
      query += this.page.pageNumber + "/" + this.page.pageSize;
      if (this.searchingText !== null && this.searchingText !== undefined && this.searchingText.length > 0) {
        query += "/" + this.searchingText;
      }
      this.HTTP.get(query).then(function (response) {
        _this.logs = response.data.entities;
        _this.page = response.data.page;
        _this.loading = false;
      }).catch(function (e) {
        console.log(e);
      });
    },
    rowClick: function rowClick(index) {
      if (this.selectedRowsIds.indexOf(index) <= -1) this.selectedRowsIds.push(index);else if (this.isDeleteModalVisible == false) {
        var i = this.selectedRowsIds.indexOf(index);
        this.selectedRowsIds.splice(i, 1);
      }
    },


    //delete
    getDeletedIds: function getDeletedIds() {
      var _this2 = this;

      var ids = [];
      this.selectedRowsIds.forEach(function (id) {
        ids.push(_this2.logs[id].id);
      });
      return ids;
    },
    deleteLogs: function deleteLogs() {
      var _this3 = this;

      this.HTTP.delete("logs/" + this.getDeletedIds()).then(function (response) {
        _this3.selectedRowsIds = [];
        _this3.closeLogsDeleteWindow();
      }).catch(function (e) {
        console.log(e);
      });
    },
    closeLogsDeleteWindow: function closeLogsDeleteWindow() {
      this.isDeleteModalVisible = false;
      this.getLogs();
    },

    //pagination

    urlBuilder: function urlBuilder(page) {
      return { query: _extends({}, this.$route.query, { page: page }) }; // Changing page in location query
    },
    pushUrl: function pushUrl() {
      this.$router.push({
        path: "Logs",
        query: {
          page: this.page.pageNumber,
          search: this.searchingText
        }
      });
    },


    //search
    searchHandler: function searchHandler(searchingText) {
      this.searchingText = searchingText;
    },
    clearSearch: function clearSearch() {
      this.searchingText = "";
      this.page.pageNumber = 1;
    }
  },
  created: function created() {
    if (this.cardsCount) {
      this.page.pageSize = this.cardsCount;
    }
    this.loading = true;
    this.HTTP.load(); //.then(() => {
    this.getLogs();
    //   });
  },

  watch: {
    $route: function $route(to, from) {
      if (to.query.page != null && to.query.page != undefined) {
        this.page.pageNumber = parseInt(to.query.page);
        this.searchingText = to.query.search;
      }

      this.getLogs();
    },

    searchingText: function searchingText(val) {
      this.pushUrl();
    },
    page: function page(val) {
      this.pushUrl();
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProfileSettings_Vue_vue_type_script_lang_js__ = __webpack_require__(97);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProfileSettings_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "profile-settings",
  data: function data() {
    return {
      vType: "default",
      cCount: 10
    };
  },

  methods: {
    save: function save() {
      this.viewType = this.vType;
      this.cardsCount = this.cCount;
      this.$router.go(-1);
    },
    setvType: function setvType() {
      if (this.viewType) this.vType = this.viewType;else {
        this.viewType = "default";
        this.vType = "default";
      }
    },
    setCardsCount: function setCardsCount() {
      if (this.cardsCount) this.cCount = this.cardsCount;else {
        this.cardsCount = 10;
        this.cCount = 10;
      }
    }
  },
  created: function created() {
    this.setvType();
    this.setCardsCount();
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesSaving_Vue_vue_type_script_lang_js__ = __webpack_require__(99);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesSaving_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__download__ = __webpack_require__(19);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.split(search).join(replacement);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "changes-saving",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a },
  data: function data() {
    return {
      loading: false,
      changesTxt: {},
      changesRaw: {},
      btype: "text/plain",
      saveType: "all",
      language: "english",
      fileType: "txt",
      grouping: "minor",
      tags: [],

      filterType: "All",
      searchingText: "",
      productId: -1,
      version: -1,

      fileLink: "",
      filename: "changes.txt"
    };
  },

  methods: {
    getCurrentVersion: function getCurrentVersion() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.loading = true;
        _this.HTTP.get("productVersions/current/" + _this.productId).then(function (response) {
          _this.version = response.data.id;
          _this.loading = false;
          resolve();
        }).catch(function (e) {
          _this.loading = false;
          console.log(e);
          reject();
        });
      });
    },
    getLastVersion: function getLastVersion() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.loading = true;
        _this2.HTTP.get("productVersions/last/" + _this2.productId).then(function (response) {
          _this2.loading = false;
          _this2.version = response.data.id;
          resolve();
        }).catch(function (e) {
          _this2.loading = false;
          console.log(e);
          reject();
        });
      });
    },
    getProductsFile: function getProductsFile() {
      this.loading = true;
      this.HTTP.post("changes/products/file", {}).then(function (response) {}).catch(function (e) {
        console.log(e);
      });
    },
    getChangesTxt: function getChangesTxt() {
      var _HTTP$post,
          _this3 = this;

      this.loading = true;
      this.HTTP.post("changes/product/file_v2", (_HTTP$post = {
        productId: this.productId,
        fileType: this.fileType,
        grouping: this.grouping,
        filterType: this.filterType,
        tags: this.tags
      }, _defineProperty(_HTTP$post, "fileType", this.fileType), _defineProperty(_HTTP$post, "language", this.language), _defineProperty(_HTTP$post, "version", this.saveType == "currentVersion" || this.saveType == "lastVersion" ? this.version : null), _HTTP$post)).then(function (response) {
        var chgs = response.data;
        if (chgs.length == 0) chgs += "\nThere is no any changes in version " + _this3.version + "!";
        if (_this3.fileType == "txt" || _this3.fileType == "markdown") {
          _this3.changesTxt = chgs.replaceAll("\n", "<br>");
          _this3.filename = _this3.fileType == "markdown" ? "changes.md" : "changes.txt";
          _this3.btype = "text/plain";
          _this3.changesRaw = chgs;
        } else {
          _this3.changesTxt = JSON.stringify(chgs);
          _this3.filename = "changes.json";
          _this3.btype = "application/json";
          _this3.changesRaw = JSON.stringify(chgs);
        }
        _this3.loading = false;
      }).catch(function (e) {
        console.log(e);
      });
    },
    download: function download() {
      var blob = new Blob([this.changesRaw]);
      __WEBPACK_IMPORTED_MODULE_2__download__["download"](blob, this.filename, this.btype);
    }
    // pushUrl() {
    //   this.$router.push({
    //     path: "ChangesSaving",
    //     query: {
    //       saveType: this.saveType,
    //       language: this.language
    //     }
    //   });
    // }

  },
  created: function created() {
    var _this4 = this;

    this.saveType = this.$route.query.saveType;
    this.language = this.$route.query.language;
    this.fileType = this.$route.query.fileType;
    this.grouping = this.$route.query.grouping;

    this.productId = parseInt(this.$route.query.productId);
    this.searchingText = this.$route.query.search;
    this.filterType = this.$route.query.filterType;
    this.tags = this.$route.query.tags;

    if (this.saveType == "currentVersion") this.getCurrentVersion().then(function () {
      _this4.getChangesTxt();
    });else if (this.saveType == "lastVersion") {
      this.getLastVersion().then(function () {
        _this4.getChangesTxt();
      });
    } else this.getChangesTxt();
  },

  watch: {
    // $route(to, from) {
    //   this.saveType = to.query.saveType;
    //   this.language = to.query.language;
    //   this.productId = parseInt(to.query.productId);
    //   this.searchingText = to.query.search;
    //   this.filterType = to.query.filterType;
    //   this.getChangesTxt();
    // },
    // saveType: function(val) {
    //   this.pushUrl();
    // },
    // language: function(val) {
    //   this.pushUrl();
    // }
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AdminPanel_Vue_vue_type_script_lang_js__ = __webpack_require__(101);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AdminPanel_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideMenu__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImportPartial__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RestorePartial__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "admin-view",
  components: { SideMenu: __WEBPACK_IMPORTED_MODULE_0__SideMenu__["a" /* default */], Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a, ImportPartial: __WEBPACK_IMPORTED_MODULE_1__ImportPartial__["a" /* default */], RestorePartial: __WEBPACK_IMPORTED_MODULE_2__RestorePartial__["a" /* default */] },
  data: function data() {
    return {
      adminHeader: "Actions",
      actions: [{
        id: 0,
        name: "Import"
      }, {
        id: 1,
        name: "Manage deleted entries"
      }],
      actionId: 0,
      productId: -1,
      loading: false
    };
  },

  methods: {
    toggleAdmin: function toggleAdmin(id) {
      this.actionId = id;
    },
    pushUrl: function pushUrl() {
      this.$router.push({
        path: "admin",
        query: {
          actionId: this.actionId,
          productId: this.productId
        }
      });
    }
  },
  created: function created() {
    var id = parseInt(this.$route.query.actionId);
    if (id) {
      this.actionId = id;
    } else {
      this.actionId = 0;
    }
    console.log("productId");
    console.log(parseInt(this.$route.query.productId));
    var pId = parseInt(this.$route.query.productId);
    if (pId > 0) this.productId = pId;

    this.pushUrl();
  },

  watch: {
    $route: function $route(to, from) {
      this.actionId = parseInt(to.query.actionId);
    },

    actionId: function actionId(val) {
      this.pushUrl();
    }
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportPartial_Vue_vue_type_script_lang_js__ = __webpack_require__(103);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportPartial_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "import-partial",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a },
  props: {},
  data: function data() {
    return {
      enFile: "",
      ruFile: "",
      products: [],
      productId: 1,
      loading: false
    };
  },


  methods: {
    handleChangesEnUpload: function handleChangesEnUpload() {
      console.log(this.$refs.changesEnFile.files);
      this.enFile = this.$refs.changesEnFile.files[0];
    },
    handleChangesRuUpload: function handleChangesRuUpload() {
      this.ruFile = this.$refs.changesRuFile.files[0];
    },
    importChanges: function importChanges() {
      var _this = this;

      this.loading = true;
      var formData = new FormData();
      formData.append("engChangesTextFile", this.enFile);
      formData.append("rusChangesTextFile", this.ruFile);

      this.HTTP.post("Changes/product/fromTxt/" + this.productId, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(function (response) {
        _this.loading = false;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    getProducts: function getProducts() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.HTTP.get("products/" + 1 + "/" + 100).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          reject(e);
        });
      });
    }
  },

  created: function created() {
    var _this3 = this;

    this.loading = true;
    this.getProducts().then(function (data) {
      console.log(data);
      _this3.products = data.entities;
      if (data.entities != null && data.entities.length > 0) _this3.productId = data.entities[0].id;
      _this3.loading = false;
    });
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RestorePartial_Vue_vue_type_script_lang_js__ = __webpack_require__(105);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RestorePartial_Vue_vue_type_script_lang_js__["a" /* default */]); 

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChangeCard__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductCard__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VersionCard__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_pagination_src_Pagination__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: "restore-partial",
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a,
    ChangeCard: __WEBPACK_IMPORTED_MODULE_0__ChangeCard__["a" /* default */],
    ProductCard: __WEBPACK_IMPORTED_MODULE_1__ProductCard__["a" /* default */],
    VersionCard: __WEBPACK_IMPORTED_MODULE_2__VersionCard__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_pagination_src_Pagination__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      selectedTable: "changes",
      productId: 121,
      products: [],
      changes: [],
      versions: [],

      //pagination
      page: {
        pageNumber: 1,
        totalPages: 13,
        pageSize: 10,
        totalItems: -1
      }
    };
  },

  methods: {
    getProducts: function getProducts(deleted, take) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.loading = true;
        _this.HTTP.get("products/" + (deleted ? "deleted/" : "") + _this.page.pageNumber + "/" + take).then(function (response) {
          _this.loading = false;
          resolve(response);
        }).catch(function (e) {
          _this.loading = false;
          reject(e);
        });
      });
    },
    getDeletedChanges: function getDeletedChanges() {
      var _this2 = this;

      this.loading = true;
      var query = "changes/product/deleted/";
      var filterType = "All";
      query += this.productId + "/" + this.page.pageNumber + "/" + this.page.pageSize + "/" + filterType;

      this.HTTP.get(query).then(function (response) {
        _this2.changes = response.data.entities;
        _this2.page = response.data.page;
        _this2.loading = false;
      }).catch(function (e) {
        console.log(e);
      });
    },
    getDeletedVersions: function getDeletedVersions() {
      var _this3 = this;

      this.loading = true;
      var query = "ProductVersions/product/deleted/";
      query += this.productId + "/" + this.page.pageNumber + "/" + this.page.pageSize;

      this.HTTP.get(query).then(function (response) {
        _this3.versions = response.data.entities;
        _this3.page = response.data.page;
        _this3.loading = false;
      }).catch(function (e) {
        console.log(e);
      });
    },
    restoreChange: function restoreChange(id) {
      var _this4 = this;

      this.loading = true;
      var query = "changes/restore/" + id;
      this.HTTP.get(query).then(function (response) {
        _this4.getDeletedChanges();
      }).catch(function (e) {
        console.log(e);
      });
    },
    restoreProduct: function restoreProduct(id) {
      var _this5 = this;

      this.loading = true;
      var query = "products/restore/" + id;
      this.HTTP.get(query).then(function (response) {
        _this5.getProducts(true, _this5.page.pageSize).then(function (response) {
          _this5.products = response.data.entities;
          _this5.page = response.data.page;
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    restoreVersion: function restoreVersion(id) {
      var _this6 = this;

      this.loading = true;
      var query = "ProductVersions/restore/" + id;
      this.HTTP.get(query).then(function (response) {
        _this6.getDeletedVersions();
      }).catch(function (e) {
        console.log(e);
      });
    },
    urlBuilder: function urlBuilder(page) {
      return { query: _extends({}, this.$route.query, { page: page }) }; // Changing page in location query
    },
    pushUrl: function pushUrl() {
      this.$router.push({
        path: "admin",
        query: {
          productId: this.productId,
          page: this.page.pageNumber,
          actionId: this.$route.query.actionId
        }
      });
    }
  },
  created: function created() {
    var _this7 = this;

    if (this.cardsCount) {
      this.page.pageSize = this.cardsCount;
    }
    if (this.selectedTable == "changes" || this.selectedTable == "versions") {
      this.getProducts(false, 1000).then(function (response) {
        _this7.products = response.data.entities;

        if (response.data.entities != null && response.data.entities.length > 0 && (!_this7.$route || _this7.$route.query.productId == "NaN" || _this7.$route.query.productId < 0)) _this7.productId = response.data.entities[0].id;else {
          console.log(_this7.$route.query.productId);
          _this7.productId = parseInt(_this7.$route.query.productId);
        }
        _this7.page = response.data.page;
      });
    }
  },

  watch: _defineProperty({
    selectedTable: function selectedTable(newVal) {
      var _this8 = this;

      if (newVal == "changes") {
        this.getProducts(false, 1000).then(function (response) {
          _this8.products = response.data.entities;
          _this8.page = response.data.page;
          _this8.productId = response.data.entities[0].id;
        });
      } else if (newVal == "products") {
        this.getProducts(true, this.page.pageSize).then(function (response) {
          _this8.products = response.data.entities;
          _this8.page = response.data.page;
        });
      } else if (newVal == "versions") {
        this.getProducts(false, 1000).then(function (response) {
          _this8.products = response.data.entities;
          _this8.page = response.data.page;
          _this8.productId = response.data.entities[0].id;
          _this8.getDeletedVersions();
        });
      }
    },
    productId: function productId(newVal) {
      var _this9 = this;

      if (this.selectedTable == "changes") this.getDeletedChanges();else if (this.selectedTable == "versions") this.getProducts(true, 1000).then(function (response) {
        _this9.products = response.data.entities;
        _this9.page = response.data.page;
      });else if (this.selectedTable == "versions") this.getDeletedVersions();
    },
    page: function page(val) {
      this.pushUrl();
    },
    $route: function $route(to, from) {
      var _this10 = this;

      this.page.pageNumber = parseInt(to.query.page);
      this.productId = parseInt(to.query.productId);

      if (this.selectedTable == "changes") this.getDeletedChanges();else if (this.selectedTable == "products") this.getProducts(true, this.page.pageSize).then(function (response) {
        _this10.products = response.data.entities;
        _this10.page = response.data.page;
      });else if (this.selectedTable == "versions") this.getDeletedVersions();
    }
  }, "productId", function productId(val) {
    this.pushUrl();
  })
});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(251);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("bfb30cc6", content, true, {});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scss_base_scss__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scss_base_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__scss_base_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Http__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_buefy__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_buefy_dist_buefy_css__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_buefy_dist_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_buefy_dist_buefy_css__);









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_buefy___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$authPage = false; //specified to show header or not
//Vue.prototype.$userName = "Allo Etot";

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__webpack_require__(255));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin({
  data: function data() {
    return {
      get HTTP() {
        return __WEBPACK_IMPORTED_MODULE_4__components_Http__["a" /* default */];
      },
      get userName() {
        var user = __WEBPACK_IMPORTED_MODULE_4__components_Http__["a" /* default */].getUserProfile();
        if (user && user.name) return user.name;
        return "John Doe";
      },
      get userRole() {
        var user = __WEBPACK_IMPORTED_MODULE_4__components_Http__["a" /* default */].getUserProfile();
        if (user && user.role) return user.role;
        return "readonly";
      }
    };
  },
  computed: {
    viewType: {
      get: function get() {
        var vt = localStorage.getItem("viewType");
        return vt;
      },
      set: function set(newValue) {
        localStorage.setItem("viewType", newValue);
      }
    },
    cardsCount: {
      get: function get() {
        var cc = localStorage.getItem("cardsCount");
        return cc;
      },
      set: function set(newValue) {
        localStorage.setItem("cardsCount", newValue);
      }
    },
    selectedProductId: {
      get: function get() {
        var pid = localStorage.getItem("selectedProductId");
        return parseInt(pid);
      },
      set: function set(newValue) {
        localStorage.setItem("selectedProductId", newValue);
      }
    },
    selectedVersionId: {
      get: function get() {
        var vid = localStorage.getItem("selectedVersionId");
        return parseInt(vid);
      },
      set: function set(newValue) {
        localStorage.setItem("selectedVersionId", newValue);
      }
    }
  }
});

var needAuth = function needAuth() {
  console.log(__WEBPACK_IMPORTED_MODULE_4__components_Http__["a" /* default */]);
  if (__WEBPACK_IMPORTED_MODULE_4__components_Http__["a" /* default */].getToken()) {
    return false;
  } else return true;
};

__WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.path !== '/auth' && to.path !== '/callback') {

    __WEBPACK_IMPORTED_MODULE_4__components_Http__["a" /* default */].getUser().then(function (user) {
      if (user !== null && !user.expired) {
        console.log("Got user!!!");
        console.log(user);
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$authPage = false;
        next();
      } else {
        console.log("user didn't received");
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$authPage = true;
        next('/auth');
      }
    });
    // if (!needAuth()) {
    //   console.log("Got token!!!");
    //   Vue.prototype.$authPage = false;
    //   next();
    // }
    // else {
    //   console.log("Token didn't received");
    //   Vue.prototype.$authPage = true;
    //   next('/auth');
    // }
  } else {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$authPage = true;
    next();
  }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */] },
  router: __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */]
  //store
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(110);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || this && this.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || this && this.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(15)))

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_2f2f0a5f__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_2f2f0a5f__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_2f2f0a5f__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_2f2f0a5f__ = __webpack_require__(113);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_2f2f0a5f__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_2f2f0a5f__["b"]; });


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.$authPage)?_c('app-header',{attrs:{"username":_vm.username}}):_vm._e(),_vm._v(" "),_c('router-view',{attrs:{"id":"rv"}}),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_vm._v("\n                  ChangeLogger ©2018\n              ")])])])])}]



/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppHeader_Vue_vue_type_template_id_099f2864__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppHeader_Vue_vue_type_script_lang_js__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AppHeader_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__AppHeader_Vue_vue_type_template_id_099f2864__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AppHeader_Vue_vue_type_template_id_099f2864__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AppHeader_Vue_vue_type_template_id_099f2864__ = __webpack_require__(116);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AppHeader_Vue_vue_type_template_id_099f2864__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AppHeader_Vue_vue_type_template_id_099f2864__["b"]; });


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar is-white is-dark",attrs:{"id":"appheader"}},[_c('div',{staticClass:"navbar-brand",attrs:{"id":"navMenu"}},[_c('div',{staticClass:"navbar-burger burger",class:{'is-active':_vm.isMobile},on:{"click":function($event){_vm.isMobile = !_vm.isMobile}}},[_c('span',{attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"navbar-menu",class:{'is-active':_vm.isMobile},attrs:{"id":"navMenu"}},[_c('div',{staticClass:"navbar-start"},[_c('a',{staticClass:"navbar-item",class:{'is-active': _vm.selectedItem == '/changes'},attrs:{"href":"#/changes"},on:{"click":function($event){_vm.selectedItem = '/changes'}}},[_vm._v("\n          Changes\n        ")]),_vm._v(" "),_c('a',{staticClass:"navbar-item",class:{'is-active': _vm.selectedItem == '/products'},attrs:{"href":"#/products"},on:{"click":function($event){_vm.selectedItem = '/products'}}},[_vm._v("\n          Products\n        ")]),_vm._v(" "),_c('a',{staticClass:"navbar-item",class:{'is-active': _vm.selectedItem == '/productGroups'},attrs:{"href":"#/productGroups"},on:{"click":function($event){_vm.selectedItem = '/productGroups'}}},[_vm._v("\n          Product Groups\n        ")]),_vm._v(" "),_c('a',{staticClass:"navbar-item",class:{'is-active': _vm.selectedItem == '/versions'},attrs:{"href":"#/versions"},on:{"click":function($event){_vm.selectedItem = '/versions'}}},[_vm._v("\n          Versions\n        ")]),_vm._v(" "),(this.userRole == 'admin')?_c('a',{staticClass:"navbar-item",class:{'is-active': _vm.selectedItem == '/logs'},attrs:{"href":"#/logs"},on:{"click":function($event){_vm.selectedItem = '/logs'}}},[_vm._v("\n          CRUD Logs\n        ")]):_vm._e(),_vm._v(" "),(this.userRole == 'admin')?_c('a',{staticClass:"navbar-item",class:{'is-active': _vm.selectedItem == '/admin'},attrs:{"href":"#/admin"},on:{"click":function($event){_vm.selectedItem = '/admin'}}},[_vm._v("\n          Admin Panel\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"navbar-end"},[_c('div',{staticClass:"navbar-item has-dropdown",class:{'is-active': _vm.dropdownActive},attrs:{"id":"profileMenu"},on:{"click":function($event){_vm.dropdownActive = !_vm.dropdownActive}}},[_c('a',{staticClass:"navbar-link"},[_c('span',[_vm._v("\n                "+_vm._s(_vm.userName)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"navbar-dropdown is-right"},[_c('a',{staticClass:"navbar-item",attrs:{"href":"https://id.fast-report.com/Manage","target":"_blank"}},[_vm._v("\n                Profile\n              ")]),_vm._v(" "),_c('a',{staticClass:"navbar-item",on:{"click":function($event){$event.preventDefault();return _vm.goToSettings($event)}}},[_vm._v("\n                Settings\n              ")]),_vm._v(" "),_c('a',{staticClass:"navbar-item",on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v("\n                 Log out\n                ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-sign-out-alt"})])}]



/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(118);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var bind = __webpack_require__(25);
var Axios = __webpack_require__(120);
var defaults = __webpack_require__(16);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(29);
axios.CancelToken = __webpack_require__(133);
axios.isCancel = __webpack_require__(28);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(134);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),
/* 119 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer(obj) {
  return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(16);
var utils = __webpack_require__(5);
var InterceptorManager = __webpack_require__(128);
var dispatchRequest = __webpack_require__(129);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, { method: 'get' }, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(27);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var transformData = __webpack_require__(130);
var isCancel = __webpack_require__(28);
var defaults = __webpack_require__(16);
var isAbsoluteURL = __webpack_require__(131);
var combineURLs = __webpack_require__(132);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(29);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function splitPath(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function () {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = i >= 0 ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function (p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function (path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function (p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function (path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function () {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function (p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};

// path.relative(from, to)
// posix version
exports.relative = function (from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};

exports.basename = function (path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  return splitPath(path)[3];
};

function filter(xs, f) {
  if (xs.filter) return xs.filter(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    if (f(xs[i], i, xs)) res.push(xs[i]);
  }
  return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b' ? function (str, start, len) {
  return str.substr(start, len);
} : function (str, start, len) {
  if (start < 0) start = str.length + start;
  return str.substr(start, len);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#app{display:flex;min-height:100vh;flex-direction:column;margin:0}*{box-sizing:border-box}body{min-height:100vh;flex-direction:column;margin:0}#main,body{display:flex}#main{flex:1}#main>aside{flex:0 0 10vw}.footer{height:10vh}nav.navbar{padding:0}", ""]);

// exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = listToStyles;
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles(parentId, list) {
  var styles = [];
  var newStyles = {};
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = item[0];
    var css = item[1];
    var media = item[2];
    var sourceMap = item[3];
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    };
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] });
    } else {
      newStyles[id].parts.push(part);
    }
  }
  return styles;
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Changes__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Products__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_ProductGroups__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Versions__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Callback__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_Silent__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_History__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_ProfileSettings__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_ChangesSaving__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_AdminPanel__ = __webpack_require__(241);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/changes', component: __WEBPACK_IMPORTED_MODULE_2__components_views_Changes__["a" /* default */] }, { path: '/auth', component: __WEBPACK_IMPORTED_MODULE_3__components_views_Auth__["a" /* default */] }, { path: '/products', component: __WEBPACK_IMPORTED_MODULE_4__components_views_Products__["a" /* default */] }, { path: '/productGroups', component: __WEBPACK_IMPORTED_MODULE_5__components_views_ProductGroups__["a" /* default */] }, { path: '/versions', component: __WEBPACK_IMPORTED_MODULE_6__components_views_Versions__["a" /* default */] }, { path: '/callback', component: __WEBPACK_IMPORTED_MODULE_7__components_views_Callback__["a" /* default */] }, { path: '/silent', component: __WEBPACK_IMPORTED_MODULE_8__components_views_Silent__["a" /* default */] }, { path: '/logs', component: __WEBPACK_IMPORTED_MODULE_9__components_views_History__["a" /* default */] }, { path: '/', component: __WEBPACK_IMPORTED_MODULE_2__components_views_Changes__["a" /* default */] }, { path: '/profileSettings', component: __WEBPACK_IMPORTED_MODULE_10__components_views_ProfileSettings__["a" /* default */] }, { path: '/changesSaving', component: __WEBPACK_IMPORTED_MODULE_11__components_views_ChangesSaving__["a" /* default */] }, { path: '/admin', component: __WEBPACK_IMPORTED_MODULE_12__components_views_AdminPanel__["a" /* default */]
    // { path: '/board/:id', name: 'board', component: Board, props: true }
  }]
}));

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
  * vue-router v3.0.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert(condition, message) {
  if (!condition) {
    throw new Error("[vue-router] " + message);
  }
}

function warn(condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn("[vue-router] " + message);
  }
}

function isError(err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1;
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render(_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children);
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h();
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (val && current !== vm || !val && current === vm) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children);
  }
};

function resolveProps(route, config) {
  switch (typeof config === 'undefined' ? 'undefined' : _typeof(config)) {
    case 'undefined':
      return;
    case 'object':
      return config;
    case 'function':
      return config(route);
    case 'boolean':
      return config ? route.params : undefined;
    default:
      if (false) {
        warn(false, "props in \"" + route.path + "\" is a " + (typeof config === 'undefined' ? 'undefined' : _typeof(config)) + ", " + "expecting an object, function or boolean.");
      }
  }
}

function extend(to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to;
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function encodeReserveReplacer(c) {
  return '%' + c.charCodeAt(0).toString(16);
};
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function encode(str) {
  return encodeURIComponent(str).replace(encodeReserveRE, encodeReserveReplacer).replace(commaRE, ',');
};

var decode = decodeURIComponent;

function resolveQuery(query, extraQuery, _parseQuery) {
  if (extraQuery === void 0) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery;
}

function parseQuery(query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res;
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}

function stringifyQuery(obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return '';
    }

    if (val === null) {
      return encode(key);
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return;
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&');
    }

    return encode(key) + '=' + encode(val);
  }).filter(function (x) {
    return x.length > 0;
  }).join('&') : null;
  return res ? "?" + res : '';
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute(record, location, redirectedFrom, router) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || record && record.name,
    meta: record && record.meta || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route);
}

function clone(value) {
  if (Array.isArray(value)) {
    return value.map(clone);
  } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res;
  } else {
    return value;
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch(record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res;
}

function getFullPath(ref, _stringifyQuery) {
  var path = ref.path;
  var query = ref.query;if (query === void 0) query = {};
  var hash = ref.hash;if (hash === void 0) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash;
}

function isSameRoute(a, b) {
  if (b === START) {
    return a === b;
  } else if (!b) {
    return false;
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && a.hash === b.hash && isObjectEqual(a.query, b.query);
  } else if (a.name && b.name) {
    return a.name === b.name && a.hash === b.hash && isObjectEqual(a.query, b.query) && isObjectEqual(a.params, b.params);
  } else {
    return false;
  }
}

function isObjectEqual(a, b) {
  if (a === void 0) a = {};
  if (b === void 0) b = {};

  // handle null value #1566
  if (!a || !b) {
    return a === b;
  }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false;
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if ((typeof aVal === 'undefined' ? 'undefined' : _typeof(aVal)) === 'object' && (typeof bVal === 'undefined' ? 'undefined' : _typeof(bVal)) === 'object') {
      return isObjectEqual(aVal, bVal);
    }
    return String(aVal) === String(bVal);
  });
}

function isIncludedRoute(current, target) {
  return current.path.replace(trailingSlashRE, '/').indexOf(target.path.replace(trailingSlashRE, '/')) === 0 && (!target.hash || current.hash === target.hash) && queryIncludes(current.query, target.query);
}

function queryIncludes(current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false;
    }
  }
  return true;
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render(h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null ? 'router-link-exact-active' : globalExactActiveClass;
    var activeClass = this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null ? exactActiveClassFallback : this.exactActiveClass;
    var compareTarget = location.path ? createRoute(null, location, null, router) : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact ? classes[exactActiveClass] : isIncludedRoute(current, compareTarget);

    var handler = function handler(e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default);
  }
};

function guardEvent(e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) {
    return;
  }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) {
    return;
  }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) {
    return;
  }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) {
      return;
    }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true;
}

function findAnchor(children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child;
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child;
      }
    }
  }
}

var _Vue;

function install(Vue) {
  if (install.installed && _Vue === Vue) {
    return;
  }
  install.installed = true;

  _Vue = Vue;

  var isDef = function isDef(v) {
    return v !== undefined;
  };

  var registerInstance = function registerInstance(vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate() {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = this.$parent && this.$parent._routerRoot || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed() {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get() {
      return this._routerRoot._router;
    }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get() {
      return this._routerRoot._route;
    }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath(relative, base, append) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative;
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative;
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/');
}

function parsePath(path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  };
}

function cleanPath(path) {
  return path.replace(/\/\//g, '/');
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
// Match escaped characters that would otherwise appear in future matches.
// This allows the user to escape special characters that won't transform.
'(\\\\.)',
// Match Express-style parameters and un-named parameters with a prefix
// and optional suffixes. Matches appear as:
//
// "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
// "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
// "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
'([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse(str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue;
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?'
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens;
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile(str, options) {
  return tokensToFunction(parse(str, options));
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty(str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk(str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (_typeof(tokens[i]) === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue;
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue;
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined');
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
        }

        if (value.length === 0) {
          if (token.optional) {
            continue;
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty');
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue;
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
      }

      path += token.prefix + segment;
    }

    return path;
  };
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup(group) {
  return group.replace(/([=!:$\/()])/g, '\\$1');
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys(re, keys) {
  re.keys = keys;
  return re;
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags(options) {
  return options.sensitive ? '' : 'i';
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp(path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys);
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp(path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys);
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp(path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options);
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp(tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys);
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp(path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */keys);
  }

  if (isarray(path)) {
    return arrayToRegexp( /** @type {!Array} */path, /** @type {!Array} */keys, options);
  }

  return stringToRegexp( /** @type {string} */path, /** @type {!Array} */keys, options);
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams(path, params, routeMsg) {
  try {
    var filler = regexpCompileCache[path] || (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true });
  } catch (e) {
    if (false) {
      warn(false, "missing param for " + routeMsg + ": " + e.message);
    }
    return '';
  }
}

/*  */

function createRouteMap(routes, oldPathList, oldPathMap, oldNameMap) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  };
}

function addRouteRecord(pathList, pathMap, nameMap, route, parent, matchAs) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(typeof route.component !== 'string', "route config \"component\" for path: " + String(path || name) + " cannot be a " + "string id. Use an actual component instead.");
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null ? {} : route.components ? route.props : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) {
        return (/^\/?$/.test(child.path)
        );
      })) {
        warn(false, "Named Route '" + route.name + "' has a default child route. " + "When navigating to this named route (:to=\"{name: '" + route.name + "'\"), " + "the default child route will not be rendered. Remove the name from " + "this route and use the name of the default child route for named " + "links instead.");
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs ? cleanPath(matchAs + "/" + child.path) : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(pathList, pathMap, nameMap, aliasRoute, parent, record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(false, "Duplicate named routes definition: " + "{ name: \"" + name + "\", path: \"" + record.path + "\" }");
    }
  }
}

function compileRouteRegex(path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], "Duplicate param keys in route with path: \"" + path + "\"");
      keys[key.name] = true;
    });
  }
  return regex;
}

function normalizePath(path, parent, strict) {
  if (!strict) {
    path = path.replace(/\/$/, '');
  }
  if (path[0] === '/') {
    return path;
  }
  if (parent == null) {
    return path;
  }
  return cleanPath(parent.path + "/" + path);
}

/*  */

function normalizeLocation(raw, current, append, router) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next;
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, "path " + current.path);
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next;
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = current && current.path || '/';
  var path = parsedPath.path ? resolvePath(parsedPath.path, basePath, append || next.append) : basePath;

  var query = resolveQuery(parsedPath.query, next.query, router && router.options.parseQuery);

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  };
}

function assign(a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a;
}

/*  */

function createMatcher(routes, router) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes(routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match(raw, currentRoute, redirectedFrom) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, "Route with name '" + name + "' does not exist");
      }
      if (!record) {
        return _createRoute(null, location);
      }
      var paramNames = record.regex.keys.filter(function (key) {
        return !key.optional;
      }).map(function (key) {
        return key.name;
      });

      if (_typeof(location.params) !== 'object') {
        location.params = {};
      }

      if (currentRoute && _typeof(currentRoute.params) === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, "named route \"" + name + "\"");
        return _createRoute(record, location, redirectedFrom);
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom);
        }
      }
    }
    // no match
    return _createRoute(null, location);
  }

  function redirect(record, location) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function' ? originalRedirect(createRoute(record, location, null, router)) : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || (typeof redirect === 'undefined' ? 'undefined' : _typeof(redirect)) !== 'object') {
      if (false) {
        warn(false, "invalid redirect option: " + JSON.stringify(redirect));
      }
      return _createRoute(null, location);
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, "redirect failed: named route \"" + name + "\" not found.");
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location);
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, "redirect route with path \"" + rawPath + "\"");
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location);
    } else {
      if (false) {
        warn(false, "invalid redirect option: " + JSON.stringify(redirect));
      }
      return _createRoute(null, location);
    }
  }

  function alias(record, location, matchAs) {
    var aliasedPath = fillParams(matchAs, location.params, "aliased route with path \"" + matchAs + "\"");
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location);
    }
    return _createRoute(null, location);
  }

  function _createRoute(record, location, redirectedFrom) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location);
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs);
    }
    return createRoute(record, location, redirectedFrom, router);
  }

  return {
    match: match,
    addRoutes: addRoutes
  };
}

function matchRoute(regex, path, params) {
  var m = path.match(regex);

  if (!m) {
    return false;
  } else if (!params) {
    return true;
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true;
}

function resolveRecordPath(path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true);
}

/*  */

var positionStore = Object.create(null);

function setupScroll() {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll(router, to, from, isPop) {
  if (!router.app) {
    return;
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return;
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return;
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition(shouldScroll, position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition() {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition() {
  var key = getStateKey();
  if (key) {
    return positionStore[key];
  }
}

function getElementPosition(el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  };
}

function isValidPosition(obj) {
  return isNumber(obj.x) || isNumber(obj.y);
}

function normalizePosition(obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  };
}

function normalizeOffset(obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  };
}

function isNumber(v) {
  return typeof v === 'number';
}

function scrollToPosition(shouldScroll, position) {
  var isObject = (typeof shouldScroll === 'undefined' ? 'undefined' : _typeof(shouldScroll)) === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && _typeof(shouldScroll.offset) === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && function () {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  }

  return window.history && 'pushState' in window.history;
}();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now ? window.performance : Date;

var _key = genKey();

function genKey() {
  return Time.now().toFixed(3);
}

function getStateKey() {
  return _key;
}

function setStateKey(key) {
  _key = key;
}

function pushState(url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState(url) {
  pushState(url, true);
}

/*  */

function runQueue(queue, fn, cb) {
  var step = function step(index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents(matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function' ? resolvedDef : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason) ? reason : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) {
      next();
    }
  };
}

function flatMapComponents(matched, fn) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return fn(m.components[key], m.instances[key], m, key);
    });
  }));
}

function flatten(arr) {
  return Array.prototype.concat.apply([], arr);
}

var hasSymbol = typeof Symbol === 'function' && _typeof(Symbol.toStringTag) === 'symbol';

function isESModule(obj) {
  return obj.__esModule || hasSymbol && obj[Symbol.toStringTag] === 'Module';
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once(fn) {
  var called = false;
  return function () {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }if (called) {
      return;
    }
    called = true;
    return fn.apply(this, args);
  };
}

/*  */

var History = function History(router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen(cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady(cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError(errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo(location, onComplete, onAbort) {
  var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) {
        cb(route);
      });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) {
        cb(err);
      });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition(route, onComplete, onAbort) {
  var this$1 = this;

  var current = this.current;
  var abort = function abort(err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (isSameRoute(route, current) &&
  // in the case the route map has been dynamically appended to
  route.matched.length === current.matched.length) {
    this.ensureURL();
    return abort();
  }

  var ref = resolveQueue(this.current.matched, route.matched);
  var updated = ref.updated;
  var deactivated = ref.deactivated;
  var activated = ref.activated;

  var queue = [].concat(
  // in-component leave guards
  extractLeaveGuards(deactivated),
  // global before hooks
  this.router.beforeHooks,
  // in-component update hooks
  extractUpdateHooks(updated),
  // in-config enter guards
  activated.map(function (m) {
    return m.beforeEnter;
  }),
  // async components
  resolveAsyncComponents(activated));

  this.pending = route;
  var iterator = function iterator(hook, next) {
    if (this$1.pending !== route) {
      return abort();
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (typeof to === 'string' || (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' && (typeof to.path === 'string' || typeof to.name === 'string')) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if ((typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function isValid() {
      return this$1.current === route;
    };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort();
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) {
            cb();
          });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute(route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase(base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = baseEl && baseEl.getAttribute('href') || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '');
}

function resolveQueue(current, next) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break;
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  };
}

function extractGuards(records, name, bind, reverse) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard) ? guard.map(function (guard) {
        return bind(guard, instance, match, key);
      }) : bind(guard, instance, match, key);
    }
  });
  return flatten(reverse ? guards.reverse() : guards);
}

function extractGuard(def, key) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key];
}

function extractLeaveGuards(deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true);
}

function extractUpdateHooks(updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard);
}

function bindGuard(guard, instance) {
  if (instance) {
    return function boundRouteGuard() {
      return guard.apply(instance, arguments);
    };
  }
}

function extractEnterGuards(activated, cbs, isValid) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid);
  });
}

function bindEnterGuard(guard, match, key, cbs, isValid) {
  return function routeEnterGuard(to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    });
  };
}

function poll(cb, // somehow flow cannot infer this is a function
instances, key, isValid) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */

var HTML5History = function (History$$1) {
  function HTML5History(router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return;
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if (History$$1) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create(History$$1 && History$$1.prototype);
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go(n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push(location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace(location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL(push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation() {
    return getLocation(this.base);
  };

  return HTML5History;
}(History);

function getLocation(base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash;
}

/*  */

var HashHistory = function (History$$1) {
  function HashHistory(router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return;
    }
    ensureSlash();
  }

  if (History$$1) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create(History$$1 && History$$1.prototype);
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners() {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return;
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push(location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace(location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go(n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL(push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation() {
    return getHash();
  };

  return HashHistory;
}(History);

function checkFallback(base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true;
  }
}

function ensureSlash() {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true;
  }
  replaceHash('/' + path);
  return false;
}

function getHash() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1);
}

function getUrl(path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return base + "#" + path;
}

function pushHash(path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash(path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = function (History$$1) {
  function AbstractHistory(router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if (History$$1) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create(History$$1 && History$$1.prototype);
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push(location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace(location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go(n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return;
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation() {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/';
  };

  AbstractHistory.prototype.ensureURL = function ensureURL() {
    // noop
  };

  return AbstractHistory;
}(History);

/*  */

var VueRouter = function VueRouter(options) {
  if (options === void 0) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break;
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break;
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break;
    default:
      if (false) {
        assert(false, "invalid mode: " + mode);
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match(raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom);
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current;
};

VueRouter.prototype.init = function init(app /* Vue component instance */) {
  var this$1 = this;

  "production" !== 'production' && assert(install.installed, "not installed. Make sure to call `Vue.use(VueRouter)` " + "before creating root instance.");

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return;
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function setupHashListener() {
      history.setupListeners();
    };
    history.transitionTo(history.getCurrentLocation(), setupHashListener, setupHashListener);
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach(fn) {
  return registerHook(this.beforeHooks, fn);
};

VueRouter.prototype.beforeResolve = function beforeResolve(fn) {
  return registerHook(this.resolveHooks, fn);
};

VueRouter.prototype.afterEach = function afterEach(fn) {
  return registerHook(this.afterHooks, fn);
};

VueRouter.prototype.onReady = function onReady(cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError(errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push(location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace(location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go(n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back() {
  this.go(-1);
};

VueRouter.prototype.forward = function forward() {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents(to) {
  var route = to ? to.matched ? to : this.resolve(to).route : this.currentRoute;
  if (!route) {
    return [];
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key];
    });
  }));
};

VueRouter.prototype.resolve = function resolve(to, current, append) {
  var location = normalizeLocation(to, current || this.history.current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  };
};

VueRouter.prototype.addRoutes = function addRoutes(routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties(VueRouter.prototype, prototypeAccessors);

function registerHook(list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) {
      list.splice(i, 1);
    }
  };
}

function createHref(base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path;
}

VueRouter.install = install;
VueRouter.version = '3.0.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Changes_Vue_vue_type_template_id_1bf80b52__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Changes_Vue_vue_type_script_lang_js__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Changes_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Changes_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Changes_Vue_vue_type_template_id_1bf80b52__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Changes_Vue_vue_type_template_id_1bf80b52__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Changes_Vue_vue_type_template_id_1bf80b52__ = __webpack_require__(143);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Changes_Vue_vue_type_template_id_1bf80b52__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Changes_Vue_vue_type_template_id_1bf80b52__["b"]; });


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"columns",attrs:{"id":"main"}},[_c('side-menu',{staticClass:"column is-2",attrs:{"header":_vm.productsHeader,"items":_vm.products,"selectedItemId":_vm.productId},on:{"elementClick":_vm.toggleChanges}}),_vm._v(" "),_c('main',{staticClass:"container column is-8 main"},[_c('changes-content-filter',{attrs:{"createNewItem":_vm.createChange,"filterGroups":_vm.filterGroups,"infoMsg":_vm.filterMsg,"saveClick":_vm.saveClick},on:{"searchClick":_vm.searchHandler,"filtrate":_vm.filtrateChanges,"expand":_vm.expandAllCards}}),_vm._v(" "),(_vm.searchingText.length > 0)?_c('nav',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"subtitle is-4"},[_c('span',[_vm._v("Search results for: "+_vm._s(_vm.searchingText))])])]),_vm._v(" "),_c('b-tooltip',{staticClass:"level-item",attrs:{"label":"Clear search results"}},[_c('button',{staticClass:"delete",on:{"click":_vm.clearSearch}},[_vm._v("Clear")])])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.changes),function(item,index){return _c('div',{key:index},[_c('change-card',{attrs:{"change":item,"action1":'edit',"action2":'delete',"action3":'search',"isExpandedCard":_vm.mustExpandCards},on:{"edit":_vm.editChange,"delete":_vm.deleteChangeModal,"search":_vm.searchHandler}}),_vm._v(" "),_c('br')],1)}),_vm._v(" "),_c('pagination',{staticClass:"is-centered",attrs:{"urlBuilder":_vm.urlBuilder,"currentPage":_vm.page.pageNumber,"lastPage":_vm.page.totalPages}}),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}})],2),_vm._v(" "),(_vm.isEditorVisible)?_c('change-editor',{attrs:{"changeId":this.changeId,"productId":_vm.productId,"header":_vm.changeEditorHeader},on:{"closeChangeEditor":_vm.closeChangeEditor}}):_vm._e(),_vm._v(" "),(_vm.isDeleteModalVisible)?_c('delete-confirmer',{attrs:{"text":_vm.deleteMsg,"header":_vm.deleteHeader,"id":this.productId},on:{"close":_vm.closeChangeDeleteWindow,"delete":_vm.deleteChange}}):_vm._e(),_vm._v(" "),(_vm.isSaveDialogVisible)?_c('changes-saver',{attrs:{"filterType":_vm.filterType,"productId":_vm.productId},on:{"closeSaveChangesWindow":_vm.closeSaveChangesWindow,"saveChanges":_vm.saveChanges}}):_vm._e()],1)])}
var staticRenderFns = []



/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SideMenu_Vue_vue_type_template_id_129dd008__ = __webpack_require__(145);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SideMenu_Vue_vue_type_template_id_129dd008__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SideMenu_Vue_vue_type_template_id_129dd008__["b"]; });


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"panel sidepanel"},[_c('p',{staticClass:"panel-heading"},[_vm._v("\n    "+_vm._s(_vm.header)+"\n  ")]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"div-overflow"},[_c('a',{staticClass:"panel-block",class:{'is-active': _vm.selectedItemId == item.id},attrs:{"title":item.name},on:{"click":function($event){_vm.elementClick(item.id)}}},[_vm._v("    \n      "+_vm._s(item.name)+"\n    ")])])})],2)}
var staticRenderFns = []



/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SideMenu_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SideMenu_Vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SideMenu_Vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SideMenu_Vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-block.is-active{font-weight:500;border-left-width:5px}.sidepanel{background-color:#fafafa;-webkit-box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1)}.div-overflow a{display:inline-block;width:100%;white-space:nowrap;overflow:hidden!important;text-overflow:ellipsis}", ""]);

// exports


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AppBreadcrumb_Vue_vue_type_template_id_45010efe__ = __webpack_require__(149);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AppBreadcrumb_Vue_vue_type_template_id_45010efe__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AppBreadcrumb_Vue_vue_type_template_id_45010efe__["b"]; });


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"breadcrumb is-small",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',_vm._l((_vm.breadcrumbItems),function(crumb,index){return _c('li',{key:index,class:{ 'is-active': crumb.isActive }},[_c('a',{attrs:{"href":"#","aria-current":"page"}},[_vm._v(" "+_vm._s(crumb.name)+" ")])])}))])}
var staticRenderFns = []



/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChangesContentFilter_Vue_vue_type_template_id_fe310e8a__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangesContentFilter_Vue_vue_type_script_lang_js__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ChangesContentFilter_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ChangesContentFilter_Vue_vue_type_template_id_fe310e8a__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ChangesContentFilter_Vue_vue_type_template_id_fe310e8a__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesContentFilter_Vue_vue_type_template_id_fe310e8a__ = __webpack_require__(152);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesContentFilter_Vue_vue_type_template_id_fe310e8a__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesContentFilter_Vue_vue_type_template_id_fe310e8a__["b"]; });


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-filter',{attrs:{"createNewItem":_vm.createNewItem,"filterGroups":_vm.filterGroups,"infoMsg":_vm.infoMsg},on:{"searchClick":_vm.searchClick,"filtrate":_vm.filtrate}},[_c('template',{slot:"customBtns"},[_c('button',{staticClass:"button",on:{"click":_vm.saveClick}},[_vm._v("Save")]),_vm._v(" "),_c('b-field',{staticStyle:{"display":"inline-flex","margin-left":"24px"}},[_c('b-tooltip',{attrs:{"label":"Expand all cards"}},[_c('b-radio-button',{attrs:{"native-value":"expanded","type":"is-success"},model:{value:(_vm.expanded),callback:function ($$v) {_vm.expanded=$$v},expression:"expanded"}},[_c('b-icon',{attrs:{"icon":"mdi mdi-menu-down mdi-24px"}}),_vm._v(" "),_c('span',{staticClass:"is-hidden-widescreen-only is-hidden-desktop-only is-hidden-tablet-only is-hidden-mobile"},[_vm._v("Expand all cards")])],1)],1),_vm._v(" "),_c('b-tooltip',{attrs:{"label":"Collapse all cards"}},[_c('b-radio-button',{attrs:{"native-value":"collapsed"},model:{value:(_vm.expanded),callback:function ($$v) {_vm.expanded=$$v},expression:"expanded"}},[_c('b-icon',{attrs:{"icon":"mdi mdi-menu-up mdi-24px"}}),_vm._v(" "),_c('span',{staticClass:"is-hidden-widescreen-only is-hidden-desktop-only is-hidden-tablet-only is-hidden-mobile"},[_vm._v("Collapse all cards")])],1)],1)],1)],1)],2)}
var staticRenderFns = []



/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentFilter_Vue_vue_type_template_id_2c1fc8ba__ = __webpack_require__(154);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentFilter_Vue_vue_type_template_id_2c1fc8ba__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentFilter_Vue_vue_type_template_id_2c1fc8ba__["b"]; });


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"subtitle is-5"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoMsg)}})])]),_vm._v(" "),_c('div',{staticClass:"level-item"},[_c('div',{staticClass:"field has-addons"},[_c('p',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchingText),expression:"searchingText"}],staticClass:"input",attrs:{"type":"text","placeholder":"Find a post"},domProps:{"value":(_vm.searchingText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchClick($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchingText=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button",on:{"click":_vm.searchClick}},[_vm._v("\n            Search\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"control"},[_vm._t("customBtns")],2)])]),_vm._v(" "),_c('div',{staticClass:"level-right"},[_vm._l((_vm.filterGroups),function(group,index){return _c('div',{key:index,staticClass:"level-item"},[(_vm.curFilter === group)?_c('div',[_c('p',{staticClass:"level-item"},[_c('strong',{staticClass:"bold",on:{"click":function($event){_vm.filtrate(group)}}},[_vm._v(_vm._s(group))])])]):_c('div',[_c('p',{staticClass:"level-item"},[_c('a',{staticClass:"bold",on:{"click":function($event){_vm.filtrate(group)}}},[_vm._v(_vm._s(group))])])])])}),_vm._v(" "),(_vm.createNewItem != undefined && this.userRole != 'readonly')?_c('p',{staticClass:"level-item"},[_c('a',{staticClass:"button is-success",on:{"click":_vm.createNewItem}},[_vm._v("New")])]):_vm._e()],2)])}
var staticRenderFns = []



/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeCard_Vue_vue_type_template_id_668ec952__ = __webpack_require__(156);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeCard_Vue_vue_type_template_id_668ec952__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeCard_Vue_vue_type_template_id_668ec952__["b"]; });


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.viewType === 'brilliant')?_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header compact"},[_c('p',{staticClass:"card-header-title compact tags"},[_c('a',{staticClass:"tag is-light",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.type)}}},[_vm._v(_vm._s(_vm.type))]),_vm._v(" "),_c('a',{staticClass:"tag is-light",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.group)}}},[_vm._v(_vm._s(_vm.group))]),_vm._v(" "),_c('a',{staticClass:"tag is-light",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.versionText)}}},[_vm._v(_vm._s(_vm.versionText))]),_vm._v(" "),_c('a',{staticClass:"tag is-light",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.userFullName)}}},[_vm._v(_vm._s(_vm.userFullName))])]),_vm._v(" "),_c('div',{staticClass:"card-header-title compact mouse-detrav-hover",staticStyle:{"justify-content":"space-between"}},[_c('div'),_vm._v(" "),_c('div',{staticClass:"tags compact"},[((_vm.action1 != null && _vm.action1.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"tag is-dark",on:{"click":_vm.runAction1}},[_vm._v(_vm._s(_vm.action1.charAt(0).toUpperCase() + _vm.action1.substr(1)))]):_vm._e(),_vm._v(" "),((_vm.action2 != null && _vm.action2.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"tag is-dark",on:{"click":_vm.runAction2}},[_vm._v(_vm._s(_vm.action2.charAt(0).toUpperCase() + _vm.action2.substr(1)))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-content compact"},[_c('div',{staticClass:"content",staticStyle:{"margin":"0","background-color":"white"}},[(_vm.translation)?_c('p',[_vm._v(_vm._s(_vm.translation.text))]):_vm._e()])])]):(_vm.viewType === 'deluxe')?_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header compact"},[_c('p',{staticClass:"card-header-title compact"},[_c('a',{staticClass:"has-text-black",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.versionText)}}},[_vm._v("Version: "+_vm._s(_vm.versionText))])]),_vm._v(" "),_c('p',{staticClass:"card-header-title compact"},[_c('a',{staticClass:"has-text-black",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.type)}}},[_vm._v("Type: "+_vm._s(_vm.type))])]),_vm._v(" "),_c('p',{staticClass:"card-header-title compact"},[_c('a',{staticClass:"has-text-black",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.group)}}},[_vm._v("Group: "+_vm._s(_vm.group))])]),_vm._v(" "),_c('p',{staticClass:"card-header-title compact"},[_c('a',{staticClass:"has-text-black",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.userFullName)}}},[_vm._v("Author: "+_vm._s(_vm.userFullName))])])]),_vm._v(" "),_c('div',{staticClass:"card-content compact"},[_c('div',{staticClass:"content",staticStyle:{"margin":"0","background-color":"white"}},[(_vm.translation)?_c('p',[_vm._v(_vm._s(_vm.translation.text))]):_vm._e()])]),_vm._v(" "),_c('footer',{staticClass:"card-footer"},[((_vm.action1 != null && _vm.action1.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item compact has-black",on:{"click":_vm.runAction1}},[_vm._v(_vm._s(_vm.action1.charAt(0).toUpperCase() + _vm.action1.substr(1)))]):_vm._e(),_vm._v(" "),((_vm.action2 != null && _vm.action2.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item compact has-black",on:{"click":_vm.runAction2}},[_vm._v(_vm._s(_vm.action2.charAt(0).toUpperCase() + _vm.action2.substr(1)))]):_vm._e()])]):_c('b-collapse',{staticClass:"card",attrs:{"open":_vm.isExpandedCard},scopedSlots:_vm._u([{key:"trigger",fn:function(props){return _c('div',{staticClass:"card-header",attrs:{"open":false}},[(_vm.isExpandedCard)?_c('div',{staticStyle:{"display":"flex","flex-direction":"row","width":"-webkit-fill-available"},on:{"click":function($event){_vm.isExpandedCard = !_vm.isExpandedCard}}},[_c('p',{staticClass:"card-header-title"},[_c('a',{staticClass:"has-text-black",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.versionText)}}},[_vm._v("Date: "+_vm._s(_vm.date))])]),_vm._v(" "),_c('p',{staticClass:"card-header-title"},[_c('a',{staticClass:"has-text-black",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.versionText)}}},[_vm._v("Version: "+_vm._s(_vm.versionText))])]),_vm._v(" "),_c('p',{staticClass:"card-header-title"},[_c('a',{staticClass:"has-text-black",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.type)}}},[_vm._v("Type: "+_vm._s(_vm.type))])]),_vm._v(" "),_c('p',{staticClass:"card-header-title"},[_c('a',{staticClass:"has-text-black",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.group)}}},[_vm._v("Group: "+_vm._s(_vm.group))])]),_vm._v(" "),_c('p',{staticClass:"card-header-title"},[_c('a',{staticClass:"has-text-black",attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.userFullName)}}},[_vm._v("Author: "+_vm._s(_vm.userFullName))])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"card-header-icon"},[_c('b-icon',{attrs:{"icon":props.open ? 'menu-up' : 'menu-down'}})],1)])]):_c('div',{staticStyle:{"display":"flex","flex-direction":"row","width":"-webkit-fill-available"},on:{"click":function($event){_vm.isExpandedCard = !_vm.isExpandedCard}}},[_c('p',{staticClass:"card-header-title compact tags"},[_c('a',{staticClass:"tag is-light",staticStyle:{"min-width":"80px"},attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.date)}}},[_vm._v(_vm._s(_vm.date))]),_vm._v(" "),_c('a',{staticClass:"tag is-light",staticStyle:{"min-width":"105px"},attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.versionText)}}},[_vm._v(_vm._s(_vm.versionText))]),_vm._v(" "),_c('a',{staticClass:"tag is-light",staticStyle:{"min-width":"105px"},attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.type)}}},[_vm._v(_vm._s(_vm.type))]),_vm._v(" "),_c('a',{staticClass:"tag is-light",staticStyle:{"min-width":"105px"},attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.group)}}},[_vm._v(_vm._s(_vm.group))]),_vm._v(" "),_c('a',{staticClass:"tag is-light",staticStyle:{"min-width":"105px"},attrs:{"target":"_blank"},on:{"click":function($event){_vm.runAction3(_vm.userFullName)}}},[_vm._v(_vm._s(_vm.userFullName))])]),_vm._v(" "),(_vm.translation)?_c('p',{staticClass:"clipped-text"},[_vm._v(_vm._s(_vm.translation.text))]):_vm._e(),_vm._v(" "),_c('p',[_c('a',{staticClass:"card-header-icon"},[_c('b-icon',{attrs:{"icon":props.open ? 'menu-up' : 'menu-down'}})],1)])])])}}])},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},_vm._l((_vm.translations),function(translation,index){return (_vm.translations)?_c('p',{key:index},[_vm._v("\n        "+_vm._s(translation.text)+"\n        "),(!!translation && !!translation.annotation && translation.annotation.length > 0)?_c('span',[_vm._v("( "+_vm._s(translation.annotation)+" )")]):_vm._e()]):_vm._e()})),_vm._v(" "),_c('nav',{staticClass:"level"},[_c('p',{staticClass:"level-item has-text-centered"},[_c('a',{staticClass:"link is-info",attrs:{"href":_vm.taskLink}},[_vm._v("Task Link")])]),_vm._v(" "),_c('p',{staticClass:"level-item has-text-centered"},[_c('a',{staticClass:"link is-info",attrs:{"href":_vm.mergeRequestLink}},[_vm._v("Merge Request Link")])]),_vm._v(" "),_c('p',{staticClass:"level-item has-text-centered"},[_c('a',{staticClass:"link is-info",attrs:{"href":_vm.documentationLink}},[_vm._v("Documentation Link")])]),_vm._v(" "),_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isPrivate),expression:"isPrivate"}],attrs:{"type":"checkbox","disabled":""},domProps:{"checked":Array.isArray(_vm.isPrivate)?_vm._i(_vm.isPrivate,null)>-1:(_vm.isPrivate)},on:{"change":function($event){var $$a=_vm.isPrivate,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isPrivate=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isPrivate=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isPrivate=$$c}}}}),_vm._v(" Private change\n      ")])])]),_vm._v(" "),_c('footer',{staticClass:"card-footer"},[((_vm.action1 != null && _vm.action1.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item",on:{"click":_vm.runAction1}},[_vm._v(_vm._s(_vm.action1.charAt(0).toUpperCase() + _vm.action1.substr(1)))]):_vm._e(),_vm._v(" "),((_vm.action2 != null && _vm.action2.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item",on:{"click":_vm.runAction2}},[_vm._v(_vm._s(_vm.action2.charAt(0).toUpperCase() + _vm.action2.substr(1)))]):_vm._e()])])}
var staticRenderFns = []



/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeCard_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeCard_Vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeCard_Vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeCard_Vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".compact.card-header{background-color:#f5f5f5}.compact.card-header-title{padding-top:1px;padding-bottom:1px}.compact.card-content{padding:.75rem 1.5rem}.compact.card-footer-item{padding-top:0;padding-bottom:0}.is-info.card-footer-item{background-color:#209cee;color:#fff}.is-danger.card-footer-item{background-color:#ff3860;color:#fff}.has-black.card-footer-item{color:#000}.compact.tags,.compact.tags:not(:last-child){margin-bottom:0}.compact.tags{flex-wrap:nowrap;flex-grow:0}.compact .tag{margin-bottom:0}.card .mouse-detrav-hover{display:none}.card:hover .mouse-detrav-hover{display:flex}.clipped-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;margin:auto;flex-grow:1}", ""]);

// exports


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChangeEditor_Vue_vue_type_template_id_9a480ad4_scoped_true__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangeEditor_Vue_vue_type_script_lang_js__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChangeEditor_Vue_vue_type_style_index_0_id_9a480ad4_scoped_true_lang_css__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ChangeEditor_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ChangeEditor_Vue_vue_type_template_id_9a480ad4_scoped_true__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ChangeEditor_Vue_vue_type_template_id_9a480ad4_scoped_true__["b" /* staticRenderFns */],
  false,
  null,
  "9a480ad4",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEditor_Vue_vue_type_template_id_9a480ad4_scoped_true__ = __webpack_require__(161);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEditor_Vue_vue_type_template_id_9a480ad4_scoped_true__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEditor_Vue_vue_type_template_id_9a480ad4_scoped_true__["b"]; });


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-window',{attrs:{"loading":_vm.loading},on:{"close":function($event){_vm.$emit('closeChangeEditor')}}},[_c('template',{slot:"header"},[_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('closeChangeEditor')}}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('div',{staticClass:"columns",attrs:{"id":"edit-header"}},[_c('div',{staticClass:"column"},[_c('label',{staticClass:"label"},[_vm._v("Change type")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',{staticClass:"label"},[_vm._v("Change group")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',{staticClass:"label"},[_vm._v("Private change")])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('b-tooltip',{attrs:{"position":"is-right","multilined":"","label":"Type of the currnet change: added, deprecated, etc."}},[_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedChangeType),expression:"selectedChangeType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedChangeType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.changeTypes),function(type,index){return _c('option',{key:index,domProps:{"value":type}},[_vm._v(_vm._s(type))])}))])])],1)])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('b-tooltip',{attrs:{"position":"is-bottom","label":"Group of the currnet change: Engine, Exports, etc."}},[_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedChangeGroupId),expression:"selectedChangeGroupId"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedChangeGroupId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.changeGroups),function(group,index){return _c('option',{key:index,domProps:{"value":group.id}},[_vm._v(_vm._s(group.name))])}))])])],1)])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"position":"is-bottom","multilined":"","label":"Specified, either should the change be shown to the users or not"}},[_c('b-switch',{model:{value:(_vm.newChangeIsPrivate),callback:function ($$v) {_vm.newChangeIsPrivate=$$v},expression:"newChangeIsPrivate"}})],1)],1)])]),_vm._v(" "),_c('label',{staticClass:"label"},[_vm._v("English")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('b-tooltip',{attrs:{"position":"is-right","label":"Text of the change: something added, fixed, etc."}},[_c('label',{staticClass:"label"},[_vm._v("Text")])]),_vm._v(" "),_c('b-field',{attrs:{"type":{'is-danger':  _vm.newChangeText.length < 5 && _vm.saveClicked},"message":{'Here should be some text...' : _vm.newChangeText.length < 5 && _vm.saveClicked }}},[_c('b-input',{attrs:{"placeholder":"added new awsome feature (not a bug!)","maxlength":"1000","spellcheck":"true"},model:{value:(_vm.newChangeText),callback:function ($$v) {_vm.newChangeText=$$v},expression:"newChangeText"}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"open":_vm.enIsOpen},on:{"update:open":function($event){_vm.enIsOpen=$event}}},[_c('button',{staticClass:"button is-light is-small collapse-button",attrs:{"slot":"trigger"},slot:"trigger"},[_vm._v(_vm._s(_vm.enIsOpen ? _vm.collapseText : _vm.expandText))]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"position":"is-right","label":"Detrav know what it is, ask for him"}},[_c('label',{staticClass:"label"},[_vm._v("Annotation")])]),_vm._v(" "),_c('b-input',{attrs:{"placeholder":"¯\\_(ツ)_/¯","maxlength":"1000","spellcheck":"true"},model:{value:(_vm.newChangeAnnotation),callback:function ($$v) {_vm.newChangeAnnotation=$$v},expression:"newChangeAnnotation"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"position":"is-right","label":"Web page of the documentation, related with this change"}},[_c('label',{staticClass:"label"},[_vm._v("Documentation link")])]),_vm._v(" "),_c('b-input',{attrs:{"placeholder":"https://somefarinthegalaxy.com/documentation"},model:{value:(_vm.newChangeDocLink),callback:function ($$v) {_vm.newChangeDocLink=$$v},expression:"newChangeDocLink"}})],1)])],1),_vm._v(" "),_c('label',{staticClass:"label"},[_vm._v("Russian")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('b-tooltip',{attrs:{"position":"is-right","label":"Text of the change on russian: something added, fixed, etc."}},[_c('label',{staticClass:"label"},[_vm._v("Text")])]),_vm._v(" "),_c('b-field',{attrs:{"type":{'is-danger':  _vm.newChangeTextRu.length < 5 && _vm.saveClicked},"message":{'Here should be some text...' : _vm.newChangeTextRu.length < 5 && _vm.saveClicked }}},[_c('b-input',{class:{ 'is-danger':  _vm.newChangeTextRu.length < 5 && _vm.saveClicked},attrs:{"placeholder":"added new awsome feature (not a bug!)","maxlength":"1000","spellcheck":"true"},model:{value:(_vm.newChangeTextRu),callback:function ($$v) {_vm.newChangeTextRu=$$v},expression:"newChangeTextRu"}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"open":_vm.ruIsOpen},on:{"update:open":function($event){_vm.ruIsOpen=$event}}},[_c('button',{staticClass:"button is-light is-small collapse-button",attrs:{"slot":"trigger"},slot:"trigger"},[_vm._v(_vm._s(_vm.ruIsOpen ? _vm.collapseText : _vm.expandText))]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"position":"is-right","label":"Detrav know what it is, ask for him"}},[_c('label',{staticClass:"label"},[_vm._v("Annotation")])]),_vm._v(" "),_c('b-input',{attrs:{"placeholder":"¯\\_(ツ)_/¯","maxlength":"1000","spellcheck":"true"},model:{value:(_vm.newChangeAnnotationRu),callback:function ($$v) {_vm.newChangeAnnotationRu=$$v},expression:"newChangeAnnotationRu"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"position":"is-right","label":"Web page of the documentation, related with this change"}},[_c('label',{staticClass:"label"},[_vm._v("Documentation link")])]),_vm._v(" "),_c('b-input',{attrs:{"placeholder":"https://somefarinthegalaxy.com/documentation"},model:{value:(_vm.newChangeDocLinkRu),callback:function ($$v) {_vm.newChangeDocLinkRu=$$v},expression:"newChangeDocLinkRu"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"label":"Web page of the task, related with this change","position":"is-right"}},[_c('label',{staticClass:"label"},[_vm._v("Task link")])]),_vm._v(" "),_c('b-input',{attrs:{"placeholder":"https://somefarinthegalaxy.com/product/task123"},model:{value:(_vm.newChangeTaskLink),callback:function ($$v) {_vm.newChangeTaskLink=$$v},expression:"newChangeTaskLink"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"label":"Web page of the merge request, related with this change","position":"is-right"}},[_c('label',{staticClass:"label"},[_vm._v("Merge Request link")])]),_vm._v(" "),_c('b-input',{attrs:{"placeholder":"https://somefarinthegalaxy.com/repo/merg24"},model:{value:(_vm.newChangeMergeLink),callback:function ($$v) {_vm.newChangeMergeLink=$$v},expression:"newChangeMergeLink"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"label":"Tags of the change","position":"is-right"}},[_c('label',{staticClass:"label"},[_vm._v("Tags")])]),_vm._v(" "),_c('b-taginput',{attrs:{"placeholder":"Add a tag: OpenSource, Desktop, etc.","ellipsis":"","icon":"label","data":_vm.filteredTags,"allow-new":true,"autocomplete":"","before-adding":_vm.beforeTagAdding},on:{"typing":_vm.getFilteredTags},model:{value:(_vm.newTags),callback:function ($$v) {_vm.newTags=$$v},expression:"newTags"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"label":"Product version, whitch includes the change","position":"is-right"}},[_c('label',{staticClass:"label"},[_vm._v("Version")])]),_vm._v(" "),_c('b-select',{model:{value:(_vm.selectedVersion),callback:function ($$v) {_vm.selectedVersion=$$v},expression:"selectedVersion"}},_vm._l((_vm.versions),function(version,index){return _c('option',{key:index,domProps:{"value":version.id}},[_vm._v(_vm._s(version.text))])}))],1)]),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{staticClass:"button is-success",on:{"click":function($event){_vm.submit()},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submit()}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.$emit('closeChangeEditor')}}},[_vm._v("Cancel")])])],2)}
var staticRenderFns = []



/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalWindow_Vue_vue_type_template_id_77790124__ = __webpack_require__(163);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalWindow_Vue_vue_type_template_id_77790124__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalWindow_Vue_vue_type_template_id_77790124__["b"]; });


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card",attrs:{"id":"modalWindow"}},[_c('header',{staticClass:"modal-card-head"},[_vm._t("header")],2),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_vm._t("body")],2),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_vm._t("footer")],2)]),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}})],1)}
var staticRenderFns = []



/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@keyframes spinAround{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.loading-overlay{bottom:0;left:0;position:absolute;right:0;top:0;-ms-flex-align:center;align-items:center;display:none;-ms-flex-pack:center;justify-content:center;overflow:hidden;z-index:999}.loading-overlay.is-active{display:-ms-flexbox;display:flex}.loading-overlay.is-full-page{position:fixed}.loading-overlay.is-full-page .loading-icon:after{top:calc(50% - 2.5em);left:calc(50% - 2.5em);width:5em;height:5em}.loading-overlay .loading-background{bottom:0;left:0;position:absolute;right:0;top:0;background:#fff;opacity:.5}.loading-overlay .loading-icon{position:relative}.loading-overlay .loading-icon:after{animation:spinAround .5s infinite linear;border:2px solid #777;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:5em;position:relative;width:5em;position:absolute;top:calc(50% - 1.5em);left:calc(50% - 1.5em);width:3em;height:3em;border-width:.25em}", ""]);

// exports


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEditor_Vue_vue_type_style_index_0_id_9a480ad4_scoped_true_lang_css__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEditor_Vue_vue_type_style_index_0_id_9a480ad4_scoped_true_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEditor_Vue_vue_type_style_index_0_id_9a480ad4_scoped_true_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEditor_Vue_vue_type_style_index_0_id_9a480ad4_scoped_true_lang_css___default.a); 

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#edit-header[data-v-9a480ad4]{margin-bottom:0;padding:0}#edit-header .column[data-v-9a480ad4]{margin-bottom:0;padding-bottom:.2rem}.collapse-button[data-v-9a480ad4]{width:-webkit-fill-available}", ""]);

// exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DeleteConfirmer_Vue_vue_type_template_id_5ef23928__ = __webpack_require__(168);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DeleteConfirmer_Vue_vue_type_template_id_5ef23928__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DeleteConfirmer_Vue_vue_type_template_id_5ef23928__["b"]; });


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-window',{on:{"close":_vm.close}},[_c('template',{slot:"header"},[_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_c('template',{slot:"body"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{staticClass:"button is-danger",on:{"click":function($event){_vm.$emit('delete')}}},[_vm._v("Delete")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("Cancel")])])],2)}
var staticRenderFns = []



/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_loaders_templateLoader_js_vue_loader_options_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_template_id_1149e074__ = __webpack_require__(170);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_loaders_templateLoader_js_vue_loader_options_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_template_id_1149e074__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__vue_loader_lib_loaders_templateLoader_js_vue_loader_options_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_template_id_1149e074__["b"]; });


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:_vm.getNavClassName()},[_c('router-link',{staticClass:"pagination-previous",attrs:{"to":_vm.urlBuilder(_vm.prevPage),"disabled":_vm.outOfRegion(_vm.formatCurrentPage - 1)}},[_vm._v(_vm._s(_vm.prev))]),_vm._v(" "),_c('router-link',{staticClass:"pagination-next",attrs:{"to":_vm.urlBuilder(_vm.nextPage),"disabled":_vm.outOfRegion(_vm.formatCurrentPage + 1)}},[_vm._v(_vm._s(_vm.next))]),_vm._v(" "),_c('ul',{staticClass:"pagination-list"},_vm._l((_vm.pagingList),function(item){return _c('li',[(item !== '...')?_c('router-link',{class:_vm.getPagingClassName(item),attrs:{"to":_vm.urlBuilder(item)}},[_vm._v(_vm._s(item))]):_c('span',{staticClass:"pagination-ellipsis"},[_vm._v("...")])],1)}))],1)}
var staticRenderFns = []



/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = function (current, length, displayLength) {
  if (length <= 1) return [];
  displayLength = displayLength - 2;
  var indexes = [1];
  var start = Math.round(current - displayLength / 2);
  var end = Math.round(current + displayLength / 2);
  if (start <= 1) {
    start = 2;
    end = start + displayLength - 1;
    if (end >= length - 1) end = length - 1;
  }
  if (end >= length - 1) {
    end = length - 1;
    start = end - displayLength + 1;
    if (start <= 1) start = 2;
  }
  if (start !== 2) indexes.push('...');
  for (var i = start; i <= end; i++) {
    indexes.push(i);
  }
  if (end !== length - 1) indexes.push('...');
  indexes.push(length);
  return indexes;
};

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_style_loader_index_js_css_loader_index_js_vue_loader_lib_loaders_stylePostLoader_js_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_style_loader_index_js_css_loader_index_js_vue_loader_lib_loaders_stylePostLoader_js_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vue_style_loader_index_js_css_loader_index_js_vue_loader_lib_loaders_stylePostLoader_js_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__vue_style_loader_index_js_css_loader_index_js_vue_loader_lib_loaders_stylePostLoader_js_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".pagination-list,.pagination-list li{list-style:none}", ""]);

// exports


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChangesSaver_Vue_vue_type_template_id_457b0a94__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangesSaver_Vue_vue_type_script_lang_js__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ChangesSaver_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ChangesSaver_Vue_vue_type_template_id_457b0a94__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ChangesSaver_Vue_vue_type_template_id_457b0a94__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesSaver_Vue_vue_type_template_id_457b0a94__ = __webpack_require__(176);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesSaver_Vue_vue_type_template_id_457b0a94__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesSaver_Vue_vue_type_template_id_457b0a94__["b"]; });


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-window',{on:{"close":function($event){_vm.$emit('closeSaveChangesWindow')}}},[_c('template',{slot:"header"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Save changes")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('closeSaveChangesWindow')}}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Select file type")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fileType),expression:"fileType"}],attrs:{"type":"radio","value":"txt"},domProps:{"checked":_vm._q(_vm.fileType,"txt")},on:{"change":function($event){_vm.fileType="txt"}}}),_vm._v(" Text\n        ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fileType),expression:"fileType"}],attrs:{"type":"radio","value":"json"},domProps:{"checked":_vm._q(_vm.fileType,"json")},on:{"change":function($event){_vm.fileType="json"}}}),_vm._v(" Json\n        ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fileType),expression:"fileType"}],attrs:{"type":"radio","value":"markdown"},domProps:{"checked":_vm._q(_vm.fileType,"markdown")},on:{"change":function($event){_vm.fileType="markdown"}}}),_vm._v(" Markdown\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Select save type")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saveType),expression:"saveType"}],attrs:{"type":"radio","value":"all"},domProps:{"checked":_vm._q(_vm.saveType,"all")},on:{"change":function($event){_vm.saveType="all"}}}),_vm._v(" Save all changes\n        ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saveType),expression:"saveType"}],attrs:{"type":"radio","disabled":"","value":"founded"},domProps:{"checked":_vm._q(_vm.saveType,"founded")},on:{"change":function($event){_vm.saveType="founded"}}}),_vm._v(" Save founded changes\n        ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saveType),expression:"saveType"}],attrs:{"type":"radio","value":"lastVersion"},domProps:{"checked":_vm._q(_vm.saveType,"lastVersion")},on:{"change":function($event){_vm.saveType="lastVersion"}}}),_vm._v(" Save changes from the last version (that has changes; for release)\n        ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saveType),expression:"saveType"}],attrs:{"type":"radio","value":"currentVersion"},domProps:{"checked":_vm._q(_vm.saveType,"currentVersion")},on:{"change":function($event){_vm.saveType="currentVersion"}}}),_vm._v(" Save changes from the current version (for release)\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Select language")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.language),expression:"language"}],attrs:{"type":"radio","value":"english","disabled":_vm.fileType == 'json'},domProps:{"checked":_vm._q(_vm.language,"english")},on:{"change":function($event){_vm.language="english"}}}),_vm._v(" English\n        ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.language),expression:"language"}],attrs:{"type":"radio","value":"russian","disabled":_vm.fileType == 'json'},domProps:{"checked":_vm._q(_vm.language,"russian")},on:{"change":function($event){_vm.language="russian"}}}),_vm._v(" Russian\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Group by")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.grouping),expression:"grouping"}],attrs:{"type":"radio","value":"minor","disabled":_vm.isGroupingDisabled},domProps:{"checked":_vm._q(_vm.grouping,"minor")},on:{"change":function($event){_vm.grouping="minor"}}}),_vm._v(" Minor\n        ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.grouping),expression:"grouping"}],attrs:{"type":"radio","value":"build","disabled":_vm.isGroupingDisabled},domProps:{"checked":_vm._q(_vm.grouping,"build")},on:{"change":function($event){_vm.grouping="build"}}}),_vm._v(" Build\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Filter by tag")]),_vm._v(" "),_c('b-tooltip',{attrs:{"label":"show changes, which includes tags(start with #, please)","position":"is-right","multilined":""}},[_c('b-taginput',{class:{ 'is-danger': !_vm.isValidTags && _vm.saveClicked },attrs:{"placeholder":"awesomechanges","ellipsis":"","icon":"label"},model:{value:(_vm.tags),callback:function ($$v) {_vm.tags=$$v},expression:"tags"}}),_vm._v(" "),(!_vm.isValidTags)?_c('p',{staticClass:"help is-danger"},[_vm._v("Here should be some valid tags (#tag1 #tag2)")]):_vm._e()],1)],1),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}})],1),_vm._v(" "),_c('template',{slot:"footer"},[_c('a',{staticClass:"button is-success",attrs:{"id":"downloadBtn","download":_vm.filename},on:{"click":_vm.download}},[_vm._v("Download")]),_vm._v(" "),_c('button',{staticClass:"button is-success",on:{"click":_vm.preview}},[_vm._v("Preview")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.$emit('closeSaveChangesWindow')}}},[_vm._v("Cancel")])])],2)}
var staticRenderFns = []



/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = function (originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 178 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Changes_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Changes_Vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Changes_Vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Changes_Vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#app{display:flex;min-height:100vh;flex-direction:column;margin:0}*{box-sizing:border-box}body{min-height:100vh;flex-direction:column;margin:0}#main,body{display:flex}#main{flex:1}#main>aside{flex:0 0 10vw}.footer{height:10vh}nav.navbar{padding:0}", ""]);

// exports


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Auth_Vue_vue_type_template_id_1aa7507e__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Auth_Vue_vue_type_script_lang_js__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Auth_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Auth_Vue_vue_type_template_id_1aa7507e__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Auth_Vue_vue_type_template_id_1aa7507e__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Auth_Vue_vue_type_template_id_1aa7507e__ = __webpack_require__(183);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Auth_Vue_vue_type_template_id_1aa7507e__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Auth_Vue_vue_type_template_id_1aa7507e__["b"]; });


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.needSignUp)?_c('section',{staticClass:"hero is-primar is-fullheight"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('div',{staticClass:"column is-4 is-offset-4"},[_c('h3',{staticClass:"title has-text-grey"},[_vm._v("Sign in")]),_vm._v(" "),_c('p',{staticClass:"subtitle has-text-grey"},[_vm._v("Please sign in to proceed.")]),_vm._v(" "),_c('div',{staticClass:"box"},[_vm._m(0),_vm._v(" "),_c('form',[(_vm.errors.length)?_c('div',{staticClass:"has-text-left alert"},[_c('b',[_vm._v("Please fix this errors:")]),_vm._v(" "),_c('ul',_vm._l((_vm.errors),function(error,index){return _c('li',{key:index},[_vm._v(_vm._s(error.description))])}))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button is-block is-info is-large is-fullwidth",on:{"click":function($event){$event.preventDefault();return _vm.signin($event)}}},[_vm._v("Sign in")])])]),_vm._v(" "),_c('p',{staticClass:"has-text-grey"},[_vm._v("\n            This is private FastReports service and you should sign in to continue!\n          ")])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"avatar column is-8 is-offset-2"},[_c('img',{attrs:{"src":"src/assets/waiter.png"}})])}]



/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Products_Vue_vue_type_template_id_0b3899bb__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Products_Vue_vue_type_script_lang_js__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Products_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Products_Vue_vue_type_template_id_0b3899bb__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Products_Vue_vue_type_template_id_0b3899bb__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Products_Vue_vue_type_template_id_0b3899bb__ = __webpack_require__(186);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Products_Vue_vue_type_template_id_0b3899bb__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Products_Vue_vue_type_template_id_0b3899bb__["b"]; });


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column container is-8 main"},[_c('content-filter',{attrs:{"createNewItem":_vm.createProduct,"filterGroups":_vm.filterGroups,"infoMsg":_vm.filterMsg},on:{"searchClick":_vm.searchHandler}}),_vm._v(" "),(_vm.searchingText.length > 0)?_c('nav',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"subtitle is-4"},[_c('span',[_vm._v("Search results for: "+_vm._s(_vm.searchingText))])])]),_vm._v(" "),_c('b-tooltip',{staticClass:"level-item",attrs:{"label":"Clear search results"}},[_c('button',{staticClass:"delete",on:{"click":_vm.clearSearch}},[_vm._v("Clear")])])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.products),function(item,index){return _c('div',{key:index},[_c('product-card',{attrs:{"product":item,"action1":'edit',"action2":'delete'},on:{"edit":_vm.editProduct,"delete":_vm.deleteProductModal}}),_vm._v(" "),_c('br')],1)}),_vm._v(" "),_c('pagination',{staticClass:"is-centered",attrs:{"urlBuilder":_vm.urlBuilder,"currentPage":_vm.page.pageNumber,"lastPage":_vm.page.totalPages}}),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}})],2),_vm._v(" "),(_vm.isEditorVisible)?_c('product-editor',{attrs:{"productId":this.productId,"header":_vm.productEditorHeader},on:{"closeProductEditor":_vm.closeProductEditor}}):_vm._e(),_vm._v(" "),(_vm.isDeleteModalVisible)?_c('delete-confirmer',{attrs:{"text":_vm.deleteMsg,"header":_vm.deleteHeader,"id":this.productId},on:{"close":_vm.closeProductDeleteWindow,"delete":_vm.deleteProduct}}):_vm._e()],1)])}
var staticRenderFns = []



/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_Vue_vue_type_template_id_67c917ea__ = __webpack_require__(188);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_Vue_vue_type_template_id_67c917ea__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_Vue_vue_type_template_id_67c917ea__["b"]; });


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.viewType === 'deluxe' || _vm.viewType === 'brilliant')?_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header compact"},[_c('p',{staticClass:"card-header-title compact"},[_c('a',{staticClass:"link is-info has-text-black",attrs:{"href":_vm.productUrl,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_vm._v("\n              ( "),_c('a',{staticClass:"link is-info has-text-black"},[_vm._v(" "+_vm._s(_vm.tag)+" ")]),_vm._v(")\n            ")]),_vm._v(" "),_c('p',{staticClass:"card-header-title compact"},[_c('a',{staticClass:"link is-info has-text-black",attrs:{"target":"_blank","href":_vm.repositoryUrl}},[_vm._v("Repository")])]),_vm._v(" "),_c('p',{staticClass:"card-header-title compact"},[_c('a',{staticClass:"link is-info has-text-black",attrs:{"href":_vm.userLink,"target":"_blank"}},[_vm._v(" Last edited by: "+_vm._s(_vm.userFullName))])])]),_vm._v(" "),_c('div',{staticClass:"card-content compact"},[_c('div',{staticClass:"content",staticStyle:{"margin":"0","background-color":"white"}},[_c('p',[_vm._v(_vm._s(_vm.description)+" ")])])]),_vm._v(" "),_c('footer',{staticClass:"card-footer"},[((_vm.action1 != null && _vm.action1.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item compact has-black",on:{"click":_vm.runAction1}},[_vm._v(_vm._s(_vm.action1.charAt(0).toUpperCase() + _vm.action1.substr(1)))]):_vm._e(),_vm._v(" "),((_vm.action2 != null && _vm.action2.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item compact has-black",on:{"click":_vm.runAction2}},[_vm._v(_vm._s(_vm.action2.charAt(0).toUpperCase() + _vm.action2.substr(1)))]):_vm._e()])]):_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header"},[_c('div',{staticClass:"container is-paddingless"},[_c('nav',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"card-header-title"},[_c('a',{staticClass:"link is-info",attrs:{"href":_vm.productUrl,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.name)+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"level-right"},[_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"card-header-title"},[_c('a',{staticClass:"link is-info",attrs:{"href":_vm.userLink,"target":"_blank"}},[_vm._v(" Last edited by: "+_vm._s(_vm.userFullName))])]),_vm._v(" "),_c('p',{staticClass:"card-header-title"},[_c('a',{staticClass:"link is-info"},[_vm._v(" "+_vm._s(_vm.tag)+" ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(_vm.description)+" ")])]),_vm._v(" "),_c('nav',{staticClass:"level"},[_c('p',{staticClass:"level-item has-text-centered"},[_c('a',{staticClass:"link is-info",attrs:{"href":_vm.repositoryUrl}},[_vm._v(_vm._s(_vm.name)+" repository")])]),_vm._v(" "),_c('p',{staticClass:"level-item has-text-centered"},[_vm._v("\n          Build Time: "+_vm._s(_vm.avgBuildTime)+" s\n        ")]),_vm._v(" "),_c('p',{staticClass:"level-item has-text-centered"},[_vm._v("\n          Product Id: "+_vm._s(_vm.id)+"\n        ")])])]),_vm._v(" "),_c('footer',{staticClass:"card-footer"},[((_vm.action1 != null && _vm.action1.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item",on:{"click":_vm.runAction1}},[_vm._v(_vm._s(_vm.action1.charAt(0).toUpperCase() + _vm.action1.substr(1)))]):_vm._e(),_vm._v(" "),((_vm.action2 != null && _vm.action2.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item",on:{"click":_vm.runAction2}},[_vm._v(_vm._s(_vm.action2.charAt(0).toUpperCase() + _vm.action2.substr(1)))]):_vm._e()])])}
var staticRenderFns = []



/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_Vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_Vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_Vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".compact.card-header{background-color:#f5f5f5}.compact.card-header-title{padding-top:1px;padding-bottom:1px}.compact.card-content{padding:.75rem 1.5rem}.compact.card-footer-item{padding-top:0;padding-bottom:0}.is-info.card-footer-item{background-color:#209cee;color:#fff}.is-danger.card-footer-item{background-color:#ff3860;color:#fff}.has-black.card-footer-item{color:#000}", ""]);

// exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductEditor_Vue_vue_type_template_id_1804b763__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductEditor_Vue_vue_type_script_lang_js__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ProductEditor_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ProductEditor_Vue_vue_type_template_id_1804b763__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ProductEditor_Vue_vue_type_template_id_1804b763__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductEditor_Vue_vue_type_template_id_1804b763__ = __webpack_require__(193);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductEditor_Vue_vue_type_template_id_1804b763__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductEditor_Vue_vue_type_template_id_1804b763__["b"]; });


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-window',{attrs:{"loading":_vm.loading},on:{"close":function($event){_vm.$emit('closeProductEditor')}}},[_c('template',{slot:"header"},[_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('closeProductEditor')}}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"label":"Name of the product","position":"is-right"}},[_c('label',{staticClass:"label"},[_vm._v("Name")])]),_vm._v(" "),_c('b-field',{attrs:{"type":{'is-danger':  _vm.newProductName.length < 2 && _vm.saveClicked},"message":{'You should specify product name!' : _vm.newProductName.length < 2 && _vm.saveClicked }}},[_c('b-input',{attrs:{"maxlength":"100","placeholder":"FastReport.Jar"},model:{value:(_vm.newProductName),callback:function ($$v) {_vm.newProductName=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"newProductName"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"label":"Brief description of the product","position":"is-right"}},[_c('label',{staticClass:"label"},[_vm._v("Description")])]),_vm._v(" "),_c('b-field',[_c('b-input',{attrs:{"type":"textarea","maxlength":"500","placeholder":"Java report generator","spellcheck":"true"},model:{value:(_vm.newProductDescription),callback:function ($$v) {_vm.newProductDescription=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"newProductDescription"}})],1)],1),_vm._v(" "),(!_vm.inherited)?_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"label":"Web page of the product","position":"is-right"}},[_c('label',{staticClass:"label"},[_vm._v("Product url")])]),_vm._v(" "),_c('b-field',[_c('b-input',{attrs:{"placeholder":"https://somefarinthegalaxy.com/product"},model:{value:(_vm.newProductUrl),callback:function ($$v) {_vm.newProductUrl=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"newProductUrl"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.inherited)?_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"label":"Web page of the product repository","position":"is-right"}},[_c('label',{staticClass:"label"},[_vm._v("Repository url")])]),_vm._v(" "),_c('b-field',[_c('b-input',{attrs:{"placeholder":"https://somefarinthegalaxy.com/repo"},model:{value:(_vm.newProductRepoUrl),callback:function ($$v) {_vm.newProductRepoUrl=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"newProductRepoUrl"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.inherited)?_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"label":"Category of the product regarding used technologies","position":"is-right"}},[_c('label',{staticClass:"label"},[_vm._v("Tag (.Net/VCL)")])]),_vm._v(" "),_c('b-field',[_c('b-input',{attrs:{"maxlength":"20","placeholder":"Java"},model:{value:(_vm.newProductTag),callback:function ($$v) {_vm.newProductTag=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"newProductTag"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.inherited)?_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"label":"Average building time of the product","position":"is-right"}},[_c('label',{staticClass:"label"},[_vm._v("Average build time, seconds")])]),_vm._v(" "),_c('b-field',[_c('b-input',{attrs:{"type":"number","placeholder":"10000"},model:{value:(_vm.newProductAvgBuildTime),callback:function ($$v) {_vm.newProductAvgBuildTime=_vm._n((typeof $$v === 'string'? $$v.trim(): $$v))},expression:"newProductAvgBuildTime"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.inherited)?_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"label":"Type product subsystems, separate by comma, please!","position":"is-right"}},[_c('label',{staticClass:"label"},[_vm._v("Product parts")])]),_vm._v(" "),_c('b-field',{attrs:{"type":{'is-danger':  _vm.productParts.length < 2 && _vm.saveClicked},"message":{'You should specify product parts!' : _vm.productParts.length < 2 && _vm.saveClicked }}},[_c('b-taginput',{attrs:{"placeholder":"Engine, Exports, .Net Core","ellipsis":"","icon":"label","data":_vm.filteredProductParts,"allow-new":true,"autocomplete":"","before-adding":_vm.beforeTagAdding},on:{"typing":_vm.getFilteredParts},model:{value:(_vm.productParts),callback:function ($$v) {_vm.productParts=$$v},expression:"productParts"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.productId <= 0 && ! _vm.inherited)?_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Initial version")]),_vm._v(" "),_c('div',{staticClass:"field is-grouped tooltip",attrs:{"data-tooltip":"First version of the product"}},[_c('p',{staticClass:"control"},[_c('label',{staticClass:"label"},[_vm._v("Major")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number.trim",value:(_vm.newProductMajor),expression:"newProductMajor",modifiers:{"number":true,"trim":true}}],staticClass:"input",class:{ 'is-danger':  (_vm.newProductMajor < 0 || !_vm.isInteger(_vm.newProductMajor)) && _vm.saveClicked},attrs:{"type":"number","min":"0","step":"1","pattern":"\\d*"},domProps:{"value":(_vm.newProductMajor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newProductMajor=_vm._n($event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('label',{staticClass:"label"},[_vm._v("Minor")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number.trim",value:(_vm.newProductMinor),expression:"newProductMinor",modifiers:{"number":true,"trim":true}}],staticClass:"input",class:{ 'is-danger':  (_vm.newProductMinor < 0 || !_vm.isInteger(_vm.newProductMinor)) && _vm.saveClicked},attrs:{"type":"number","min":"0","step":"1","pattern":"\\d*"},domProps:{"value":(_vm.newProductMinor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newProductMinor=_vm._n($event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('label',{staticClass:"label"},[_vm._v("Build")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number.trim",value:(_vm.newProductBuild),expression:"newProductBuild",modifiers:{"number":true,"trim":true}}],staticClass:"input",class:{ 'is-danger':  (_vm.newProductBuild < 0 || !_vm.isInteger(_vm.newProductBuild)) && _vm.saveClicked},attrs:{"type":"number","min":"0","step":"1","pattern":"\\d*"},domProps:{"value":(_vm.newProductBuild)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newProductBuild=_vm._n($event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),((_vm.newProductMajor < 0 || _vm.newProductMinor < 0 || _vm.newProductBuild < 0) && _vm.saveClicked)?_c('p',{staticClass:"help is-danger"},[_vm._v("You should specify not negative product version!")]):_vm._e(),_vm._v(" "),((!_vm.isInteger(_vm.newProductMajor) || !_vm.isInteger(_vm.newProductMinor) || !_vm.isInteger(_vm.newProductBuild)) && _vm.saveClicked)?_c('p',{staticClass:"help is-danger"},[_vm._v("Product version should be integer!")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.errors.length)?_c('div',{staticClass:"has-text-left has-text-danger"},[_c('b',{staticClass:"label is-danger"},[_vm._v("Please fix this error:")]),_vm._v(" "),_c('ul',_vm._l((_vm.errors),function(error,index){return _c('li',{key:index,staticClass:"is-danger"},[_vm._v(_vm._s(error))])}))]):_vm._e()]),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{staticClass:"button is-success",on:{"click":function($event){_vm.submit()}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.$emit('closeProductEditor')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-tooltip',{attrs:{"label":"Create a new product based on this one","position":"is-right"}},[((this.productId != 0))?_c('button',{staticClass:"button is-info",on:{"click":function($event){_vm.createInheritedProduct()}}},[_vm._v("Copy")]):_vm._e()])],1)],2)}
var staticRenderFns = []



/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductGroups_Vue_vue_type_template_id_b83db3c0__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductGroups_Vue_vue_type_script_lang_js__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ProductGroups_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ProductGroups_Vue_vue_type_template_id_b83db3c0__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ProductGroups_Vue_vue_type_template_id_b83db3c0__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductGroups_Vue_vue_type_template_id_b83db3c0__ = __webpack_require__(196);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductGroups_Vue_vue_type_template_id_b83db3c0__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductGroups_Vue_vue_type_template_id_b83db3c0__["b"]; });


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column container is-8 main"},[_c('content-filter',{attrs:{"createNewItem":_vm.createProduct,"filterGroups":_vm.filterGroups,"infoMsg":_vm.filterMsg},on:{"searchClick":_vm.searchHandler}}),_vm._v(" "),(_vm.searchingText.length > 0)?_c('nav',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"subtitle is-4"},[_c('span',[_vm._v("Search results for: "+_vm._s(_vm.searchingText))])])]),_vm._v(" "),_c('b-tooltip',{staticClass:"level-item",attrs:{"label":"Clear search results"}},[_c('button',{staticClass:"delete",on:{"click":_vm.clearSearch}},[_vm._v("Clear")])])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.groups),function(item,index){return _c('div',{key:index},[_c('product-card',{attrs:{"product":item,"action1":'edit',"action2":'delete',"action3":'file'},on:{"edit":_vm.editProduct,"delete":_vm.deleteGroupModal,"file":_vm.saveFileModal}}),_vm._v(" "),_c('br')],1)}),_vm._v(" "),_c('pagination',{staticClass:"is-centered",attrs:{"urlBuilder":_vm.urlBuilder,"currentPage":_vm.page.pageNumber,"lastPage":_vm.page.totalPages}}),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}})],2),_vm._v(" "),(_vm.isEditorVisible)?_c('product-editor',{attrs:{"groupId":this.groupId,"header":_vm.productEditorHeader},on:{"closeProductEditor":_vm.closeProductEditor}}):_vm._e(),_vm._v(" "),(_vm.isDeleteModalVisible)?_c('delete-confirmer',{attrs:{"text":_vm.deleteMsg,"header":_vm.deleteHeader,"id":this.groupId},on:{"close":_vm.closeProductDeleteWindow,"delete":_vm.deleteGroup}}):_vm._e(),_vm._v(" "),(_vm.isSaverVisible)?_c('changes-saver',{attrs:{"groupId":this.groupId,"filterType":_vm.filterType},on:{"closeSaveChangesWindow":_vm.closeFileSaver}}):_vm._e()],1)])}
var staticRenderFns = []



/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductsGroupCard_Vue_vue_type_template_id_d54ae666__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductsGroupCard_Vue_vue_type_script_lang_js__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductsGroupCard_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ProductsGroupCard_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ProductsGroupCard_Vue_vue_type_template_id_d54ae666__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ProductsGroupCard_Vue_vue_type_template_id_d54ae666__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupCard_Vue_vue_type_template_id_d54ae666__ = __webpack_require__(199);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupCard_Vue_vue_type_template_id_d54ae666__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupCard_Vue_vue_type_template_id_d54ae666__["b"]; });


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.viewType === 'deluxe' || _vm.viewType === 'brilliant')?_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header compact"},[_c('p',{staticClass:"card-header-title compact"},[_c('a',{staticClass:"link is-info has-text-black",attrs:{"href":_vm.userLink,"target":"_blank"}},[_vm._v(" Last edited by: "+_vm._s(_vm.userFullName))])])]),_vm._v(" "),_c('footer',{staticClass:"card-footer"},[((_vm.action1 != null && _vm.action1.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item compact has-black",on:{"click":_vm.runAction1}},[_vm._v(_vm._s(_vm.action1.charAt(0).toUpperCase() + _vm.action1.substr(1)))]):_vm._e(),_vm._v(" "),((_vm.action2 != null && _vm.action2.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item compact has-black",on:{"click":_vm.runAction2}},[_vm._v(_vm._s(_vm.action2.charAt(0).toUpperCase() + _vm.action2.substr(1)))]):_vm._e(),_vm._v(" "),((_vm.action3 != null && _vm.action3.length > 0))?_c('a',{staticClass:"card-footer-item",on:{"click":_vm.runAction3}},[_vm._v(_vm._s(_vm.action3.charAt(0).toUpperCase() + _vm.action3.substr(1)))]):_vm._e()])]):_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header"},[_c('div',{staticClass:"container is-paddingless"},[_c('nav',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"card-header-title"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"level-right"},[_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"card-header-title"},[_c('a',{staticClass:"link is-info",attrs:{"href":_vm.userLink,"target":"_blank"}},[_vm._v(" Last edited by: "+_vm._s(_vm.userFullName))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(_vm.name)+" ")])]),_vm._v(" "),_c('nav',{staticClass:"level"},[_c('p',{staticClass:"level-item has-text-centered"},[_vm._v("\n        Group Id: "+_vm._s(_vm.id)+"\n      ")])])]),_vm._v(" "),_c('footer',{staticClass:"card-footer"},[((_vm.action1 != null && _vm.action1.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item",on:{"click":_vm.runAction1}},[_vm._v(_vm._s(_vm.action1.charAt(0).toUpperCase() + _vm.action1.substr(1)))]):_vm._e(),_vm._v(" "),((_vm.action2 != null && _vm.action2.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item",on:{"click":_vm.runAction2}},[_vm._v(_vm._s(_vm.action2.charAt(0).toUpperCase() + _vm.action2.substr(1)))]):_vm._e(),_vm._v(" "),((_vm.action3 != null && _vm.action3.length > 0))?_c('a',{staticClass:"card-footer-item",on:{"click":_vm.runAction3}},[_vm._v(_vm._s(_vm.action3.charAt(0).toUpperCase() + _vm.action3.substr(1)))]):_vm._e()])])}
var staticRenderFns = []



/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupCard_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupCard_Vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupCard_Vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupCard_Vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".compact.card-header{background-color:#f5f5f5}.compact.card-header-title{padding-top:1px;padding-bottom:1px}.compact.card-content{padding:.75rem 1.5rem}.compact.card-footer-item{padding-top:0;padding-bottom:0}.is-info.card-footer-item{background-color:#209cee;color:#fff}.is-danger.card-footer-item{background-color:#ff3860;color:#fff}.has-black.card-footer-item{color:#000}", ""]);

// exports


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductsGroupEditor_vue_vue_type_template_id_0b54bdb8__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductsGroupEditor_vue_vue_type_script_lang_js__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect_dist_vue_multiselect_min_css_vue_type_style_index_0_lang_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ProductsGroupEditor_vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ProductsGroupEditor_vue_vue_type_template_id_0b54bdb8__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ProductsGroupEditor_vue_vue_type_template_id_0b54bdb8__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupEditor_vue_vue_type_template_id_0b54bdb8__ = __webpack_require__(204);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupEditor_vue_vue_type_template_id_0b54bdb8__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductsGroupEditor_vue_vue_type_template_id_0b54bdb8__["b"]; });


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-window',{attrs:{"loading":_vm.loading},on:{"close":function($event){_vm.$emit('closeProductEditor')}}},[_c('template',{slot:"header"},[_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('closeProductEditor')}}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('div',{staticClass:"field"},[_c('b-tooltip',{attrs:{"label":"Name of the group","position":"is-right"}},[_c('label',{staticClass:"label"},[_vm._v("Name")])]),_vm._v(" "),_c('b-field',{attrs:{"type":{'is-danger':  _vm.newGroupName.length < 2 && _vm.saveClicked},"message":{'You should specify a group name!' : _vm.newGroupName.length < 2 && _vm.saveClicked }}},[_c('b-input',{attrs:{"maxlength":"100","placeholder":"FastReport Super Deluxe 3000"},model:{value:(_vm.newGroupName),callback:function ($$v) {_vm.newGroupName=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"newGroupName"}})],1)],1),_vm._v(" "),_c('div',[_c('label',{staticClass:"typo__label"},[_vm._v("Products")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.allProducts,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":"Pick some","label":"name","track-by":"name","preselect-first":true},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var values = ref.values;
var search = ref.search;
var isOpen = ref.isOpen;
return [(_vm.products.length)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!isOpen),expression:"!isOpen"}],staticClass:"multiselect__single"},[_vm._v(_vm._s(_vm.products.length)+" products selected")]):_vm._e()]}}]),model:{value:(_vm.products),callback:function ($$v) {_vm.products=$$v},expression:"products"}})],1),_vm._v(" "),_c('div',[_c('pre',{staticClass:"has-background-white"},[_vm._v("\n\n\n\n\n\n\n\n\n      ")])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.errors.length)?_c('div',{staticClass:"has-text-left has-text-danger"},[_c('b',{staticClass:"label is-danger"},[_vm._v("Please fix this error:")]),_vm._v(" "),_c('ul',_vm._l((_vm.errors),function(error,index){return _c('li',{key:index,staticClass:"is-danger"},[_vm._v(_vm._s(error))])}))]):_vm._e()]),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{staticClass:"button is-success",on:{"click":function($event){_vm.submit()}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.$emit('closeProductEditor')}}},[_vm._v("Cancel")])])],2)}
var staticRenderFns = []



/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t, e) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueMultiselect = e() : t.VueMultiselect = e();
}(this, function () {
  return function (t) {
    function e(i) {
      if (n[i]) return n[i].exports;var r = n[i] = { i: i, l: !1, exports: {} };return t[i].call(r.exports, r, r.exports, e), r.l = !0, r.exports;
    }var n = {};return e.m = t, e.c = n, e.i = function (t) {
      return t;
    }, e.d = function (t, n, i) {
      e.o(t, n) || Object.defineProperty(t, n, { configurable: !1, enumerable: !0, get: i });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "/", e(e.s = 60);
  }([function (t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = n);
  }, function (t, e, n) {
    var i = n(49)("wks"),
        r = n(30),
        o = n(0).Symbol,
        s = "function" == typeof o;(t.exports = function (t) {
      return i[t] || (i[t] = s && o[t] || (s ? o : r)("Symbol." + t));
    }).store = i;
  }, function (t, e, n) {
    var i = n(5);t.exports = function (t) {
      if (!i(t)) throw TypeError(t + " is not an object!");return t;
    };
  }, function (t, e, n) {
    var i = n(0),
        r = n(10),
        o = n(8),
        s = n(6),
        u = n(11),
        a = function a(t, e, n) {
      var l,
          c,
          f,
          p,
          h = t & a.F,
          d = t & a.G,
          v = t & a.S,
          g = t & a.P,
          y = t & a.B,
          m = d ? i : v ? i[e] || (i[e] = {}) : (i[e] || {}).prototype,
          b = d ? r : r[e] || (r[e] = {}),
          _ = b.prototype || (b.prototype = {});d && (n = e);for (l in n) {
        c = !h && m && void 0 !== m[l], f = (c ? m : n)[l], p = y && c ? u(f, i) : g && "function" == typeof f ? u(Function.call, f) : f, m && s(m, l, f, t & a.U), b[l] != f && o(b, l, p), g && _[l] != f && (_[l] = f);
      }
    };i.core = r, a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, t.exports = a;
  }, function (t, e, n) {
    t.exports = !n(7)(function () {
      return 7 != Object.defineProperty({}, "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) ? null !== t : "function" == typeof t;
    };
  }, function (t, e, n) {
    var i = n(0),
        r = n(8),
        o = n(12),
        s = n(30)("src"),
        u = Function.toString,
        a = ("" + u).split("toString");n(10).inspectSource = function (t) {
      return u.call(t);
    }, (t.exports = function (t, e, n, u) {
      var l = "function" == typeof n;l && (o(n, "name") || r(n, "name", e)), t[e] !== n && (l && (o(n, s) || r(n, s, t[e] ? "" + t[e] : a.join(String(e)))), t === i ? t[e] = n : u ? t[e] ? t[e] = n : r(t, e, n) : (delete t[e], r(t, e, n)));
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && this[s] || u.call(this);
    });
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, e, n) {
    var i = n(13),
        r = n(25);t.exports = n(4) ? function (t, e, n) {
      return i.f(t, e, r(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e) {
    var n = {}.toString;t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  }, function (t, e) {
    var n = t.exports = { version: "2.5.7" };"number" == typeof __e && (__e = n);
  }, function (t, e, n) {
    var i = n(14);t.exports = function (t, e, n) {
      if (i(t), void 0 === e) return t;switch (n) {case 1:
          return function (n) {
            return t.call(e, n);
          };case 2:
          return function (n, i) {
            return t.call(e, n, i);
          };case 3:
          return function (n, i, r) {
            return t.call(e, n, i, r);
          };}return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e) {
    var n = {}.hasOwnProperty;t.exports = function (t, e) {
      return n.call(t, e);
    };
  }, function (t, e, n) {
    var i = n(2),
        r = n(41),
        o = n(29),
        s = Object.defineProperty;e.f = n(4) ? Object.defineProperty : function (t, e, n) {
      if (i(t), e = o(e, !0), i(n), r) try {
        return s(t, e, n);
      } catch (t) {}if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");return "value" in n && (t[e] = n.value), t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");return t;
    };
  }, function (t, e) {
    t.exports = {};
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);return t;
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(7);t.exports = function (t, e) {
      return !!t && i(function () {
        e ? t.call(null, function () {}, 1) : t.call(null);
      });
    };
  }, function (t, e, n) {
    var i = n(23),
        r = n(16);t.exports = function (t) {
      return i(r(t));
    };
  }, function (t, e, n) {
    var i = n(53),
        r = Math.min;t.exports = function (t) {
      return t > 0 ? r(i(t), 9007199254740991) : 0;
    };
  }, function (t, e, n) {
    var i = n(11),
        r = n(23),
        o = n(28),
        s = n(19),
        u = n(64);t.exports = function (t, e) {
      var n = 1 == t,
          a = 2 == t,
          l = 3 == t,
          c = 4 == t,
          f = 6 == t,
          p = 5 == t || f,
          h = e || u;return function (e, u, d) {
        for (var v, g, y = o(e), m = r(y), b = i(u, d, 3), _ = s(m.length), x = 0, w = n ? h(e, _) : a ? h(e, 0) : void 0; _ > x; x++) {
          if ((p || x in m) && (v = m[x], g = b(v, x, y), t)) if (n) w[x] = g;else if (g) switch (t) {case 3:
              return !0;case 5:
              return v;case 6:
              return x;case 2:
              w.push(v);} else if (c) return !1;
        }return f ? -1 : l || c ? c : w;
      };
    };
  }, function (t, e, n) {
    var i = n(5),
        r = n(0).document,
        o = i(r) && i(r.createElement);t.exports = function (t) {
      return o ? r.createElement(t) : {};
    };
  }, function (t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, e, n) {
    var i = n(9);t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == i(t) ? t.split("") : Object(t);
    };
  }, function (t, e) {
    t.exports = !1;
  }, function (t, e) {
    t.exports = function (t, e) {
      return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e };
    };
  }, function (t, e, n) {
    var i = n(13).f,
        r = n(12),
        o = n(1)("toStringTag");t.exports = function (t, e, n) {
      t && !r(t = n ? t : t.prototype, o) && i(t, o, { configurable: !0, value: e });
    };
  }, function (t, e, n) {
    var i = n(49)("keys"),
        r = n(30);t.exports = function (t) {
      return i[t] || (i[t] = r(t));
    };
  }, function (t, e, n) {
    var i = n(16);t.exports = function (t) {
      return Object(i(t));
    };
  }, function (t, e, n) {
    var i = n(5);t.exports = function (t, e) {
      if (!i(t)) return t;var n, r;if (e && "function" == typeof (n = t.toString) && !i(r = n.call(t))) return r;if ("function" == typeof (n = t.valueOf) && !i(r = n.call(t))) return r;if (!e && "function" == typeof (n = t.toString) && !i(r = n.call(t))) return r;throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e) {
    var n = 0,
        i = Math.random();t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + i).toString(36));
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(0),
        r = n(12),
        o = n(9),
        s = n(67),
        u = n(29),
        a = n(7),
        l = n(77).f,
        c = n(45).f,
        f = n(13).f,
        p = n(51).trim,
        _h = i.Number,
        d = _h,
        v = _h.prototype,
        g = "Number" == o(n(44)(v)),
        y = "trim" in String.prototype,
        m = function m(t) {
      var e = u(t, !1);if ("string" == typeof e && e.length > 2) {
        e = y ? e.trim() : p(e, 3);var n,
            i,
            r,
            o = e.charCodeAt(0);if (43 === o || 45 === o) {
          if (88 === (n = e.charCodeAt(2)) || 120 === n) return NaN;
        } else if (48 === o) {
          switch (e.charCodeAt(1)) {case 66:case 98:
              i = 2, r = 49;break;case 79:case 111:
              i = 8, r = 55;break;default:
              return +e;}for (var s, a = e.slice(2), l = 0, c = a.length; l < c; l++) {
            if ((s = a.charCodeAt(l)) < 48 || s > r) return NaN;
          }return parseInt(a, i);
        }
      }return +e;
    };if (!_h(" 0o1") || !_h("0b1") || _h("+0x1")) {
      _h = function h(t) {
        var e = arguments.length < 1 ? 0 : t,
            n = this;return n instanceof _h && (g ? a(function () {
          v.valueOf.call(n);
        }) : "Number" != o(n)) ? s(new d(m(e)), n, _h) : m(e);
      };for (var b, _ = n(4) ? l(d) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), x = 0; _.length > x; x++) {
        r(d, b = _[x]) && !r(_h, b) && f(_h, b, c(d, b));
      }_h.prototype = v, v.constructor = _h, n(6)(i, "Number", _h);
    }
  }, function (t, e, n) {
    "use strict";
    function i(t) {
      return 0 !== t && (!(!Array.isArray(t) || 0 !== t.length) || !t);
    }function r(t) {
      return function () {
        return !t.apply(void 0, arguments);
      };
    }function o(t, e) {
      return void 0 === t && (t = "undefined"), null === t && (t = "null"), !1 === t && (t = "false"), -1 !== t.toString().toLowerCase().indexOf(e.trim());
    }function s(t, e, n, i) {
      return t.filter(function (t) {
        return o(i(t, n), e);
      });
    }function u(t) {
      return t.filter(function (t) {
        return !t.$isLabel;
      });
    }function a(t, e) {
      return function (n) {
        return n.reduce(function (n, i) {
          return i[t] && i[t].length ? (n.push({ $groupLabel: i[e], $isLabel: !0 }), n.concat(i[t])) : n;
        }, []);
      };
    }function l(t, e, i, r, o) {
      return function (u) {
        return u.map(function (u) {
          var a;if (!u[i]) return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];var l = s(u[i], t, e, o);return l.length ? (a = {}, n.i(d.a)(a, r, u[r]), n.i(d.a)(a, i, l), a) : [];
        });
      };
    }var c = n(59),
        f = n(54),
        p = (n.n(f), n(95)),
        h = (n.n(p), n(31)),
        d = (n.n(h), n(58)),
        v = n(91),
        g = (n.n(v), n(98)),
        y = (n.n(g), n(92)),
        m = (n.n(y), n(88)),
        b = (n.n(m), n(97)),
        _ = (n.n(b), n(89)),
        x = (n.n(_), n(96)),
        w = (n.n(x), n(93)),
        S = (n.n(w), n(90)),
        O = (n.n(S), function () {
      for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) {
        e[n] = arguments[n];
      }return function (t) {
        return e.reduce(function (t, e) {
          return e(t);
        }, t);
      };
    });e.a = { data: function data() {
        return { search: "", isOpen: !1, preferredOpenDirection: "below", optimizedHeight: this.maxHeight };
      }, props: { internalSearch: { type: Boolean, default: !0 }, options: { type: Array, required: !0 }, multiple: { type: Boolean, default: !1 }, value: { type: null, default: function _default() {
            return [];
          } }, trackBy: { type: String }, label: { type: String }, searchable: { type: Boolean, default: !0 }, clearOnSelect: { type: Boolean, default: !0 }, hideSelected: { type: Boolean, default: !1 }, placeholder: { type: String, default: "Select option" }, allowEmpty: { type: Boolean, default: !0 }, resetAfter: { type: Boolean, default: !1 }, closeOnSelect: { type: Boolean, default: !0 }, customLabel: { type: Function, default: function _default(t, e) {
            return i(t) ? "" : e ? t[e] : t;
          } }, taggable: { type: Boolean, default: !1 }, tagPlaceholder: { type: String, default: "Press enter to create a tag" }, tagPosition: { type: String, default: "top" }, max: { type: [Number, Boolean], default: !1 }, id: { default: null }, optionsLimit: { type: Number, default: 1e3 }, groupValues: { type: String }, groupLabel: { type: String }, groupSelect: { type: Boolean, default: !1 }, blockKeys: { type: Array, default: function _default() {
            return [];
          } }, preserveSearch: { type: Boolean, default: !1 }, preselectFirst: { type: Boolean, default: !1 } }, mounted: function mounted() {
        !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
      }, computed: { internalValue: function internalValue() {
          return this.value || 0 === this.value ? Array.isArray(this.value) ? this.value : [this.value] : [];
        }, filteredOptions: function filteredOptions() {
          var t = this.search || "",
              e = t.toLowerCase().trim(),
              n = this.options.concat();return n = this.internalSearch ? this.groupValues ? this.filterAndFlat(n, e, this.label) : s(n, e, this.label, this.customLabel) : this.groupValues ? a(this.groupValues, this.groupLabel)(n) : n, n = this.hideSelected ? n.filter(r(this.isSelected)) : n, this.taggable && e.length && !this.isExistingOption(e) && ("bottom" === this.tagPosition ? n.push({ isTag: !0, label: t }) : n.unshift({ isTag: !0, label: t })), n.slice(0, this.optionsLimit);
        }, valueKeys: function valueKeys() {
          var t = this;return this.trackBy ? this.internalValue.map(function (e) {
            return e[t.trackBy];
          }) : this.internalValue;
        }, optionKeys: function optionKeys() {
          var t = this;return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map(function (e) {
            return t.customLabel(e, t.label).toString().toLowerCase();
          });
        }, currentOptionLabel: function currentOptionLabel() {
          return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
        } }, watch: { internalValue: function internalValue() {
          this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("input", this.multiple ? [] : null));
        }, search: function search() {
          this.$emit("search-change", this.search, this.id);
        } }, methods: { getValue: function getValue() {
          return this.multiple ? this.internalValue : 0 === this.internalValue.length ? null : this.internalValue[0];
        }, filterAndFlat: function filterAndFlat(t, e, n) {
          return O(l(e, n, this.groupValues, this.groupLabel, this.customLabel), a(this.groupValues, this.groupLabel))(t);
        }, flatAndStrip: function flatAndStrip(t) {
          return O(a(this.groupValues, this.groupLabel), u)(t);
        }, updateSearch: function updateSearch(t) {
          this.search = t;
        }, isExistingOption: function isExistingOption(t) {
          return !!this.options && this.optionKeys.indexOf(t) > -1;
        }, isSelected: function isSelected(t) {
          var e = this.trackBy ? t[this.trackBy] : t;return this.valueKeys.indexOf(e) > -1;
        }, isOptionDisabled: function isOptionDisabled(t) {
          return !!t.$isDisabled;
        }, getOptionLabel: function getOptionLabel(t) {
          if (i(t)) return "";if (t.isTag) return t.label;if (t.$isLabel) return t.$groupLabel;var e = this.customLabel(t, this.label);return i(e) ? "" : e;
        }, select: function select(t, e) {
          if (t.$isLabel && this.groupSelect) return void this.selectGroup(t);if (!(-1 !== this.blockKeys.indexOf(e) || this.disabled || t.$isDisabled || t.$isLabel) && (!this.max || !this.multiple || this.internalValue.length !== this.max) && ("Tab" !== e || this.pointerDirty)) {
            if (t.isTag) this.$emit("tag", t.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();else {
              if (this.isSelected(t)) return void ("Tab" !== e && this.removeElement(t));this.$emit("select", t, this.id), this.multiple ? this.$emit("input", this.internalValue.concat([t]), this.id) : this.$emit("input", t, this.id), this.clearOnSelect && (this.search = "");
            }this.closeOnSelect && this.deactivate();
          }
        }, selectGroup: function selectGroup(t) {
          var e = this,
              n = this.options.find(function (n) {
            return n[e.groupLabel] === t.$groupLabel;
          });if (n) if (this.wholeGroupSelected(n)) {
            this.$emit("remove", n[this.groupValues], this.id);var i = this.internalValue.filter(function (t) {
              return -1 === n[e.groupValues].indexOf(t);
            });this.$emit("input", i, this.id);
          } else {
            var r = n[this.groupValues].filter(function (t) {
              return !(e.isOptionDisabled(t) || e.isSelected(t));
            });this.$emit("select", r, this.id), this.$emit("input", this.internalValue.concat(r), this.id);
          }
        }, wholeGroupSelected: function wholeGroupSelected(t) {
          var e = this;return t[this.groupValues].every(function (t) {
            return e.isSelected(t) || e.isOptionDisabled(t);
          });
        }, wholeGroupDisabled: function wholeGroupDisabled(t) {
          return t[this.groupValues].every(this.isOptionDisabled);
        }, removeElement: function removeElement(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];if (!this.disabled && !t.$isDisabled) {
            if (!this.allowEmpty && this.internalValue.length <= 1) return void this.deactivate();var i = "object" === n.i(c.a)(t) ? this.valueKeys.indexOf(t[this.trackBy]) : this.valueKeys.indexOf(t);if (this.$emit("remove", t, this.id), this.multiple) {
              var r = this.internalValue.slice(0, i).concat(this.internalValue.slice(i + 1));this.$emit("input", r, this.id);
            } else this.$emit("input", null, this.id);this.closeOnSelect && e && this.deactivate();
          }
        }, removeLastElement: function removeLastElement() {
          -1 === this.blockKeys.indexOf("Delete") && 0 === this.search.length && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
        }, activate: function activate() {
          var t = this;this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && 0 === this.pointer && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.$nextTick(function () {
            return t.$refs.search.focus();
          })) : this.$el.focus(), this.$emit("open", this.id));
        }, deactivate: function deactivate() {
          this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search.blur() : this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
        }, toggle: function toggle() {
          this.isOpen ? this.deactivate() : this.activate();
        }, adjustPosition: function adjustPosition() {
          if ("undefined" != typeof window) {
            var t = this.$el.getBoundingClientRect().top,
                e = window.innerHeight - this.$el.getBoundingClientRect().bottom;e > this.maxHeight || e > t || "below" === this.openDirection || "bottom" === this.openDirection ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(e - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(t - 40, this.maxHeight));
          }
        } } };
  }, function (t, e, n) {
    "use strict";
    var i = n(54),
        r = (n.n(i), n(31));n.n(r);e.a = { data: function data() {
        return { pointer: 0, pointerDirty: !1 };
      }, props: { showPointer: { type: Boolean, default: !0 }, optionHeight: { type: Number, default: 40 } }, computed: { pointerPosition: function pointerPosition() {
          return this.pointer * this.optionHeight;
        }, visibleElements: function visibleElements() {
          return this.optimizedHeight / this.optionHeight;
        } }, watch: { filteredOptions: function filteredOptions() {
          this.pointerAdjust();
        }, isOpen: function isOpen() {
          this.pointerDirty = !1;
        } }, methods: { optionHighlight: function optionHighlight(t, e) {
          return { "multiselect__option--highlight": t === this.pointer && this.showPointer, "multiselect__option--selected": this.isSelected(e) };
        }, groupHighlight: function groupHighlight(t, e) {
          var n = this;if (!this.groupSelect) return ["multiselect__option--group", "multiselect__option--disabled"];var i = this.options.find(function (t) {
            return t[n.groupLabel] === e.$groupLabel;
          });return i && !this.wholeGroupDisabled(i) ? ["multiselect__option--group", { "multiselect__option--highlight": t === this.pointer && this.showPointer }, { "multiselect__option--group-selected": this.wholeGroupSelected(i) }] : "multiselect__option--disabled";
        }, addPointerElement: function addPointerElement() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Enter",
              e = t.key;this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
        }, pointerForward: function pointerForward() {
          this.pointer < this.filteredOptions.length - 1 && (this.pointer++, this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
        }, pointerBackward: function pointerBackward() {
          this.pointer > 0 ? (this.pointer--, this.$refs.list.scrollTop >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
        }, pointerReset: function pointerReset() {
          this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
        }, pointerAdjust: function pointerAdjust() {
          this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
        }, pointerSet: function pointerSet(t) {
          this.pointer = t, this.pointerDirty = !0;
        } } };
  }, function (t, e, n) {
    "use strict";
    var i = n(36),
        r = n(74),
        o = n(15),
        s = n(18);t.exports = n(72)(Array, "Array", function (t, e) {
      this._t = s(t), this._i = 0, this._k = e;
    }, function () {
      var t = this._t,
          e = this._k,
          n = this._i++;return !t || n >= t.length ? (this._t = void 0, r(1)) : "keys" == e ? r(0, n) : "values" == e ? r(0, t[n]) : r(0, [n, t[n]]);
    }, "values"), o.Arguments = o.Array, i("keys"), i("values"), i("entries");
  }, function (t, e, n) {
    "use strict";
    var i = n(31),
        r = (n.n(i), n(32)),
        o = n(33);e.a = { name: "vue-multiselect", mixins: [r.a, o.a], props: { name: { type: String, default: "" }, selectLabel: { type: String, default: "Press enter to select" }, selectGroupLabel: { type: String, default: "Press enter to select group" }, selectedLabel: { type: String, default: "Selected" }, deselectLabel: { type: String, default: "Press enter to remove" }, deselectGroupLabel: { type: String, default: "Press enter to deselect group" }, showLabels: { type: Boolean, default: !0 }, limit: { type: Number, default: 99999 }, maxHeight: { type: Number, default: 300 }, limitText: { type: Function, default: function _default(t) {
            return "and ".concat(t, " more");
          } }, loading: { type: Boolean, default: !1 }, disabled: { type: Boolean, default: !1 }, openDirection: { type: String, default: "" }, showNoOptions: { type: Boolean, default: !0 }, showNoResults: { type: Boolean, default: !0 }, tabindex: { type: Number, default: 0 } }, computed: { isSingleLabelVisible: function isSingleLabelVisible() {
          return (this.singleValue || 0 === this.singleValue) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
        }, isPlaceholderVisible: function isPlaceholderVisible() {
          return !(this.internalValue.length || this.searchable && this.isOpen);
        }, visibleValues: function visibleValues() {
          return this.multiple ? this.internalValue.slice(0, this.limit) : [];
        }, singleValue: function singleValue() {
          return this.internalValue[0];
        }, deselectLabelText: function deselectLabelText() {
          return this.showLabels ? this.deselectLabel : "";
        }, deselectGroupLabelText: function deselectGroupLabelText() {
          return this.showLabels ? this.deselectGroupLabel : "";
        }, selectLabelText: function selectLabelText() {
          return this.showLabels ? this.selectLabel : "";
        }, selectGroupLabelText: function selectGroupLabelText() {
          return this.showLabels ? this.selectGroupLabel : "";
        }, selectedLabelText: function selectedLabelText() {
          return this.showLabels ? this.selectedLabel : "";
        }, inputStyle: function inputStyle() {
          if (this.searchable || this.multiple && this.value && this.value.length) return this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" };
        }, contentStyle: function contentStyle() {
          return this.options.length ? { display: "inline-block" } : { display: "block" };
        }, isAbove: function isAbove() {
          return "above" === this.openDirection || "top" === this.openDirection || "below" !== this.openDirection && "bottom" !== this.openDirection && "above" === this.preferredOpenDirection;
        }, showSearchInput: function showSearchInput() {
          return this.searchable && (!this.hasSingleSelectedSlot || !this.visibleSingleValue && 0 !== this.visibleSingleValue || this.isOpen);
        } } };
  }, function (t, e, n) {
    var i = n(1)("unscopables"),
        r = Array.prototype;void 0 == r[i] && n(8)(r, i, {}), t.exports = function (t) {
      r[i][t] = !0;
    };
  }, function (t, e, n) {
    var i = n(18),
        r = n(19),
        o = n(85);t.exports = function (t) {
      return function (e, n, s) {
        var u,
            a = i(e),
            l = r(a.length),
            c = o(s, l);if (t && n != n) {
          for (; l > c;) {
            if ((u = a[c++]) != u) return !0;
          }
        } else for (; l > c; c++) {
          if ((t || c in a) && a[c] === n) return t || c || 0;
        }return !t && -1;
      };
    };
  }, function (t, e, n) {
    var i = n(9),
        r = n(1)("toStringTag"),
        o = "Arguments" == i(function () {
      return arguments;
    }()),
        s = function s(t, e) {
      try {
        return t[e];
      } catch (t) {}
    };t.exports = function (t) {
      var e, n, u;return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = s(e = Object(t), r)) ? n : o ? i(e) : "Object" == (u = i(e)) && "function" == typeof e.callee ? "Arguments" : u;
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(2);t.exports = function () {
      var t = i(this),
          e = "";return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
    };
  }, function (t, e, n) {
    var i = n(0).document;t.exports = i && i.documentElement;
  }, function (t, e, n) {
    t.exports = !n(4) && !n(7)(function () {
      return 7 != Object.defineProperty(n(21)("div"), "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (t, e, n) {
    var i = n(9);t.exports = Array.isArray || function (t) {
      return "Array" == i(t);
    };
  }, function (t, e, n) {
    "use strict";
    function i(t) {
      var e, n;this.promise = new t(function (t, i) {
        if (void 0 !== e || void 0 !== n) throw TypeError("Bad Promise constructor");e = t, n = i;
      }), this.resolve = r(e), this.reject = r(n);
    }var r = n(14);t.exports.f = function (t) {
      return new i(t);
    };
  }, function (t, e, n) {
    var i = n(2),
        r = n(76),
        o = n(22),
        s = n(27)("IE_PROTO"),
        u = function u() {},
        _a = function a() {
      var t,
          e = n(21)("iframe"),
          i = o.length;for (e.style.display = "none", n(40).appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write("<script>document.F=Object<\/script>"), t.close(), _a = t.F; i--;) {
        delete _a.prototype[o[i]];
      }return _a();
    };t.exports = Object.create || function (t, e) {
      var n;return null !== t ? (u.prototype = i(t), n = new u(), u.prototype = null, n[s] = t) : n = _a(), void 0 === e ? n : r(n, e);
    };
  }, function (t, e, n) {
    var i = n(79),
        r = n(25),
        o = n(18),
        s = n(29),
        u = n(12),
        a = n(41),
        l = Object.getOwnPropertyDescriptor;e.f = n(4) ? l : function (t, e) {
      if (t = o(t), e = s(e, !0), a) try {
        return l(t, e);
      } catch (t) {}if (u(t, e)) return r(!i.f.call(t, e), t[e]);
    };
  }, function (t, e, n) {
    var i = n(12),
        r = n(18),
        o = n(37)(!1),
        s = n(27)("IE_PROTO");t.exports = function (t, e) {
      var n,
          u = r(t),
          a = 0,
          l = [];for (n in u) {
        n != s && i(u, n) && l.push(n);
      }for (; e.length > a;) {
        i(u, n = e[a++]) && (~o(l, n) || l.push(n));
      }return l;
    };
  }, function (t, e, n) {
    var i = n(46),
        r = n(22);t.exports = Object.keys || function (t) {
      return i(t, r);
    };
  }, function (t, e, n) {
    var i = n(2),
        r = n(5),
        o = n(43);t.exports = function (t, e) {
      if (i(t), r(e) && e.constructor === t) return e;var n = o.f(t);return (0, n.resolve)(e), n.promise;
    };
  }, function (t, e, n) {
    var i = n(10),
        r = n(0),
        o = r["__core-js_shared__"] || (r["__core-js_shared__"] = {});(t.exports = function (t, e) {
      return o[t] || (o[t] = void 0 !== e ? e : {});
    })("versions", []).push({ version: i.version, mode: n(24) ? "pure" : "global", copyright: "© 2018 Denis Pushkarev (zloirock.ru)" });
  }, function (t, e, n) {
    var i = n(2),
        r = n(14),
        o = n(1)("species");t.exports = function (t, e) {
      var n,
          s = i(t).constructor;return void 0 === s || void 0 == (n = i(s)[o]) ? e : r(n);
    };
  }, function (t, e, n) {
    var i = n(3),
        r = n(16),
        o = n(7),
        s = n(84),
        u = "[" + s + "]",
        a = "​",
        l = RegExp("^" + u + u + "*"),
        c = RegExp(u + u + "*$"),
        f = function f(t, e, n) {
      var r = {},
          u = o(function () {
        return !!s[t]() || a[t]() != a;
      }),
          l = r[t] = u ? e(p) : s[t];n && (r[n] = l), i(i.P + i.F * u, "String", r);
    },
        p = f.trim = function (t, e) {
      return t = String(r(t)), 1 & e && (t = t.replace(l, "")), 2 & e && (t = t.replace(c, "")), t;
    };t.exports = f;
  }, function (t, e, n) {
    var i,
        r,
        o,
        s = n(11),
        u = n(68),
        a = n(40),
        l = n(21),
        c = n(0),
        f = c.process,
        p = c.setImmediate,
        h = c.clearImmediate,
        d = c.MessageChannel,
        v = c.Dispatch,
        g = 0,
        y = {},
        m = function m() {
      var t = +this;if (y.hasOwnProperty(t)) {
        var e = y[t];delete y[t], e();
      }
    },
        b = function b(t) {
      m.call(t.data);
    };p && h || (p = function p(t) {
      for (var e = [], n = 1; arguments.length > n;) {
        e.push(arguments[n++]);
      }return y[++g] = function () {
        u("function" == typeof t ? t : Function(t), e);
      }, i(g), g;
    }, h = function h(t) {
      delete y[t];
    }, "process" == n(9)(f) ? i = function i(t) {
      f.nextTick(s(m, t, 1));
    } : v && v.now ? i = function i(t) {
      v.now(s(m, t, 1));
    } : d ? (r = new d(), o = r.port2, r.port1.onmessage = b, i = s(o.postMessage, o, 1)) : c.addEventListener && "function" == typeof postMessage && !c.importScripts ? (i = function i(t) {
      c.postMessage(t + "", "*");
    }, c.addEventListener("message", b, !1)) : i = "onreadystatechange" in l("script") ? function (t) {
      a.appendChild(l("script")).onreadystatechange = function () {
        a.removeChild(this), m.call(t);
      };
    } : function (t) {
      setTimeout(s(m, t, 1), 0);
    }), t.exports = { set: p, clear: h };
  }, function (t, e) {
    var n = Math.ceil,
        i = Math.floor;t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? i : n)(t);
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(3),
        r = n(20)(5),
        o = !0;"find" in [] && Array(1).find(function () {
      o = !1;
    }), i(i.P + i.F * o, "Array", { find: function find(t) {
        return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
      } }), n(36)("find");
  }, function (t, e, n) {
    "use strict";
    var i,
        r,
        o,
        s,
        u = n(24),
        a = n(0),
        l = n(11),
        c = n(38),
        f = n(3),
        p = n(5),
        h = n(14),
        d = n(61),
        v = n(66),
        g = n(50),
        y = n(52).set,
        m = n(75)(),
        b = n(43),
        _ = n(80),
        x = n(86),
        w = n(48),
        S = a.TypeError,
        O = a.process,
        L = O && O.versions,
        k = L && L.v8 || "",
        _P = a.Promise,
        T = "process" == c(O),
        V = function V() {},
        E = r = b.f,
        A = !!function () {
      try {
        var t = _P.resolve(1),
            e = (t.constructor = {})[n(1)("species")] = function (t) {
          t(V, V);
        };return (T || "function" == typeof PromiseRejectionEvent) && t.then(V) instanceof e && 0 !== k.indexOf("6.6") && -1 === x.indexOf("Chrome/66");
      } catch (t) {}
    }(),
        C = function C(t) {
      var e;return !(!p(t) || "function" != typeof (e = t.then)) && e;
    },
        D = function D(t, e) {
      if (!t._n) {
        t._n = !0;var n = t._c;m(function () {
          for (var i = t._v, r = 1 == t._s, o = 0; n.length > o;) {
            !function (e) {
              var n,
                  o,
                  s,
                  u = r ? e.ok : e.fail,
                  a = e.resolve,
                  l = e.reject,
                  c = e.domain;try {
                u ? (r || (2 == t._h && $(t), t._h = 1), !0 === u ? n = i : (c && c.enter(), n = u(i), c && (c.exit(), s = !0)), n === e.promise ? l(S("Promise-chain cycle")) : (o = C(n)) ? o.call(n, a, l) : a(n)) : l(i);
              } catch (t) {
                c && !s && c.exit(), l(t);
              }
            }(n[o++]);
          }t._c = [], t._n = !1, e && !t._h && j(t);
        });
      }
    },
        j = function j(t) {
      y.call(a, function () {
        var e,
            n,
            i,
            r = t._v,
            o = N(t);if (o && (e = _(function () {
          T ? O.emit("unhandledRejection", r, t) : (n = a.onunhandledrejection) ? n({ promise: t, reason: r }) : (i = a.console) && i.error && i.error("Unhandled promise rejection", r);
        }), t._h = T || N(t) ? 2 : 1), t._a = void 0, o && e.e) throw e.v;
      });
    },
        N = function N(t) {
      return 1 !== t._h && 0 === (t._a || t._c).length;
    },
        $ = function $(t) {
      y.call(a, function () {
        var e;T ? O.emit("rejectionHandled", t) : (e = a.onrejectionhandled) && e({ promise: t, reason: t._v });
      });
    },
        F = function F(t) {
      var e = this;e._d || (e._d = !0, e = e._w || e, e._v = t, e._s = 2, e._a || (e._a = e._c.slice()), D(e, !0));
    },
        M = function M(t) {
      var e,
          n = this;if (!n._d) {
        n._d = !0, n = n._w || n;try {
          if (n === t) throw S("Promise can't be resolved itself");(e = C(t)) ? m(function () {
            var i = { _w: n, _d: !1 };try {
              e.call(t, l(M, i, 1), l(F, i, 1));
            } catch (t) {
              F.call(i, t);
            }
          }) : (n._v = t, n._s = 1, D(n, !1));
        } catch (t) {
          F.call({ _w: n, _d: !1 }, t);
        }
      }
    };A || (_P = function P(t) {
      d(this, _P, "Promise", "_h"), h(t), i.call(this);try {
        t(l(M, this, 1), l(F, this, 1));
      } catch (t) {
        F.call(this, t);
      }
    }, i = function i(t) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }, i.prototype = n(81)(_P.prototype, { then: function then(t, e) {
        var n = E(g(this, _P));return n.ok = "function" != typeof t || t, n.fail = "function" == typeof e && e, n.domain = T ? O.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && D(this, !1), n.promise;
      }, catch: function _catch(t) {
        return this.then(void 0, t);
      } }), o = function o() {
      var t = new i();this.promise = t, this.resolve = l(M, t, 1), this.reject = l(F, t, 1);
    }, b.f = E = function E(t) {
      return t === _P || t === s ? new o(t) : r(t);
    }), f(f.G + f.W + f.F * !A, { Promise: _P }), n(26)(_P, "Promise"), n(83)("Promise"), s = n(10).Promise, f(f.S + f.F * !A, "Promise", { reject: function reject(t) {
        var e = E(this);return (0, e.reject)(t), e.promise;
      } }), f(f.S + f.F * (u || !A), "Promise", { resolve: function resolve(t) {
        return w(u && this === s ? _P : this, t);
      } }), f(f.S + f.F * !(A && n(73)(function (t) {
      _P.all(t).catch(V);
    })), "Promise", { all: function all(t) {
        var e = this,
            n = E(e),
            i = n.resolve,
            r = n.reject,
            o = _(function () {
          var n = [],
              o = 0,
              s = 1;v(t, !1, function (t) {
            var u = o++,
                a = !1;n.push(void 0), s++, e.resolve(t).then(function (t) {
              a || (a = !0, n[u] = t, --s || i(n));
            }, r);
          }), --s || i(n);
        });return o.e && r(o.v), n.promise;
      }, race: function race(t) {
        var e = this,
            n = E(e),
            i = n.reject,
            r = _(function () {
          v(t, !1, function (t) {
            e.resolve(t).then(n.resolve, i);
          });
        });return r.e && i(r.v), n.promise;
      } });
  }, function (t, e, n) {
    "use strict";
    var i = n(3),
        r = n(10),
        o = n(0),
        s = n(50),
        u = n(48);i(i.P + i.R, "Promise", { finally: function _finally(t) {
        var e = s(this, r.Promise || o.Promise),
            n = "function" == typeof t;return this.then(n ? function (n) {
          return u(e, t()).then(function () {
            return n;
          });
        } : t, n ? function (n) {
          return u(e, t()).then(function () {
            throw n;
          });
        } : t);
      } });
  }, function (t, e, n) {
    "use strict";
    function i(t) {
      n(99);
    }var r = n(35),
        o = n(101),
        s = n(100),
        u = i,
        a = s(r.a, o.a, !1, u, null, null);e.a = a.exports;
  }, function (t, e, n) {
    "use strict";
    function i(t, e, n) {
      return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
    }e.a = i;
  }, function (t, e, n) {
    "use strict";
    function i(t) {
      return (i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return typeof t === "undefined" ? "undefined" : _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
      })(t);
    }function r(t) {
      return (r = "function" == typeof Symbol && "symbol" === i(Symbol.iterator) ? function (t) {
        return i(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : i(t);
      })(t);
    }e.a = r;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = n(34),
        r = (n.n(i), n(55)),
        o = (n.n(r), n(56)),
        s = (n.n(o), n(57)),
        u = n(32),
        a = n(33);n.d(e, "Multiselect", function () {
      return s.a;
    }), n.d(e, "multiselectMixin", function () {
      return u.a;
    }), n.d(e, "pointerMixin", function () {
      return a.a;
    }), e.default = s.a;
  }, function (t, e) {
    t.exports = function (t, e, n, i) {
      if (!(t instanceof e) || void 0 !== i && i in t) throw TypeError(n + ": incorrect invocation!");return t;
    };
  }, function (t, e, n) {
    var i = n(14),
        r = n(28),
        o = n(23),
        s = n(19);t.exports = function (t, e, n, u, a) {
      i(e);var l = r(t),
          c = o(l),
          f = s(l.length),
          p = a ? f - 1 : 0,
          h = a ? -1 : 1;if (n < 2) for (;;) {
        if (p in c) {
          u = c[p], p += h;break;
        }if (p += h, a ? p < 0 : f <= p) throw TypeError("Reduce of empty array with no initial value");
      }for (; a ? p >= 0 : f > p; p += h) {
        p in c && (u = e(u, c[p], p, l));
      }return u;
    };
  }, function (t, e, n) {
    var i = n(5),
        r = n(42),
        o = n(1)("species");t.exports = function (t) {
      var e;return r(t) && (e = t.constructor, "function" != typeof e || e !== Array && !r(e.prototype) || (e = void 0), i(e) && null === (e = e[o]) && (e = void 0)), void 0 === e ? Array : e;
    };
  }, function (t, e, n) {
    var i = n(63);t.exports = function (t, e) {
      return new (i(t))(e);
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(8),
        r = n(6),
        o = n(7),
        s = n(16),
        u = n(1);t.exports = function (t, e, n) {
      var a = u(t),
          l = n(s, a, ""[t]),
          c = l[0],
          f = l[1];o(function () {
        var e = {};return e[a] = function () {
          return 7;
        }, 7 != ""[t](e);
      }) && (r(String.prototype, t, c), i(RegExp.prototype, a, 2 == e ? function (t, e) {
        return f.call(t, this, e);
      } : function (t) {
        return f.call(t, this);
      }));
    };
  }, function (t, e, n) {
    var i = n(11),
        r = n(70),
        o = n(69),
        s = n(2),
        u = n(19),
        a = n(87),
        l = {},
        c = {},
        e = t.exports = function (t, e, n, f, p) {
      var h,
          d,
          v,
          g,
          y = p ? function () {
        return t;
      } : a(t),
          m = i(n, f, e ? 2 : 1),
          b = 0;if ("function" != typeof y) throw TypeError(t + " is not iterable!");if (o(y)) {
        for (h = u(t.length); h > b; b++) {
          if ((g = e ? m(s(d = t[b])[0], d[1]) : m(t[b])) === l || g === c) return g;
        }
      } else for (v = y.call(t); !(d = v.next()).done;) {
        if ((g = r(v, m, d.value, e)) === l || g === c) return g;
      }
    };e.BREAK = l, e.RETURN = c;
  }, function (t, e, n) {
    var i = n(5),
        r = n(82).set;t.exports = function (t, e, n) {
      var o,
          s = e.constructor;return s !== n && "function" == typeof s && (o = s.prototype) !== n.prototype && i(o) && r && r(t, o), t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var i = void 0 === n;switch (e.length) {case 0:
          return i ? t() : t.call(n);case 1:
          return i ? t(e[0]) : t.call(n, e[0]);case 2:
          return i ? t(e[0], e[1]) : t.call(n, e[0], e[1]);case 3:
          return i ? t(e[0], e[1], e[2]) : t.call(n, e[0], e[1], e[2]);case 4:
          return i ? t(e[0], e[1], e[2], e[3]) : t.call(n, e[0], e[1], e[2], e[3]);}return t.apply(n, e);
    };
  }, function (t, e, n) {
    var i = n(15),
        r = n(1)("iterator"),
        o = Array.prototype;t.exports = function (t) {
      return void 0 !== t && (i.Array === t || o[r] === t);
    };
  }, function (t, e, n) {
    var i = n(2);t.exports = function (t, e, n, r) {
      try {
        return r ? e(i(n)[0], n[1]) : e(n);
      } catch (e) {
        var o = t.return;throw void 0 !== o && i(o.call(t)), e;
      }
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(44),
        r = n(25),
        o = n(26),
        s = {};n(8)(s, n(1)("iterator"), function () {
      return this;
    }), t.exports = function (t, e, n) {
      t.prototype = i(s, { next: r(1, n) }), o(t, e + " Iterator");
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(24),
        r = n(3),
        o = n(6),
        s = n(8),
        u = n(15),
        a = n(71),
        l = n(26),
        c = n(78),
        f = n(1)("iterator"),
        p = !([].keys && "next" in [].keys()),
        h = function h() {
      return this;
    };t.exports = function (t, e, n, d, v, g, y) {
      a(n, e, d);var m,
          b,
          _,
          x = function x(t) {
        if (!p && t in L) return L[t];switch (t) {case "keys":case "values":
            return function () {
              return new n(this, t);
            };}return function () {
          return new n(this, t);
        };
      },
          w = e + " Iterator",
          S = "values" == v,
          O = !1,
          L = t.prototype,
          k = L[f] || L["@@iterator"] || v && L[v],
          P = k || x(v),
          T = v ? S ? x("entries") : P : void 0,
          V = "Array" == e ? L.entries || k : k;if (V && (_ = c(V.call(new t()))) !== Object.prototype && _.next && (l(_, w, !0), i || "function" == typeof _[f] || s(_, f, h)), S && k && "values" !== k.name && (O = !0, P = function P() {
        return k.call(this);
      }), i && !y || !p && !O && L[f] || s(L, f, P), u[e] = P, u[w] = h, v) if (m = { values: S ? P : x("values"), keys: g ? P : x("keys"), entries: T }, y) for (b in m) {
        b in L || o(L, b, m[b]);
      } else r(r.P + r.F * (p || O), e, m);return m;
    };
  }, function (t, e, n) {
    var i = n(1)("iterator"),
        r = !1;try {
      var o = [7][i]();o.return = function () {
        r = !0;
      }, Array.from(o, function () {
        throw 2;
      });
    } catch (t) {}t.exports = function (t, e) {
      if (!e && !r) return !1;var n = !1;try {
        var o = [7],
            s = o[i]();s.next = function () {
          return { done: n = !0 };
        }, o[i] = function () {
          return s;
        }, t(o);
      } catch (t) {}return n;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return { value: e, done: !!t };
    };
  }, function (t, e, n) {
    var i = n(0),
        r = n(52).set,
        o = i.MutationObserver || i.WebKitMutationObserver,
        s = i.process,
        u = i.Promise,
        a = "process" == n(9)(s);t.exports = function () {
      var t,
          e,
          n,
          l = function l() {
        var i, r;for (a && (i = s.domain) && i.exit(); t;) {
          r = t.fn, t = t.next;try {
            r();
          } catch (i) {
            throw t ? n() : e = void 0, i;
          }
        }e = void 0, i && i.enter();
      };if (a) n = function n() {
        s.nextTick(l);
      };else if (!o || i.navigator && i.navigator.standalone) {
        if (u && u.resolve) {
          var c = u.resolve(void 0);n = function n() {
            c.then(l);
          };
        } else n = function n() {
          r.call(i, l);
        };
      } else {
        var f = !0,
            p = document.createTextNode("");new o(l).observe(p, { characterData: !0 }), n = function n() {
          p.data = f = !f;
        };
      }return function (i) {
        var r = { fn: i, next: void 0 };e && (e.next = r), t || (t = r, n()), e = r;
      };
    };
  }, function (t, e, n) {
    var i = n(13),
        r = n(2),
        o = n(47);t.exports = n(4) ? Object.defineProperties : function (t, e) {
      r(t);for (var n, s = o(e), u = s.length, a = 0; u > a;) {
        i.f(t, n = s[a++], e[n]);
      }return t;
    };
  }, function (t, e, n) {
    var i = n(46),
        r = n(22).concat("length", "prototype");e.f = Object.getOwnPropertyNames || function (t) {
      return i(t, r);
    };
  }, function (t, e, n) {
    var i = n(12),
        r = n(28),
        o = n(27)("IE_PROTO"),
        s = Object.prototype;t.exports = Object.getPrototypeOf || function (t) {
      return t = r(t), i(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? s : null;
    };
  }, function (t, e) {
    e.f = {}.propertyIsEnumerable;
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return { e: !1, v: t() };
      } catch (t) {
        return { e: !0, v: t };
      }
    };
  }, function (t, e, n) {
    var i = n(6);t.exports = function (t, e, n) {
      for (var r in e) {
        i(t, r, e[r], n);
      }return t;
    };
  }, function (t, e, n) {
    var i = n(5),
        r = n(2),
        o = function o(t, e) {
      if (r(t), !i(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
    };t.exports = { set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, i) {
        try {
          i = n(11)(Function.call, n(45).f(Object.prototype, "__proto__").set, 2), i(t, []), e = !(t instanceof Array);
        } catch (t) {
          e = !0;
        }return function (t, n) {
          return o(t, n), e ? t.__proto__ = n : i(t, n), t;
        };
      }({}, !1) : void 0), check: o };
  }, function (t, e, n) {
    "use strict";
    var i = n(0),
        r = n(13),
        o = n(4),
        s = n(1)("species");t.exports = function (t) {
      var e = i[t];o && e && !e[s] && r.f(e, s, { configurable: !0, get: function get() {
          return this;
        } });
    };
  }, function (t, e) {
    t.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  }, function (t, e, n) {
    var i = n(53),
        r = Math.max,
        o = Math.min;t.exports = function (t, e) {
      return t = i(t), t < 0 ? r(t + e, 0) : o(t, e);
    };
  }, function (t, e, n) {
    var i = n(0),
        r = i.navigator;t.exports = r && r.userAgent || "";
  }, function (t, e, n) {
    var i = n(38),
        r = n(1)("iterator"),
        o = n(15);t.exports = n(10).getIteratorMethod = function (t) {
      if (void 0 != t) return t[r] || t["@@iterator"] || o[i(t)];
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(3),
        r = n(20)(2);i(i.P + i.F * !n(17)([].filter, !0), "Array", { filter: function filter(t) {
        return r(this, t, arguments[1]);
      } });
  }, function (t, e, n) {
    "use strict";
    var i = n(3),
        r = n(37)(!1),
        o = [].indexOf,
        s = !!o && 1 / [1].indexOf(1, -0) < 0;i(i.P + i.F * (s || !n(17)(o)), "Array", { indexOf: function indexOf(t) {
        return s ? o.apply(this, arguments) || 0 : r(this, t, arguments[1]);
      } });
  }, function (t, e, n) {
    var i = n(3);i(i.S, "Array", { isArray: n(42) });
  }, function (t, e, n) {
    "use strict";
    var i = n(3),
        r = n(20)(1);i(i.P + i.F * !n(17)([].map, !0), "Array", { map: function map(t) {
        return r(this, t, arguments[1]);
      } });
  }, function (t, e, n) {
    "use strict";
    var i = n(3),
        r = n(62);i(i.P + i.F * !n(17)([].reduce, !0), "Array", { reduce: function reduce(t) {
        return r(this, t, arguments.length, arguments[1], !1);
      } });
  }, function (t, e, n) {
    var i = Date.prototype,
        r = i.toString,
        o = i.getTime;new Date(NaN) + "" != "Invalid Date" && n(6)(i, "toString", function () {
      var t = o.call(this);return t === t ? r.call(this) : "Invalid Date";
    });
  }, function (t, e, n) {
    n(4) && "g" != /./g.flags && n(13).f(RegExp.prototype, "flags", { configurable: !0, get: n(39) });
  }, function (t, e, n) {
    n(65)("search", 1, function (t, e, n) {
      return [function (n) {
        "use strict";
        var i = t(this),
            r = void 0 == n ? void 0 : n[e];return void 0 !== r ? r.call(n, i) : new RegExp(n)[e](String(i));
      }, n];
    });
  }, function (t, e, n) {
    "use strict";
    n(94);var i = n(2),
        r = n(39),
        o = n(4),
        s = /./.toString,
        u = function u(t) {
      n(6)(RegExp.prototype, "toString", t, !0);
    };n(7)(function () {
      return "/a/b" != s.call({ source: "a", flags: "b" });
    }) ? u(function () {
      var t = i(this);return "/".concat(t.source, "/", "flags" in t ? t.flags : !o && t instanceof RegExp ? r.call(t) : void 0);
    }) : "toString" != s.name && u(function () {
      return s.call(this);
    });
  }, function (t, e, n) {
    "use strict";
    n(51)("trim", function (t) {
      return function () {
        return t(this, 3);
      };
    });
  }, function (t, e, n) {
    for (var i = n(34), r = n(47), o = n(6), s = n(0), u = n(8), a = n(15), l = n(1), c = l("iterator"), f = l("toStringTag"), p = a.Array, h = { CSSRuleList: !0, CSSStyleDeclaration: !1, CSSValueList: !1, ClientRectList: !1, DOMRectList: !1, DOMStringList: !1, DOMTokenList: !0, DataTransferItemList: !1, FileList: !1, HTMLAllCollection: !1, HTMLCollection: !1, HTMLFormElement: !1, HTMLSelectElement: !1, MediaList: !0, MimeTypeArray: !1, NamedNodeMap: !1, NodeList: !0, PaintRequestList: !1, Plugin: !1, PluginArray: !1, SVGLengthList: !1, SVGNumberList: !1, SVGPathSegList: !1, SVGPointList: !1, SVGStringList: !1, SVGTransformList: !1, SourceBufferList: !1, StyleSheetList: !0, TextTrackCueList: !1, TextTrackList: !1, TouchList: !1 }, d = r(h), v = 0; v < d.length; v++) {
      var g,
          y = d[v],
          m = h[y],
          b = s[y],
          _ = b && b.prototype;if (_ && (_[c] || u(_, c, p), _[f] || u(_, f, y), a[y] = p, m)) for (g in i) {
        _[g] || o(_, g, i[g], !0);
      }
    }
  }, function (t, e) {}, function (t, e) {
    t.exports = function (t, e, n, i, r, o) {
      var s,
          u = t = t || {},
          a = _typeof(t.default);"object" !== a && "function" !== a || (s = t, u = t.default);var l = "function" == typeof u ? u.options : u;e && (l.render = e.render, l.staticRenderFns = e.staticRenderFns, l._compiled = !0), n && (l.functional = !0), r && (l._scopeId = r);var c;if (o ? (c = function c(t) {
        t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), i && i.call(this, t), t && t._registeredComponents && t._registeredComponents.add(o);
      }, l._ssrRegister = c) : i && (c = i), c) {
        var f = l.functional,
            p = f ? l.render : l.beforeCreate;f ? (l._injectStyles = c, l.render = function (t, e) {
          return c.call(e), p(t, e);
        }) : l.beforeCreate = p ? [].concat(p, c) : [c];
      }return { esModule: s, exports: u, options: l };
    };
  }, function (t, e, n) {
    "use strict";
    var i = function i() {
      var t = this,
          e = t.$createElement,
          n = t._self._c || e;return n("div", { staticClass: "multiselect", class: { "multiselect--active": t.isOpen, "multiselect--disabled": t.disabled, "multiselect--above": t.isAbove }, attrs: { tabindex: t.searchable ? -1 : t.tabindex }, on: { focus: function focus(e) {
            t.activate();
          }, blur: function blur(e) {
            !t.searchable && t.deactivate();
          }, keydown: [function (e) {
            return "button" in e || !t._k(e.keyCode, "down", 40, e.key, ["Down", "ArrowDown"]) ? e.target !== e.currentTarget ? null : (e.preventDefault(), void t.pointerForward()) : null;
          }, function (e) {
            return "button" in e || !t._k(e.keyCode, "up", 38, e.key, ["Up", "ArrowUp"]) ? e.target !== e.currentTarget ? null : (e.preventDefault(), void t.pointerBackward()) : null;
          }], keypress: function keypress(e) {
            return "button" in e || !t._k(e.keyCode, "enter", 13, e.key, "Enter") || !t._k(e.keyCode, "tab", 9, e.key, "Tab") ? (e.stopPropagation(), e.target !== e.currentTarget ? null : void t.addPointerElement(e)) : null;
          }, keyup: function keyup(e) {
            if (!("button" in e) && t._k(e.keyCode, "esc", 27, e.key, "Escape")) return null;t.deactivate();
          } } }, [t._t("caret", [n("div", { staticClass: "multiselect__select", on: { mousedown: function mousedown(e) {
            e.preventDefault(), e.stopPropagation(), t.toggle();
          } } })], { toggle: t.toggle }), t._v(" "), t._t("clear", null, { search: t.search }), t._v(" "), n("div", { ref: "tags", staticClass: "multiselect__tags" }, [t._t("selection", [n("div", { directives: [{ name: "show", rawName: "v-show", value: t.visibleValues.length > 0, expression: "visibleValues.length > 0" }], staticClass: "multiselect__tags-wrap" }, [t._l(t.visibleValues, function (e, i) {
        return [t._t("tag", [n("span", { key: i, staticClass: "multiselect__tag" }, [n("span", { domProps: { textContent: t._s(t.getOptionLabel(e)) } }), t._v(" "), n("i", { staticClass: "multiselect__tag-icon", attrs: { "aria-hidden": "true", tabindex: "1" }, on: { keypress: function keypress(n) {
              if (!("button" in n) && t._k(n.keyCode, "enter", 13, n.key, "Enter")) return null;n.preventDefault(), t.removeElement(e);
            }, mousedown: function mousedown(n) {
              n.preventDefault(), t.removeElement(e);
            } } })])], { option: e, search: t.search, remove: t.removeElement })];
      })], 2), t._v(" "), t.internalValue && t.internalValue.length > t.limit ? [t._t("limit", [n("strong", { staticClass: "multiselect__strong", domProps: { textContent: t._s(t.limitText(t.internalValue.length - t.limit)) } })])] : t._e()], { search: t.search, remove: t.removeElement, values: t.visibleValues, isOpen: t.isOpen }), t._v(" "), n("transition", { attrs: { name: "multiselect__loading" } }, [t._t("loading", [n("div", { directives: [{ name: "show", rawName: "v-show", value: t.loading, expression: "loading" }], staticClass: "multiselect__spinner" })])], 2), t._v(" "), t.searchable ? n("input", { ref: "search", staticClass: "multiselect__input", style: t.inputStyle, attrs: { name: t.name, id: t.id, type: "text", autocomplete: "nope", placeholder: t.placeholder, disabled: t.disabled, tabindex: t.tabindex }, domProps: { value: t.search }, on: { input: function input(e) {
            t.updateSearch(e.target.value);
          }, focus: function focus(e) {
            e.preventDefault(), t.activate();
          }, blur: function blur(e) {
            e.preventDefault(), t.deactivate();
          }, keyup: function keyup(e) {
            if (!("button" in e) && t._k(e.keyCode, "esc", 27, e.key, "Escape")) return null;t.deactivate();
          }, keydown: [function (e) {
            if (!("button" in e) && t._k(e.keyCode, "down", 40, e.key, ["Down", "ArrowDown"])) return null;e.preventDefault(), t.pointerForward();
          }, function (e) {
            if (!("button" in e) && t._k(e.keyCode, "up", 38, e.key, ["Up", "ArrowUp"])) return null;e.preventDefault(), t.pointerBackward();
          }, function (e) {
            if (!("button" in e) && t._k(e.keyCode, "delete", [8, 46], e.key, ["Backspace", "Delete"])) return null;e.stopPropagation(), t.removeLastElement();
          }], keypress: function keypress(e) {
            return "button" in e || !t._k(e.keyCode, "enter", 13, e.key, "Enter") ? (e.preventDefault(), e.stopPropagation(), e.target !== e.currentTarget ? null : void t.addPointerElement(e)) : null;
          } } }) : t._e(), t._v(" "), t.isSingleLabelVisible ? n("span", { staticClass: "multiselect__single", on: { mousedown: function mousedown(e) {
            return e.preventDefault(), t.toggle(e);
          } } }, [t._t("singleLabel", [[t._v(t._s(t.currentOptionLabel))]], { option: t.singleValue })], 2) : t._e(), t._v(" "), t.isPlaceholderVisible ? n("span", { staticClass: "multiselect__placeholder", on: { mousedown: function mousedown(e) {
            return e.preventDefault(), t.toggle(e);
          } } }, [t._t("placeholder", [t._v("\n          " + t._s(t.placeholder) + "\n        ")])], 2) : t._e()], 2), t._v(" "), n("transition", { attrs: { name: "multiselect" } }, [n("div", { directives: [{ name: "show", rawName: "v-show", value: t.isOpen, expression: "isOpen" }], ref: "list", staticClass: "multiselect__content-wrapper", style: { maxHeight: t.optimizedHeight + "px" }, attrs: { tabindex: "-1" }, on: { focus: t.activate, mousedown: function mousedown(t) {
            t.preventDefault();
          } } }, [n("ul", { staticClass: "multiselect__content", style: t.contentStyle }, [t._t("beforeList"), t._v(" "), t.multiple && t.max === t.internalValue.length ? n("li", [n("span", { staticClass: "multiselect__option" }, [t._t("maxElements", [t._v("Maximum of " + t._s(t.max) + " options selected. First remove a selected option to select another.")])], 2)]) : t._e(), t._v(" "), !t.max || t.internalValue.length < t.max ? t._l(t.filteredOptions, function (e, i) {
        return n("li", { key: i, staticClass: "multiselect__element" }, [e && (e.$isLabel || e.$isDisabled) ? t._e() : n("span", { staticClass: "multiselect__option", class: t.optionHighlight(i, e), attrs: { "data-select": e && e.isTag ? t.tagPlaceholder : t.selectLabelText, "data-selected": t.selectedLabelText, "data-deselect": t.deselectLabelText }, on: { click: function click(n) {
              n.stopPropagation(), t.select(e);
            }, mouseenter: function mouseenter(e) {
              if (e.target !== e.currentTarget) return null;t.pointerSet(i);
            } } }, [t._t("option", [n("span", [t._v(t._s(t.getOptionLabel(e)))])], { option: e, search: t.search })], 2), t._v(" "), e && (e.$isLabel || e.$isDisabled) ? n("span", { staticClass: "multiselect__option", class: t.groupHighlight(i, e), attrs: { "data-select": t.groupSelect && t.selectGroupLabelText, "data-deselect": t.groupSelect && t.deselectGroupLabelText }, on: { mouseenter: function mouseenter(e) {
              if (e.target !== e.currentTarget) return null;t.groupSelect && t.pointerSet(i);
            }, mousedown: function mousedown(n) {
              n.preventDefault(), t.selectGroup(e);
            } } }, [t._t("option", [n("span", [t._v(t._s(t.getOptionLabel(e)))])], { option: e, search: t.search })], 2) : t._e()]);
      }) : t._e(), t._v(" "), n("li", { directives: [{ name: "show", rawName: "v-show", value: t.showNoResults && 0 === t.filteredOptions.length && t.search && !t.loading, expression: "showNoResults && (filteredOptions.length === 0 && search && !loading)" }] }, [n("span", { staticClass: "multiselect__option" }, [t._t("noResult", [t._v("No elements found. Consider changing the search query.")], { search: t.search })], 2)]), t._v(" "), n("li", { directives: [{ name: "show", rawName: "v-show", value: t.showNoOptions && 0 === t.options.length && !t.search && !t.loading, expression: "showNoOptions && (options.length === 0 && !search && !loading)" }] }, [n("span", { staticClass: "multiselect__option" }, [t._t("noOptions", [t._v("List is empty.")])], 2)]), t._v(" "), t._t("afterList")], 2)])])], 2);
    },
        r = [],
        o = { render: i, staticRenderFns: r };e.a = o;
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)(module)))

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_style_loader_index_js_css_loader_index_js_vue_loader_lib_loaders_stylePostLoader_js_vue_multiselect_min_css_vue_type_style_index_0_lang_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_style_loader_index_js_css_loader_index_js_vue_loader_lib_loaders_stylePostLoader_js_vue_multiselect_min_css_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vue_style_loader_index_js_css_loader_index_js_vue_loader_lib_loaders_stylePostLoader_js_vue_multiselect_min_css_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__vue_style_loader_index_js_css_loader_index_js_vue_loader_lib_loaders_stylePostLoader_js_vue_multiselect_min_css_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}", ""]);

// exports


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CombinedChangesSaver_Vue_vue_type_template_id_46b7a5fc__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CombinedChangesSaver_Vue_vue_type_script_lang_js__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CombinedChangesSaver_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__CombinedChangesSaver_Vue_vue_type_template_id_46b7a5fc__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CombinedChangesSaver_Vue_vue_type_template_id_46b7a5fc__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CombinedChangesSaver_Vue_vue_type_template_id_46b7a5fc__ = __webpack_require__(210);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CombinedChangesSaver_Vue_vue_type_template_id_46b7a5fc__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CombinedChangesSaver_Vue_vue_type_template_id_46b7a5fc__["b"]; });


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-window',{on:{"close":function($event){_vm.$emit('closeSaveChangesWindow')}}},[_c('template',{slot:"header"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Save changes")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('closeSaveChangesWindow')}}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Select file type")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fileType),expression:"fileType"}],attrs:{"type":"radio","value":"txt"},domProps:{"checked":_vm._q(_vm.fileType,"txt")},on:{"change":function($event){_vm.fileType="txt"}}}),_vm._v(" Text\n                ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fileType),expression:"fileType"}],attrs:{"type":"radio","value":"markdown"},domProps:{"checked":_vm._q(_vm.fileType,"markdown")},on:{"change":function($event){_vm.fileType="markdown"}}}),_vm._v(" Markdown\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Choose how many versions to include in the log (0 = everything)")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"number"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.versionDepth),expression:"versionDepth"}],attrs:{"type":"number","value":"all"},domProps:{"value":(_vm.versionDepth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.versionDepth=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Select language")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.language),expression:"language"}],attrs:{"type":"radio","value":"english","disabled":_vm.fileType == 'json'},domProps:{"checked":_vm._q(_vm.language,"english")},on:{"change":function($event){_vm.language="english"}}}),_vm._v(" English\n                ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.language),expression:"language"}],attrs:{"type":"radio","value":"russian","disabled":_vm.fileType == 'json'},domProps:{"checked":_vm._q(_vm.language,"russian")},on:{"change":function($event){_vm.language="russian"}}}),_vm._v(" Russian\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Group by")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.grouping),expression:"grouping"}],attrs:{"type":"radio","value":"minor","disabled":_vm.isGroupingDisabled},domProps:{"checked":_vm._q(_vm.grouping,"minor")},on:{"change":function($event){_vm.grouping="minor"}}}),_vm._v(" Minor\n                ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.grouping),expression:"grouping"}],attrs:{"type":"radio","value":"build","disabled":_vm.isGroupingDisabled},domProps:{"checked":_vm._q(_vm.grouping,"build")},on:{"change":function($event){_vm.grouping="build"}}}),_vm._v(" Build\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.includePrivate),expression:"includePrivate"}],attrs:{"type":"checkbox","value":"false"},domProps:{"checked":Array.isArray(_vm.includePrivate)?_vm._i(_vm.includePrivate,"false")>-1:(_vm.includePrivate)},on:{"change":function($event){var $$a=_vm.includePrivate,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="false",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.includePrivate=$$a.concat([$$v]))}else{$$i>-1&&(_vm.includePrivate=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.includePrivate=$$c}}}}),_vm._v("\n                Include private changes\n            ")])]),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}})],1),_vm._v(" "),_c('template',{slot:"footer"},[_c('a',{staticClass:"button is-success",attrs:{"id":"downloadBtn","download":_vm.filename},on:{"click":_vm.downloadChanges}},[_vm._v("Download")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.$emit('closeSaveChangesWindow')}}},[_vm._v("Cancel")])])],2)}
var staticRenderFns = []



/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Versions_Vue_vue_type_template_id_091b4e68__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Versions_Vue_vue_type_script_lang_js__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Versions_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Versions_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Versions_Vue_vue_type_template_id_091b4e68__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Versions_Vue_vue_type_template_id_091b4e68__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Versions_Vue_vue_type_template_id_091b4e68__ = __webpack_require__(213);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Versions_Vue_vue_type_template_id_091b4e68__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Versions_Vue_vue_type_template_id_091b4e68__["b"]; });


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"columns",attrs:{"id":"main"}},[_c('div',{staticClass:"column is-2"},[_c('side-menu',{staticClass:"column",attrs:{"header":_vm.versionsHeader,"items":_vm.products,"selectedItemId":_vm.productId},on:{"elementClick":_vm.toggleVersion}}),_vm._v(" "),_c('side-menu',{staticClass:"column",attrs:{"header":_vm.groupsHeader,"items":_vm.groups,"selectedItemId":_vm.groupId},on:{"elementClick":_vm.toggleGroup}})],1),_vm._v(" "),_c('main',{staticClass:"container column is-8 main"},[_c('content-filter',{attrs:{"createNewItem":_vm.createChange,"filterGroups":_vm.filterGroups,"infoMsg":_vm.filterMsg},on:{"searchClick":_vm.searchHandler}}),_vm._v(" "),(_vm.searchingText.length > 0)?_c('nav',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"subtitle is-4"},[_c('span',[_vm._v("Search results for: "+_vm._s(_vm.searchingText))])])]),_vm._v(" "),_c('b-tooltip',{staticClass:"level-item",attrs:{"label":"Clear search results"}},[_c('button',{staticClass:"delete",on:{"click":_vm.clearSearch}},[_vm._v("Clear")])])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((this.versions),function(version,index){return _c('div',{key:index},[_c('version-card',{attrs:{"version":version,"action1":'edit',"action2":'delete'},on:{"edit":_vm.editChange,"delete":_vm.deleteVersionModal}}),_vm._v(" "),_c('br')],1)}),_vm._v(" "),_c('pagination',{staticClass:"is-centered",attrs:{"urlBuilder":_vm.urlBuilder,"currentPage":_vm.page.pageNumber,"lastPage":_vm.page.totalPages}}),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}})],2),_vm._v(" "),(_vm.isUpdatingGroup)?_c('group-version-creator',{attrs:{"groupId":_vm.groupId,"header":_vm.VersionEditorHeader},on:{"closeGroupVersionEditor":_vm.closeGroupVersionEditor}}):_vm._e(),_vm._v(" "),(_vm.isEditorVisible)?_c('version-editor',{attrs:{"versionId":this.versionId,"productId":_vm.productId,"header":_vm.VersionEditorHeader},on:{"closeVersionEditor":_vm.closeVersionEditor}}):_vm._e(),_vm._v(" "),(_vm.isDeleteModalVisible)?_c('delete-confirmer',{attrs:{"text":_vm.deleteMsg,"header":_vm.deleteHeader,"id":this.productId},on:{"close":_vm.closeChangeDeleteWindow,"delete":_vm.deleteVersion}}):_vm._e()],1)])}
var staticRenderFns = []



/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionCard_Vue_vue_type_template_id_274bfe68__ = __webpack_require__(215);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionCard_Vue_vue_type_template_id_274bfe68__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionCard_Vue_vue_type_template_id_274bfe68__["b"]; });


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.viewType === 'brilliant')?_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header compact"},[_c('div',{staticClass:"card-header-title compact"},[_c('span',{staticClass:"is-light",staticStyle:{"margin-right":"1rem"}},[_vm._v("\n          #"+_vm._s(_vm.version.id)+" Version: "+_vm._s(_vm.versionText)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"tags compact"},[(_vm.version.state === 'Success')?_c('span',{staticClass:"tag is-success"},[_vm._v("\n          "+_vm._s(_vm.version.state)+"\n        ")]):(_vm.version.state === 'Building')?_c('span',{staticClass:"tag is-warning"},[_vm._v("\n          "+_vm._s(_vm.version.state)+"\n        ")]):(_vm.version.state === 'Initiated')?_c('span',{staticClass:"tag is-info"},[_vm._v("\n          "+_vm._s(_vm.version.state)+"\n        ")]):(_vm.version.state === 'Failed')?_c('span',{staticClass:"tag is-danger"},[_vm._v("\n          "+_vm._s(_vm.version.state)+"\n        ")]):_c('span',{staticClass:"tag is-dark"},[_vm._v("\n          "+_vm._s(_vm.version.state)+"\n        ")]),_vm._v(" "),(_vm.version.type == 'Stable')?_c('span',{staticClass:"tag is-success"},[_vm._v("\n           "+_vm._s(_vm.version.type)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.version.type == 'Night')?_c('span',{staticClass:"tag is-dark"},[_vm._v("\n           "+_vm._s(_vm.version.type)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.version.name)?_c('span',{staticClass:"tag is-light"},[_vm._v("\n          "+_vm._s(_vm.version.name)+"\n        ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"tag is-light"},[_vm._v(" \n          Changes count: "+_vm._s(_vm.version.changesCount)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card-header-title compact mouse-detrav-hover",staticStyle:{"justify-content":"space-between"}},[_c('div'),_vm._v(" "),_c('div',{staticClass:"tags compact"},[((_vm.action1 != null && _vm.action1.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"tag is-dark",on:{"click":_vm.runAction1}},[_vm._v("\n            "+_vm._s(_vm.action1.charAt(0).toUpperCase() + _vm.action1.substr(1))+" ")]):_vm._e(),_vm._v(" "),((_vm.action2 != null && _vm.action2.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"tag is-dark",on:{"click":_vm.runAction2}},[_vm._v("\n            "+_vm._s(_vm.action2.charAt(0).toUpperCase() + _vm.action2.substr(1))+" ")]):_vm._e()])])])]):(_vm.viewType === 'deluxe')?_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header compact"},[_c('p',{staticClass:"card-header-title compact"},[_vm._v("\n         #"+_vm._s(_vm.version.id)+" Version: "+_vm._s(_vm.versionText)+"\n      ")])]),_vm._v(" "),_c('nav',{staticClass:"card-content compact"},[_c('div',{staticClass:"level compact",staticStyle:{"margin":"0","background-color":"white"}},[_c('p',{staticClass:"level-item has-text-centered"},[_vm._v("\n          State: "+_vm._s(_vm.version.state)+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"level-item has-text-centered"},[_vm._v("\n          Type: "+_vm._s(_vm.version.type)+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"level-item has-text-centered"},[_vm._v("\n          Changes count: "+_vm._s(_vm.version.changesCount)+"\n        ")])])]),_vm._v(" "),_c('footer',{staticClass:"card-footer"},[((_vm.action1 != null && _vm.action1.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item compact has-black",on:{"click":_vm.runAction1}},[_vm._v(_vm._s(_vm.action1.charAt(0).toUpperCase() + _vm.action1.substr(1)))]):_vm._e(),_vm._v(" "),((_vm.action2 != null && _vm.action2.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item compact has-black",on:{"click":_vm.runAction2}},[_vm._v(_vm._s(_vm.action2.charAt(0).toUpperCase() + _vm.action2.substr(1)))]):_vm._e()])]):_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header"},[_c('p',{staticClass:"card-header-title"},[_vm._v("\n        #"+_vm._s(_vm.version.id)+" Version: "+_vm._s(_vm.versionText)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('nav',{staticClass:"level"},[_c('p',{staticClass:"level-item has-text-centered"},[_vm._v("\n          State: "+_vm._s(_vm.version.state)+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"level-item has-text-centered"},[_vm._v("\n          Type: "+_vm._s(_vm.version.type)+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"level-item has-text-centered"},[_vm._v("\n          Changes count: "+_vm._s(_vm.version.changesCount)+"\n        ")])])]),_vm._v(" "),_c('footer',{staticClass:"card-footer"},[((_vm.action1 != null && _vm.action1.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item",on:{"click":_vm.runAction1}},[_vm._v(_vm._s(_vm.action1.charAt(0).toUpperCase() + _vm.action1.substr(1)))]):_vm._e(),_vm._v(" "),((_vm.action2 != null && _vm.action2.length > 0) && this.userRole != 'readonly')?_c('a',{staticClass:"card-footer-item",on:{"click":_vm.runAction2}},[_vm._v(_vm._s(_vm.action2.charAt(0).toUpperCase() + _vm.action2.substr(1)))]):_vm._e()])])}
var staticRenderFns = []



/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionCard_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionCard_Vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionCard_Vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionCard_Vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".compact.card-header{background-color:#f5f5f5}.compact.card-header-title{padding-top:1px;padding-bottom:1px}.compact.card-content{padding:.75rem 1.5rem}.compact.card-footer-item{padding-top:0;padding-bottom:0}.is-info.card-footer-item{background-color:#209cee;color:#fff}.is-danger.card-footer-item{background-color:#ff3860;color:#fff}.has-black.card-footer-item{color:#000}", ""]);

// exports


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VersionEditor_Vue_vue_type_template_id_3f7aa927__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VersionEditor_Vue_vue_type_script_lang_js__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__VersionEditor_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__VersionEditor_Vue_vue_type_template_id_3f7aa927__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__VersionEditor_Vue_vue_type_template_id_3f7aa927__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionEditor_Vue_vue_type_template_id_3f7aa927__ = __webpack_require__(220);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionEditor_Vue_vue_type_template_id_3f7aa927__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VersionEditor_Vue_vue_type_template_id_3f7aa927__["b"]; });


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-window',{attrs:{"loading":_vm.loading},on:{"close":function($event){_vm.$emit('closeVersionEditor')}}},[_c('template',{slot:"header"},[_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('closeVersionEditor')}}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('div',{staticClass:"field is-grouped tooltip is-tooltip-bottom",attrs:{"data-tooltip":"Version of the product"}},[_c('p',{staticClass:"control"},[_c('label',{staticClass:"label"},[_vm._v("Major")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number.trim",value:(_vm.newVersionMajor),expression:"newVersionMajor",modifiers:{"number":true,"trim":true}}],staticClass:"input",class:{ 'is-danger':  (_vm.newVersionMajor < 0 || !_vm.isInteger(_vm.newVersionMajor)) && _vm.saveClicked},attrs:{"type":"number","min":"0","step":"1","pattern":"\\d*"},domProps:{"value":(_vm.newVersionMajor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newVersionMajor=_vm._n($event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('label',{staticClass:"label"},[_vm._v("Minor")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number.trim",value:(_vm.newVersionMinor),expression:"newVersionMinor",modifiers:{"number":true,"trim":true}}],staticClass:"input",class:{ 'is-danger':  (_vm.newVersionMinor < 0 || !_vm.isInteger(_vm.newVersionMinor)) && _vm.saveClicked},attrs:{"type":"number","min":"0","step":"1","pattern":"\\d*"},domProps:{"value":(_vm.newVersionMinor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newVersionMinor=_vm._n($event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('label',{staticClass:"label"},[_vm._v("Build")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number.trim",value:(_vm.newVersionBuild),expression:"newVersionBuild",modifiers:{"number":true,"trim":true}}],staticClass:"input",class:{ 'is-danger':  (_vm.newVersionBuild < 0 || !_vm.isInteger(_vm.newVersionBuild)) && _vm.saveClicked},attrs:{"type":"number","min":"0","step":"1","pattern":"\\d*"},domProps:{"value":(_vm.newVersionBuild)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newVersionBuild=_vm._n($event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),((_vm.newVersionMajor < 0 || _vm.newVersionMinor < 0 || _vm.newVersionBuild < 0) && _vm.saveClicked)?_c('p',{staticClass:"help is-danger"},[_vm._v("You should specify not negative product version!")]):_vm._e(),_vm._v(" "),((!_vm.isInteger(_vm.newVersionMajor) || !_vm.isInteger(_vm.newVersionMinor) || !_vm.isInteger(_vm.newVersionBuild)) && _vm.saveClicked)?_c('p',{staticClass:"help is-danger"},[_vm._v("\n      Product version should be integer and not negative!\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"control tooltip",attrs:{"data-tooltip":"Name of the product version (not necessary)"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.newVersionName),expression:"newVersionName",modifiers:{"trim":true}}],staticClass:"input",attrs:{"type":"text","placeholder":"Rostov-on-Don"},domProps:{"value":(_vm.newVersionName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newVersionName=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"select tooltip is-tooltip-right",attrs:{"data-tooltip":"Specifies a type of the version"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedType),expression:"selectedType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.types),function(type,index){return _c('option',{key:index,domProps:{"value":type}},[_vm._v("\n              "+_vm._s(type)+"\n            ")])}))])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("State")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"select tooltip is-tooltip-right",attrs:{"data-tooltip":"Specifies a stage of building the version"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedState),expression:"selectedState"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedState=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.states),function(state,index){return _c('option',{key:index,domProps:{"value":state}},[_vm._v("\n              "+_vm._s(state)+"\n            ")])}))])])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.errors.length)?_c('div',{staticClass:" has-text-left  has-text-danger"},[_c('b',{staticClass:"label is-danger"},[_vm._v("Please fix this error:")]),_vm._v(" "),_c('ul',_vm._l((_vm.errors),function(error,index){return _c('li',{key:index,staticClass:"is-danger"},[_vm._v(_vm._s(error))])}))]):_vm._e()]),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{staticClass:"button is-success",on:{"click":function($event){_vm.submit()},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submit()}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.$emit('closeVersionEditor')}}},[_vm._v("Cancel")])])],2)}
var staticRenderFns = []



/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GroupVersionCreator_vue_vue_type_template_id_00e94ccc__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GroupVersionCreator_vue_vue_type_script_lang_js__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GroupVersionCreator_vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GroupVersionCreator_vue_vue_type_template_id_00e94ccc__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GroupVersionCreator_vue_vue_type_template_id_00e94ccc__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GroupVersionCreator_vue_vue_type_template_id_00e94ccc__ = __webpack_require__(223);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GroupVersionCreator_vue_vue_type_template_id_00e94ccc__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GroupVersionCreator_vue_vue_type_template_id_00e94ccc__["b"]; });


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-window',{attrs:{"loading":_vm.loading},on:{"close":function($event){_vm.$emit('closeGroupVersionEditor')}}},[_c('template',{slot:"header"},[_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('closeGroupVersionEditor')}}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('div',{staticClass:"field is-grouped tooltip is-tooltip-bottom",attrs:{"data-tooltip":"Version of the product"}},[_c('p',{staticClass:"control"},[_c('label',{staticClass:"label"},[_vm._v("Major")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number.trim",value:(_vm.newVersionMajor),expression:"newVersionMajor",modifiers:{"number":true,"trim":true}}],staticClass:"input",class:{ 'is-danger':  (_vm.newVersionMajor < 0 || !_vm.isInteger(_vm.newVersionMajor)) && _vm.saveClicked},attrs:{"type":"number","min":"0","step":"1","pattern":"\\d*"},domProps:{"value":(_vm.newVersionMajor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newVersionMajor=_vm._n($event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('label',{staticClass:"label"},[_vm._v("Minor")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number.trim",value:(_vm.newVersionMinor),expression:"newVersionMinor",modifiers:{"number":true,"trim":true}}],staticClass:"input",class:{ 'is-danger':  (_vm.newVersionMinor < 0 || !_vm.isInteger(_vm.newVersionMinor)) && _vm.saveClicked},attrs:{"type":"number","min":"0","step":"1","pattern":"\\d*"},domProps:{"value":(_vm.newVersionMinor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newVersionMinor=_vm._n($event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('label',{staticClass:"label"},[_vm._v("Build")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number.trim",value:(_vm.newVersionBuild),expression:"newVersionBuild",modifiers:{"number":true,"trim":true}}],staticClass:"input",class:{ 'is-danger':  (_vm.newVersionBuild < 0 || !_vm.isInteger(_vm.newVersionBuild)) && _vm.saveClicked},attrs:{"type":"number","min":"0","step":"1","pattern":"\\d*"},domProps:{"value":(_vm.newVersionBuild)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newVersionBuild=_vm._n($event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),((_vm.newVersionMajor < 0 || _vm.newVersionMinor < 0 || _vm.newVersionBuild < 0) && _vm.saveClicked)?_c('p',{staticClass:"help is-danger"},[_vm._v("You should specify not negative product version!")]):_vm._e(),_vm._v(" "),((!_vm.isInteger(_vm.newVersionMajor) || !_vm.isInteger(_vm.newVersionMinor) || !_vm.isInteger(_vm.newVersionBuild)) && _vm.saveClicked)?_c('p',{staticClass:"help is-danger"},[_vm._v("\n      Product version should be integer and not negative!\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"control tooltip",attrs:{"data-tooltip":"Name of the product version (not necessary)"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.newVersionName),expression:"newVersionName",modifiers:{"trim":true}}],staticClass:"input",attrs:{"type":"text","placeholder":"Rostov-on-Don"},domProps:{"value":(_vm.newVersionName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newVersionName=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"select tooltip is-tooltip-right",attrs:{"data-tooltip":"Specifies a type of the version"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedType),expression:"selectedType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.types),function(type,index){return _c('option',{key:index,domProps:{"value":type}},[_vm._v("\n              "+_vm._s(type)+"\n            ")])}))])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("State")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"select tooltip is-tooltip-right",attrs:{"data-tooltip":"Specifies a stage of building the version"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedState),expression:"selectedState"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedState=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.states),function(state,index){return _c('option',{key:index,domProps:{"value":state}},[_vm._v("\n              "+_vm._s(state)+"\n            ")])}))])])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.errors.length)?_c('div',{staticClass:" has-text-left  has-text-danger"},[_c('b',{staticClass:"label is-danger"},[_vm._v("Please fix this error:")]),_vm._v(" "),_c('ul',_vm._l((_vm.errors),function(error,index){return _c('li',{key:index,staticClass:"is-danger"},[_vm._v(_vm._s(error))])}))]):_vm._e()]),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{staticClass:"button is-success",on:{"click":function($event){_vm.submit()},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submit()}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.$emit('closeGroupVersionEditor')}}},[_vm._v("Cancel")])])],2)}
var staticRenderFns = []



/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Versions_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Versions_Vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Versions_Vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Versions_Vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#app{display:flex;min-height:100vh;flex-direction:column;margin:0}*{box-sizing:border-box}body{min-height:100vh;flex-direction:column;margin:0}#main,body{display:flex}#main{flex:1}#main>aside{flex:0 0 10vw}.footer{height:10vh}nav.navbar{padding:0}", ""]);

// exports


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Callback_Vue_vue_type_template_id_02b99754__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Callback_Vue_vue_type_script_lang_js__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Callback_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Callback_Vue_vue_type_template_id_02b99754__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Callback_Vue_vue_type_template_id_02b99754__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Callback_Vue_vue_type_template_id_02b99754__ = __webpack_require__(228);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Callback_Vue_vue_type_template_id_02b99754__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Callback_Vue_vue_type_template_id_02b99754__["b"]; });


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}},[_vm._v("Callback")])],1)}
var staticRenderFns = []



/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Silent_Vue_vue_type_template_id_6d8be9e7__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Silent_Vue_vue_type_script_lang_js__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Silent_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Silent_Vue_vue_type_template_id_6d8be9e7__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Silent_Vue_vue_type_template_id_6d8be9e7__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Silent_Vue_vue_type_template_id_6d8be9e7__ = __webpack_require__(231);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Silent_Vue_vue_type_template_id_6d8be9e7__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Silent_Vue_vue_type_template_id_6d8be9e7__["b"]; });


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}},[_vm._v("Sign In Silent")])}
var staticRenderFns = []



/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__History_Vue_vue_type_template_id_7e675da0__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__History_Vue_vue_type_script_lang_js__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__History_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__History_Vue_vue_type_template_id_7e675da0__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__History_Vue_vue_type_template_id_7e675da0__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_History_Vue_vue_type_template_id_7e675da0__ = __webpack_require__(234);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_History_Vue_vue_type_template_id_7e675da0__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_History_Vue_vue_type_template_id_7e675da0__["b"]; });


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"columns",attrs:{"id":"main"}},[_c('main',{staticClass:"container column is-8 main"},[_c('content-filter',{attrs:{"infoMsg":_vm.filterMsg},on:{"searchClick":_vm.searchHandler}}),_vm._v(" "),(_vm.searchingText.length > 0)?_c('nav',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"subtitle is-4"},[_c('span',[_vm._v("Search results for: "+_vm._s(_vm.searchingText))])])]),_vm._v(" "),_c('b-tooltip',{staticClass:"level-item",attrs:{"label":"Clear search results"}},[_c('button',{staticClass:"delete",on:{"click":_vm.clearSearch}},[_vm._v("Clear")])])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table is-fullwidth"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.logs),function(item,index){return _c('tr',{key:index,class:{'is-selected':_vm.selectedRowsIds.indexOf(index) > -1},on:{"click":function($event){_vm.rowClick(index)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tableName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.entityId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(Date.parse(item.createDate),"mm/d/YYYY h:mm A")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.user !== null ? (item.user.name + " " + item.user.familyName) : "Johnessa Doe"))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.user !== null ? item.user.email : ""))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"buttons has-addons",on:{"click":function($event){_vm.isDeleteModalVisible=true}}},[_vm._m(1,true)])])])}))]),_vm._v(" "),_c('pagination',{staticClass:"is-centered",attrs:{"urlBuilder":_vm.urlBuilder,"currentPage":_vm.page.pageNumber,"lastPage":_vm.page.totalPages}}),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}}),_vm._v(" "),(_vm.isDeleteModalVisible)?_c('delete-confirmer',{attrs:{"text":_vm.deleteMsg,"header":_vm.deleteHeader},on:{"close":_vm.closeLogsDeleteWindow,"delete":_vm.deleteLogs}}):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("id")]),_vm._v(" "),_c('th',[_vm._v("Table Name")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Entity Id")]),_vm._v(" "),_c('th',[_vm._v("Text")]),_vm._v(" "),_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("User Name")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"control"},[_c('a',{staticClass:"button is-danger",attrs:{"title":"Delete"}},[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fas fa-ban"})])])])}]



/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfileSettings_Vue_vue_type_template_id_fd8bc488__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProfileSettings_Vue_vue_type_script_lang_js__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ProfileSettings_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ProfileSettings_Vue_vue_type_template_id_fd8bc488__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ProfileSettings_Vue_vue_type_template_id_fd8bc488__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProfileSettings_Vue_vue_type_template_id_fd8bc488__ = __webpack_require__(237);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProfileSettings_Vue_vue_type_template_id_fd8bc488__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProfileSettings_Vue_vue_type_template_id_fd8bc488__["b"]; });


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container column is-8"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Cards appearance")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vType),expression:"vType"}],attrs:{"type":"radio","value":"default"},domProps:{"checked":_vm._q(_vm.vType,"default")},on:{"change":function($event){_vm.vType="default"}}}),_vm._v(" Default view\n        ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vType),expression:"vType"}],attrs:{"type":"radio","value":"deluxe"},domProps:{"checked":_vm._q(_vm.vType,"deluxe")},on:{"change":function($event){_vm.vType="deluxe"}}}),_vm._v(" Deluxe view\n        ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vType),expression:"vType"}],attrs:{"type":"radio","value":"brilliant"},domProps:{"checked":_vm._q(_vm.vType,"brilliant")},on:{"change":function($event){_vm.vType="brilliant"}}}),_vm._v(" Brilliant view\n        ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vType),expression:"vType"}],attrs:{"disabled":"","type":"radio","value":"awesome"},domProps:{"checked":_vm._q(_vm.vType,"awesome")},on:{"change":function($event){_vm.vType="awesome"}}}),_vm._v(" Awesome view\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Cards count on the page>\n        "),_c('input',{directives:[{name:"model",rawName:"v-model.number.trim",value:(_vm.cCount),expression:"cCount",modifiers:{"number":true,"trim":true}}],staticClass:"input",attrs:{"type":"number","placeholder":"10"},domProps:{"value":(_vm.cCount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cCount=_vm._n($event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"field is-grouped"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-link",on:{"click":_vm.save}},[_vm._v("Save")])])])])])}
var staticRenderFns = []



/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChangesSaving_Vue_vue_type_template_id_31fced31__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangesSaving_Vue_vue_type_script_lang_js__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ChangesSaving_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ChangesSaving_Vue_vue_type_template_id_31fced31__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ChangesSaving_Vue_vue_type_template_id_31fced31__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesSaving_Vue_vue_type_template_id_31fced31__ = __webpack_require__(240);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesSaving_Vue_vue_type_template_id_31fced31__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangesSaving_Vue_vue_type_template_id_31fced31__["b"]; });


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column container is-8 main"},[_c('h1',{staticClass:"title"},[_vm._v("Changes saving")]),_vm._v(" "),_c('a',{staticClass:"button is-success",on:{"click":_vm.download}},[_vm._v("Download")]),_vm._v(" "),_c('span',{staticClass:"is-family-monospace",domProps:{"innerHTML":_vm._s(_vm.changesTxt)}}),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}})],1)])])}
var staticRenderFns = []



/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdminPanel_Vue_vue_type_template_id_50d7dc6c__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdminPanel_Vue_vue_type_script_lang_js__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AdminPanel_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__AdminPanel_Vue_vue_type_template_id_50d7dc6c__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AdminPanel_Vue_vue_type_template_id_50d7dc6c__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AdminPanel_Vue_vue_type_template_id_50d7dc6c__ = __webpack_require__(243);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AdminPanel_Vue_vue_type_template_id_50d7dc6c__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AdminPanel_Vue_vue_type_template_id_50d7dc6c__["b"]; });


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"columns",attrs:{"id":"main"}},[_c('side-menu',{staticClass:"column is-2",attrs:{"header":_vm.adminHeader,"items":_vm.actions,"selectedItemId":_vm.actionId},on:{"elementClick":_vm.toggleAdmin}}),_vm._v(" "),_c('main',{staticClass:"container column is-8 main"},[(_vm.actionId == 0)?_c('import-partial'):_c('restore-partial'),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}})],1)],1)])}
var staticRenderFns = []



/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImportPartial_Vue_vue_type_template_id_7fc719ce__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImportPartial_Vue_vue_type_script_lang_js__ = __webpack_require__(102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ImportPartial_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ImportPartial_Vue_vue_type_template_id_7fc719ce__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ImportPartial_Vue_vue_type_template_id_7fc719ce__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportPartial_Vue_vue_type_template_id_7fc719ce__ = __webpack_require__(246);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportPartial_Vue_vue_type_template_id_7fc719ce__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportPartial_Vue_vue_type_template_id_7fc719ce__["b"]; });


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Select product")]),_vm._v(" "),_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.productId),expression:"productId"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.productId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.products),function(product,index){return _c('option',{key:index,domProps:{"value":product.id}},[_vm._v("\n          "+_vm._s(product.name)+"\n        ")])}))])]),_vm._v(" "),_c('label',{staticClass:"label"},[_vm._v("Select files to import")]),_vm._v(" "),_c('div',{staticClass:"field file has-name"},[_c('label',{staticClass:"file-label"},[_c('input',{ref:"changesEnFile",staticClass:"file-input",attrs:{"type":"file","id":"changesEnFile"},on:{"change":function($event){_vm.handleChangesEnUpload()}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('span',{staticClass:"file-name"},[_vm._v("\n       "+_vm._s(_vm.enFile.name)+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"file has-name"},[_c('label',{staticClass:"file-label"},[_c('input',{ref:"changesRuFile",staticClass:"file-input",attrs:{"type":"file","id":"changesRuFile"},on:{"change":function($event){_vm.handleChangesRuUpload()}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',{staticClass:"file-name"},[_vm._v("\n         "+_vm._s(_vm.ruFile.name)+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('button',{staticClass:"button is-success",on:{"click":_vm.importChanges}},[_vm._v("Import")])]),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"file-cta"},[_c('span',{staticClass:"file-icon"},[_c('i',{staticClass:"fas fa-upload"})]),_vm._v(" "),_c('span',{staticClass:"file-label"},[_vm._v("\n          Choose a file with english changes (changes.txt)\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"file-cta"},[_c('span',{staticClass:"file-icon"},[_c('i',{staticClass:"fas fa-upload"})]),_vm._v(" "),_c('span',{staticClass:"file-label"},[_vm._v("\n            Choose a file with russian changes (changes.rus)\n          ")])])}]



/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RestorePartial_Vue_vue_type_template_id_c4c1cf16__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RestorePartial_Vue_vue_type_script_lang_js__ = __webpack_require__(104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RestorePartial_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__RestorePartial_Vue_vue_type_script_lang_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__RestorePartial_Vue_vue_type_template_id_c4c1cf16__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__RestorePartial_Vue_vue_type_template_id_c4c1cf16__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RestorePartial_Vue_vue_type_template_id_c4c1cf16__ = __webpack_require__(249);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RestorePartial_Vue_vue_type_template_id_c4c1cf16__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RestorePartial_Vue_vue_type_template_id_c4c1cf16__["b"]; });


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Select table")]),_vm._v(" "),_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTable),expression:"selectedTable"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTable=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"changes"}},[_vm._v(" Changes ")]),_vm._v(" "),_c('option',{attrs:{"value":"products"}},[_vm._v(" Products ")]),_vm._v(" "),_c('option',{attrs:{"value":"versions"}},[_vm._v(" Versions ")])])])]),_vm._v(" "),(_vm.selectedTable === 'changes' || _vm.selectedTable === 'versions')?_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Select product")]),_vm._v(" "),_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.productId),expression:"productId"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.productId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.products),function(product,index){return _c('option',{key:index,domProps:{"value":product.id}},[_vm._v("\n            "+_vm._s(product.name)+"\n          ")])}))])]):_vm._e(),_vm._v(" "),(_vm.selectedTable === 'changes' && _vm.products != null && _vm.products.length > 0)?_c('div',_vm._l((_vm.changes),function(item,index){return _c('div',{key:index},[_c('change-card',{attrs:{"change":item,"action2":'restore'},on:{"restore":_vm.restoreChange}}),_vm._v(" "),_c('br')],1)})):(_vm.selectedTable === 'products')?_c('div',_vm._l((_vm.products),function(item,index){return _c('div',{key:index},[_c('product-card',{attrs:{"product":item,"action2":'restore'},on:{"restore":_vm.restoreProduct}}),_vm._v(" "),_c('br')],1)})):(_vm.selectedTable === 'versions')?_c('div',_vm._l((_vm.versions),function(item,index){return _c('div',{key:index},[_c('version-card',{attrs:{"version":item,"action2":'restore'},on:{"restore":_vm.restoreVersion}}),_vm._v(" "),_c('br')],1)})):_vm._e(),_vm._v(" "),_c('pagination',{staticClass:"is-centered",attrs:{"urlBuilder":_vm.urlBuilder,"currentPage":_vm.page.pageNumber,"lastPage":_vm.page.totalPages}}),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}})],1)}
var staticRenderFns = []



/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RestorePartial_Vue_vue_type_style_index_0_lang_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RestorePartial_Vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RestorePartial_Vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RestorePartial_Vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! Buefy v0.7.10 | MIT License | github.com/buefy/buefy */
(function webpackUniversalModuleDefinition(root, factory) {
    if (( false ? 'undefined' : _typeof2(exports)) === 'object' && ( false ? 'undefined' : _typeof2(module)) === 'object') module.exports = factory(__webpack_require__(7));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object') exports["Buefy"] = factory(require("vue"));else root["Buefy"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_18__) {
    return (/******/function (modules) {
            // webpackBootstrap
            /******/ // The module cache
            /******/var installedModules = {};
            /******/
            /******/ // The require function
            /******/function __webpack_require__(moduleId) {
                /******/
                /******/ // Check if module is in cache
                /******/if (installedModules[moduleId]) {
                    /******/return installedModules[moduleId].exports;
                    /******/
                }
                /******/ // Create a new module (and put it into the cache)
                /******/var module = installedModules[moduleId] = {
                    /******/i: moduleId,
                    /******/l: false,
                    /******/exports: {}
                    /******/ };
                /******/
                /******/ // Execute the module function
                /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
                /******/
                /******/ // Flag the module as loaded
                /******/module.l = true;
                /******/
                /******/ // Return the exports of the module
                /******/return module.exports;
                /******/
            }
            /******/
            /******/
            /******/ // expose the modules object (__webpack_modules__)
            /******/__webpack_require__.m = modules;
            /******/
            /******/ // expose the module cache
            /******/__webpack_require__.c = installedModules;
            /******/
            /******/ // define getter function for harmony exports
            /******/__webpack_require__.d = function (exports, name, getter) {
                /******/if (!__webpack_require__.o(exports, name)) {
                    /******/Object.defineProperty(exports, name, {
                        /******/configurable: false,
                        /******/enumerable: true,
                        /******/get: getter
                        /******/ });
                    /******/
                }
                /******/
            };
            /******/
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/__webpack_require__.n = function (module) {
                /******/var getter = module && module.__esModule ?
                /******/function getDefault() {
                    return module['default'];
                } :
                /******/function getModuleExports() {
                    return module;
                };
                /******/__webpack_require__.d(getter, 'a', getter);
                /******/return getter;
                /******/
            };
            /******/
            /******/ // Object.prototype.hasOwnProperty.call
            /******/__webpack_require__.o = function (object, property) {
                return Object.prototype.hasOwnProperty.call(object, property);
            };
            /******/
            /******/ // __webpack_public_path__
            /******/__webpack_require__.p = "/";
            /******/
            /******/ // Load entry module and return exports
            /******/return __webpack_require__(__webpack_require__.s = 70);
            /******/
        }(
        /************************************************************************/
        /******/[
        /* 0 */
        /***/function (module, exports) {

            /* globals __VUE_SSR_CONTEXT__ */

            // this module is a runtime utility for cleaner component module output and will
            // be included in the final webpack user bundle

            module.exports = function normalizeComponent(rawScriptExports, compiledTemplate, injectStyles, scopeId, moduleIdentifier /* server only */
            ) {
                var esModule;
                var scriptExports = rawScriptExports = rawScriptExports || {};

                // ES6 modules interop
                var type = _typeof2(rawScriptExports.default);
                if (type === 'object' || type === 'function') {
                    esModule = rawScriptExports;
                    scriptExports = rawScriptExports.default;
                }

                // Vue.extend constructor export interop
                var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

                // render functions
                if (compiledTemplate) {
                    options.render = compiledTemplate.render;
                    options.staticRenderFns = compiledTemplate.staticRenderFns;
                }

                // scopedId
                if (scopeId) {
                    options._scopeId = scopeId;
                }

                var hook;
                if (moduleIdentifier) {
                    // server build
                    hook = function hook(context) {
                        // 2.3 injection
                        context = context || // cached call
                        this.$vnode && this.$vnode.ssrContext || // stateful
                        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
                        // 2.2 with runInNewContext: true
                        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                            context = __VUE_SSR_CONTEXT__;
                        }
                        // inject component styles
                        if (injectStyles) {
                            injectStyles.call(this, context);
                        }
                        // register component module identifier for async chunk inferrence
                        if (context && context._registeredComponents) {
                            context._registeredComponents.add(moduleIdentifier);
                        }
                    };
                    // used by ssr in case component is cached and beforeCreate
                    // never gets called
                    options._ssrRegister = hook;
                } else if (injectStyles) {
                    hook = injectStyles;
                }

                if (hook) {
                    var functional = options.functional;
                    var existing = functional ? options.render : options.beforeCreate;
                    if (!functional) {
                        // inject component registration as beforeCreate hook
                        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
                    } else {
                        // register for functioal component in vue file
                        options.render = function renderWithStyleInjection(h, context) {
                            hook.call(context);
                            return existing(h, context);
                        };
                    }
                }

                return {
                    esModule: esModule,
                    exports: scriptExports,
                    options: options
                };
            };

            /***/
        },
        /* 1 */
        /***/function (module, exports, __webpack_require__) {

            "use strict";

            exports.__esModule = true;

            var _defineProperty = __webpack_require__(102);

            var _defineProperty2 = _interopRequireDefault(_defineProperty);

            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : { default: obj };
            }

            exports.default = function (obj, key, value) {
                if (key in obj) {
                    (0, _defineProperty2.default)(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }

                return obj;
            };

            /***/
        },
        /* 2 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";
            /* harmony export (binding) */
            __webpack_require__.d(__webpack_exports__, "b", function () {
                return setOptions;
            });
            var config = {
                defaultContainerElement: null,
                defaultIconPack: 'mdi',
                defaultIconComponent: null,
                defaultDialogConfirmText: null,
                defaultDialogCancelText: null,
                defaultSnackbarDuration: 3500,
                defaultSnackbarPosition: null,
                defaultToastDuration: 2000,
                defaultToastPosition: null,
                defaultNotificationDuration: 2000,
                defaultNotificationPosition: null,
                defaultTooltipType: 'is-primary',
                defaultTooltipAnimated: false,
                defaultInputAutocomplete: 'on',
                defaultDateFormatter: null,
                defaultDateParser: null,
                defaultDateCreator: null,
                defaultDayNames: null,
                defaultMonthNames: null,
                defaultFirstDayOfWeek: null,
                defaultUnselectableDaysOfWeek: null,
                defaultTimeFormatter: null,
                defaultTimeParser: null,
                defaultModalCanCancel: ['escape', 'x', 'outside', 'button'],
                defaultModalScroll: null,
                defaultDatepickerMobileNative: true,
                defaultTimepickerMobileNative: true,
                defaultNoticeQueue: true,
                defaultInputHasCounter: true,
                defaultUseHtml5Validation: true,
                defaultDropdownMobileModal: true,
                defaultFieldLabelPosition: null,
                defaultDatepickerYearsRange: [-100, 3],
                defaultDatepickerNearbyMonthDays: true,
                defaultDatepickerNearbySelectableMonthDays: false
            };

            /* harmony default export */__webpack_exports__["a"] = config;

            var setOptions = function setOptions(options) {
                config = options;
            };

            /***/
        },
        /* 3 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(106),
            /* template */
            __webpack_require__(107),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 4 */
        /***/function (module, exports, __webpack_require__) {

            var store = __webpack_require__(37)('wks');
            var uid = __webpack_require__(26);
            var _Symbol = __webpack_require__(8).Symbol;
            var USE_SYMBOL = typeof _Symbol == 'function';

            var $exports = module.exports = function (name) {
                return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
            };

            $exports.store = store;

            /***/
        },
        /* 5 */
        /***/function (module, exports, __webpack_require__) {

            module.exports = { "default": __webpack_require__(89), __esModule: true };

            /***/
        },
        /* 6 */
        /***/function (module, exports) {

            var core = module.exports = { version: '2.5.7' };
            if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


            /***/
        },
        /* 7 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";
            /* harmony export (immutable) */
            __webpack_exports__["a"] = getValueByPath;
            /* harmony export (immutable) */__webpack_exports__["b"] = indexOf;
            /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "c", function () {
                return isMobile;
            });
            /* harmony export (immutable) */__webpack_exports__["d"] = removeElement;
            /* unused harmony export escapeRegExpChars */
            /**
             * Get value of an object property/path even if it's nested
             */
            function getValueByPath(obj, path) {
                var value = path.split('.').reduce(function (o, i) {
                    return o[i];
                }, obj);
                return value;
            }

            /**
             * Extension of indexOf method by equality function if specified
             */
            function indexOf(array, obj, fn) {
                if (!array) return -1;

                if (!fn || typeof fn !== 'function') return array.indexOf(obj);

                for (var i = 0; i < array.length; i++) {
                    if (fn(array[i], obj)) {
                        return i;
                    }
                }

                return -1;
            }

            /**
             * Mobile detection
             * https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
             */
            var isMobile = {
                Android: function Android() {
                    return typeof window !== 'undefined' && window.navigator.userAgent.match(/Android/i);
                },
                BlackBerry: function BlackBerry() {
                    return typeof window !== 'undefined' && window.navigator.userAgent.match(/BlackBerry/i);
                },
                iOS: function iOS() {
                    return typeof window !== 'undefined' && window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
                },
                Opera: function Opera() {
                    return typeof window !== 'undefined' && window.navigator.userAgent.match(/Opera Mini/i);
                },
                Windows: function Windows() {
                    return typeof window !== 'undefined' && window.navigator.userAgent.match(/IEMobile/i);
                },
                any: function any() {
                    return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
                }
            };

            function removeElement(el) {
                if (typeof el.remove !== 'undefined') {
                    el.remove();
                } else if (typeof el.parentNode !== 'undefined') {
                    el.parentNode.removeChild(el);
                }
            }

            /**
             * Escape regex characters
             * http://stackoverflow.com/a/6969486
             */
            function escapeRegExpChars(value) {
                if (!value) return value;

                // eslint-disable-next-line
                return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
            }

            /***/
        },
        /* 8 */
        /***/function (module, exports) {

            // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
            var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
            // eslint-disable-next-line no-new-func
            : Function('return this')();
            if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


            /***/
        },
        /* 9 */
        /***/function (module, exports, __webpack_require__) {

            var anObject = __webpack_require__(15);
            var IE8_DOM_DEFINE = __webpack_require__(47);
            var toPrimitive = __webpack_require__(32);
            var dP = Object.defineProperty;

            exports.f = __webpack_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
                anObject(O);
                P = toPrimitive(P, true);
                anObject(Attributes);
                if (IE8_DOM_DEFINE) try {
                    return dP(O, P, Attributes);
                } catch (e) {/* empty */}
                if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
                if ('value' in Attributes) O[P] = Attributes.value;
                return O;
            };

            /***/
        },
        /* 10 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";
            /* harmony import */
            var __WEBPACK_IMPORTED_MODULE_0__utils_config__ = __webpack_require__(2);

            /* harmony default export */__webpack_exports__["a"] = {
                props: {
                    size: String,
                    expanded: Boolean,
                    loading: Boolean,
                    rounded: Boolean,
                    icon: String,
                    iconPack: String,
                    // Native options to use in HTML5 validation
                    autocomplete: String,
                    maxlength: [Number, String],
                    useHtml5Validation: {
                        type: Boolean,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_0__utils_config__["a" /* default */].defaultUseHtml5Validation;
                        }
                    },
                    validationMessage: String
                },
                data: function data() {
                    return {
                        isValid: true,
                        isFocused: false,
                        newIconPack: this.iconPack || __WEBPACK_IMPORTED_MODULE_0__utils_config__["a" /* default */].defaultIconPack
                    };
                },

                computed: {
                    /**
                     * Find parent Field, max 3 levels deep.
                     */
                    parentField: function parentField() {
                        var parent = this.$parent;
                        for (var i = 0; i < 3; i++) {
                            if (parent && !parent.$data._isField) {
                                parent = parent.$parent;
                            }
                        }
                        return parent;
                    },

                    /**
                     * Get the type prop from parent if it's a Field.
                     */
                    statusType: function statusType() {
                        if (!this.parentField) return;
                        if (!this.parentField.newType) return;
                        if (typeof this.parentField.newType === 'string') {
                            return this.parentField.newType;
                        } else {
                            for (var key in this.parentField.newType) {
                                if (this.parentField.newType[key]) {
                                    return key;
                                }
                            }
                        }
                    },

                    /**
                     * Get the message prop from parent if it's a Field.
                     */
                    statusMessage: function statusMessage() {
                        if (!this.parentField) return;

                        return this.parentField.newMessage;
                    },

                    /**
                     * Fix icon size for inputs, large was too big
                     */
                    iconSize: function iconSize() {
                        switch (this.size) {
                            case 'is-small':
                                return this.size;
                            case 'is-medium':
                                return;
                            case 'is-large':
                                return this.newIconPack === 'mdi' ? 'is-medium' : '';
                        }
                    }
                },
                methods: {
                    /**
                     * Focus method that work dynamically depending on the component.
                     */
                    focus: function focus() {
                        var _this = this;

                        if (this.$data._elementRef === undefined) return;

                        this.$nextTick(function () {
                            var el = _this.$el.querySelector(_this.$data._elementRef);
                            if (el) el.focus();
                        });
                    },
                    onBlur: function onBlur($event) {
                        this.isFocused = false;
                        this.$emit('blur', $event);
                        this.checkHtml5Validity();
                    },
                    onFocus: function onFocus($event) {
                        this.isFocused = true;
                        this.$emit('focus', $event);
                    },

                    /**
                     * Check HTML5 validation, set isValid property.
                     * If validation fail, send 'is-danger' type,
                     * and error message to parent if it's a Field.
                     */
                    checkHtml5Validity: function checkHtml5Validity() {
                        var _this2 = this;

                        if (!this.useHtml5Validation) return;

                        if (this.$refs[this.$data._elementRef] === undefined) return;

                        var el = this.$el.querySelector(this.$data._elementRef);

                        var type = null;
                        var message = null;
                        var isValid = true;
                        if (!el.checkValidity()) {
                            type = 'is-danger';
                            message = this.validationMessage || el.validationMessage;
                            isValid = false;
                        }
                        this.isValid = isValid;

                        this.$nextTick(function () {
                            if (_this2.parentField) {
                                // Set type only if not defined
                                if (!_this2.parentField.type) {
                                    _this2.parentField.newType = type;
                                }
                                // Set message only if not defined
                                if (!_this2.parentField.message) {
                                    _this2.parentField.newMessage = message;
                                }
                            }
                        });

                        return this.isValid;
                    }
                }
            };

            /***/
        },
        /* 11 */
        /***/function (module, exports, __webpack_require__) {

            module.exports = { "default": __webpack_require__(71), __esModule: true };

            /***/
        },
        /* 12 */
        /***/function (module, exports, __webpack_require__) {

            // Thank's IE8 for his funny defineProperty
            module.exports = !__webpack_require__(21)(function () {
                return Object.defineProperty({}, 'a', { get: function get() {
                        return 7;
                    } }).a != 7;
            });

            /***/
        },
        /* 13 */
        /***/function (module, exports) {

            var hasOwnProperty = {}.hasOwnProperty;
            module.exports = function (it, key) {
                return hasOwnProperty.call(it, key);
            };

            /***/
        },
        /* 14 */
        /***/function (module, exports, __webpack_require__) {

            var dP = __webpack_require__(9);
            var createDesc = __webpack_require__(22);
            module.exports = __webpack_require__(12) ? function (object, key, value) {
                return dP.f(object, key, createDesc(1, value));
            } : function (object, key, value) {
                object[key] = value;
                return object;
            };

            /***/
        },
        /* 15 */
        /***/function (module, exports, __webpack_require__) {

            var isObject = __webpack_require__(20);
            module.exports = function (it) {
                if (!isObject(it)) throw TypeError(it + ' is not an object!');
                return it;
            };

            /***/
        },
        /* 16 */
        /***/function (module, exports, __webpack_require__) {

            // to indexed object, toObject with fallback for non-array-like ES3 strings
            var IObject = __webpack_require__(50);
            var defined = __webpack_require__(34);
            module.exports = function (it) {
                return IObject(defined(it));
            };

            /***/
        },
        /* 17 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(105),
            /* template */
            __webpack_require__(108),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 18 */
        /***/function (module, exports) {

            module.exports = __WEBPACK_EXTERNAL_MODULE_18__;

            /***/
        },
        /* 19 */
        /***/function (module, exports, __webpack_require__) {

            var global = __webpack_require__(8);
            var core = __webpack_require__(6);
            var ctx = __webpack_require__(46);
            var hide = __webpack_require__(14);
            var has = __webpack_require__(13);
            var PROTOTYPE = 'prototype';

            var $export = function $export(type, name, source) {
                var IS_FORCED = type & $export.F;
                var IS_GLOBAL = type & $export.G;
                var IS_STATIC = type & $export.S;
                var IS_PROTO = type & $export.P;
                var IS_BIND = type & $export.B;
                var IS_WRAP = type & $export.W;
                var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
                var expProto = exports[PROTOTYPE];
                var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
                var key, own, out;
                if (IS_GLOBAL) source = name;
                for (key in source) {
                    // contains in native
                    own = !IS_FORCED && target && target[key] !== undefined;
                    if (own && has(exports, key)) continue;
                    // export native or passed
                    out = own ? target[key] : source[key];
                    // prevent global pollution for namespaces
                    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
                    // bind timers to global for call from export context
                    : IS_BIND && own ? ctx(out, global)
                    // wrap global constructors for prevent change them in library
                    : IS_WRAP && target[key] == out ? function (C) {
                        var F = function F(a, b, c) {
                            if (this instanceof C) {
                                switch (arguments.length) {
                                    case 0:
                                        return new C();
                                    case 1:
                                        return new C(a);
                                    case 2:
                                        return new C(a, b);
                                }return new C(a, b, c);
                            }return C.apply(this, arguments);
                        };
                        F[PROTOTYPE] = C[PROTOTYPE];
                        return F;
                        // make static versions for prototype methods
                    }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
                    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
                    if (IS_PROTO) {
                        (exports.virtual || (exports.virtual = {}))[key] = out;
                        // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
                        if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
                    }
                }
            };
            // type bitmap
            $export.F = 1; // forced
            $export.G = 2; // global
            $export.S = 4; // static
            $export.P = 8; // proto
            $export.B = 16; // bind
            $export.W = 32; // wrap
            $export.U = 64; // safe
            $export.R = 128; // real proto method for `library`
            module.exports = $export;

            /***/
        },
        /* 20 */
        /***/function (module, exports) {

            module.exports = function (it) {
                return (typeof it === 'undefined' ? 'undefined' : _typeof2(it)) === 'object' ? it !== null : typeof it === 'function';
            };

            /***/
        },
        /* 21 */
        /***/function (module, exports) {

            module.exports = function (exec) {
                try {
                    return !!exec();
                } catch (e) {
                    return true;
                }
            };

            /***/
        },
        /* 22 */
        /***/function (module, exports) {

            module.exports = function (bitmap, value) {
                return {
                    enumerable: !(bitmap & 1),
                    configurable: !(bitmap & 2),
                    writable: !(bitmap & 4),
                    value: value
                };
            };

            /***/
        },
        /* 23 */
        /***/function (module, exports) {

            module.exports = {};

            /***/
        },
        /* 24 */
        /***/function (module, exports, __webpack_require__) {

            // 19.1.2.14 / 15.2.3.14 Object.keys(O)
            var $keys = __webpack_require__(49);
            var enumBugKeys = __webpack_require__(38);

            module.exports = Object.keys || function keys(O) {
                return $keys(O, enumBugKeys);
            };

            /***/
        },
        /* 25 */
        /***/function (module, exports) {

            module.exports = true;

            /***/
        },
        /* 26 */
        /***/function (module, exports) {

            var id = 0;
            var px = Math.random();
            module.exports = function (key) {
                return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
            };

            /***/
        },
        /* 27 */
        /***/function (module, exports) {

            exports.f = {}.propertyIsEnumerable;

            /***/
        },
        /* 28 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(123),
            /* template */
            __webpack_require__(124),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 29 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(125),
            /* template */
            __webpack_require__(126),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 30 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(127),
            /* template */
            __webpack_require__(130),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 31 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(137),
            /* template */
            __webpack_require__(138),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 32 */
        /***/function (module, exports, __webpack_require__) {

            // 7.1.1 ToPrimitive(input [, PreferredType])
            var isObject = __webpack_require__(20);
            // instead of the ES6 spec version, we didn't implement @@toPrimitive case
            // and the second argument - flag - preferred type is a string
            module.exports = function (it, S) {
                if (!isObject(it)) return it;
                var fn, val;
                if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
                if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                throw TypeError("Can't convert object to primitive value");
            };

            /***/
        },
        /* 33 */
        /***/function (module, exports) {

            var toString = {}.toString;

            module.exports = function (it) {
                return toString.call(it).slice(8, -1);
            };

            /***/
        },
        /* 34 */
        /***/function (module, exports) {

            // 7.2.1 RequireObjectCoercible(argument)
            module.exports = function (it) {
                if (it == undefined) throw TypeError("Can't call method on  " + it);
                return it;
            };

            /***/
        },
        /* 35 */
        /***/function (module, exports) {

            // 7.1.4 ToInteger
            var ceil = Math.ceil;
            var floor = Math.floor;
            module.exports = function (it) {
                return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
            };

            /***/
        },
        /* 36 */
        /***/function (module, exports, __webpack_require__) {

            var shared = __webpack_require__(37)('keys');
            var uid = __webpack_require__(26);
            module.exports = function (key) {
                return shared[key] || (shared[key] = uid(key));
            };

            /***/
        },
        /* 37 */
        /***/function (module, exports, __webpack_require__) {

            var core = __webpack_require__(6);
            var global = __webpack_require__(8);
            var SHARED = '__core-js_shared__';
            var store = global[SHARED] || (global[SHARED] = {});

            (module.exports = function (key, value) {
                return store[key] || (store[key] = value !== undefined ? value : {});
            })('versions', []).push({
                version: core.version,
                mode: __webpack_require__(25) ? 'pure' : 'global',
                copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
            });

            /***/
        },
        /* 38 */
        /***/function (module, exports) {

            // IE 8- don't enum bug keys
            module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

            /***/
        },
        /* 39 */
        /***/function (module, exports) {

            exports.f = Object.getOwnPropertySymbols;

            /***/
        },
        /* 40 */
        /***/function (module, exports, __webpack_require__) {

            // 7.1.13 ToObject(argument)
            var defined = __webpack_require__(34);
            module.exports = function (it) {
                return Object(defined(it));
            };

            /***/
        },
        /* 41 */
        /***/function (module, exports, __webpack_require__) {

            "use strict";

            var $at = __webpack_require__(81)(true);

            // 21.1.3.27 String.prototype[@@iterator]()
            __webpack_require__(54)(String, 'String', function (iterated) {
                this._t = String(iterated); // target
                this._i = 0; // next index
                // 21.1.5.2.1 %StringIteratorPrototype%.next()
            }, function () {
                var O = this._t;
                var index = this._i;
                var point;
                if (index >= O.length) return { value: undefined, done: true };
                point = $at(O, index);
                this._i += point.length;
                return { value: point, done: false };
            });

            /***/
        },
        /* 42 */
        /***/function (module, exports, __webpack_require__) {

            var def = __webpack_require__(9).f;
            var has = __webpack_require__(13);
            var TAG = __webpack_require__(4)('toStringTag');

            module.exports = function (it, tag, stat) {
                if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
            };

            /***/
        },
        /* 43 */
        /***/function (module, exports, __webpack_require__) {

            exports.f = __webpack_require__(4);

            /***/
        },
        /* 44 */
        /***/function (module, exports, __webpack_require__) {

            var global = __webpack_require__(8);
            var core = __webpack_require__(6);
            var LIBRARY = __webpack_require__(25);
            var wksExt = __webpack_require__(43);
            var defineProperty = __webpack_require__(9).f;
            module.exports = function (name) {
                var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
                if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
            };

            /***/
        },
        /* 45 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";
            /* harmony import */
            var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(2);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(7);

            /* harmony default export */__webpack_exports__["a"] = {
                props: {
                    type: {
                        type: String,
                        default: 'is-dark'
                    },
                    message: String,
                    duration: Number,
                    queue: {
                        type: Boolean,
                        default: undefined
                    },
                    position: {
                        type: String,
                        default: 'is-top',
                        validator: function validator(value) {
                            return ['is-top-right', 'is-top', 'is-top-left', 'is-bottom-right', 'is-bottom', 'is-bottom-left'].indexOf(value) > -1;
                        }
                    },
                    container: String
                },
                data: function data() {
                    return {
                        isActive: false,
                        parentTop: null,
                        parentBottom: null,
                        newContainer: this.container || __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].defaultContainerElement
                    };
                },

                computed: {
                    correctParent: function correctParent() {
                        switch (this.position) {
                            case 'is-top-right':
                            case 'is-top':
                            case 'is-top-left':
                                return this.parentTop;

                            case 'is-bottom-right':
                            case 'is-bottom':
                            case 'is-bottom-left':
                                return this.parentBottom;
                        }
                    },
                    transition: function transition() {
                        switch (this.position) {
                            case 'is-top-right':
                            case 'is-top':
                            case 'is-top-left':
                                return {
                                    enter: 'fadeInDown',
                                    leave: 'fadeOut'
                                };
                            case 'is-bottom-right':
                            case 'is-bottom':
                            case 'is-bottom-left':
                                return {
                                    enter: 'fadeInUp',
                                    leave: 'fadeOut'
                                };
                        }
                    }
                },
                methods: {
                    shouldQueue: function shouldQueue() {
                        var queue = this.queue !== undefined ? this.queue : __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].defaultNoticeQueue;

                        if (!queue) return false;

                        return this.parentTop.childElementCount > 0 || this.parentBottom.childElementCount > 0;
                    },
                    close: function close() {
                        var _this = this;

                        clearTimeout(this.timer);
                        this.isActive = false;

                        // Timeout for the animation complete before destroying
                        setTimeout(function () {
                            _this.$destroy();
                            Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* removeElement */])(_this.$el);
                        }, 150);
                    },
                    showNotice: function showNotice() {
                        var _this2 = this;

                        if (this.shouldQueue()) {
                            // Call recursively if should queue
                            setTimeout(function () {
                                return _this2.showNotice();
                            }, 250);
                            return;
                        }
                        this.correctParent.insertAdjacentElement('afterbegin', this.$el);
                        this.isActive = true;

                        if (!this.indefinite) {
                            this.timer = setTimeout(function () {
                                return _this2.close();
                            }, this.newDuration);
                        }
                    },
                    setupContainer: function setupContainer() {
                        this.parentTop = document.querySelector('.notices.is-top');
                        this.parentBottom = document.querySelector('.notices.is-bottom');

                        if (this.parentTop && this.parentBottom) return;

                        if (!this.parentTop) {
                            this.parentTop = document.createElement('div');
                            this.parentTop.className = 'notices is-top';
                        }

                        if (!this.parentBottom) {
                            this.parentBottom = document.createElement('div');
                            this.parentBottom.className = 'notices is-bottom';
                        }

                        var container = document.querySelector(this.newContainer) || document.body;

                        container.appendChild(this.parentTop);
                        container.appendChild(this.parentBottom);

                        if (this.newContainer) {
                            this.parentTop.classList.add('has-custom-container');
                            this.parentBottom.classList.add('has-custom-container');
                        }
                    }
                },
                beforeMount: function beforeMount() {
                    this.setupContainer();
                },
                mounted: function mounted() {
                    this.showNotice();
                }
            };

            /***/
        },
        /* 46 */
        /***/function (module, exports, __webpack_require__) {

            // optional / simple context binding
            var aFunction = __webpack_require__(73);
            module.exports = function (fn, that, length) {
                aFunction(fn);
                if (that === undefined) return fn;
                switch (length) {
                    case 1:
                        return function (a) {
                            return fn.call(that, a);
                        };
                    case 2:
                        return function (a, b) {
                            return fn.call(that, a, b);
                        };
                    case 3:
                        return function (a, b, c) {
                            return fn.call(that, a, b, c);
                        };
                }
                return function () /* ...args */{
                    return fn.apply(that, arguments);
                };
            };

            /***/
        },
        /* 47 */
        /***/function (module, exports, __webpack_require__) {

            module.exports = !__webpack_require__(12) && !__webpack_require__(21)(function () {
                return Object.defineProperty(__webpack_require__(48)('div'), 'a', { get: function get() {
                        return 7;
                    } }).a != 7;
            });

            /***/
        },
        /* 48 */
        /***/function (module, exports, __webpack_require__) {

            var isObject = __webpack_require__(20);
            var document = __webpack_require__(8).document;
            // typeof document.createElement is 'object' in old IE
            var is = isObject(document) && isObject(document.createElement);
            module.exports = function (it) {
                return is ? document.createElement(it) : {};
            };

            /***/
        },
        /* 49 */
        /***/function (module, exports, __webpack_require__) {

            var has = __webpack_require__(13);
            var toIObject = __webpack_require__(16);
            var arrayIndexOf = __webpack_require__(75)(false);
            var IE_PROTO = __webpack_require__(36)('IE_PROTO');

            module.exports = function (object, names) {
                var O = toIObject(object);
                var i = 0;
                var result = [];
                var key;
                for (key in O) {
                    if (key != IE_PROTO) has(O, key) && result.push(key);
                } // Don't enum bug & hidden keys
                while (names.length > i) {
                    if (has(O, key = names[i++])) {
                        ~arrayIndexOf(result, key) || result.push(key);
                    }
                }return result;
            };

            /***/
        },
        /* 50 */
        /***/function (module, exports, __webpack_require__) {

            // fallback for non-array-like ES3 and non-enumerable old V8 strings
            var cof = __webpack_require__(33);
            // eslint-disable-next-line no-prototype-builtins
            module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
                return cof(it) == 'String' ? it.split('') : Object(it);
            };

            /***/
        },
        /* 51 */
        /***/function (module, exports, __webpack_require__) {

            // 7.1.15 ToLength
            var toInteger = __webpack_require__(35);
            var min = Math.min;
            module.exports = function (it) {
                return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
            };

            /***/
        },
        /* 52 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(78),
            /* template */
            __webpack_require__(109),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 53 */
        /***/function (module, exports, __webpack_require__) {

            "use strict";

            exports.__esModule = true;

            var _iterator = __webpack_require__(79);

            var _iterator2 = _interopRequireDefault(_iterator);

            var _symbol = __webpack_require__(5);

            var _symbol2 = _interopRequireDefault(_symbol);

            var _typeof = typeof _symbol2.default === "function" && _typeof2(_iterator2.default) === "symbol" ? function (obj) {
                return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
            } : function (obj) {
                return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
            };

            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : { default: obj };
            }

            exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
                return typeof obj === "undefined" ? "undefined" : _typeof(obj);
            } : function (obj) {
                return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
            };

            /***/
        },
        /* 54 */
        /***/function (module, exports, __webpack_require__) {

            "use strict";

            var LIBRARY = __webpack_require__(25);
            var $export = __webpack_require__(19);
            var redefine = __webpack_require__(55);
            var hide = __webpack_require__(14);
            var Iterators = __webpack_require__(23);
            var $iterCreate = __webpack_require__(82);
            var setToStringTag = __webpack_require__(42);
            var getPrototypeOf = __webpack_require__(85);
            var ITERATOR = __webpack_require__(4)('iterator');
            var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
            var FF_ITERATOR = '@@iterator';
            var KEYS = 'keys';
            var VALUES = 'values';

            var returnThis = function returnThis() {
                return this;
            };

            module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
                $iterCreate(Constructor, NAME, next);
                var getMethod = function getMethod(kind) {
                    if (!BUGGY && kind in proto) return proto[kind];
                    switch (kind) {
                        case KEYS:
                            return function keys() {
                                return new Constructor(this, kind);
                            };
                        case VALUES:
                            return function values() {
                                return new Constructor(this, kind);
                            };
                    }return function entries() {
                        return new Constructor(this, kind);
                    };
                };
                var TAG = NAME + ' Iterator';
                var DEF_VALUES = DEFAULT == VALUES;
                var VALUES_BUG = false;
                var proto = Base.prototype;
                var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
                var $default = $native || getMethod(DEFAULT);
                var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
                var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
                var methods, key, IteratorPrototype;
                // Fix native
                if ($anyNative) {
                    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
                    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
                        // Set @@toStringTag to native iterators
                        setToStringTag(IteratorPrototype, TAG, true);
                        // fix for some old engines
                        if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
                    }
                }
                // fix Array#{values, @@iterator}.name in V8 / FF
                if (DEF_VALUES && $native && $native.name !== VALUES) {
                    VALUES_BUG = true;
                    $default = function values() {
                        return $native.call(this);
                    };
                }
                // Define iterator
                if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
                    hide(proto, ITERATOR, $default);
                }
                // Plug for library
                Iterators[NAME] = $default;
                Iterators[TAG] = returnThis;
                if (DEFAULT) {
                    methods = {
                        values: DEF_VALUES ? $default : getMethod(VALUES),
                        keys: IS_SET ? $default : getMethod(KEYS),
                        entries: $entries
                    };
                    if (FORCED) for (key in methods) {
                        if (!(key in proto)) redefine(proto, key, methods[key]);
                    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
                }
                return methods;
            };

            /***/
        },
        /* 55 */
        /***/function (module, exports, __webpack_require__) {

            module.exports = __webpack_require__(14);

            /***/
        },
        /* 56 */
        /***/function (module, exports, __webpack_require__) {

            // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
            var anObject = __webpack_require__(15);
            var dPs = __webpack_require__(83);
            var enumBugKeys = __webpack_require__(38);
            var IE_PROTO = __webpack_require__(36)('IE_PROTO');
            var Empty = function Empty() {/* empty */};
            var PROTOTYPE = 'prototype';

            // Create object with fake `null` prototype: use iframe Object with cleared prototype
            var _createDict = function createDict() {
                // Thrash, waste and sodomy: IE GC bug
                var iframe = __webpack_require__(48)('iframe');
                var i = enumBugKeys.length;
                var lt = '<';
                var gt = '>';
                var iframeDocument;
                iframe.style.display = 'none';
                __webpack_require__(84).appendChild(iframe);
                iframe.src = 'javascript:'; // eslint-disable-line no-script-url
                // createDict = iframe.contentWindow.Object;
                // html.removeChild(iframe);
                iframeDocument = iframe.contentWindow.document;
                iframeDocument.open();
                iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
                iframeDocument.close();
                _createDict = iframeDocument.F;
                while (i--) {
                    delete _createDict[PROTOTYPE][enumBugKeys[i]];
                }return _createDict();
            };

            module.exports = Object.create || function create(O, Properties) {
                var result;
                if (O !== null) {
                    Empty[PROTOTYPE] = anObject(O);
                    result = new Empty();
                    Empty[PROTOTYPE] = null;
                    // add "__proto__" for Object.getPrototypeOf polyfill
                    result[IE_PROTO] = O;
                } else result = _createDict();
                return Properties === undefined ? result : dPs(result, Properties);
            };

            /***/
        },
        /* 57 */
        /***/function (module, exports, __webpack_require__) {

            __webpack_require__(86);
            var global = __webpack_require__(8);
            var hide = __webpack_require__(14);
            var Iterators = __webpack_require__(23);
            var TO_STRING_TAG = __webpack_require__(4)('toStringTag');

            var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

            for (var i = 0; i < DOMIterables.length; i++) {
                var NAME = DOMIterables[i];
                var Collection = global[NAME];
                var proto = Collection && Collection.prototype;
                if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
                Iterators[NAME] = Iterators.Array;
            }

            /***/
        },
        /* 58 */
        /***/function (module, exports, __webpack_require__) {

            // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
            var $keys = __webpack_require__(49);
            var hiddenKeys = __webpack_require__(38).concat('length', 'prototype');

            exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                return $keys(O, hiddenKeys);
            };

            /***/
        },
        /* 59 */
        /***/function (module, exports, __webpack_require__) {

            module.exports = { "default": __webpack_require__(99), __esModule: true };

            /***/
        },
        /* 60 */
        /***/function (module, exports, __webpack_require__) {

            var classof = __webpack_require__(101);
            var ITERATOR = __webpack_require__(4)('iterator');
            var Iterators = __webpack_require__(23);
            module.exports = __webpack_require__(6).getIteratorMethod = function (it) {
                if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
            };

            /***/
        },
        /* 61 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(113),
            /* template */
            __webpack_require__(114),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 62 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";
            /* harmony import */
            var __WEBPACK_IMPORTED_MODULE_0__FormElementMixin__ = __webpack_require__(10);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(7);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(2);

            var AM = 'AM';
            var PM = 'PM';
            var HOUR_FORMAT_24 = '24';
            var HOUR_FORMAT_12 = '12';

            var defaultTimeFormatter = function defaultTimeFormatter(date, vm) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var period = '';
                if (vm.hourFormat === HOUR_FORMAT_12) {
                    period = ' ' + (hours < 12 ? AM : PM);
                    if (hours > 12) {
                        hours -= 12;
                    } else if (hours === 0) {
                        hours = 12;
                    }
                }
                return vm.pad(hours) + ':' + vm.pad(minutes) + (vm.enableSeconds ? ':' + vm.pad(seconds) : '') + period;
            };

            var defaultTimeParser = function defaultTimeParser(timeString, vm) {
                if (timeString) {
                    var am = false;
                    if (vm.hourFormat === HOUR_FORMAT_12) {
                        var dateString12 = timeString.split(' ');
                        timeString = dateString12[0];
                        am = dateString12[1] === AM;
                    }
                    var time = timeString.split(':');
                    var hours = parseInt(time[0], 10);
                    var minutes = parseInt(time[1], 10);
                    var seconds = vm.enableSeconds ? parseInt(time[2], 10) : 0;
                    if (isNaN(hours) || hours < 0 || hours > 23 || vm.hourFormat === HOUR_FORMAT_12 && (hours < 1 || hours > 12) || isNaN(minutes) || minutes < 0 || minutes > 59) {
                        return null;
                    }
                    var d = null;
                    if (vm.computedValue && !isNaN(vm.computedValue)) {
                        d = new Date(vm.computedValue);
                    } else {
                        d = new Date();
                        d.setMilliseconds(0);
                    }
                    d.setSeconds(seconds);
                    d.setMinutes(minutes);
                    if (vm.hourFormat === HOUR_FORMAT_12) {
                        if (am && hours === 12) {
                            hours = 0;
                        } else if (!am && hours !== 12) {
                            hours += 12;
                        }
                    }
                    d.setHours(hours);
                    return new Date(d.getTime());
                }
                return null;
            };

            /* harmony default export */__webpack_exports__["a"] = {
                mixins: [__WEBPACK_IMPORTED_MODULE_0__FormElementMixin__["a" /* default */]],
                inheritAttrs: false,
                props: {
                    value: Date,
                    inline: Boolean,
                    minTime: Date,
                    maxTime: Date,
                    placeholder: String,
                    editable: Boolean,
                    disabled: Boolean,
                    hourFormat: {
                        type: String,
                        default: HOUR_FORMAT_24,
                        validator: function validator(value) {
                            return value === HOUR_FORMAT_24 || value === HOUR_FORMAT_12;
                        }
                    },
                    incrementMinutes: {
                        type: Number,
                        default: 1
                    },
                    incrementSeconds: {
                        type: Number,
                        default: 1
                    },
                    timeFormatter: {
                        type: Function,
                        default: function _default(date, vm) {
                            if (typeof __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].defaultTimeFormatter === 'function') {
                                return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].defaultTimeFormatter(date);
                            } else {
                                return defaultTimeFormatter(date, vm);
                            }
                        }
                    },
                    timeParser: {
                        type: Function,
                        default: function _default(date, vm) {
                            if (typeof __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].defaultTimeParser === 'function') {
                                return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].defaultTimeParser(date);
                            } else {
                                return defaultTimeParser(date, vm);
                            }
                        }
                    },
                    mobileNative: {
                        type: Boolean,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].defaultTimepickerMobileNative;
                        }
                    },
                    position: String,
                    unselectableTimes: Array,
                    openOnFocus: Boolean,
                    enableSeconds: Boolean
                },
                data: function data() {
                    return {
                        dateSelected: this.value,
                        hoursSelected: null,
                        minutesSelected: null,
                        secondsSelected: null,
                        meridienSelected: null,
                        _elementRef: 'input',
                        AM: AM,
                        PM: PM,
                        HOUR_FORMAT_24: HOUR_FORMAT_24,
                        HOUR_FORMAT_12: HOUR_FORMAT_12
                    };
                },

                computed: {
                    computedValue: {
                        get: function get() {
                            return this.dateSelected;
                        },
                        set: function set(value) {
                            this.dateSelected = value;
                            this.$emit('input', value);
                        }
                    },
                    hours: function hours() {
                        var hours = [];
                        var numberOfHours = this.isHourFormat24 ? 24 : 12;
                        for (var i = 0; i < numberOfHours; i++) {
                            var value = i;
                            var label = value;
                            if (!this.isHourFormat24) {
                                value = i + 1;
                                label = value;
                                if (this.meridienSelected === this.AM) {
                                    if (value === 12) {
                                        value = 0;
                                    }
                                } else if (this.meridienSelected === this.PM) {
                                    if (value !== 12) {
                                        value += 12;
                                    }
                                }
                            }
                            hours.push({
                                label: this.formatNumber(label),
                                value: value
                            });
                        }
                        return hours;
                    },
                    minutes: function minutes() {
                        var minutes = [];
                        for (var i = 0; i < 60; i += this.incrementMinutes) {
                            minutes.push({
                                label: this.formatNumber(i),
                                value: i
                            });
                        }
                        return minutes;
                    },
                    seconds: function seconds() {
                        var seconds = [];
                        for (var i = 0; i < 60; i += this.incrementSeconds) {
                            seconds.push({
                                label: this.formatNumber(i),
                                value: i
                            });
                        }
                        return seconds;
                    },
                    meridiens: function meridiens() {
                        return [AM, PM];
                    },
                    isMobile: function isMobile() {
                        return this.mobileNative && __WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* isMobile */].any();
                    },
                    isHourFormat24: function isHourFormat24() {
                        return this.hourFormat === HOUR_FORMAT_24;
                    }
                },
                watch: {
                    hourFormat: function hourFormat() {
                        if (this.hoursSelected !== null) {
                            this.meridienSelected = this.hoursSelected >= 12 ? PM : AM;
                        }
                    },

                    /**
                     * When v-model is changed:
                     *   1. Update internal value.
                     *   2. If it's invalid, validate again.
                     */
                    value: {
                        handler: function handler(value) {
                            this.updateInternalState(value);
                            !this.isValid && this.$refs.input.checkHtml5Validity();
                        },

                        immediate: true
                    }
                },
                methods: {
                    onMeridienChange: function onMeridienChange(value) {
                        if (this.hoursSelected !== null) {
                            if (value === PM) {
                                this.hoursSelected += 12;
                            } else if (value === AM) {
                                this.hoursSelected -= 12;
                            }
                        }
                        this.updateDateSelected(this.hoursSelected, this.minutesSelected, this.enableSeconds ? this.secondsSelected : 0, value);
                    },
                    onHoursChange: function onHoursChange(value) {
                        this.updateDateSelected(parseInt(value, 10), this.minutesSelected, this.enableSeconds ? this.secondsSelected : 0, this.meridienSelected);
                    },
                    onMinutesChange: function onMinutesChange(value) {
                        this.updateDateSelected(this.hoursSelected, parseInt(value, 10), this.enableSeconds ? this.secondsSelected : 0, this.meridienSelected);
                    },
                    onSecondsChange: function onSecondsChange(value) {
                        this.updateDateSelected(this.hoursSelected, this.minutesSelected, parseInt(value, 10), this.meridienSelected);
                    },
                    updateDateSelected: function updateDateSelected(hours, minutes, seconds, meridiens) {
                        if (hours != null && minutes != null && (!this.isHourFormat24 && meridiens !== null || this.isHourFormat24)) {
                            var time = null;
                            if (this.computedValue && !isNaN(this.computedValue)) {
                                time = new Date(this.computedValue);
                            } else {
                                time = new Date();
                                time.setMilliseconds(0);
                            }
                            time.setHours(hours);
                            time.setMinutes(minutes);
                            time.setSeconds(seconds);
                            this.computedValue = new Date(time.getTime());
                        }
                    },
                    updateInternalState: function updateInternalState(value) {
                        if (value) {
                            this.hoursSelected = value.getHours();
                            this.minutesSelected = value.getMinutes();
                            this.secondsSelected = value.getSeconds();
                            this.meridienSelected = value.getHours() >= 12 ? PM : AM;
                        } else {
                            this.hoursSelected = null;
                            this.minutesSelected = null;
                            this.secondsSelected = null;
                            this.meridienSelected = AM;
                        }
                        this.dateSelected = value;
                    },
                    isHourDisabled: function isHourDisabled(hour) {
                        var _this = this;

                        var disabled = false;
                        if (this.minTime) {
                            var minHours = this.minTime.getHours();
                            disabled = hour < minHours;
                        }
                        if (this.maxTime) {
                            if (!disabled) {
                                var maxHours = this.maxTime.getHours();
                                disabled = hour > maxHours;
                            }
                        }
                        if (this.unselectableTimes) {
                            if (!disabled) {
                                var unselectable = this.unselectableTimes.filter(function (time) {
                                    if (_this.enableSeconds && _this.secondsSelected !== null) {
                                        return time.getHours() === hour && time.getMinutes() === _this.minutesSelected && time.getSeconds() === _this.secondsSelected;
                                    } else if (_this.minutesSelected !== null) {
                                        return time.getHours() === hour && time.getMinutes() === _this.minutesSelected;
                                    } else {
                                        return time.getHours() === hour;
                                    }
                                });
                                disabled = unselectable.length > 0;
                            }
                        }
                        return disabled;
                    },
                    isMinuteDisabled: function isMinuteDisabled(minute) {
                        var _this2 = this;

                        var disabled = false;
                        if (this.hoursSelected !== null) {
                            if (this.isHourDisabled(this.hoursSelected)) {
                                disabled = true;
                            } else {
                                if (this.minTime) {
                                    var minHours = this.minTime.getHours();
                                    var minMinutes = this.minTime.getMinutes();
                                    disabled = this.hoursSelected === minHours && minute < minMinutes;
                                }
                                if (this.maxTime) {
                                    if (!disabled) {
                                        var maxHours = this.maxTime.getHours();
                                        var maxMinutes = this.maxTime.getMinutes();
                                        disabled = this.hoursSelected === maxHours && minute > maxMinutes;
                                    }
                                }
                            }
                            if (this.unselectableTimes) {
                                if (!disabled) {
                                    var unselectable = this.unselectableTimes.filter(function (time) {
                                        if (_this2.enableSeconds && _this2.secondsSelected !== null) {
                                            return time.getHours() === _this2.hoursSelected && time.getMinutes() === minute && time.getSeconds() === _this2.secondsSelected;
                                        } else {
                                            return time.getHours() === _this2.hoursSelected && time.getMinutes() === minute;
                                        }
                                    });
                                    disabled = unselectable.length > 0;
                                }
                            }
                        }
                        return disabled;
                    },
                    isSecondDisabled: function isSecondDisabled(second) {
                        var _this3 = this;

                        var disabled = false;
                        if (this.minutesSelected !== null) {
                            if (this.isMinuteDisabled(this.minutesSelected)) {
                                disabled = true;
                            } else {
                                if (this.minTime) {
                                    var minHours = this.minTime.getHours();
                                    var minMinutes = this.minTime.getMinutes();
                                    var minSeconds = this.minTime.getSeconds();
                                    disabled = this.hoursSelected === minHours && this.minutesSelected === minMinutes && second < minSeconds;
                                }
                                if (this.maxTime) {
                                    if (!disabled) {
                                        var maxHours = this.maxTime.getHours();
                                        var maxMinutes = this.maxTime.getMinutes();
                                        var maxSeconds = this.maxTime.getSeconds();
                                        disabled = this.hoursSelected === maxHours && this.minutesSelected === maxMinutes && second > maxSeconds;
                                    }
                                }
                            }
                            if (this.unselectableTimes) {
                                if (!disabled) {
                                    var unselectable = this.unselectableTimes.filter(function (time) {
                                        return time.getHours() === _this3.hoursSelected && time.getMinutes() === _this3.minutesSelected && time.getSeconds() === second;
                                    });
                                    disabled = unselectable.length > 0;
                                }
                            }
                        }
                        return disabled;
                    },

                    /*
                    * Parse string into date
                    */
                    onChange: function onChange(value) {
                        var date = this.timeParser(value, this);
                        this.updateInternalState(date);
                        if (date && !isNaN(date)) {
                            this.computedValue = date;
                        } else {
                            // Force refresh input value when not valid date
                            this.computedValue = null;
                            this.$refs.input.newValue = this.computedValue;
                        }
                    },

                    /*
                    * Toggle timepicker
                    */
                    toggle: function toggle(active) {
                        if (this.$refs.dropdown) {
                            this.$refs.dropdown.isActive = typeof active === 'boolean' ? active : !this.$refs.dropdown.isActive;
                        }
                    },

                    /*
                    * Close timepicker
                    */
                    close: function close() {
                        this.toggle(false);
                    },

                    /*
                    * Call default onFocus method and show timepicker
                    */
                    handleOnFocus: function handleOnFocus() {
                        this.onFocus();
                        if (this.openOnFocus) {
                            this.toggle(true);
                        }
                    },

                    /*
                    * Format date into string 'HH-MM-SS'
                    */
                    formatHHMMSS: function formatHHMMSS(value) {
                        var date = new Date(value);
                        if (value && !isNaN(date)) {
                            var hours = date.getHours();
                            var minutes = date.getMinutes();
                            var seconds = date.getSeconds();
                            return this.formatNumber(hours) + ':' + this.formatNumber(minutes, true) + ':' + this.formatNumber(seconds, true);
                        }
                        return '';
                    },

                    /*
                    * Parse time from string
                    */
                    onChangeNativePicker: function onChangeNativePicker(event) {
                        var date = event.target.value;
                        if (date) {
                            var time = null;
                            if (this.computedValue && !isNaN(this.computedValue)) {
                                time = new Date(this.computedValue);
                            } else {
                                time = new Date();
                                time.setMilliseconds(0);
                            }
                            var t = date.split(':');
                            time.setHours(parseInt(t[0], 10));
                            time.setMinutes(parseInt(t[1], 10));
                            time.setSeconds(t[2] ? parseInt(t[2], 10) : 0);
                            this.computedValue = new Date(time.getTime());
                        } else {
                            this.computedValue = null;
                        }
                    },
                    formatNumber: function formatNumber(value, isMinute) {
                        return this.isHourFormat24 || isMinute ? this.pad(value) : value;
                    },
                    pad: function pad(value) {
                        return (value < 10 ? '0' : '') + value;
                    },

                    /*
                    * Format date into string
                    */
                    formatValue: function formatValue(date) {
                        if (date && !isNaN(date)) {
                            return this.timeFormatter(date, this);
                        } else {
                            return null;
                        }
                    },

                    /**
                     * Keypress event that is bound to the document.
                     */
                    keyPress: function keyPress(event) {
                        // Esc key
                        if (this.$refs.dropdown && this.$refs.dropdown.isActive && event.keyCode === 27) {
                            this.toggle(false);
                        }
                    }
                },
                created: function created() {
                    if (typeof window !== 'undefined') {
                        document.addEventListener('keyup', this.keyPress);
                    }
                },
                beforeDestroy: function beforeDestroy() {
                    if (typeof window !== 'undefined') {
                        document.removeEventListener('keyup', this.keyPress);
                    }
                }
            };

            /***/
        },
        /* 63 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(151),
            /* template */
            __webpack_require__(152),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 64 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";
            /* unused harmony export isSSR */
            /* harmony export (binding) */
            __webpack_require__.d(__webpack_exports__, "b", function () {
                return HTMLElement;
            });
            /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
                return File;
            });
            // Polyfills for SSR

            var isSSR = typeof window === 'undefined';

            var HTMLElement = isSSR ? Object : window.HTMLElement;
            var File = isSSR ? Object : window.File;

            /***/
        },
        /* 65 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";
            /* harmony import */
            var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__components_icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__components_icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_icon_Icon__);

            /* harmony default export */__webpack_exports__["a"] = {
                components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_1__components_icon_Icon___default.a),
                props: {
                    active: {
                        type: Boolean,
                        default: true
                    },
                    title: String,
                    closable: {
                        type: Boolean,
                        default: true
                    },
                    message: String,
                    type: String,
                    hasIcon: Boolean,
                    size: String,
                    iconPack: String,
                    iconSize: String,
                    autoClose: {
                        type: Boolean,
                        default: false
                    },
                    duration: {
                        type: Number,
                        default: 2000
                    }
                },
                data: function data() {
                    return {
                        isActive: this.active
                    };
                },

                watch: {
                    active: function active(value) {
                        this.isActive = value;
                    },
                    isActive: function isActive(value) {
                        if (value) {
                            this.setAutoClose();
                        } else {
                            if (this.timer) {
                                clearTimeout(this.timer);
                            }
                        }
                    }
                },
                computed: {
                    /**
                     * Icon name (MDI) based on type.
                     */
                    icon: function icon() {
                        switch (this.type) {
                            case 'is-info':
                                return 'information';
                            case 'is-success':
                                return 'check-circle';
                            case 'is-warning':
                                return 'alert';
                            case 'is-danger':
                                return 'alert-circle';
                            default:
                                return null;
                        }
                    }
                },
                methods: {
                    /**
                     * Close the Message and emit events.
                     */
                    close: function close() {
                        this.isActive = false;
                        this.$emit('close');
                        this.$emit('update:active', false);
                    },

                    /**
                     * Set timer to auto close message
                     */
                    setAutoClose: function setAutoClose() {
                        var _this = this;

                        if (this.autoClose) {
                            this.timer = setTimeout(function () {
                                if (_this.isActive) {
                                    _this.close();
                                }
                            }, this.duration);
                        }
                    }
                },
                mounted: function mounted() {
                    this.setAutoClose();
                }
            };

            /***/
        },
        /* 66 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(177),
            /* template */
            __webpack_require__(178),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 67 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";
            /* harmony default export */
            __webpack_exports__["a"] = {
                name: 'BSlotComponent',
                props: {
                    component: {
                        type: Object,
                        required: true
                    },
                    name: {
                        type: String,
                        default: 'default'
                    },
                    tag: {
                        type: String,
                        default: 'div'
                    },
                    event: {
                        type: String,
                        default: 'hook:updated'
                    }
                },
                methods: {
                    refresh: function refresh() {
                        this.$forceUpdate();
                    },
                    isVueComponent: function isVueComponent() {
                        return this.component && this.component._isVue;
                    }
                },
                created: function created() {
                    if (this.isVueComponent()) {
                        this.component.$on(this.event, this.refresh);
                    }
                },
                beforeDestroy: function beforeDestroy() {
                    if (this.isVueComponent()) {
                        this.component.$off(this.event, this.refresh);
                    }
                },
                render: function render(createElement) {
                    if (this.isVueComponent()) {
                        var slots = this.component.$slots[this.name];
                        return createElement(this.tag, {}, slots);
                    }
                }
            };

            /***/
        },
        /* 68 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(209),
            /* template */
            __webpack_require__(210),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 69 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(217),
            /* template */
            __webpack_require__(218),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 70 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            var components_namespaceObject = {};
            __webpack_require__.d(components_namespaceObject, "Autocomplete", function () {
                return autocomplete;
            });
            __webpack_require__.d(components_namespaceObject, "Button", function () {
                return components_button;
            });
            __webpack_require__.d(components_namespaceObject, "Checkbox", function () {
                return components_checkbox;
            });
            __webpack_require__.d(components_namespaceObject, "Clockpicker", function () {
                return clockpicker;
            });
            __webpack_require__.d(components_namespaceObject, "Collapse", function () {
                return collapse;
            });
            __webpack_require__.d(components_namespaceObject, "Datepicker", function () {
                return datepicker;
            });
            __webpack_require__.d(components_namespaceObject, "Dialog", function () {
                return dialog;
            });
            __webpack_require__.d(components_namespaceObject, "Dropdown", function () {
                return dropdown;
            });
            __webpack_require__.d(components_namespaceObject, "Field", function () {
                return field;
            });
            __webpack_require__.d(components_namespaceObject, "Icon", function () {
                return icon;
            });
            __webpack_require__.d(components_namespaceObject, "Input", function () {
                return input;
            });
            __webpack_require__.d(components_namespaceObject, "Loading", function () {
                return loading;
            });
            __webpack_require__.d(components_namespaceObject, "Menu", function () {
                return menu;
            });
            __webpack_require__.d(components_namespaceObject, "Message", function () {
                return components_message;
            });
            __webpack_require__.d(components_namespaceObject, "Modal", function () {
                return modal;
            });
            __webpack_require__.d(components_namespaceObject, "Notification", function () {
                return notification;
            });
            __webpack_require__.d(components_namespaceObject, "Numberinput", function () {
                return numberinput;
            });
            __webpack_require__.d(components_namespaceObject, "Pagination", function () {
                return pagination;
            });
            __webpack_require__.d(components_namespaceObject, "Radio", function () {
                return components_radio;
            });
            __webpack_require__.d(components_namespaceObject, "Select", function () {
                return components_select;
            });
            __webpack_require__.d(components_namespaceObject, "Snackbar", function () {
                return snackbar;
            });
            __webpack_require__.d(components_namespaceObject, "Steps", function () {
                return steps;
            });
            __webpack_require__.d(components_namespaceObject, "Switch", function () {
                return components_switch;
            });
            __webpack_require__.d(components_namespaceObject, "Table", function () {
                return table;
            });
            __webpack_require__.d(components_namespaceObject, "Tabs", function () {
                return tabs;
            });
            __webpack_require__.d(components_namespaceObject, "Tag", function () {
                return tag;
            });
            __webpack_require__.d(components_namespaceObject, "Taginput", function () {
                return taginput;
            });
            __webpack_require__.d(components_namespaceObject, "Timepicker", function () {
                return timepicker;
            });
            __webpack_require__.d(components_namespaceObject, "Toast", function () {
                return toast;
            });
            __webpack_require__.d(components_namespaceObject, "Tooltip", function () {
                return tooltip;
            });
            __webpack_require__.d(components_namespaceObject, "Upload", function () {
                return upload;
            });

            // EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
            var object_assign = __webpack_require__(11);
            var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

            // EXTERNAL MODULE: ./src/scss/buefy-build.scss
            var buefy_build = __webpack_require__(77);
            var buefy_build_default = /*#__PURE__*/__webpack_require__.n(buefy_build);

            // EXTERNAL MODULE: ./src/components/autocomplete/Autocomplete.vue
            var Autocomplete = __webpack_require__(52);
            var Autocomplete_default = /*#__PURE__*/__webpack_require__.n(Autocomplete);

            // CONCATENATED MODULE: ./src/utils/plugins.js

            var use = function use(plugin) {
                if (typeof window !== 'undefined' && window.Vue) {
                    window.Vue.use(plugin);
                }
            };

            var registerComponent = function registerComponent(Vue, component) {
                Vue.component(component.name, component);
            };

            var registerComponentProgrammatic = function registerComponentProgrammatic(Vue, property, component) {
                Vue.prototype[property] = component;
            };
            // CONCATENATED MODULE: ./src/components/autocomplete/index.js


            var Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Autocomplete_default.a);
                }
            };

            use(Plugin);

            /* harmony default export */var autocomplete = Plugin;

            // EXTERNAL MODULE: ./src/components/button/Button.vue
            var Button = __webpack_require__(110);
            var Button_default = /*#__PURE__*/__webpack_require__.n(Button);

            // CONCATENATED MODULE: ./src/components/button/index.js


            var button_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Button_default.a);
                }
            };

            use(button_Plugin);

            /* harmony default export */var components_button = button_Plugin;

            // EXTERNAL MODULE: ./src/components/checkbox/Checkbox.vue
            var Checkbox = __webpack_require__(61);
            var Checkbox_default = /*#__PURE__*/__webpack_require__.n(Checkbox);

            // EXTERNAL MODULE: ./src/components/checkbox/CheckboxButton.vue
            var CheckboxButton = __webpack_require__(115);
            var CheckboxButton_default = /*#__PURE__*/__webpack_require__.n(CheckboxButton);

            // CONCATENATED MODULE: ./src/components/checkbox/index.js


            var checkbox_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Checkbox_default.a);
                    registerComponent(Vue, CheckboxButton_default.a);
                }
            };

            use(checkbox_Plugin);

            /* harmony default export */var components_checkbox = checkbox_Plugin;

            // EXTERNAL MODULE: ./src/components/collapse/Collapse.vue
            var Collapse = __webpack_require__(118);
            var Collapse_default = /*#__PURE__*/__webpack_require__.n(Collapse);

            // CONCATENATED MODULE: ./src/components/collapse/index.js


            var collapse_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Collapse_default.a);
                }
            };

            use(collapse_Plugin);

            /* harmony default export */var collapse = collapse_Plugin;

            // EXTERNAL MODULE: ./src/components/clockpicker/Clockpicker.vue
            var Clockpicker = __webpack_require__(121);
            var Clockpicker_default = /*#__PURE__*/__webpack_require__.n(Clockpicker);

            // CONCATENATED MODULE: ./src/components/clockpicker/index.js


            var clockpicker_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Clockpicker_default.a);
                }
            };

            use(clockpicker_Plugin);

            /* harmony default export */var clockpicker = clockpicker_Plugin;

            // EXTERNAL MODULE: ./src/components/datepicker/Datepicker.vue
            var Datepicker = __webpack_require__(135);
            var Datepicker_default = /*#__PURE__*/__webpack_require__.n(Datepicker);

            // CONCATENATED MODULE: ./src/components/datepicker/index.js


            var datepicker_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Datepicker_default.a);
                }
            };

            use(datepicker_Plugin);

            /* harmony default export */var datepicker = datepicker_Plugin;

            // EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","amd":"vue","root":"Vue"}
            var external___commonjs___vue___commonjs2___vue___amd___vue___root___Vue__ = __webpack_require__(18);
            var external___commonjs___vue___commonjs2___vue___amd___vue___root___Vue___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___vue___commonjs2___vue___amd___vue___root___Vue__);

            // EXTERNAL MODULE: ./src/components/dialog/Dialog.vue
            var Dialog = __webpack_require__(149);
            var Dialog_default = /*#__PURE__*/__webpack_require__.n(Dialog);

            // CONCATENATED MODULE: ./src/components/dialog/index.js


            function dialog_open(propsData) {
                var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : external___commonjs___vue___commonjs2___vue___amd___vue___root___Vue___default.a;
                var DialogComponent = vm.extend(Dialog_default.a);
                return new DialogComponent({
                    el: document.createElement('div'),
                    propsData: propsData
                });
            }

            var DialogProgrammatic = {
                alert: function alert(params) {
                    var message = void 0;
                    if (typeof params === 'string') message = params;
                    var defaultParam = {
                        canCancel: false,
                        message: message
                    };
                    var propsData = assign_default()(defaultParam, params);
                    return dialog_open(propsData);
                },
                confirm: function confirm(params) {
                    var defaultParam = {};
                    var propsData = assign_default()(defaultParam, params);
                    return dialog_open(propsData);
                },
                prompt: function prompt(params) {
                    var defaultParam = {
                        hasInput: true,
                        confirmText: 'Done'
                    };
                    var propsData = assign_default()(defaultParam, params);
                    return dialog_open(propsData);
                }
            };

            var dialog_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Dialog_default.a);
                    registerComponentProgrammatic(Vue, '$dialog', DialogProgrammatic);
                }
            };

            use(dialog_Plugin);

            /* harmony default export */var dialog = dialog_Plugin;

            // EXTERNAL MODULE: ./src/components/dropdown/Dropdown.vue
            var Dropdown = __webpack_require__(28);
            var Dropdown_default = /*#__PURE__*/__webpack_require__.n(Dropdown);

            // EXTERNAL MODULE: ./src/components/dropdown/DropdownItem.vue
            var DropdownItem = __webpack_require__(29);
            var DropdownItem_default = /*#__PURE__*/__webpack_require__.n(DropdownItem);

            // CONCATENATED MODULE: ./src/components/dropdown/index.js


            var dropdown_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Dropdown_default.a);
                    registerComponent(Vue, DropdownItem_default.a);
                }
            };

            use(dropdown_Plugin);

            /* harmony default export */var dropdown = dropdown_Plugin;

            // EXTERNAL MODULE: ./src/components/field/Field.vue
            var Field = __webpack_require__(30);
            var Field_default = /*#__PURE__*/__webpack_require__.n(Field);

            // CONCATENATED MODULE: ./src/components/field/index.js


            var field_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Field_default.a);
                }
            };

            use(field_Plugin);

            /* harmony default export */var field = field_Plugin;

            // EXTERNAL MODULE: ./src/components/icon/Icon.vue
            var Icon = __webpack_require__(3);
            var Icon_default = /*#__PURE__*/__webpack_require__.n(Icon);

            // CONCATENATED MODULE: ./src/components/icon/index.js


            var icon_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Icon_default.a);
                }
            };

            use(icon_Plugin);

            /* harmony default export */var icon = icon_Plugin;

            // EXTERNAL MODULE: ./src/components/input/Input.vue
            var Input = __webpack_require__(17);
            var Input_default = /*#__PURE__*/__webpack_require__.n(Input);

            // CONCATENATED MODULE: ./src/components/input/index.js


            var input_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Input_default.a);
                }
            };

            use(input_Plugin);

            /* harmony default export */var input = input_Plugin;

            // EXTERNAL MODULE: ./src/components/loading/Loading.vue
            var Loading = __webpack_require__(154);
            var Loading_default = /*#__PURE__*/__webpack_require__.n(Loading);

            // CONCATENATED MODULE: ./src/components/loading/index.js


            var LoadingProgrammatic = {
                open: function open(params) {
                    var defaultParam = {
                        programmatic: true
                    };
                    var propsData = assign_default()(defaultParam, params);

                    var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : external___commonjs___vue___commonjs2___vue___amd___vue___root___Vue___default.a;
                    var LoadingComponent = vm.extend(Loading_default.a);
                    return new LoadingComponent({
                        el: document.createElement('div'),
                        propsData: propsData
                    });
                }
            };

            var loading_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Loading_default.a);
                    registerComponentProgrammatic(Vue, '$loading', LoadingProgrammatic);
                }
            };

            use(loading_Plugin);

            /* harmony default export */var loading = loading_Plugin;

            // EXTERNAL MODULE: ./src/components/menu/Menu.vue
            var Menu = __webpack_require__(157);
            var Menu_default = /*#__PURE__*/__webpack_require__.n(Menu);

            // EXTERNAL MODULE: ./src/components/menu/MenuList.vue
            var MenuList = __webpack_require__(160);
            var MenuList_default = /*#__PURE__*/__webpack_require__.n(MenuList);

            // EXTERNAL MODULE: ./src/components/menu/MenuItem.vue
            var MenuItem = __webpack_require__(162);
            var MenuItem_default = /*#__PURE__*/__webpack_require__.n(MenuItem);

            // CONCATENATED MODULE: ./src/components/menu/index.js


            var menu_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Menu_default.a);
                    registerComponent(Vue, MenuList_default.a);
                    registerComponent(Vue, MenuItem_default.a);
                }
            };

            use(menu_Plugin);

            /* harmony default export */var menu = menu_Plugin;

            // EXTERNAL MODULE: ./src/components/message/Message.vue
            var Message = __webpack_require__(165);
            var Message_default = /*#__PURE__*/__webpack_require__.n(Message);

            // CONCATENATED MODULE: ./src/components/message/index.js


            var message_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Message_default.a);
                }
            };

            use(message_Plugin);

            /* harmony default export */var components_message = message_Plugin;

            // EXTERNAL MODULE: ./src/components/modal/Modal.vue
            var Modal = __webpack_require__(63);
            var Modal_default = /*#__PURE__*/__webpack_require__.n(Modal);

            // CONCATENATED MODULE: ./src/components/modal/index.js


            var ModalProgrammatic = {
                open: function open(params) {
                    var content = void 0;
                    var parent = void 0;
                    if (typeof params === 'string') content = params;

                    var defaultParam = {
                        programmatic: true,
                        content: content
                    };
                    if (params.parent) {
                        parent = params.parent;
                        delete params.parent;
                    }
                    var propsData = assign_default()(defaultParam, params);

                    var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : external___commonjs___vue___commonjs2___vue___amd___vue___root___Vue___default.a;
                    var ModalComponent = vm.extend(Modal_default.a);
                    return new ModalComponent({
                        parent: parent,
                        el: document.createElement('div'),
                        propsData: propsData
                    });
                }
            };

            var modal_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Modal_default.a);
                    registerComponentProgrammatic(Vue, '$modal', ModalProgrammatic);
                }
            };

            use(modal_Plugin);

            /* harmony default export */var modal = modal_Plugin;

            // EXTERNAL MODULE: ./src/components/notification/Notification.vue
            var Notification = __webpack_require__(168);
            var Notification_default = /*#__PURE__*/__webpack_require__.n(Notification);

            // EXTERNAL MODULE: ./src/components/notification/NotificationNotice.vue
            var NotificationNotice = __webpack_require__(171);
            var NotificationNotice_default = /*#__PURE__*/__webpack_require__.n(NotificationNotice);

            // EXTERNAL MODULE: ./src/utils/config.js
            var config = __webpack_require__(2);

            // CONCATENATED MODULE: ./src/components/notification/index.js


            var NotificationProgrammatic = {
                open: function open(params) {
                    var message = void 0;
                    var parent = void 0;
                    if (typeof params === 'string') message = params;

                    var defaultParam = {
                        message: message,
                        position: config["a" /* default */].defaultNotificationPosition || 'is-top-right'
                    };
                    if (params.parent) {
                        parent = params.parent;
                        delete params.parent;
                    }
                    var propsData = assign_default()(defaultParam, typeof params === 'string' ? {} : params);

                    var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : external___commonjs___vue___commonjs2___vue___amd___vue___root___Vue___default.a;
                    var NotificationNoticeComponent = vm.extend(NotificationNotice_default.a);
                    return new NotificationNoticeComponent({
                        parent: parent,
                        el: document.createElement('div'),
                        propsData: propsData
                    });
                }
            };

            var notification_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Notification_default.a);
                    registerComponentProgrammatic(Vue, '$notification', NotificationProgrammatic);
                }
            };

            use(notification_Plugin);

            /* harmony default export */var notification = notification_Plugin;

            // EXTERNAL MODULE: ./src/components/numberinput/Numberinput.vue
            var Numberinput = __webpack_require__(174);
            var Numberinput_default = /*#__PURE__*/__webpack_require__.n(Numberinput);

            // CONCATENATED MODULE: ./src/components/numberinput/index.js


            var numberinput_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Numberinput_default.a);
                }
            };

            use(numberinput_Plugin);

            /* harmony default export */var numberinput = numberinput_Plugin;

            // EXTERNAL MODULE: ./src/components/pagination/Pagination.vue
            var Pagination = __webpack_require__(66);
            var Pagination_default = /*#__PURE__*/__webpack_require__.n(Pagination);

            // CONCATENATED MODULE: ./src/components/pagination/index.js


            var pagination_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Pagination_default.a);
                }
            };

            use(pagination_Plugin);

            /* harmony default export */var pagination = pagination_Plugin;

            // EXTERNAL MODULE: ./src/components/radio/Radio.vue
            var Radio = __webpack_require__(179);
            var Radio_default = /*#__PURE__*/__webpack_require__.n(Radio);

            // EXTERNAL MODULE: ./src/components/radio/RadioButton.vue
            var RadioButton = __webpack_require__(182);
            var RadioButton_default = /*#__PURE__*/__webpack_require__.n(RadioButton);

            // CONCATENATED MODULE: ./src/components/radio/index.js


            var radio_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Radio_default.a);
                    registerComponent(Vue, RadioButton_default.a);
                }
            };

            use(radio_Plugin);

            /* harmony default export */var components_radio = radio_Plugin;

            // EXTERNAL MODULE: ./src/components/select/Select.vue
            var Select = __webpack_require__(31);
            var Select_default = /*#__PURE__*/__webpack_require__.n(Select);

            // CONCATENATED MODULE: ./src/components/select/index.js


            var select_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Select_default.a);
                }
            };

            use(select_Plugin);

            /* harmony default export */var components_select = select_Plugin;

            // EXTERNAL MODULE: ./src/components/snackbar/Snackbar.vue
            var Snackbar = __webpack_require__(185);
            var Snackbar_default = /*#__PURE__*/__webpack_require__.n(Snackbar);

            // CONCATENATED MODULE: ./src/components/snackbar/index.js


            var SnackbarProgrammatic = {
                open: function open(params) {
                    var message = void 0;
                    var parent = void 0;
                    if (typeof params === 'string') message = params;

                    var defaultParam = {
                        type: 'is-success',
                        position: config["a" /* default */].defaultSnackbarPosition || 'is-bottom-right',
                        message: message
                    };
                    if (params.parent) {
                        parent = params.parent;
                        delete params.parent;
                    }
                    var propsData = assign_default()(defaultParam, params);

                    var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : external___commonjs___vue___commonjs2___vue___amd___vue___root___Vue___default.a;
                    var SnackbarComponent = vm.extend(Snackbar_default.a);
                    return new SnackbarComponent({
                        parent: parent,
                        el: document.createElement('div'),
                        propsData: propsData
                    });
                }
            };

            var snackbar_Plugin = {
                install: function install(Vue) {
                    registerComponentProgrammatic(Vue, '$snackbar', SnackbarProgrammatic);
                }
            };

            use(snackbar_Plugin);

            /* harmony default export */var snackbar = snackbar_Plugin;

            // EXTERNAL MODULE: ./src/components/steps/Steps.vue
            var Steps = __webpack_require__(188);
            var Steps_default = /*#__PURE__*/__webpack_require__.n(Steps);

            // EXTERNAL MODULE: ./src/components/steps/StepItem.vue
            var StepItem = __webpack_require__(191);
            var StepItem_default = /*#__PURE__*/__webpack_require__.n(StepItem);

            // CONCATENATED MODULE: ./src/components/steps/index.js


            var steps_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Steps_default.a);
                    registerComponent(Vue, StepItem_default.a);
                }
            };

            use(steps_Plugin);

            /* harmony default export */var steps = steps_Plugin;

            // EXTERNAL MODULE: ./src/components/switch/Switch.vue
            var Switch = __webpack_require__(193);
            var Switch_default = /*#__PURE__*/__webpack_require__.n(Switch);

            // CONCATENATED MODULE: ./src/components/switch/index.js


            var switch_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Switch_default.a);
                }
            };

            use(switch_Plugin);

            /* harmony default export */var components_switch = switch_Plugin;

            // EXTERNAL MODULE: ./src/components/table/Table.vue
            var Table = __webpack_require__(196);
            var Table_default = /*#__PURE__*/__webpack_require__.n(Table);

            // EXTERNAL MODULE: ./src/components/table/TableColumn.vue
            var TableColumn = __webpack_require__(68);
            var TableColumn_default = /*#__PURE__*/__webpack_require__.n(TableColumn);

            // CONCATENATED MODULE: ./src/components/table/index.js


            var table_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Table_default.a);
                    registerComponent(Vue, TableColumn_default.a);
                }
            };

            use(table_Plugin);

            /* harmony default export */var table = table_Plugin;

            // EXTERNAL MODULE: ./src/components/tabs/Tabs.vue
            var Tabs = __webpack_require__(212);
            var Tabs_default = /*#__PURE__*/__webpack_require__.n(Tabs);

            // EXTERNAL MODULE: ./src/components/tabs/TabItem.vue
            var TabItem = __webpack_require__(215);
            var TabItem_default = /*#__PURE__*/__webpack_require__.n(TabItem);

            // CONCATENATED MODULE: ./src/components/tabs/index.js


            var tabs_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Tabs_default.a);
                    registerComponent(Vue, TabItem_default.a);
                }
            };

            use(tabs_Plugin);

            /* harmony default export */var tabs = tabs_Plugin;

            // EXTERNAL MODULE: ./src/components/tag/Tag.vue
            var Tag = __webpack_require__(69);
            var Tag_default = /*#__PURE__*/__webpack_require__.n(Tag);

            // EXTERNAL MODULE: ./src/components/tag/Taglist.vue
            var Taglist = __webpack_require__(219);
            var Taglist_default = /*#__PURE__*/__webpack_require__.n(Taglist);

            // CONCATENATED MODULE: ./src/components/tag/index.js


            var tag_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Tag_default.a);
                    registerComponent(Vue, Taglist_default.a);
                }
            };

            use(tag_Plugin);

            /* harmony default export */var tag = tag_Plugin;

            // EXTERNAL MODULE: ./src/components/taginput/Taginput.vue
            var Taginput = __webpack_require__(222);
            var Taginput_default = /*#__PURE__*/__webpack_require__.n(Taginput);

            // CONCATENATED MODULE: ./src/components/taginput/index.js


            var taginput_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Taginput_default.a);
                }
            };

            use(taginput_Plugin);

            /* harmony default export */var taginput = taginput_Plugin;

            // EXTERNAL MODULE: ./src/components/timepicker/Timepicker.vue
            var Timepicker = __webpack_require__(225);
            var Timepicker_default = /*#__PURE__*/__webpack_require__.n(Timepicker);

            // CONCATENATED MODULE: ./src/components/timepicker/index.js


            var timepicker_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Timepicker_default.a);
                }
            };

            use(timepicker_Plugin);

            /* harmony default export */var timepicker = timepicker_Plugin;

            // EXTERNAL MODULE: ./src/components/toast/Toast.vue
            var Toast = __webpack_require__(228);
            var Toast_default = /*#__PURE__*/__webpack_require__.n(Toast);

            // CONCATENATED MODULE: ./src/components/toast/index.js


            var ToastProgrammatic = {
                open: function open(params) {
                    var message = void 0;
                    var parent = void 0;
                    if (typeof params === 'string') message = params;

                    var defaultParam = {
                        message: message,
                        position: config["a" /* default */].defaultToastPosition || 'is-top'
                    };
                    if (params.parent) {
                        parent = params.parent;
                        delete params.parent;
                    }
                    var propsData = assign_default()(defaultParam, params);

                    var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : external___commonjs___vue___commonjs2___vue___amd___vue___root___Vue___default.a;
                    var ToastComponent = vm.extend(Toast_default.a);
                    return new ToastComponent({
                        parent: parent,
                        el: document.createElement('div'),
                        propsData: propsData
                    });
                }
            };

            var toast_Plugin = {
                install: function install(Vue) {
                    registerComponentProgrammatic(Vue, '$toast', ToastProgrammatic);
                }
            };

            use(toast_Plugin);

            /* harmony default export */var toast = toast_Plugin;

            // EXTERNAL MODULE: ./src/components/tooltip/Tooltip.vue
            var Tooltip = __webpack_require__(231);
            var Tooltip_default = /*#__PURE__*/__webpack_require__.n(Tooltip);

            // CONCATENATED MODULE: ./src/components/tooltip/index.js


            var tooltip_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Tooltip_default.a);
                }
            };

            use(tooltip_Plugin);

            /* harmony default export */var tooltip = tooltip_Plugin;

            // EXTERNAL MODULE: ./src/components/upload/Upload.vue
            var Upload = __webpack_require__(234);
            var Upload_default = /*#__PURE__*/__webpack_require__.n(Upload);

            // CONCATENATED MODULE: ./src/components/upload/index.js


            var upload_Plugin = {
                install: function install(Vue) {
                    registerComponent(Vue, Upload_default.a);
                }
            };

            use(upload_Plugin);

            /* harmony default export */var upload = upload_Plugin;

            // CONCATENATED MODULE: ./src/components/index.js


            // CONCATENATED MODULE: ./src/index.js


            var Buefy = {
                install: function install(Vue) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                    // Options
                    Object(config["b" /* setOptions */])(assign_default()(config["a" /* default */], options));
                    // Components
                    for (var componentKey in components_namespaceObject) {
                        Vue.use(components_namespaceObject[componentKey]);
                    }
                    // Config component
                    var BuefyProgrammatic = {
                        setOptions: function setOptions(options) {
                            Object(config["b" /* setOptions */])(assign_default()(config["a" /* default */], options));
                        }
                    };
                    registerComponentProgrammatic(Vue, '$buefy', BuefyProgrammatic);
                }
            };

            use(Buefy);

            /* harmony default export */var src = __webpack_exports__["default"] = Buefy;

            /***/
        },
        /* 71 */
        /***/function (module, exports, __webpack_require__) {

            __webpack_require__(72);
            module.exports = __webpack_require__(6).Object.assign;

            /***/
        },
        /* 72 */
        /***/function (module, exports, __webpack_require__) {

            // 19.1.3.1 Object.assign(target, source)
            var $export = __webpack_require__(19);

            $export($export.S + $export.F, 'Object', { assign: __webpack_require__(74) });

            /***/
        },
        /* 73 */
        /***/function (module, exports) {

            module.exports = function (it) {
                if (typeof it != 'function') throw TypeError(it + ' is not a function!');
                return it;
            };

            /***/
        },
        /* 74 */
        /***/function (module, exports, __webpack_require__) {

            "use strict";

            // 19.1.2.1 Object.assign(target, source, ...)

            var getKeys = __webpack_require__(24);
            var gOPS = __webpack_require__(39);
            var pIE = __webpack_require__(27);
            var toObject = __webpack_require__(40);
            var IObject = __webpack_require__(50);
            var $assign = Object.assign;

            // should work with symbols and should have deterministic property order (V8 bug)
            module.exports = !$assign || __webpack_require__(21)(function () {
                var A = {};
                var B = {};
                // eslint-disable-next-line no-undef
                var S = Symbol();
                var K = 'abcdefghijklmnopqrst';
                A[S] = 7;
                K.split('').forEach(function (k) {
                    B[k] = k;
                });
                return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
            }) ? function assign(target, source) {
                // eslint-disable-line no-unused-vars
                var T = toObject(target);
                var aLen = arguments.length;
                var index = 1;
                var getSymbols = gOPS.f;
                var isEnum = pIE.f;
                while (aLen > index) {
                    var S = IObject(arguments[index++]);
                    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
                    var length = keys.length;
                    var j = 0;
                    var key;
                    while (length > j) {
                        if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
                    }
                }return T;
            } : $assign;

            /***/
        },
        /* 75 */
        /***/function (module, exports, __webpack_require__) {

            // false -> Array#indexOf
            // true  -> Array#includes
            var toIObject = __webpack_require__(16);
            var toLength = __webpack_require__(51);
            var toAbsoluteIndex = __webpack_require__(76);
            module.exports = function (IS_INCLUDES) {
                return function ($this, el, fromIndex) {
                    var O = toIObject($this);
                    var length = toLength(O.length);
                    var index = toAbsoluteIndex(fromIndex, length);
                    var value;
                    // Array#includes uses SameValueZero equality algorithm
                    // eslint-disable-next-line no-self-compare
                    if (IS_INCLUDES && el != el) while (length > index) {
                        value = O[index++];
                        // eslint-disable-next-line no-self-compare
                        if (value != value) return true;
                        // Array#indexOf ignores holes, Array#includes - not
                    } else for (; length > index; index++) {
                        if (IS_INCLUDES || index in O) {
                            if (O[index] === el) return IS_INCLUDES || index || 0;
                        }
                    }return !IS_INCLUDES && -1;
                };
            };

            /***/
        },
        /* 76 */
        /***/function (module, exports, __webpack_require__) {

            var toInteger = __webpack_require__(35);
            var max = Math.max;
            var min = Math.min;
            module.exports = function (index, length) {
                index = toInteger(index);
                return index < 0 ? max(index + length, 0) : min(index, length);
            };

            /***/
        },
        /* 77 */
        /***/function (module, exports) {

            // removed by extract-text-webpack-plugin

            /***/},
        /* 78 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(53);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(59);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(7);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__utils_FormElementMixin__ = __webpack_require__(10);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__input_Input__ = __webpack_require__(17);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__input_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__input_Input__);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BAutocomplete',
                components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5__input_Input___default.a.name, __WEBPACK_IMPORTED_MODULE_5__input_Input___default.a),
                mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_FormElementMixin__["a" /* default */]],
                inheritAttrs: false,
                props: {
                    value: [Number, String],
                    data: {
                        type: Array,
                        default: function _default() {
                            return [];
                        }
                    },
                    field: {
                        type: String,
                        default: 'value'
                    },
                    keepFirst: Boolean,
                    clearOnSelect: Boolean,
                    openOnFocus: Boolean,
                    customFormatter: Function
                },
                data: function data() {
                    return {
                        selected: null,
                        hovered: null,
                        isActive: false,
                        newValue: this.value,
                        newAutocomplete: this.autocomplete || 'off',
                        isListInViewportVertically: true,
                        hasFocus: false,
                        _isAutocomplete: true,
                        _elementRef: 'input'
                    };
                },

                computed: {
                    /**
                     * White-listed items to not close when clicked.
                     * Add input, dropdown and all children.
                     */
                    whiteList: function whiteList() {
                        var whiteList = [];
                        whiteList.push(this.$refs.input.$el.querySelector('input'));
                        whiteList.push(this.$refs.dropdown);
                        // Add all chidren from dropdown
                        if (this.$refs.dropdown !== undefined) {
                            var children = this.$refs.dropdown.querySelectorAll('*');
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var child = _step.value;

                                    whiteList.push(child);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }

                        return whiteList;
                    },

                    /**
                     * Check if exists default slot
                     */
                    hasDefaultSlot: function hasDefaultSlot() {
                        return !!this.$scopedSlots.default;
                    },

                    /**
                     * Check if exists "empty" slot
                     */
                    hasEmptySlot: function hasEmptySlot() {
                        return !!this.$slots.empty;
                    },

                    /**
                     * Check if exists "header" slot
                     */
                    hasHeaderSlot: function hasHeaderSlot() {
                        return !!this.$slots.header;
                    },

                    /**
                     * Check if exists "footer" slot
                     */
                    hasFooterSlot: function hasFooterSlot() {
                        return !!this.$slots.footer;
                    }
                },
                watch: {
                    /**
                     * When dropdown is toggled, check the visibility to know when
                     * to open upwards.
                     */
                    isActive: function isActive(active) {
                        var _this = this;

                        if (active) {
                            this.calcDropdownInViewportVertical();
                        } else {
                            this.$nextTick(function () {
                                return _this.setHovered(null);
                            });
                            // Timeout to wait for the animation to finish before recalculating
                            setTimeout(function () {
                                _this.calcDropdownInViewportVertical();
                            }, 100);
                        }
                    },

                    /**
                     * When updating input's value
                     *   1. Emit changes
                     *   2. If value isn't the same as selected, set null
                     *   3. Close dropdown if value is clear or else open it
                     */
                    newValue: function newValue(value) {
                        this.$emit('input', value);
                        // Check if selected is invalid
                        var currentValue = this.getValue(this.selected);
                        if (currentValue && currentValue !== value) {
                            this.setSelected(null, false);
                        }
                        // Close dropdown if input is clear or else open it
                        if (this.hasFocus && (!this.openOnFocus || value)) {
                            this.isActive = !!value;
                        }
                    },

                    /**
                     * When v-model is changed:
                     *   1. Update internal value.
                     *   2. If it's invalid, validate again.
                     */
                    value: function value(_value) {
                        this.newValue = _value;
                        !this.isValid && this.$refs.input.checkHtml5Validity();
                    },

                    /**
                     * Select first option if "keep-first
                     */
                    data: function data(value) {
                        // Keep first option always pre-selected
                        if (this.keepFirst) {
                            this.selectFirstOption(value);
                        }
                    }
                },
                methods: {
                    /**
                     * Set which option is currently hovered.
                     */
                    setHovered: function setHovered(option) {
                        if (option === undefined) return;

                        this.hovered = option;
                    },

                    /**
                     * Set which option is currently selected, update v-model,
                     * update input value and close dropdown.
                     */
                    setSelected: function setSelected(option) {
                        var _this2 = this;

                        var closeDropdown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                        if (option === undefined) return;

                        this.selected = option;
                        this.$emit('select', this.selected);
                        if (this.selected !== null) {
                            this.newValue = this.clearOnSelect ? '' : this.getValue(this.selected);
                        }
                        closeDropdown && this.$nextTick(function () {
                            _this2.isActive = false;
                        });
                    },

                    /**
                     * Select first option
                     */
                    selectFirstOption: function selectFirstOption(options) {
                        var _this3 = this;

                        this.$nextTick(function () {
                            if (options.length) {
                                // If has visible data or open on focus, keep updating the hovered
                                if (_this3.openOnFocus || _this3.newValue !== '' && _this3.hovered !== options[0]) {
                                    _this3.setHovered(options[0]);
                                }
                            } else {
                                _this3.setHovered(null);
                            }
                        });
                    },

                    /**
                     * Enter key listener.
                     * Select the hovered option.
                     */
                    enterPressed: function enterPressed() {
                        if (this.hovered === null) return;
                        this.setSelected(this.hovered);
                    },

                    /**
                     * Tab key listener.
                     * Select hovered option if it exists, close dropdown, then allow
                     * native handling to move to next tabbable element.
                     */
                    tabPressed: function tabPressed() {
                        if (this.hovered === null) {
                            this.isActive = false;
                            return;
                        }
                        this.setSelected(this.hovered);
                    },

                    /**
                     * Close dropdown if clicked outside.
                     */
                    clickedOutside: function clickedOutside(event) {
                        if (this.whiteList.indexOf(event.target) < 0) this.isActive = false;
                    },

                    /**
                     * Return display text for the input.
                     * If object, get value from path, or else just the value.
                     */
                    getValue: function getValue(option) {
                        if (!option) return;

                        if (typeof this.customFormatter !== 'undefined') {
                            return this.customFormatter(option);
                        }
                        return (typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(option)) === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["a" /* getValueByPath */])(option, this.field) : option;
                    },

                    /**
                     * Calculate if the dropdown is vertically visible when activated,
                     * otherwise it is openened upwards.
                     */
                    calcDropdownInViewportVertical: function calcDropdownInViewportVertical() {
                        var _this4 = this;

                        this.$nextTick(function () {
                            /**
                            * this.$refs.dropdown may be undefined
                            * when Autocomplete is conditional rendered
                            */
                            if (_this4.$refs.dropdown === undefined) return;

                            var rect = _this4.$refs.dropdown.getBoundingClientRect();

                            _this4.isListInViewportVertically = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
                        });
                    },

                    /**
                     * Arrows keys listener.
                     * If dropdown is active, set hovered option, or else just open.
                     */
                    keyArrows: function keyArrows(direction) {
                        var sum = direction === 'down' ? 1 : -1;
                        if (this.isActive) {
                            var index = this.data.indexOf(this.hovered) + sum;
                            index = index > this.data.length - 1 ? this.data.length : index;
                            index = index < 0 ? 0 : index;

                            this.setHovered(this.data[index]);

                            var list = this.$refs.dropdown.querySelector('.dropdown-content');
                            var element = list.querySelectorAll('a.dropdown-item:not(.is-disabled)')[index];

                            if (!element) return;

                            var visMin = list.scrollTop;
                            var visMax = list.scrollTop + list.clientHeight - element.clientHeight;

                            if (element.offsetTop < visMin) {
                                list.scrollTop = element.offsetTop;
                            } else if (element.offsetTop >= visMax) {
                                list.scrollTop = element.offsetTop - list.clientHeight + element.clientHeight;
                            }
                        } else {
                            this.isActive = true;
                        }
                    },

                    /**
                     * Focus listener.
                     * If value is the same as selected, select all text.
                     */
                    focused: function focused(event) {
                        if (this.getValue(this.selected) === this.newValue) {
                            this.$el.querySelector('input').select();
                        }
                        if (this.openOnFocus) {
                            this.isActive = true;
                            if (this.keepFirst) {
                                this.selectFirstOption(this.data);
                            }
                        }
                        this.hasFocus = true;
                        this.$emit('focus', event);
                    },

                    /**
                    * Blur listener.
                    */
                    onBlur: function onBlur(event) {
                        this.hasFocus = false;
                        this.$emit('blur', event);
                    },
                    onInput: function onInput(event) {
                        var currentValue = this.getValue(this.selected);
                        if (currentValue && currentValue === this.newValue) return;
                        this.$emit('typing', this.newValue);
                    }
                },
                created: function created() {
                    if (typeof window !== 'undefined') {
                        document.addEventListener('click', this.clickedOutside);
                        window.addEventListener('resize', this.calcDropdownInViewportVertical);
                    }
                },
                beforeDestroy: function beforeDestroy() {
                    if (typeof window !== 'undefined') {
                        document.removeEventListener('click', this.clickedOutside);
                        window.removeEventListener('resize', this.calcDropdownInViewportVertical);
                    }
                }
            };

            /***/
        },
        /* 79 */
        /***/function (module, exports, __webpack_require__) {

            module.exports = { "default": __webpack_require__(80), __esModule: true };

            /***/
        },
        /* 80 */
        /***/function (module, exports, __webpack_require__) {

            __webpack_require__(41);
            __webpack_require__(57);
            module.exports = __webpack_require__(43).f('iterator');

            /***/
        },
        /* 81 */
        /***/function (module, exports, __webpack_require__) {

            var toInteger = __webpack_require__(35);
            var defined = __webpack_require__(34);
            // true  -> String#at
            // false -> String#codePointAt
            module.exports = function (TO_STRING) {
                return function (that, pos) {
                    var s = String(defined(that));
                    var i = toInteger(pos);
                    var l = s.length;
                    var a, b;
                    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
                    a = s.charCodeAt(i);
                    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
                };
            };

            /***/
        },
        /* 82 */
        /***/function (module, exports, __webpack_require__) {

            "use strict";

            var create = __webpack_require__(56);
            var descriptor = __webpack_require__(22);
            var setToStringTag = __webpack_require__(42);
            var IteratorPrototype = {};

            // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
            __webpack_require__(14)(IteratorPrototype, __webpack_require__(4)('iterator'), function () {
                return this;
            });

            module.exports = function (Constructor, NAME, next) {
                Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
                setToStringTag(Constructor, NAME + ' Iterator');
            };

            /***/
        },
        /* 83 */
        /***/function (module, exports, __webpack_require__) {

            var dP = __webpack_require__(9);
            var anObject = __webpack_require__(15);
            var getKeys = __webpack_require__(24);

            module.exports = __webpack_require__(12) ? Object.defineProperties : function defineProperties(O, Properties) {
                anObject(O);
                var keys = getKeys(Properties);
                var length = keys.length;
                var i = 0;
                var P;
                while (length > i) {
                    dP.f(O, P = keys[i++], Properties[P]);
                }return O;
            };

            /***/
        },
        /* 84 */
        /***/function (module, exports, __webpack_require__) {

            var document = __webpack_require__(8).document;
            module.exports = document && document.documentElement;

            /***/
        },
        /* 85 */
        /***/function (module, exports, __webpack_require__) {

            // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
            var has = __webpack_require__(13);
            var toObject = __webpack_require__(40);
            var IE_PROTO = __webpack_require__(36)('IE_PROTO');
            var ObjectProto = Object.prototype;

            module.exports = Object.getPrototypeOf || function (O) {
                O = toObject(O);
                if (has(O, IE_PROTO)) return O[IE_PROTO];
                if (typeof O.constructor == 'function' && O instanceof O.constructor) {
                    return O.constructor.prototype;
                }return O instanceof Object ? ObjectProto : null;
            };

            /***/
        },
        /* 86 */
        /***/function (module, exports, __webpack_require__) {

            "use strict";

            var addToUnscopables = __webpack_require__(87);
            var step = __webpack_require__(88);
            var Iterators = __webpack_require__(23);
            var toIObject = __webpack_require__(16);

            // 22.1.3.4 Array.prototype.entries()
            // 22.1.3.13 Array.prototype.keys()
            // 22.1.3.29 Array.prototype.values()
            // 22.1.3.30 Array.prototype[@@iterator]()
            module.exports = __webpack_require__(54)(Array, 'Array', function (iterated, kind) {
                this._t = toIObject(iterated); // target
                this._i = 0; // next index
                this._k = kind; // kind
                // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
            }, function () {
                var O = this._t;
                var kind = this._k;
                var index = this._i++;
                if (!O || index >= O.length) {
                    this._t = undefined;
                    return step(1);
                }
                if (kind == 'keys') return step(0, index);
                if (kind == 'values') return step(0, O[index]);
                return step(0, [index, O[index]]);
            }, 'values');

            // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
            Iterators.Arguments = Iterators.Array;

            addToUnscopables('keys');
            addToUnscopables('values');
            addToUnscopables('entries');

            /***/
        },
        /* 87 */
        /***/function (module, exports) {

            module.exports = function () {/* empty */};

            /***/
        },
        /* 88 */
        /***/function (module, exports) {

            module.exports = function (done, value) {
                return { value: value, done: !!done };
            };

            /***/
        },
        /* 89 */
        /***/function (module, exports, __webpack_require__) {

            __webpack_require__(90);
            __webpack_require__(96);
            __webpack_require__(97);
            __webpack_require__(98);
            module.exports = __webpack_require__(6).Symbol;

            /***/
        },
        /* 90 */
        /***/function (module, exports, __webpack_require__) {

            "use strict";

            // ECMAScript 6 symbols shim

            var global = __webpack_require__(8);
            var has = __webpack_require__(13);
            var DESCRIPTORS = __webpack_require__(12);
            var $export = __webpack_require__(19);
            var redefine = __webpack_require__(55);
            var META = __webpack_require__(91).KEY;
            var $fails = __webpack_require__(21);
            var shared = __webpack_require__(37);
            var setToStringTag = __webpack_require__(42);
            var uid = __webpack_require__(26);
            var wks = __webpack_require__(4);
            var wksExt = __webpack_require__(43);
            var wksDefine = __webpack_require__(44);
            var enumKeys = __webpack_require__(92);
            var isArray = __webpack_require__(93);
            var anObject = __webpack_require__(15);
            var isObject = __webpack_require__(20);
            var toIObject = __webpack_require__(16);
            var toPrimitive = __webpack_require__(32);
            var createDesc = __webpack_require__(22);
            var _create = __webpack_require__(56);
            var gOPNExt = __webpack_require__(94);
            var $GOPD = __webpack_require__(95);
            var $DP = __webpack_require__(9);
            var $keys = __webpack_require__(24);
            var gOPD = $GOPD.f;
            var dP = $DP.f;
            var gOPN = gOPNExt.f;
            var $Symbol = global.Symbol;
            var $JSON = global.JSON;
            var _stringify = $JSON && $JSON.stringify;
            var PROTOTYPE = 'prototype';
            var HIDDEN = wks('_hidden');
            var TO_PRIMITIVE = wks('toPrimitive');
            var isEnum = {}.propertyIsEnumerable;
            var SymbolRegistry = shared('symbol-registry');
            var AllSymbols = shared('symbols');
            var OPSymbols = shared('op-symbols');
            var ObjectProto = Object[PROTOTYPE];
            var USE_NATIVE = typeof $Symbol == 'function';
            var QObject = global.QObject;
            // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
            var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

            // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
            var setSymbolDesc = DESCRIPTORS && $fails(function () {
                return _create(dP({}, 'a', {
                    get: function get() {
                        return dP(this, 'a', { value: 7 }).a;
                    }
                })).a != 7;
            }) ? function (it, key, D) {
                var protoDesc = gOPD(ObjectProto, key);
                if (protoDesc) delete ObjectProto[key];
                dP(it, key, D);
                if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
            } : dP;

            var wrap = function wrap(tag) {
                var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
                sym._k = tag;
                return sym;
            };

            var isSymbol = USE_NATIVE && _typeof2($Symbol.iterator) == 'symbol' ? function (it) {
                return (typeof it === 'undefined' ? 'undefined' : _typeof2(it)) == 'symbol';
            } : function (it) {
                return it instanceof $Symbol;
            };

            var $defineProperty = function defineProperty(it, key, D) {
                if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
                anObject(it);
                key = toPrimitive(key, true);
                anObject(D);
                if (has(AllSymbols, key)) {
                    if (!D.enumerable) {
                        if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
                        it[HIDDEN][key] = true;
                    } else {
                        if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
                        D = _create(D, { enumerable: createDesc(0, false) });
                    }return setSymbolDesc(it, key, D);
                }return dP(it, key, D);
            };
            var $defineProperties = function defineProperties(it, P) {
                anObject(it);
                var keys = enumKeys(P = toIObject(P));
                var i = 0;
                var l = keys.length;
                var key;
                while (l > i) {
                    $defineProperty(it, key = keys[i++], P[key]);
                }return it;
            };
            var $create = function create(it, P) {
                return P === undefined ? _create(it) : $defineProperties(_create(it), P);
            };
            var $propertyIsEnumerable = function propertyIsEnumerable(key) {
                var E = isEnum.call(this, key = toPrimitive(key, true));
                if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
                return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
            };
            var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
                it = toIObject(it);
                key = toPrimitive(key, true);
                if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
                var D = gOPD(it, key);
                if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
                return D;
            };
            var $getOwnPropertyNames = function getOwnPropertyNames(it) {
                var names = gOPN(toIObject(it));
                var result = [];
                var i = 0;
                var key;
                while (names.length > i) {
                    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
                }return result;
            };
            var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
                var IS_OP = it === ObjectProto;
                var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
                var result = [];
                var i = 0;
                var key;
                while (names.length > i) {
                    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
                }return result;
            };

            // 19.4.1.1 Symbol([description])
            if (!USE_NATIVE) {
                $Symbol = function _Symbol2() {
                    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
                    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
                    var $set = function $set(value) {
                        if (this === ObjectProto) $set.call(OPSymbols, value);
                        if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                        setSymbolDesc(this, tag, createDesc(1, value));
                    };
                    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
                    return wrap(tag);
                };
                redefine($Symbol[PROTOTYPE], 'toString', function toString() {
                    return this._k;
                });

                $GOPD.f = $getOwnPropertyDescriptor;
                $DP.f = $defineProperty;
                __webpack_require__(58).f = gOPNExt.f = $getOwnPropertyNames;
                __webpack_require__(27).f = $propertyIsEnumerable;
                __webpack_require__(39).f = $getOwnPropertySymbols;

                if (DESCRIPTORS && !__webpack_require__(25)) {
                    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
                }

                wksExt.f = function (name) {
                    return wrap(wks(name));
                };
            }

            $export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

            for (var es6Symbols =
            // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
            'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
                wks(es6Symbols[j++]);
            }for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
                wksDefine(wellKnownSymbols[k++]);
            }$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
                // 19.4.2.1 Symbol.for(key)
                'for': function _for(key) {
                    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
                },
                // 19.4.2.5 Symbol.keyFor(sym)
                keyFor: function keyFor(sym) {
                    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
                    for (var key in SymbolRegistry) {
                        if (SymbolRegistry[key] === sym) return key;
                    }
                },
                useSetter: function useSetter() {
                    setter = true;
                },
                useSimple: function useSimple() {
                    setter = false;
                }
            });

            $export($export.S + $export.F * !USE_NATIVE, 'Object', {
                // 19.1.2.2 Object.create(O [, Properties])
                create: $create,
                // 19.1.2.4 Object.defineProperty(O, P, Attributes)
                defineProperty: $defineProperty,
                // 19.1.2.3 Object.defineProperties(O, Properties)
                defineProperties: $defineProperties,
                // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
                getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
                // 19.1.2.7 Object.getOwnPropertyNames(O)
                getOwnPropertyNames: $getOwnPropertyNames,
                // 19.1.2.8 Object.getOwnPropertySymbols(O)
                getOwnPropertySymbols: $getOwnPropertySymbols
            });

            // 24.3.2 JSON.stringify(value [, replacer [, space]])
            $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
                var S = $Symbol();
                // MS Edge converts symbol values to JSON as {}
                // WebKit converts symbol values to JSON as null
                // V8 throws on boxed symbols
                return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
            })), 'JSON', {
                stringify: function stringify(it) {
                    var args = [it];
                    var i = 1;
                    var replacer, $replacer;
                    while (arguments.length > i) {
                        args.push(arguments[i++]);
                    }$replacer = replacer = args[1];
                    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
                    if (!isArray(replacer)) replacer = function replacer(key, value) {
                        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
                        if (!isSymbol(value)) return value;
                    };
                    args[1] = replacer;
                    return _stringify.apply($JSON, args);
                }
            });

            // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
            $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(14)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
            // 19.4.3.5 Symbol.prototype[@@toStringTag]
            setToStringTag($Symbol, 'Symbol');
            // 20.2.1.9 Math[@@toStringTag]
            setToStringTag(Math, 'Math', true);
            // 24.3.3 JSON[@@toStringTag]
            setToStringTag(global.JSON, 'JSON', true);

            /***/
        },
        /* 91 */
        /***/function (module, exports, __webpack_require__) {

            var META = __webpack_require__(26)('meta');
            var isObject = __webpack_require__(20);
            var has = __webpack_require__(13);
            var setDesc = __webpack_require__(9).f;
            var id = 0;
            var isExtensible = Object.isExtensible || function () {
                return true;
            };
            var FREEZE = !__webpack_require__(21)(function () {
                return isExtensible(Object.preventExtensions({}));
            });
            var setMeta = function setMeta(it) {
                setDesc(it, META, { value: {
                        i: 'O' + ++id, // object ID
                        w: {} // weak collections IDs
                    } });
            };
            var fastKey = function fastKey(it, create) {
                // return primitive with prefix
                if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof2(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
                if (!has(it, META)) {
                    // can't set metadata to uncaught frozen object
                    if (!isExtensible(it)) return 'F';
                    // not necessary to add metadata
                    if (!create) return 'E';
                    // add missing metadata
                    setMeta(it);
                    // return object ID
                }return it[META].i;
            };
            var getWeak = function getWeak(it, create) {
                if (!has(it, META)) {
                    // can't set metadata to uncaught frozen object
                    if (!isExtensible(it)) return true;
                    // not necessary to add metadata
                    if (!create) return false;
                    // add missing metadata
                    setMeta(it);
                    // return hash weak collections IDs
                }return it[META].w;
            };
            // add metadata on freeze-family methods calling
            var onFreeze = function onFreeze(it) {
                if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
                return it;
            };
            var meta = module.exports = {
                KEY: META,
                NEED: false,
                fastKey: fastKey,
                getWeak: getWeak,
                onFreeze: onFreeze
            };

            /***/
        },
        /* 92 */
        /***/function (module, exports, __webpack_require__) {

            // all enumerable object keys, includes symbols
            var getKeys = __webpack_require__(24);
            var gOPS = __webpack_require__(39);
            var pIE = __webpack_require__(27);
            module.exports = function (it) {
                var result = getKeys(it);
                var getSymbols = gOPS.f;
                if (getSymbols) {
                    var symbols = getSymbols(it);
                    var isEnum = pIE.f;
                    var i = 0;
                    var key;
                    while (symbols.length > i) {
                        if (isEnum.call(it, key = symbols[i++])) result.push(key);
                    }
                }return result;
            };

            /***/
        },
        /* 93 */
        /***/function (module, exports, __webpack_require__) {

            // 7.2.2 IsArray(argument)
            var cof = __webpack_require__(33);
            module.exports = Array.isArray || function isArray(arg) {
                return cof(arg) == 'Array';
            };

            /***/
        },
        /* 94 */
        /***/function (module, exports, __webpack_require__) {

            // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
            var toIObject = __webpack_require__(16);
            var gOPN = __webpack_require__(58).f;
            var toString = {}.toString;

            var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof2(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

            var getWindowNames = function getWindowNames(it) {
                try {
                    return gOPN(it);
                } catch (e) {
                    return windowNames.slice();
                }
            };

            module.exports.f = function getOwnPropertyNames(it) {
                return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
            };

            /***/
        },
        /* 95 */
        /***/function (module, exports, __webpack_require__) {

            var pIE = __webpack_require__(27);
            var createDesc = __webpack_require__(22);
            var toIObject = __webpack_require__(16);
            var toPrimitive = __webpack_require__(32);
            var has = __webpack_require__(13);
            var IE8_DOM_DEFINE = __webpack_require__(47);
            var gOPD = Object.getOwnPropertyDescriptor;

            exports.f = __webpack_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P) {
                O = toIObject(O);
                P = toPrimitive(P, true);
                if (IE8_DOM_DEFINE) try {
                    return gOPD(O, P);
                } catch (e) {/* empty */}
                if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
            };

            /***/
        },
        /* 96 */
        /***/function (module, exports) {

            /***/},
        /* 97 */
        /***/function (module, exports, __webpack_require__) {

            __webpack_require__(44)('asyncIterator');

            /***/
        },
        /* 98 */
        /***/function (module, exports, __webpack_require__) {

            __webpack_require__(44)('observable');

            /***/
        },
        /* 99 */
        /***/function (module, exports, __webpack_require__) {

            __webpack_require__(57);
            __webpack_require__(41);
            module.exports = __webpack_require__(100);

            /***/
        },
        /* 100 */
        /***/function (module, exports, __webpack_require__) {

            var anObject = __webpack_require__(15);
            var get = __webpack_require__(60);
            module.exports = __webpack_require__(6).getIterator = function (it) {
                var iterFn = get(it);
                if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
                return anObject(iterFn.call(it));
            };

            /***/
        },
        /* 101 */
        /***/function (module, exports, __webpack_require__) {

            // getting tag from 19.1.3.6 Object.prototype.toString()
            var cof = __webpack_require__(33);
            var TAG = __webpack_require__(4)('toStringTag');
            // ES3 wrong here
            var ARG = cof(function () {
                return arguments;
            }()) == 'Arguments';

            // fallback for IE11 Script Access Denied error
            var tryGet = function tryGet(it, key) {
                try {
                    return it[key];
                } catch (e) {/* empty */}
            };

            module.exports = function (it) {
                var O, T, B;
                return it === undefined ? 'Undefined' : it === null ? 'Null'
                // @@toStringTag case
                : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
                // builtinTag case
                : ARG ? cof(O)
                // ES3 arguments fallback
                : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
            };

            /***/
        },
        /* 102 */
        /***/function (module, exports, __webpack_require__) {

            module.exports = { "default": __webpack_require__(103), __esModule: true };

            /***/
        },
        /* 103 */
        /***/function (module, exports, __webpack_require__) {

            __webpack_require__(104);
            var $Object = __webpack_require__(6).Object;
            module.exports = function defineProperty(it, key, desc) {
                return $Object.defineProperty(it, key, desc);
            };

            /***/
        },
        /* 104 */
        /***/function (module, exports, __webpack_require__) {

            var $export = __webpack_require__(19);
            // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
            $export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperty: __webpack_require__(9).f });

            /***/
        },
        /* 105 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon_Icon__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__utils_config__ = __webpack_require__(2);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__utils_FormElementMixin__ = __webpack_require__(10);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BInput',
                components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a),
                mixins: [__WEBPACK_IMPORTED_MODULE_3__utils_FormElementMixin__["a" /* default */]],
                inheritAttrs: false,
                props: {
                    value: [Number, String],
                    type: {
                        type: String,
                        default: 'text'
                    },
                    passwordReveal: Boolean,
                    hasCounter: {
                        type: Boolean,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_2__utils_config__["a" /* default */].defaultInputHasCounter;
                        }
                    },
                    customClass: {
                        type: String,
                        default: ''
                    }
                },
                data: function data() {
                    return {
                        newValue: this.value,
                        newType: this.type,
                        newAutocomplete: this.autocomplete || __WEBPACK_IMPORTED_MODULE_2__utils_config__["a" /* default */].defaultInputAutocomplete,
                        isPasswordVisible: false,
                        _elementRef: this.type === 'textarea' ? 'textarea' : 'input'
                    };
                },

                computed: {
                    computedValue: {
                        get: function get() {
                            return this.newValue;
                        },
                        set: function set(value) {
                            this.newValue = value;
                            this.$emit('input', value);
                            !this.isValid && this.checkHtml5Validity();
                        }
                    },
                    rootClasses: function rootClasses() {
                        return [this.iconPosition, this.size, {
                            'is-expanded': this.expanded,
                            'is-loading': this.loading,
                            'is-clearfix': !this.hasMessage
                        }];
                    },
                    inputClasses: function inputClasses() {
                        return [this.statusType, this.size, { 'is-rounded': this.rounded }];
                    },
                    hasIconRight: function hasIconRight() {
                        return this.passwordReveal || this.loading || this.statusType;
                    },

                    /**
                    * Position of the icon or if it's both sides.
                    */
                    iconPosition: function iconPosition() {
                        if (this.icon && this.hasIconRight) {
                            return 'has-icons-left has-icons-right';
                        } else if (!this.icon && this.hasIconRight) {
                            return 'has-icons-right';
                        } else if (this.icon) {
                            return 'has-icons-left';
                        }
                    },

                    /**
                    * Icon name (MDI) based on the type.
                    */
                    statusTypeIcon: function statusTypeIcon() {
                        switch (this.statusType) {
                            case 'is-success':
                                return 'check';
                            case 'is-danger':
                                return 'alert-circle';
                            case 'is-info':
                                return 'information';
                            case 'is-warning':
                                return 'alert';
                        }
                    },

                    /**
                    * Check if have any message prop from parent if it's a Field.
                    */
                    hasMessage: function hasMessage() {
                        return !!this.statusMessage;
                    },

                    /**
                    * Current password-reveal icon name.
                    */
                    passwordVisibleIcon: function passwordVisibleIcon() {
                        return !this.isPasswordVisible ? 'eye' : 'eye-off';
                    },

                    /**
                    * Get value length
                    */
                    valueLength: function valueLength() {
                        if (typeof this.computedValue === 'string') {
                            return this.computedValue.length;
                        } else if (typeof this.computedValue === 'number') {
                            return this.computedValue.toString().length;
                        }
                        return 0;
                    }
                },
                watch: {
                    /**
                    * When v-model is changed:
                    *   1. Set internal value.
                    */
                    value: function value(_value) {
                        this.newValue = _value;
                    }
                },
                methods: {
                    /**
                    * Toggle the visibility of a password-reveal input
                    * by changing the type and focus the input right away.
                    */
                    togglePasswordVisibility: function togglePasswordVisibility() {
                        var _this = this;

                        this.isPasswordVisible = !this.isPasswordVisible;
                        this.newType = this.isPasswordVisible ? 'text' : 'password';

                        this.$nextTick(function () {
                            _this.$refs.input.focus();
                        });
                    },

                    /**
                    * Input's 'input' event listener, 'nextTick' is used to prevent event firing
                    * before ui update, helps when using masks (Cleavejs and potentially others).
                    */
                    onInput: function onInput(event) {
                        var _this2 = this;

                        this.$nextTick(function () {
                            if (event.target) {
                                _this2.computedValue = event.target.value;
                            }
                        });
                    }
                }
            };

            /***/
        },
        /* 106 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__utils_config__ = __webpack_require__(2);
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BIcon',
                props: {
                    type: [String, Object],
                    pack: String,
                    icon: String,
                    size: String,
                    customSize: String,
                    customClass: String,
                    both: Boolean // This is used internally to show both MDI and FA icon
                },
                computed: {
                    /**
                    * Internal icon name based on the pack.
                    * If pack is 'fa', gets the equivalent FA icon name of the MDI,
                    * internal icons are always MDI.
                    */
                    newIcon: function newIcon() {
                        return this.newPack === 'mdi' ? this.newPack + '-' + this.icon : this.addFAPrefix(this.getEquivalentIconOf(this.icon));
                    },
                    newPack: function newPack() {
                        return this.pack || __WEBPACK_IMPORTED_MODULE_0__utils_config__["a" /* default */].defaultIconPack;
                    },
                    newType: function newType() {
                        if (!this.type) return;

                        var splitType = [];
                        if (typeof this.type === 'string') {
                            splitType = this.type.split('-');
                        } else {
                            for (var key in this.type) {
                                if (this.type[key]) {
                                    splitType = key.split('-');
                                    break;
                                }
                            }
                        }
                        if (splitType.length <= 1) return;

                        return 'has-text-' + splitType[1];
                    },
                    newCustomSize: function newCustomSize() {
                        return this.customSize || this.customSizeByPack;
                    },
                    customSizeByPack: function customSizeByPack() {
                        var defaultSize = this.newPack === 'mdi' ? 'mdi-24px' : this.addFAPrefix('lg');
                        var mediumSize = this.newPack === 'mdi' ? 'mdi-36px' : this.addFAPrefix('2x');
                        var largeSize = this.newPack === 'mdi' ? 'mdi-48px' : this.addFAPrefix('3x');
                        switch (this.size) {
                            case 'is-small':
                                return;
                            case 'is-medium':
                                return mediumSize;
                            case 'is-large':
                                return largeSize;
                            default:
                                return defaultSize;
                        }
                    },
                    useIconComponent: function useIconComponent() {
                        return __WEBPACK_IMPORTED_MODULE_0__utils_config__["a" /* default */].defaultIconComponent;
                    }
                },
                methods: {
                    addFAPrefix: function addFAPrefix(value) {
                        if (this.useIconComponent) {
                            return value;
                        }
                        return 'fa-' + value;
                    },

                    /**
                    * Equivalent FA icon name of the MDI.
                    */
                    getEquivalentIconOf: function getEquivalentIconOf(value) {
                        // Only transform the class if the both prop is set to true
                        if (!this.both) {
                            return value;
                        }

                        switch (value) {
                            case 'check':
                                return 'check';
                            case 'information':
                                return 'info-circle';
                            case 'check-circle':
                                return 'check-circle';
                            case 'alert':
                                return 'exclamation-triangle';
                            case 'alert-circle':
                                return 'exclamation-circle';
                            case 'arrow-up':
                                return 'arrow-up';
                            case 'chevron-right':
                                return 'angle-right';
                            case 'chevron-left':
                                return 'angle-left';
                            case 'chevron-down':
                                return 'angle-down';
                            case 'eye':
                                return 'eye';
                            case 'eye-off':
                                return 'eye-slash';
                            case 'menu-down':
                                return 'caret-down';
                            case 'menu-up':
                                return 'caret-up';
                            default:
                                return value;
                        }
                    }
                }
            };

            /***/
        },
        /* 107 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('span', {
                        staticClass: "icon",
                        class: [_vm.newType, _vm.size]
                    }, [!_vm.useIconComponent ? _c('i', {
                        class: [_vm.newPack, _vm.newIcon, _vm.newCustomSize, _vm.customClass]
                    }) : _c(_vm.useIconComponent, {
                        tag: "component",
                        class: [_vm.customClass],
                        attrs: {
                            "icon": [_vm.newPack, _vm.newIcon],
                            "size": _vm.newCustomSize
                        }
                    })], 1);
                }, staticRenderFns: []

                /***/ };
        },
        /* 108 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "control",
                        class: _vm.rootClasses
                    }, [_vm.type !== 'textarea' ? _c('input', _vm._b({
                        ref: "input",
                        staticClass: "input",
                        class: [_vm.inputClasses, _vm.customClass],
                        attrs: {
                            "type": _vm.newType,
                            "autocomplete": _vm.newAutocomplete,
                            "maxlength": _vm.maxlength
                        },
                        domProps: {
                            "value": _vm.computedValue
                        },
                        on: {
                            "input": _vm.onInput,
                            "blur": _vm.onBlur,
                            "focus": _vm.onFocus
                        }
                    }, 'input', _vm.$attrs, false)) : _c('textarea', _vm._b({
                        ref: "textarea",
                        staticClass: "textarea",
                        class: [_vm.inputClasses, _vm.customClass],
                        attrs: {
                            "maxlength": _vm.maxlength
                        },
                        domProps: {
                            "value": _vm.computedValue
                        },
                        on: {
                            "input": _vm.onInput,
                            "blur": _vm.onBlur,
                            "focus": _vm.onFocus
                        }
                    }, 'textarea', _vm.$attrs, false)), _vm._v(" "), _vm.icon ? _c('b-icon', {
                        staticClass: "is-left",
                        attrs: {
                            "icon": _vm.icon,
                            "pack": _vm.iconPack,
                            "size": _vm.iconSize
                        }
                    }) : _vm._e(), _vm._v(" "), !_vm.loading && (_vm.passwordReveal || _vm.statusType) ? _c('b-icon', {
                        staticClass: "is-right",
                        class: {
                            'is-clickable': _vm.passwordReveal
                        },
                        attrs: {
                            "icon": _vm.passwordReveal ? _vm.passwordVisibleIcon : _vm.statusTypeIcon,
                            "pack": _vm.iconPack,
                            "size": _vm.iconSize,
                            "type": !_vm.passwordReveal ? _vm.statusType : 'is-primary',
                            "both": ""
                        },
                        nativeOn: {
                            "click": function click($event) {
                                _vm.togglePasswordVisibility($event);
                            }
                        }
                    }) : _vm._e(), _vm._v(" "), _vm.maxlength && _vm.hasCounter && _vm.type !== 'number' ? _c('small', {
                        staticClass: "help counter",
                        class: {
                            'is-invisible': !_vm.isFocused
                        }
                    }, [_vm._v("\n        " + _vm._s(_vm.valueLength) + " / " + _vm._s(_vm.maxlength) + "\n    ")]) : _vm._e()], 1);
                }, staticRenderFns: []

                /***/ };
        },
        /* 109 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "autocomplete control",
                        class: {
                            'is-expanded': _vm.expanded
                        }
                    }, [_c('b-input', _vm._b({
                        ref: "input",
                        attrs: {
                            "type": "text",
                            "size": _vm.size,
                            "loading": _vm.loading,
                            "rounded": _vm.rounded,
                            "icon": _vm.icon,
                            "icon-pack": _vm.iconPack,
                            "maxlength": _vm.maxlength,
                            "autocomplete": _vm.newAutocomplete,
                            "use-html5-validation": _vm.useHtml5Validation
                        },
                        on: {
                            "input": _vm.onInput,
                            "focus": _vm.focused,
                            "blur": _vm.onBlur
                        },
                        nativeOn: {
                            "keyup": function keyup($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.isActive = false;
                            },
                            "keydown": [function ($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key)) {
                                    return null;
                                }
                                _vm.tabPressed($event);
                            }, function ($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.enterPressed($event);
                            }, function ($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.keyArrows('up');
                            }, function ($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.keyArrows('down');
                            }]
                        },
                        model: {
                            value: _vm.newValue,
                            callback: function callback($$v) {
                                _vm.newValue = $$v;
                            },
                            expression: "newValue"
                        }
                    }, 'b-input', _vm.$attrs, false)), _vm._v(" "), _c('transition', {
                        attrs: {
                            "name": "fade"
                        }
                    }, [_c('div', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isActive && (_vm.data.length > 0 || _vm.hasEmptySlot || _vm.hasHeaderSlot),
                            expression: "isActive && (data.length > 0 || hasEmptySlot || hasHeaderSlot)"
                        }],
                        ref: "dropdown",
                        staticClass: "dropdown-menu",
                        class: {
                            'is-opened-top': !_vm.isListInViewportVertically
                        }
                    }, [_c('div', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isActive,
                            expression: "isActive"
                        }],
                        staticClass: "dropdown-content"
                    }, [_vm.hasHeaderSlot ? _c('div', {
                        staticClass: "dropdown-item"
                    }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _vm._l(_vm.data, function (option, index) {
                        return _c('a', {
                            key: index,
                            staticClass: "dropdown-item",
                            class: {
                                'is-hovered': option === _vm.hovered
                            },
                            on: {
                                "click": function click($event) {
                                    _vm.setSelected(option);
                                }
                            }
                        }, [_vm.hasDefaultSlot ? _vm._t("default", null, {
                            option: option,
                            index: index
                        }) : _c('span', [_vm._v("\n                        " + _vm._s(_vm.getValue(option, true)) + "\n                    ")])], 2);
                    }), _vm._v(" "), _vm.data.length === 0 && _vm.hasEmptySlot ? _c('div', {
                        staticClass: "dropdown-item is-disabled"
                    }, [_vm._t("empty")], 2) : _vm._e(), _vm._v(" "), _vm.hasFooterSlot ? _c('div', {
                        staticClass: "dropdown-item"
                    }, [_vm._t("footer")], 2) : _vm._e()], 2)])])], 1);
                }, staticRenderFns: []

                /***/ };
        },
        /* 110 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(111),
            /* template */
            __webpack_require__(112),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 111 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon_Icon__);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BButton',
                components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a),
                inheritAttrs: false,
                props: {
                    type: [String, Object],
                    size: String,
                    label: String,
                    iconPack: String,
                    iconLeft: String,
                    iconRight: String,
                    rounded: Boolean,
                    loading: Boolean,
                    outlined: Boolean,
                    inverted: Boolean,
                    focused: Boolean,
                    active: Boolean,
                    hovered: Boolean,
                    selected: Boolean,
                    nativeType: {
                        type: String,
                        default: 'button',
                        validator: function validator(value) {
                            return ['button', 'submit', 'reset'].indexOf(value) >= 0;
                        }
                    },
                    tag: {
                        type: String,
                        default: 'button',
                        validator: function validator(value) {
                            return ['button', 'a', 'input', 'router-link', 'nuxt-link', 'n-link', 'NuxtLink', 'NLink'].indexOf(value) >= 0;
                        }
                    }
                },
                computed: {
                    iconSize: function iconSize() {
                        if (!this.size || this.size === 'is-medium') {
                            return 'is-small';
                        } else if (this.size === 'is-large') {
                            return 'is-medium';
                        }
                        return this.size;
                    }
                }
            };

            /***/
        },
        /* 112 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c(_vm.tag, _vm._b({
                        tag: "component",
                        staticClass: "button",
                        class: [_vm.size, _vm.type, {
                            'is-rounded': _vm.rounded,
                            'is-loading': _vm.loading,
                            'is-outlined': _vm.outlined,
                            'is-inverted': _vm.inverted,
                            'is-focused': _vm.focused,
                            'is-active': _vm.active,
                            'is-hovered': _vm.hovered,
                            'is-selected': _vm.selected
                        }],
                        attrs: {
                            "type": _vm.nativeType
                        },
                        on: {
                            "click": function click($event) {
                                _vm.$emit('click', $event);
                            }
                        }
                    }, 'component', _vm.$attrs, false), [_vm.iconLeft ? _c('b-icon', {
                        attrs: {
                            "pack": _vm.iconPack,
                            "icon": _vm.iconLeft,
                            "size": _vm.iconSize
                        }
                    }) : _vm._e(), _vm._v(" "), _vm.label ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm.$slots.default ? _c('span', [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _vm.iconRight ? _c('b-icon', {
                        attrs: {
                            "pack": _vm.iconPack,
                            "icon": _vm.iconRight,
                            "size": _vm.iconSize
                        }
                    }) : _vm._e()], 1);
                }, staticRenderFns: []

                /***/ };
        },
        /* 113 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__ = __webpack_require__(5);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BCheckbox',
                props: {
                    value: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                    nativeValue: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                    indeterminate: Boolean,
                    type: String,
                    disabled: Boolean,
                    required: Boolean,
                    name: String,
                    size: String,
                    trueValue: {
                        type: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                        default: true
                    },
                    falseValue: {
                        type: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                        default: false
                    }
                },
                data: function data() {
                    return {
                        newValue: this.value
                    };
                },

                computed: {
                    computedValue: {
                        get: function get() {
                            return this.newValue;
                        },
                        set: function set(value) {
                            this.newValue = value;
                            this.$emit('input', value);
                        }
                    }
                },
                watch: {
                    /**
                     * When v-model change, set internal value.
                     */
                    value: function value(_value) {
                        this.newValue = _value;
                    }
                }
            };

            /***/
        },
        /* 114 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('label', {
                        ref: "label",
                        staticClass: "b-checkbox checkbox",
                        class: [_vm.size, {
                            'is-disabled': _vm.disabled
                        }],
                        attrs: {
                            "disabled": _vm.disabled
                        },
                        on: {
                            "keydown": function keydown($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.$refs.label.click();
                            }
                        }
                    }, [_c('input', {
                        directives: [{
                            name: "model",
                            rawName: "v-model",
                            value: _vm.computedValue,
                            expression: "computedValue"
                        }],
                        attrs: {
                            "type": "checkbox",
                            "disabled": _vm.disabled,
                            "required": _vm.required,
                            "name": _vm.name,
                            "true-value": _vm.trueValue,
                            "false-value": _vm.falseValue
                        },
                        domProps: {
                            "indeterminate": _vm.indeterminate,
                            "value": _vm.nativeValue,
                            "checked": Array.isArray(_vm.computedValue) ? _vm._i(_vm.computedValue, _vm.nativeValue) > -1 : _vm._q(_vm.computedValue, _vm.trueValue)
                        },
                        on: {
                            "click": function click($event) {
                                $event.stopPropagation();
                            },
                            "change": function change($event) {
                                var $$a = _vm.computedValue,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? _vm.trueValue : _vm.falseValue;
                                if (Array.isArray($$a)) {
                                    var $$v = _vm.nativeValue,
                                        $$i = _vm._i($$a, $$v);
                                    if ($$el.checked) {
                                        $$i < 0 && (_vm.computedValue = $$a.concat([$$v]));
                                    } else {
                                        $$i > -1 && (_vm.computedValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                                    }
                                } else {
                                    _vm.computedValue = $$c;
                                }
                            }
                        }
                    }), _vm._v(" "), _c('span', {
                        staticClass: "check",
                        class: _vm.type
                    }), _vm._v(" "), _c('span', {
                        staticClass: "control-label"
                    }, [_vm._t("default")], 2)]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 115 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(116),
            /* template */
            __webpack_require__(117),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 116 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__ = __webpack_require__(5);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BCheckboxButton',
                props: {
                    value: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                    nativeValue: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                    disabled: Boolean,
                    required: Boolean,
                    name: String,
                    size: String,
                    type: {
                        type: String,
                        default: 'is-primary'
                    }
                },
                data: function data() {
                    return {
                        newValue: this.value,
                        isFocused: false
                    };
                },

                computed: {
                    computedValue: {
                        get: function get() {
                            return this.newValue;
                        },
                        set: function set(value) {
                            this.newValue = value;
                            this.$emit('input', value);
                        }
                    },
                    checked: function checked() {
                        if (Array.isArray(this.newValue)) {
                            return this.newValue.indexOf(this.nativeValue) >= 0;
                        }
                        return this.newValue === this.nativeValue;
                    }
                },
                watch: {
                    /**
                     * When v-model change, set internal value.
                     */
                    value: function value(_value) {
                        this.newValue = _value;
                    }
                }
            };

            /***/
        },
        /* 117 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "control"
                    }, [_c('label', {
                        ref: "label",
                        staticClass: "b-checkbox checkbox button",
                        class: [_vm.checked ? _vm.type : null, _vm.size, {
                            'is-disabled': _vm.disabled,
                            'is-focused': _vm.isFocused
                        }],
                        attrs: {
                            "disabled": _vm.disabled
                        },
                        on: {
                            "keydown": function keydown($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.$refs.label.click();
                            }
                        }
                    }, [_vm._t("default"), _vm._v(" "), _c('input', {
                        directives: [{
                            name: "model",
                            rawName: "v-model",
                            value: _vm.computedValue,
                            expression: "computedValue"
                        }],
                        attrs: {
                            "type": "checkbox",
                            "disabled": _vm.disabled,
                            "required": _vm.required,
                            "name": _vm.name
                        },
                        domProps: {
                            "value": _vm.nativeValue,
                            "checked": Array.isArray(_vm.computedValue) ? _vm._i(_vm.computedValue, _vm.nativeValue) > -1 : _vm.computedValue
                        },
                        on: {
                            "click": function click($event) {
                                $event.stopPropagation();
                            },
                            "focus": function focus($event) {
                                _vm.isFocused = true;
                            },
                            "blur": function blur($event) {
                                _vm.isFocused = false;
                            },
                            "change": function change($event) {
                                var $$a = _vm.computedValue,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false;
                                if (Array.isArray($$a)) {
                                    var $$v = _vm.nativeValue,
                                        $$i = _vm._i($$a, $$v);
                                    if ($$el.checked) {
                                        $$i < 0 && (_vm.computedValue = $$a.concat([$$v]));
                                    } else {
                                        $$i > -1 && (_vm.computedValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                                    }
                                } else {
                                    _vm.computedValue = $$c;
                                }
                            }
                        }
                    })], 2)]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 118 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(119),
            /* template */
            __webpack_require__(120),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 119 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BCollapse',
                props: {
                    open: {
                        type: Boolean,
                        default: true
                    },
                    animation: {
                        type: String,
                        default: 'fade'
                    },
                    ariaId: {
                        type: String,
                        default: ''
                    }
                },
                data: function data() {
                    return {
                        isOpen: this.open
                    };
                },

                watch: {
                    open: function open(value) {
                        this.isOpen = value;
                    }
                },
                methods: {
                    /**
                    * Toggle and emit events
                    */
                    toggle: function toggle() {
                        this.isOpen = !this.isOpen;
                        this.$emit('update:open', this.isOpen);
                        this.$emit(this.isOpen ? 'open' : 'close');
                    }
                }
            };

            /***/
        },
        /* 120 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "collapse"
                    }, [_c('div', {
                        staticClass: "collapse-trigger",
                        on: {
                            "click": _vm.toggle
                        }
                    }, [_vm._t("trigger", null, {
                        open: _vm.isOpen
                    })], 2), _vm._v(" "), _c('transition', {
                        attrs: {
                            "name": _vm.animation
                        }
                    }, [_c('div', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isOpen,
                            expression: "isOpen"
                        }],
                        staticClass: "collapse-content",
                        attrs: {
                            "id": _vm.ariaId,
                            "aria-expanded": _vm.isOpen
                        }
                    }, [_vm._t("default")], 2)])], 1);
                }, staticRenderFns: []

                /***/ };
        },
        /* 121 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(122),
            /* template */
            __webpack_require__(134),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 122 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__utils_TimepickerMixin__ = __webpack_require__(62);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__dropdown_Dropdown__ = __webpack_require__(28);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__dropdown_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dropdown_Dropdown__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__dropdown_DropdownItem__ = __webpack_require__(29);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__dropdown_DropdownItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__dropdown_DropdownItem__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__input_Input__ = __webpack_require__(17);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__input_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__input_Input__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__field_Field__ = __webpack_require__(30);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__field_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__field_Field__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__icon_Icon__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__ClockpickerFace__ = __webpack_require__(131);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__ClockpickerFace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ClockpickerFace__);

            var _components;

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            var outerPadding = 12;

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BClockpicker',
                components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7__ClockpickerFace___default.a.name, __WEBPACK_IMPORTED_MODULE_7__ClockpickerFace___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4__input_Input___default.a.name, __WEBPACK_IMPORTED_MODULE_4__input_Input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5__field_Field___default.a.name, __WEBPACK_IMPORTED_MODULE_5__field_Field___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_6__icon_Icon___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2__dropdown_Dropdown___default.a.name, __WEBPACK_IMPORTED_MODULE_2__dropdown_Dropdown___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3__dropdown_DropdownItem___default.a.name, __WEBPACK_IMPORTED_MODULE_3__dropdown_DropdownItem___default.a), _components),
                mixins: [__WEBPACK_IMPORTED_MODULE_1__utils_TimepickerMixin__["a" /* default */]],
                props: {
                    pickerSize: {
                        type: Number,
                        default: 290
                    },
                    hourFormat: {
                        type: String,
                        default: '12',
                        validator: function validator(value) {
                            return value === '24' || value === '12';
                        }
                    },
                    incrementMinutes: {
                        type: Number,
                        default: 5
                    },
                    autoSwitch: {
                        type: Boolean,
                        default: true
                    },
                    type: {
                        type: String,
                        default: 'is-primary'
                    }
                },
                data: function data() {
                    return {
                        isSelectingHour: true,
                        isDragging: false,
                        _isClockpicker: true
                    };
                },

                computed: {
                    hoursDisplay: function hoursDisplay() {
                        if (this.hoursSelected == null) return '--';
                        if (this.isHourFormat24) return this.pad(this.hoursSelected);

                        var display = this.hoursSelected;
                        if (this.meridienSelected === this.PM) display -= 12;
                        if (display === 0) display = 12;
                        return display;
                    },
                    minutesDisplay: function minutesDisplay() {
                        return this.minutesSelected == null ? '--' : this.pad(this.minutesSelected);
                    },
                    minFaceValue: function minFaceValue() {
                        return this.isSelectingHour && !this.isHourFormat24 && this.meridienSelected === this.PM ? 12 : 0;
                    },
                    maxFaceValue: function maxFaceValue() {
                        return this.isSelectingHour ? !this.isHourFormat24 && this.meridienSelected === this.AM ? 11 : 23 : 59;
                    },
                    faceFormatter: function faceFormatter() {
                        return this.isSelectingHour && !this.isHourFormat24 ? function (val) {
                            return val;
                        } : this.formatNumber;
                    },
                    faceSize: function faceSize() {
                        return this.pickerSize - outerPadding * 2;
                    },
                    faceDisabledValues: function faceDisabledValues() {
                        return this.isSelectingHour ? this.isHourDisabled : this.isMinuteDisabled;
                    }
                },
                methods: {
                    onClockInput: function onClockInput(value) {
                        if (this.isSelectingHour) {
                            this.hoursSelected = value;
                            this.onHoursChange(value);
                        } else {
                            this.minutesSelected = value;
                            this.onMinutesChange(value);
                        }
                    },
                    onClockChange: function onClockChange(value) {
                        if (this.autoSwitch && this.isSelectingHour) {
                            this.isSelectingHour = !this.isSelectingHour;
                        }
                    },
                    onMeridienClick: function onMeridienClick(value) {
                        if (this.meridienSelected !== value) {
                            this.meridienSelected = value;
                            this.onMeridienChange(value);
                        }
                    }
                }
            };

            /***/
        },
        /* 123 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(59);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__(5);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__utils_config__ = __webpack_require__(2);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BDropdown',
                props: {
                    value: {
                        type: [String, Number, Boolean, Object, Array, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a, Function],
                        default: null
                    },
                    disabled: Boolean,
                    hoverable: Boolean,
                    inline: Boolean,
                    position: {
                        type: String,
                        validator: function validator(value) {
                            return ['is-top-right', 'is-top-left', 'is-bottom-left'].indexOf(value) > -1;
                        }
                    },
                    mobileModal: {
                        type: Boolean,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_2__utils_config__["a" /* default */].defaultDropdownMobileModal;
                        }
                    },
                    ariaRole: {
                        type: String,
                        default: ''
                    },
                    animation: {
                        type: String,
                        default: 'fade'
                    },
                    multiple: Boolean,
                    closeOnClick: {
                        type: Boolean,
                        default: true
                    }
                },
                data: function data() {
                    return {
                        selected: this.value,
                        isActive: false,
                        isHoverable: this.hoverable,
                        _isDropdown: true // Used internally by DropdownItem
                    };
                },

                computed: {
                    rootClasses: function rootClasses() {
                        return [this.position, {
                            'is-disabled': this.disabled,
                            'is-hoverable': this.hoverable,
                            'is-inline': this.inline,
                            'is-active': this.isActive || this.inline,
                            'is-mobile-modal': this.isMobileModal
                        }];
                    },
                    isMobileModal: function isMobileModal() {
                        return this.mobileModal && !this.inline && !this.hoverable;
                    },
                    ariaRoleMenu: function ariaRoleMenu() {
                        return this.ariaRole === 'menu' || this.ariaRole === 'list' ? this.ariaRole : null;
                    }
                },
                watch: {
                    /**
                    * When v-model is changed set the new selected item.
                    */
                    value: function value(_value) {
                        this.selected = _value;
                    },

                    /**
                    * Emit event when isActive value is changed.
                    */
                    isActive: function isActive(value) {
                        this.$emit('active-change', value);
                    }
                },
                methods: {
                    /**
                    * Click listener from DropdownItem.
                    *   1. Set new selected item.
                    *   2. Emit input event to update the user v-model.
                    *   3. Close the dropdown.
                    */
                    selectItem: function selectItem(value) {
                        if (this.multiple) {
                            if (this.selected) {
                                var index = this.selected.indexOf(value);
                                if (index === -1) {
                                    this.selected.push(value);
                                } else {
                                    this.selected.splice(index, 1);
                                }
                            } else {
                                this.selected = [value];
                            }
                            this.$emit('change', this.selected);
                        } else {
                            if (this.selected !== value) {
                                this.selected = value;
                                this.$emit('change', this.selected);
                            }
                        }
                        this.$emit('input', this.selected);
                        if (!this.multiple) {
                            this.isActive = !this.closeOnClick;
                            /*
                            * breaking change
                            if (this.hoverable && this.closeOnClick) {
                                this.isHoverable = false
                                // Timeout for the animation complete before destroying
                                setTimeout(() => {
                                    this.isHoverable = true
                                }, 250)
                            }
                            */
                        }
                    },

                    /**
                    * White-listed items to not close when clicked.
                    */
                    isInWhiteList: function isInWhiteList(el) {
                        if (el === this.$refs.dropdownMenu) return true;
                        if (el === this.$refs.trigger) return true;
                        // All chidren from dropdown
                        if (this.$refs.dropdownMenu !== undefined) {
                            var children = this.$refs.dropdownMenu.querySelectorAll('*');
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var child = _step.value;

                                    if (el === child) {
                                        return true;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        // All children from trigger
                        if (this.$refs.trigger !== undefined) {
                            var _children = this.$refs.trigger.querySelectorAll('*');
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var _child = _step2.value;

                                    if (el === _child) {
                                        return true;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }

                        return false;
                    },

                    /**
                    * Close dropdown if clicked outside.
                    */
                    clickedOutside: function clickedOutside(event) {
                        if (this.inline) return;

                        if (!this.isInWhiteList(event.target)) this.isActive = false;
                    },

                    /**
                    * Toggle dropdown if it's not disabled.
                    */
                    toggle: function toggle() {
                        var _this = this;

                        if (this.disabled) return;

                        if (!this.isActive) {
                            // if not active, toggle after clickOutside event
                            // this fixes toggling programmatic
                            this.$nextTick(function () {
                                var value = !_this.isActive;
                                _this.isActive = value;
                                // Vue 2.6.x ???
                                setTimeout(function () {
                                    return _this.isActive = value;
                                });
                            });
                        } else {
                            this.isActive = !this.isActive;
                        }
                    }
                },
                created: function created() {
                    if (typeof window !== 'undefined') {
                        document.addEventListener('click', this.clickedOutside);
                    }
                },
                beforeDestroy: function beforeDestroy() {
                    if (typeof window !== 'undefined') {
                        document.removeEventListener('click', this.clickedOutside);
                    }
                }
            };

            /***/
        },
        /* 124 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "dropdown",
                        class: _vm.rootClasses
                    }, [!_vm.inline ? _c('div', {
                        ref: "trigger",
                        staticClass: "dropdown-trigger",
                        attrs: {
                            "role": "button",
                            "aria-haspopup": "true"
                        },
                        on: {
                            "click": _vm.toggle
                        }
                    }, [_vm._t("trigger")], 2) : _vm._e(), _vm._v(" "), _c('transition', {
                        attrs: {
                            "name": _vm.animation
                        }
                    }, [_vm.isMobileModal ? _c('div', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isActive,
                            expression: "isActive"
                        }],
                        staticClass: "background",
                        attrs: {
                            "aria-hidden": !_vm.isActive
                        }
                    }) : _vm._e()]), _vm._v(" "), _c('transition', {
                        attrs: {
                            "name": _vm.animation
                        }
                    }, [_c('div', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.disabled && (_vm.isActive || _vm.isHoverable) || _vm.inline,
                            expression: "(!disabled && (isActive || isHoverable)) || inline"
                        }],
                        ref: "dropdownMenu",
                        staticClass: "dropdown-menu",
                        attrs: {
                            "aria-hidden": !_vm.isActive
                        }
                    }, [_c('div', {
                        staticClass: "dropdown-content",
                        attrs: {
                            "role": _vm.ariaRoleMenu
                        }
                    }, [_vm._t("default")], 2)])])], 1);
                }, staticRenderFns: []

                /***/ };
        },
        /* 125 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__ = __webpack_require__(5);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BDropdownItem',
                props: {
                    value: {
                        type: [String, Number, Boolean, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a, Function],
                        default: null
                    },
                    separator: Boolean,
                    disabled: Boolean,
                    custom: Boolean,
                    paddingless: Boolean,
                    hasLink: Boolean,
                    ariaRole: {
                        type: String,
                        default: ''
                    }
                },
                computed: {
                    anchorClasses: function anchorClasses() {
                        return {
                            'is-disabled': this.$parent.disabled || this.disabled,
                            'is-paddingless': this.paddingless,
                            'is-active': this.isActive
                        };
                    },
                    itemClasses: function itemClasses() {
                        return {
                            'dropdown-item': !this.hasLink,
                            'is-disabled': this.disabled,
                            'is-paddingless': this.paddingless,
                            'is-active': this.isActive,
                            'has-link': this.hasLink
                        };
                    },
                    ariaRoleItem: function ariaRoleItem() {
                        return this.ariaRole === 'menuitem' || this.ariaRole === 'listitem' ? this.ariaRole : null;
                    },

                    /**
                    * Check if item can be clickable.
                    */
                    isClickable: function isClickable() {
                        return !this.$parent.disabled && !this.separator && !this.disabled && !this.custom;
                    },
                    isActive: function isActive() {
                        if (this.$parent.selected === null) return false;
                        if (this.$parent.multiple) return this.$parent.selected.indexOf(this.value) >= 0;
                        return this.value === this.$parent.selected;
                    }
                },
                methods: {
                    /**
                    * Click listener, select the item.
                    */
                    selectItem: function selectItem() {
                        if (!this.isClickable) return;

                        this.$parent.selectItem(this.value);
                        this.$emit('click');
                    }
                },
                created: function created() {
                    if (!this.$parent.$data._isDropdown) {
                        this.$destroy();
                        throw new Error('You should wrap bDropdownItem on a bDropdown');
                    }
                }
            };

            /***/
        },
        /* 126 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _vm.separator ? _c('hr', {
                        staticClass: "dropdown-divider"
                    }) : !_vm.custom && !_vm.hasLink ? _c('a', {
                        staticClass: "dropdown-item",
                        class: _vm.anchorClasses,
                        attrs: {
                            "role": _vm.ariaRoleItem,
                            "tabindex": "0"
                        },
                        on: {
                            "click": _vm.selectItem
                        }
                    }, [_vm._t("default")], 2) : _c('div', {
                        class: _vm.itemClasses,
                        attrs: {
                            "role": _vm.ariaRoleItem,
                            "tabindex": "0"
                        },
                        on: {
                            "click": _vm.selectItem
                        }
                    }, [_vm._t("default")], 2);
                }, staticRenderFns: []

                /***/ };
        },
        /* 127 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__utils_config__ = __webpack_require__(2);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__FieldBody__ = __webpack_require__(128);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__FieldBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FieldBody__);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BField',
                components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__FieldBody___default.a.name, __WEBPACK_IMPORTED_MODULE_2__FieldBody___default.a),
                props: {
                    type: [String, Object],
                    label: String,
                    labelFor: String,
                    message: [String, Array, Object],
                    grouped: Boolean,
                    groupMultiline: Boolean,
                    position: String,
                    expanded: Boolean,
                    horizontal: Boolean,
                    addons: {
                        type: Boolean,
                        default: true
                    },
                    customClass: String,
                    labelPosition: {
                        type: String,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_1__utils_config__["a" /* default */].defaultFieldLabelPosition;
                        }
                    }
                },
                data: function data() {
                    return {
                        newType: this.type,
                        newMessage: this.message,
                        fieldLabelSize: null,
                        _isField: true // Used internally by Input and Select
                    };
                },

                computed: {
                    rootClasses: function rootClasses() {
                        return [this.newPosition, {
                            'is-expanded': this.expanded,
                            'is-grouped-multiline': this.groupMultiline,
                            'is-horizontal': this.horizontal,
                            'is-floating-in-label': this.hasLabel && !this.horizontal && this.labelPosition === 'inside',
                            'is-floating-label': this.hasLabel && !this.horizontal && this.labelPosition === 'on-border'
                        }];
                    },

                    /**
                    * Correct Bulma class for the side of the addon or group.
                    *
                    * This is not kept like the others (is-small, etc.),
                    * because since 'has-addons' is set automatically it
                    * doesn't make sense to teach users what addons are exactly.
                    */
                    newPosition: function newPosition() {
                        if (this.position === undefined) return;

                        var position = this.position.split('-');
                        if (position.length < 1) return;

                        var prefix = this.grouped ? 'is-grouped-' : 'has-addons-';

                        if (this.position) return prefix + position[1];
                    },

                    /**
                    * Formatted message in case it's an array
                    * (each element is separated by <br> tag)
                    */
                    formattedMessage: function formattedMessage() {
                        if (typeof this.newMessage === 'string') {
                            return this.newMessage;
                        } else {
                            var messages = [];
                            if (Array.isArray(this.newMessage)) {
                                this.newMessage.forEach(function (message) {
                                    if (typeof message === 'string') {
                                        messages.push(message);
                                    } else {
                                        for (var key in message) {
                                            if (message[key]) {
                                                messages.push(key);
                                            }
                                        }
                                    }
                                });
                            } else {
                                for (var key in this.newMessage) {
                                    if (this.newMessage[key]) {
                                        messages.push(key);
                                    }
                                }
                            }
                            return messages.filter(function (m) {
                                if (m) return m;
                            }).join(' <br> ');
                        }
                    },
                    hasLabel: function hasLabel() {
                        return this.label || this.$slots.label;
                    }
                },
                watch: {
                    /**
                    * Set internal type when prop change.
                    */
                    type: function type(value) {
                        this.newType = value;
                    },

                    /**
                    * Set internal message when prop change.
                    */
                    message: function message(value) {
                        this.newMessage = value;
                    }
                },
                methods: {
                    /**
                    * Field has addons if there are more than one slot
                    * (element / component) in the Field.
                    * Or is grouped when prop is set.
                    * Is a method to be called when component re-render.
                    */
                    fieldType: function fieldType() {
                        if (this.grouped) return 'is-grouped';

                        var renderedNode = 0;
                        if (this.$slots.default) {
                            renderedNode = this.$slots.default.reduce(function (i, node) {
                                return node.tag ? i + 1 : i;
                            }, 0);
                        }
                        if (renderedNode > 1 && this.addons && !this.horizontal) {
                            return 'has-addons';
                        }
                    }
                },
                mounted: function mounted() {
                    if (this.horizontal) {
                        // Bulma docs: .is-normal for any .input or .button
                        var elements = this.$el.querySelectorAll('.input, .select, .button, .textarea');
                        if (elements.length > 0) {
                            this.fieldLabelSize = 'is-normal';
                        }
                    }
                }
            };

            /***/
        },
        /* 128 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(129),
            /* template */
            null,
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 129 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BFieldBody',
                props: {
                    message: {
                        type: String
                    },
                    type: {
                        type: [String, Object]
                    }
                },
                render: function render(createElement) {
                    var _this = this;

                    return createElement('div', { attrs: { 'class': 'field-body' } }, this.$slots.default.map(function (element) {
                        // skip returns and comments
                        if (!element.tag) {
                            return element;
                        }
                        if (_this.message) {
                            return createElement('b-field', { attrs: { message: _this.message, 'type': _this.type } }, [element]);
                        }
                        return createElement('b-field', { attrs: { 'type': _this.type } }, [element]);
                    }));
                }
            };

            /***/
        },
        /* 130 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "field",
                        class: [_vm.rootClasses, _vm.fieldType()]
                    }, [_vm.horizontal ? _c('div', {
                        staticClass: "field-label",
                        class: [_vm.customClass, _vm.fieldLabelSize]
                    }, [_vm.hasLabel ? _c('label', {
                        staticClass: "label",
                        class: _vm.customClass,
                        attrs: {
                            "for": _vm.labelFor
                        }
                    }, [_vm.$slots.label ? _vm._t("label") : [_vm._v(_vm._s(_vm.label))]], 2) : _vm._e()]) : [_vm.hasLabel ? _c('label', {
                        staticClass: "label",
                        class: _vm.customClass,
                        attrs: {
                            "for": _vm.labelFor
                        }
                    }, [_vm.$slots.label ? _vm._t("label") : [_vm._v(_vm._s(_vm.label))]], 2) : _vm._e()], _vm._v(" "), _vm.horizontal ? _c('b-field-body', {
                        attrs: {
                            "message": _vm.newMessage ? _vm.formattedMessage : '',
                            "type": _vm.newType
                        }
                    }, [_vm._t("default")], 2) : [_vm._t("default")], _vm._v(" "), _vm.newMessage && !_vm.horizontal ? _c('p', {
                        staticClass: "help",
                        class: _vm.newType,
                        domProps: {
                            "innerHTML": _vm._s(_vm.formattedMessage)
                        }
                    }) : _vm._e()], 2);
                }, staticRenderFns: []

                /***/ };
        },
        /* 131 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(132),
            /* template */
            __webpack_require__(133),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 132 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            // These should match the variables in clockpicker.scss
            var indicatorSize = 40;
            var paddingInner = 5;

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BClockpickerFace',
                props: {
                    pickerSize: Number,
                    min: Number,
                    max: Number,
                    double: Boolean,
                    value: Number,
                    faceNumbers: Array,
                    disabledValues: Function
                },
                data: function data() {
                    return {
                        isDragging: false,
                        inputValue: this.value,
                        prevAngle: 720
                    };
                },

                computed: {
                    /**
                    * How many number indicators are shown on the face
                    */
                    count: function count() {
                        return this.max - this.min + 1;
                    },

                    /**
                    * How many number indicators are shown per ring on the face
                    */
                    countPerRing: function countPerRing() {
                        return this.double ? this.count / 2 : this.count;
                    },

                    /**
                    * Radius of the clock face
                    */
                    radius: function radius() {
                        return this.pickerSize / 2;
                    },

                    /**
                    * Radius of the outer ring of number indicators
                    */
                    outerRadius: function outerRadius() {
                        return this.radius - paddingInner - indicatorSize / 2;
                    },

                    /**
                    * Radius of the inner ring of number indicators
                    */
                    innerRadius: function innerRadius() {
                        return Math.max(this.outerRadius * 0.6, this.outerRadius - paddingInner - indicatorSize);
                        // 48px gives enough room for the outer ring of numbers
                    },

                    /**
                    * The angle for each selectable value
                    * For hours this ends up being 30 degrees, for minutes 6 degrees
                    */
                    degreesPerUnit: function degreesPerUnit() {
                        return 360 / this.countPerRing;
                    },

                    /**
                    * Used for calculating x/y grid location based on degrees
                    */
                    degrees: function degrees() {
                        return this.degreesPerUnit * Math.PI / 180;
                    },

                    /**
                    * Calculates the angle the clock hand should be rotated for the
                    * selected value
                    */
                    handRotateAngle: function handRotateAngle() {
                        var currentAngle = this.prevAngle;
                        while (currentAngle < 0) {
                            currentAngle += 360;
                        }var targetAngle = this.calcHandAngle(this.displayedValue);
                        var degreesDiff = this.shortestDistanceDegrees(currentAngle, targetAngle);
                        var angle = this.prevAngle + degreesDiff;
                        return angle;
                    },

                    /**
                    * Determines how long the selector hand is based on if the
                    * selected value is located along the outer or inner ring
                    */
                    handScale: function handScale() {
                        return this.calcHandScale(this.displayedValue);
                    },
                    handStyle: function handStyle() {
                        return {
                            transform: 'rotate(' + this.handRotateAngle + 'deg) scaleY(' + this.handScale + ')',
                            transition: '.3s cubic-bezier(.25,.8,.50,1)'
                        };
                    },

                    /**
                    * The value the hand should be pointing at
                    */
                    displayedValue: function displayedValue() {
                        return this.inputValue == null ? this.min : this.inputValue;
                    }
                },
                watch: {
                    value: function value(_value) {
                        if (_value !== this.inputValue) {
                            this.prevAngle = this.handRotateAngle;
                        }
                        this.inputValue = _value;
                    }
                },
                methods: {
                    isDisabled: function isDisabled(value) {
                        return this.disabledValues && this.disabledValues(value);
                    },

                    /**
                    * Calculates the distance between two points
                    */
                    euclidean: function euclidean(p0, p1) {
                        var dx = p1.x - p0.x;
                        var dy = p1.y - p0.y;

                        return Math.sqrt(dx * dx + dy * dy);
                    },
                    shortestDistanceDegrees: function shortestDistanceDegrees(start, stop) {
                        var modDiff = (stop - start) % 360;
                        var shortestDistance = 180 - Math.abs(Math.abs(modDiff) - 180);
                        return (modDiff + 360) % 360 < 180 ? shortestDistance * 1 : shortestDistance * -1;
                    },

                    /**
                    * Calculates the angle of the line from the center point
                    * to the given point.
                    */
                    coordToAngle: function coordToAngle(center, p1) {
                        var value = 2 * Math.atan2(p1.y - center.y - this.euclidean(center, p1), p1.x - center.x);
                        return Math.abs(value * 180 / Math.PI);
                    },

                    /**
                    * Generates the inline style translate() property for a
                    * number indicator, which determines it's location on the
                    * clock face
                    */
                    getNumberTranslate: function getNumberTranslate(value) {
                        var _getNumberCoords = this.getNumberCoords(value),
                            x = _getNumberCoords.x,
                            y = _getNumberCoords.y;

                        return 'translate(' + x + 'px, ' + y + 'px)';
                    },

                    /***
                    * Calculates the coordinates on the clock face for a number
                    * indicator value
                    */
                    getNumberCoords: function getNumberCoords(value) {
                        var radius = this.isInnerRing(value) ? this.innerRadius : this.outerRadius;
                        return {
                            x: Math.round(radius * Math.sin((value - this.min) * this.degrees)),
                            y: Math.round(-radius * Math.cos((value - this.min) * this.degrees))
                        };
                    },
                    getFaceNumberClasses: function getFaceNumberClasses(num) {
                        return {
                            'active': num.value === this.displayedValue,
                            'disabled': this.isDisabled(num.value)
                        };
                    },

                    /**
                    * Determines if a value resides on the inner ring
                    */
                    isInnerRing: function isInnerRing(value) {
                        return this.double && value - this.min >= this.countPerRing;
                    },
                    calcHandAngle: function calcHandAngle(value) {
                        var angle = this.degreesPerUnit * (value - this.min);
                        if (this.isInnerRing(value)) angle -= 360;
                        return angle;
                    },
                    calcHandScale: function calcHandScale(value) {
                        return this.isInnerRing(value) ? this.innerRadius / this.outerRadius : 1;
                    },
                    onMouseDown: function onMouseDown(e) {
                        e.preventDefault();
                        this.isDragging = true;
                        this.onDragMove(e);
                    },
                    onMouseUp: function onMouseUp() {
                        this.isDragging = false;
                        if (!this.isDisabled(this.inputValue)) {
                            this.$emit('change', this.inputValue);
                        }
                    },
                    onDragMove: function onDragMove(e) {
                        e.preventDefault();
                        if (!this.isDragging && e.type !== 'click') return;

                        var _$refs$clock$getBound = this.$refs.clock.getBoundingClientRect(),
                            width = _$refs$clock$getBound.width,
                            top = _$refs$clock$getBound.top,
                            left = _$refs$clock$getBound.left;

                        var _ref = 'touches' in e ? e.touches[0] : e,
                            clientX = _ref.clientX,
                            clientY = _ref.clientY;

                        var center = { x: width / 2, y: -width / 2 };
                        var coords = { x: clientX - left, y: top - clientY };
                        var handAngle = Math.round(this.coordToAngle(center, coords) + 360) % 360;
                        var insideClick = this.double && this.euclidean(center, coords) < (this.outerRadius + this.innerRadius) / 2 - 16;

                        var value = Math.round(handAngle / this.degreesPerUnit) + this.min + (insideClick ? this.countPerRing : 0);

                        // Necessary to fix edge case when selecting left part of max value
                        if (handAngle >= 360 - this.degreesPerUnit / 2) {
                            value = insideClick ? this.max : this.min;
                        }
                        this.update(value);
                    },
                    update: function update(value) {
                        if (this.inputValue !== value && !this.isDisabled(value)) {
                            this.prevAngle = this.handRotateAngle;
                            this.inputValue = value;
                            this.$emit('input', value);
                        }
                    }
                }
            };

            /***/
        },
        /* 133 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "b-clockpicker-face",
                        on: {
                            "mousedown": _vm.onMouseDown,
                            "mouseup": _vm.onMouseUp,
                            "mousemove": _vm.onDragMove,
                            "touchstart": _vm.onMouseDown,
                            "touchend": _vm.onMouseUp,
                            "touchmove": _vm.onDragMove
                        }
                    }, [_c('div', {
                        ref: "clock",
                        staticClass: "b-clockpicker-face-outer-ring"
                    }, [_c('div', {
                        staticClass: "b-clockpicker-face-hand",
                        style: _vm.handStyle
                    }), _vm._v(" "), _vm._l(_vm.faceNumbers, function (num, index) {
                        return _c('span', {
                            key: index,
                            staticClass: "b-clockpicker-face-number",
                            class: _vm.getFaceNumberClasses(num),
                            style: {
                                transform: _vm.getNumberTranslate(num.value)
                            }
                        }, [_c('span', [_vm._v(_vm._s(num.label))])]);
                    })], 2)]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 134 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "b-clockpicker control",
                        class: [_vm.size, _vm.type, {
                            'is-expanded': _vm.expanded
                        }]
                    }, [!_vm.isMobile || _vm.inline ? _c('b-dropdown', {
                        ref: "dropdown",
                        attrs: {
                            "position": _vm.position,
                            "disabled": _vm.disabled,
                            "inline": _vm.inline
                        }
                    }, [!_vm.inline ? _c('b-input', _vm._b({
                        ref: "input",
                        attrs: {
                            "slot": "trigger",
                            "autocomplete": "off",
                            "value": _vm.formatValue(_vm.computedValue),
                            "placeholder": _vm.placeholder,
                            "size": _vm.size,
                            "icon": _vm.icon,
                            "icon-pack": _vm.iconPack,
                            "loading": _vm.loading,
                            "disabled": _vm.disabled,
                            "readonly": !_vm.editable,
                            "rounded": _vm.rounded,
                            "use-html5-validation": _vm.useHtml5Validation
                        },
                        on: {
                            "focus": _vm.handleOnFocus,
                            "blur": function blur($event) {
                                _vm.onBlur() && _vm.checkHtml5Validity();
                            }
                        },
                        nativeOn: {
                            "click": function click($event) {
                                $event.stopPropagation();
                                _vm.toggle(true);
                            },
                            "keyup": function keyup($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                    return null;
                                }
                                _vm.toggle(true);
                            },
                            "change": function change($event) {
                                _vm.onChangeNativePicker($event);
                            }
                        },
                        slot: "trigger"
                    }, 'b-input', _vm.$attrs, false)) : _vm._e(), _vm._v(" "), _c('div', {
                        staticClass: "card",
                        attrs: {
                            "disabled": _vm.disabled,
                            "custom": ""
                        }
                    }, [_vm.inline ? _c('header', {
                        staticClass: "card-header"
                    }, [_c('div', {
                        staticClass: "b-clockpicker-header card-header-title"
                    }, [_c('div', {
                        staticClass: "b-clockpicker-time"
                    }, [_c('span', {
                        staticClass: "b-clockpicker-btn",
                        class: {
                            active: _vm.isSelectingHour
                        },
                        on: {
                            "click": function click($event) {
                                _vm.isSelectingHour = true;
                            }
                        }
                    }, [_vm._v(_vm._s(_vm.hoursDisplay))]), _vm._v(" "), _c('span', [_vm._v(":")]), _vm._v(" "), _c('span', {
                        staticClass: "b-clockpicker-btn",
                        class: {
                            active: !_vm.isSelectingHour
                        },
                        on: {
                            "click": function click($event) {
                                _vm.isSelectingHour = false;
                            }
                        }
                    }, [_vm._v(_vm._s(_vm.minutesDisplay))])]), _vm._v(" "), !_vm.isHourFormat24 ? _c('div', {
                        staticClass: "b-clockpicker-period"
                    }, [_c('div', {
                        staticClass: "b-clockpicker-btn",
                        class: {
                            active: _vm.meridienSelected == _vm.AM
                        },
                        on: {
                            "click": function click($event) {
                                _vm.onMeridienClick(_vm.AM);
                            }
                        }
                    }, [_vm._v("am")]), _vm._v(" "), _c('div', {
                        staticClass: "b-clockpicker-btn",
                        class: {
                            active: _vm.meridienSelected == _vm.PM
                        },
                        on: {
                            "click": function click($event) {
                                _vm.onMeridienClick(_vm.PM);
                            }
                        }
                    }, [_vm._v("pm")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
                        staticClass: "card-content"
                    }, [_c('div', {
                        staticClass: "b-clockpicker-body",
                        style: {
                            width: _vm.faceSize + 'px',
                            height: _vm.faceSize + 'px'
                        }
                    }, [!_vm.inline ? _c('div', {
                        staticClass: "b-clockpicker-time"
                    }, [_c('div', {
                        staticClass: "b-clockpicker-btn",
                        class: {
                            active: _vm.isSelectingHour
                        },
                        on: {
                            "click": function click($event) {
                                _vm.isSelectingHour = true;
                            }
                        }
                    }, [_vm._v("Hours")]), _vm._v(" "), _c('span', {
                        staticClass: "b-clockpicker-btn",
                        class: {
                            active: !_vm.isSelectingHour
                        },
                        on: {
                            "click": function click($event) {
                                _vm.isSelectingHour = false;
                            }
                        }
                    }, [_vm._v("Min")])]) : _vm._e(), _vm._v(" "), !_vm.isHourFormat24 && !_vm.inline ? _c('div', {
                        staticClass: "b-clockpicker-period"
                    }, [_c('div', {
                        staticClass: "b-clockpicker-btn",
                        class: {
                            active: _vm.meridienSelected == _vm.AM
                        },
                        on: {
                            "click": function click($event) {
                                _vm.onMeridienClick(_vm.AM);
                            }
                        }
                    }, [_vm._v(_vm._s(_vm.AM))]), _vm._v(" "), _c('div', {
                        staticClass: "b-clockpicker-btn",
                        class: {
                            active: _vm.meridienSelected == _vm.PM
                        },
                        on: {
                            "click": function click($event) {
                                _vm.onMeridienClick(_vm.PM);
                            }
                        }
                    }, [_vm._v(_vm._s(_vm.PM))])]) : _vm._e(), _vm._v(" "), _c('b-clockpicker-face', {
                        attrs: {
                            "picker-size": _vm.faceSize,
                            "min": _vm.minFaceValue,
                            "max": _vm.maxFaceValue,
                            "face-numbers": _vm.isSelectingHour ? _vm.hours : _vm.minutes,
                            "disabled-values": _vm.faceDisabledValues,
                            "double": _vm.isSelectingHour && _vm.isHourFormat24,
                            "value": _vm.isSelectingHour ? _vm.hoursSelected : _vm.minutesSelected
                        },
                        on: {
                            "input": _vm.onClockInput,
                            "change": _vm.onClockChange
                        }
                    })], 1)]), _vm._v(" "), _vm.$slots.default !== undefined && _vm.$slots.default.length ? _c('footer', {
                        staticClass: "b-clockpicker-footer card-footer"
                    }, [_vm._t("default")], 2) : _vm._e()])], 1) : _c('b-input', _vm._b({
                        ref: "input",
                        attrs: {
                            "type": "time",
                            "autocomplete": "off",
                            "value": _vm.formatHHMMSS(_vm.computedValue),
                            "placeholder": _vm.placeholder,
                            "size": _vm.size,
                            "icon": _vm.icon,
                            "icon-pack": _vm.iconPack,
                            "loading": _vm.loading,
                            "max": _vm.formatHHMMSS(_vm.maxTime),
                            "min": _vm.formatHHMMSS(_vm.minTime),
                            "disabled": _vm.disabled,
                            "readonly": false,
                            "use-html5-validation": _vm.useHtml5Validation
                        },
                        on: {
                            "focus": _vm.handleOnFocus,
                            "blur": function blur($event) {
                                _vm.onBlur() && _vm.checkHtml5Validity();
                            }
                        },
                        nativeOn: {
                            "click": function click($event) {
                                $event.stopPropagation();
                                _vm.toggle(true);
                            },
                            "keyup": function keyup($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                    return null;
                                }
                                _vm.toggle(true);
                            },
                            "change": function change($event) {
                                _vm.onChangeNativePicker($event);
                            }
                        }
                    }, 'b-input', _vm.$attrs, false))], 1);
                }, staticRenderFns: []

                /***/ };
        },
        /* 135 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(136),
            /* template */
            __webpack_require__(148),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 136 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__utils_FormElementMixin__ = __webpack_require__(10);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(7);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__utils_config__ = __webpack_require__(2);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__dropdown_Dropdown__ = __webpack_require__(28);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__dropdown_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__dropdown_Dropdown__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__dropdown_DropdownItem__ = __webpack_require__(29);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__dropdown_DropdownItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__dropdown_DropdownItem__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__input_Input__ = __webpack_require__(17);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__input_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__input_Input__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__field_Field__ = __webpack_require__(30);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__field_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__field_Field__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_8__select_Select__ = __webpack_require__(31);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_8__select_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__select_Select__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_9__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_9__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__icon_Icon__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_10__DatepickerTable__ = __webpack_require__(139);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_10__DatepickerTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__DatepickerTable__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_11__DatepickerMonth__ = __webpack_require__(145);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_11__DatepickerMonth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__DatepickerMonth__);

            var _components;

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            var defaultDateFormatter = function defaultDateFormatter(date, vm) {
                var yyyyMMdd = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
                var d = new Date(yyyyMMdd);
                return !vm.isTypeMonth ? d.toLocaleDateString() : d.toLocaleDateString(undefined, { year: 'numeric', month: '2-digit' });
            };

            var defaultDateParser = function defaultDateParser(date, vm) {
                if (!vm.isTypeMonth) return new Date(Date.parse(date));
                if (date) {
                    var s = date.split('/');
                    var year = s[0].length === 4 ? s[0] : s[1];
                    var month = s[0].length === 2 ? s[0] : s[1];
                    if (year && month) {
                        return new Date(parseInt(year, 10), parseInt(month - 1, 10), 1, 0, 0, 0, 0);
                    }
                }
                return null;
            };

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BDatepicker',
                components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10__DatepickerTable___default.a.name, __WEBPACK_IMPORTED_MODULE_10__DatepickerTable___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11__DatepickerMonth___default.a.name, __WEBPACK_IMPORTED_MODULE_11__DatepickerMonth___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6__input_Input___default.a.name, __WEBPACK_IMPORTED_MODULE_6__input_Input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7__field_Field___default.a.name, __WEBPACK_IMPORTED_MODULE_7__field_Field___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8__select_Select___default.a.name, __WEBPACK_IMPORTED_MODULE_8__select_Select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_9__icon_Icon___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4__dropdown_Dropdown___default.a.name, __WEBPACK_IMPORTED_MODULE_4__dropdown_Dropdown___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5__dropdown_DropdownItem___default.a.name, __WEBPACK_IMPORTED_MODULE_5__dropdown_DropdownItem___default.a), _components),
                mixins: [__WEBPACK_IMPORTED_MODULE_1__utils_FormElementMixin__["a" /* default */]],
                inheritAttrs: false,
                props: {
                    value: Date,
                    dayNames: {
                        type: Array,
                        default: function _default() {
                            if (Array.isArray(__WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDayNames)) {
                                return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDayNames;
                            } else {
                                return ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'S'];
                            }
                        }
                    },
                    monthNames: {
                        type: Array,
                        default: function _default() {
                            if (Array.isArray(__WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultMonthNames)) {
                                return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultMonthNames;
                            } else {
                                return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                            }
                        }
                    },
                    firstDayOfWeek: {
                        type: Number,
                        default: function _default() {
                            if (typeof __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultFirstDayOfWeek === 'number') {
                                return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultFirstDayOfWeek;
                            } else {
                                return 0;
                            }
                        }
                    },
                    inline: Boolean,
                    minDate: Date,
                    maxDate: Date,
                    focusedDate: Date,
                    placeholder: String,
                    editable: Boolean,
                    disabled: Boolean,
                    unselectableDates: Array,
                    unselectableDaysOfWeek: {
                        type: Array,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultUnselectableDaysOfWeek;
                        }
                    },
                    selectableDates: Array,
                    dateFormatter: {
                        type: Function,
                        default: function _default(date, vm) {
                            if (typeof __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDateFormatter === 'function') {
                                return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDateFormatter(date);
                            } else {
                                return defaultDateFormatter(date, vm);
                            }
                        }
                    },
                    dateParser: {
                        type: Function,
                        default: function _default(date, vm) {
                            if (typeof __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDateParser === 'function') {
                                return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDateParser(date);
                            } else {
                                return defaultDateParser(date, vm);
                            }
                        }
                    },
                    dateCreator: {
                        type: Function,
                        default: function _default() {
                            if (typeof __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDateCreator === 'function') {
                                return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDateCreator();
                            } else {
                                return new Date();
                            }
                        }
                    },
                    mobileNative: {
                        type: Boolean,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDatepickerMobileNative;
                        }
                    },
                    position: String,
                    events: Array,
                    indicators: {
                        type: String,
                        default: 'dots'
                    },
                    openOnFocus: Boolean,
                    yearsRange: {
                        type: Array,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDatepickerYearsRange;
                        }
                    },
                    type: {
                        type: String,
                        validator: function validator(value) {
                            return ['month'].indexOf(value) >= 0;
                        }
                    },
                    nearbyMonthDays: {
                        type: Boolean,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDatepickerNearbyMonthDays;
                        }
                    },
                    nearbySelectableMonthDays: {
                        type: Boolean,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDatepickerNearbySelectableMonthDays;
                        }
                    }
                },
                data: function data() {
                    var focusedDate = this.value || this.focusedDate || this.dateCreator();

                    return {
                        dateSelected: this.value,
                        focusedDateData: {
                            month: focusedDate.getMonth(),
                            year: focusedDate.getFullYear()
                        },
                        _elementRef: 'input',
                        _isDatepicker: true
                    };
                },

                computed: {
                    computedValue: {
                        get: function get() {
                            return this.dateSelected;
                        },
                        set: function set(value) {
                            this.updateInternalState(value);
                            this.togglePicker(false);
                            this.$emit('input', value);
                        }
                    },
                    /*
                    * Returns an array of years for the year dropdown. If earliest/latest
                    * dates are set by props, range of years will fall within those dates.
                    */
                    listOfYears: function listOfYears() {
                        var latestYear = this.focusedDateData.year + this.yearsRange[1];
                        if (this.maxDate && this.maxDate.getFullYear() < latestYear) {
                            latestYear = this.maxDate.getFullYear();
                        }

                        var earliestYear = this.focusedDateData.year + this.yearsRange[0];
                        if (this.minDate && this.minDate.getFullYear() > earliestYear) {
                            earliestYear = this.minDate.getFullYear();
                        }

                        var arrayOfYears = [];
                        for (var i = earliestYear; i <= latestYear; i++) {
                            arrayOfYears.push(i);
                        }

                        return arrayOfYears.reverse();
                    },
                    showPrev: function showPrev() {
                        if (!this.minDate) return false;
                        if (this.isTypeMonth) {
                            return this.focusedDateData.year <= this.minDate.getFullYear();
                        }
                        var dateToCheck = new Date(this.focusedDateData.year, this.focusedDateData.month);
                        var date = new Date(this.minDate.getFullYear(), this.minDate.getMonth());
                        return dateToCheck <= date;
                    },
                    showNext: function showNext() {
                        if (!this.maxDate) return false;
                        if (this.isTypeMonth) {
                            return this.focusedDateData.year >= this.maxDate.getFullYear();
                        }
                        var dateToCheck = new Date(this.focusedDateData.year, this.focusedDateData.month);
                        var date = new Date(this.maxDate.getFullYear(), this.maxDate.getMonth());
                        return dateToCheck >= date;
                    },
                    isMobile: function isMobile() {
                        return this.mobileNative && __WEBPACK_IMPORTED_MODULE_2__utils_helpers__["c" /* isMobile */].any();
                    },
                    isTypeMonth: function isTypeMonth() {
                        return this.type === 'month';
                    }
                },
                watch: {
                    /**
                    * When v-model is changed:
                    *   1. Update internal value.
                    *   2. If it's invalid, validate again.
                    */
                    value: function value(_value) {
                        this.updateInternalState(_value);
                        this.togglePicker(false);
                        !this.isValid && this.$refs.input.checkHtml5Validity();
                    },
                    focusedDate: function focusedDate(value) {
                        if (value) {
                            this.focusedDateData = {
                                month: value.getMonth(),
                                year: value.getFullYear()
                            };
                        }
                    },

                    /*
                    * Emit input event on month and/or year change
                    */
                    'focusedDateData.month': function focusedDateDataMonth(value) {
                        this.$emit('change-month', value);
                    },
                    'focusedDateData.year': function focusedDateDataYear(value) {
                        this.$emit('change-year', value);
                    }
                },
                methods: {
                    /*
                    * Parse string into date
                    */
                    onChange: function onChange(value) {
                        var date = this.dateParser(value, this);
                        if (date && !isNaN(date)) {
                            this.computedValue = date;
                        } else {
                            // Force refresh input value when not valid date
                            this.computedValue = null;
                            this.$refs.input.newValue = this.computedValue;
                        }
                    },

                    /*
                    * Format date into string
                    */
                    formatValue: function formatValue(value) {
                        if (value && !isNaN(value)) {
                            return this.dateFormatter(value, this);
                        } else {
                            return null;
                        }
                    },

                    /*
                    * Either decrement month by 1 if not January or decrement year by 1
                    * and set month to 11 (December) or decrement year when 'month'
                    */
                    prev: function prev() {
                        if (this.disabled) return;

                        if (this.isTypeMonth) {
                            this.focusedDateData.year -= 1;
                        } else {
                            if (this.focusedDateData.month > 0) {
                                this.focusedDateData.month -= 1;
                            } else {
                                this.focusedDateData.month = 11;
                                this.focusedDateData.year -= 1;
                            }
                        }
                    },

                    /*
                    * Either increment month by 1 if not December or increment year by 1
                    * and set month to 0 (January) or increment year when 'month'
                    */
                    next: function next() {
                        if (this.disabled) return;

                        if (this.isTypeMonth) {
                            this.focusedDateData.year += 1;
                        } else {
                            if (this.focusedDateData.month < 11) {
                                this.focusedDateData.month += 1;
                            } else {
                                this.focusedDateData.month = 0;
                                this.focusedDateData.year += 1;
                            }
                        }
                    },
                    formatNative: function formatNative(value) {
                        return this.isTypeMonth ? this.formatYYYYMM(value) : this.formatYYYYMMDD(value);
                    },

                    /*
                    * Format date into string 'YYYY-MM-DD'
                    */
                    formatYYYYMMDD: function formatYYYYMMDD(value) {
                        var date = new Date(value);
                        if (value && !isNaN(date)) {
                            var year = date.getFullYear();
                            var month = date.getMonth() + 1;
                            var day = date.getDate();
                            return year + '-' + ((month < 10 ? '0' : '') + month) + '-' + ((day < 10 ? '0' : '') + day);
                        }
                        return '';
                    },

                    /*
                    * Format date into string 'YYYY-MM'
                    */
                    formatYYYYMM: function formatYYYYMM(value) {
                        var date = new Date(value);
                        if (value && !isNaN(date)) {
                            var year = date.getFullYear();
                            var month = date.getMonth() + 1;
                            return year + '-' + ((month < 10 ? '0' : '') + month);
                        }
                        return '';
                    },

                    /*
                    * Parse date from string
                    */
                    onChangeNativePicker: function onChangeNativePicker(event) {
                        var date = event.target.value;
                        this.computedValue = date ? new Date(date) : null;
                    },
                    updateInternalState: function updateInternalState(value) {
                        var currentDate = !value ? this.dateCreator() : value;
                        this.focusedDateData = {
                            month: currentDate.getMonth(),
                            year: currentDate.getFullYear()
                        };
                        this.dateSelected = value;
                    },

                    /*
                    * Toggle datepicker
                    */
                    togglePicker: function togglePicker(active) {
                        if (this.$refs.dropdown) {
                            this.$refs.dropdown.isActive = typeof active === 'boolean' ? active : !this.$refs.dropdown.isActive;
                        }
                    },

                    /*
                    * Call default onFocus method and show datepicker
                    */
                    handleOnFocus: function handleOnFocus(event) {
                        this.onFocus(event);
                        if (this.openOnFocus) {
                            this.togglePicker(true);
                        }
                    },

                    /*
                    * Toggle dropdown
                    */
                    toggle: function toggle() {
                        if (this.mobileNative && this.isMobile) {
                            this.$refs.input.$el.click();
                            return;
                        }
                        this.$refs.dropdown.toggle();
                    },

                    /*
                    * Avoid dropdown toggle when is already visible
                    */
                    onInputClick: function onInputClick(event) {
                        if (this.$refs.dropdown.isActive) {
                            event.stopPropagation();
                        }
                    },

                    /**
                    * Keypress event that is bound to the document.
                    */
                    keyPress: function keyPress(event) {
                        // Esc key
                        if (this.$refs.dropdown && this.$refs.dropdown.isActive && event.keyCode === 27) {
                            this.togglePicker(false);
                        }
                    }
                },
                created: function created() {
                    if (typeof window !== 'undefined') {
                        document.addEventListener('keyup', this.keyPress);
                    }
                },
                beforeDestroy: function beforeDestroy() {
                    if (typeof window !== 'undefined') {
                        document.removeEventListener('keyup', this.keyPress);
                    }
                }
            };

            /***/
        },
        /* 137 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__ = __webpack_require__(5);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__icon_Icon__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__utils_FormElementMixin__ = __webpack_require__(10);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BSelect',
                components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_2__icon_Icon___default.a),
                mixins: [__WEBPACK_IMPORTED_MODULE_3__utils_FormElementMixin__["a" /* default */]],
                inheritAttrs: false,
                props: {
                    value: {
                        type: [String, Number, Boolean, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a, Function],
                        default: null
                    },
                    placeholder: String,
                    multiple: Boolean,
                    nativeSize: [String, Number]
                },
                data: function data() {
                    return {
                        selected: this.value,
                        _elementRef: 'select'
                    };
                },

                computed: {
                    computedValue: {
                        get: function get() {
                            return this.selected;
                        },
                        set: function set(value) {
                            this.selected = value;
                            this.$emit('input', value);
                            !this.isValid && this.checkHtml5Validity();
                        }
                    },
                    spanClasses: function spanClasses() {
                        return [this.size, this.statusType, {
                            'is-fullwidth': this.expanded,
                            'is-loading': this.loading,
                            'is-multiple': this.multiple,
                            'is-rounded': this.rounded,
                            'is-empty': this.selected === null
                        }];
                    }
                },
                watch: {
                    /**
                    * When v-model is changed:
                    *   1. Set the selected option.
                    *   2. If it's invalid, validate again.
                    */
                    value: function value(_value) {
                        this.selected = _value;
                        !this.isValid && this.checkHtml5Validity();
                    }
                }
            };

            /***/
        },
        /* 138 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "control",
                        class: {
                            'is-expanded': _vm.expanded, 'has-icons-left': _vm.icon
                        }
                    }, [_c('span', {
                        staticClass: "select",
                        class: _vm.spanClasses
                    }, [_c('select', _vm._b({
                        directives: [{
                            name: "model",
                            rawName: "v-model",
                            value: _vm.computedValue,
                            expression: "computedValue"
                        }],
                        ref: "select",
                        attrs: {
                            "multiple": _vm.multiple,
                            "size": _vm.nativeSize
                        },
                        on: {
                            "blur": function blur($event) {
                                _vm.$emit('blur', $event) && _vm.checkHtml5Validity();
                            },
                            "focus": function focus($event) {
                                _vm.$emit('focus', $event);
                            },
                            "change": function change($event) {
                                var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
                                    return o.selected;
                                }).map(function (o) {
                                    var val = "_value" in o ? o._value : o.value;
                                    return val;
                                });
                                _vm.computedValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
                            }
                        }
                    }, 'select', _vm.$attrs, false), [_vm.placeholder ? [_vm.computedValue == null ? _c('option', {
                        attrs: {
                            "disabled": "",
                            "hidden": ""
                        },
                        domProps: {
                            "value": null
                        }
                    }, [_vm._v("\n                    " + _vm._s(_vm.placeholder) + "\n                ")]) : _vm._e()] : _vm._e(), _vm._v(" "), _vm._t("default")], 2)]), _vm._v(" "), _vm.icon ? _c('b-icon', {
                        staticClass: "is-left",
                        attrs: {
                            "icon": _vm.icon,
                            "pack": _vm.iconPack,
                            "size": _vm.iconSize
                        }
                    }) : _vm._e()], 1);
                }, staticRenderFns: []

                /***/ };
        },
        /* 139 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(140),
            /* template */
            __webpack_require__(144),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 140 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__DatepickerTableRow__ = __webpack_require__(141);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__DatepickerTableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DatepickerTableRow__);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BDatepickerTable',
                components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__DatepickerTableRow___default.a.name, __WEBPACK_IMPORTED_MODULE_1__DatepickerTableRow___default.a),
                props: {
                    value: Date,
                    dayNames: Array,
                    monthNames: Array,
                    firstDayOfWeek: Number,
                    events: Array,
                    indicators: String,
                    minDate: Date,
                    maxDate: Date,
                    focused: Object,
                    disabled: Boolean,
                    dateCreator: Function,
                    unselectableDates: Array,
                    unselectableDaysOfWeek: Array,
                    selectableDates: Array,
                    nearbyMonthDays: Boolean,
                    nearbySelectableMonthDays: Boolean
                },
                computed: {
                    visibleDayNames: function visibleDayNames() {
                        var visibleDayNames = [];
                        var index = this.firstDayOfWeek;
                        while (visibleDayNames.length < this.dayNames.length) {
                            var currentDayName = this.dayNames[index % this.dayNames.length];
                            visibleDayNames.push(currentDayName);
                            index++;
                        }
                        return visibleDayNames;
                    },
                    hasEvents: function hasEvents() {
                        return this.events && this.events.length;
                    },

                    /*
                    * Return array of all events in the specified month
                    */
                    eventsInThisMonth: function eventsInThisMonth() {
                        if (!this.events) return [];

                        var monthEvents = [];

                        for (var i = 0; i < this.events.length; i++) {
                            var event = this.events[i];

                            if (!event.hasOwnProperty('date')) {
                                event = { date: event };
                            }
                            if (!event.hasOwnProperty('type')) {
                                event.type = 'is-primary';
                            }
                            if (event.date.getMonth() === this.focused.month && event.date.getFullYear() === this.focused.year) {
                                monthEvents.push(event);
                            }
                        }

                        return monthEvents;
                    },

                    /*
                    * Return array of all weeks in the specified month
                    */
                    weeksInThisMonth: function weeksInThisMonth() {
                        var month = this.focused.month;
                        var year = this.focused.year;
                        var weeksInThisMonth = [];
                        var daysInThisMonth = new Date(year, month + 1, 0).getDate();

                        var startingDay = 1;

                        while (startingDay <= daysInThisMonth + 6) {
                            var newWeek = this.weekBuilder(startingDay, month, year);
                            var weekValid = false;

                            newWeek.forEach(function (day) {
                                if (day.getMonth() === month) {
                                    weekValid = true;
                                }
                            });

                            if (weekValid) {
                                weeksInThisMonth.push(newWeek);
                            }

                            startingDay += 7;
                        }

                        return weeksInThisMonth;
                    }
                },
                methods: {
                    /*
                    * Emit input event with selected date as payload for v-model in parent
                    */
                    updateSelectedDate: function updateSelectedDate(date) {
                        this.$emit('input', date);
                    },

                    /*
                    * Return array of all days in the week that the startingDate is within
                    */
                    weekBuilder: function weekBuilder(startingDate, month, year) {
                        var thisMonth = new Date(year, month);

                        var thisWeek = [];

                        var dayOfWeek = new Date(year, month, startingDate).getDay();

                        var end = dayOfWeek >= this.firstDayOfWeek ? dayOfWeek - this.firstDayOfWeek : 7 - this.firstDayOfWeek + dayOfWeek;

                        var daysAgo = 1;
                        for (var i = 0; i < end; i++) {
                            thisWeek.unshift(new Date(thisMonth.getFullYear(), thisMonth.getMonth(), startingDate - daysAgo));
                            daysAgo++;
                        }

                        thisWeek.push(new Date(year, month, startingDate));

                        var daysForward = 1;
                        while (thisWeek.length < 7) {
                            thisWeek.push(new Date(year, month, startingDate + daysForward));
                            daysForward++;
                        }

                        return thisWeek;
                    },
                    eventsInThisWeek: function eventsInThisWeek(week) {
                        return this.eventsInThisMonth.filter(function (event) {
                            var stripped = new Date(Date.parse(event.date));
                            stripped.setHours(0);
                            stripped.setMinutes(0);
                            stripped.setSeconds(0);
                            stripped.setMilliseconds(0);
                            var timed = stripped.getTime();

                            return week.some(function (weekDate) {
                                return weekDate.getTime() === timed;
                            });
                        });
                    }
                }
            };

            /***/
        },
        /* 141 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(142),
            /* template */
            __webpack_require__(143),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 142 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BDatepickerTableRow',
                props: {
                    selectedDate: Date,
                    week: {
                        type: Array,
                        required: true
                    },
                    month: {
                        type: Number,
                        required: true
                    },
                    minDate: Date,
                    maxDate: Date,
                    disabled: Boolean,
                    unselectableDates: Array,
                    unselectableDaysOfWeek: Array,
                    selectableDates: Array,
                    events: Array,
                    indicators: String,
                    dateCreator: Function,
                    nearbyMonthDays: Boolean,
                    nearbySelectableMonthDays: Boolean
                },
                methods: {
                    /*
                    * Check that selected day is within earliest/latest params and
                    * is within this month
                    */
                    selectableDate: function selectableDate(day) {
                        var validity = [];

                        if (this.minDate) {
                            validity.push(day >= this.minDate);
                        }

                        if (this.maxDate) {
                            validity.push(day <= this.maxDate);
                        }

                        if (this.nearbyMonthDays && !this.nearbySelectableMonthDays) {
                            validity.push(day.getMonth() === this.month);
                        }

                        if (this.selectableDates) {
                            for (var i = 0; i < this.selectableDates.length; i++) {
                                var enabledDate = this.selectableDates[i];
                                if (day.getDate() === enabledDate.getDate() && day.getFullYear() === enabledDate.getFullYear() && day.getMonth() === enabledDate.getMonth()) {
                                    return true;
                                } else {
                                    validity.push(false);
                                }
                            }
                        }

                        if (this.unselectableDates) {
                            for (var _i = 0; _i < this.unselectableDates.length; _i++) {
                                var disabledDate = this.unselectableDates[_i];
                                validity.push(day.getDate() !== disabledDate.getDate() || day.getFullYear() !== disabledDate.getFullYear() || day.getMonth() !== disabledDate.getMonth());
                            }
                        }

                        if (this.unselectableDaysOfWeek) {
                            for (var _i2 = 0; _i2 < this.unselectableDaysOfWeek.length; _i2++) {
                                var dayOfWeek = this.unselectableDaysOfWeek[_i2];
                                validity.push(day.getDay() !== dayOfWeek);
                            }
                        }

                        return validity.indexOf(false) < 0;
                    },

                    /*
                    * Emit select event with chosen date as payload
                    */
                    emitChosenDate: function emitChosenDate(day) {
                        if (this.disabled) return;

                        if (this.selectableDate(day)) {
                            this.$emit('select', day);
                        }
                    },
                    eventsDateMatch: function eventsDateMatch(day) {
                        if (!this.events || !this.events.length) return false;

                        var dayEvents = [];

                        for (var i = 0; i < this.events.length; i++) {
                            if (this.events[i].date.getDay() === day.getDay()) {
                                dayEvents.push(this.events[i]);
                            }
                        }

                        if (!dayEvents.length) {
                            return false;
                        }

                        return dayEvents;
                    },

                    /*
                    * Build classObject for cell using validations
                    */
                    classObject: function classObject(day) {
                        function dateMatch(dateOne, dateTwo) {
                            // if either date is null or undefined, return false
                            if (!dateOne || !dateTwo) {
                                return false;
                            }

                            return dateOne.getDate() === dateTwo.getDate() && dateOne.getFullYear() === dateTwo.getFullYear() && dateOne.getMonth() === dateTwo.getMonth();
                        }

                        return {
                            'is-selected': dateMatch(day, this.selectedDate),
                            'is-today': dateMatch(day, this.dateCreator()),
                            'is-selectable': this.selectableDate(day) && !this.disabled,
                            'is-unselectable': !this.selectableDate(day) || this.disabled,
                            'is-invisible': !this.nearbyMonthDays && day.getMonth() !== this.month,
                            'is-nearby': this.nearbySelectableMonthDays && day.getMonth() !== this.month
                        };
                    }
                }
            };

            /***/
        },
        /* 143 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "datepicker-row"
                    }, [_vm._l(_vm.week, function (day, index) {
                        return [_vm.selectableDate(day) && !_vm.disabled ? _c('a', {
                            key: index,
                            staticClass: "datepicker-cell",
                            class: [_vm.classObject(day), {
                                'has-event': _vm.eventsDateMatch(day)
                            }, _vm.indicators],
                            attrs: {
                                "role": "button",
                                "href": "#",
                                "disabled": _vm.disabled
                            },
                            on: {
                                "click": function click($event) {
                                    $event.preventDefault();
                                    _vm.emitChosenDate(day);
                                },
                                "keydown": [function ($event) {
                                    if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                        return null;
                                    }
                                    $event.preventDefault();
                                    _vm.emitChosenDate(day);
                                }, function ($event) {
                                    if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key)) {
                                        return null;
                                    }
                                    $event.preventDefault();
                                    _vm.emitChosenDate(day);
                                }]
                            }
                        }, [_vm._v("\n            " + _vm._s(day.getDate()) + "\n            "), _vm.eventsDateMatch(day) ? _c('div', {
                            staticClass: "events"
                        }, _vm._l(_vm.eventsDateMatch(day), function (event, index) {
                            return _c('div', {
                                key: index,
                                staticClass: "event",
                                class: event.type
                            });
                        })) : _vm._e()]) : _c('div', {
                            key: index,
                            staticClass: "datepicker-cell",
                            class: _vm.classObject(day)
                        }, [_vm._v("\n            " + _vm._s(day.getDate()) + "\n        ")])];
                    })], 2);
                }, staticRenderFns: []

                /***/ };
        },
        /* 144 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('section', {
                        staticClass: "datepicker-table"
                    }, [_c('header', {
                        staticClass: "datepicker-header"
                    }, _vm._l(_vm.visibleDayNames, function (day, index) {
                        return _c('div', {
                            key: index,
                            staticClass: "datepicker-cell"
                        }, [_vm._v("\n            " + _vm._s(day) + "\n        ")]);
                    })), _vm._v(" "), _c('div', {
                        staticClass: "datepicker-body",
                        class: {
                            'has-events': _vm.hasEvents
                        }
                    }, _vm._l(_vm.weeksInThisMonth, function (week, index) {
                        return _c('b-datepicker-table-row', {
                            key: index,
                            attrs: {
                                "selected-date": _vm.value,
                                "week": week,
                                "month": _vm.focused.month,
                                "min-date": _vm.minDate,
                                "max-date": _vm.maxDate,
                                "disabled": _vm.disabled,
                                "unselectable-dates": _vm.unselectableDates,
                                "unselectable-days-of-week": _vm.unselectableDaysOfWeek,
                                "selectable-dates": _vm.selectableDates,
                                "events": _vm.eventsInThisWeek(week),
                                "indicators": _vm.indicators,
                                "date-creator": _vm.dateCreator,
                                "nearby-month-days": _vm.nearbyMonthDays,
                                "nearby-selectable-month-days": _vm.nearbySelectableMonthDays
                            },
                            on: {
                                "select": _vm.updateSelectedDate
                            }
                        });
                    }))]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 145 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(146),
            /* template */
            __webpack_require__(147),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 146 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BDatepickerMonth',
                props: {
                    value: Date,
                    monthNames: Array,
                    events: Array,
                    indicators: String,
                    minDate: Date,
                    maxDate: Date,
                    focused: Object,
                    disabled: Boolean,
                    dateCreator: Function,
                    unselectableDates: Array,
                    unselectableDaysOfWeek: Array,
                    selectableDates: Array
                },
                computed: {
                    hasEvents: function hasEvents() {
                        return this.events && this.events.length;
                    },

                    /*
                    * Return array of all events in the specified month
                    */
                    eventsInThisYear: function eventsInThisYear() {
                        if (!this.events) return [];

                        var yearEvents = [];

                        for (var i = 0; i < this.events.length; i++) {
                            var event = this.events[i];

                            if (!event.hasOwnProperty('date')) {
                                event = { date: event };
                            }
                            if (!event.hasOwnProperty('type')) {
                                event.type = 'is-primary';
                            }
                            if (event.date.getFullYear() === this.focused.year) {
                                yearEvents.push(event);
                            }
                        }

                        return yearEvents;
                    },
                    monthDates: function monthDates() {
                        var year = this.focused.year;
                        var months = [];
                        for (var i = 0; i < 12; i++) {
                            var d = new Date(year, i, 1);
                            d.setHours(0, 0, 0, 0);
                            months.push(d);
                        }
                        return months;
                    }
                },
                methods: {
                    selectableDate: function selectableDate(day) {
                        var validity = [];

                        if (this.minDate) {
                            validity.push(day >= this.minDate);
                        }

                        if (this.maxDate) {
                            validity.push(day <= this.maxDate);
                        }

                        validity.push(day.getFullYear() === this.focused.year);

                        if (this.selectableDates) {
                            for (var i = 0; i < this.selectableDates.length; i++) {
                                var enabledDate = this.selectableDates[i];
                                if (day.getFullYear() === enabledDate.getFullYear() && day.getMonth() === enabledDate.getMonth()) {
                                    return true;
                                } else {
                                    validity.push(false);
                                }
                            }
                        }

                        if (this.unselectableDates) {
                            for (var _i = 0; _i < this.unselectableDates.length; _i++) {
                                var disabledDate = this.unselectableDates[_i];
                                validity.push(day.getFullYear() !== disabledDate.getFullYear() || day.getMonth() !== disabledDate.getMonth());
                            }
                        }

                        if (this.unselectableDaysOfWeek) {
                            for (var _i2 = 0; _i2 < this.unselectableDaysOfWeek.length; _i2++) {
                                var dayOfWeek = this.unselectableDaysOfWeek[_i2];
                                validity.push(day.getDay() !== dayOfWeek);
                            }
                        }

                        return validity.indexOf(false) < 0;
                    },
                    eventsDateMatch: function eventsDateMatch(day) {
                        if (!this.eventsInThisYear.length) return false;

                        var monthEvents = [];

                        for (var i = 0; i < this.eventsInThisYear.length; i++) {
                            if (this.eventsInThisYear[i].date.getMonth() === day.getMonth()) {
                                monthEvents.push(this.events[i]);
                            }
                        }

                        if (!monthEvents.length) {
                            return false;
                        }

                        return monthEvents;
                    },

                    /*
                    * Build classObject for cell using validations
                    */
                    classObject: function classObject(day) {
                        function dateMatch(dateOne, dateTwo) {
                            // if either date is null or undefined, return false
                            if (!dateOne || !dateTwo) {
                                return false;
                            }

                            return dateOne.getFullYear() === dateTwo.getFullYear() && dateOne.getMonth() === dateTwo.getMonth();
                        }

                        return {
                            'is-selected': dateMatch(day, this.value),
                            'is-today': dateMatch(day, this.dateCreator()),
                            'is-selectable': this.selectableDate(day) && !this.disabled,
                            'is-unselectable': !this.selectableDate(day) || this.disabled
                        };
                    },

                    /*
                    * Emit select event with chosen date as payload
                    */
                    emitChosenDate: function emitChosenDate(day) {
                        if (this.disabled) return;

                        if (this.selectableDate(day)) {
                            this.$emit('input', day);
                        }
                    }
                }
            };

            /***/
        },
        /* 147 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('section', {
                        staticClass: "datepicker-table"
                    }, [_c('div', {
                        staticClass: "datepicker-body",
                        class: {
                            'has-events': _vm.hasEvents
                        }
                    }, [_c('div', {
                        staticClass: "datepicker-months"
                    }, [_vm._l(_vm.monthDates, function (date, index) {
                        return [_vm.selectableDate(date) && !_vm.disabled ? _c('a', {
                            key: index,
                            staticClass: "datepicker-cell",
                            class: [_vm.classObject(date), {
                                'has-event': _vm.eventsDateMatch(date)
                            }, _vm.indicators],
                            attrs: {
                                "role": "button",
                                "href": "#",
                                "disabled": _vm.disabled
                            },
                            on: {
                                "click": function click($event) {
                                    $event.preventDefault();
                                    _vm.emitChosenDate(date);
                                },
                                "keydown": [function ($event) {
                                    if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                        return null;
                                    }
                                    $event.preventDefault();
                                    _vm.emitChosenDate(date);
                                }, function ($event) {
                                    if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key)) {
                                        return null;
                                    }
                                    $event.preventDefault();
                                    _vm.emitChosenDate(date);
                                }]
                            }
                        }, [_vm._v("\n                    " + _vm._s(_vm.monthNames[date.getMonth()]) + "\n                    "), _vm.eventsDateMatch(date) ? _c('div', {
                            staticClass: "events"
                        }, _vm._l(_vm.eventsDateMatch(date), function (event, index) {
                            return _c('div', {
                                key: index,
                                staticClass: "event",
                                class: event.type
                            });
                        })) : _vm._e()]) : _c('div', {
                            key: index,
                            staticClass: "datepicker-cell",
                            class: _vm.classObject(date)
                        }, [_vm._v("\n                    " + _vm._s(_vm.monthNames[date.getMonth()]) + "\n                ")])];
                    })], 2)])]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 148 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "datepicker control",
                        class: [_vm.size, {
                            'is-expanded': _vm.expanded
                        }]
                    }, [!_vm.isMobile || _vm.inline ? _c('b-dropdown', {
                        ref: "dropdown",
                        attrs: {
                            "position": _vm.position,
                            "disabled": _vm.disabled,
                            "inline": _vm.inline
                        }
                    }, [!_vm.inline ? _c('b-input', _vm._b({
                        ref: "input",
                        attrs: {
                            "slot": "trigger",
                            "autocomplete": "off",
                            "value": _vm.formatValue(_vm.computedValue),
                            "placeholder": _vm.placeholder,
                            "size": _vm.size,
                            "icon": _vm.icon,
                            "icon-pack": _vm.iconPack,
                            "rounded": _vm.rounded,
                            "loading": _vm.loading,
                            "disabled": _vm.disabled,
                            "readonly": !_vm.editable,
                            "use-html5-validation": _vm.useHtml5Validation
                        },
                        on: {
                            "focus": _vm.handleOnFocus,
                            "blur": _vm.onBlur
                        },
                        nativeOn: {
                            "click": function click($event) {
                                _vm.onInputClick($event);
                            },
                            "keyup": function keyup($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                    return null;
                                }
                                _vm.togglePicker(true);
                            },
                            "change": function change($event) {
                                _vm.onChange($event.target.value);
                            }
                        },
                        slot: "trigger"
                    }, 'b-input', _vm.$attrs, false)) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
                        attrs: {
                            "disabled": _vm.disabled,
                            "custom": ""
                        }
                    }, [_c('header', {
                        staticClass: "datepicker-header"
                    }, [_vm.$slots.header !== undefined && _vm.$slots.header.length ? [_vm._t("header")] : _c('div', {
                        staticClass: "pagination field is-centered",
                        class: _vm.size
                    }, [_c('a', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.showPrev && !_vm.disabled,
                            expression: "!showPrev && !disabled"
                        }],
                        staticClass: "pagination-previous",
                        attrs: {
                            "role": "button",
                            "href": "#",
                            "disabled": _vm.disabled
                        },
                        on: {
                            "click": function click($event) {
                                $event.preventDefault();
                                _vm.prev($event);
                            },
                            "keydown": [function ($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.prev($event);
                            }, function ($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.prev($event);
                            }]
                        }
                    }, [_c('b-icon', {
                        attrs: {
                            "icon": "chevron-left",
                            "pack": _vm.iconPack,
                            "both": "",
                            "type": "is-primary is-clickable"
                        }
                    })], 1), _vm._v(" "), _c('a', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.showNext && !_vm.disabled,
                            expression: "!showNext && !disabled"
                        }],
                        staticClass: "pagination-next",
                        attrs: {
                            "role": "button",
                            "href": "#",
                            "disabled": _vm.disabled
                        },
                        on: {
                            "click": function click($event) {
                                $event.preventDefault();
                                _vm.next($event);
                            },
                            "keydown": [function ($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.next($event);
                            }, function ($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.next($event);
                            }]
                        }
                    }, [_c('b-icon', {
                        attrs: {
                            "icon": "chevron-right",
                            "pack": _vm.iconPack,
                            "both": "",
                            "type": "is-primary is-clickable"
                        }
                    })], 1), _vm._v(" "), _c('div', {
                        staticClass: "pagination-list"
                    }, [_c('b-field', [!_vm.isTypeMonth ? _c('b-select', {
                        attrs: {
                            "disabled": _vm.disabled,
                            "size": _vm.size
                        },
                        model: {
                            value: _vm.focusedDateData.month,
                            callback: function callback($$v) {
                                _vm.$set(_vm.focusedDateData, "month", $$v);
                            },
                            expression: "focusedDateData.month"
                        }
                    }, _vm._l(_vm.monthNames, function (month, index) {
                        return _c('option', {
                            key: month,
                            domProps: {
                                "value": index
                            }
                        }, [_vm._v("\n                                    " + _vm._s(month) + "\n                                ")]);
                    })) : _vm._e(), _vm._v(" "), _c('b-select', {
                        attrs: {
                            "disabled": _vm.disabled,
                            "size": _vm.size
                        },
                        model: {
                            value: _vm.focusedDateData.year,
                            callback: function callback($$v) {
                                _vm.$set(_vm.focusedDateData, "year", $$v);
                            },
                            expression: "focusedDateData.year"
                        }
                    }, _vm._l(_vm.listOfYears, function (year) {
                        return _c('option', {
                            key: year,
                            domProps: {
                                "value": year
                            }
                        }, [_vm._v("\n                                    " + _vm._s(year) + "\n                                ")]);
                    }))], 1)], 1)])], 2), _vm._v(" "), !_vm.isTypeMonth ? _c('div', {
                        staticClass: "datepicker-content"
                    }, [_c('b-datepicker-table', {
                        attrs: {
                            "day-names": _vm.dayNames,
                            "month-names": _vm.monthNames,
                            "first-day-of-week": _vm.firstDayOfWeek,
                            "min-date": _vm.minDate,
                            "max-date": _vm.maxDate,
                            "focused": _vm.focusedDateData,
                            "disabled": _vm.disabled,
                            "unselectable-dates": _vm.unselectableDates,
                            "unselectable-days-of-week": _vm.unselectableDaysOfWeek,
                            "selectable-dates": _vm.selectableDates,
                            "events": _vm.events,
                            "indicators": _vm.indicators,
                            "date-creator": _vm.dateCreator,
                            "type-month": _vm.isTypeMonth,
                            "nearby-month-days": _vm.nearbyMonthDays,
                            "nearby-selectable-month-days": _vm.nearbySelectableMonthDays
                        },
                        on: {
                            "close": function close($event) {
                                _vm.togglePicker(false);
                            }
                        },
                        model: {
                            value: _vm.computedValue,
                            callback: function callback($$v) {
                                _vm.computedValue = $$v;
                            },
                            expression: "computedValue"
                        }
                    })], 1) : _c('div', [_c('b-datepicker-month', {
                        attrs: {
                            "month-names": _vm.monthNames,
                            "min-date": _vm.minDate,
                            "max-date": _vm.maxDate,
                            "focused": _vm.focusedDateData,
                            "disabled": _vm.disabled,
                            "unselectable-dates": _vm.unselectableDates,
                            "unselectable-days-of-week": _vm.unselectableDaysOfWeek,
                            "selectable-dates": _vm.selectableDates,
                            "events": _vm.events,
                            "indicators": _vm.indicators,
                            "date-creator": _vm.dateCreator
                        },
                        on: {
                            "close": function close($event) {
                                _vm.togglePicker(false);
                            }
                        },
                        model: {
                            value: _vm.computedValue,
                            callback: function callback($$v) {
                                _vm.computedValue = $$v;
                            },
                            expression: "computedValue"
                        }
                    })], 1), _vm._v(" "), _vm.$slots.default !== undefined && _vm.$slots.default.length ? _c('footer', {
                        staticClass: "datepicker-footer"
                    }, [_vm._t("default")], 2) : _vm._e()])], 1) : _c('b-input', _vm._b({
                        ref: "input",
                        attrs: {
                            "type": !_vm.isTypeMonth ? 'date' : 'month',
                            "autocomplete": "off",
                            "value": _vm.formatNative(_vm.computedValue),
                            "placeholder": _vm.placeholder,
                            "size": _vm.size,
                            "icon": _vm.icon,
                            "icon-pack": _vm.iconPack,
                            "loading": _vm.loading,
                            "max": _vm.formatNative(_vm.maxDate),
                            "min": _vm.formatNative(_vm.minDate),
                            "disabled": _vm.disabled,
                            "readonly": false,
                            "use-html5-validation": _vm.useHtml5Validation
                        },
                        on: {
                            "focus": _vm.handleOnFocus,
                            "blur": _vm.onBlur
                        },
                        nativeOn: {
                            "change": function change($event) {
                                _vm.onChangeNativePicker($event);
                            }
                        }
                    }, 'b-input', _vm.$attrs, false))], 1);
                }, staticRenderFns: []

                /***/ };
        },
        /* 149 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(150),
            /* template */
            __webpack_require__(153),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 150 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon_Icon__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__modal_Modal__ = __webpack_require__(63);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modal_Modal__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__utils_config__ = __webpack_require__(2);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(7);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BDialog',
                components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a),
                extends: __WEBPACK_IMPORTED_MODULE_2__modal_Modal___default.a,
                props: {
                    title: String,
                    message: String,
                    icon: String,
                    iconPack: String,
                    hasIcon: Boolean,
                    type: {
                        type: String,
                        default: 'is-primary'
                    },
                    size: String,
                    confirmText: {
                        type: String,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDialogConfirmText ? __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDialogConfirmText : 'OK';
                        }
                    },
                    cancelText: {
                        type: String,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDialogCancelText ? __WEBPACK_IMPORTED_MODULE_3__utils_config__["a" /* default */].defaultDialogCancelText : 'Cancel';
                        }
                    },
                    hasInput: Boolean, // Used internally to know if it's prompt
                    inputAttrs: {
                        type: Object,
                        default: function _default() {
                            return {};
                        }
                    },
                    onConfirm: {
                        type: Function,
                        default: function _default() {}
                    },
                    focusOn: {
                        type: String,
                        default: 'confirm'
                    }
                },
                data: function data() {
                    var prompt = this.hasInput ? this.inputAttrs.value || '' : '';

                    return {
                        prompt: prompt,
                        isActive: false,
                        validationMessage: ''
                    };
                },

                computed: {
                    /**
                    * Icon name (MDI) based on the type.
                    */
                    iconByType: function iconByType() {
                        switch (this.type) {
                            case 'is-info':
                                return 'information';
                            case 'is-success':
                                return 'check-circle';
                            case 'is-warning':
                                return 'alert';
                            case 'is-danger':
                                return 'alert-circle';
                            default:
                                return null;
                        }
                    },
                    showCancel: function showCancel() {
                        return this.cancelOptions.indexOf('button') >= 0;
                    }
                },
                methods: {
                    /**
                    * If it's a prompt Dialog, validate the input.
                    * Call the onConfirm prop (function) and close the Dialog.
                    */
                    confirm: function confirm() {
                        var _this = this;

                        if (this.$refs.input !== undefined) {
                            if (!this.$refs.input.checkValidity()) {
                                this.validationMessage = this.$refs.input.validationMessage;
                                this.$nextTick(function () {
                                    return _this.$refs.input.select();
                                });
                                return;
                            }
                        }

                        this.onConfirm(this.prompt);
                        this.close();
                    },

                    /**
                    * Close the Dialog.
                    */
                    close: function close() {
                        var _this2 = this;

                        this.isActive = false;
                        // Timeout for the animation complete before destroying
                        setTimeout(function () {
                            _this2.$destroy();
                            Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["d" /* removeElement */])(_this2.$el);
                        }, 150);
                    }
                },
                beforeMount: function beforeMount() {
                    var _this3 = this;

                    // Insert the Dialog component in body tag
                    this.$nextTick(function () {
                        document.body.appendChild(_this3.$el);
                    });
                },
                mounted: function mounted() {
                    var _this4 = this;

                    this.isActive = true;

                    if (typeof this.inputAttrs.required === 'undefined') {
                        this.$set(this.inputAttrs, 'required', true);
                    }

                    this.$nextTick(function () {
                        // Handle which element receives focus
                        if (_this4.hasInput) {
                            _this4.$refs.input.focus();
                        } else if (_this4.focusOn === 'cancel' && _this4.showCancel) {
                            _this4.$refs.cancelButton.focus();
                        } else {
                            _this4.$refs.confirmButton.focus();
                        }
                    });
                }
            };

            /***/
        },
        /* 151 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(7);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__utils_config__ = __webpack_require__(2);
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BModal',
                props: {
                    active: Boolean,
                    component: [Object, Function],
                    content: String,
                    programmatic: Boolean,
                    props: Object,
                    events: Object,
                    width: {
                        type: [String, Number],
                        default: 960
                    },
                    hasModalCard: Boolean,
                    animation: {
                        type: String,
                        default: 'zoom-out'
                    },
                    canCancel: {
                        type: [Array, Boolean],
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_1__utils_config__["a" /* default */].defaultModalCanCancel;
                        }
                    },
                    onCancel: {
                        type: Function,
                        default: function _default() {}
                    },
                    scroll: {
                        type: String,
                        default: function _default() {
                            return __WEBPACK_IMPORTED_MODULE_1__utils_config__["a" /* default */].defaultModalScroll ? __WEBPACK_IMPORTED_MODULE_1__utils_config__["a" /* default */].defaultModalScroll : 'clip';
                        },
                        validator: function validator(value) {
                            return ['clip', 'keep'].indexOf(value) >= 0;
                        }
                    },
                    fullScreen: Boolean,
                    customClass: String
                },
                data: function data() {
                    return {
                        isActive: this.active || false,
                        savedScrollTop: null,
                        newWidth: typeof this.width === 'number' ? this.width + 'px' : this.width
                    };
                },

                computed: {
                    cancelOptions: function cancelOptions() {
                        return typeof this.canCancel === 'boolean' ? this.canCancel ? __WEBPACK_IMPORTED_MODULE_1__utils_config__["a" /* default */].defaultModalCanCancel : [] : this.canCancel;
                    },
                    showX: function showX() {
                        return this.cancelOptions.indexOf('x') >= 0;
                    },
                    customStyle: function customStyle() {
                        if (!this.fullScreen) {
                            return { maxWidth: this.newWidth };
                        }
                        return null;
                    }
                },
                watch: {
                    active: function active(value) {
                        this.isActive = value;
                    },
                    isActive: function isActive() {
                        this.handleScroll();
                    }
                },
                methods: {
                    handleScroll: function handleScroll() {
                        if (typeof window === 'undefined') return;

                        if (this.scroll === 'clip') {
                            if (this.isActive) {
                                document.documentElement.classList.add('is-clipped');
                            } else {
                                document.documentElement.classList.remove('is-clipped');
                            }
                            return;
                        }

                        this.savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;

                        if (this.isActive) {
                            document.body.classList.add('is-noscroll');
                        } else {
                            document.body.classList.remove('is-noscroll');
                        }

                        if (this.isActive) {
                            document.body.style.top = '-' + this.savedScrollTop + 'px';
                            return;
                        }

                        document.documentElement.scrollTop = this.savedScrollTop;
                        document.body.style.top = null;
                        this.savedScrollTop = null;
                    },

                    /**
                    * Close the Modal if canCancel and call the onCancel prop (function).
                    */
                    cancel: function cancel(method) {
                        if (this.cancelOptions.indexOf(method) < 0) return;

                        this.onCancel.apply(null, arguments);
                        this.close();
                    },

                    /**
                    * Call the onCancel prop (function).
                    * Emit events, and destroy modal if it's programmatic.
                    */
                    close: function close() {
                        var _this = this;

                        this.$emit('close');
                        this.$emit('update:active', false);

                        // Timeout for the animation complete before destroying
                        if (this.programmatic) {
                            this.isActive = false;
                            setTimeout(function () {
                                _this.$destroy();
                                Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["d" /* removeElement */])(_this.$el);
                            }, 150);
                        }
                    },

                    /**
                    * Keypress event that is bound to the document.
                    */
                    keyPress: function keyPress(event) {
                        // Esc key
                        if (this.isActive && event.keyCode === 27) this.cancel('escape');
                    }
                },
                created: function created() {
                    if (typeof window !== 'undefined') {
                        document.addEventListener('keyup', this.keyPress);
                    }
                },
                beforeMount: function beforeMount() {
                    // Insert the Modal component in body tag
                    // only if it's programmatic
                    this.programmatic && document.body.appendChild(this.$el);
                },
                mounted: function mounted() {
                    if (this.programmatic) this.isActive = true;else if (this.isActive) this.handleScroll();
                },
                beforeDestroy: function beforeDestroy() {
                    if (typeof window !== 'undefined') {
                        document.removeEventListener('keyup', this.keyPress);
                        // reset scroll
                        document.documentElement.classList.remove('is-clipped');
                        var savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;
                        document.body.classList.remove('is-noscroll');
                        document.documentElement.scrollTop = savedScrollTop;
                        document.body.style.top = null;
                    }
                }
            };

            /***/
        },
        /* 152 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('transition', {
                        attrs: {
                            "name": _vm.animation
                        }
                    }, [_vm.isActive ? _c('div', {
                        staticClass: "modal is-active",
                        class: [{
                            'is-full-screen': _vm.fullScreen
                        }, _vm.customClass]
                    }, [_c('div', {
                        staticClass: "modal-background",
                        on: {
                            "click": function click($event) {
                                _vm.cancel('outside');
                            }
                        }
                    }), _vm._v(" "), _c('div', {
                        staticClass: "animation-content",
                        class: {
                            'modal-content': !_vm.hasModalCard
                        },
                        style: _vm.customStyle
                    }, [_vm.component ? _c(_vm.component, _vm._g(_vm._b({
                        tag: "component",
                        on: {
                            "close": _vm.close
                        }
                    }, 'component', _vm.props, false), _vm.events)) : _vm.content ? _c('div', {
                        domProps: {
                            "innerHTML": _vm._s(_vm.content)
                        }
                    }) : _vm._t("default")], 2), _vm._v(" "), _vm.showX ? _c('button', {
                        staticClass: "modal-close is-large",
                        attrs: {
                            "type": "button"
                        },
                        on: {
                            "click": function click($event) {
                                _vm.cancel('x');
                            }
                        }
                    }) : _vm._e()]) : _vm._e()]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 153 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('transition', {
                        attrs: {
                            "name": _vm.animation
                        }
                    }, [_vm.isActive ? _c('div', {
                        staticClass: "dialog modal is-active",
                        class: _vm.size
                    }, [_c('div', {
                        staticClass: "modal-background",
                        on: {
                            "click": function click($event) {
                                _vm.cancel('outside');
                            }
                        }
                    }), _vm._v(" "), _c('div', {
                        staticClass: "modal-card animation-content"
                    }, [_vm.title ? _c('header', {
                        staticClass: "modal-card-head"
                    }, [_c('p', {
                        staticClass: "modal-card-title"
                    }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('section', {
                        staticClass: "modal-card-body",
                        class: {
                            'is-titleless': !_vm.title, 'is-flex': _vm.hasIcon
                        }
                    }, [_c('div', {
                        staticClass: "media"
                    }, [_vm.hasIcon ? _c('div', {
                        staticClass: "media-left"
                    }, [_c('b-icon', {
                        attrs: {
                            "icon": _vm.icon ? _vm.icon : _vm.iconByType,
                            "pack": _vm.iconPack,
                            "type": _vm.type,
                            "both": !_vm.icon,
                            "size": "is-large"
                        }
                    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
                        staticClass: "media-content"
                    }, [_c('p', {
                        domProps: {
                            "innerHTML": _vm._s(_vm.message)
                        }
                    }), _vm._v(" "), _vm.hasInput ? _c('div', {
                        staticClass: "field"
                    }, [_c('div', {
                        staticClass: "control"
                    }, [_c('input', _vm._b({
                        directives: [{
                            name: "model",
                            rawName: "v-model",
                            value: _vm.prompt,
                            expression: "prompt"
                        }],
                        ref: "input",
                        staticClass: "input",
                        class: {
                            'is-danger': _vm.validationMessage
                        },
                        domProps: {
                            "value": _vm.prompt
                        },
                        on: {
                            "keyup": function keyup($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                    return null;
                                }
                                _vm.confirm($event);
                            },
                            "input": function input($event) {
                                if ($event.target.composing) {
                                    return;
                                }
                                _vm.prompt = $event.target.value;
                            }
                        }
                    }, 'input', _vm.inputAttrs, false))]), _vm._v(" "), _c('p', {
                        staticClass: "help is-danger"
                    }, [_vm._v(_vm._s(_vm.validationMessage))])]) : _vm._e()])])]), _vm._v(" "), _c('footer', {
                        staticClass: "modal-card-foot"
                    }, [_vm.showCancel ? _c('button', {
                        ref: "cancelButton",
                        staticClass: "button",
                        on: {
                            "click": function click($event) {
                                _vm.cancel('button');
                            }
                        }
                    }, [_vm._v("\n                    " + _vm._s(_vm.cancelText) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('button', {
                        ref: "confirmButton",
                        staticClass: "button",
                        class: _vm.type,
                        on: {
                            "click": _vm.confirm
                        }
                    }, [_vm._v("\n                    " + _vm._s(_vm.confirmText) + "\n                ")])])])]) : _vm._e()]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 154 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(155),
            /* template */
            __webpack_require__(156),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 155 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(7);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__utils_ssr__ = __webpack_require__(64);
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BLoading',
                props: {
                    active: Boolean,
                    programmatic: Boolean,
                    container: [Object, Function, __WEBPACK_IMPORTED_MODULE_1__utils_ssr__["b" /* HTMLElement */]],
                    isFullPage: {
                        type: Boolean,
                        default: true
                    },
                    animation: {
                        type: String,
                        default: 'fade'
                    },
                    canCancel: {
                        type: Boolean,
                        default: false
                    },
                    onCancel: {
                        type: Function,
                        default: function _default() {}
                    }
                },
                data: function data() {
                    return {
                        isActive: this.active || false
                    };
                },

                watch: {
                    active: function active(value) {
                        this.isActive = value;
                    }
                },
                methods: {
                    /**
                    * Close the Modal if canCancel.
                    */
                    cancel: function cancel() {
                        if (!this.canCancel || !this.isActive) return;

                        this.close();
                    },

                    /**
                    * Emit events, and destroy modal if it's programmatic.
                    */
                    close: function close() {
                        var _this = this;

                        this.onCancel.apply(null, arguments);
                        this.$emit('close');
                        this.$emit('update:active', false);

                        // Timeout for the animation complete before destroying
                        if (this.programmatic) {
                            this.isActive = false;
                            setTimeout(function () {
                                _this.$destroy();
                                Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["d" /* removeElement */])(_this.$el);
                            }, 150);
                        }
                    },

                    /**
                    * Keypress event that is bound to the document.
                    */
                    keyPress: function keyPress(event) {
                        // Esc key
                        if (event.keyCode === 27) this.cancel();
                    }
                },
                created: function created() {
                    if (typeof window !== 'undefined') {
                        document.addEventListener('keyup', this.keyPress);
                    }
                },
                beforeMount: function beforeMount() {
                    // Insert the Loading component in body tag
                    // only if it's programmatic
                    if (this.programmatic) {
                        if (!this.container) {
                            document.body.appendChild(this.$el);
                        } else {
                            this.isFullPage = false;
                            this.container.appendChild(this.$el);
                        }
                    }
                },
                mounted: function mounted() {
                    if (this.programmatic) this.isActive = true;
                },
                beforeDestroy: function beforeDestroy() {
                    if (typeof window !== 'undefined') {
                        document.removeEventListener('keyup', this.keyPress);
                    }
                }
            };

            /***/
        },
        /* 156 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('transition', {
                        attrs: {
                            "name": _vm.animation
                        }
                    }, [_vm.isActive ? _c('div', {
                        staticClass: "loading-overlay is-active",
                        class: {
                            'is-full-page': _vm.isFullPage
                        }
                    }, [_c('div', {
                        staticClass: "loading-background",
                        on: {
                            "click": _vm.cancel
                        }
                    }), _vm._v(" "), _vm._t("default", [_c('div', {
                        staticClass: "loading-icon"
                    })])], 2) : _vm._e()]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 157 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(158),
            /* template */
            __webpack_require__(159),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 158 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BMenu'
            };

            /***/
        },
        /* 159 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "menu"
                    }, [_vm._t("default")], 2);
                }, staticRenderFns: []

                /***/ };
        },
        /* 160 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(161),
            /* template */
            null,
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 161 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BMenuList',
                functional: true,
                props: {
                    label: String,
                    icon: String,
                    iconPack: String
                },
                render: function render(createElement, context) {
                    var vlabel = null;
                    var slots = context.slots();
                    if (context.props.label || slots.label) {
                        vlabel = createElement('p', { attrs: { 'class': 'menu-label' } }, context.props.label ? context.props.icon ? [createElement('b-icon', {
                            props: {
                                'icon': context.props.icon,
                                'pack': context.props.iconPack,
                                'size': 'is-small'
                            }
                        }), createElement('span', {}, context.props.label)] : context.props.label : slots.label);
                    }
                    var vnode = createElement('ul', { attrs: { 'class': 'menu-list' } }, slots.default);
                    return vlabel ? [vlabel, vnode] : vnode;
                }
            };

            /***/
        },
        /* 162 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(163),
            /* template */
            __webpack_require__(164),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 163 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon_Icon__);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BMenuItem',
                components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a),
                inheritAttrs: false,
                props: {
                    label: String,
                    active: Boolean,
                    expanded: Boolean,
                    disabled: Boolean,
                    iconPack: String,
                    icon: String,
                    animation: {
                        type: String,
                        default: 'fade'
                    },
                    tag: {
                        type: String,
                        default: 'a',
                        validator: function validator(value) {
                            return ['a', 'router-link', 'nuxt-link', 'n-link', 'NuxtLink', 'NLink'].indexOf(value) >= 0;
                        }
                    }
                },
                data: function data() {
                    return {
                        newActive: this.active,
                        newExpanded: this.expanded
                    };
                },

                watch: {
                    active: function active(value) {
                        this.newActive = value;
                    },
                    expanded: function expanded(value) {
                        this.newExpanded = value;
                    }
                },
                methods: {
                    onClick: function onClick(event) {
                        if (this.disabled) return;
                        this.reset(this.$parent);
                        this.newExpanded = true;
                        this.$emit('update:expanded', this.newActive);
                        this.newActive = true;
                        this.$emit('update:active', this.newActive);
                        this.$emit('click', event);
                    },
                    reset: function reset(parent) {
                        var _this = this;

                        var items = parent.$children.filter(function (c) {
                            return c.name === _this.name;
                        });
                        items.forEach(function (item) {
                            if (item !== _this) {
                                _this.reset(item);
                                item.newExpanded = false;
                                item.$emit('update:expanded', item.newActive);
                                item.newActive = false;
                                item.$emit('update:active', item.newActive);
                            }
                        });
                    }
                }
            };

            /***/
        },
        /* 164 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('li', [_c(_vm.tag, _vm._b({
                        tag: "component",
                        class: {
                            'is-active': _vm.newActive,
                            'is-disabled': _vm.disabled
                        },
                        on: {
                            "click": function click($event) {
                                _vm.onClick($event);
                            }
                        }
                    }, 'component', _vm.$attrs, false), [_vm.icon ? _c('b-icon', {
                        attrs: {
                            "icon": _vm.icon,
                            "pack": _vm.iconPack,
                            "size": "is-small"
                        }
                    }) : _vm._e(), _vm._v(" "), _vm.label ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._t("label", null, {
                        expanded: _vm.newExpanded,
                        active: _vm.newActive
                    })], 2), _vm._v(" "), _vm.$slots.default ? [_c('transition', {
                        attrs: {
                            "name": _vm.animation
                        }
                    }, [_c('ul', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: _vm.newExpanded,
                            expression: "newExpanded"
                        }]
                    }, [_vm._t("default")], 2)])] : _vm._e()], 2);
                }, staticRenderFns: []

                /***/ };
        },
        /* 165 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(166),
            /* template */
            __webpack_require__(167),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 166 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__utils_MessageMixin_js__ = __webpack_require__(65);
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BMessage',
                mixins: [__WEBPACK_IMPORTED_MODULE_0__utils_MessageMixin_js__["a" /* default */]],
                props: {
                    ariaCloseLabel: String
                },
                data: function data() {
                    return {
                        newIconSize: this.iconSize || this.size || 'is-large'
                    };
                }
            };

            /***/
        },
        /* 167 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('transition', {
                        attrs: {
                            "name": "fade"
                        }
                    }, [_vm.isActive ? _c('article', {
                        staticClass: "message",
                        class: [_vm.type, _vm.size]
                    }, [_vm.title ? _c('header', {
                        staticClass: "message-header"
                    }, [_c('p', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm.closable ? _c('button', {
                        staticClass: "delete",
                        attrs: {
                            "type": "button",
                            "aria-label": _vm.ariaCloseLabel
                        },
                        on: {
                            "click": _vm.close
                        }
                    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('section', {
                        staticClass: "message-body"
                    }, [_c('div', {
                        staticClass: "media"
                    }, [_vm.icon && _vm.hasIcon ? _c('div', {
                        staticClass: "media-left"
                    }, [_c('b-icon', {
                        class: _vm.type,
                        attrs: {
                            "icon": _vm.icon,
                            "pack": _vm.iconPack,
                            "both": "",
                            "size": _vm.newIconSize
                        }
                    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
                        staticClass: "media-content"
                    }, [_vm._t("default")], 2)])])]) : _vm._e()]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 168 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(169),
            /* template */
            __webpack_require__(170),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 169 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__utils_MessageMixin_js__ = __webpack_require__(65);
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BNotification',
                mixins: [__WEBPACK_IMPORTED_MODULE_0__utils_MessageMixin_js__["a" /* default */]],
                props: {
                    position: String,
                    ariaCloseLabel: String
                }
            };

            /***/
        },
        /* 170 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('transition', {
                        attrs: {
                            "name": "fade"
                        }
                    }, [_c('article', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isActive,
                            expression: "isActive"
                        }],
                        staticClass: "notification",
                        class: [_vm.type, _vm.position]
                    }, [_vm.closable ? _c('button', {
                        staticClass: "delete",
                        attrs: {
                            "type": "button",
                            "aria-label": _vm.ariaCloseLabel
                        },
                        on: {
                            "click": _vm.close
                        }
                    }) : _vm._e(), _vm._v(" "), _c('div', {
                        staticClass: "media"
                    }, [_vm.icon && _vm.hasIcon ? _c('div', {
                        staticClass: "media-left"
                    }, [_c('b-icon', {
                        attrs: {
                            "icon": _vm.icon,
                            "pack": _vm.iconPack,
                            "both": "",
                            "size": "is-large",
                            "aria-hidden": ""
                        }
                    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
                        staticClass: "media-content"
                    }, [_vm.message ? _c('p', {
                        staticClass: "text",
                        domProps: {
                            "innerHTML": _vm._s(_vm.message)
                        }
                    }) : _vm._t("default")], 2)])])]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 171 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(172),
            /* template */
            __webpack_require__(173),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 172 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__utils_config__ = __webpack_require__(2);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__utils_NoticeMixin_js__ = __webpack_require__(45);
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BNotificationNotice',
                mixins: [__WEBPACK_IMPORTED_MODULE_1__utils_NoticeMixin_js__["a" /* default */]],
                props: {
                    indefinite: {
                        type: Boolean,
                        default: false
                    }
                },
                data: function data() {
                    return {
                        newDuration: this.duration || __WEBPACK_IMPORTED_MODULE_0__utils_config__["a" /* default */].defaultNotificationDuration
                    };
                }
            };

            /***/
        },
        /* 173 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('b-notification', _vm._b({
                        on: {
                            "close": _vm.close
                        }
                    }, 'b-notification', _vm.$options.propsData, false));
                }, staticRenderFns: []

                /***/ };
        },
        /* 174 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(175),
            /* template */
            __webpack_require__(176),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 175 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon_Icon__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__input_Input__ = __webpack_require__(17);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__input_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__input_Input__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__utils_FormElementMixin__ = __webpack_require__(10);

            var _components;

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BNumberinput',
                components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2__input_Input___default.a.name, __WEBPACK_IMPORTED_MODULE_2__input_Input___default.a), _components),
                mixins: [__WEBPACK_IMPORTED_MODULE_3__utils_FormElementMixin__["a" /* default */]],
                inheritAttrs: false,
                props: {
                    value: Number,
                    min: [Number, String],
                    max: [Number, String],
                    step: [Number, String],
                    disabled: Boolean,
                    type: {
                        type: String,
                        default: 'is-primary'
                    },
                    editable: {
                        type: Boolean,
                        default: true
                    },
                    controlsRounded: {
                        type: Boolean,
                        default: false
                    },
                    controlsPosition: String
                },
                data: function data() {
                    return {
                        newValue: !isNaN(this.value) ? this.value : parseFloat(this.min) || 0,
                        newStep: this.step || 1,
                        _elementRef: 'input'
                    };
                },

                computed: {
                    computedValue: {
                        get: function get() {
                            return this.newValue;
                        },
                        set: function set(value) {
                            var newValue = value;
                            if (value === '') {
                                newValue = parseFloat(this.min) || 0;
                            }
                            this.newValue = newValue;
                            this.$emit('input', newValue);
                            !this.isValid && this.$refs.input.checkHtml5Validity();
                        }
                    },
                    fieldClasses: function fieldClasses() {
                        return [{ 'has-addons': this.controlsPosition === 'compact' }, { 'is-grouped': this.controlsPosition !== 'compact' }];
                    },
                    buttonClasses: function buttonClasses() {
                        return [this.type, this.size, { 'is-rounded': this.controlsRounded }];
                    },
                    minNumber: function minNumber() {
                        return typeof this.min === 'string' ? parseFloat(this.min) : this.min;
                    },
                    maxNumber: function maxNumber() {
                        return typeof this.max === 'string' ? parseFloat(this.max) : this.max;
                    },
                    stepNumber: function stepNumber() {
                        return typeof this.newStep === 'string' ? parseFloat(this.newStep) : this.newStep;
                    },
                    disabledMin: function disabledMin() {
                        return this.computedValue - this.stepNumber < this.minNumber;
                    },
                    disabledMax: function disabledMax() {
                        return this.computedValue + this.stepNumber > this.maxNumber;
                    },
                    stepDecimals: function stepDecimals() {
                        var step = this.stepNumber.toString();
                        var index = step.indexOf('.');
                        if (index >= 0) {
                            return step.substring(index + 1).length;
                        }
                        return 0;
                    }
                },
                watch: {
                    /**
                    * When v-model is changed:
                    *   1. Set internal value.
                    */
                    value: function value(_value) {
                        this.newValue = _value;
                    }
                },
                methods: {
                    decrement: function decrement() {
                        if (typeof this.minNumber === 'undefined' || this.computedValue - this.stepNumber >= this.minNumber) {
                            var value = this.computedValue - this.stepNumber;
                            this.computedValue = parseFloat(value.toFixed(this.stepDecimals));
                        }
                    },
                    increment: function increment() {
                        if (typeof this.maxNumber === 'undefined' || this.computedValue + this.stepNumber <= this.maxNumber) {
                            var value = this.computedValue + this.stepNumber;
                            this.computedValue = parseFloat(value.toFixed(this.stepDecimals));
                        }
                    },
                    onControlClick: function onControlClick(event, inc) {
                        // IE 11 -> filter click event
                        if (event.detail !== 0 || event.type === 'click') return;
                        if (inc) this.increment();else this.decrement();
                    },
                    onStartLongPress: function onStartLongPress(event, inc) {
                        var _this = this;

                        if (event.button !== 0 && event.type !== 'touchstart') return;
                        this._$intervalTime = new Date();
                        clearInterval(this._$intervalRef);
                        this._$intervalRef = setInterval(function () {
                            if (inc) _this.increment();else _this.decrement();
                        }, 250);
                    },
                    onStopLongPress: function onStopLongPress(inc) {
                        if (!this._$intervalRef) return;
                        var d = new Date();
                        if (d - this._$intervalTime < 250) {
                            if (inc) this.increment();else this.decrement();
                        }
                        clearInterval(this._$intervalRef);
                        this._$intervalRef = null;
                    }
                }
            };

            /***/
        },
        /* 176 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "b-numberinput field",
                        class: _vm.fieldClasses
                    }, [_c('p', {
                        staticClass: "control",
                        on: {
                            "mouseup": function mouseup($event) {
                                _vm.onStopLongPress(false);
                            },
                            "mouseleave": function mouseleave($event) {
                                _vm.onStopLongPress(false);
                            },
                            "touchend": function touchend($event) {
                                _vm.onStopLongPress(false);
                            },
                            "touchcancel": function touchcancel($event) {
                                _vm.onStopLongPress(false);
                            }
                        }
                    }, [_c('button', {
                        staticClass: "button",
                        class: _vm.buttonClasses,
                        attrs: {
                            "type": "button",
                            "disabled": _vm.disabled || _vm.disabledMin
                        },
                        on: {
                            "mousedown": function mousedown($event) {
                                _vm.onStartLongPress($event, false);
                            },
                            "touchstart": function touchstart($event) {
                                $event.preventDefault();
                                _vm.onStartLongPress($event, false);
                            },
                            "click": function click($event) {
                                _vm.onControlClick($event, false);
                            }
                        }
                    }, [_c('b-icon', {
                        attrs: {
                            "icon": "minus",
                            "pack": _vm.iconPack,
                            "size": _vm.iconSize
                        }
                    })], 1)]), _vm._v(" "), _c('b-input', _vm._b({
                        ref: "input",
                        attrs: {
                            "type": "number",
                            "step": _vm.newStep,
                            "max": _vm.max,
                            "min": _vm.min,
                            "size": _vm.size,
                            "disabled": _vm.disabled,
                            "readonly": !_vm.editable,
                            "loading": _vm.loading,
                            "rounded": _vm.rounded,
                            "icon": _vm.icon,
                            "icon-pack": _vm.iconPack,
                            "autocomplete": _vm.autocomplete,
                            "expanded": _vm.expanded,
                            "use-html5-validation": _vm.useHtml5Validation
                        },
                        on: {
                            "focus": function focus($event) {
                                _vm.$emit('focus', $event);
                            },
                            "blur": function blur($event) {
                                _vm.$emit('blur', $event);
                            }
                        },
                        model: {
                            value: _vm.computedValue,
                            callback: function callback($$v) {
                                _vm.computedValue = _vm._n($$v);
                            },
                            expression: "computedValue"
                        }
                    }, 'b-input', _vm.$attrs, false)), _vm._v(" "), _c('p', {
                        staticClass: "control",
                        on: {
                            "mouseup": function mouseup($event) {
                                _vm.onStopLongPress(true);
                            },
                            "mouseleave": function mouseleave($event) {
                                _vm.onStopLongPress(true);
                            },
                            "touchend": function touchend($event) {
                                _vm.onStopLongPress(true);
                            },
                            "touchcancel": function touchcancel($event) {
                                _vm.onStopLongPress(true);
                            }
                        }
                    }, [_c('button', {
                        staticClass: "button",
                        class: _vm.buttonClasses,
                        attrs: {
                            "type": "button",
                            "disabled": _vm.disabled || _vm.disabledMax
                        },
                        on: {
                            "mousedown": function mousedown($event) {
                                _vm.onStartLongPress($event, true);
                            },
                            "touchstart": function touchstart($event) {
                                $event.preventDefault();
                                _vm.onStartLongPress($event, true);
                            },
                            "click": function click($event) {
                                _vm.onControlClick($event, true);
                            }
                        }
                    }, [_c('b-icon', {
                        attrs: {
                            "icon": "plus",
                            "pack": _vm.iconPack,
                            "size": _vm.iconSize
                        }
                    })], 1)])], 1);
                }, staticRenderFns: []

                /***/ };
        },
        /* 177 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon_Icon__);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BPagination',
                components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a),
                props: {
                    total: [Number, String],
                    perPage: {
                        type: [Number, String],
                        default: 20
                    },
                    current: {
                        type: [Number, String],
                        default: 1
                    },
                    size: String,
                    simple: Boolean,
                    rounded: Boolean,
                    order: String,
                    iconPack: String,
                    ariaNextLabel: String,
                    ariaPreviousLabel: String,
                    ariaPageLabel: String,
                    ariaCurrentLabel: String
                },
                computed: {
                    rootClasses: function rootClasses() {
                        return [this.order, this.size, {
                            'is-simple': this.simple,
                            'is-rounded': this.rounded
                        }];
                    },

                    /**
                    * Total page size (count).
                    */
                    pageCount: function pageCount() {
                        return Math.ceil(this.total / this.perPage);
                    },

                    /**
                    * First item of the page (count).
                    */
                    firstItem: function firstItem() {
                        var firstItem = this.current * this.perPage - this.perPage + 1;
                        return firstItem >= 0 ? firstItem : 0;
                    },

                    /**
                    * Check if previous button is available.
                    */
                    hasPrev: function hasPrev() {
                        return this.current > 1;
                    },

                    /**
                    * Check if first page button should be visible.
                    */
                    hasFirst: function hasFirst() {
                        return this.current >= 3;
                    },

                    /**
                    * Check if first ellipsis should be visible.
                    */
                    hasFirstEllipsis: function hasFirstEllipsis() {
                        return this.current >= 4;
                    },

                    /**
                    * Check if last page button should be visible.
                    */
                    hasLast: function hasLast() {
                        return this.current <= this.pageCount - 2;
                    },

                    /**
                    * Check if last ellipsis should be visible.
                    */
                    hasLastEllipsis: function hasLastEllipsis() {
                        return this.current < this.pageCount - 2 && this.current <= this.pageCount - 3;
                    },

                    /**
                    * Check if next button is available.
                    */
                    hasNext: function hasNext() {
                        return this.current < this.pageCount;
                    },

                    /**
                    * Get near pages, 1 before and 1 after the current.
                    * Also add the click event to the array.
                    */
                    pagesInRange: function pagesInRange() {
                        var _this = this;

                        if (this.simple) return;

                        var left = Math.max(1, this.current - 1);
                        var right = Math.min(this.current + 1, this.pageCount);

                        var pages = [];

                        var _loop = function _loop(i) {
                            pages.push({
                                number: i,
                                isCurrent: _this.current === i,
                                click: function click(event) {
                                    if (_this.current === i) return;
                                    _this.$emit('change', i);
                                    _this.$emit('update:current', i);

                                    // Set focus on element to keep tab order
                                    _this.$nextTick(function () {
                                        return event.target.focus();
                                    });
                                }
                            });
                        };

                        for (var i = left; i <= right; i++) {
                            _loop(i);
                        }
                        return pages;
                    }
                },
                watch: {
                    /**
                    * If current page is trying to be greater than page count, set to last.
                    */
                    pageCount: function pageCount(value) {
                        if (this.current > value) this.last();
                    }
                },
                methods: {
                    /**
                    * Previous button click listener.
                    */
                    prev: function prev() {
                        if (!this.hasPrev) return;
                        this.$emit('change', this.current - 1);
                        this.$emit('update:current', this.current - 1);
                    },

                    /**
                    * First button click listener.
                    */
                    first: function first() {
                        this.$emit('change', 1);
                        this.$emit('update:current', 1);
                    },

                    /**
                    * Last button click listener.
                    */
                    last: function last() {
                        this.$emit('change', this.pageCount);
                        this.$emit('update:current', this.pageCount);
                    },

                    /**
                    * Next button click listener.
                    */
                    next: function next() {
                        if (!this.hasNext) return;
                        this.$emit('change', this.current + 1);
                        this.$emit('update:current', this.current + 1);
                    },

                    /**
                    * Get text for aria-label according to page number.
                    */
                    getAriaPageLabel: function getAriaPageLabel(pageNumber, isCurrent) {
                        if (this.ariaPageLabel && (!isCurrent || !this.ariaCurrentLabel)) {
                            return this.ariaPageLabel + ' ' + pageNumber + '.';
                        } else if (this.ariaPageLabel && isCurrent && this.ariaCurrentLabel) {
                            return this.ariaCurrentLabel + ', ' + this.ariaPageLabel + ' ' + pageNumber + '.';
                        }
                        return null;
                    }
                }
            };

            /***/
        },
        /* 178 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('nav', {
                        staticClass: "pagination",
                        class: _vm.rootClasses
                    }, [_c('a', {
                        staticClass: "pagination-previous",
                        attrs: {
                            "role": "button",
                            "href": "#",
                            "disabled": !_vm.hasPrev,
                            "aria-label": _vm.ariaPreviousLabel
                        },
                        on: {
                            "click": function click($event) {
                                $event.preventDefault();
                                _vm.prev($event);
                            }
                        }
                    }, [_c('b-icon', {
                        attrs: {
                            "icon": "chevron-left",
                            "pack": _vm.iconPack,
                            "both": "",
                            "aria-hidden": "true"
                        }
                    })], 1), _vm._v(" "), _c('a', {
                        staticClass: "pagination-next",
                        attrs: {
                            "role": "button",
                            "href": "#",
                            "disabled": !_vm.hasNext,
                            "aria-label": _vm.ariaNextLabel
                        },
                        on: {
                            "click": function click($event) {
                                $event.preventDefault();
                                _vm.next($event);
                            }
                        }
                    }, [_c('b-icon', {
                        attrs: {
                            "icon": "chevron-right",
                            "pack": _vm.iconPack,
                            "both": "",
                            "aria-hidden": "true"
                        }
                    })], 1), _vm._v(" "), !_vm.simple ? _c('ul', {
                        staticClass: "pagination-list"
                    }, [_vm.hasFirst ? _c('li', [_c('a', {
                        staticClass: "pagination-link",
                        attrs: {
                            "role": "button",
                            "href": "#",
                            "aria-label": _vm.getAriaPageLabel(1, false)
                        },
                        on: {
                            "click": function click($event) {
                                $event.preventDefault();
                                _vm.first($event);
                            }
                        }
                    }, [_vm._v("\n                1\n            ")])]) : _vm._e(), _vm._v(" "), _vm.hasFirstEllipsis ? _c('li', [_c('span', {
                        staticClass: "pagination-ellipsis"
                    }, [_vm._v("…")])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.pagesInRange, function (page) {
                        return _c('li', {
                            key: page.number
                        }, [_c('a', {
                            staticClass: "pagination-link",
                            class: {
                                'is-current': page.isCurrent
                            },
                            attrs: {
                                "role": "button",
                                "href": "#",
                                "aria-label": _vm.getAriaPageLabel(page.number, page.isCurrent),
                                "aria-current": page.isCurrent
                            },
                            on: {
                                "click": function click($event) {
                                    $event.preventDefault();
                                    page.click($event);
                                }
                            }
                        }, [_vm._v("\n                " + _vm._s(page.number) + "\n            ")])]);
                    }), _vm._v(" "), _vm.hasLastEllipsis ? _c('li', [_c('span', {
                        staticClass: "pagination-ellipsis"
                    }, [_vm._v("…")])]) : _vm._e(), _vm._v(" "), _vm.hasLast ? _c('li', [_c('a', {
                        staticClass: "pagination-link",
                        attrs: {
                            "role": "button",
                            "href": "#",
                            "aria-label": _vm.getAriaPageLabel(_vm.pageCount, false)
                        },
                        on: {
                            "click": function click($event) {
                                $event.preventDefault();
                                _vm.last($event);
                            }
                        }
                    }, [_vm._v("\n                " + _vm._s(_vm.pageCount) + "\n            ")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm.simple ? _c('small', {
                        staticClass: "info"
                    }, [_vm.perPage == 1 ? [_vm._v("\n            " + _vm._s(_vm.firstItem) + " / " + _vm._s(_vm.total) + "\n        ")] : [_vm._v("\n            " + _vm._s(_vm.firstItem) + "-" + _vm._s(Math.min(_vm.current * _vm.perPage, _vm.total)) + " / " + _vm._s(_vm.total) + "\n        ")]], 2) : _vm._e()]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 179 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(180),
            /* template */
            __webpack_require__(181),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 180 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__ = __webpack_require__(5);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BRadio',
                props: {
                    value: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                    nativeValue: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                    type: String,
                    disabled: Boolean,
                    required: Boolean,
                    name: String,
                    size: String
                },
                data: function data() {
                    return {
                        newValue: this.value
                    };
                },

                computed: {
                    computedValue: {
                        get: function get() {
                            return this.newValue;
                        },
                        set: function set(value) {
                            this.newValue = value;
                            this.$emit('input', value);
                        }
                    }
                },
                watch: {
                    /**
                    * When v-model change, set internal value.
                    */
                    value: function value(_value) {
                        this.newValue = _value;
                    }
                }
            };

            /***/
        },
        /* 181 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('label', {
                        ref: "label",
                        staticClass: "b-radio radio",
                        class: [_vm.size, {
                            'is-disabled': _vm.disabled
                        }],
                        attrs: {
                            "disabled": _vm.disabled,
                            "tabindex": _vm.disabled ? false : 0
                        },
                        on: {
                            "keydown": function keydown($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key) && _vm._k($event.keyCode, "space", 32, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.$refs.label.click();
                            }
                        }
                    }, [_c('input', {
                        directives: [{
                            name: "model",
                            rawName: "v-model",
                            value: _vm.computedValue,
                            expression: "computedValue"
                        }],
                        attrs: {
                            "tabindex": "-1",
                            "type": "radio",
                            "disabled": _vm.disabled,
                            "required": _vm.required,
                            "name": _vm.name
                        },
                        domProps: {
                            "value": _vm.nativeValue,
                            "checked": _vm._q(_vm.computedValue, _vm.nativeValue)
                        },
                        on: {
                            "click": function click($event) {
                                $event.stopPropagation();
                            },
                            "change": function change($event) {
                                _vm.computedValue = _vm.nativeValue;
                            }
                        }
                    }), _vm._v(" "), _c('span', {
                        staticClass: "check",
                        class: _vm.type
                    }), _vm._v(" "), _c('span', {
                        staticClass: "control-label"
                    }, [_vm._t("default")], 2)]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 182 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(183),
            /* template */
            __webpack_require__(184),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 183 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__ = __webpack_require__(5);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BRadioButton',
                props: {
                    value: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                    nativeValue: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                    type: {
                        type: String,
                        default: 'is-primary'
                    },
                    disabled: Boolean,
                    required: Boolean,
                    name: String,
                    size: String
                },
                data: function data() {
                    return {
                        newValue: this.value
                    };
                },

                computed: {
                    computedValue: {
                        get: function get() {
                            return this.newValue;
                        },
                        set: function set(value) {
                            this.newValue = value;
                            this.$emit('input', value);
                        }
                    }
                },
                watch: {
                    /**
                    * When v-model change, set internal value.
                    */
                    value: function value(_value) {
                        this.newValue = _value;
                    }
                }
            };

            /***/
        },
        /* 184 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "control"
                    }, [_c('label', {
                        ref: "label",
                        staticClass: "b-radio radio button",
                        class: [_vm.newValue === _vm.nativeValue ? _vm.type : null, _vm.size],
                        attrs: {
                            "disabled": _vm.disabled,
                            "tabindex": _vm.disabled ? false : 0
                        },
                        on: {
                            "keydown": function keydown($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key) && _vm._k($event.keyCode, "space", 32, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.$refs.label.click();
                            }
                        }
                    }, [_vm._t("default"), _vm._v(" "), _c('input', {
                        directives: [{
                            name: "model",
                            rawName: "v-model",
                            value: _vm.computedValue,
                            expression: "computedValue"
                        }],
                        attrs: {
                            "tabindex": "-1",
                            "type": "radio",
                            "disabled": _vm.disabled,
                            "required": _vm.required,
                            "name": _vm.name
                        },
                        domProps: {
                            "value": _vm.nativeValue,
                            "checked": _vm._q(_vm.computedValue, _vm.nativeValue)
                        },
                        on: {
                            "click": function click($event) {
                                $event.stopPropagation();
                            },
                            "change": function change($event) {
                                _vm.computedValue = _vm.nativeValue;
                            }
                        }
                    })], 2)]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 185 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(186),
            /* template */
            __webpack_require__(187),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 186 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__utils_config__ = __webpack_require__(2);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__utils_NoticeMixin_js__ = __webpack_require__(45);
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BSnackbar',
                mixins: [__WEBPACK_IMPORTED_MODULE_1__utils_NoticeMixin_js__["a" /* default */]],
                props: {
                    actionText: {
                        type: String,
                        default: 'OK'
                    },
                    onAction: {
                        type: Function,
                        default: function _default() {}
                    },
                    indefinite: {
                        type: Boolean,
                        default: false
                    }
                },
                data: function data() {
                    return {
                        newDuration: this.duration || __WEBPACK_IMPORTED_MODULE_0__utils_config__["a" /* default */].defaultSnackbarDuration
                    };
                },

                methods: {
                    /**
                    * Click listener.
                    * Call action prop before closing (from Mixin).
                    */
                    action: function action() {
                        this.onAction();
                        this.close();
                    }
                }
            };

            /***/
        },
        /* 187 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('transition', {
                        attrs: {
                            "enter-active-class": _vm.transition.enter,
                            "leave-active-class": _vm.transition.leave
                        }
                    }, [_c('div', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isActive,
                            expression: "isActive"
                        }],
                        staticClass: "snackbar",
                        class: [_vm.type, _vm.position]
                    }, [_c('div', {
                        staticClass: "text",
                        domProps: {
                            "innerHTML": _vm._s(_vm.message)
                        }
                    }), _vm._v(" "), _vm.actionText ? _c('div', {
                        staticClass: "action",
                        class: _vm.type,
                        on: {
                            "click": _vm.action
                        }
                    }, [_c('button', {
                        staticClass: "button"
                    }, [_vm._v(_vm._s(_vm.actionText))])]) : _vm._e()])]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 188 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(189),
            /* template */
            __webpack_require__(190),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 189 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon_Icon__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__utils_SlotComponent__ = __webpack_require__(67);

            var _components;

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BSteps',
                components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2__utils_SlotComponent__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__utils_SlotComponent__["a" /* default */]), _components),
                props: {
                    value: Number,
                    type: [String, Object],
                    size: String,
                    animated: {
                        type: Boolean,
                        default: true
                    },
                    destroyOnHide: {
                        type: Boolean,
                        default: false
                    },
                    iconPack: String,
                    hasNavigation: {
                        type: Boolean,
                        default: true
                    },
                    ariaNextLabel: String,
                    ariaPreviousLabel: String
                },
                data: function data() {
                    return {
                        activeStep: this.value || 0,
                        stepItems: [],
                        contentHeight: 0,
                        isTransitioning: false,
                        _isSteps: true // Used internally by StepItem
                    };
                },

                computed: {
                    mainClasses: function mainClasses() {
                        return [this.type, this.size];
                    },
                    reversedStepItems: function reversedStepItems() {
                        return this.stepItems.slice().reverse();
                    },

                    /**
                        * Check the first visible step index.
                        */
                    firstVisibleStepIndex: function firstVisibleStepIndex() {
                        return this.stepItems.findIndex(function (step, idx) {
                            return step.visible;
                        });
                    },

                    /**
                        * Check if previous button is available.
                        */
                    hasPrev: function hasPrev() {
                        return this.firstVisibleStepIndex >= 0 && this.activeStep > this.firstVisibleStepIndex;
                    },

                    /**
                        * Check the last visible step index.
                        */
                    lastVisibleStepIndex: function lastVisibleStepIndex() {
                        var idx = this.reversedStepItems.findIndex(function (step, idx) {
                            return step.visible;
                        });
                        if (idx >= 0) {
                            return this.stepItems.length - 1 - idx;
                        }
                        return idx;
                    },

                    /**
                        * Check if next button is available.
                        */
                    hasNext: function hasNext() {
                        return this.lastVisibleStepIndex >= 0 && this.activeStep < this.lastVisibleStepIndex;
                    }
                },
                watch: {
                    /**
                    * When v-model is changed set the new active step.
                    */
                    value: function value(_value) {
                        this.changeStep(_value);
                    },

                    /**
                    * When step-items are updated, set active one.
                    */
                    stepItems: function stepItems() {
                        if (this.activeStep < this.stepItems.length) {
                            this.stepItems[this.activeStep].isActive = true;
                        }
                    }
                },
                methods: {
                    /**
                    * Change the active step and emit change event.
                    */
                    changeStep: function changeStep(newIndex) {
                        if (this.activeStep === newIndex) return;

                        if (this.activeStep < this.stepItems.length) {
                            this.stepItems[this.activeStep].deactivate(this.activeStep, newIndex);
                        }
                        this.stepItems[newIndex].activate(this.activeStep, newIndex);
                        this.activeStep = newIndex;
                        this.$emit('change', newIndex);
                    },

                    /**
                        * Return if the step should be clickable or not.
                        */
                    isItemClickable: function isItemClickable(stepItem) {
                        if (stepItem.clickable === undefined) {
                            return stepItem.completed;
                        }
                        return stepItem.clickable;
                    },

                    /**
                    * Step click listener, emit input event and change active step.
                    */
                    stepClick: function stepClick(value) {
                        this.$emit('input', value);
                        this.changeStep(value);
                    },

                    /**
                        * Previous button click listener.
                        */
                    prev: function prev() {
                        var _this = this;

                        if (!this.hasPrev) return;
                        var prevItemIdx = this.reversedStepItems.findIndex(function (step, idx) {
                            return _this.stepItems.length - 1 - idx < _this.activeStep && step.visible;
                        });
                        if (prevItemIdx >= 0) {
                            prevItemIdx = this.stepItems.length - 1 - prevItemIdx;
                        }
                        this.changeStep(prevItemIdx);
                    },

                    /**
                        * Previous button click listener.
                        */
                    next: function next() {
                        var _this2 = this;

                        if (!this.hasNext) return;
                        var nextItemIdx = this.stepItems.findIndex(function (step, idx) {
                            return idx > _this2.activeStep && step.visible;
                        });
                        this.changeStep(nextItemIdx);
                    }
                },
                mounted: function mounted() {
                    if (this.activeStep < this.stepItems.length) {
                        this.stepItems[this.activeStep].isActive = true;
                    }
                }
            };

            /***/
        },
        /* 190 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "b-steps"
                    }, [_c('nav', {
                        staticClass: "steps",
                        class: _vm.mainClasses
                    }, [_c('ul', {
                        staticClass: "step-items"
                    }, _vm._l(_vm.stepItems, function (stepItem, index) {
                        return _c('li', {
                            directives: [{
                                name: "show",
                                rawName: "v-show",
                                value: stepItem.visible,
                                expression: "stepItem.visible"
                            }],
                            key: index,
                            staticClass: "step-item",
                            class: [stepItem.type || _vm.type, {
                                'is-active': _vm.activeStep === index,
                                'is-completed': stepItem.completed || _vm.activeStep > index
                            }]
                        }, [_c('a', {
                            staticClass: "step-link",
                            class: {
                                'is-clickable': _vm.isItemClickable(stepItem)
                            },
                            on: {
                                "click": function click($event) {
                                    _vm.isItemClickable(stepItem) && _vm.stepClick(index);
                                }
                            }
                        }, [_c('div', {
                            staticClass: "step-marker"
                        }, [stepItem.icon ? _c('b-icon', {
                            attrs: {
                                "icon": stepItem.icon,
                                "pack": stepItem.iconPack,
                                "size": _vm.size
                            }
                        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
                            staticClass: "step-details"
                        }, [_c('span', {
                            staticClass: "step-title"
                        }, [_vm._v(_vm._s(stepItem.label))])])])]);
                    }))]), _vm._v(" "), _c('section', {
                        staticClass: "step-content",
                        class: {
                            'is-transitioning': _vm.isTransitioning
                        }
                    }, [_vm._t("default")], 2), _vm._v(" "), _vm.hasNavigation ? _c('nav', {
                        staticClass: "step-navigation"
                    }, [_c('a', {
                        staticClass: "pagination-previous",
                        attrs: {
                            "role": "button",
                            "href": "#",
                            "disabled": !_vm.hasPrev,
                            "aria-label": _vm.ariaPreviousLabel
                        },
                        on: {
                            "click": function click($event) {
                                $event.preventDefault();
                                _vm.prev($event);
                            }
                        }
                    }, [_c('b-icon', {
                        attrs: {
                            "icon": "chevron-left",
                            "pack": _vm.iconPack,
                            "both": "",
                            "aria-hidden": "true"
                        }
                    })], 1), _vm._v(" "), _c('a', {
                        staticClass: "pagination-next",
                        attrs: {
                            "role": "button",
                            "href": "#",
                            "disabled": !_vm.hasNext,
                            "aria-label": _vm.ariaNextLabel
                        },
                        on: {
                            "click": function click($event) {
                                $event.preventDefault();
                                _vm.next($event);
                            }
                        }
                    }, [_c('b-icon', {
                        attrs: {
                            "icon": "chevron-right",
                            "pack": _vm.iconPack,
                            "both": "",
                            "aria-hidden": "true"
                        }
                    })], 1)]) : _vm._e()]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 191 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(192),
            /* template */
            null,
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 192 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BStepItem',
                props: {
                    label: String,
                    type: String | Object,
                    icon: String,
                    iconPack: String,
                    clickable: Boolean,
                    completed: {
                        type: Boolean,
                        default: false
                    },
                    visible: {
                        type: Boolean,
                        default: true
                    }
                },
                data: function data() {
                    return {
                        isActive: false,
                        transitionName: null
                    };
                },

                methods: {
                    /**
                    * Activate step, alter animation name based on the index.
                    */
                    activate: function activate(oldIndex, index) {
                        this.transitionName = index < oldIndex ? 'slide-next' : 'slide-prev';
                        this.isActive = true;
                    },

                    /**
                    * Deactivate step, alter animation name based on the index.
                    */
                    deactivate: function deactivate(oldIndex, index) {
                        this.transitionName = index < oldIndex ? 'slide-next' : 'slide-prev';
                        this.isActive = false;
                    }
                },
                created: function created() {
                    if (!this.$parent.$data._isSteps) {
                        this.$destroy();
                        throw new Error('You should wrap bStepItem on a bSteps');
                    }
                    this.$parent.stepItems.push(this);
                },
                beforeDestroy: function beforeDestroy() {
                    var index = this.$parent.stepItems.indexOf(this);
                    if (index >= 0) {
                        this.$parent.stepItems.splice(index, 1);
                    }
                },
                render: function render(createElement) {
                    var _this = this;

                    // if destroy apply v-if
                    if (this.$parent.destroyOnHide) {
                        if (!this.isActive || !this.visible) {
                            return;
                        }
                    }
                    var vnode = createElement('div', {
                        directives: [{
                            name: 'show',
                            value: this.isActive && this.visible
                        }],
                        attrs: { 'class': 'step-item' }
                    }, this.$slots.default);
                    // check animated prop
                    if (this.$parent.animated) {
                        return createElement('transition', {
                            props: {
                                'name': this.transitionName
                            },
                            on: {
                                'before-enter': function beforeEnter() {
                                    _this.$parent.isTransitioning = true;
                                },
                                'after-enter': function afterEnter() {
                                    _this.$parent.isTransitioning = false;
                                }
                            }
                        }, [vnode]);
                    }
                    return vnode;
                }
            };

            /***/
        },
        /* 193 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(194),
            /* template */
            __webpack_require__(195),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 194 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__ = __webpack_require__(5);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__);

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BSwitch',
                props: {
                    value: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                    nativeValue: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                    disabled: Boolean,
                    type: String,
                    name: String,
                    required: Boolean,
                    size: String,
                    trueValue: {
                        type: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                        default: true
                    },
                    falseValue: {
                        type: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                        default: false
                    }
                },
                data: function data() {
                    return {
                        newValue: this.value,
                        isMouseDown: false
                    };
                },

                computed: {
                    computedValue: {
                        get: function get() {
                            return this.newValue;
                        },
                        set: function set(value) {
                            this.newValue = value;
                            this.$emit('input', value);
                        }
                    }
                },
                watch: {
                    /**
                    * When v-model change, set internal value.
                    */
                    value: function value(_value) {
                        this.newValue = _value;
                    }
                }
            };

            /***/
        },
        /* 195 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('label', {
                        ref: "label",
                        staticClass: "switch",
                        class: [_vm.size, {
                            'is-disabled': _vm.disabled
                        }],
                        attrs: {
                            "disabled": _vm.disabled
                        },
                        on: {
                            "keydown": function keydown($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.$refs.label.click();
                            },
                            "mousedown": function mousedown($event) {
                                _vm.isMouseDown = true;
                            },
                            "mouseup": function mouseup($event) {
                                _vm.isMouseDown = false;
                            },
                            "mouseout": function mouseout($event) {
                                _vm.isMouseDown = false;
                            },
                            "blur": function blur($event) {
                                _vm.isMouseDown = false;
                            }
                        }
                    }, [_c('input', {
                        directives: [{
                            name: "model",
                            rawName: "v-model",
                            value: _vm.computedValue,
                            expression: "computedValue"
                        }],
                        attrs: {
                            "type": "checkbox",
                            "disabled": _vm.disabled,
                            "name": _vm.name,
                            "required": _vm.required,
                            "true-value": _vm.trueValue,
                            "false-value": _vm.falseValue
                        },
                        domProps: {
                            "value": _vm.nativeValue,
                            "checked": Array.isArray(_vm.computedValue) ? _vm._i(_vm.computedValue, _vm.nativeValue) > -1 : _vm._q(_vm.computedValue, _vm.trueValue)
                        },
                        on: {
                            "click": function click($event) {
                                $event.stopPropagation();
                            },
                            "change": function change($event) {
                                var $$a = _vm.computedValue,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? _vm.trueValue : _vm.falseValue;
                                if (Array.isArray($$a)) {
                                    var $$v = _vm.nativeValue,
                                        $$i = _vm._i($$a, $$v);
                                    if ($$el.checked) {
                                        $$i < 0 && (_vm.computedValue = $$a.concat([$$v]));
                                    } else {
                                        $$i > -1 && (_vm.computedValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                                    }
                                } else {
                                    _vm.computedValue = $$c;
                                }
                            }
                        }
                    }), _vm._v(" "), _c('span', {
                        staticClass: "check",
                        class: [{
                            'is-elastic': _vm.isMouseDown && !_vm.disabled
                        }, _vm.type]
                    }), _vm._v(" "), _c('span', {
                        staticClass: "control-label"
                    }, [_vm._t("default")], 2)]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 196 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(197),
            /* template */
            __webpack_require__(211),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 197 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(198);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(7);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__checkbox_Checkbox__ = __webpack_require__(61);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__checkbox_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__checkbox_Checkbox__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__icon_Icon__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__pagination_Pagination__ = __webpack_require__(66);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__pagination_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pagination_Pagination__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__TableMobileSort__ = __webpack_require__(206);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__TableMobileSort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TableMobileSort__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__TableColumn__ = __webpack_require__(68);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__TableColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TableColumn__);

            var _components;

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BTable',
                components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3__checkbox_Checkbox___default.a.name, __WEBPACK_IMPORTED_MODULE_3__checkbox_Checkbox___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_4__icon_Icon___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5__pagination_Pagination___default.a.name, __WEBPACK_IMPORTED_MODULE_5__pagination_Pagination___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6__TableMobileSort___default.a.name, __WEBPACK_IMPORTED_MODULE_6__TableMobileSort___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7__TableColumn___default.a.name, __WEBPACK_IMPORTED_MODULE_7__TableColumn___default.a), _components),
                props: {
                    data: {
                        type: Array,
                        default: function _default() {
                            return [];
                        }
                    },
                    columns: {
                        type: Array,
                        default: function _default() {
                            return [];
                        }
                    },
                    bordered: Boolean,
                    striped: Boolean,
                    narrowed: Boolean,
                    hoverable: Boolean,
                    loading: Boolean,
                    detailed: Boolean,
                    checkable: Boolean,
                    headerCheckable: {
                        type: Boolean,
                        default: true
                    },
                    checkboxPosition: {
                        type: String,
                        default: 'left',
                        validator: function validator(value) {
                            return ['left', 'right'].indexOf(value) >= 0;
                        }
                    },
                    selected: Object,
                    focusable: Boolean,
                    customIsChecked: Function,
                    isRowCheckable: {
                        type: Function,
                        default: function _default() {
                            return true;
                        }
                    },
                    checkedRows: {
                        type: Array,
                        default: function _default() {
                            return [];
                        }
                    },
                    mobileCards: {
                        type: Boolean,
                        default: true
                    },
                    defaultSort: [String, Array],
                    defaultSortDirection: {
                        type: String,
                        default: 'asc'
                    },
                    paginated: Boolean,
                    currentPage: {
                        type: Number,
                        default: 1
                    },
                    perPage: {
                        type: [Number, String],
                        default: 20
                    },
                    showDetailIcon: {
                        type: Boolean,
                        default: true
                    },
                    paginationSimple: Boolean,
                    paginationSize: String,
                    paginationPosition: {
                        type: String,
                        default: 'bottom',
                        validator: function validator(value) {
                            return ['bottom', 'top', 'both'].indexOf(value) >= 0;
                        }
                    },
                    backendSorting: Boolean,
                    rowClass: {
                        type: Function,
                        default: function _default() {
                            return '';
                        }
                    },
                    openedDetailed: {
                        type: Array,
                        default: function _default() {
                            return [];
                        }
                    },
                    hasDetailedVisible: {
                        type: Function,
                        default: function _default() {
                            return true;
                        }
                    },
                    detailKey: {
                        type: String,
                        default: ''
                    },
                    customDetailRow: {
                        type: Boolean,
                        default: false
                    },
                    backendPagination: Boolean,
                    total: {
                        type: [Number, String],
                        default: 0
                    },
                    iconPack: String,
                    mobileSortPlaceholder: String,
                    customRowKey: String,
                    draggable: {
                        type: Boolean,
                        defualt: false
                    },
                    ariaNextLabel: String,
                    ariaPreviousLabel: String,
                    ariaPageLabel: String,
                    ariaCurrentLabel: String
                },
                data: function data() {
                    return {
                        getValueByPath: __WEBPACK_IMPORTED_MODULE_2__utils_helpers__["a" /* getValueByPath */],
                        newColumns: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.columns)),
                        visibleDetailRows: this.openedDetailed,
                        newData: this.data,
                        newDataTotal: this.backendPagination ? this.total : this.data.length,
                        newCheckedRows: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.checkedRows)),
                        newCurrentPage: this.currentPage,
                        currentSortColumn: {},
                        isAsc: true,
                        firstTimeSort: true, // Used by first time initSort
                        _isTable: true // Used by TableColumn
                    };
                },

                computed: {
                    /**
                    * return if detailed row tabled
                    * will be with chevron column & icon or not
                    */
                    showDetailRowIcon: function showDetailRowIcon() {
                        return this.detailed && this.showDetailIcon;
                    },
                    tableClasses: function tableClasses() {
                        return {
                            'is-bordered': this.bordered,
                            'is-striped': this.striped,
                            'is-narrow': this.narrowed,
                            'has-mobile-cards': this.mobileCards,
                            'is-hoverable': (this.hoverable || this.focusable) && this.visibleData.length
                        };
                    },

                    /**
                    * Splitted data based on the pagination.
                    */
                    visibleData: function visibleData() {
                        if (!this.paginated) return this.newData;

                        var currentPage = this.newCurrentPage;
                        var perPage = this.perPage;

                        if (this.newData.length <= perPage) {
                            return this.newData;
                        } else {
                            var start = (currentPage - 1) * perPage;
                            var end = parseInt(start, 10) + parseInt(perPage, 10);
                            return this.newData.slice(start, end);
                        }
                    },
                    visibleColumns: function visibleColumns() {
                        if (!this.newColumns) return this.newColumns;
                        return this.newColumns.filter(function (column) {
                            return column.visible || column.visible === undefined;
                        });
                    },

                    /**
                    * Check if all rows in the page are checked.
                    */
                    isAllChecked: function isAllChecked() {
                        var _this = this;

                        var validVisibleData = this.visibleData.filter(function (row) {
                            return _this.isRowCheckable(row);
                        });
                        if (validVisibleData.length === 0) return false;
                        var isAllChecked = validVisibleData.some(function (currentVisibleRow) {
                            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["b" /* indexOf */])(_this.newCheckedRows, currentVisibleRow, _this.customIsChecked) < 0;
                        });
                        return !isAllChecked;
                    },

                    /**
                    * Check if all rows in the page are checkable.
                    */
                    isAllUncheckable: function isAllUncheckable() {
                        var _this2 = this;

                        var validVisibleData = this.visibleData.filter(function (row) {
                            return _this2.isRowCheckable(row);
                        });
                        return validVisibleData.length === 0;
                    },

                    /**
                    * Check if has any sortable column.
                    */
                    hasSortablenewColumns: function hasSortablenewColumns() {
                        return this.newColumns.some(function (column) {
                            return column.sortable;
                        });
                    },

                    /**
                    * Return total column count based if it's checkable or expanded
                    */
                    columnCount: function columnCount() {
                        var count = this.newColumns.length;
                        count += this.checkable ? 1 : 0;
                        count += this.detailed ? 1 : 0;

                        return count;
                    }
                },
                watch: {
                    /**
                    * When data prop change:
                    *   1. Update internal value.
                    *   2. Reset newColumns (thead), in case it's on a v-for loop.
                    *   3. Sort again if it's not backend-sort.
                    *   4. Set new total if it's not backend-paginated.
                    */
                    data: function data(value) {
                        var _this3 = this;

                        // Save newColumns before resetting
                        var newColumns = this.newColumns;

                        this.newColumns = [];
                        this.newData = value;

                        // Prevent table from being headless, data could change and created hook
                        // on column might not trigger
                        this.$nextTick(function () {
                            if (!_this3.newColumns.length) _this3.newColumns = newColumns;
                        });

                        if (!this.backendSorting) {
                            this.sort(this.currentSortColumn, true);
                        }
                        if (!this.backendPagination) {
                            this.newDataTotal = value.length;
                        }
                    },

                    /**
                    * When Pagination total change, update internal total
                    * only if it's backend-paginated.
                    */
                    total: function total(newTotal) {
                        if (!this.backendPagination) return;

                        this.newDataTotal = newTotal;
                    },

                    /**
                    * When checkedRows prop change, update internal value without
                    * mutating original data.
                    */
                    checkedRows: function checkedRows(rows) {
                        this.newCheckedRows = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(rows));
                    },
                    columns: function columns(value) {
                        this.newColumns = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(value));
                    },
                    newColumns: function newColumns(value) {
                        this.checkSort();
                    },

                    /**
                        * When the user wants to control the detailed rows via props.
                        * Or wants to open the details of certain row with the router for example.
                        */
                    openedDetailed: function openedDetailed(expandedRows) {
                        this.visibleDetailRows = expandedRows;
                    },
                    currentPage: function currentPage(newVal) {
                        this.newCurrentPage = newVal;
                    }
                },
                methods: {
                    /**
                    * Sort an array by key without mutating original data.
                    * Call the user sort function if it was passed.
                    */
                    sortBy: function sortBy(array, key, fn, isAsc) {
                        var sorted = [];
                        // Sorting without mutating original data
                        if (fn && typeof fn === 'function') {
                            sorted = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(array)).sort(function (a, b) {
                                return fn(a, b, isAsc);
                            });
                        } else {
                            sorted = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(array)).sort(function (a, b) {
                                // Get nested values from objects
                                var newA = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["a" /* getValueByPath */])(a, key);
                                var newB = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["a" /* getValueByPath */])(b, key);

                                // sort boolean type
                                if (typeof newA === 'boolean' && typeof newB === 'boolean') {
                                    return isAsc ? newA - newB : newB - newA;
                                }

                                if (!newA && newA !== 0) return 1;
                                if (!newB && newB !== 0) return -1;
                                if (newA === newB) return 0;

                                newA = typeof newA === 'string' ? newA.toUpperCase() : newA;
                                newB = typeof newB === 'string' ? newB.toUpperCase() : newB;

                                return isAsc ? newA > newB ? 1 : -1 : newA > newB ? -1 : 1;
                            });
                        }

                        return sorted;
                    },

                    /**
                    * Sort the column.
                    * Toggle current direction on column if it's sortable
                    * and not just updating the prop.
                    */
                    sort: function sort(column) {
                        var updatingData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                        if (!column || !column.sortable) return;

                        if (!updatingData) {
                            this.isAsc = column === this.currentSortColumn ? !this.isAsc : this.defaultSortDirection.toLowerCase() !== 'desc';
                        }
                        if (!this.firstTimeSort) {
                            this.$emit('sort', column.field, this.isAsc ? 'asc' : 'desc');
                        }
                        if (!this.backendSorting) {
                            this.newData = this.sortBy(this.newData, column.field, column.customSort, this.isAsc);
                        }
                        this.currentSortColumn = column;
                    },

                    /**
                    * Check if the row is checked (is added to the array).
                    */
                    isRowChecked: function isRowChecked(row) {
                        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["b" /* indexOf */])(this.newCheckedRows, row, this.customIsChecked) >= 0;
                    },

                    /**
                    * Remove a checked row from the array.
                    */
                    removeCheckedRow: function removeCheckedRow(row) {
                        var index = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["b" /* indexOf */])(this.newCheckedRows, row, this.customIsChecked);
                        if (index >= 0) {
                            this.newCheckedRows.splice(index, 1);
                        }
                    },

                    /**
                    * Header checkbox click listener.
                    * Add or remove all rows in current page.
                    */
                    checkAll: function checkAll() {
                        var _this4 = this;

                        var isAllChecked = this.isAllChecked;
                        this.visibleData.forEach(function (currentRow) {
                            _this4.removeCheckedRow(currentRow);
                            if (!isAllChecked) {
                                if (_this4.isRowCheckable(currentRow)) {
                                    _this4.newCheckedRows.push(currentRow);
                                }
                            }
                        });

                        this.$emit('check', this.newCheckedRows);
                        this.$emit('check-all', this.newCheckedRows);

                        // Emit checked rows to update user variable
                        this.$emit('update:checkedRows', this.newCheckedRows);
                    },

                    /**
                    * Row checkbox click listener.
                    * Add or remove a single row.
                    */
                    checkRow: function checkRow(row) {
                        if (!this.isRowChecked(row)) {
                            this.newCheckedRows.push(row);
                        } else {
                            this.removeCheckedRow(row);
                        }

                        this.$emit('check', this.newCheckedRows, row);

                        // Emit checked rows to update user variable
                        this.$emit('update:checkedRows', this.newCheckedRows);
                    },

                    /**
                    * Row click listener.
                    * Emit all necessary events.
                    */
                    selectRow: function selectRow(row, index) {
                        this.$emit('click', row);

                        if (this.selected === row) return;

                        // Emit new and old row
                        this.$emit('select', row, this.selected);

                        // Emit new row to update user variable
                        this.$emit('update:selected', row);
                    },

                    /**
                    * Paginator change listener.
                    */
                    pageChanged: function pageChanged(page) {
                        this.newCurrentPage = page > 0 ? page : 1;
                        this.$emit('page-change', this.newCurrentPage);
                        this.$emit('update:currentPage', this.newCurrentPage);
                    },

                    /**
                    * Toggle to show/hide details slot
                    */
                    toggleDetails: function toggleDetails(obj) {
                        var found = this.isVisibleDetailRow(obj);

                        if (found) {
                            this.closeDetailRow(obj);
                            this.$emit('details-close', obj);
                        } else {
                            this.openDetailRow(obj);
                            this.$emit('details-open', obj);
                        }

                        // Syncs the detailed rows with the parent component
                        this.$emit('update:openedDetailed', this.visibleDetailRows);
                    },
                    openDetailRow: function openDetailRow(obj) {
                        var index = this.handleDetailKey(obj);
                        this.visibleDetailRows.push(index);
                    },
                    closeDetailRow: function closeDetailRow(obj) {
                        var index = this.handleDetailKey(obj);
                        var i = this.visibleDetailRows.indexOf(index);
                        this.visibleDetailRows.splice(i, 1);
                    },
                    isVisibleDetailRow: function isVisibleDetailRow(obj) {
                        var index = this.handleDetailKey(obj);
                        var result = this.visibleDetailRows.indexOf(index) >= 0;
                        return result;
                    },
                    isActiveDetailRow: function isActiveDetailRow(row) {
                        return this.detailed && !this.customDetailRow && this.isVisibleDetailRow(row);
                    },
                    isActiveCustomDetailRow: function isActiveCustomDetailRow(row) {
                        return this.detailed && this.customDetailRow && this.isVisibleDetailRow(row);
                    },

                    /**
                        * When the detailKey is defined we use the object[detailKey] as index.
                        * If not, use the object reference by default.
                        */
                    handleDetailKey: function handleDetailKey(index) {
                        var key = this.detailKey;
                        return !key.length ? index : index[key];
                    },
                    checkPredefinedDetailedRows: function checkPredefinedDetailedRows() {
                        var defaultExpandedRowsDefined = this.openedDetailed.length > 0;
                        if (defaultExpandedRowsDefined && !this.detailKey.length) {
                            throw new Error('If you set a predefined opened-detailed, you must provide a unique key using the prop "detail-key"');
                        }
                    },

                    /**
                    * Call initSort only first time (For example async data).
                    */
                    checkSort: function checkSort() {
                        if (this.newColumns.length && this.firstTimeSort) {
                            this.initSort();
                            this.firstTimeSort = false;
                        } else if (this.newColumns.length) {
                            if (this.currentSortColumn.field) {
                                for (var i = 0; i < this.newColumns.length; i++) {
                                    if (this.newColumns[i].field === this.currentSortColumn.field) {
                                        this.currentSortColumn = this.newColumns[i];
                                        break;
                                    }
                                }
                            }
                        }
                    },

                    /**
                    * Check if footer slot has custom content.
                    */
                    hasCustomFooterSlot: function hasCustomFooterSlot() {
                        if (this.$slots.footer.length > 1) return true;

                        var tag = this.$slots.footer[0].tag;
                        if (tag !== 'th' && tag !== 'td') return false;

                        return true;
                    },

                    /**
                    * Check if bottom-left slot exists.
                    */
                    hasBottomLeftSlot: function hasBottomLeftSlot() {
                        return typeof this.$slots['bottom-left'] !== 'undefined';
                    },

                    /**
                    * Table arrow keys listener, change selection.
                    */
                    pressedArrow: function pressedArrow(pos) {
                        if (!this.visibleData.length) return;

                        var index = this.visibleData.indexOf(this.selected) + pos;

                        // Prevent from going up from first and down from last
                        index = index < 0 ? 0 : index > this.visibleData.length - 1 ? this.visibleData.length - 1 : index;

                        this.selectRow(this.visibleData[index]);
                    },

                    /**
                    * Focus table element if has selected prop.
                    */
                    focus: function focus() {
                        if (!this.focusable) return;

                        this.$el.querySelector('table').focus();
                    },

                    /**
                    * Initial sorted column based on the default-sort prop.
                    */
                    initSort: function initSort() {
                        var _this5 = this;

                        if (!this.defaultSort) return;

                        var sortField = '';
                        var sortDirection = this.defaultSortDirection;

                        if (Array.isArray(this.defaultSort)) {
                            sortField = this.defaultSort[0];
                            if (this.defaultSort[1]) {
                                sortDirection = this.defaultSort[1];
                            }
                        } else {
                            sortField = this.defaultSort;
                        }

                        this.newColumns.forEach(function (column) {
                            if (column.field === sortField) {
                                _this5.isAsc = sortDirection.toLowerCase() !== 'desc';
                                _this5.sort(column, true);
                            }
                        });
                    },

                    /**
                    * Emits drag start event
                    */
                    handleDragStart: function handleDragStart(event, row, index) {
                        this.$emit('dragstart', { event: event, row: row, index: index });
                    },

                    /**
                    * Emits drop event
                    */
                    handleDrop: function handleDrop(event, row, index) {
                        this.$emit('drop', { event: event, row: row, index: index });
                    },

                    /**
                    * Emits drag over event
                    */
                    handleDragOver: function handleDragOver(event, row, index) {
                        this.$emit('dragover', { event: event, row: row, index: index });
                    },

                    /**
                    * Emits drag leave event
                    */
                    handleDragLeave: function handleDragLeave(event, row, index) {
                        this.$emit('dragleave', { event: event, row: row, index: index });
                    }
                },

                mounted: function mounted() {
                    this.checkPredefinedDetailedRows();
                    this.checkSort();
                }
            };

            /***/
        },
        /* 198 */
        /***/function (module, exports, __webpack_require__) {

            "use strict";

            exports.__esModule = true;

            var _from = __webpack_require__(199);

            var _from2 = _interopRequireDefault(_from);

            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : { default: obj };
            }

            exports.default = function (arr) {
                if (Array.isArray(arr)) {
                    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                        arr2[i] = arr[i];
                    }

                    return arr2;
                } else {
                    return (0, _from2.default)(arr);
                }
            };

            /***/
        },
        /* 199 */
        /***/function (module, exports, __webpack_require__) {

            module.exports = { "default": __webpack_require__(200), __esModule: true };

            /***/
        },
        /* 200 */
        /***/function (module, exports, __webpack_require__) {

            __webpack_require__(41);
            __webpack_require__(201);
            module.exports = __webpack_require__(6).Array.from;

            /***/
        },
        /* 201 */
        /***/function (module, exports, __webpack_require__) {

            "use strict";

            var ctx = __webpack_require__(46);
            var $export = __webpack_require__(19);
            var toObject = __webpack_require__(40);
            var call = __webpack_require__(202);
            var isArrayIter = __webpack_require__(203);
            var toLength = __webpack_require__(51);
            var createProperty = __webpack_require__(204);
            var getIterFn = __webpack_require__(60);

            $export($export.S + $export.F * !__webpack_require__(205)(function (iter) {
                Array.from(iter);
            }), 'Array', {
                // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
                from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
                    var O = toObject(arrayLike);
                    var C = typeof this == 'function' ? this : Array;
                    var aLen = arguments.length;
                    var mapfn = aLen > 1 ? arguments[1] : undefined;
                    var mapping = mapfn !== undefined;
                    var index = 0;
                    var iterFn = getIterFn(O);
                    var length, result, step, iterator;
                    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
                    // if object isn't iterable or it's array with default iterator - use simple case
                    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
                        for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
                            createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
                        }
                    } else {
                        length = toLength(O.length);
                        for (result = new C(length); length > index; index++) {
                            createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
                        }
                    }
                    result.length = index;
                    return result;
                }
            });

            /***/
        },
        /* 202 */
        /***/function (module, exports, __webpack_require__) {

            // call something on iterator step with safe closing on error
            var anObject = __webpack_require__(15);
            module.exports = function (iterator, fn, value, entries) {
                try {
                    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
                    // 7.4.6 IteratorClose(iterator, completion)
                } catch (e) {
                    var ret = iterator['return'];
                    if (ret !== undefined) anObject(ret.call(iterator));
                    throw e;
                }
            };

            /***/
        },
        /* 203 */
        /***/function (module, exports, __webpack_require__) {

            // check on default Array iterator
            var Iterators = __webpack_require__(23);
            var ITERATOR = __webpack_require__(4)('iterator');
            var ArrayProto = Array.prototype;

            module.exports = function (it) {
                return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
            };

            /***/
        },
        /* 204 */
        /***/function (module, exports, __webpack_require__) {

            "use strict";

            var $defineProperty = __webpack_require__(9);
            var createDesc = __webpack_require__(22);

            module.exports = function (object, index, value) {
                if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
            };

            /***/
        },
        /* 205 */
        /***/function (module, exports, __webpack_require__) {

            var ITERATOR = __webpack_require__(4)('iterator');
            var SAFE_CLOSING = false;

            try {
                var riter = [7][ITERATOR]();
                riter['return'] = function () {
                    SAFE_CLOSING = true;
                };
                // eslint-disable-next-line no-throw-literal
                Array.from(riter, function () {
                    throw 2;
                });
            } catch (e) {/* empty */}

            module.exports = function (exec, skipClosing) {
                if (!skipClosing && !SAFE_CLOSING) return false;
                var safe = false;
                try {
                    var arr = [7];
                    var iter = arr[ITERATOR]();
                    iter.next = function () {
                        return { done: safe = true };
                    };
                    arr[ITERATOR] = function () {
                        return iter;
                    };
                    exec(arr);
                } catch (e) {/* empty */}
                return safe;
            };

            /***/
        },
        /* 206 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(207),
            /* template */
            __webpack_require__(208),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 207 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__select_Select__ = __webpack_require__(31);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__select_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__select_Select__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__icon_Icon__);

            var _components;

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BTableMobileSort',
                components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1__select_Select___default.a.name, __WEBPACK_IMPORTED_MODULE_1__select_Select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_2__icon_Icon___default.a), _components),
                props: {
                    currentSortColumn: Object,
                    isAsc: Boolean,
                    columns: Array,
                    placeholder: String
                },
                data: function data() {
                    return {
                        mobileSort: this.currentSortColumn
                    };
                },

                computed: {
                    showPlaceholder: function showPlaceholder() {
                        var _this = this;

                        return !this.columns || !this.columns.some(function (column) {
                            return column === _this.mobileSort;
                        });
                    }
                },
                watch: {
                    mobileSort: function mobileSort(column) {
                        if (this.currentSortColumn === column) return;

                        this.$emit('sort', column);
                    },
                    currentSortColumn: function currentSortColumn(column) {
                        this.mobileSort = column;
                    }
                },
                methods: {
                    sort: function sort() {
                        this.$emit('sort', this.mobileSort);
                    }
                }
            };

            /***/
        },
        /* 208 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "field table-mobile-sort"
                    }, [_c('div', {
                        staticClass: "field has-addons"
                    }, [_c('b-select', {
                        attrs: {
                            "expanded": ""
                        },
                        model: {
                            value: _vm.mobileSort,
                            callback: function callback($$v) {
                                _vm.mobileSort = $$v;
                            },
                            expression: "mobileSort"
                        }
                    }, [_vm.placeholder ? [_c('option', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showPlaceholder,
                            expression: "showPlaceholder"
                        }],
                        attrs: {
                            "selected": "",
                            "disabled": "",
                            "hidden": ""
                        },
                        domProps: {
                            "value": {}
                        }
                    }, [_vm._v("\n                    " + _vm._s(_vm.placeholder) + "\n                ")])] : _vm._e(), _vm._v(" "), _vm._l(_vm.columns, function (column, index) {
                        return column.sortable ? _c('option', {
                            key: index,
                            domProps: {
                                "value": column
                            }
                        }, [_vm._v("\n                " + _vm._s(column.label) + "\n            ")]) : _vm._e();
                    })], 2), _vm._v(" "), _c('div', {
                        staticClass: "control"
                    }, [_c('button', {
                        staticClass: "button is-primary",
                        on: {
                            "click": _vm.sort
                        }
                    }, [_c('b-icon', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: _vm.currentSortColumn === _vm.mobileSort,
                            expression: "currentSortColumn === mobileSort"
                        }],
                        class: {
                            'is-desc': !_vm.isAsc
                        },
                        attrs: {
                            "icon": "arrow-up",
                            "size": "is-small",
                            "both": ""
                        }
                    })], 1)])], 1)]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 209 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__ = __webpack_require__(5);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__);

            //
            //
            //
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BTableColumn',
                props: {
                    label: String,
                    customKey: [String, Number],
                    field: String,
                    meta: [String, Number, Boolean, Function, Object, Array, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default.a],
                    width: [Number, String],
                    numeric: Boolean,
                    centered: Boolean,
                    sortable: Boolean,
                    visible: {
                        type: Boolean,
                        default: true
                    },
                    customSort: Function,
                    internal: Boolean // Used internally by Table
                },
                data: function data() {
                    return {
                        newKey: this.customKey || this.label
                    };
                },

                computed: {
                    rootClasses: function rootClasses() {
                        return {
                            'has-text-right': this.numeric && !this.centered,
                            'has-text-centered': this.centered
                        };
                    }
                },
                methods: {
                    addRefToTable: function addRefToTable() {
                        var _this = this;

                        if (!this.$parent.$data._isTable) {
                            this.$destroy();
                            throw new Error('You should wrap bTableColumn on a bTable');
                        }

                        if (this.internal) return;

                        // Since we're using scoped prop the columns gonna be multiplied,
                        // this finds when to stop based on the newKey property.
                        var repeated = this.$parent.newColumns.some(function (column) {
                            return column.newKey === _this.newKey;
                        });
                        !repeated && this.$parent.newColumns.push(this);
                    }
                },
                beforeMount: function beforeMount() {
                    this.addRefToTable();
                },
                beforeUpdate: function beforeUpdate() {
                    this.addRefToTable();
                },
                beforeDestroy: function beforeDestroy() {
                    var index = this.$parent.newColumns.map(function (column) {
                        return column.newKey;
                    }).indexOf(this.newKey);
                    if (index >= 0) {
                        this.$parent.newColumns.splice(index, 1);
                    }
                }
            };

            /***/
        },
        /* 210 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _vm.visible ? _c('td', {
                        class: _vm.rootClasses,
                        attrs: {
                            "data-label": _vm.label
                        }
                    }, [_c('span', [_vm._t("default")], 2)]) : _vm._e();
                }, staticRenderFns: []

                /***/ };
        },
        /* 211 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "b-table",
                        class: {
                            'is-loading': _vm.loading
                        }
                    }, [_vm.mobileCards && _vm.hasSortablenewColumns ? _c('b-table-mobile-sort', {
                        attrs: {
                            "current-sort-column": _vm.currentSortColumn,
                            "is-asc": _vm.isAsc,
                            "columns": _vm.newColumns,
                            "placeholder": _vm.mobileSortPlaceholder
                        },
                        on: {
                            "sort": function sort(column) {
                                return _vm.sort(column);
                            }
                        }
                    }) : _vm._e(), _vm._v(" "), _vm.paginated && (_vm.paginationPosition === 'top' || _vm.paginationPosition === 'both') ? _c('div', {
                        staticClass: "top level"
                    }, [_c('div', {
                        staticClass: "level-left"
                    }, [_vm._t("top-left")], 2), _vm._v(" "), _c('div', {
                        staticClass: "level-right"
                    }, [_vm.paginated ? _c('div', {
                        staticClass: "level-item"
                    }, [_c('b-pagination', {
                        attrs: {
                            "icon-pack": _vm.iconPack,
                            "total": _vm.newDataTotal,
                            "per-page": _vm.perPage,
                            "simple": _vm.paginationSimple,
                            "size": _vm.paginationSize,
                            "current": _vm.newCurrentPage,
                            "aria-next-label": _vm.ariaNextLabel,
                            "aria-previous-label": _vm.ariaPreviousLabel,
                            "aria-page-label": _vm.ariaPageLabel,
                            "aria-current-label": _vm.ariaCurrentLabel
                        },
                        on: {
                            "change": _vm.pageChanged
                        }
                    })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
                        staticClass: "table-wrapper"
                    }, [_c('table', {
                        staticClass: "table",
                        class: _vm.tableClasses,
                        attrs: {
                            "tabindex": !_vm.focusable ? false : 0
                        },
                        on: {
                            "keydown": [function ($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) {
                                    return null;
                                }
                                if ($event.target !== $event.currentTarget) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.pressedArrow(-1);
                            }, function ($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) {
                                    return null;
                                }
                                if ($event.target !== $event.currentTarget) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.pressedArrow(1);
                            }]
                        }
                    }, [_vm.newColumns.length ? _c('thead', [_c('tr', [_vm.showDetailRowIcon ? _c('th', {
                        attrs: {
                            "width": "40px"
                        }
                    }) : _vm._e(), _vm._v(" "), _vm.checkable && _vm.checkboxPosition === 'left' ? _c('th', {
                        staticClass: "checkbox-cell"
                    }, [_vm.headerCheckable ? [_c('b-checkbox', {
                        attrs: {
                            "value": _vm.isAllChecked,
                            "disabled": _vm.isAllUncheckable
                        },
                        nativeOn: {
                            "change": function change($event) {
                                _vm.checkAll($event);
                            }
                        }
                    })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._l(_vm.visibleColumns, function (column, index) {
                        return _c('th', {
                            key: index,
                            class: {
                                'is-current-sort': _vm.currentSortColumn === column,
                                'is-sortable': column.sortable
                            },
                            style: {
                                width: column.width === undefined ? null : column.width + 'px'
                            },
                            on: {
                                "click": function click($event) {
                                    $event.stopPropagation();
                                    _vm.sort(column);
                                }
                            }
                        }, [_c('div', {
                            staticClass: "th-wrap",
                            class: {
                                'is-numeric': column.numeric,
                                'is-centered': column.centered
                            }
                        }, [_vm.$scopedSlots.header ? _vm._t("header", null, {
                            column: column,
                            index: index
                        }) : [_vm._v(_vm._s(column.label))], _vm._v(" "), _c('b-icon', {
                            directives: [{
                                name: "show",
                                rawName: "v-show",
                                value: _vm.currentSortColumn === column,
                                expression: "currentSortColumn === column"
                            }],
                            class: {
                                'is-desc': !_vm.isAsc
                            },
                            attrs: {
                                "icon": "arrow-up",
                                "pack": _vm.iconPack,
                                "both": "",
                                "size": "is-small"
                            }
                        })], 2)]);
                    }), _vm._v(" "), _vm.checkable && _vm.checkboxPosition === 'right' ? _c('th', {
                        staticClass: "checkbox-cell"
                    }, [_vm.headerCheckable ? [_c('b-checkbox', {
                        attrs: {
                            "value": _vm.isAllChecked,
                            "disabled": _vm.isAllUncheckable
                        },
                        nativeOn: {
                            "change": function change($event) {
                                _vm.checkAll($event);
                            }
                        }
                    })] : _vm._e()], 2) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm.visibleData.length ? _c('tbody', [_vm._l(_vm.visibleData, function (row, index) {
                        return [_c('tr', {
                            key: _vm.customRowKey ? row[_vm.customRowKey] : index,
                            class: [_vm.rowClass(row, index), {
                                'is-selected': row === _vm.selected,
                                'is-checked': _vm.isRowChecked(row)
                            }],
                            attrs: {
                                "draggable": _vm.draggable
                            },
                            on: {
                                "click": function click($event) {
                                    _vm.selectRow(row);
                                },
                                "dblclick": function dblclick($event) {
                                    _vm.$emit('dblclick', row);
                                },
                                "contextmenu": function contextmenu($event) {
                                    _vm.$emit('contextmenu', row, $event);
                                },
                                "dragstart": function dragstart($event) {
                                    _vm.handleDragStart($event, row, index);
                                },
                                "drop": function drop($event) {
                                    _vm.handleDrop($event, row, index);
                                },
                                "dragover": function dragover($event) {
                                    _vm.handleDragOver($event, row, index);
                                },
                                "dragleave": function dragleave($event) {
                                    _vm.handleDragLeave($event, row, index);
                                }
                            }
                        }, [_vm.showDetailRowIcon ? _c('td', {
                            staticClass: "chevron-cell"
                        }, [_vm.hasDetailedVisible(row) ? _c('a', {
                            attrs: {
                                "role": "button"
                            },
                            on: {
                                "click": function click($event) {
                                    $event.stopPropagation();
                                    _vm.toggleDetails(row);
                                }
                            }
                        }, [_c('b-icon', {
                            class: {
                                'is-expanded': _vm.isVisibleDetailRow(row)
                            },
                            attrs: {
                                "icon": "chevron-right",
                                "pack": _vm.iconPack,
                                "both": ""
                            }
                        })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.checkable && _vm.checkboxPosition === 'left' ? _c('td', {
                            staticClass: "checkbox-cell"
                        }, [_c('b-checkbox', {
                            attrs: {
                                "disabled": !_vm.isRowCheckable(row),
                                "value": _vm.isRowChecked(row)
                            },
                            nativeOn: {
                                "change": function change($event) {
                                    _vm.checkRow(row);
                                },
                                "click": function click($event) {
                                    $event.stopPropagation();
                                }
                            }
                        })], 1) : _vm._e(), _vm._v(" "), _vm.$scopedSlots.default ? _vm._t("default", null, {
                            row: row,
                            index: index
                        }) : _vm._l(_vm.newColumns, function (column) {
                            return _c('BTableColumn', _vm._b({
                                key: column.field,
                                attrs: {
                                    "internal": ""
                                }
                            }, 'BTableColumn', column, false), [column.renderHtml ? _c('span', {
                                domProps: {
                                    "innerHTML": _vm._s(_vm.getValueByPath(row, column.field))
                                }
                            }) : [_vm._v("\n                                    " + _vm._s(_vm.getValueByPath(row, column.field)) + "\n                                ")]], 2);
                        }), _vm._v(" "), _vm.checkable && _vm.checkboxPosition === 'right' ? _c('td', {
                            staticClass: "checkbox-cell"
                        }, [_c('b-checkbox', {
                            attrs: {
                                "disabled": !_vm.isRowCheckable(row),
                                "value": _vm.isRowChecked(row)
                            },
                            nativeOn: {
                                "change": function change($event) {
                                    _vm.checkRow(row);
                                },
                                "click": function click($event) {
                                    $event.stopPropagation();
                                }
                            }
                        })], 1) : _vm._e()], 2), _vm._v(" "), _vm.isActiveDetailRow(row) ? _c('tr', {
                            staticClass: "detail"
                        }, [_c('td', {
                            attrs: {
                                "colspan": _vm.columnCount
                            }
                        }, [_c('div', {
                            staticClass: "detail-container"
                        }, [_vm._t("detail", null, {
                            row: row,
                            index: index
                        })], 2)])]) : _vm._e(), _vm._v(" "), _vm.isActiveCustomDetailRow(row) ? _vm._t("detail", null, {
                            row: row,
                            index: index
                        }) : _vm._e()];
                    })], 2) : _c('tbody', [_c('tr', {
                        staticClass: "is-empty"
                    }, [_c('td', {
                        attrs: {
                            "colspan": _vm.columnCount
                        }
                    }, [_vm._t("empty")], 2)])]), _vm._v(" "), _vm.$slots.footer !== undefined ? _c('tfoot', [_c('tr', {
                        staticClass: "table-footer"
                    }, [_vm.hasCustomFooterSlot() ? _vm._t("footer") : _c('th', {
                        attrs: {
                            "colspan": _vm.columnCount
                        }
                    }, [_vm._t("footer")], 2)], 2)]) : _vm._e()])]), _vm._v(" "), _vm.checkable && _vm.hasBottomLeftSlot() || _vm.paginated && (_vm.paginationPosition === 'bottom' || _vm.paginationPosition === 'both') ? _c('div', {
                        staticClass: "level"
                    }, [_c('div', {
                        staticClass: "level-left"
                    }, [_vm._t("bottom-left")], 2), _vm._v(" "), _c('div', {
                        staticClass: "level-right"
                    }, [_vm.paginated ? _c('div', {
                        staticClass: "level-item"
                    }, [_c('b-pagination', {
                        attrs: {
                            "icon-pack": _vm.iconPack,
                            "total": _vm.newDataTotal,
                            "per-page": _vm.perPage,
                            "simple": _vm.paginationSimple,
                            "size": _vm.paginationSize,
                            "current": _vm.newCurrentPage,
                            "aria-next-label": _vm.ariaNextLabel,
                            "aria-previous-label": _vm.ariaPreviousLabel,
                            "aria-page-label": _vm.ariaPageLabel,
                            "aria-current-label": _vm.ariaCurrentLabel
                        },
                        on: {
                            "change": _vm.pageChanged
                        }
                    })], 1) : _vm._e()])]) : _vm._e()], 1);
                }, staticRenderFns: []

                /***/ };
        },
        /* 212 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(213),
            /* template */
            __webpack_require__(214),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 213 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon_Icon__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__utils_SlotComponent__ = __webpack_require__(67);

            var _components;

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BTabs',
                components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_1__icon_Icon___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2__utils_SlotComponent__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__utils_SlotComponent__["a" /* default */]), _components),
                props: {
                    value: Number,
                    expanded: Boolean,
                    type: String,
                    size: String,
                    position: String,
                    animated: {
                        type: Boolean,
                        default: true
                    },
                    destroyOnHide: {
                        type: Boolean,
                        default: false
                    }
                },
                data: function data() {
                    return {
                        activeTab: this.value || 0,
                        tabItems: [],
                        contentHeight: 0,
                        isTransitioning: false,
                        _isTabs: true // Used internally by TabItem
                    };
                },

                computed: {
                    navClasses: function navClasses() {
                        return [this.type, this.size, this.position, {
                            'is-fullwidth': this.expanded,
                            'is-toggle-rounded is-toggle': this.type === 'is-toggle-rounded'
                        }];
                    }
                },
                watch: {
                    /**
                    * When v-model is changed set the new active tab.
                    */
                    value: function value(_value) {
                        this.changeTab(_value);
                    },

                    /**
                    * When tab-items are updated, set active one.
                    */
                    tabItems: function tabItems() {
                        if (this.activeTab < this.tabItems.length) {
                            this.tabItems[this.activeTab].isActive = true;
                        }
                    }
                },
                methods: {
                    /**
                    * Change the active tab and emit change event.
                    */
                    changeTab: function changeTab(newIndex) {
                        if (this.activeTab === newIndex) return;

                        if (this.activeTab < this.tabItems.length) {
                            this.tabItems[this.activeTab].deactivate(this.activeTab, newIndex);
                        }
                        this.tabItems[newIndex].activate(this.activeTab, newIndex);
                        this.activeTab = newIndex;
                        this.$emit('change', newIndex);
                    },

                    /**
                    * Tab click listener, emit input event and change active tab.
                    */
                    tabClick: function tabClick(value) {
                        this.$emit('input', value);
                        this.changeTab(value);
                    }
                },
                mounted: function mounted() {
                    if (this.activeTab < this.tabItems.length) {
                        this.tabItems[this.activeTab].isActive = true;
                    }
                }
            };

            /***/
        },
        /* 214 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "b-tabs",
                        class: {
                            'is-fullwidth': _vm.expanded
                        }
                    }, [_c('nav', {
                        staticClass: "tabs",
                        class: _vm.navClasses
                    }, [_c('ul', _vm._l(_vm.tabItems, function (tabItem, index) {
                        return _c('li', {
                            directives: [{
                                name: "show",
                                rawName: "v-show",
                                value: tabItem.visible,
                                expression: "tabItem.visible"
                            }],
                            key: index,
                            class: {
                                'is-active': _vm.activeTab === index, 'is-disabled': tabItem.disabled
                            }
                        }, [_c('a', {
                            on: {
                                "click": function click($event) {
                                    _vm.tabClick(index);
                                }
                            }
                        }, [tabItem.$slots.header ? [_c('b-slot-component', {
                            attrs: {
                                "component": tabItem,
                                "name": "header",
                                "tag": "span"
                            }
                        })] : [tabItem.icon ? _c('b-icon', {
                            attrs: {
                                "icon": tabItem.icon,
                                "pack": tabItem.iconPack,
                                "size": _vm.size
                            }
                        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(tabItem.label))])]], 2)]);
                    }))]), _vm._v(" "), _c('section', {
                        staticClass: "tab-content",
                        class: {
                            'is-transitioning': _vm.isTransitioning
                        }
                    }, [_vm._t("default")], 2)]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 215 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(216),
            /* template */
            null,
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 216 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BTabItem',
                props: {
                    label: String,
                    icon: String,
                    iconPack: String,
                    disabled: Boolean,
                    visible: {
                        type: Boolean,
                        default: true
                    }
                },
                data: function data() {
                    return {
                        isActive: false,
                        transitionName: null
                    };
                },

                methods: {
                    /**
                    * Activate tab, alter animation name based on the index.
                    */
                    activate: function activate(oldIndex, index) {
                        this.transitionName = index < oldIndex ? 'slide-next' : 'slide-prev';
                        this.isActive = true;
                    },

                    /**
                    * Deactivate tab, alter animation name based on the index.
                    */
                    deactivate: function deactivate(oldIndex, index) {
                        this.transitionName = index < oldIndex ? 'slide-next' : 'slide-prev';
                        this.isActive = false;
                    }
                },
                created: function created() {
                    if (!this.$parent.$data._isTabs) {
                        this.$destroy();
                        throw new Error('You should wrap bTabItem on a bTabs');
                    }
                    this.$parent.tabItems.push(this);
                },
                beforeDestroy: function beforeDestroy() {
                    var index = this.$parent.tabItems.indexOf(this);
                    if (index >= 0) {
                        this.$parent.tabItems.splice(index, 1);
                    }
                },
                render: function render(createElement) {
                    var _this = this;

                    // if destroy apply v-if
                    if (this.$parent.destroyOnHide) {
                        if (!this.isActive || !this.visible) {
                            return;
                        }
                    }
                    var vnode = createElement('div', {
                        directives: [{
                            name: 'show',
                            value: this.isActive && this.visible
                        }],
                        attrs: { 'class': 'tab-item' }
                    }, this.$slots.default);
                    // check animated prop
                    if (this.$parent.animated) {
                        return createElement('transition', {
                            props: {
                                'name': this.transitionName
                            },
                            on: {
                                'before-enter': function beforeEnter() {
                                    _this.$parent.isTransitioning = true;
                                },
                                'after-enter': function afterEnter() {
                                    _this.$parent.isTransitioning = false;
                                }
                            }
                        }, [vnode]);
                    }
                    return vnode;
                }
            };

            /***/
        },
        /* 217 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BTag',
                props: {
                    attached: Boolean,
                    closable: Boolean,
                    type: String,
                    size: String,
                    rounded: Boolean,
                    disabled: Boolean,
                    ellipsis: Boolean,
                    tabstop: {
                        type: Boolean,
                        default: true
                    }
                },
                methods: {
                    /**
                    * Emit close event when delete button is clicked
                    * or delete key is pressed.
                    */
                    close: function close() {
                        if (this.disabled) return;

                        this.$emit('close');
                    }
                }
            };

            /***/
        },
        /* 218 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _vm.attached && _vm.closable ? _c('div', {
                        staticClass: "tags has-addons"
                    }, [_c('span', {
                        staticClass: "tag",
                        class: [_vm.type, _vm.size, {
                            'is-rounded': _vm.rounded
                        }]
                    }, [_c('span', {
                        class: {
                            'has-ellipsis': _vm.ellipsis
                        }
                    }, [_vm._t("default")], 2)]), _vm._v(" "), _c('a', {
                        staticClass: "tag is-delete",
                        class: [_vm.size, {
                            'is-rounded': _vm.rounded
                        }],
                        attrs: {
                            "role": "button",
                            "tabindex": _vm.tabstop ? 0 : false,
                            "disabled": _vm.disabled
                        },
                        on: {
                            "click": function click($event) {
                                _vm.close();
                            },
                            "keyup": function keyup($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.close();
                            }
                        }
                    })]) : _c('span', {
                        staticClass: "tag",
                        class: [_vm.type, _vm.size, {
                            'is-rounded': _vm.rounded
                        }]
                    }, [_c('span', {
                        class: {
                            'has-ellipsis': _vm.ellipsis
                        }
                    }, [_vm._t("default")], 2), _vm._v(" "), _vm.closable ? _c('a', {
                        staticClass: "delete is-small",
                        attrs: {
                            "role": "button",
                            "disabled": _vm.disabled,
                            "tabindex": _vm.tabstop ? 0 : false
                        },
                        on: {
                            "click": function click($event) {
                                _vm.close();
                            },
                            "keyup": function keyup($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key)) {
                                    return null;
                                }
                                $event.preventDefault();
                                _vm.close();
                            }
                        }
                    }) : _vm._e()]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 219 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(220),
            /* template */
            __webpack_require__(221),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 220 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            //
            //
            //
            //
            //
            //

            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BTaglist',
                props: {
                    attached: Boolean
                }
            };

            /***/
        },
        /* 221 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "tags",
                        class: {
                            'has-addons': _vm.attached
                        }
                    }, [_vm._t("default")], 2);
                }, staticRenderFns: []

                /***/ };
        },
        /* 222 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(223),
            /* template */
            __webpack_require__(224),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 223 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(53);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(7);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__tag_Tag__ = __webpack_require__(69);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__tag_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tag_Tag__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__autocomplete_Autocomplete__ = __webpack_require__(52);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__autocomplete_Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__autocomplete_Autocomplete__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__utils_FormElementMixin__ = __webpack_require__(10);

            var _components;

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BTaginput',
                components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4__autocomplete_Autocomplete___default.a.name, __WEBPACK_IMPORTED_MODULE_4__autocomplete_Autocomplete___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3__tag_Tag___default.a.name, __WEBPACK_IMPORTED_MODULE_3__tag_Tag___default.a), _components),
                mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_FormElementMixin__["a" /* default */]],
                inheritAttrs: false,
                props: {
                    value: {
                        type: Array,
                        default: function _default() {
                            return [];
                        }
                    },
                    data: {
                        type: Array,
                        default: function _default() {
                            return [];
                        }
                    },
                    type: String,
                    rounded: {
                        type: Boolean,
                        default: false
                    },
                    attached: {
                        type: Boolean,
                        default: false
                    },
                    maxtags: {
                        type: [Number, String],
                        required: false
                    },
                    field: {
                        type: String,
                        default: 'value'
                    },
                    autocomplete: Boolean,
                    nativeAutocomplete: String,
                    disabled: Boolean,
                    ellipsis: Boolean,
                    closable: {
                        type: Boolean,
                        default: true
                    },
                    confirmKeyCodes: {
                        type: Array,
                        default: function _default() {
                            return [13, 188];
                        }
                    },
                    removeOnKeys: {
                        type: Array,
                        default: function _default() {
                            return [8];
                        }
                    },
                    allowNew: Boolean,
                    onPasteSeparators: {
                        type: Array,
                        default: function _default() {
                            return [','];
                        }
                    },
                    beforeAdding: {
                        type: Function,
                        default: function _default() {
                            return true;
                        }
                    },
                    allowDuplicates: {
                        type: Boolean,
                        default: false
                    }
                },
                data: function data() {
                    return {
                        tags: this.value || [],
                        newTag: '',
                        _elementRef: 'input',
                        _isTaginput: true
                    };
                },

                computed: {
                    rootClasses: function rootClasses() {
                        return {
                            'is-expanded': this.expanded
                        };
                    },
                    containerClasses: function containerClasses() {
                        return {
                            'is-focused': this.isFocused,
                            'is-focusable': this.hasInput
                        };
                    },
                    valueLength: function valueLength() {
                        return this.newTag.trim().length;
                    },
                    defaultSlotName: function defaultSlotName() {
                        return this.hasDefaultSlot ? 'default' : 'dontrender';
                    },
                    emptySlotName: function emptySlotName() {
                        return this.hasEmptySlot ? 'empty' : 'dontrender';
                    },
                    headerSlotName: function headerSlotName() {
                        return this.hasHeaderSlot ? 'header' : 'dontrender';
                    },
                    footerSlotName: function footerSlotName() {
                        return this.hasHeaderSlot ? 'footer' : 'dontrender';
                    },
                    hasDefaultSlot: function hasDefaultSlot() {
                        return !!this.$scopedSlots.default;
                    },
                    hasEmptySlot: function hasEmptySlot() {
                        return !!this.$slots.empty;
                    },
                    hasHeaderSlot: function hasHeaderSlot() {
                        return !!this.$slots.header;
                    },
                    hasFooterSlot: function hasFooterSlot() {
                        return !!this.$slots.footer;
                    },

                    /**
                     * Show the input field if a maxtags hasn't been set or reached.
                     */
                    hasInput: function hasInput() {
                        return this.maxtags == null || this.tagsLength < this.maxtags;
                    },
                    tagsLength: function tagsLength() {
                        return this.tags.length;
                    },

                    /**
                     * If Taginput has onPasteSeparators prop,
                     * returning new RegExp used to split pasted string.
                     */
                    separatorsAsRegExp: function separatorsAsRegExp() {
                        var sep = this.onPasteSeparators;

                        return sep.length ? new RegExp(sep.map(function (s) {
                            return s ? s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') : null;
                        }).join('|'), 'g') : null;
                    }
                },
                watch: {
                    /**
                     * When v-model is changed set internal value.
                     */
                    value: function value(_value) {
                        this.tags = _value;
                    },
                    hasInput: function hasInput() {
                        if (!this.hasInput) this.onBlur();
                    }
                },
                methods: {
                    addTag: function addTag(tag) {
                        var tagToAdd = tag || this.newTag.trim();

                        if (tagToAdd) {
                            if (!this.autocomplete) {
                                var reg = this.separatorsAsRegExp;
                                if (reg && tagToAdd.match(reg)) {
                                    tagToAdd.split(reg).map(function (t) {
                                        return t.trim();
                                    }).filter(function (t) {
                                        return t.length !== 0;
                                    }).map(this.addTag);
                                    return;
                                }
                            }

                            // Add the tag input if it is not blank
                            // or previously added (if not allowDuplicates).
                            var add = !this.allowDuplicates ? this.tags.indexOf(tagToAdd) === -1 : true;
                            if (add && this.beforeAdding(tagToAdd)) {
                                this.tags.push(tagToAdd);
                                this.$emit('input', this.tags);
                                this.$emit('add', tagToAdd);
                            }
                        }

                        this.newTag = '';
                    },
                    getNormalizedTagText: function getNormalizedTagText(tag) {
                        if ((typeof tag === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(tag)) === 'object') {
                            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["a" /* getValueByPath */])(tag, this.field);
                        }

                        return tag;
                    },
                    customOnBlur: function customOnBlur($event) {
                        // Add tag on-blur if not select only
                        if (!this.autocomplete) this.addTag();

                        this.onBlur($event);
                    },
                    onSelect: function onSelect(option) {
                        var _this = this;

                        if (!option) return;

                        this.addTag(option);
                        this.$nextTick(function () {
                            _this.newTag = '';
                        });
                    },
                    removeTag: function removeTag(index) {
                        var tag = this.tags.splice(index, 1)[0];
                        this.$emit('input', this.tags);
                        this.$emit('remove', tag);
                        return tag;
                    },
                    removeLastTag: function removeLastTag() {
                        if (this.tagsLength > 0) {
                            this.removeTag(this.tagsLength - 1);
                        }
                    },
                    keydown: function keydown(event) {
                        if (this.removeOnKeys.indexOf(event.keyCode) !== -1 && !this.newTag.length) {
                            this.removeLastTag();
                        }
                        // Stop if is to accept select only
                        if (this.autocomplete && !this.allowNew) return;

                        if (this.confirmKeyCodes.indexOf(event.keyCode) >= 0) {
                            event.preventDefault();
                            this.addTag();
                        }
                    },
                    onTyping: function onTyping($event) {
                        this.$emit('typing', $event.trim());
                    }
                }
            };

            /***/
        },
        /* 224 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "taginput control",
                        class: _vm.rootClasses
                    }, [_c('div', {
                        staticClass: "taginput-container",
                        class: [_vm.statusType, _vm.size, _vm.containerClasses],
                        attrs: {
                            "disabled": _vm.disabled
                        },
                        on: {
                            "click": function click($event) {
                                _vm.hasInput && _vm.focus($event);
                            }
                        }
                    }, [_vm._l(_vm.tags, function (tag, index) {
                        return _c('b-tag', {
                            key: index,
                            attrs: {
                                "type": _vm.type,
                                "size": _vm.size,
                                "rounded": _vm.rounded,
                                "attached": _vm.attached,
                                "tabstop": false,
                                "disabled": _vm.disabled,
                                "ellipsis": _vm.ellipsis,
                                "closable": _vm.closable,
                                "title": _vm.ellipsis && _vm.getNormalizedTagText(tag)
                            },
                            on: {
                                "close": function close($event) {
                                    _vm.removeTag(index);
                                }
                            }
                        }, [_vm._v("\n            " + _vm._s(_vm.getNormalizedTagText(tag)) + "\n        ")]);
                    }), _vm._v(" "), _vm.hasInput ? _c('b-autocomplete', _vm._b({
                        ref: "autocomplete",
                        attrs: {
                            "data": _vm.data,
                            "field": _vm.field,
                            "icon": _vm.icon,
                            "icon-pack": _vm.iconPack,
                            "maxlength": _vm.maxlength,
                            "has-counter": false,
                            "size": _vm.size,
                            "disabled": _vm.disabled,
                            "loading": _vm.loading,
                            "autocomplete": _vm.nativeAutocomplete,
                            "keep-first": !_vm.allowNew,
                            "use-html5-validation": _vm.useHtml5Validation
                        },
                        on: {
                            "typing": _vm.onTyping,
                            "focus": _vm.onFocus,
                            "blur": _vm.customOnBlur,
                            "select": _vm.onSelect
                        },
                        nativeOn: {
                            "keydown": function keydown($event) {
                                _vm.keydown($event);
                            }
                        },
                        scopedSlots: _vm._u([{
                            key: _vm.defaultSlotName,
                            fn: function fn(props) {
                                return [_vm._t("default", null, {
                                    option: props.option,
                                    index: props.index
                                })];
                            }
                        }]),
                        model: {
                            value: _vm.newTag,
                            callback: function callback($$v) {
                                _vm.newTag = $$v;
                            },
                            expression: "newTag"
                        }
                    }, 'b-autocomplete', _vm.$attrs, false), [_c('template', {
                        slot: _vm.headerSlotName
                    }, [_vm._t("header")], 2), _vm._v(" "), _c('template', {
                        slot: _vm.emptySlotName
                    }, [_vm._t("empty")], 2), _vm._v(" "), _c('template', {
                        slot: _vm.footerSlotName
                    }, [_vm._t("footer")], 2)], 2) : _vm._e()], 2), _vm._v(" "), _vm.maxtags || _vm.maxlength ? _c('p', {
                        staticClass: "help counter"
                    }, [_vm.maxlength && _vm.valueLength > 0 ? [_vm._v("\n            " + _vm._s(_vm.valueLength) + " / " + _vm._s(_vm.maxlength) + "\n        ")] : _vm.maxtags ? [_vm._v("\n            " + _vm._s(_vm.tagsLength) + " / " + _vm._s(_vm.maxtags) + "\n        ")] : _vm._e()], 2) : _vm._e()]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 225 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(226),
            /* template */
            __webpack_require__(227),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 226 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__utils_TimepickerMixin__ = __webpack_require__(62);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__dropdown_Dropdown__ = __webpack_require__(28);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__dropdown_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dropdown_Dropdown__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__dropdown_DropdownItem__ = __webpack_require__(29);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__dropdown_DropdownItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__dropdown_DropdownItem__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__input_Input__ = __webpack_require__(17);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__input_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__input_Input__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__field_Field__ = __webpack_require__(30);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__field_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__field_Field__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__select_Select__ = __webpack_require__(31);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__select_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__select_Select__);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__icon_Icon__ = __webpack_require__(3);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__icon_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__icon_Icon__);

            var _components;

            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BTimepicker',
                components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4__input_Input___default.a.name, __WEBPACK_IMPORTED_MODULE_4__input_Input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5__field_Field___default.a.name, __WEBPACK_IMPORTED_MODULE_5__field_Field___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6__select_Select___default.a.name, __WEBPACK_IMPORTED_MODULE_6__select_Select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7__icon_Icon___default.a.name, __WEBPACK_IMPORTED_MODULE_7__icon_Icon___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2__dropdown_Dropdown___default.a.name, __WEBPACK_IMPORTED_MODULE_2__dropdown_Dropdown___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3__dropdown_DropdownItem___default.a.name, __WEBPACK_IMPORTED_MODULE_3__dropdown_DropdownItem___default.a), _components),
                mixins: [__WEBPACK_IMPORTED_MODULE_1__utils_TimepickerMixin__["a" /* default */]],
                inheritAttrs: false,
                data: function data() {
                    return {
                        _isTimepicker: true
                    };
                },

                computed: {
                    nativeStep: function nativeStep() {
                        if (this.enableSeconds) return '1';
                    }
                }
            };

            /***/
        },
        /* 227 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('div', {
                        staticClass: "timepicker control",
                        class: [_vm.size, {
                            'is-expanded': _vm.expanded
                        }]
                    }, [!_vm.isMobile || _vm.inline ? _c('b-dropdown', {
                        ref: "dropdown",
                        attrs: {
                            "position": _vm.position,
                            "disabled": _vm.disabled,
                            "inline": _vm.inline
                        }
                    }, [!_vm.inline ? _c('b-input', _vm._b({
                        ref: "input",
                        attrs: {
                            "slot": "trigger",
                            "autocomplete": "off",
                            "value": _vm.formatValue(_vm.computedValue),
                            "placeholder": _vm.placeholder,
                            "size": _vm.size,
                            "icon": _vm.icon,
                            "icon-pack": _vm.iconPack,
                            "loading": _vm.loading,
                            "disabled": _vm.disabled,
                            "readonly": !_vm.editable,
                            "rounded": _vm.rounded,
                            "use-html5-validation": _vm.useHtml5Validation
                        },
                        on: {
                            "focus": _vm.handleOnFocus,
                            "blur": function blur($event) {
                                _vm.onBlur() && _vm.checkHtml5Validity();
                            }
                        },
                        nativeOn: {
                            "keyup": function keyup($event) {
                                if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) {
                                    return null;
                                }
                                _vm.toggle(true);
                            },
                            "change": function change($event) {
                                _vm.onChange($event.target.value);
                            }
                        },
                        slot: "trigger"
                    }, 'b-input', _vm.$attrs, false)) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
                        attrs: {
                            "disabled": _vm.disabled,
                            "custom": ""
                        }
                    }, [_c('b-field', {
                        attrs: {
                            "grouped": "",
                            "position": "is-centered"
                        }
                    }, [_c('b-select', {
                        attrs: {
                            "disabled": _vm.disabled,
                            "placeholder": "00"
                        },
                        nativeOn: {
                            "change": function change($event) {
                                _vm.onHoursChange($event.target.value);
                            }
                        },
                        model: {
                            value: _vm.hoursSelected,
                            callback: function callback($$v) {
                                _vm.hoursSelected = $$v;
                            },
                            expression: "hoursSelected"
                        }
                    }, _vm._l(_vm.hours, function (hour) {
                        return _c('option', {
                            key: hour.value,
                            attrs: {
                                "disabled": _vm.isHourDisabled(hour.value)
                            },
                            domProps: {
                                "value": hour.value
                            }
                        }, [_vm._v("\n                        " + _vm._s(hour.label) + "\n                    ")]);
                    })), _vm._v(" "), _c('span', {
                        staticClass: "control is-colon"
                    }, [_vm._v(":")]), _vm._v(" "), _c('b-select', {
                        attrs: {
                            "disabled": _vm.disabled,
                            "placeholder": "00"
                        },
                        nativeOn: {
                            "change": function change($event) {
                                _vm.onMinutesChange($event.target.value);
                            }
                        },
                        model: {
                            value: _vm.minutesSelected,
                            callback: function callback($$v) {
                                _vm.minutesSelected = $$v;
                            },
                            expression: "minutesSelected"
                        }
                    }, _vm._l(_vm.minutes, function (minute) {
                        return _c('option', {
                            key: minute.value,
                            attrs: {
                                "disabled": _vm.isMinuteDisabled(minute.value)
                            },
                            domProps: {
                                "value": minute.value
                            }
                        }, [_vm._v("\n                        " + _vm._s(minute.label) + "\n                    ")]);
                    })), _vm._v(" "), _vm.enableSeconds ? [_c('span', {
                        staticClass: "control is-colon"
                    }, [_vm._v(":")]), _vm._v(" "), _c('b-select', {
                        attrs: {
                            "disabled": _vm.disabled,
                            "placeholder": "00"
                        },
                        nativeOn: {
                            "change": function change($event) {
                                _vm.onSecondsChange($event.target.value);
                            }
                        },
                        model: {
                            value: _vm.secondsSelected,
                            callback: function callback($$v) {
                                _vm.secondsSelected = $$v;
                            },
                            expression: "secondsSelected"
                        }
                    }, _vm._l(_vm.seconds, function (second) {
                        return _c('option', {
                            key: second.value,
                            attrs: {
                                "disabled": _vm.isSecondDisabled(second.value)
                            },
                            domProps: {
                                "value": second.value
                            }
                        }, [_vm._v("\n                            " + _vm._s(second.label) + "\n                        ")]);
                    }))] : _vm._e(), _vm._v(" "), !_vm.isHourFormat24 ? _c('b-select', {
                        attrs: {
                            "disabled": _vm.disabled
                        },
                        nativeOn: {
                            "change": function change($event) {
                                _vm.onMeridienChange($event.target.value);
                            }
                        },
                        model: {
                            value: _vm.meridienSelected,
                            callback: function callback($$v) {
                                _vm.meridienSelected = $$v;
                            },
                            expression: "meridienSelected"
                        }
                    }, _vm._l(_vm.meridiens, function (meridien) {
                        return _c('option', {
                            key: meridien,
                            domProps: {
                                "value": meridien
                            }
                        }, [_vm._v("\n                        " + _vm._s(meridien) + "\n                    ")]);
                    })) : _vm._e()], 2), _vm._v(" "), _vm.$slots.default !== undefined && _vm.$slots.default.length ? _c('footer', {
                        staticClass: "timepicker-footer"
                    }, [_vm._t("default")], 2) : _vm._e()], 1)], 1) : _c('b-input', _vm._b({
                        ref: "input",
                        attrs: {
                            "type": "time",
                            "step": _vm.nativeStep,
                            "autocomplete": "off",
                            "value": _vm.formatHHMMSS(_vm.computedValue),
                            "placeholder": _vm.placeholder,
                            "size": _vm.size,
                            "icon": _vm.icon,
                            "icon-pack": _vm.iconPack,
                            "loading": _vm.loading,
                            "max": _vm.formatHHMMSS(_vm.maxTime),
                            "min": _vm.formatHHMMSS(_vm.minTime),
                            "disabled": _vm.disabled,
                            "readonly": false,
                            "use-html5-validation": _vm.useHtml5Validation
                        },
                        on: {
                            "focus": _vm.handleOnFocus,
                            "blur": function blur($event) {
                                _vm.onBlur() && _vm.checkHtml5Validity();
                            }
                        },
                        nativeOn: {
                            "change": function change($event) {
                                _vm.onChange($event.target.value);
                            }
                        }
                    }, 'b-input', _vm.$attrs, false))], 1);
                }, staticRenderFns: []

                /***/ };
        },
        /* 228 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(229),
            /* template */
            __webpack_require__(230),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 229 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__utils_config__ = __webpack_require__(2);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__utils_NoticeMixin_js__ = __webpack_require__(45);
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BToast',
                mixins: [__WEBPACK_IMPORTED_MODULE_1__utils_NoticeMixin_js__["a" /* default */]],
                data: function data() {
                    return {
                        newDuration: this.duration || __WEBPACK_IMPORTED_MODULE_0__utils_config__["a" /* default */].defaultToastDuration
                    };
                }
            };

            /***/
        },
        /* 230 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('transition', {
                        attrs: {
                            "enter-active-class": _vm.transition.enter,
                            "leave-active-class": _vm.transition.leave
                        }
                    }, [_c('div', {
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isActive,
                            expression: "isActive"
                        }],
                        staticClass: "toast",
                        class: [_vm.type, _vm.position],
                        attrs: {
                            "aria-hidden": !_vm.isActive,
                            "role": "alert"
                        }
                    }, [_c('div', {
                        domProps: {
                            "innerHTML": _vm._s(_vm.message)
                        }
                    })])]);
                }, staticRenderFns: []

                /***/ };
        },
        /* 231 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(232),
            /* template */
            __webpack_require__(233),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 232 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__utils_config__ = __webpack_require__(2);
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BTooltip',
                props: {
                    active: {
                        type: Boolean,
                        default: true
                    },
                    type: String,
                    label: String,
                    position: {
                        type: String,
                        default: 'is-top',
                        validator: function validator(value) {
                            return ['is-top', 'is-bottom', 'is-left', 'is-right'].indexOf(value) > -1;
                        }
                    },
                    always: Boolean,
                    animated: Boolean,
                    square: Boolean,
                    dashed: Boolean,
                    multilined: Boolean,
                    size: {
                        type: String,
                        default: 'is-medium'
                    },
                    delay: {
                        type: Number,
                        default: 0
                    }
                },
                computed: {
                    newType: function newType() {
                        return this.type || __WEBPACK_IMPORTED_MODULE_0__utils_config__["a" /* default */].defaultTooltipType;
                    },
                    newAnimated: function newAnimated() {
                        return this.animated || __WEBPACK_IMPORTED_MODULE_0__utils_config__["a" /* default */].defaultTooltipAnimated;
                    }
                }
            };

            /***/
        },
        /* 233 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('span', {
                        class: [_vm.newType, _vm.position, _vm.size, {
                            'b-tooltip': _vm.active,
                            'is-square': _vm.square,
                            'is-animated': _vm.newAnimated,
                            'is-always': _vm.always,
                            'is-multiline': _vm.multilined,
                            'is-dashed': _vm.dashed
                        }],
                        style: {
                            'transition-delay': _vm.delay + "ms"
                        },
                        attrs: {
                            "data-label": _vm.label
                        }
                    }, [_vm._t("default")], 2);
                }, staticRenderFns: []

                /***/ };
        },
        /* 234 */
        /***/function (module, exports, __webpack_require__) {

            var Component = __webpack_require__(0)(
            /* script */
            __webpack_require__(235),
            /* template */
            __webpack_require__(236),
            /* styles */
            null,
            /* scopeId */
            null,
            /* moduleIdentifier (server only) */
            null);

            module.exports = Component.exports;

            /***/
        },
        /* 235 */
        /***/function (module, __webpack_exports__, __webpack_require__) {

            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__utils_FormElementMixin__ = __webpack_require__(10);
            /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__utils_ssr__ = __webpack_require__(64);
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //


            /* harmony default export */__webpack_exports__["default"] = {
                name: 'BUpload',
                mixins: [__WEBPACK_IMPORTED_MODULE_0__utils_FormElementMixin__["a" /* default */]],
                inheritAttrs: false,
                props: {
                    value: {
                        type: [Object, Function, __WEBPACK_IMPORTED_MODULE_1__utils_ssr__["a" /* File */], Array]
                    },
                    multiple: Boolean,
                    disabled: Boolean,
                    accept: String,
                    dragDrop: Boolean,
                    type: {
                        type: String,
                        default: 'is-primary'
                    },
                    native: {
                        type: Boolean,
                        default: false
                    }
                },
                data: function data() {
                    return {
                        newValue: this.value,
                        dragDropFocus: false,
                        _elementRef: 'input'
                    };
                },

                watch: {
                    /**
                    * When v-model is changed:
                    *   1. Set internal value.
                    *   2. Reset input value if array is empty
                    *   3. If it's invalid, validate again.
                    */
                    value: function value(_value) {
                        this.newValue = _value;
                        if (!this.newValue || Array.isArray(this.newValue) && this.newValue.length === 0) {
                            this.$refs.input.value = null;
                        }
                        !this.isValid && !this.dragDrop && this.checkHtml5Validity();
                    }
                },
                methods: {

                    /**
                    * Listen change event on input type 'file',
                    * emit 'input' event and validate
                    */
                    onFileChange: function onFileChange(event) {
                        if (this.disabled || this.loading) return;
                        if (this.dragDrop) {
                            this.updateDragDropFocus(false);
                        }
                        var value = event.target.files || event.dataTransfer.files;
                        if (value.length === 0) {
                            if (!this.newValue) {
                                return;
                            }
                            this.newValue = null;
                        } else if (!this.multiple) {
                            // only one element in case drag drop mode and isn't multiple
                            if (this.dragDrop && value.length !== 1) return;else {
                                var file = value[0];
                                if (this.checkType(file)) {
                                    this.newValue = file;
                                } else if (this.newValue) {
                                    this.newValue = null;
                                } else {
                                    return;
                                }
                            }
                        } else {
                            // always new values if native or undefined local
                            var newValues = false;
                            if (this.native || !this.newValue) {
                                this.newValue = [];
                                newValues = true;
                            }
                            for (var i = 0; i < value.length; i++) {
                                var _file = value[i];
                                if (this.checkType(_file)) {
                                    this.newValue.push(_file);
                                    newValues = true;
                                }
                            }
                            if (!newValues) {
                                return;
                            }
                        }
                        this.$emit('input', this.newValue);
                        !this.dragDrop && this.checkHtml5Validity();
                    },

                    /**
                    * Listen drag-drop to update internal variable
                    */
                    updateDragDropFocus: function updateDragDropFocus(focus) {
                        if (!this.disabled && !this.loading) {
                            this.dragDropFocus = focus;
                        }
                    },

                    /**
                    * Check mime type of file
                    */
                    checkType: function checkType(file) {
                        if (!this.accept) return true;
                        var types = this.accept.split(',');
                        if (types.length === 0) return true;
                        var valid = false;
                        for (var i = 0; i < types.length && !valid; i++) {
                            var type = types[i].trim();
                            if (type) {
                                if (type.substring(0, 1) === '.') {
                                    // check extension
                                    var extIndex = file.name.lastIndexOf('.');
                                    var extension = extIndex >= 0 ? file.name.substring(extIndex) : '';
                                    if (extension.toLowerCase() === type.toLowerCase()) {
                                        valid = true;
                                    }
                                } else {
                                    // check mime type
                                    if (file.type.match(type)) {
                                        valid = true;
                                    }
                                }
                            }
                        }
                        return valid;
                    }
                }
            };

            /***/
        },
        /* 236 */
        /***/function (module, exports) {

            module.exports = { render: function render() {
                    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
                    return _c('label', {
                        staticClass: "upload control"
                    }, [!_vm.dragDrop ? [_vm._t("default")] : _c('div', {
                        staticClass: "upload-draggable",
                        class: [_vm.type, {
                            'is-loading': _vm.loading,
                            'is-disabled': _vm.disabled,
                            'is-hovered': _vm.dragDropFocus
                        }],
                        on: {
                            "dragover": function dragover($event) {
                                $event.preventDefault();
                                _vm.updateDragDropFocus(true);
                            },
                            "dragleave": function dragleave($event) {
                                $event.preventDefault();
                                _vm.updateDragDropFocus(false);
                            },
                            "dragenter": function dragenter($event) {
                                $event.preventDefault();
                                _vm.updateDragDropFocus(true);
                            },
                            "drop": function drop($event) {
                                $event.preventDefault();
                                _vm.onFileChange($event);
                            }
                        }
                    }, [_vm._t("default")], 2), _vm._v(" "), _c('input', _vm._b({
                        ref: "input",
                        class: {
                            'file-draggable': _vm.dragDrop
                        },
                        attrs: {
                            "type": "file",
                            "multiple": _vm.multiple,
                            "accept": _vm.accept,
                            "disabled": _vm.disabled
                        },
                        on: {
                            "change": _vm.onFileChange
                        }
                    }, 'input', _vm.$attrs, false))], 2);
                }, staticRenderFns: []

                /***/ };
        }]
        /******/)
    );
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)(module)))

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(254);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(2).default
var update = add("6e4843aa", content, true, {});

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "/*! Buefy v0.7.10 | MIT License | github.com/buefy/buefy */\n\n/*! bulma.io v0.7.5 | MIT License | github.com/jgthms/bulma */@keyframes spinAround{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.breadcrumb,.button,.delete,.file,.is-unselectable,.modal-close,.pagination-ellipsis,.pagination-link,.pagination-next,.pagination-previous,.tabs{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.navbar-link:not(.is-arrowless):after,.select:not(.is-multiple):not(.is-loading):after{border:3px solid transparent;border-radius:2px;border-right:0;border-top:0;content:\" \";display:block;height:.625em;margin-top:-.4375em;pointer-events:none;position:absolute;top:50%;transform:rotate(-45deg);transform-origin:center;width:.625em}.block:not(:last-child),.box:not(:last-child),.breadcrumb:not(:last-child),.content:not(:last-child),.highlight:not(:last-child),.level:not(:last-child),.list:not(:last-child),.message:not(:last-child),.notification:not(:last-child),.progress:not(:last-child),.subtitle:not(:last-child),.table-container:not(:last-child),.table:not(:last-child),.tabs:not(:last-child),.title:not(:last-child){margin-bottom:1.5rem}.delete,.modal-close{-moz-appearance:none;-webkit-appearance:none;background-color:hsla(0,0%,4%,.2);border:none;border-radius:290486px;cursor:pointer;pointer-events:auto;display:inline-block;flex-grow:0;flex-shrink:0;font-size:0;height:20px;max-height:20px;max-width:20px;min-height:20px;min-width:20px;outline:none;position:relative;vertical-align:top;width:20px}.delete:after,.delete:before,.modal-close:after,.modal-close:before{background-color:#fff;content:\"\";display:block;left:50%;position:absolute;top:50%;transform:translateX(-50%) translateY(-50%) rotate(45deg);transform-origin:center center}.delete:before,.modal-close:before{height:2px;width:50%}.delete:after,.modal-close:after{height:50%;width:2px}.delete:focus,.delete:hover,.modal-close:focus,.modal-close:hover{background-color:hsla(0,0%,4%,.3)}.delete:active,.modal-close:active{background-color:hsla(0,0%,4%,.4)}.is-small.delete,.is-small.modal-close{height:16px;max-height:16px;max-width:16px;min-height:16px;min-width:16px;width:16px}.is-medium.delete,.is-medium.modal-close{height:24px;max-height:24px;max-width:24px;min-height:24px;min-width:24px;width:24px}.is-large.delete,.is-large.modal-close{height:32px;max-height:32px;max-width:32px;min-height:32px;min-width:32px;width:32px}.button.is-loading:after,.control.is-loading:after,.loader,.select.is-loading:after{animation:spinAround .5s infinite linear;border:2px solid #dbdbdb;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:1em;position:relative;width:1em}.hero-video,.image.is-1by1 .has-ratio,.image.is-1by1 img,.image.is-1by2 .has-ratio,.image.is-1by2 img,.image.is-1by3 .has-ratio,.image.is-1by3 img,.image.is-2by1 .has-ratio,.image.is-2by1 img,.image.is-2by3 .has-ratio,.image.is-2by3 img,.image.is-3by1 .has-ratio,.image.is-3by1 img,.image.is-3by2 .has-ratio,.image.is-3by2 img,.image.is-3by4 .has-ratio,.image.is-3by4 img,.image.is-3by5 .has-ratio,.image.is-3by5 img,.image.is-4by3 .has-ratio,.image.is-4by3 img,.image.is-4by5 .has-ratio,.image.is-4by5 img,.image.is-5by3 .has-ratio,.image.is-5by3 img,.image.is-5by4 .has-ratio,.image.is-5by4 img,.image.is-9by16 .has-ratio,.image.is-9by16 img,.image.is-16by9 .has-ratio,.image.is-16by9 img,.image.is-square .has-ratio,.image.is-square img,.is-overlay,.modal,.modal-background{bottom:0;left:0;position:absolute;right:0;top:0}.button,.file-cta,.file-name,.input,.pagination-ellipsis,.pagination-link,.pagination-next,.pagination-previous,.select select,.taginput .taginput-container.is-focusable,.textarea{-moz-appearance:none;-webkit-appearance:none;align-items:center;border:1px solid transparent;border-radius:4px;box-shadow:none;display:inline-flex;font-size:1rem;height:2.25em;justify-content:flex-start;line-height:1.5;padding:calc(.375em - 1px) calc(.625em - 1px);position:relative;vertical-align:top}.button:active,.button:focus,.file-cta:active,.file-cta:focus,.file-name:active,.file-name:focus,.input:active,.input:focus,.is-active.button,.is-active.file-cta,.is-active.file-name,.is-active.input,.is-active.pagination-ellipsis,.is-active.pagination-link,.is-active.pagination-next,.is-active.pagination-previous,.is-active.textarea,.is-focused.button,.is-focused.file-cta,.is-focused.file-name,.is-focused.input,.is-focused.pagination-ellipsis,.is-focused.pagination-link,.is-focused.pagination-next,.is-focused.pagination-previous,.is-focused.textarea,.pagination-ellipsis:active,.pagination-ellipsis:focus,.pagination-link:active,.pagination-link:focus,.pagination-next:active,.pagination-next:focus,.pagination-previous:active,.pagination-previous:focus,.select select.is-active,.select select.is-focused,.select select:active,.select select:focus,.taginput .is-active.taginput-container.is-focusable,.taginput .is-focused.taginput-container.is-focusable,.taginput .taginput-container.is-focusable:active,.taginput .taginput-container.is-focusable:focus,.textarea:active,.textarea:focus{outline:none}.button[disabled],.file-cta[disabled],.file-name[disabled],.input[disabled],.pagination-ellipsis[disabled],.pagination-link[disabled],.pagination-next[disabled],.pagination-previous[disabled],.select fieldset[disabled] select,.select select[disabled],.taginput .taginput-container.is-focusable[disabled],.taginput fieldset[disabled] .taginput-container.is-focusable,.textarea[disabled],fieldset[disabled] .button,fieldset[disabled] .file-cta,fieldset[disabled] .file-name,fieldset[disabled] .input,fieldset[disabled] .pagination-ellipsis,fieldset[disabled] .pagination-link,fieldset[disabled] .pagination-next,fieldset[disabled] .pagination-previous,fieldset[disabled] .select select,fieldset[disabled] .taginput .taginput-container.is-focusable,fieldset[disabled] .textarea{cursor:not-allowed}\n\n/*! minireset.css v0.0.4 | MIT License | github.com/jgthms/minireset.css */blockquote,body,dd,dl,dt,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,html,iframe,legend,li,ol,p,pre,textarea,ul{margin:0;padding:0}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}ul{list-style:none}button,input,select,textarea{margin:0}html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}embed,iframe,img,object,video{height:auto;max-width:100%}audio{max-width:100%}iframe{border:0}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}td:not([align]),th:not([align]){text-align:left}html{background-color:#fff;font-size:16px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;min-width:300px;overflow-x:hidden;overflow-y:scroll;text-rendering:optimizeLegibility;text-size-adjust:100%}article,aside,figure,footer,header,hgroup,section{display:block}body,button,input,select,textarea{font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif}code,pre{-moz-osx-font-smoothing:auto;-webkit-font-smoothing:auto;font-family:monospace}body{color:#4a4a4a;font-size:1em;font-weight:400;line-height:1.5}a{color:#7957d5;cursor:pointer;text-decoration:none}a strong{color:currentColor}a:hover{color:#363636}code{color:#ff3860;font-size:.875em;font-weight:400;padding:.25em .5em}code,hr{background-color:#f5f5f5}hr{border:none;display:block;height:2px;margin:1.5rem 0}img{height:auto;max-width:100%}input[type=checkbox],input[type=radio]{vertical-align:baseline}small{font-size:.875em}span{font-style:inherit;font-weight:inherit}strong{color:#363636;font-weight:700}fieldset{border:none}pre{-webkit-overflow-scrolling:touch;background-color:#f5f5f5;color:#4a4a4a;font-size:.875em;overflow-x:auto;padding:1.25rem 1.5rem;white-space:pre;word-wrap:normal}pre code{background-color:transparent;color:currentColor;font-size:1em;padding:0}table td,table th{vertical-align:top}table td:not([align]),table th:not([align]){text-align:left}table th{color:#363636}.is-clearfix:after{clear:both;content:\" \";display:table}.is-pulled-left{float:left!important}.is-pulled-right{float:right!important}.is-clipped{overflow:hidden!important}.is-size-1{font-size:3rem!important}.is-size-2{font-size:2.5rem!important}.is-size-3{font-size:2rem!important}.is-size-4{font-size:1.5rem!important}.is-size-5{font-size:1.25rem!important}.is-size-6{font-size:1rem!important}.is-size-7{font-size:.75rem!important}@media screen and (max-width:768px){.is-size-1-mobile{font-size:3rem!important}.is-size-2-mobile{font-size:2.5rem!important}.is-size-3-mobile{font-size:2rem!important}.is-size-4-mobile{font-size:1.5rem!important}.is-size-5-mobile{font-size:1.25rem!important}.is-size-6-mobile{font-size:1rem!important}.is-size-7-mobile{font-size:.75rem!important}}@media print,screen and (min-width:769px){.is-size-1-tablet{font-size:3rem!important}.is-size-2-tablet{font-size:2.5rem!important}.is-size-3-tablet{font-size:2rem!important}.is-size-4-tablet{font-size:1.5rem!important}.is-size-5-tablet{font-size:1.25rem!important}.is-size-6-tablet{font-size:1rem!important}.is-size-7-tablet{font-size:.75rem!important}}@media screen and (max-width:1023px){.is-size-1-touch{font-size:3rem!important}.is-size-2-touch{font-size:2.5rem!important}.is-size-3-touch{font-size:2rem!important}.is-size-4-touch{font-size:1.5rem!important}.is-size-5-touch{font-size:1.25rem!important}.is-size-6-touch{font-size:1rem!important}.is-size-7-touch{font-size:.75rem!important}}@media screen and (min-width:1024px){.is-size-1-desktop{font-size:3rem!important}.is-size-2-desktop{font-size:2.5rem!important}.is-size-3-desktop{font-size:2rem!important}.is-size-4-desktop{font-size:1.5rem!important}.is-size-5-desktop{font-size:1.25rem!important}.is-size-6-desktop{font-size:1rem!important}.is-size-7-desktop{font-size:.75rem!important}}@media screen and (min-width:1216px){.is-size-1-widescreen{font-size:3rem!important}.is-size-2-widescreen{font-size:2.5rem!important}.is-size-3-widescreen{font-size:2rem!important}.is-size-4-widescreen{font-size:1.5rem!important}.is-size-5-widescreen{font-size:1.25rem!important}.is-size-6-widescreen{font-size:1rem!important}.is-size-7-widescreen{font-size:.75rem!important}}@media screen and (min-width:1408px){.is-size-1-fullhd{font-size:3rem!important}.is-size-2-fullhd{font-size:2.5rem!important}.is-size-3-fullhd{font-size:2rem!important}.is-size-4-fullhd{font-size:1.5rem!important}.is-size-5-fullhd{font-size:1.25rem!important}.is-size-6-fullhd{font-size:1rem!important}.is-size-7-fullhd{font-size:.75rem!important}}.has-text-centered{text-align:center!important}.has-text-justified{text-align:justify!important}.has-text-left{text-align:left!important}.has-text-right{text-align:right!important}@media screen and (max-width:768px){.has-text-centered-mobile{text-align:center!important}}@media print,screen and (min-width:769px){.has-text-centered-tablet{text-align:center!important}}@media screen and (min-width:769px) and (max-width:1023px){.has-text-centered-tablet-only{text-align:center!important}}@media screen and (max-width:1023px){.has-text-centered-touch{text-align:center!important}}@media screen and (min-width:1024px){.has-text-centered-desktop{text-align:center!important}}@media screen and (min-width:1024px) and (max-width:1215px){.has-text-centered-desktop-only{text-align:center!important}}@media screen and (min-width:1216px){.has-text-centered-widescreen{text-align:center!important}}@media screen and (min-width:1216px) and (max-width:1407px){.has-text-centered-widescreen-only{text-align:center!important}}@media screen and (min-width:1408px){.has-text-centered-fullhd{text-align:center!important}}@media screen and (max-width:768px){.has-text-justified-mobile{text-align:justify!important}}@media print,screen and (min-width:769px){.has-text-justified-tablet{text-align:justify!important}}@media screen and (min-width:769px) and (max-width:1023px){.has-text-justified-tablet-only{text-align:justify!important}}@media screen and (max-width:1023px){.has-text-justified-touch{text-align:justify!important}}@media screen and (min-width:1024px){.has-text-justified-desktop{text-align:justify!important}}@media screen and (min-width:1024px) and (max-width:1215px){.has-text-justified-desktop-only{text-align:justify!important}}@media screen and (min-width:1216px){.has-text-justified-widescreen{text-align:justify!important}}@media screen and (min-width:1216px) and (max-width:1407px){.has-text-justified-widescreen-only{text-align:justify!important}}@media screen and (min-width:1408px){.has-text-justified-fullhd{text-align:justify!important}}@media screen and (max-width:768px){.has-text-left-mobile{text-align:left!important}}@media print,screen and (min-width:769px){.has-text-left-tablet{text-align:left!important}}@media screen and (min-width:769px) and (max-width:1023px){.has-text-left-tablet-only{text-align:left!important}}@media screen and (max-width:1023px){.has-text-left-touch{text-align:left!important}}@media screen and (min-width:1024px){.has-text-left-desktop{text-align:left!important}}@media screen and (min-width:1024px) and (max-width:1215px){.has-text-left-desktop-only{text-align:left!important}}@media screen and (min-width:1216px){.has-text-left-widescreen{text-align:left!important}}@media screen and (min-width:1216px) and (max-width:1407px){.has-text-left-widescreen-only{text-align:left!important}}@media screen and (min-width:1408px){.has-text-left-fullhd{text-align:left!important}}@media screen and (max-width:768px){.has-text-right-mobile{text-align:right!important}}@media print,screen and (min-width:769px){.has-text-right-tablet{text-align:right!important}}@media screen and (min-width:769px) and (max-width:1023px){.has-text-right-tablet-only{text-align:right!important}}@media screen and (max-width:1023px){.has-text-right-touch{text-align:right!important}}@media screen and (min-width:1024px){.has-text-right-desktop{text-align:right!important}}@media screen and (min-width:1024px) and (max-width:1215px){.has-text-right-desktop-only{text-align:right!important}}@media screen and (min-width:1216px){.has-text-right-widescreen{text-align:right!important}}@media screen and (min-width:1216px) and (max-width:1407px){.has-text-right-widescreen-only{text-align:right!important}}@media screen and (min-width:1408px){.has-text-right-fullhd{text-align:right!important}}.is-capitalized{text-transform:capitalize!important}.is-lowercase{text-transform:lowercase!important}.is-uppercase{text-transform:uppercase!important}.is-italic{font-style:italic!important}.has-text-white{color:#fff!important}a.has-text-white:focus,a.has-text-white:hover{color:#e6e6e6!important}.has-background-white{background-color:#fff!important}.has-text-black{color:#0a0a0a!important}a.has-text-black:focus,a.has-text-black:hover{color:#000!important}.has-background-black{background-color:#0a0a0a!important}.has-text-light{color:#f5f5f5!important}a.has-text-light:focus,a.has-text-light:hover{color:#dbdbdb!important}.has-background-light{background-color:#f5f5f5!important}.has-text-dark{color:#363636!important}a.has-text-dark:focus,a.has-text-dark:hover{color:#1c1c1c!important}.has-background-dark{background-color:#363636!important}.has-text-primary{color:#7957d5!important}a.has-text-primary:focus,a.has-text-primary:hover{color:#5a32c7!important}.has-background-primary{background-color:#7957d5!important}.has-text-link{color:#7957d5!important}a.has-text-link:focus,a.has-text-link:hover{color:#5a32c7!important}.has-background-link{background-color:#7957d5!important}.has-text-info{color:#167df0!important}a.has-text-info:focus,a.has-text-info:hover{color:#0d64c6!important}.has-background-info{background-color:#167df0!important}.has-text-success{color:#23d160!important}a.has-text-success:focus,a.has-text-success:hover{color:#1ca64c!important}.has-background-success{background-color:#23d160!important}.has-text-warning{color:#ffdd57!important}a.has-text-warning:focus,a.has-text-warning:hover{color:#ffd324!important}.has-background-warning{background-color:#ffdd57!important}.has-text-danger{color:#ff3860!important}a.has-text-danger:focus,a.has-text-danger:hover{color:#ff0537!important}.has-background-danger{background-color:#ff3860!important}.has-text-black-bis{color:#121212!important}.has-background-black-bis{background-color:#121212!important}.has-text-black-ter{color:#242424!important}.has-background-black-ter{background-color:#242424!important}.has-text-grey-darker{color:#363636!important}.has-background-grey-darker{background-color:#363636!important}.has-text-grey-dark{color:#4a4a4a!important}.has-background-grey-dark{background-color:#4a4a4a!important}.has-text-grey{color:#7a7a7a!important}.has-background-grey{background-color:#7a7a7a!important}.has-text-grey-light{color:#b5b5b5!important}.has-background-grey-light{background-color:#b5b5b5!important}.has-text-grey-lighter{color:#dbdbdb!important}.has-background-grey-lighter{background-color:#dbdbdb!important}.has-text-white-ter{color:#f5f5f5!important}.has-background-white-ter{background-color:#f5f5f5!important}.has-text-white-bis{color:#fafafa!important}.has-background-white-bis{background-color:#fafafa!important}.has-text-weight-light{font-weight:300!important}.has-text-weight-normal{font-weight:400!important}.has-text-weight-medium{font-weight:500!important}.has-text-weight-semibold{font-weight:600!important}.has-text-weight-bold{font-weight:700!important}.is-family-primary,.is-family-sans-serif,.is-family-secondary{font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif!important}.is-family-code,.is-family-monospace{font-family:monospace!important}.is-block{display:block!important}@media screen and (max-width:768px){.is-block-mobile{display:block!important}}@media print,screen and (min-width:769px){.is-block-tablet{display:block!important}}@media screen and (min-width:769px) and (max-width:1023px){.is-block-tablet-only{display:block!important}}@media screen and (max-width:1023px){.is-block-touch{display:block!important}}@media screen and (min-width:1024px){.is-block-desktop{display:block!important}}@media screen and (min-width:1024px) and (max-width:1215px){.is-block-desktop-only{display:block!important}}@media screen and (min-width:1216px){.is-block-widescreen{display:block!important}}@media screen and (min-width:1216px) and (max-width:1407px){.is-block-widescreen-only{display:block!important}}@media screen and (min-width:1408px){.is-block-fullhd{display:block!important}}.is-flex{display:flex!important}@media screen and (max-width:768px){.is-flex-mobile{display:flex!important}}@media print,screen and (min-width:769px){.is-flex-tablet{display:flex!important}}@media screen and (min-width:769px) and (max-width:1023px){.is-flex-tablet-only{display:flex!important}}@media screen and (max-width:1023px){.is-flex-touch{display:flex!important}}@media screen and (min-width:1024px){.is-flex-desktop{display:flex!important}}@media screen and (min-width:1024px) and (max-width:1215px){.is-flex-desktop-only{display:flex!important}}@media screen and (min-width:1216px){.is-flex-widescreen{display:flex!important}}@media screen and (min-width:1216px) and (max-width:1407px){.is-flex-widescreen-only{display:flex!important}}@media screen and (min-width:1408px){.is-flex-fullhd{display:flex!important}}.is-inline{display:inline!important}@media screen and (max-width:768px){.is-inline-mobile{display:inline!important}}@media print,screen and (min-width:769px){.is-inline-tablet{display:inline!important}}@media screen and (min-width:769px) and (max-width:1023px){.is-inline-tablet-only{display:inline!important}}@media screen and (max-width:1023px){.is-inline-touch{display:inline!important}}@media screen and (min-width:1024px){.is-inline-desktop{display:inline!important}}@media screen and (min-width:1024px) and (max-width:1215px){.is-inline-desktop-only{display:inline!important}}@media screen and (min-width:1216px){.is-inline-widescreen{display:inline!important}}@media screen and (min-width:1216px) and (max-width:1407px){.is-inline-widescreen-only{display:inline!important}}@media screen and (min-width:1408px){.is-inline-fullhd{display:inline!important}}.is-inline-block{display:inline-block!important}@media screen and (max-width:768px){.is-inline-block-mobile{display:inline-block!important}}@media print,screen and (min-width:769px){.is-inline-block-tablet{display:inline-block!important}}@media screen and (min-width:769px) and (max-width:1023px){.is-inline-block-tablet-only{display:inline-block!important}}@media screen and (max-width:1023px){.is-inline-block-touch{display:inline-block!important}}@media screen and (min-width:1024px){.is-inline-block-desktop{display:inline-block!important}}@media screen and (min-width:1024px) and (max-width:1215px){.is-inline-block-desktop-only{display:inline-block!important}}@media screen and (min-width:1216px){.is-inline-block-widescreen{display:inline-block!important}}@media screen and (min-width:1216px) and (max-width:1407px){.is-inline-block-widescreen-only{display:inline-block!important}}@media screen and (min-width:1408px){.is-inline-block-fullhd{display:inline-block!important}}.is-inline-flex{display:inline-flex!important}@media screen and (max-width:768px){.is-inline-flex-mobile{display:inline-flex!important}}@media print,screen and (min-width:769px){.is-inline-flex-tablet{display:inline-flex!important}}@media screen and (min-width:769px) and (max-width:1023px){.is-inline-flex-tablet-only{display:inline-flex!important}}@media screen and (max-width:1023px){.is-inline-flex-touch{display:inline-flex!important}}@media screen and (min-width:1024px){.is-inline-flex-desktop{display:inline-flex!important}}@media screen and (min-width:1024px) and (max-width:1215px){.is-inline-flex-desktop-only{display:inline-flex!important}}@media screen and (min-width:1216px){.is-inline-flex-widescreen{display:inline-flex!important}}@media screen and (min-width:1216px) and (max-width:1407px){.is-inline-flex-widescreen-only{display:inline-flex!important}}@media screen and (min-width:1408px){.is-inline-flex-fullhd{display:inline-flex!important}}.is-hidden{display:none!important}.is-sr-only{border:none!important;clip:rect(0,0,0,0)!important;height:.01em!important;overflow:hidden!important;padding:0!important;position:absolute!important;white-space:nowrap!important;width:.01em!important}@media screen and (max-width:768px){.is-hidden-mobile{display:none!important}}@media print,screen and (min-width:769px){.is-hidden-tablet{display:none!important}}@media screen and (min-width:769px) and (max-width:1023px){.is-hidden-tablet-only{display:none!important}}@media screen and (max-width:1023px){.is-hidden-touch{display:none!important}}@media screen and (min-width:1024px){.is-hidden-desktop{display:none!important}}@media screen and (min-width:1024px) and (max-width:1215px){.is-hidden-desktop-only{display:none!important}}@media screen and (min-width:1216px){.is-hidden-widescreen{display:none!important}}@media screen and (min-width:1216px) and (max-width:1407px){.is-hidden-widescreen-only{display:none!important}}@media screen and (min-width:1408px){.is-hidden-fullhd{display:none!important}}.is-invisible{visibility:hidden!important}@media screen and (max-width:768px){.is-invisible-mobile{visibility:hidden!important}}@media print,screen and (min-width:769px){.is-invisible-tablet{visibility:hidden!important}}@media screen and (min-width:769px) and (max-width:1023px){.is-invisible-tablet-only{visibility:hidden!important}}@media screen and (max-width:1023px){.is-invisible-touch{visibility:hidden!important}}@media screen and (min-width:1024px){.is-invisible-desktop{visibility:hidden!important}}@media screen and (min-width:1024px) and (max-width:1215px){.is-invisible-desktop-only{visibility:hidden!important}}@media screen and (min-width:1216px){.is-invisible-widescreen{visibility:hidden!important}}@media screen and (min-width:1216px) and (max-width:1407px){.is-invisible-widescreen-only{visibility:hidden!important}}@media screen and (min-width:1408px){.is-invisible-fullhd{visibility:hidden!important}}.is-marginless{margin:0!important}.is-paddingless{padding:0!important}.is-radiusless{border-radius:0!important}.is-shadowless{box-shadow:none!important}.is-relative{position:relative!important}.box{background-color:#fff;border-radius:6px;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);color:#4a4a4a;display:block;padding:1.25rem}a.box:focus,a.box:hover{box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px #7957d5}a.box:active{box-shadow:inset 0 1px 2px hsla(0,0%,4%,.2),0 0 0 1px #7957d5}.button{background-color:#fff;border-color:#dbdbdb;border-width:1px;color:#363636;cursor:pointer;justify-content:center;padding:calc(.375em - 1px) .75em;text-align:center;white-space:nowrap}.button strong{color:inherit}.button .icon,.button .icon.is-large,.button .icon.is-medium,.button .icon.is-small{height:1.5em;width:1.5em}.button .icon:first-child:not(:last-child){margin-left:calc(-.375em - 1px);margin-right:.1875em}.button .icon:last-child:not(:first-child){margin-left:.1875em;margin-right:calc(-.375em - 1px)}.button .icon:first-child:last-child{margin-left:calc(-.375em - 1px);margin-right:calc(-.375em - 1px)}.button.is-hovered,.button:hover{border-color:#b5b5b5;color:#363636}.button.is-focused,.button:focus{border-color:#7957d5;color:#363636}.button.is-focused:not(:active),.button:focus:not(:active){box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.button.is-active,.button:active{border-color:#4a4a4a;color:#363636}.button.is-text{background-color:transparent;border-color:transparent;color:#4a4a4a;text-decoration:underline}.button.is-text.is-focused,.button.is-text.is-hovered,.button.is-text:focus,.button.is-text:hover{background-color:#f5f5f5;color:#363636}.button.is-text.is-active,.button.is-text:active{background-color:#e8e8e8;color:#363636}.button.is-text[disabled],fieldset[disabled] .button.is-text{background-color:transparent;border-color:transparent;box-shadow:none}.button.is-white{background-color:#fff;border-color:transparent;color:#0a0a0a}.button.is-white.is-hovered,.button.is-white:hover{background-color:#f9f9f9;border-color:transparent;color:#0a0a0a}.button.is-white.is-focused,.button.is-white:focus{border-color:transparent;color:#0a0a0a}.button.is-white.is-focused:not(:active),.button.is-white:focus:not(:active){box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.button.is-white.is-active,.button.is-white:active{background-color:#f2f2f2;border-color:transparent;color:#0a0a0a}.button.is-white[disabled],fieldset[disabled] .button.is-white{background-color:#fff;border-color:transparent;box-shadow:none}.button.is-white.is-inverted{background-color:#0a0a0a;color:#fff}.button.is-white.is-inverted.is-hovered,.button.is-white.is-inverted:hover{background-color:#000}.button.is-white.is-inverted[disabled],fieldset[disabled] .button.is-white.is-inverted{background-color:#0a0a0a;border-color:transparent;box-shadow:none;color:#fff}.button.is-white.is-loading:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.button.is-white.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-white.is-outlined.is-focused,.button.is-white.is-outlined.is-hovered,.button.is-white.is-outlined:focus,.button.is-white.is-outlined:hover{background-color:#fff;border-color:#fff;color:#0a0a0a}.button.is-white.is-outlined.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-white.is-outlined.is-loading.is-focused:after,.button.is-white.is-outlined.is-loading.is-hovered:after,.button.is-white.is-outlined.is-loading:focus:after,.button.is-white.is-outlined.is-loading:hover:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.button.is-white.is-outlined[disabled],fieldset[disabled] .button.is-white.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-white.is-inverted.is-outlined{background-color:transparent;border-color:#0a0a0a;color:#0a0a0a}.button.is-white.is-inverted.is-outlined.is-focused,.button.is-white.is-inverted.is-outlined.is-hovered,.button.is-white.is-inverted.is-outlined:focus,.button.is-white.is-inverted.is-outlined:hover{background-color:#0a0a0a;color:#fff}.button.is-white.is-inverted.is-outlined.is-loading.is-focused:after,.button.is-white.is-inverted.is-outlined.is-loading.is-hovered:after,.button.is-white.is-inverted.is-outlined.is-loading:focus:after,.button.is-white.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.button.is-white.is-inverted.is-outlined[disabled],fieldset[disabled] .button.is-white.is-inverted.is-outlined{background-color:transparent;border-color:#0a0a0a;box-shadow:none;color:#0a0a0a}.button.is-black{background-color:#0a0a0a;border-color:transparent;color:#fff}.button.is-black.is-hovered,.button.is-black:hover{background-color:#040404;border-color:transparent;color:#fff}.button.is-black.is-focused,.button.is-black:focus{border-color:transparent;color:#fff}.button.is-black.is-focused:not(:active),.button.is-black:focus:not(:active){box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.button.is-black.is-active,.button.is-black:active{background-color:#000;border-color:transparent;color:#fff}.button.is-black[disabled],fieldset[disabled] .button.is-black{background-color:#0a0a0a;border-color:transparent;box-shadow:none}.button.is-black.is-inverted{background-color:#fff;color:#0a0a0a}.button.is-black.is-inverted.is-hovered,.button.is-black.is-inverted:hover{background-color:#f2f2f2}.button.is-black.is-inverted[disabled],fieldset[disabled] .button.is-black.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#0a0a0a}.button.is-black.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-black.is-outlined{background-color:transparent;border-color:#0a0a0a;color:#0a0a0a}.button.is-black.is-outlined.is-focused,.button.is-black.is-outlined.is-hovered,.button.is-black.is-outlined:focus,.button.is-black.is-outlined:hover{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.button.is-black.is-outlined.is-loading:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.button.is-black.is-outlined.is-loading.is-focused:after,.button.is-black.is-outlined.is-loading.is-hovered:after,.button.is-black.is-outlined.is-loading:focus:after,.button.is-black.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.button.is-black.is-outlined[disabled],fieldset[disabled] .button.is-black.is-outlined{background-color:transparent;border-color:#0a0a0a;box-shadow:none;color:#0a0a0a}.button.is-black.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-black.is-inverted.is-outlined.is-focused,.button.is-black.is-inverted.is-outlined.is-hovered,.button.is-black.is-inverted.is-outlined:focus,.button.is-black.is-inverted.is-outlined:hover{background-color:#fff;color:#0a0a0a}.button.is-black.is-inverted.is-outlined.is-loading.is-focused:after,.button.is-black.is-inverted.is-outlined.is-loading.is-hovered:after,.button.is-black.is-inverted.is-outlined.is-loading:focus:after,.button.is-black.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.button.is-black.is-inverted.is-outlined[disabled],fieldset[disabled] .button.is-black.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-light{background-color:#f5f5f5;border-color:transparent;color:#363636}.button.is-light.is-hovered,.button.is-light:hover{background-color:#eee;border-color:transparent;color:#363636}.button.is-light.is-focused,.button.is-light:focus{border-color:transparent;color:#363636}.button.is-light.is-focused:not(:active),.button.is-light:focus:not(:active){box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.button.is-light.is-active,.button.is-light:active{background-color:#e8e8e8;border-color:transparent;color:#363636}.button.is-light[disabled],fieldset[disabled] .button.is-light{background-color:#f5f5f5;border-color:transparent;box-shadow:none}.button.is-light.is-inverted{background-color:#363636;color:#f5f5f5}.button.is-light.is-inverted.is-hovered,.button.is-light.is-inverted:hover{background-color:#292929}.button.is-light.is-inverted[disabled],fieldset[disabled] .button.is-light.is-inverted{background-color:#363636;border-color:transparent;box-shadow:none;color:#f5f5f5}.button.is-light.is-loading:after{border-color:transparent transparent #363636 #363636!important}.button.is-light.is-outlined{background-color:transparent;border-color:#f5f5f5;color:#f5f5f5}.button.is-light.is-outlined.is-focused,.button.is-light.is-outlined.is-hovered,.button.is-light.is-outlined:focus,.button.is-light.is-outlined:hover{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.button.is-light.is-outlined.is-loading:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.button.is-light.is-outlined.is-loading.is-focused:after,.button.is-light.is-outlined.is-loading.is-hovered:after,.button.is-light.is-outlined.is-loading:focus:after,.button.is-light.is-outlined.is-loading:hover:after{border-color:transparent transparent #363636 #363636!important}.button.is-light.is-outlined[disabled],fieldset[disabled] .button.is-light.is-outlined{background-color:transparent;border-color:#f5f5f5;box-shadow:none;color:#f5f5f5}.button.is-light.is-inverted.is-outlined{background-color:transparent;border-color:#363636;color:#363636}.button.is-light.is-inverted.is-outlined.is-focused,.button.is-light.is-inverted.is-outlined.is-hovered,.button.is-light.is-inverted.is-outlined:focus,.button.is-light.is-inverted.is-outlined:hover{background-color:#363636;color:#f5f5f5}.button.is-light.is-inverted.is-outlined.is-loading.is-focused:after,.button.is-light.is-inverted.is-outlined.is-loading.is-hovered:after,.button.is-light.is-inverted.is-outlined.is-loading:focus:after,.button.is-light.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.button.is-light.is-inverted.is-outlined[disabled],fieldset[disabled] .button.is-light.is-inverted.is-outlined{background-color:transparent;border-color:#363636;box-shadow:none;color:#363636}.button.is-dark{background-color:#363636;border-color:transparent;color:#f5f5f5}.button.is-dark.is-hovered,.button.is-dark:hover{background-color:#2f2f2f;border-color:transparent;color:#f5f5f5}.button.is-dark.is-focused,.button.is-dark:focus{border-color:transparent;color:#f5f5f5}.button.is-dark.is-focused:not(:active),.button.is-dark:focus:not(:active){box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.button.is-dark.is-active,.button.is-dark:active{background-color:#292929;border-color:transparent;color:#f5f5f5}.button.is-dark[disabled],fieldset[disabled] .button.is-dark{background-color:#363636;border-color:transparent;box-shadow:none}.button.is-dark.is-inverted{background-color:#f5f5f5;color:#363636}.button.is-dark.is-inverted.is-hovered,.button.is-dark.is-inverted:hover{background-color:#e8e8e8}.button.is-dark.is-inverted[disabled],fieldset[disabled] .button.is-dark.is-inverted{background-color:#f5f5f5;border-color:transparent;box-shadow:none;color:#363636}.button.is-dark.is-loading:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.button.is-dark.is-outlined{background-color:transparent;border-color:#363636;color:#363636}.button.is-dark.is-outlined.is-focused,.button.is-dark.is-outlined.is-hovered,.button.is-dark.is-outlined:focus,.button.is-dark.is-outlined:hover{background-color:#363636;border-color:#363636;color:#f5f5f5}.button.is-dark.is-outlined.is-loading:after{border-color:transparent transparent #363636 #363636!important}.button.is-dark.is-outlined.is-loading.is-focused:after,.button.is-dark.is-outlined.is-loading.is-hovered:after,.button.is-dark.is-outlined.is-loading:focus:after,.button.is-dark.is-outlined.is-loading:hover:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.button.is-dark.is-outlined[disabled],fieldset[disabled] .button.is-dark.is-outlined{background-color:transparent;border-color:#363636;box-shadow:none;color:#363636}.button.is-dark.is-inverted.is-outlined{background-color:transparent;border-color:#f5f5f5;color:#f5f5f5}.button.is-dark.is-inverted.is-outlined.is-focused,.button.is-dark.is-inverted.is-outlined.is-hovered,.button.is-dark.is-inverted.is-outlined:focus,.button.is-dark.is-inverted.is-outlined:hover{background-color:#f5f5f5;color:#363636}.button.is-dark.is-inverted.is-outlined.is-loading.is-focused:after,.button.is-dark.is-inverted.is-outlined.is-loading.is-hovered:after,.button.is-dark.is-inverted.is-outlined.is-loading:focus:after,.button.is-dark.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #363636 #363636!important}.button.is-dark.is-inverted.is-outlined[disabled],fieldset[disabled] .button.is-dark.is-inverted.is-outlined{background-color:transparent;border-color:#f5f5f5;box-shadow:none;color:#f5f5f5}.button.is-primary{background-color:#7957d5;border-color:transparent;color:#fff}.button.is-primary.is-hovered,.button.is-primary:hover{background-color:#714dd2;border-color:transparent;color:#fff}.button.is-primary.is-focused,.button.is-primary:focus{border-color:transparent;color:#fff}.button.is-primary.is-focused:not(:active),.button.is-primary:focus:not(:active){box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.button.is-primary.is-active,.button.is-primary:active{background-color:#6943d0;border-color:transparent;color:#fff}.button.is-primary[disabled],fieldset[disabled] .button.is-primary{background-color:#7957d5;border-color:transparent;box-shadow:none}.button.is-primary.is-inverted{background-color:#fff;color:#7957d5}.button.is-primary.is-inverted.is-hovered,.button.is-primary.is-inverted:hover{background-color:#f2f2f2}.button.is-primary.is-inverted[disabled],fieldset[disabled] .button.is-primary.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#7957d5}.button.is-primary.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-primary.is-outlined{background-color:transparent;border-color:#7957d5;color:#7957d5}.button.is-primary.is-outlined.is-focused,.button.is-primary.is-outlined.is-hovered,.button.is-primary.is-outlined:focus,.button.is-primary.is-outlined:hover{background-color:#7957d5;border-color:#7957d5;color:#fff}.button.is-primary.is-outlined.is-loading:after{border-color:transparent transparent #7957d5 #7957d5!important}.button.is-primary.is-outlined.is-loading.is-focused:after,.button.is-primary.is-outlined.is-loading.is-hovered:after,.button.is-primary.is-outlined.is-loading:focus:after,.button.is-primary.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.button.is-primary.is-outlined[disabled],fieldset[disabled] .button.is-primary.is-outlined{background-color:transparent;border-color:#7957d5;box-shadow:none;color:#7957d5}.button.is-primary.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-primary.is-inverted.is-outlined.is-focused,.button.is-primary.is-inverted.is-outlined.is-hovered,.button.is-primary.is-inverted.is-outlined:focus,.button.is-primary.is-inverted.is-outlined:hover{background-color:#fff;color:#7957d5}.button.is-primary.is-inverted.is-outlined.is-loading.is-focused:after,.button.is-primary.is-inverted.is-outlined.is-loading.is-hovered:after,.button.is-primary.is-inverted.is-outlined.is-loading:focus:after,.button.is-primary.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #7957d5 #7957d5!important}.button.is-primary.is-inverted.is-outlined[disabled],fieldset[disabled] .button.is-primary.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-link{background-color:#7957d5;border-color:transparent;color:#fff}.button.is-link.is-hovered,.button.is-link:hover{background-color:#714dd2;border-color:transparent;color:#fff}.button.is-link.is-focused,.button.is-link:focus{border-color:transparent;color:#fff}.button.is-link.is-focused:not(:active),.button.is-link:focus:not(:active){box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.button.is-link.is-active,.button.is-link:active{background-color:#6943d0;border-color:transparent;color:#fff}.button.is-link[disabled],fieldset[disabled] .button.is-link{background-color:#7957d5;border-color:transparent;box-shadow:none}.button.is-link.is-inverted{background-color:#fff;color:#7957d5}.button.is-link.is-inverted.is-hovered,.button.is-link.is-inverted:hover{background-color:#f2f2f2}.button.is-link.is-inverted[disabled],fieldset[disabled] .button.is-link.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#7957d5}.button.is-link.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-link.is-outlined{background-color:transparent;border-color:#7957d5;color:#7957d5}.button.is-link.is-outlined.is-focused,.button.is-link.is-outlined.is-hovered,.button.is-link.is-outlined:focus,.button.is-link.is-outlined:hover{background-color:#7957d5;border-color:#7957d5;color:#fff}.button.is-link.is-outlined.is-loading:after{border-color:transparent transparent #7957d5 #7957d5!important}.button.is-link.is-outlined.is-loading.is-focused:after,.button.is-link.is-outlined.is-loading.is-hovered:after,.button.is-link.is-outlined.is-loading:focus:after,.button.is-link.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.button.is-link.is-outlined[disabled],fieldset[disabled] .button.is-link.is-outlined{background-color:transparent;border-color:#7957d5;box-shadow:none;color:#7957d5}.button.is-link.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-link.is-inverted.is-outlined.is-focused,.button.is-link.is-inverted.is-outlined.is-hovered,.button.is-link.is-inverted.is-outlined:focus,.button.is-link.is-inverted.is-outlined:hover{background-color:#fff;color:#7957d5}.button.is-link.is-inverted.is-outlined.is-loading.is-focused:after,.button.is-link.is-inverted.is-outlined.is-loading.is-hovered:after,.button.is-link.is-inverted.is-outlined.is-loading:focus:after,.button.is-link.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #7957d5 #7957d5!important}.button.is-link.is-inverted.is-outlined[disabled],fieldset[disabled] .button.is-link.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-info{background-color:#167df0;border-color:transparent;color:#fff}.button.is-info.is-hovered,.button.is-info:hover{background-color:#0f77ea;border-color:transparent;color:#fff}.button.is-info.is-focused,.button.is-info:focus{border-color:transparent;color:#fff}.button.is-info.is-focused:not(:active),.button.is-info:focus:not(:active){box-shadow:0 0 0 .125em rgba(22,125,240,.25)}.button.is-info.is-active,.button.is-info:active{background-color:#0e71de;border-color:transparent;color:#fff}.button.is-info[disabled],fieldset[disabled] .button.is-info{background-color:#167df0;border-color:transparent;box-shadow:none}.button.is-info.is-inverted{background-color:#fff;color:#167df0}.button.is-info.is-inverted.is-hovered,.button.is-info.is-inverted:hover{background-color:#f2f2f2}.button.is-info.is-inverted[disabled],fieldset[disabled] .button.is-info.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#167df0}.button.is-info.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-info.is-outlined{background-color:transparent;border-color:#167df0;color:#167df0}.button.is-info.is-outlined.is-focused,.button.is-info.is-outlined.is-hovered,.button.is-info.is-outlined:focus,.button.is-info.is-outlined:hover{background-color:#167df0;border-color:#167df0;color:#fff}.button.is-info.is-outlined.is-loading:after{border-color:transparent transparent #167df0 #167df0!important}.button.is-info.is-outlined.is-loading.is-focused:after,.button.is-info.is-outlined.is-loading.is-hovered:after,.button.is-info.is-outlined.is-loading:focus:after,.button.is-info.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.button.is-info.is-outlined[disabled],fieldset[disabled] .button.is-info.is-outlined{background-color:transparent;border-color:#167df0;box-shadow:none;color:#167df0}.button.is-info.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-info.is-inverted.is-outlined.is-focused,.button.is-info.is-inverted.is-outlined.is-hovered,.button.is-info.is-inverted.is-outlined:focus,.button.is-info.is-inverted.is-outlined:hover{background-color:#fff;color:#167df0}.button.is-info.is-inverted.is-outlined.is-loading.is-focused:after,.button.is-info.is-inverted.is-outlined.is-loading.is-hovered:after,.button.is-info.is-inverted.is-outlined.is-loading:focus:after,.button.is-info.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #167df0 #167df0!important}.button.is-info.is-inverted.is-outlined[disabled],fieldset[disabled] .button.is-info.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-success{background-color:#23d160;border-color:transparent;color:#fff}.button.is-success.is-hovered,.button.is-success:hover{background-color:#22c65b;border-color:transparent;color:#fff}.button.is-success.is-focused,.button.is-success:focus{border-color:transparent;color:#fff}.button.is-success.is-focused:not(:active),.button.is-success:focus:not(:active){box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.button.is-success.is-active,.button.is-success:active{background-color:#20bc56;border-color:transparent;color:#fff}.button.is-success[disabled],fieldset[disabled] .button.is-success{background-color:#23d160;border-color:transparent;box-shadow:none}.button.is-success.is-inverted{background-color:#fff;color:#23d160}.button.is-success.is-inverted.is-hovered,.button.is-success.is-inverted:hover{background-color:#f2f2f2}.button.is-success.is-inverted[disabled],fieldset[disabled] .button.is-success.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#23d160}.button.is-success.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-success.is-outlined{background-color:transparent;border-color:#23d160;color:#23d160}.button.is-success.is-outlined.is-focused,.button.is-success.is-outlined.is-hovered,.button.is-success.is-outlined:focus,.button.is-success.is-outlined:hover{background-color:#23d160;border-color:#23d160;color:#fff}.button.is-success.is-outlined.is-loading:after{border-color:transparent transparent #23d160 #23d160!important}.button.is-success.is-outlined.is-loading.is-focused:after,.button.is-success.is-outlined.is-loading.is-hovered:after,.button.is-success.is-outlined.is-loading:focus:after,.button.is-success.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.button.is-success.is-outlined[disabled],fieldset[disabled] .button.is-success.is-outlined{background-color:transparent;border-color:#23d160;box-shadow:none;color:#23d160}.button.is-success.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-success.is-inverted.is-outlined.is-focused,.button.is-success.is-inverted.is-outlined.is-hovered,.button.is-success.is-inverted.is-outlined:focus,.button.is-success.is-inverted.is-outlined:hover{background-color:#fff;color:#23d160}.button.is-success.is-inverted.is-outlined.is-loading.is-focused:after,.button.is-success.is-inverted.is-outlined.is-loading.is-hovered:after,.button.is-success.is-inverted.is-outlined.is-loading:focus:after,.button.is-success.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #23d160 #23d160!important}.button.is-success.is-inverted.is-outlined[disabled],fieldset[disabled] .button.is-success.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-warning{background-color:#ffdd57;border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning.is-hovered,.button.is-warning:hover{background-color:#ffdb4a;border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning.is-focused,.button.is-warning:focus{border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning.is-focused:not(:active),.button.is-warning:focus:not(:active){box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.button.is-warning.is-active,.button.is-warning:active{background-color:#ffd83d;border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning[disabled],fieldset[disabled] .button.is-warning{background-color:#ffdd57;border-color:transparent;box-shadow:none}.button.is-warning.is-inverted{color:#ffdd57}.button.is-warning.is-inverted,.button.is-warning.is-inverted.is-hovered,.button.is-warning.is-inverted:hover{background-color:rgba(0,0,0,.7)}.button.is-warning.is-inverted[disabled],fieldset[disabled] .button.is-warning.is-inverted{background-color:rgba(0,0,0,.7);border-color:transparent;box-shadow:none;color:#ffdd57}.button.is-warning.is-loading:after{border-color:transparent transparent rgba(0,0,0,.7) rgba(0,0,0,.7)!important}.button.is-warning.is-outlined{background-color:transparent;border-color:#ffdd57;color:#ffdd57}.button.is-warning.is-outlined.is-focused,.button.is-warning.is-outlined.is-hovered,.button.is-warning.is-outlined:focus,.button.is-warning.is-outlined:hover{background-color:#ffdd57;border-color:#ffdd57;color:rgba(0,0,0,.7)}.button.is-warning.is-outlined.is-loading:after{border-color:transparent transparent #ffdd57 #ffdd57!important}.button.is-warning.is-outlined.is-loading.is-focused:after,.button.is-warning.is-outlined.is-loading.is-hovered:after,.button.is-warning.is-outlined.is-loading:focus:after,.button.is-warning.is-outlined.is-loading:hover:after{border-color:transparent transparent rgba(0,0,0,.7) rgba(0,0,0,.7)!important}.button.is-warning.is-outlined[disabled],fieldset[disabled] .button.is-warning.is-outlined{background-color:transparent;border-color:#ffdd57;box-shadow:none;color:#ffdd57}.button.is-warning.is-inverted.is-outlined{background-color:transparent;border-color:rgba(0,0,0,.7);color:rgba(0,0,0,.7)}.button.is-warning.is-inverted.is-outlined.is-focused,.button.is-warning.is-inverted.is-outlined.is-hovered,.button.is-warning.is-inverted.is-outlined:focus,.button.is-warning.is-inverted.is-outlined:hover{background-color:rgba(0,0,0,.7);color:#ffdd57}.button.is-warning.is-inverted.is-outlined.is-loading.is-focused:after,.button.is-warning.is-inverted.is-outlined.is-loading.is-hovered:after,.button.is-warning.is-inverted.is-outlined.is-loading:focus:after,.button.is-warning.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #ffdd57 #ffdd57!important}.button.is-warning.is-inverted.is-outlined[disabled],fieldset[disabled] .button.is-warning.is-inverted.is-outlined{background-color:transparent;border-color:rgba(0,0,0,.7);box-shadow:none;color:rgba(0,0,0,.7)}.button.is-danger{background-color:#ff3860;border-color:transparent;color:#fff}.button.is-danger.is-hovered,.button.is-danger:hover{background-color:#ff2b56;border-color:transparent;color:#fff}.button.is-danger.is-focused,.button.is-danger:focus{border-color:transparent;color:#fff}.button.is-danger.is-focused:not(:active),.button.is-danger:focus:not(:active){box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.button.is-danger.is-active,.button.is-danger:active{background-color:#ff1f4b;border-color:transparent;color:#fff}.button.is-danger[disabled],fieldset[disabled] .button.is-danger{background-color:#ff3860;border-color:transparent;box-shadow:none}.button.is-danger.is-inverted{background-color:#fff;color:#ff3860}.button.is-danger.is-inverted.is-hovered,.button.is-danger.is-inverted:hover{background-color:#f2f2f2}.button.is-danger.is-inverted[disabled],fieldset[disabled] .button.is-danger.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#ff3860}.button.is-danger.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-danger.is-outlined{background-color:transparent;border-color:#ff3860;color:#ff3860}.button.is-danger.is-outlined.is-focused,.button.is-danger.is-outlined.is-hovered,.button.is-danger.is-outlined:focus,.button.is-danger.is-outlined:hover{background-color:#ff3860;border-color:#ff3860;color:#fff}.button.is-danger.is-outlined.is-loading:after{border-color:transparent transparent #ff3860 #ff3860!important}.button.is-danger.is-outlined.is-loading.is-focused:after,.button.is-danger.is-outlined.is-loading.is-hovered:after,.button.is-danger.is-outlined.is-loading:focus:after,.button.is-danger.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.button.is-danger.is-outlined[disabled],fieldset[disabled] .button.is-danger.is-outlined{background-color:transparent;border-color:#ff3860;box-shadow:none;color:#ff3860}.button.is-danger.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-danger.is-inverted.is-outlined.is-focused,.button.is-danger.is-inverted.is-outlined.is-hovered,.button.is-danger.is-inverted.is-outlined:focus,.button.is-danger.is-inverted.is-outlined:hover{background-color:#fff;color:#ff3860}.button.is-danger.is-inverted.is-outlined.is-loading.is-focused:after,.button.is-danger.is-inverted.is-outlined.is-loading.is-hovered:after,.button.is-danger.is-inverted.is-outlined.is-loading:focus:after,.button.is-danger.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #ff3860 #ff3860!important}.button.is-danger.is-inverted.is-outlined[disabled],fieldset[disabled] .button.is-danger.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-small{border-radius:2px;font-size:.75rem}.button.is-normal{font-size:1rem}.button.is-medium{font-size:1.25rem}.button.is-large{font-size:1.5rem}.button[disabled],fieldset[disabled] .button{background-color:#fff;border-color:#dbdbdb;box-shadow:none;opacity:.5}.button.is-fullwidth{display:flex;width:100%}.button.is-loading{color:transparent!important;pointer-events:none}.button.is-loading:after{position:absolute;left:calc(50% - 0.5em);top:calc(50% - 0.5em);position:absolute!important}.button.is-static{background-color:#f5f5f5;border-color:#dbdbdb;color:#7a7a7a;box-shadow:none;pointer-events:none}.button.is-rounded{border-radius:290486px;padding-left:1em;padding-right:1em}.buttons{align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start}.buttons .button{margin-bottom:.5rem}.buttons .button:not(:last-child):not(.is-fullwidth){margin-right:.5rem}.buttons:last-child{margin-bottom:-.5rem}.buttons:not(:last-child){margin-bottom:1rem}.buttons.are-small .button:not(.is-normal):not(.is-medium):not(.is-large){border-radius:2px;font-size:.75rem}.buttons.are-medium .button:not(.is-small):not(.is-normal):not(.is-large){font-size:1.25rem}.buttons.are-large .button:not(.is-small):not(.is-normal):not(.is-medium){font-size:1.5rem}.buttons.has-addons .button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.buttons.has-addons .button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.buttons.has-addons .button:last-child{margin-right:0}.buttons.has-addons .button.is-hovered,.buttons.has-addons .button:hover{z-index:2}.buttons.has-addons .button.is-active,.buttons.has-addons .button.is-focused,.buttons.has-addons .button.is-selected,.buttons.has-addons .button:active,.buttons.has-addons .button:focus{z-index:3}.buttons.has-addons .button.is-active:hover,.buttons.has-addons .button.is-focused:hover,.buttons.has-addons .button.is-selected:hover,.buttons.has-addons .button:active:hover,.buttons.has-addons .button:focus:hover{z-index:4}.buttons.has-addons .button.is-expanded{flex-grow:1;flex-shrink:1}.buttons.is-centered{justify-content:center}.buttons.is-centered:not(.has-addons) .button:not(.is-fullwidth){margin-left:.25rem;margin-right:.25rem}.buttons.is-right{justify-content:flex-end}.buttons.is-right:not(.has-addons) .button:not(.is-fullwidth){margin-left:.25rem;margin-right:.25rem}.container{flex-grow:1;margin:0 auto;position:relative;width:auto}@media screen and (min-width:1024px){.container{max-width:960px}.container.is-fluid{margin-left:32px;margin-right:32px;max-width:none}}@media screen and (max-width:1215px){.container.is-widescreen{max-width:1152px}}@media screen and (max-width:1407px){.container.is-fullhd{max-width:1344px}}@media screen and (min-width:1216px){.container{max-width:1152px}}@media screen and (min-width:1408px){.container{max-width:1344px}}.content li+li{margin-top:.25em}.content blockquote:not(:last-child),.content dl:not(:last-child),.content ol:not(:last-child),.content p:not(:last-child),.content pre:not(:last-child),.content table:not(:last-child),.content ul:not(:last-child){margin-bottom:1em}.content h1,.content h2,.content h3,.content h4,.content h5,.content h6{color:#363636;font-weight:600;line-height:1.125}.content h1{font-size:2em;margin-bottom:.5em}.content h1:not(:first-child){margin-top:1em}.content h2{font-size:1.75em;margin-bottom:.5714em}.content h2:not(:first-child){margin-top:1.1428em}.content h3{font-size:1.5em;margin-bottom:.6666em}.content h3:not(:first-child){margin-top:1.3333em}.content h4{font-size:1.25em;margin-bottom:.8em}.content h5{font-size:1.125em;margin-bottom:.8888em}.content h6{font-size:1em;margin-bottom:1em}.content blockquote{background-color:#f5f5f5;border-left:5px solid #dbdbdb;padding:1.25em 1.5em}.content ol{list-style-position:outside;margin-left:2em;margin-top:1em}.content ol:not([type]){list-style-type:decimal}.content ol:not([type]).is-lower-alpha{list-style-type:lower-alpha}.content ol:not([type]).is-lower-roman{list-style-type:lower-roman}.content ol:not([type]).is-upper-alpha{list-style-type:upper-alpha}.content ol:not([type]).is-upper-roman{list-style-type:upper-roman}.content ul{list-style:disc outside;margin-left:2em;margin-top:1em}.content ul ul{list-style-type:circle;margin-top:.5em}.content ul ul ul{list-style-type:square}.content dd{margin-left:2em}.content figure{margin-left:2em;margin-right:2em;text-align:center}.content figure:not(:first-child){margin-top:2em}.content figure:not(:last-child){margin-bottom:2em}.content figure img{display:inline-block}.content figure figcaption{font-style:italic}.content pre{-webkit-overflow-scrolling:touch;overflow-x:auto;padding:1.25em 1.5em;white-space:pre;word-wrap:normal}.content sub,.content sup{font-size:75%}.content table{width:100%}.content table td,.content table th{border:1px solid #dbdbdb;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.content table th{color:#363636}.content table th:not([align]){text-align:left}.content table thead td,.content table thead th{border-width:0 0 2px;color:#363636}.content table tfoot td,.content table tfoot th{border-width:2px 0 0;color:#363636}.content table tbody tr:last-child td,.content table tbody tr:last-child th{border-bottom-width:0}.content .tabs li+li{margin-top:0}.content.is-small{font-size:.75rem}.content.is-medium{font-size:1.25rem}.content.is-large{font-size:1.5rem}.icon{align-items:center;display:inline-flex;justify-content:center;height:1.5rem;width:1.5rem}.icon.is-small{height:1rem;width:1rem}.icon.is-medium{height:2rem;width:2rem}.icon.is-large{height:3rem;width:3rem}.image{display:block;position:relative}.image img{display:block;height:auto;width:100%}.image img.is-rounded{border-radius:290486px}.image.is-1by1 .has-ratio,.image.is-1by1 img,.image.is-1by2 .has-ratio,.image.is-1by2 img,.image.is-1by3 .has-ratio,.image.is-1by3 img,.image.is-2by1 .has-ratio,.image.is-2by1 img,.image.is-2by3 .has-ratio,.image.is-2by3 img,.image.is-3by1 .has-ratio,.image.is-3by1 img,.image.is-3by2 .has-ratio,.image.is-3by2 img,.image.is-3by4 .has-ratio,.image.is-3by4 img,.image.is-3by5 .has-ratio,.image.is-3by5 img,.image.is-4by3 .has-ratio,.image.is-4by3 img,.image.is-4by5 .has-ratio,.image.is-4by5 img,.image.is-5by3 .has-ratio,.image.is-5by3 img,.image.is-5by4 .has-ratio,.image.is-5by4 img,.image.is-9by16 .has-ratio,.image.is-9by16 img,.image.is-16by9 .has-ratio,.image.is-16by9 img,.image.is-square .has-ratio,.image.is-square img{height:100%;width:100%}.image.is-1by1,.image.is-square{padding-top:100%}.image.is-5by4{padding-top:80%}.image.is-4by3{padding-top:75%}.image.is-3by2{padding-top:66.6666%}.image.is-5by3{padding-top:60%}.image.is-16by9{padding-top:56.25%}.image.is-2by1{padding-top:50%}.image.is-3by1{padding-top:33.3333%}.image.is-4by5{padding-top:125%}.image.is-3by4{padding-top:133.3333%}.image.is-2by3{padding-top:150%}.image.is-3by5{padding-top:166.6666%}.image.is-9by16{padding-top:177.7777%}.image.is-1by2{padding-top:200%}.image.is-1by3{padding-top:300%}.image.is-16x16{height:16px;width:16px}.image.is-24x24{height:24px;width:24px}.image.is-32x32{height:32px;width:32px}.image.is-48x48{height:48px;width:48px}.image.is-64x64{height:64px;width:64px}.image.is-96x96{height:96px;width:96px}.image.is-128x128{height:128px;width:128px}.notification{background-color:#f5f5f5;border-radius:4px;padding:1.25rem 2.5rem 1.25rem 1.5rem;position:relative}.notification a:not(.button):not(.dropdown-item){color:currentColor;text-decoration:underline}.notification strong{color:currentColor}.notification code,.notification pre{background:#fff}.notification pre code{background:transparent}.notification>.delete{position:absolute;right:.5rem;top:.5rem}.notification .content,.notification .subtitle,.notification .title{color:currentColor}.notification.is-white{background-color:#fff;color:#0a0a0a}.notification.is-black{background-color:#0a0a0a;color:#fff}.notification.is-light{background-color:#f5f5f5;color:#363636}.notification.is-dark{background-color:#363636;color:#f5f5f5}.notification.is-link,.notification.is-primary{background-color:#7957d5;color:#fff}.notification.is-info{background-color:#167df0;color:#fff}.notification.is-success{background-color:#23d160;color:#fff}.notification.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.notification.is-danger{background-color:#ff3860;color:#fff}.progress{-moz-appearance:none;-webkit-appearance:none;border:none;border-radius:290486px;display:block;height:1rem;overflow:hidden;padding:0;width:100%}.progress::-webkit-progress-bar{background-color:#dbdbdb}.progress::-webkit-progress-value{background-color:#4a4a4a}.progress::-moz-progress-bar{background-color:#4a4a4a}.progress::-ms-fill{background-color:#4a4a4a;border:none}.progress.is-white::-webkit-progress-value{background-color:#fff}.progress.is-white::-moz-progress-bar{background-color:#fff}.progress.is-white::-ms-fill{background-color:#fff}.progress.is-white:indeterminate{background-image:linear-gradient(90deg,#fff 30%,#dbdbdb 0)}.progress.is-black::-webkit-progress-value{background-color:#0a0a0a}.progress.is-black::-moz-progress-bar{background-color:#0a0a0a}.progress.is-black::-ms-fill{background-color:#0a0a0a}.progress.is-black:indeterminate{background-image:linear-gradient(90deg,#0a0a0a 30%,#dbdbdb 0)}.progress.is-light::-webkit-progress-value{background-color:#f5f5f5}.progress.is-light::-moz-progress-bar{background-color:#f5f5f5}.progress.is-light::-ms-fill{background-color:#f5f5f5}.progress.is-light:indeterminate{background-image:linear-gradient(90deg,#f5f5f5 30%,#dbdbdb 0)}.progress.is-dark::-webkit-progress-value{background-color:#363636}.progress.is-dark::-moz-progress-bar{background-color:#363636}.progress.is-dark::-ms-fill{background-color:#363636}.progress.is-dark:indeterminate{background-image:linear-gradient(90deg,#363636 30%,#dbdbdb 0)}.progress.is-primary::-webkit-progress-value{background-color:#7957d5}.progress.is-primary::-moz-progress-bar{background-color:#7957d5}.progress.is-primary::-ms-fill{background-color:#7957d5}.progress.is-primary:indeterminate{background-image:linear-gradient(90deg,#7957d5 30%,#dbdbdb 0)}.progress.is-link::-webkit-progress-value{background-color:#7957d5}.progress.is-link::-moz-progress-bar{background-color:#7957d5}.progress.is-link::-ms-fill{background-color:#7957d5}.progress.is-link:indeterminate{background-image:linear-gradient(90deg,#7957d5 30%,#dbdbdb 0)}.progress.is-info::-webkit-progress-value{background-color:#167df0}.progress.is-info::-moz-progress-bar{background-color:#167df0}.progress.is-info::-ms-fill{background-color:#167df0}.progress.is-info:indeterminate{background-image:linear-gradient(90deg,#167df0 30%,#dbdbdb 0)}.progress.is-success::-webkit-progress-value{background-color:#23d160}.progress.is-success::-moz-progress-bar{background-color:#23d160}.progress.is-success::-ms-fill{background-color:#23d160}.progress.is-success:indeterminate{background-image:linear-gradient(90deg,#23d160 30%,#dbdbdb 0)}.progress.is-warning::-webkit-progress-value{background-color:#ffdd57}.progress.is-warning::-moz-progress-bar{background-color:#ffdd57}.progress.is-warning::-ms-fill{background-color:#ffdd57}.progress.is-warning:indeterminate{background-image:linear-gradient(90deg,#ffdd57 30%,#dbdbdb 0)}.progress.is-danger::-webkit-progress-value{background-color:#ff3860}.progress.is-danger::-moz-progress-bar{background-color:#ff3860}.progress.is-danger::-ms-fill{background-color:#ff3860}.progress.is-danger:indeterminate{background-image:linear-gradient(90deg,#ff3860 30%,#dbdbdb 0)}.progress:indeterminate{animation-duration:1.5s;animation-iteration-count:infinite;animation-name:moveIndeterminate;animation-timing-function:linear;background-color:#dbdbdb;background-image:linear-gradient(90deg,#4a4a4a 30%,#dbdbdb 0);background-position:0 0;background-repeat:no-repeat;background-size:150% 150%}.progress:indeterminate::-webkit-progress-bar{background-color:transparent}.progress:indeterminate::-moz-progress-bar{background-color:transparent}.progress.is-small{height:.75rem}.progress.is-medium{height:1.25rem}.progress.is-large{height:1.5rem}@keyframes moveIndeterminate{0%{background-position:200% 0}to{background-position:-200% 0}}.table{background-color:#fff;color:#363636}.table td,.table th{border:1px solid #dbdbdb;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.table td.is-white,.table th.is-white{background-color:#fff;border-color:#fff;color:#0a0a0a}.table td.is-black,.table th.is-black{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.table td.is-light,.table th.is-light{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.table td.is-dark,.table th.is-dark{background-color:#363636;border-color:#363636;color:#f5f5f5}.table td.is-link,.table td.is-primary,.table th.is-link,.table th.is-primary{background-color:#7957d5;border-color:#7957d5;color:#fff}.table td.is-info,.table th.is-info{background-color:#167df0;border-color:#167df0;color:#fff}.table td.is-success,.table th.is-success{background-color:#23d160;border-color:#23d160;color:#fff}.table td.is-warning,.table th.is-warning{background-color:#ffdd57;border-color:#ffdd57;color:rgba(0,0,0,.7)}.table td.is-danger,.table th.is-danger{background-color:#ff3860;border-color:#ff3860;color:#fff}.table td.is-narrow,.table th.is-narrow{white-space:nowrap;width:1%}.table td.is-selected,.table th.is-selected{background-color:#7957d5;color:#fff}.table td.is-selected a,.table td.is-selected strong,.table th.is-selected a,.table th.is-selected strong{color:currentColor}.table th{color:#363636}.table th:not([align]){text-align:left}.table tr.is-selected{background-color:#7957d5;color:#fff}.table tr.is-selected a,.table tr.is-selected strong{color:currentColor}.table tr.is-selected td,.table tr.is-selected th{border-color:#fff;color:currentColor}.table thead{background-color:transparent}.table thead td,.table thead th{border-width:0 0 2px;color:#363636}.table tfoot{background-color:transparent}.table tfoot td,.table tfoot th{border-width:2px 0 0;color:#363636}.table tbody{background-color:transparent}.table tbody tr:last-child td,.table tbody tr:last-child th{border-bottom-width:0}.table.is-bordered td,.table.is-bordered th{border-width:1px}.table.is-bordered tr:last-child td,.table.is-bordered tr:last-child th{border-bottom-width:1px}.table.is-fullwidth{width:100%}.table.is-hoverable.is-striped tbody tr:not(.is-selected):hover,.table.is-hoverable tbody tr:not(.is-selected):hover{background-color:#fafafa}.table.is-hoverable.is-striped tbody tr:not(.is-selected):hover:nth-child(2n){background-color:#f5f5f5}.table.is-narrow td,.table.is-narrow th{padding:.25em .5em}.table.is-striped tbody tr:not(.is-selected):nth-child(2n){background-color:#fafafa}.table-container{-webkit-overflow-scrolling:touch;overflow:auto;overflow-y:hidden;max-width:100%}.tags{align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start}.tags .tag{margin-bottom:.5rem}.tags .tag:not(:last-child){margin-right:.5rem}.tags:last-child{margin-bottom:-.5rem}.tags:not(:last-child){margin-bottom:1rem}.tags.are-medium .tag:not(.is-normal):not(.is-large){font-size:1rem}.tags.are-large .tag:not(.is-normal):not(.is-medium){font-size:1.25rem}.tags.is-centered{justify-content:center}.tags.is-centered .tag{margin-right:.25rem;margin-left:.25rem}.tags.is-right{justify-content:flex-end}.tags.is-right .tag:not(:first-child){margin-left:.5rem}.tags.has-addons .tag,.tags.is-right .tag:not(:last-child){margin-right:0}.tags.has-addons .tag:not(:first-child){margin-left:0;border-bottom-left-radius:0;border-top-left-radius:0}.tags.has-addons .tag:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.tag:not(body){align-items:center;background-color:#f5f5f5;border-radius:4px;color:#4a4a4a;display:inline-flex;font-size:.75rem;height:2em;justify-content:center;line-height:1.5;padding-left:.75em;padding-right:.75em;white-space:nowrap}.tag:not(body) .delete{margin-left:.25rem;margin-right:-.375rem}.tag:not(body).is-white{background-color:#fff;color:#0a0a0a}.tag:not(body).is-black{background-color:#0a0a0a;color:#fff}.tag:not(body).is-light{background-color:#f5f5f5;color:#363636}.tag:not(body).is-dark{background-color:#363636;color:#f5f5f5}.tag:not(body).is-link,.tag:not(body).is-primary{background-color:#7957d5;color:#fff}.tag:not(body).is-info{background-color:#167df0;color:#fff}.tag:not(body).is-success{background-color:#23d160;color:#fff}.tag:not(body).is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.tag:not(body).is-danger{background-color:#ff3860;color:#fff}.tag:not(body).is-normal{font-size:.75rem}.tag:not(body).is-medium{font-size:1rem}.tag:not(body).is-large{font-size:1.25rem}.tag:not(body) .icon:first-child:not(:last-child){margin-left:-.375em;margin-right:.1875em}.tag:not(body) .icon:last-child:not(:first-child){margin-left:.1875em;margin-right:-.375em}.tag:not(body) .icon:first-child:last-child{margin-left:-.375em;margin-right:-.375em}.tag:not(body).is-delete{margin-left:1px;padding:0;position:relative;width:2em}.tag:not(body).is-delete:after,.tag:not(body).is-delete:before{background-color:currentColor;content:\"\";display:block;left:50%;position:absolute;top:50%;transform:translateX(-50%) translateY(-50%) rotate(45deg);transform-origin:center center}.tag:not(body).is-delete:before{height:1px;width:50%}.tag:not(body).is-delete:after{height:50%;width:1px}.tag:not(body).is-delete:focus,.tag:not(body).is-delete:hover{background-color:#e8e8e8}.tag:not(body).is-delete:active{background-color:#dbdbdb}.tag:not(body).is-rounded{border-radius:290486px}a.tag:hover{text-decoration:underline}.subtitle,.title{word-break:break-word}.subtitle em,.subtitle span,.title em,.title span{font-weight:inherit}.subtitle sub,.subtitle sup,.title sub,.title sup{font-size:.75em}.subtitle .tag,.title .tag{vertical-align:middle}.title{color:#363636;font-size:2rem;font-weight:600;line-height:1.125}.title strong{color:inherit;font-weight:inherit}.title+.highlight{margin-top:-.75rem}.title:not(.is-spaced)+.subtitle{margin-top:-1.25rem}.title.is-1{font-size:3rem}.title.is-2{font-size:2.5rem}.title.is-3{font-size:2rem}.title.is-4{font-size:1.5rem}.title.is-5{font-size:1.25rem}.title.is-6{font-size:1rem}.title.is-7{font-size:.75rem}.subtitle{color:#4a4a4a;font-size:1.25rem;font-weight:400;line-height:1.25}.subtitle strong{color:#363636;font-weight:600}.subtitle:not(.is-spaced)+.title{margin-top:-1.25rem}.subtitle.is-1{font-size:3rem}.subtitle.is-2{font-size:2.5rem}.subtitle.is-3{font-size:2rem}.subtitle.is-4{font-size:1.5rem}.subtitle.is-5{font-size:1.25rem}.subtitle.is-6{font-size:1rem}.subtitle.is-7{font-size:.75rem}.heading{display:block;font-size:11px;letter-spacing:1px;margin-bottom:5px;text-transform:uppercase}.highlight{font-weight:400;max-width:100%;overflow:hidden;padding:0}.highlight pre{overflow:auto;max-width:100%}.number{align-items:center;background-color:#f5f5f5;border-radius:290486px;display:inline-flex;font-size:1.25rem;height:2em;justify-content:center;margin-right:1.5rem;min-width:2.5em;padding:.25rem .5rem;text-align:center;vertical-align:top}.input,.select select,.taginput .taginput-container.is-focusable,.textarea{background-color:#fff;border-color:#dbdbdb;border-radius:4px;color:#363636}.input::-moz-placeholder,.select select::-moz-placeholder,.taginput .taginput-container.is-focusable::-moz-placeholder,.textarea::-moz-placeholder{color:rgba(54,54,54,.3)}.input::-webkit-input-placeholder,.select select::-webkit-input-placeholder,.taginput .taginput-container.is-focusable::-webkit-input-placeholder,.textarea::-webkit-input-placeholder{color:rgba(54,54,54,.3)}.input:-moz-placeholder,.select select:-moz-placeholder,.taginput .taginput-container.is-focusable:-moz-placeholder,.textarea:-moz-placeholder{color:rgba(54,54,54,.3)}.input:-ms-input-placeholder,.select select:-ms-input-placeholder,.taginput .taginput-container.is-focusable:-ms-input-placeholder,.textarea:-ms-input-placeholder{color:rgba(54,54,54,.3)}.input:hover,.is-hovered.input,.is-hovered.textarea,.select select.is-hovered,.select select:hover,.taginput .is-hovered.taginput-container.is-focusable,.taginput .taginput-container.is-focusable:hover,.textarea:hover{border-color:#b5b5b5}.input:active,.input:focus,.is-active.input,.is-active.textarea,.is-focused.input,.is-focused.textarea,.select select.is-active,.select select.is-focused,.select select:active,.select select:focus,.taginput .is-active.taginput-container.is-focusable,.taginput .is-focused.taginput-container.is-focusable,.taginput .taginput-container.is-focusable:active,.taginput .taginput-container.is-focusable:focus,.textarea:active,.textarea:focus{border-color:#7957d5;box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.input[disabled],.select fieldset[disabled] select,.select select[disabled],.taginput .taginput-container.is-focusable[disabled],.taginput fieldset[disabled] .taginput-container.is-focusable,.textarea[disabled],fieldset[disabled] .input,fieldset[disabled] .select select,fieldset[disabled] .taginput .taginput-container.is-focusable,fieldset[disabled] .textarea{background-color:#f5f5f5;border-color:#f5f5f5;box-shadow:none;color:#7a7a7a}.input[disabled]::-moz-placeholder,.select fieldset[disabled] select::-moz-placeholder,.select select[disabled]::-moz-placeholder,.taginput .taginput-container.is-focusable[disabled]::-moz-placeholder,.taginput fieldset[disabled] .taginput-container.is-focusable::-moz-placeholder,.textarea[disabled]::-moz-placeholder,fieldset[disabled] .input::-moz-placeholder,fieldset[disabled] .select select::-moz-placeholder,fieldset[disabled] .taginput .taginput-container.is-focusable::-moz-placeholder,fieldset[disabled] .textarea::-moz-placeholder{color:hsla(0,0%,48%,.3)}.input[disabled]::-webkit-input-placeholder,.select fieldset[disabled] select::-webkit-input-placeholder,.select select[disabled]::-webkit-input-placeholder,.taginput .taginput-container.is-focusable[disabled]::-webkit-input-placeholder,.taginput fieldset[disabled] .taginput-container.is-focusable::-webkit-input-placeholder,.textarea[disabled]::-webkit-input-placeholder,fieldset[disabled] .input::-webkit-input-placeholder,fieldset[disabled] .select select::-webkit-input-placeholder,fieldset[disabled] .taginput .taginput-container.is-focusable::-webkit-input-placeholder,fieldset[disabled] .textarea::-webkit-input-placeholder{color:hsla(0,0%,48%,.3)}.input[disabled]:-moz-placeholder,.select fieldset[disabled] select:-moz-placeholder,.select select[disabled]:-moz-placeholder,.taginput .taginput-container.is-focusable[disabled]:-moz-placeholder,.taginput fieldset[disabled] .taginput-container.is-focusable:-moz-placeholder,.textarea[disabled]:-moz-placeholder,fieldset[disabled] .input:-moz-placeholder,fieldset[disabled] .select select:-moz-placeholder,fieldset[disabled] .taginput .taginput-container.is-focusable:-moz-placeholder,fieldset[disabled] .textarea:-moz-placeholder{color:hsla(0,0%,48%,.3)}.input[disabled]:-ms-input-placeholder,.select fieldset[disabled] select:-ms-input-placeholder,.select select[disabled]:-ms-input-placeholder,.taginput .taginput-container.is-focusable[disabled]:-ms-input-placeholder,.taginput fieldset[disabled] .taginput-container.is-focusable:-ms-input-placeholder,.textarea[disabled]:-ms-input-placeholder,fieldset[disabled] .input:-ms-input-placeholder,fieldset[disabled] .select select:-ms-input-placeholder,fieldset[disabled] .taginput .taginput-container.is-focusable:-ms-input-placeholder,fieldset[disabled] .textarea:-ms-input-placeholder{color:hsla(0,0%,48%,.3)}.input,.taginput .taginput-container.is-focusable,.textarea{box-shadow:inset 0 1px 2px hsla(0,0%,4%,.1);max-width:100%;width:100%}.input[readonly],.taginput .taginput-container.is-focusable[readonly],.textarea[readonly]{box-shadow:none}.is-white.input,.is-white.textarea,.taginput .is-white.taginput-container.is-focusable{border-color:#fff}.is-white.input:active,.is-white.input:focus,.is-white.is-active.input,.is-white.is-active.textarea,.is-white.is-focused.input,.is-white.is-focused.textarea,.is-white.textarea:active,.is-white.textarea:focus,.taginput .is-white.is-active.taginput-container.is-focusable,.taginput .is-white.is-focused.taginput-container.is-focusable,.taginput .is-white.taginput-container.is-focusable:active,.taginput .is-white.taginput-container.is-focusable:focus{box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.is-black.input,.is-black.textarea,.taginput .is-black.taginput-container.is-focusable{border-color:#0a0a0a}.is-black.input:active,.is-black.input:focus,.is-black.is-active.input,.is-black.is-active.textarea,.is-black.is-focused.input,.is-black.is-focused.textarea,.is-black.textarea:active,.is-black.textarea:focus,.taginput .is-black.is-active.taginput-container.is-focusable,.taginput .is-black.is-focused.taginput-container.is-focusable,.taginput .is-black.taginput-container.is-focusable:active,.taginput .is-black.taginput-container.is-focusable:focus{box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.is-light.input,.is-light.textarea,.taginput .is-light.taginput-container.is-focusable{border-color:#f5f5f5}.is-light.input:active,.is-light.input:focus,.is-light.is-active.input,.is-light.is-active.textarea,.is-light.is-focused.input,.is-light.is-focused.textarea,.is-light.textarea:active,.is-light.textarea:focus,.taginput .is-light.is-active.taginput-container.is-focusable,.taginput .is-light.is-focused.taginput-container.is-focusable,.taginput .is-light.taginput-container.is-focusable:active,.taginput .is-light.taginput-container.is-focusable:focus{box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.is-dark.input,.is-dark.textarea,.taginput .is-dark.taginput-container.is-focusable{border-color:#363636}.is-dark.input:active,.is-dark.input:focus,.is-dark.is-active.input,.is-dark.is-active.textarea,.is-dark.is-focused.input,.is-dark.is-focused.textarea,.is-dark.textarea:active,.is-dark.textarea:focus,.taginput .is-dark.is-active.taginput-container.is-focusable,.taginput .is-dark.is-focused.taginput-container.is-focusable,.taginput .is-dark.taginput-container.is-focusable:active,.taginput .is-dark.taginput-container.is-focusable:focus{box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.is-primary.input,.is-primary.textarea,.taginput .is-primary.taginput-container.is-focusable{border-color:#7957d5}.is-primary.input:active,.is-primary.input:focus,.is-primary.is-active.input,.is-primary.is-active.textarea,.is-primary.is-focused.input,.is-primary.is-focused.textarea,.is-primary.textarea:active,.is-primary.textarea:focus,.taginput .is-primary.is-active.taginput-container.is-focusable,.taginput .is-primary.is-focused.taginput-container.is-focusable,.taginput .is-primary.taginput-container.is-focusable:active,.taginput .is-primary.taginput-container.is-focusable:focus{box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.is-link.input,.is-link.textarea,.taginput .is-link.taginput-container.is-focusable{border-color:#7957d5}.is-link.input:active,.is-link.input:focus,.is-link.is-active.input,.is-link.is-active.textarea,.is-link.is-focused.input,.is-link.is-focused.textarea,.is-link.textarea:active,.is-link.textarea:focus,.taginput .is-link.is-active.taginput-container.is-focusable,.taginput .is-link.is-focused.taginput-container.is-focusable,.taginput .is-link.taginput-container.is-focusable:active,.taginput .is-link.taginput-container.is-focusable:focus{box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.is-info.input,.is-info.textarea,.taginput .is-info.taginput-container.is-focusable{border-color:#167df0}.is-info.input:active,.is-info.input:focus,.is-info.is-active.input,.is-info.is-active.textarea,.is-info.is-focused.input,.is-info.is-focused.textarea,.is-info.textarea:active,.is-info.textarea:focus,.taginput .is-info.is-active.taginput-container.is-focusable,.taginput .is-info.is-focused.taginput-container.is-focusable,.taginput .is-info.taginput-container.is-focusable:active,.taginput .is-info.taginput-container.is-focusable:focus{box-shadow:0 0 0 .125em rgba(22,125,240,.25)}.is-success.input,.is-success.textarea,.taginput .is-success.taginput-container.is-focusable{border-color:#23d160}.is-success.input:active,.is-success.input:focus,.is-success.is-active.input,.is-success.is-active.textarea,.is-success.is-focused.input,.is-success.is-focused.textarea,.is-success.textarea:active,.is-success.textarea:focus,.taginput .is-success.is-active.taginput-container.is-focusable,.taginput .is-success.is-focused.taginput-container.is-focusable,.taginput .is-success.taginput-container.is-focusable:active,.taginput .is-success.taginput-container.is-focusable:focus{box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.is-warning.input,.is-warning.textarea,.taginput .is-warning.taginput-container.is-focusable{border-color:#ffdd57}.is-warning.input:active,.is-warning.input:focus,.is-warning.is-active.input,.is-warning.is-active.textarea,.is-warning.is-focused.input,.is-warning.is-focused.textarea,.is-warning.textarea:active,.is-warning.textarea:focus,.taginput .is-warning.is-active.taginput-container.is-focusable,.taginput .is-warning.is-focused.taginput-container.is-focusable,.taginput .is-warning.taginput-container.is-focusable:active,.taginput .is-warning.taginput-container.is-focusable:focus{box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.is-danger.input,.is-danger.textarea,.taginput .is-danger.taginput-container.is-focusable{border-color:#ff3860}.is-danger.input:active,.is-danger.input:focus,.is-danger.is-active.input,.is-danger.is-active.textarea,.is-danger.is-focused.input,.is-danger.is-focused.textarea,.is-danger.textarea:active,.is-danger.textarea:focus,.taginput .is-danger.is-active.taginput-container.is-focusable,.taginput .is-danger.is-focused.taginput-container.is-focusable,.taginput .is-danger.taginput-container.is-focusable:active,.taginput .is-danger.taginput-container.is-focusable:focus{box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.is-small.input,.is-small.textarea,.taginput .is-small.taginput-container.is-focusable{border-radius:2px;font-size:.75rem}.is-medium.input,.is-medium.textarea,.taginput .is-medium.taginput-container.is-focusable{font-size:1.25rem}.is-large.input,.is-large.textarea,.taginput .is-large.taginput-container.is-focusable{font-size:1.5rem}.is-fullwidth.input,.is-fullwidth.textarea,.taginput .is-fullwidth.taginput-container.is-focusable{display:block;width:100%}.is-inline.input,.is-inline.textarea,.taginput .is-inline.taginput-container.is-focusable{display:inline;width:auto}.input.is-rounded,.taginput .is-rounded.taginput-container.is-focusable{border-radius:290486px;padding-left:1em;padding-right:1em}.input.is-static,.taginput .is-static.taginput-container.is-focusable{background-color:transparent;border-color:transparent;box-shadow:none;padding-left:0;padding-right:0}.textarea{display:block;max-width:100%;min-width:100%;padding:.625em;resize:vertical}.textarea:not([rows]){max-height:600px;min-height:120px}.textarea[rows]{height:auto}.textarea.has-fixed-size{resize:none}.checkbox,.radio{cursor:pointer;display:inline-block;line-height:1.25;position:relative}.checkbox input,.radio input{cursor:pointer}.checkbox:hover,.radio:hover{color:#363636}.checkbox[disabled],.radio[disabled],fieldset[disabled] .checkbox,fieldset[disabled] .radio{color:#7a7a7a;cursor:not-allowed}.radio+.radio{margin-left:.5em}.select{display:inline-block;max-width:100%;position:relative;vertical-align:top}.select:not(.is-multiple){height:2.25em}.select:not(.is-multiple):not(.is-loading):after{border-color:#7957d5;right:1.125em;z-index:4}.select.is-rounded select{border-radius:290486px;padding-left:1em}.select select{cursor:pointer;display:block;font-size:1em;max-width:100%;outline:none}.select select::-ms-expand{display:none}.select select[disabled]:hover,fieldset[disabled] .select select:hover{border-color:#f5f5f5}.select select:not([multiple]){padding-right:2.5em}.select select[multiple]{height:auto;padding:0}.select select[multiple] option{padding:.5em 1em}.select:not(.is-multiple):not(.is-loading):hover:after{border-color:#363636}.select.is-white:not(:hover):after,.select.is-white select{border-color:#fff}.select.is-white select.is-hovered,.select.is-white select:hover{border-color:#f2f2f2}.select.is-white select.is-active,.select.is-white select.is-focused,.select.is-white select:active,.select.is-white select:focus{box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.select.is-black:not(:hover):after,.select.is-black select{border-color:#0a0a0a}.select.is-black select.is-hovered,.select.is-black select:hover{border-color:#000}.select.is-black select.is-active,.select.is-black select.is-focused,.select.is-black select:active,.select.is-black select:focus{box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.select.is-light:not(:hover):after,.select.is-light select{border-color:#f5f5f5}.select.is-light select.is-hovered,.select.is-light select:hover{border-color:#e8e8e8}.select.is-light select.is-active,.select.is-light select.is-focused,.select.is-light select:active,.select.is-light select:focus{box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.select.is-dark:not(:hover):after,.select.is-dark select{border-color:#363636}.select.is-dark select.is-hovered,.select.is-dark select:hover{border-color:#292929}.select.is-dark select.is-active,.select.is-dark select.is-focused,.select.is-dark select:active,.select.is-dark select:focus{box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.select.is-primary:not(:hover):after,.select.is-primary select{border-color:#7957d5}.select.is-primary select.is-hovered,.select.is-primary select:hover{border-color:#6943d0}.select.is-primary select.is-active,.select.is-primary select.is-focused,.select.is-primary select:active,.select.is-primary select:focus{box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.select.is-link:not(:hover):after,.select.is-link select{border-color:#7957d5}.select.is-link select.is-hovered,.select.is-link select:hover{border-color:#6943d0}.select.is-link select.is-active,.select.is-link select.is-focused,.select.is-link select:active,.select.is-link select:focus{box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.select.is-info:not(:hover):after,.select.is-info select{border-color:#167df0}.select.is-info select.is-hovered,.select.is-info select:hover{border-color:#0e71de}.select.is-info select.is-active,.select.is-info select.is-focused,.select.is-info select:active,.select.is-info select:focus{box-shadow:0 0 0 .125em rgba(22,125,240,.25)}.select.is-success:not(:hover):after,.select.is-success select{border-color:#23d160}.select.is-success select.is-hovered,.select.is-success select:hover{border-color:#20bc56}.select.is-success select.is-active,.select.is-success select.is-focused,.select.is-success select:active,.select.is-success select:focus{box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.select.is-warning:not(:hover):after,.select.is-warning select{border-color:#ffdd57}.select.is-warning select.is-hovered,.select.is-warning select:hover{border-color:#ffd83d}.select.is-warning select.is-active,.select.is-warning select.is-focused,.select.is-warning select:active,.select.is-warning select:focus{box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.select.is-danger:not(:hover):after,.select.is-danger select{border-color:#ff3860}.select.is-danger select.is-hovered,.select.is-danger select:hover{border-color:#ff1f4b}.select.is-danger select.is-active,.select.is-danger select.is-focused,.select.is-danger select:active,.select.is-danger select:focus{box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.select.is-small{border-radius:2px;font-size:.75rem}.select.is-medium{font-size:1.25rem}.select.is-large{font-size:1.5rem}.select.is-disabled:after{border-color:#7a7a7a}.select.is-fullwidth,.select.is-fullwidth select{width:100%}.select.is-loading:after{margin-top:0;position:absolute;right:.625em;top:.625em;transform:none}.select.is-loading.is-small:after{font-size:.75rem}.select.is-loading.is-medium:after{font-size:1.25rem}.select.is-loading.is-large:after{font-size:1.5rem}.file{align-items:stretch;display:flex;justify-content:flex-start;position:relative}.file.is-white .file-cta{background-color:#fff;border-color:transparent;color:#0a0a0a}.file.is-white.is-hovered .file-cta,.file.is-white:hover .file-cta{background-color:#f9f9f9;border-color:transparent;color:#0a0a0a}.file.is-white.is-focused .file-cta,.file.is-white:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em hsla(0,0%,100%,.25);color:#0a0a0a}.file.is-white.is-active .file-cta,.file.is-white:active .file-cta{background-color:#f2f2f2;border-color:transparent;color:#0a0a0a}.file.is-black .file-cta{background-color:#0a0a0a;border-color:transparent;color:#fff}.file.is-black.is-hovered .file-cta,.file.is-black:hover .file-cta{background-color:#040404;border-color:transparent;color:#fff}.file.is-black.is-focused .file-cta,.file.is-black:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em hsla(0,0%,4%,.25);color:#fff}.file.is-black.is-active .file-cta,.file.is-black:active .file-cta{background-color:#000;border-color:transparent;color:#fff}.file.is-light .file-cta{background-color:#f5f5f5;border-color:transparent;color:#363636}.file.is-light.is-hovered .file-cta,.file.is-light:hover .file-cta{background-color:#eee;border-color:transparent;color:#363636}.file.is-light.is-focused .file-cta,.file.is-light:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em hsla(0,0%,96%,.25);color:#363636}.file.is-light.is-active .file-cta,.file.is-light:active .file-cta{background-color:#e8e8e8;border-color:transparent;color:#363636}.file.is-dark .file-cta{background-color:#363636;border-color:transparent;color:#f5f5f5}.file.is-dark.is-hovered .file-cta,.file.is-dark:hover .file-cta{background-color:#2f2f2f;border-color:transparent;color:#f5f5f5}.file.is-dark.is-focused .file-cta,.file.is-dark:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(54,54,54,.25);color:#f5f5f5}.file.is-dark.is-active .file-cta,.file.is-dark:active .file-cta{background-color:#292929;border-color:transparent;color:#f5f5f5}.file.is-primary .file-cta{background-color:#7957d5;border-color:transparent;color:#fff}.file.is-primary.is-hovered .file-cta,.file.is-primary:hover .file-cta{background-color:#714dd2;border-color:transparent;color:#fff}.file.is-primary.is-focused .file-cta,.file.is-primary:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(121,87,213,.25);color:#fff}.file.is-primary.is-active .file-cta,.file.is-primary:active .file-cta{background-color:#6943d0;border-color:transparent;color:#fff}.file.is-link .file-cta{background-color:#7957d5;border-color:transparent;color:#fff}.file.is-link.is-hovered .file-cta,.file.is-link:hover .file-cta{background-color:#714dd2;border-color:transparent;color:#fff}.file.is-link.is-focused .file-cta,.file.is-link:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(121,87,213,.25);color:#fff}.file.is-link.is-active .file-cta,.file.is-link:active .file-cta{background-color:#6943d0;border-color:transparent;color:#fff}.file.is-info .file-cta{background-color:#167df0;border-color:transparent;color:#fff}.file.is-info.is-hovered .file-cta,.file.is-info:hover .file-cta{background-color:#0f77ea;border-color:transparent;color:#fff}.file.is-info.is-focused .file-cta,.file.is-info:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(22,125,240,.25);color:#fff}.file.is-info.is-active .file-cta,.file.is-info:active .file-cta{background-color:#0e71de;border-color:transparent;color:#fff}.file.is-success .file-cta{background-color:#23d160;border-color:transparent;color:#fff}.file.is-success.is-hovered .file-cta,.file.is-success:hover .file-cta{background-color:#22c65b;border-color:transparent;color:#fff}.file.is-success.is-focused .file-cta,.file.is-success:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(35,209,96,.25);color:#fff}.file.is-success.is-active .file-cta,.file.is-success:active .file-cta{background-color:#20bc56;border-color:transparent;color:#fff}.file.is-warning .file-cta{background-color:#ffdd57;border-color:transparent;color:rgba(0,0,0,.7)}.file.is-warning.is-hovered .file-cta,.file.is-warning:hover .file-cta{background-color:#ffdb4a;border-color:transparent;color:rgba(0,0,0,.7)}.file.is-warning.is-focused .file-cta,.file.is-warning:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(255,221,87,.25);color:rgba(0,0,0,.7)}.file.is-warning.is-active .file-cta,.file.is-warning:active .file-cta{background-color:#ffd83d;border-color:transparent;color:rgba(0,0,0,.7)}.file.is-danger .file-cta{background-color:#ff3860;border-color:transparent;color:#fff}.file.is-danger.is-hovered .file-cta,.file.is-danger:hover .file-cta{background-color:#ff2b56;border-color:transparent;color:#fff}.file.is-danger.is-focused .file-cta,.file.is-danger:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(255,56,96,.25);color:#fff}.file.is-danger.is-active .file-cta,.file.is-danger:active .file-cta{background-color:#ff1f4b;border-color:transparent;color:#fff}.file.is-small{font-size:.75rem}.file.is-medium{font-size:1.25rem}.file.is-medium .file-icon .fa{font-size:21px}.file.is-large{font-size:1.5rem}.file.is-large .file-icon .fa{font-size:28px}.file.has-name .file-cta{border-bottom-right-radius:0;border-top-right-radius:0}.file.has-name .file-name{border-bottom-left-radius:0;border-top-left-radius:0}.file.has-name.is-empty .file-cta{border-radius:4px}.file.has-name.is-empty .file-name{display:none}.file.is-boxed .file-label{flex-direction:column}.file.is-boxed .file-cta{flex-direction:column;height:auto;padding:1em 3em}.file.is-boxed .file-name{border-width:0 1px 1px}.file.is-boxed .file-icon{height:1.5em;width:1.5em}.file.is-boxed .file-icon .fa{font-size:21px}.file.is-boxed.is-small .file-icon .fa{font-size:14px}.file.is-boxed.is-medium .file-icon .fa{font-size:28px}.file.is-boxed.is-large .file-icon .fa{font-size:35px}.file.is-boxed.has-name .file-cta{border-radius:4px 4px 0 0}.file.is-boxed.has-name .file-name{border-radius:0 0 4px 4px;border-width:0 1px 1px}.file.is-centered{justify-content:center}.file.is-fullwidth .file-label{width:100%}.file.is-fullwidth .file-name{flex-grow:1;max-width:none}.file.is-right{justify-content:flex-end}.file.is-right .file-cta{border-radius:0 4px 4px 0}.file.is-right .file-name{border-radius:4px 0 0 4px;border-width:1px 0 1px 1px;order:-1}.file-label{align-items:stretch;display:flex;cursor:pointer;justify-content:flex-start;overflow:hidden;position:relative}.file-label:hover .file-cta{background-color:#eee;color:#363636}.file-label:hover .file-name{border-color:#d5d5d5}.file-label:active .file-cta{background-color:#e8e8e8;color:#363636}.file-label:active .file-name{border-color:#cfcfcf}.file-input{height:100%;left:0;opacity:0;outline:none;position:absolute;top:0;width:100%}.file-cta,.file-name{border-color:#dbdbdb;border-radius:4px;font-size:1em;padding-left:1em;padding-right:1em;white-space:nowrap}.file-cta{background-color:#f5f5f5;color:#4a4a4a}.file-name{border-color:#dbdbdb;border-style:solid;border-width:1px 1px 1px 0;display:block;max-width:16em;overflow:hidden;text-align:left;text-overflow:ellipsis}.file-icon{align-items:center;display:flex;height:1em;justify-content:center;margin-right:.5em;width:1em}.file-icon .fa{font-size:14px}.label{color:#363636;display:block;font-size:1rem;font-weight:600}.label:not(:last-child){margin-bottom:.5em}.label.is-small{font-size:.75rem}.label.is-medium{font-size:1.25rem}.label.is-large{font-size:1.5rem}.help{display:block;font-size:.75rem;margin-top:.25rem}.help.is-white{color:#fff}.help.is-black{color:#0a0a0a}.help.is-light{color:#f5f5f5}.help.is-dark{color:#363636}.help.is-link,.help.is-primary{color:#7957d5}.help.is-info{color:#167df0}.help.is-success{color:#23d160}.help.is-warning{color:#ffdd57}.help.is-danger{color:#ff3860}.field:not(:last-child){margin-bottom:.75rem}.field.has-addons{display:flex;justify-content:flex-start}.field.has-addons .control:not(:last-child){margin-right:-1px}.field.has-addons .control:not(:first-child):not(:last-child) .button,.field.has-addons .control:not(:first-child):not(:last-child) .input,.field.has-addons .control:not(:first-child):not(:last-child) .select select,.field.has-addons .control:not(:first-child):not(:last-child) .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:not(:first-child):not(:last-child) .taginput-container.is-focusable{border-radius:0}.field.has-addons .control:first-child:not(:only-child) .button,.field.has-addons .control:first-child:not(:only-child) .input,.field.has-addons .control:first-child:not(:only-child) .select select,.field.has-addons .control:first-child:not(:only-child) .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:first-child:not(:only-child) .taginput-container.is-focusable{border-bottom-right-radius:0;border-top-right-radius:0}.field.has-addons .control:last-child:not(:only-child) .button,.field.has-addons .control:last-child:not(:only-child) .input,.field.has-addons .control:last-child:not(:only-child) .select select,.field.has-addons .control:last-child:not(:only-child) .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:last-child:not(:only-child) .taginput-container.is-focusable{border-bottom-left-radius:0;border-top-left-radius:0}.field.has-addons .control .button:not([disabled]).is-hovered,.field.has-addons .control .button:not([disabled]):hover,.field.has-addons .control .input:not([disabled]).is-hovered,.field.has-addons .control .input:not([disabled]):hover,.field.has-addons .control .select select:not([disabled]).is-hovered,.field.has-addons .control .select select:not([disabled]):hover,.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-hovered,.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):hover,.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-hovered,.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):hover{z-index:2}.field.has-addons .control .button:not([disabled]).is-active,.field.has-addons .control .button:not([disabled]).is-focused,.field.has-addons .control .button:not([disabled]):active,.field.has-addons .control .button:not([disabled]):focus,.field.has-addons .control .input:not([disabled]).is-active,.field.has-addons .control .input:not([disabled]).is-focused,.field.has-addons .control .input:not([disabled]):active,.field.has-addons .control .input:not([disabled]):focus,.field.has-addons .control .select select:not([disabled]).is-active,.field.has-addons .control .select select:not([disabled]).is-focused,.field.has-addons .control .select select:not([disabled]):active,.field.has-addons .control .select select:not([disabled]):focus,.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-active,.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-focused,.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):active,.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):focus,.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-active,.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-focused,.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):active,.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):focus{z-index:3}.field.has-addons .control .button:not([disabled]).is-active:hover,.field.has-addons .control .button:not([disabled]).is-focused:hover,.field.has-addons .control .button:not([disabled]):active:hover,.field.has-addons .control .button:not([disabled]):focus:hover,.field.has-addons .control .input:not([disabled]).is-active:hover,.field.has-addons .control .input:not([disabled]).is-focused:hover,.field.has-addons .control .input:not([disabled]):active:hover,.field.has-addons .control .input:not([disabled]):focus:hover,.field.has-addons .control .select select:not([disabled]).is-active:hover,.field.has-addons .control .select select:not([disabled]).is-focused:hover,.field.has-addons .control .select select:not([disabled]):active:hover,.field.has-addons .control .select select:not([disabled]):focus:hover,.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-active:hover,.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-focused:hover,.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):active:hover,.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):focus:hover,.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-active:hover,.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-focused:hover,.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):active:hover,.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):focus:hover{z-index:4}.field.has-addons .control.is-expanded{flex-grow:1;flex-shrink:1}.field.has-addons.has-addons-centered{justify-content:center}.field.has-addons.has-addons-right{justify-content:flex-end}.field.has-addons.has-addons-fullwidth .control{flex-grow:1;flex-shrink:0}.field.is-grouped{display:flex;justify-content:flex-start}.field.is-grouped>.control{flex-shrink:0}.field.is-grouped>.control:not(:last-child){margin-bottom:0;margin-right:.75rem}.field.is-grouped>.control.is-expanded{flex-grow:1;flex-shrink:1}.field.is-grouped.is-grouped-centered{justify-content:center}.field.is-grouped.is-grouped-right{justify-content:flex-end}.field.is-grouped.is-grouped-multiline{flex-wrap:wrap}.field.is-grouped.is-grouped-multiline>.control:last-child,.field.is-grouped.is-grouped-multiline>.control:not(:last-child){margin-bottom:.75rem}.field.is-grouped.is-grouped-multiline:last-child{margin-bottom:-.75rem}.field.is-grouped.is-grouped-multiline:not(:last-child){margin-bottom:0}@media print,screen and (min-width:769px){.field.is-horizontal{display:flex}}.field-label .label{font-size:inherit}@media screen and (max-width:768px){.field-label{margin-bottom:.5rem}}@media print,screen and (min-width:769px){.field-label{flex-basis:0;flex-grow:1;flex-shrink:0;margin-right:1.5rem;text-align:right}.field-label.is-small{font-size:.75rem;padding-top:.375em}.field-label.is-normal{padding-top:.375em}.field-label.is-medium{font-size:1.25rem;padding-top:.375em}.field-label.is-large{font-size:1.5rem;padding-top:.375em}}.field-body .field .field{margin-bottom:0}@media print,screen and (min-width:769px){.field-body{display:flex;flex-basis:0;flex-grow:5;flex-shrink:1}.field-body .field{margin-bottom:0}.field-body>.field{flex-shrink:1}.field-body>.field:not(.is-narrow){flex-grow:1}.field-body>.field:not(:last-child){margin-right:.75rem}}.control{box-sizing:border-box;clear:both;font-size:1rem;position:relative;text-align:left}.control.has-icons-left .input:focus~.icon,.control.has-icons-left .select:focus~.icon,.control.has-icons-left .taginput .taginput-container.is-focusable:focus~.icon,.control.has-icons-right .input:focus~.icon,.control.has-icons-right .select:focus~.icon,.control.has-icons-right .taginput .taginput-container.is-focusable:focus~.icon,.taginput .control.has-icons-left .taginput-container.is-focusable:focus~.icon,.taginput .control.has-icons-right .taginput-container.is-focusable:focus~.icon{color:#7a7a7a}.control.has-icons-left .input.is-small~.icon,.control.has-icons-left .select.is-small~.icon,.control.has-icons-left .taginput .is-small.taginput-container.is-focusable~.icon,.control.has-icons-right .input.is-small~.icon,.control.has-icons-right .select.is-small~.icon,.control.has-icons-right .taginput .is-small.taginput-container.is-focusable~.icon,.taginput .control.has-icons-left .is-small.taginput-container.is-focusable~.icon,.taginput .control.has-icons-right .is-small.taginput-container.is-focusable~.icon{font-size:.75rem}.control.has-icons-left .input.is-medium~.icon,.control.has-icons-left .select.is-medium~.icon,.control.has-icons-left .taginput .is-medium.taginput-container.is-focusable~.icon,.control.has-icons-right .input.is-medium~.icon,.control.has-icons-right .select.is-medium~.icon,.control.has-icons-right .taginput .is-medium.taginput-container.is-focusable~.icon,.taginput .control.has-icons-left .is-medium.taginput-container.is-focusable~.icon,.taginput .control.has-icons-right .is-medium.taginput-container.is-focusable~.icon{font-size:1.25rem}.control.has-icons-left .input.is-large~.icon,.control.has-icons-left .select.is-large~.icon,.control.has-icons-left .taginput .is-large.taginput-container.is-focusable~.icon,.control.has-icons-right .input.is-large~.icon,.control.has-icons-right .select.is-large~.icon,.control.has-icons-right .taginput .is-large.taginput-container.is-focusable~.icon,.taginput .control.has-icons-left .is-large.taginput-container.is-focusable~.icon,.taginput .control.has-icons-right .is-large.taginput-container.is-focusable~.icon{font-size:1.5rem}.control.has-icons-left .icon,.control.has-icons-right .icon{color:#dbdbdb;height:2.25em;pointer-events:none;position:absolute;top:0;width:2.25em;z-index:4}.control.has-icons-left .input,.control.has-icons-left .select select,.control.has-icons-left .taginput .taginput-container.is-focusable,.taginput .control.has-icons-left .taginput-container.is-focusable{padding-left:2.25em}.control.has-icons-left .icon.is-left{left:0}.control.has-icons-right .input,.control.has-icons-right .select select,.control.has-icons-right .taginput .taginput-container.is-focusable,.taginput .control.has-icons-right .taginput-container.is-focusable{padding-right:2.25em}.control.has-icons-right .icon.is-right{right:0}.control.is-loading:after{position:absolute!important;right:.625em;top:.625em;z-index:4}.control.is-loading.is-small:after{font-size:.75rem}.control.is-loading.is-medium:after{font-size:1.25rem}.control.is-loading.is-large:after{font-size:1.5rem}.breadcrumb{font-size:1rem;white-space:nowrap}.breadcrumb a{align-items:center;color:#7957d5;display:flex;justify-content:center;padding:0 .75em}.breadcrumb a:hover{color:#363636}.breadcrumb li{align-items:center;display:flex}.breadcrumb li:first-child a{padding-left:0}.breadcrumb li.is-active a{color:#363636;cursor:default;pointer-events:none}.breadcrumb li+li:before{color:#b5b5b5;content:\"/\"}.breadcrumb ol,.breadcrumb ul{align-items:flex-start;display:flex;flex-wrap:wrap;justify-content:flex-start}.breadcrumb .icon:first-child{margin-right:.5em}.breadcrumb .icon:last-child{margin-left:.5em}.breadcrumb.is-centered ol,.breadcrumb.is-centered ul{justify-content:center}.breadcrumb.is-right ol,.breadcrumb.is-right ul{justify-content:flex-end}.breadcrumb.is-small{font-size:.75rem}.breadcrumb.is-medium{font-size:1.25rem}.breadcrumb.is-large{font-size:1.5rem}.breadcrumb.has-arrow-separator li+li:before{content:\"\\2192\"}.breadcrumb.has-bullet-separator li+li:before{content:\"\\2022\"}.breadcrumb.has-dot-separator li+li:before{content:\"\\B7\"}.breadcrumb.has-succeeds-separator li+li:before{content:\"\\227B\"}.card{background-color:#fff;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);color:#4a4a4a;max-width:100%;position:relative}.card-header{background-color:transparent;align-items:stretch;box-shadow:0 1px 2px hsla(0,0%,4%,.1);display:flex}.card-header-title{align-items:center;color:#363636;display:flex;flex-grow:1;font-weight:700;padding:.75rem}.card-header-icon,.card-header-title.is-centered{justify-content:center}.card-header-icon{align-items:center;cursor:pointer;display:flex;padding:.75rem}.card-image{display:block;position:relative}.card-content{padding:1.5rem}.card-content,.card-footer{background-color:transparent}.card-footer{border-top:1px solid #dbdbdb;align-items:stretch;display:flex}.card-footer-item{align-items:center;display:flex;flex-basis:0;flex-grow:1;flex-shrink:0;justify-content:center;padding:.75rem}.card-footer-item:not(:last-child){border-right:1px solid #dbdbdb}.card .media:not(:last-child){margin-bottom:1.5rem}.dropdown{display:inline-flex;position:relative;vertical-align:top}.dropdown.is-active .dropdown-menu,.dropdown.is-hoverable:hover .dropdown-menu{display:block}.dropdown.is-right .dropdown-menu{left:auto;right:0}.dropdown.is-up .dropdown-menu{bottom:100%;padding-bottom:4px;padding-top:0;top:auto}.dropdown-menu{display:none;left:0;min-width:12rem;padding-top:4px;position:absolute;top:100%;z-index:20}.dropdown-content{background-color:#fff;border-radius:4px;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);padding-bottom:.5rem;padding-top:.5rem}.dropdown-item,.dropdown .dropdown-menu .has-link a{color:#4a4a4a;display:block;font-size:.875rem;line-height:1.5;padding:.375rem 1rem;position:relative}.dropdown .dropdown-menu .has-link a,a.dropdown-item,button.dropdown-item{padding-right:3rem;text-align:left;white-space:nowrap;width:100%}.dropdown .dropdown-menu .has-link a:hover,a.dropdown-item:hover,button.dropdown-item:hover{background-color:#f5f5f5;color:#0a0a0a}.dropdown .dropdown-menu .has-link a.is-active,a.dropdown-item.is-active,button.dropdown-item.is-active{background-color:#7957d5;color:#fff}.dropdown-divider{background-color:#dbdbdb;border:none;display:block;height:1px;margin:.5rem 0}.level{align-items:center;justify-content:space-between}.level code{border-radius:4px}.level img{display:inline-block;vertical-align:top}.level.is-mobile,.level.is-mobile .level-left,.level.is-mobile .level-right{display:flex}.level.is-mobile .level-left+.level-right{margin-top:0}.level.is-mobile .level-item:not(:last-child){margin-bottom:0;margin-right:.75rem}.level.is-mobile .level-item:not(.is-narrow){flex-grow:1}@media print,screen and (min-width:769px){.level{display:flex}.level>.level-item:not(.is-narrow){flex-grow:1}}.level-item{align-items:center;display:flex;flex-basis:auto;flex-grow:0;flex-shrink:0;justify-content:center}.level-item .subtitle,.level-item .title{margin-bottom:0}@media screen and (max-width:768px){.level-item:not(:last-child){margin-bottom:.75rem}}.level-left,.level-right{flex-basis:auto;flex-grow:0;flex-shrink:0}.level-left .level-item.is-flexible,.level-right .level-item.is-flexible{flex-grow:1}@media print,screen and (min-width:769px){.level-left .level-item:not(:last-child),.level-right .level-item:not(:last-child){margin-right:.75rem}}.level-left{align-items:center;justify-content:flex-start}@media screen and (max-width:768px){.level-left+.level-right{margin-top:1.5rem}}@media print,screen and (min-width:769px){.level-left{display:flex}}.level-right{align-items:center;justify-content:flex-end}@media print,screen and (min-width:769px){.level-right{display:flex}}.list{background-color:#fff;border-radius:4px;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1)}.list-item{display:block;padding:.5em 1em}.list-item:not(a){color:#4a4a4a}.list-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-item:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px}.list-item:not(:last-child){border-bottom:1px solid #dbdbdb}.list-item.is-active{background-color:#7957d5;color:#fff}a.list-item{background-color:#f5f5f5;cursor:pointer}.media{align-items:flex-start;display:flex;text-align:left}.media .content:not(:last-child){margin-bottom:.75rem}.media .media{border-top:1px solid hsla(0,0%,86%,.5);display:flex;padding-top:.75rem}.media .media .content:not(:last-child),.media .media .control:not(:last-child){margin-bottom:.5rem}.media .media .media{padding-top:.5rem}.media .media .media+.media{margin-top:.5rem}.media+.media{border-top:1px solid hsla(0,0%,86%,.5);margin-top:1rem;padding-top:1rem}.media.is-large+.media{margin-top:1.5rem;padding-top:1.5rem}.media-left,.media-right{flex-basis:auto;flex-grow:0;flex-shrink:0}.media-left{margin-right:1rem}.media-right{margin-left:1rem}.media-content{flex-basis:auto;flex-grow:1;flex-shrink:1;text-align:left}@media screen and (max-width:768px){.media-content{overflow-x:auto}}.menu{font-size:1rem}.menu.is-small{font-size:.75rem}.menu.is-medium{font-size:1.25rem}.menu.is-large{font-size:1.5rem}.menu-list{line-height:1.25}.menu-list a{border-radius:2px;color:#4a4a4a;display:block;padding:.5em .75em}.menu-list a:hover{background-color:#f5f5f5;color:#363636}.menu-list a.is-active{background-color:#7957d5;color:#fff}.menu-list li ul{border-left:1px solid #dbdbdb;margin:.75em;padding-left:.75em}.menu-label{color:#7a7a7a;font-size:.75em;letter-spacing:.1em;text-transform:uppercase}.menu-label:not(:first-child){margin-top:1em}.menu-label:not(:last-child){margin-bottom:1em}.message{background-color:#f5f5f5;border-radius:4px;font-size:1rem}.message strong{color:currentColor}.message a:not(.button):not(.tag):not(.dropdown-item){color:currentColor;text-decoration:underline}.message.is-small{font-size:.75rem}.message.is-medium{font-size:1.25rem}.message.is-large{font-size:1.5rem}.message.is-white{background-color:#fff}.message.is-white .message-header{background-color:#fff;color:#0a0a0a}.message.is-white .message-body{border-color:#fff;color:#4d4d4d}.message.is-black{background-color:#fafafa}.message.is-black .message-header{background-color:#0a0a0a;color:#fff}.message.is-black .message-body{border-color:#0a0a0a;color:#090909}.message.is-light{background-color:#fafafa}.message.is-light .message-header{background-color:#f5f5f5;color:#363636}.message.is-light .message-body{border-color:#f5f5f5;color:#505050}.message.is-dark{background-color:#fafafa}.message.is-dark .message-header{background-color:#363636;color:#f5f5f5}.message.is-dark .message-body{border-color:#363636;color:#2a2a2a}.message.is-primary{background-color:#f8f7fd}.message.is-primary .message-header{background-color:#7957d5;color:#fff}.message.is-primary .message-body{border-color:#7957d5;color:#5534ae}.message.is-link{background-color:#f8f7fd}.message.is-link .message-header{background-color:#7957d5;color:#fff}.message.is-link .message-body{border-color:#7957d5;color:#5534ae}.message.is-info{background-color:#f5fafe}.message.is-info .message-header{background-color:#167df0;color:#fff}.message.is-info .message-body{border-color:#167df0;color:#115199}.message.is-success{background-color:#f6fef9}.message.is-success .message-header{background-color:#23d160;color:#fff}.message.is-success .message-body{border-color:#23d160;color:#0e301a}.message.is-warning{background-color:#fffdf5}.message.is-warning .message-header{background-color:#ffdd57;color:rgba(0,0,0,.7)}.message.is-warning .message-body{border-color:#ffdd57;color:#3b3108}.message.is-danger{background-color:#fff5f7}.message.is-danger .message-header{background-color:#ff3860;color:#fff}.message.is-danger .message-body{border-color:#ff3860;color:#cd0930}.message-header{align-items:center;background-color:#4a4a4a;border-radius:4px 4px 0 0;color:#fff;display:flex;font-weight:700;justify-content:space-between;line-height:1.25;padding:.75em 1em;position:relative}.message-header .delete{flex-grow:0;flex-shrink:0;margin-left:.75em}.message-header+.message-body{border-width:0;border-top-left-radius:0;border-top-right-radius:0}.message-body{border-color:#dbdbdb;border-radius:4px;border-style:solid;border-width:0 0 0 4px;color:#4a4a4a;padding:1.25em 1.5em}.message-body code,.message-body pre{background-color:#fff}.message-body pre code{background-color:transparent}.modal{align-items:center;display:none;flex-direction:column;justify-content:center;overflow:hidden;position:fixed;z-index:40}.modal.is-active{display:flex}.modal-background{background-color:hsla(0,0%,4%,.86)}.modal-card,.modal-content{margin:0 20px;max-height:calc(100vh - 160px);overflow:auto;position:relative;width:100%}@media print,screen and (min-width:769px){.modal-card,.modal-content{margin:0 auto;max-height:calc(100vh - 40px);width:640px}}.modal-close{background:none;height:40px;position:fixed;right:20px;top:20px;width:40px}.modal-card{display:flex;flex-direction:column;max-height:calc(100vh - 40px);overflow:hidden;-ms-overflow-y:visible}.modal-card-foot,.modal-card-head{align-items:center;background-color:#f5f5f5;display:flex;flex-shrink:0;justify-content:flex-start;padding:20px;position:relative}.modal-card-head{border-bottom:1px solid #dbdbdb;border-top-left-radius:6px;border-top-right-radius:6px}.modal-card-title{color:#363636;flex-grow:1;flex-shrink:0;font-size:1.5rem;line-height:1}.modal-card-foot{border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top:1px solid #dbdbdb}.modal-card-foot .button:not(:last-child){margin-right:.5em}.modal-card-body{-webkit-overflow-scrolling:touch;background-color:#fff;flex-grow:1;flex-shrink:1;overflow:auto;padding:20px}.navbar{background-color:#fff;min-height:3.25rem;position:relative;z-index:30}.navbar.is-white{background-color:#fff;color:#0a0a0a}.navbar.is-white .navbar-brand .navbar-link,.navbar.is-white .navbar-brand>.navbar-item{color:#0a0a0a}.navbar.is-white .navbar-brand .navbar-link.is-active,.navbar.is-white .navbar-brand .navbar-link:focus,.navbar.is-white .navbar-brand .navbar-link:hover,.navbar.is-white .navbar-brand>a.navbar-item.is-active,.navbar.is-white .navbar-brand>a.navbar-item:focus,.navbar.is-white .navbar-brand>a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.navbar.is-white .navbar-brand .navbar-link:after{border-color:#0a0a0a}.navbar.is-white .navbar-burger{color:#0a0a0a}@media screen and (min-width:1024px){.navbar.is-white .navbar-end .navbar-link,.navbar.is-white .navbar-end>.navbar-item,.navbar.is-white .navbar-start .navbar-link,.navbar.is-white .navbar-start>.navbar-item{color:#0a0a0a}.navbar.is-white .navbar-end .navbar-link.is-active,.navbar.is-white .navbar-end .navbar-link:focus,.navbar.is-white .navbar-end .navbar-link:hover,.navbar.is-white .navbar-end>a.navbar-item.is-active,.navbar.is-white .navbar-end>a.navbar-item:focus,.navbar.is-white .navbar-end>a.navbar-item:hover,.navbar.is-white .navbar-start .navbar-link.is-active,.navbar.is-white .navbar-start .navbar-link:focus,.navbar.is-white .navbar-start .navbar-link:hover,.navbar.is-white .navbar-start>a.navbar-item.is-active,.navbar.is-white .navbar-start>a.navbar-item:focus,.navbar.is-white .navbar-start>a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.navbar.is-white .navbar-end .navbar-link:after,.navbar.is-white .navbar-start .navbar-link:after{border-color:#0a0a0a}.navbar.is-white .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-white .navbar-item.has-dropdown:focus .navbar-link,.navbar.is-white .navbar-item.has-dropdown:hover .navbar-link{background-color:#f2f2f2;color:#0a0a0a}.navbar.is-white .navbar-dropdown a.navbar-item.is-active{background-color:#fff;color:#0a0a0a}}.navbar.is-black{background-color:#0a0a0a;color:#fff}.navbar.is-black .navbar-brand .navbar-link,.navbar.is-black .navbar-brand>.navbar-item{color:#fff}.navbar.is-black .navbar-brand .navbar-link.is-active,.navbar.is-black .navbar-brand .navbar-link:focus,.navbar.is-black .navbar-brand .navbar-link:hover,.navbar.is-black .navbar-brand>a.navbar-item.is-active,.navbar.is-black .navbar-brand>a.navbar-item:focus,.navbar.is-black .navbar-brand>a.navbar-item:hover{background-color:#000;color:#fff}.navbar.is-black .navbar-brand .navbar-link:after{border-color:#fff}.navbar.is-black .navbar-burger{color:#fff}@media screen and (min-width:1024px){.navbar.is-black .navbar-end .navbar-link,.navbar.is-black .navbar-end>.navbar-item,.navbar.is-black .navbar-start .navbar-link,.navbar.is-black .navbar-start>.navbar-item{color:#fff}.navbar.is-black .navbar-end .navbar-link.is-active,.navbar.is-black .navbar-end .navbar-link:focus,.navbar.is-black .navbar-end .navbar-link:hover,.navbar.is-black .navbar-end>a.navbar-item.is-active,.navbar.is-black .navbar-end>a.navbar-item:focus,.navbar.is-black .navbar-end>a.navbar-item:hover,.navbar.is-black .navbar-start .navbar-link.is-active,.navbar.is-black .navbar-start .navbar-link:focus,.navbar.is-black .navbar-start .navbar-link:hover,.navbar.is-black .navbar-start>a.navbar-item.is-active,.navbar.is-black .navbar-start>a.navbar-item:focus,.navbar.is-black .navbar-start>a.navbar-item:hover{background-color:#000;color:#fff}.navbar.is-black .navbar-end .navbar-link:after,.navbar.is-black .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-black .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-black .navbar-item.has-dropdown:focus .navbar-link,.navbar.is-black .navbar-item.has-dropdown:hover .navbar-link{background-color:#000;color:#fff}.navbar.is-black .navbar-dropdown a.navbar-item.is-active{background-color:#0a0a0a;color:#fff}}.navbar.is-light{background-color:#f5f5f5;color:#363636}.navbar.is-light .navbar-brand .navbar-link,.navbar.is-light .navbar-brand>.navbar-item{color:#363636}.navbar.is-light .navbar-brand .navbar-link.is-active,.navbar.is-light .navbar-brand .navbar-link:focus,.navbar.is-light .navbar-brand .navbar-link:hover,.navbar.is-light .navbar-brand>a.navbar-item.is-active,.navbar.is-light .navbar-brand>a.navbar-item:focus,.navbar.is-light .navbar-brand>a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.navbar.is-light .navbar-brand .navbar-link:after{border-color:#363636}.navbar.is-light .navbar-burger{color:#363636}@media screen and (min-width:1024px){.navbar.is-light .navbar-end .navbar-link,.navbar.is-light .navbar-end>.navbar-item,.navbar.is-light .navbar-start .navbar-link,.navbar.is-light .navbar-start>.navbar-item{color:#363636}.navbar.is-light .navbar-end .navbar-link.is-active,.navbar.is-light .navbar-end .navbar-link:focus,.navbar.is-light .navbar-end .navbar-link:hover,.navbar.is-light .navbar-end>a.navbar-item.is-active,.navbar.is-light .navbar-end>a.navbar-item:focus,.navbar.is-light .navbar-end>a.navbar-item:hover,.navbar.is-light .navbar-start .navbar-link.is-active,.navbar.is-light .navbar-start .navbar-link:focus,.navbar.is-light .navbar-start .navbar-link:hover,.navbar.is-light .navbar-start>a.navbar-item.is-active,.navbar.is-light .navbar-start>a.navbar-item:focus,.navbar.is-light .navbar-start>a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.navbar.is-light .navbar-end .navbar-link:after,.navbar.is-light .navbar-start .navbar-link:after{border-color:#363636}.navbar.is-light .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-light .navbar-item.has-dropdown:focus .navbar-link,.navbar.is-light .navbar-item.has-dropdown:hover .navbar-link{background-color:#e8e8e8;color:#363636}.navbar.is-light .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#363636}}.navbar.is-dark{background-color:#363636;color:#f5f5f5}.navbar.is-dark .navbar-brand .navbar-link,.navbar.is-dark .navbar-brand>.navbar-item{color:#f5f5f5}.navbar.is-dark .navbar-brand .navbar-link.is-active,.navbar.is-dark .navbar-brand .navbar-link:focus,.navbar.is-dark .navbar-brand .navbar-link:hover,.navbar.is-dark .navbar-brand>a.navbar-item.is-active,.navbar.is-dark .navbar-brand>a.navbar-item:focus,.navbar.is-dark .navbar-brand>a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.navbar.is-dark .navbar-brand .navbar-link:after{border-color:#f5f5f5}.navbar.is-dark .navbar-burger{color:#f5f5f5}@media screen and (min-width:1024px){.navbar.is-dark .navbar-end .navbar-link,.navbar.is-dark .navbar-end>.navbar-item,.navbar.is-dark .navbar-start .navbar-link,.navbar.is-dark .navbar-start>.navbar-item{color:#f5f5f5}.navbar.is-dark .navbar-end .navbar-link.is-active,.navbar.is-dark .navbar-end .navbar-link:focus,.navbar.is-dark .navbar-end .navbar-link:hover,.navbar.is-dark .navbar-end>a.navbar-item.is-active,.navbar.is-dark .navbar-end>a.navbar-item:focus,.navbar.is-dark .navbar-end>a.navbar-item:hover,.navbar.is-dark .navbar-start .navbar-link.is-active,.navbar.is-dark .navbar-start .navbar-link:focus,.navbar.is-dark .navbar-start .navbar-link:hover,.navbar.is-dark .navbar-start>a.navbar-item.is-active,.navbar.is-dark .navbar-start>a.navbar-item:focus,.navbar.is-dark .navbar-start>a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.navbar.is-dark .navbar-end .navbar-link:after,.navbar.is-dark .navbar-start .navbar-link:after{border-color:#f5f5f5}.navbar.is-dark .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-dark .navbar-item.has-dropdown:focus .navbar-link,.navbar.is-dark .navbar-item.has-dropdown:hover .navbar-link{background-color:#292929;color:#f5f5f5}.navbar.is-dark .navbar-dropdown a.navbar-item.is-active{background-color:#363636;color:#f5f5f5}}.navbar.is-primary{background-color:#7957d5;color:#fff}.navbar.is-primary .navbar-brand .navbar-link,.navbar.is-primary .navbar-brand>.navbar-item{color:#fff}.navbar.is-primary .navbar-brand .navbar-link.is-active,.navbar.is-primary .navbar-brand .navbar-link:focus,.navbar.is-primary .navbar-brand .navbar-link:hover,.navbar.is-primary .navbar-brand>a.navbar-item.is-active,.navbar.is-primary .navbar-brand>a.navbar-item:focus,.navbar.is-primary .navbar-brand>a.navbar-item:hover{background-color:#6943d0;color:#fff}.navbar.is-primary .navbar-brand .navbar-link:after{border-color:#fff}.navbar.is-primary .navbar-burger{color:#fff}@media screen and (min-width:1024px){.navbar.is-primary .navbar-end .navbar-link,.navbar.is-primary .navbar-end>.navbar-item,.navbar.is-primary .navbar-start .navbar-link,.navbar.is-primary .navbar-start>.navbar-item{color:#fff}.navbar.is-primary .navbar-end .navbar-link.is-active,.navbar.is-primary .navbar-end .navbar-link:focus,.navbar.is-primary .navbar-end .navbar-link:hover,.navbar.is-primary .navbar-end>a.navbar-item.is-active,.navbar.is-primary .navbar-end>a.navbar-item:focus,.navbar.is-primary .navbar-end>a.navbar-item:hover,.navbar.is-primary .navbar-start .navbar-link.is-active,.navbar.is-primary .navbar-start .navbar-link:focus,.navbar.is-primary .navbar-start .navbar-link:hover,.navbar.is-primary .navbar-start>a.navbar-item.is-active,.navbar.is-primary .navbar-start>a.navbar-item:focus,.navbar.is-primary .navbar-start>a.navbar-item:hover{background-color:#6943d0;color:#fff}.navbar.is-primary .navbar-end .navbar-link:after,.navbar.is-primary .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-primary .navbar-item.has-dropdown:focus .navbar-link,.navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link{background-color:#6943d0;color:#fff}.navbar.is-primary .navbar-dropdown a.navbar-item.is-active{background-color:#7957d5;color:#fff}}.navbar.is-link{background-color:#7957d5;color:#fff}.navbar.is-link .navbar-brand .navbar-link,.navbar.is-link .navbar-brand>.navbar-item{color:#fff}.navbar.is-link .navbar-brand .navbar-link.is-active,.navbar.is-link .navbar-brand .navbar-link:focus,.navbar.is-link .navbar-brand .navbar-link:hover,.navbar.is-link .navbar-brand>a.navbar-item.is-active,.navbar.is-link .navbar-brand>a.navbar-item:focus,.navbar.is-link .navbar-brand>a.navbar-item:hover{background-color:#6943d0;color:#fff}.navbar.is-link .navbar-brand .navbar-link:after{border-color:#fff}.navbar.is-link .navbar-burger{color:#fff}@media screen and (min-width:1024px){.navbar.is-link .navbar-end .navbar-link,.navbar.is-link .navbar-end>.navbar-item,.navbar.is-link .navbar-start .navbar-link,.navbar.is-link .navbar-start>.navbar-item{color:#fff}.navbar.is-link .navbar-end .navbar-link.is-active,.navbar.is-link .navbar-end .navbar-link:focus,.navbar.is-link .navbar-end .navbar-link:hover,.navbar.is-link .navbar-end>a.navbar-item.is-active,.navbar.is-link .navbar-end>a.navbar-item:focus,.navbar.is-link .navbar-end>a.navbar-item:hover,.navbar.is-link .navbar-start .navbar-link.is-active,.navbar.is-link .navbar-start .navbar-link:focus,.navbar.is-link .navbar-start .navbar-link:hover,.navbar.is-link .navbar-start>a.navbar-item.is-active,.navbar.is-link .navbar-start>a.navbar-item:focus,.navbar.is-link .navbar-start>a.navbar-item:hover{background-color:#6943d0;color:#fff}.navbar.is-link .navbar-end .navbar-link:after,.navbar.is-link .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-link .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-link .navbar-item.has-dropdown:focus .navbar-link,.navbar.is-link .navbar-item.has-dropdown:hover .navbar-link{background-color:#6943d0;color:#fff}.navbar.is-link .navbar-dropdown a.navbar-item.is-active{background-color:#7957d5;color:#fff}}.navbar.is-info{background-color:#167df0;color:#fff}.navbar.is-info .navbar-brand .navbar-link,.navbar.is-info .navbar-brand>.navbar-item{color:#fff}.navbar.is-info .navbar-brand .navbar-link.is-active,.navbar.is-info .navbar-brand .navbar-link:focus,.navbar.is-info .navbar-brand .navbar-link:hover,.navbar.is-info .navbar-brand>a.navbar-item.is-active,.navbar.is-info .navbar-brand>a.navbar-item:focus,.navbar.is-info .navbar-brand>a.navbar-item:hover{background-color:#0e71de;color:#fff}.navbar.is-info .navbar-brand .navbar-link:after{border-color:#fff}.navbar.is-info .navbar-burger{color:#fff}@media screen and (min-width:1024px){.navbar.is-info .navbar-end .navbar-link,.navbar.is-info .navbar-end>.navbar-item,.navbar.is-info .navbar-start .navbar-link,.navbar.is-info .navbar-start>.navbar-item{color:#fff}.navbar.is-info .navbar-end .navbar-link.is-active,.navbar.is-info .navbar-end .navbar-link:focus,.navbar.is-info .navbar-end .navbar-link:hover,.navbar.is-info .navbar-end>a.navbar-item.is-active,.navbar.is-info .navbar-end>a.navbar-item:focus,.navbar.is-info .navbar-end>a.navbar-item:hover,.navbar.is-info .navbar-start .navbar-link.is-active,.navbar.is-info .navbar-start .navbar-link:focus,.navbar.is-info .navbar-start .navbar-link:hover,.navbar.is-info .navbar-start>a.navbar-item.is-active,.navbar.is-info .navbar-start>a.navbar-item:focus,.navbar.is-info .navbar-start>a.navbar-item:hover{background-color:#0e71de;color:#fff}.navbar.is-info .navbar-end .navbar-link:after,.navbar.is-info .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-info .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-info .navbar-item.has-dropdown:focus .navbar-link,.navbar.is-info .navbar-item.has-dropdown:hover .navbar-link{background-color:#0e71de;color:#fff}.navbar.is-info .navbar-dropdown a.navbar-item.is-active{background-color:#167df0;color:#fff}}.navbar.is-success{background-color:#23d160;color:#fff}.navbar.is-success .navbar-brand .navbar-link,.navbar.is-success .navbar-brand>.navbar-item{color:#fff}.navbar.is-success .navbar-brand .navbar-link.is-active,.navbar.is-success .navbar-brand .navbar-link:focus,.navbar.is-success .navbar-brand .navbar-link:hover,.navbar.is-success .navbar-brand>a.navbar-item.is-active,.navbar.is-success .navbar-brand>a.navbar-item:focus,.navbar.is-success .navbar-brand>a.navbar-item:hover{background-color:#20bc56;color:#fff}.navbar.is-success .navbar-brand .navbar-link:after{border-color:#fff}.navbar.is-success .navbar-burger{color:#fff}@media screen and (min-width:1024px){.navbar.is-success .navbar-end .navbar-link,.navbar.is-success .navbar-end>.navbar-item,.navbar.is-success .navbar-start .navbar-link,.navbar.is-success .navbar-start>.navbar-item{color:#fff}.navbar.is-success .navbar-end .navbar-link.is-active,.navbar.is-success .navbar-end .navbar-link:focus,.navbar.is-success .navbar-end .navbar-link:hover,.navbar.is-success .navbar-end>a.navbar-item.is-active,.navbar.is-success .navbar-end>a.navbar-item:focus,.navbar.is-success .navbar-end>a.navbar-item:hover,.navbar.is-success .navbar-start .navbar-link.is-active,.navbar.is-success .navbar-start .navbar-link:focus,.navbar.is-success .navbar-start .navbar-link:hover,.navbar.is-success .navbar-start>a.navbar-item.is-active,.navbar.is-success .navbar-start>a.navbar-item:focus,.navbar.is-success .navbar-start>a.navbar-item:hover{background-color:#20bc56;color:#fff}.navbar.is-success .navbar-end .navbar-link:after,.navbar.is-success .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-success .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-success .navbar-item.has-dropdown:focus .navbar-link,.navbar.is-success .navbar-item.has-dropdown:hover .navbar-link{background-color:#20bc56;color:#fff}.navbar.is-success .navbar-dropdown a.navbar-item.is-active{background-color:#23d160;color:#fff}}.navbar.is-warning{background-color:#ffdd57}.navbar.is-warning,.navbar.is-warning .navbar-brand .navbar-link,.navbar.is-warning .navbar-brand>.navbar-item{color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-brand .navbar-link.is-active,.navbar.is-warning .navbar-brand .navbar-link:focus,.navbar.is-warning .navbar-brand .navbar-link:hover,.navbar.is-warning .navbar-brand>a.navbar-item.is-active,.navbar.is-warning .navbar-brand>a.navbar-item:focus,.navbar.is-warning .navbar-brand>a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-brand .navbar-link:after{border-color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-burger{color:rgba(0,0,0,.7)}@media screen and (min-width:1024px){.navbar.is-warning .navbar-end .navbar-link,.navbar.is-warning .navbar-end>.navbar-item,.navbar.is-warning .navbar-start .navbar-link,.navbar.is-warning .navbar-start>.navbar-item{color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-end .navbar-link.is-active,.navbar.is-warning .navbar-end .navbar-link:focus,.navbar.is-warning .navbar-end .navbar-link:hover,.navbar.is-warning .navbar-end>a.navbar-item.is-active,.navbar.is-warning .navbar-end>a.navbar-item:focus,.navbar.is-warning .navbar-end>a.navbar-item:hover,.navbar.is-warning .navbar-start .navbar-link.is-active,.navbar.is-warning .navbar-start .navbar-link:focus,.navbar.is-warning .navbar-start .navbar-link:hover,.navbar.is-warning .navbar-start>a.navbar-item.is-active,.navbar.is-warning .navbar-start>a.navbar-item:focus,.navbar.is-warning .navbar-start>a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-end .navbar-link:after,.navbar.is-warning .navbar-start .navbar-link:after{border-color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-warning .navbar-item.has-dropdown:focus .navbar-link,.navbar.is-warning .navbar-item.has-dropdown:hover .navbar-link{background-color:#ffd83d;color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-dropdown a.navbar-item.is-active{background-color:#ffdd57;color:rgba(0,0,0,.7)}}.navbar.is-danger{background-color:#ff3860;color:#fff}.navbar.is-danger .navbar-brand .navbar-link,.navbar.is-danger .navbar-brand>.navbar-item{color:#fff}.navbar.is-danger .navbar-brand .navbar-link.is-active,.navbar.is-danger .navbar-brand .navbar-link:focus,.navbar.is-danger .navbar-brand .navbar-link:hover,.navbar.is-danger .navbar-brand>a.navbar-item.is-active,.navbar.is-danger .navbar-brand>a.navbar-item:focus,.navbar.is-danger .navbar-brand>a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.navbar.is-danger .navbar-brand .navbar-link:after{border-color:#fff}.navbar.is-danger .navbar-burger{color:#fff}@media screen and (min-width:1024px){.navbar.is-danger .navbar-end .navbar-link,.navbar.is-danger .navbar-end>.navbar-item,.navbar.is-danger .navbar-start .navbar-link,.navbar.is-danger .navbar-start>.navbar-item{color:#fff}.navbar.is-danger .navbar-end .navbar-link.is-active,.navbar.is-danger .navbar-end .navbar-link:focus,.navbar.is-danger .navbar-end .navbar-link:hover,.navbar.is-danger .navbar-end>a.navbar-item.is-active,.navbar.is-danger .navbar-end>a.navbar-item:focus,.navbar.is-danger .navbar-end>a.navbar-item:hover,.navbar.is-danger .navbar-start .navbar-link.is-active,.navbar.is-danger .navbar-start .navbar-link:focus,.navbar.is-danger .navbar-start .navbar-link:hover,.navbar.is-danger .navbar-start>a.navbar-item.is-active,.navbar.is-danger .navbar-start>a.navbar-item:focus,.navbar.is-danger .navbar-start>a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.navbar.is-danger .navbar-end .navbar-link:after,.navbar.is-danger .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-danger .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-danger .navbar-item.has-dropdown:focus .navbar-link,.navbar.is-danger .navbar-item.has-dropdown:hover .navbar-link{background-color:#ff1f4b;color:#fff}.navbar.is-danger .navbar-dropdown a.navbar-item.is-active{background-color:#ff3860;color:#fff}}.navbar>.container{align-items:stretch;display:flex;min-height:3.25rem;width:100%}.navbar.has-shadow{box-shadow:0 2px 0 0 #f5f5f5}.navbar.is-fixed-bottom,.navbar.is-fixed-top{left:0;position:fixed;right:0;z-index:30}.navbar.is-fixed-bottom{bottom:0}.navbar.is-fixed-bottom.has-shadow{box-shadow:0 -2px 0 0 #f5f5f5}.navbar.is-fixed-top{top:0}body.has-navbar-fixed-top,html.has-navbar-fixed-top{padding-top:3.25rem}body.has-navbar-fixed-bottom,html.has-navbar-fixed-bottom{padding-bottom:3.25rem}.navbar-brand,.navbar-tabs{align-items:stretch;display:flex;flex-shrink:0;min-height:3.25rem}.navbar-brand a.navbar-item:focus,.navbar-brand a.navbar-item:hover{background-color:transparent}.navbar-tabs{-webkit-overflow-scrolling:touch;max-width:100vw;overflow-x:auto;overflow-y:hidden}.navbar-burger{color:#4a4a4a;cursor:pointer;display:block;height:3.25rem;position:relative;width:3.25rem;margin-left:auto}.navbar-burger span{background-color:currentColor;display:block;height:1px;left:calc(50% - 8px);position:absolute;transform-origin:center;transition-duration:86ms;transition-property:background-color,opacity,transform;transition-timing-function:ease-out;width:16px}.navbar-burger span:first-child{top:calc(50% - 6px)}.navbar-burger span:nth-child(2){top:calc(50% - 1px)}.navbar-burger span:nth-child(3){top:calc(50% + 4px)}.navbar-burger:hover{background-color:rgba(0,0,0,.05)}.navbar-burger.is-active span:first-child{transform:translateY(5px) rotate(45deg)}.navbar-burger.is-active span:nth-child(2){opacity:0}.navbar-burger.is-active span:nth-child(3){transform:translateY(-5px) rotate(-45deg)}.navbar-menu{display:none}.navbar-item,.navbar-link{color:#4a4a4a;display:block;line-height:1.5;padding:.5rem .75rem;position:relative}.navbar-item .icon:only-child,.navbar-link .icon:only-child{margin-left:-.25rem;margin-right:-.25rem}.navbar-link,a.navbar-item{cursor:pointer}.navbar-link.is-active,.navbar-link:focus,.navbar-link:focus-within,.navbar-link:hover,a.navbar-item.is-active,a.navbar-item:focus,a.navbar-item:focus-within,a.navbar-item:hover{background-color:#fafafa;color:#7957d5}.navbar-item{display:block;flex-grow:0;flex-shrink:0}.navbar-item img{max-height:1.75rem}.navbar-item.has-dropdown{padding:0}.navbar-item.is-expanded{flex-grow:1;flex-shrink:1}.navbar-item.is-tab{border-bottom:1px solid transparent;min-height:3.25rem;padding-bottom:calc(.5rem - 1px)}.navbar-item.is-tab.is-active,.navbar-item.is-tab:focus,.navbar-item.is-tab:hover{background-color:transparent;border-bottom-color:#7957d5}.navbar-item.is-tab.is-active{border-bottom-style:solid;border-bottom-width:3px;color:#7957d5;padding-bottom:calc(.5rem - 3px)}.navbar-content{flex-grow:1;flex-shrink:1}.navbar-link:not(.is-arrowless){padding-right:2.5em}.navbar-link:not(.is-arrowless):after{border-color:#7957d5;margin-top:-.375em;right:1.125em}.navbar-dropdown{font-size:.875rem;padding-bottom:.5rem;padding-top:.5rem}.navbar-dropdown .navbar-item{padding-left:1.5rem;padding-right:1.5rem}.navbar-divider{background-color:#f5f5f5;border:none;display:none;height:2px;margin:.5rem 0}@media screen and (max-width:1023px){.navbar>.container{display:block}.navbar-brand .navbar-item,.navbar-tabs .navbar-item{align-items:center;display:flex}.navbar-link:after{display:none}.navbar-menu{background-color:#fff;box-shadow:0 8px 16px hsla(0,0%,4%,.1);padding:.5rem 0}.navbar-menu.is-active{display:block}.navbar.is-fixed-bottom-touch,.navbar.is-fixed-top-touch{left:0;position:fixed;right:0;z-index:30}.navbar.is-fixed-bottom-touch{bottom:0}.navbar.is-fixed-bottom-touch.has-shadow{box-shadow:0 -2px 3px hsla(0,0%,4%,.1)}.navbar.is-fixed-top-touch{top:0}.navbar.is-fixed-top-touch .navbar-menu,.navbar.is-fixed-top .navbar-menu{-webkit-overflow-scrolling:touch;max-height:calc(100vh - 3.25rem);overflow:auto}body.has-navbar-fixed-top-touch,html.has-navbar-fixed-top-touch{padding-top:3.25rem}body.has-navbar-fixed-bottom-touch,html.has-navbar-fixed-bottom-touch{padding-bottom:3.25rem}}@media screen and (min-width:1024px){.navbar,.navbar-end,.navbar-menu,.navbar-start{align-items:stretch;display:flex}.navbar{min-height:3.25rem}.navbar.is-spaced{padding:1rem 2rem}.navbar.is-spaced .navbar-end,.navbar.is-spaced .navbar-start{align-items:center}.navbar.is-spaced .navbar-link,.navbar.is-spaced a.navbar-item{border-radius:4px}.navbar.is-transparent .navbar-link.is-active,.navbar.is-transparent .navbar-link:focus,.navbar.is-transparent .navbar-link:hover,.navbar.is-transparent a.navbar-item.is-active,.navbar.is-transparent a.navbar-item:focus,.navbar.is-transparent a.navbar-item:hover{background-color:transparent!important}.navbar.is-transparent .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:focus-within .navbar-link,.navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:focus .navbar-link,.navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:hover .navbar-link{background-color:transparent!important}.navbar.is-transparent .navbar-dropdown a.navbar-item:focus,.navbar.is-transparent .navbar-dropdown a.navbar-item:hover{background-color:#f5f5f5;color:#0a0a0a}.navbar.is-transparent .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#7957d5}.navbar-burger{display:none}.navbar-item,.navbar-link{align-items:center;display:flex}.navbar-item{display:flex}.navbar-item.has-dropdown{align-items:stretch}.navbar-item.has-dropdown-up .navbar-link:after{transform:rotate(135deg) translate(.25em,-.25em)}.navbar-item.has-dropdown-up .navbar-dropdown{border-bottom:2px solid #dbdbdb;border-radius:6px 6px 0 0;border-top:none;bottom:100%;box-shadow:0 -8px 8px hsla(0,0%,4%,.1);top:auto}.navbar-item.is-active .navbar-dropdown,.navbar-item.is-hoverable:focus-within .navbar-dropdown,.navbar-item.is-hoverable:focus .navbar-dropdown,.navbar-item.is-hoverable:hover .navbar-dropdown{display:block}.navbar-item.is-active .navbar-dropdown.is-boxed,.navbar-item.is-hoverable:focus-within .navbar-dropdown.is-boxed,.navbar-item.is-hoverable:focus .navbar-dropdown.is-boxed,.navbar-item.is-hoverable:hover .navbar-dropdown.is-boxed,.navbar.is-spaced .navbar-item.is-active .navbar-dropdown,.navbar.is-spaced .navbar-item.is-hoverable:focus-within .navbar-dropdown,.navbar.is-spaced .navbar-item.is-hoverable:focus .navbar-dropdown,.navbar.is-spaced .navbar-item.is-hoverable:hover .navbar-dropdown{opacity:1;pointer-events:auto;transform:translateY(0)}.navbar-menu{flex-grow:1;flex-shrink:0}.navbar-start{justify-content:flex-start;margin-right:auto}.navbar-end{justify-content:flex-end;margin-left:auto}.navbar-dropdown{background-color:#fff;border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top:2px solid #dbdbdb;box-shadow:0 8px 8px hsla(0,0%,4%,.1);display:none;font-size:.875rem;left:0;min-width:100%;position:absolute;top:100%;z-index:20}.navbar-dropdown .navbar-item{padding:.375rem 1rem;white-space:nowrap}.navbar-dropdown a.navbar-item{padding-right:3rem}.navbar-dropdown a.navbar-item:focus,.navbar-dropdown a.navbar-item:hover{background-color:#f5f5f5;color:#0a0a0a}.navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#7957d5}.navbar-dropdown.is-boxed,.navbar.is-spaced .navbar-dropdown{border-radius:6px;border-top:none;box-shadow:0 8px 8px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);display:block;opacity:0;pointer-events:none;top:calc(100% + -4px);transform:translateY(-5px);transition-duration:86ms;transition-property:opacity,transform}.navbar-dropdown.is-right{left:auto;right:0}.navbar-divider{display:block}.container>.navbar .navbar-brand,.navbar>.container .navbar-brand{margin-left:-.75rem}.container>.navbar .navbar-menu,.navbar>.container .navbar-menu{margin-right:-.75rem}.navbar.is-fixed-bottom-desktop,.navbar.is-fixed-top-desktop{left:0;position:fixed;right:0;z-index:30}.navbar.is-fixed-bottom-desktop{bottom:0}.navbar.is-fixed-bottom-desktop.has-shadow{box-shadow:0 -2px 3px hsla(0,0%,4%,.1)}.navbar.is-fixed-top-desktop{top:0}body.has-navbar-fixed-top-desktop,html.has-navbar-fixed-top-desktop{padding-top:3.25rem}body.has-navbar-fixed-bottom-desktop,html.has-navbar-fixed-bottom-desktop{padding-bottom:3.25rem}body.has-spaced-navbar-fixed-top,html.has-spaced-navbar-fixed-top{padding-top:5.25rem}body.has-spaced-navbar-fixed-bottom,html.has-spaced-navbar-fixed-bottom{padding-bottom:5.25rem}.navbar-link.is-active,a.navbar-item.is-active{color:#0a0a0a}.navbar-link.is-active:not(:focus):not(:hover),a.navbar-item.is-active:not(:focus):not(:hover){background-color:transparent}.navbar-item.has-dropdown.is-active .navbar-link,.navbar-item.has-dropdown:focus .navbar-link,.navbar-item.has-dropdown:hover .navbar-link{background-color:#fafafa}}.hero.is-fullheight-with-navbar{min-height:calc(100vh - 3.25rem)}.pagination{font-size:1rem;margin:-.25rem}.pagination.is-small{font-size:.75rem}.pagination.is-medium{font-size:1.25rem}.pagination.is-large{font-size:1.5rem}.pagination.is-rounded .pagination-next,.pagination.is-rounded .pagination-previous{padding-left:1em;padding-right:1em;border-radius:290486px}.pagination.is-rounded .pagination-link{border-radius:290486px}.pagination,.pagination-list{align-items:center;display:flex;justify-content:center;text-align:center}.pagination-ellipsis,.pagination-link,.pagination-next,.pagination-previous{font-size:1em;justify-content:center;margin:.25rem;padding-left:.5em;padding-right:.5em;text-align:center}.pagination-link,.pagination-next,.pagination-previous{border-color:#dbdbdb;color:#363636;min-width:2.25em}.pagination-link:hover,.pagination-next:hover,.pagination-previous:hover{border-color:#b5b5b5;color:#363636}.pagination-link:focus,.pagination-next:focus,.pagination-previous:focus{border-color:#7957d5}.pagination-link:active,.pagination-next:active,.pagination-previous:active{box-shadow:inset 0 1px 2px hsla(0,0%,4%,.2)}.pagination-link[disabled],.pagination-next[disabled],.pagination-previous[disabled]{background-color:#dbdbdb;border-color:#dbdbdb;box-shadow:none;color:#7a7a7a;opacity:.5}.pagination-next,.pagination-previous{padding-left:.75em;padding-right:.75em;white-space:nowrap}.pagination-link.is-current{background-color:#7957d5;border-color:#7957d5;color:#fff}.pagination-ellipsis{color:#b5b5b5;pointer-events:none}.pagination-list{flex-wrap:wrap}@media screen and (max-width:768px){.pagination{flex-wrap:wrap}.pagination-list li,.pagination-next,.pagination-previous{flex-grow:1;flex-shrink:1}}@media print,screen and (min-width:769px){.pagination-list{flex-grow:1;flex-shrink:1;justify-content:flex-start;order:1}.pagination-previous{order:2}.pagination-next{order:3}.pagination{justify-content:space-between}.pagination.is-centered .pagination-previous{order:1}.pagination.is-centered .pagination-list{justify-content:center;order:2}.pagination.is-centered .pagination-next{order:3}.pagination.is-right .pagination-previous{order:1}.pagination.is-right .pagination-next{order:2}.pagination.is-right .pagination-list{justify-content:flex-end;order:3}}.panel{font-size:1rem}.panel:not(:last-child){margin-bottom:1.5rem}.panel-block,.panel-heading,.panel-tabs{border-bottom:1px solid #dbdbdb;border-left:1px solid #dbdbdb;border-right:1px solid #dbdbdb}.panel-block:first-child,.panel-heading:first-child,.panel-tabs:first-child{border-top:1px solid #dbdbdb}.panel-heading{background-color:#f5f5f5;border-radius:4px 4px 0 0;color:#363636;font-size:1.25em;font-weight:300;line-height:1.25;padding:.5em .75em}.panel-tabs{align-items:flex-end;display:flex;font-size:.875em;justify-content:center}.panel-tabs a{border-bottom:1px solid #dbdbdb;margin-bottom:-1px;padding:.5em}.panel-tabs a.is-active{border-bottom-color:#4a4a4a;color:#363636}.panel-list a{color:#4a4a4a}.panel-list a:hover{color:#7957d5}.panel-block{align-items:center;color:#363636;display:flex;justify-content:flex-start;padding:.5em .75em}.panel-block input[type=checkbox]{margin-right:.75em}.panel-block>.control{flex-grow:1;flex-shrink:1;width:100%}.panel-block.is-wrapped{flex-wrap:wrap}.panel-block.is-active{border-left-color:#7957d5;color:#363636}.panel-block.is-active .panel-icon{color:#7957d5}a.panel-block,label.panel-block{cursor:pointer}a.panel-block:hover,label.panel-block:hover{background-color:#f5f5f5}.panel-icon{display:inline-block;font-size:14px;height:1em;line-height:1em;text-align:center;vertical-align:top;width:1em;color:#7a7a7a;margin-right:.75em}.panel-icon .fa{font-size:inherit;line-height:inherit}.tabs{-webkit-overflow-scrolling:touch;align-items:stretch;display:flex;font-size:1rem;justify-content:space-between;overflow:hidden;overflow-x:auto;white-space:nowrap}.tabs a{align-items:center;border-bottom-color:#dbdbdb;border-bottom-style:solid;border-bottom-width:1px;color:#4a4a4a;display:flex;justify-content:center;margin-bottom:-1px;padding:.5em 1em;vertical-align:top}.tabs a:hover{border-bottom-color:#363636;color:#363636}.tabs li{display:block}.tabs li.is-active a{border-bottom-color:#7957d5;color:#7957d5}.tabs ul{align-items:center;border-bottom-color:#dbdbdb;border-bottom-style:solid;border-bottom-width:1px;display:flex;flex-grow:1;flex-shrink:0;justify-content:flex-start}.tabs ul.is-center,.tabs ul.is-left{padding-right:.75em}.tabs ul.is-center{flex:none;justify-content:center;padding-left:.75em}.tabs ul.is-right{justify-content:flex-end;padding-left:.75em}.tabs .icon:first-child{margin-right:.5em}.tabs .icon:last-child{margin-left:.5em}.tabs.is-centered ul{justify-content:center}.tabs.is-right ul{justify-content:flex-end}.tabs.is-boxed a{border:1px solid transparent;border-radius:4px 4px 0 0}.tabs.is-boxed a:hover{background-color:#f5f5f5;border-bottom-color:#dbdbdb}.tabs.is-boxed li.is-active a{background-color:#fff;border-color:#dbdbdb;border-bottom-color:transparent!important}.tabs.is-fullwidth li{flex-grow:1;flex-shrink:0}.tabs.is-toggle a{border:1px solid #dbdbdb;margin-bottom:0;position:relative}.tabs.is-toggle a:hover{background-color:#f5f5f5;border-color:#b5b5b5;z-index:2}.tabs.is-toggle li+li{margin-left:-1px}.tabs.is-toggle li:first-child a{border-radius:4px 0 0 4px}.tabs.is-toggle li:last-child a{border-radius:0 4px 4px 0}.tabs.is-toggle li.is-active a{background-color:#7957d5;border-color:#7957d5;color:#fff;z-index:1}.tabs.is-toggle ul{border-bottom:none}.tabs.is-toggle.is-toggle-rounded li:first-child a{border-bottom-left-radius:290486px;border-top-left-radius:290486px;padding-left:1.25em}.tabs.is-toggle.is-toggle-rounded li:last-child a{border-bottom-right-radius:290486px;border-top-right-radius:290486px;padding-right:1.25em}.tabs.is-small{font-size:.75rem}.tabs.is-medium{font-size:1.25rem}.tabs.is-large{font-size:1.5rem}.column{display:block;flex-basis:0;flex-grow:1;flex-shrink:1;padding:.75rem}.columns.is-mobile>.column.is-narrow{flex:none}.columns.is-mobile>.column.is-full{flex:none;width:100%}.columns.is-mobile>.column.is-three-quarters{flex:none;width:75%}.columns.is-mobile>.column.is-two-thirds{flex:none;width:66.6666%}.columns.is-mobile>.column.is-half{flex:none;width:50%}.columns.is-mobile>.column.is-one-third{flex:none;width:33.3333%}.columns.is-mobile>.column.is-one-quarter{flex:none;width:25%}.columns.is-mobile>.column.is-one-fifth{flex:none;width:20%}.columns.is-mobile>.column.is-two-fifths{flex:none;width:40%}.columns.is-mobile>.column.is-three-fifths{flex:none;width:60%}.columns.is-mobile>.column.is-four-fifths{flex:none;width:80%}.columns.is-mobile>.column.is-offset-three-quarters{margin-left:75%}.columns.is-mobile>.column.is-offset-two-thirds{margin-left:66.6666%}.columns.is-mobile>.column.is-offset-half{margin-left:50%}.columns.is-mobile>.column.is-offset-one-third{margin-left:33.3333%}.columns.is-mobile>.column.is-offset-one-quarter{margin-left:25%}.columns.is-mobile>.column.is-offset-one-fifth{margin-left:20%}.columns.is-mobile>.column.is-offset-two-fifths{margin-left:40%}.columns.is-mobile>.column.is-offset-three-fifths{margin-left:60%}.columns.is-mobile>.column.is-offset-four-fifths{margin-left:80%}.columns.is-mobile>.column.is-0{flex:none;width:0}.columns.is-mobile>.column.is-offset-0{margin-left:0}.columns.is-mobile>.column.is-1{flex:none;width:8.33333%}.columns.is-mobile>.column.is-offset-1{margin-left:8.33333%}.columns.is-mobile>.column.is-2{flex:none;width:16.66667%}.columns.is-mobile>.column.is-offset-2{margin-left:16.66667%}.columns.is-mobile>.column.is-3{flex:none;width:25%}.columns.is-mobile>.column.is-offset-3{margin-left:25%}.columns.is-mobile>.column.is-4{flex:none;width:33.33333%}.columns.is-mobile>.column.is-offset-4{margin-left:33.33333%}.columns.is-mobile>.column.is-5{flex:none;width:41.66667%}.columns.is-mobile>.column.is-offset-5{margin-left:41.66667%}.columns.is-mobile>.column.is-6{flex:none;width:50%}.columns.is-mobile>.column.is-offset-6{margin-left:50%}.columns.is-mobile>.column.is-7{flex:none;width:58.33333%}.columns.is-mobile>.column.is-offset-7{margin-left:58.33333%}.columns.is-mobile>.column.is-8{flex:none;width:66.66667%}.columns.is-mobile>.column.is-offset-8{margin-left:66.66667%}.columns.is-mobile>.column.is-9{flex:none;width:75%}.columns.is-mobile>.column.is-offset-9{margin-left:75%}.columns.is-mobile>.column.is-10{flex:none;width:83.33333%}.columns.is-mobile>.column.is-offset-10{margin-left:83.33333%}.columns.is-mobile>.column.is-11{flex:none;width:91.66667%}.columns.is-mobile>.column.is-offset-11{margin-left:91.66667%}.columns.is-mobile>.column.is-12{flex:none;width:100%}.columns.is-mobile>.column.is-offset-12{margin-left:100%}@media screen and (max-width:768px){.column.is-narrow-mobile{flex:none}.column.is-full-mobile{flex:none;width:100%}.column.is-three-quarters-mobile{flex:none;width:75%}.column.is-two-thirds-mobile{flex:none;width:66.6666%}.column.is-half-mobile{flex:none;width:50%}.column.is-one-third-mobile{flex:none;width:33.3333%}.column.is-one-quarter-mobile{flex:none;width:25%}.column.is-one-fifth-mobile{flex:none;width:20%}.column.is-two-fifths-mobile{flex:none;width:40%}.column.is-three-fifths-mobile{flex:none;width:60%}.column.is-four-fifths-mobile{flex:none;width:80%}.column.is-offset-three-quarters-mobile{margin-left:75%}.column.is-offset-two-thirds-mobile{margin-left:66.6666%}.column.is-offset-half-mobile{margin-left:50%}.column.is-offset-one-third-mobile{margin-left:33.3333%}.column.is-offset-one-quarter-mobile{margin-left:25%}.column.is-offset-one-fifth-mobile{margin-left:20%}.column.is-offset-two-fifths-mobile{margin-left:40%}.column.is-offset-three-fifths-mobile{margin-left:60%}.column.is-offset-four-fifths-mobile{margin-left:80%}.column.is-0-mobile{flex:none;width:0}.column.is-offset-0-mobile{margin-left:0}.column.is-1-mobile{flex:none;width:8.33333%}.column.is-offset-1-mobile{margin-left:8.33333%}.column.is-2-mobile{flex:none;width:16.66667%}.column.is-offset-2-mobile{margin-left:16.66667%}.column.is-3-mobile{flex:none;width:25%}.column.is-offset-3-mobile{margin-left:25%}.column.is-4-mobile{flex:none;width:33.33333%}.column.is-offset-4-mobile{margin-left:33.33333%}.column.is-5-mobile{flex:none;width:41.66667%}.column.is-offset-5-mobile{margin-left:41.66667%}.column.is-6-mobile{flex:none;width:50%}.column.is-offset-6-mobile{margin-left:50%}.column.is-7-mobile{flex:none;width:58.33333%}.column.is-offset-7-mobile{margin-left:58.33333%}.column.is-8-mobile{flex:none;width:66.66667%}.column.is-offset-8-mobile{margin-left:66.66667%}.column.is-9-mobile{flex:none;width:75%}.column.is-offset-9-mobile{margin-left:75%}.column.is-10-mobile{flex:none;width:83.33333%}.column.is-offset-10-mobile{margin-left:83.33333%}.column.is-11-mobile{flex:none;width:91.66667%}.column.is-offset-11-mobile{margin-left:91.66667%}.column.is-12-mobile{flex:none;width:100%}.column.is-offset-12-mobile{margin-left:100%}}@media print,screen and (min-width:769px){.column.is-narrow,.column.is-narrow-tablet{flex:none}.column.is-full,.column.is-full-tablet{flex:none;width:100%}.column.is-three-quarters,.column.is-three-quarters-tablet{flex:none;width:75%}.column.is-two-thirds,.column.is-two-thirds-tablet{flex:none;width:66.6666%}.column.is-half,.column.is-half-tablet{flex:none;width:50%}.column.is-one-third,.column.is-one-third-tablet{flex:none;width:33.3333%}.column.is-one-quarter,.column.is-one-quarter-tablet{flex:none;width:25%}.column.is-one-fifth,.column.is-one-fifth-tablet{flex:none;width:20%}.column.is-two-fifths,.column.is-two-fifths-tablet{flex:none;width:40%}.column.is-three-fifths,.column.is-three-fifths-tablet{flex:none;width:60%}.column.is-four-fifths,.column.is-four-fifths-tablet{flex:none;width:80%}.column.is-offset-three-quarters,.column.is-offset-three-quarters-tablet{margin-left:75%}.column.is-offset-two-thirds,.column.is-offset-two-thirds-tablet{margin-left:66.6666%}.column.is-offset-half,.column.is-offset-half-tablet{margin-left:50%}.column.is-offset-one-third,.column.is-offset-one-third-tablet{margin-left:33.3333%}.column.is-offset-one-quarter,.column.is-offset-one-quarter-tablet{margin-left:25%}.column.is-offset-one-fifth,.column.is-offset-one-fifth-tablet{margin-left:20%}.column.is-offset-two-fifths,.column.is-offset-two-fifths-tablet{margin-left:40%}.column.is-offset-three-fifths,.column.is-offset-three-fifths-tablet{margin-left:60%}.column.is-offset-four-fifths,.column.is-offset-four-fifths-tablet{margin-left:80%}.column.is-0,.column.is-0-tablet{flex:none;width:0}.column.is-offset-0,.column.is-offset-0-tablet{margin-left:0}.column.is-1,.column.is-1-tablet{flex:none;width:8.33333%}.column.is-offset-1,.column.is-offset-1-tablet{margin-left:8.33333%}.column.is-2,.column.is-2-tablet{flex:none;width:16.66667%}.column.is-offset-2,.column.is-offset-2-tablet{margin-left:16.66667%}.column.is-3,.column.is-3-tablet{flex:none;width:25%}.column.is-offset-3,.column.is-offset-3-tablet{margin-left:25%}.column.is-4,.column.is-4-tablet{flex:none;width:33.33333%}.column.is-offset-4,.column.is-offset-4-tablet{margin-left:33.33333%}.column.is-5,.column.is-5-tablet{flex:none;width:41.66667%}.column.is-offset-5,.column.is-offset-5-tablet{margin-left:41.66667%}.column.is-6,.column.is-6-tablet{flex:none;width:50%}.column.is-offset-6,.column.is-offset-6-tablet{margin-left:50%}.column.is-7,.column.is-7-tablet{flex:none;width:58.33333%}.column.is-offset-7,.column.is-offset-7-tablet{margin-left:58.33333%}.column.is-8,.column.is-8-tablet{flex:none;width:66.66667%}.column.is-offset-8,.column.is-offset-8-tablet{margin-left:66.66667%}.column.is-9,.column.is-9-tablet{flex:none;width:75%}.column.is-offset-9,.column.is-offset-9-tablet{margin-left:75%}.column.is-10,.column.is-10-tablet{flex:none;width:83.33333%}.column.is-offset-10,.column.is-offset-10-tablet{margin-left:83.33333%}.column.is-11,.column.is-11-tablet{flex:none;width:91.66667%}.column.is-offset-11,.column.is-offset-11-tablet{margin-left:91.66667%}.column.is-12,.column.is-12-tablet{flex:none;width:100%}.column.is-offset-12,.column.is-offset-12-tablet{margin-left:100%}}@media screen and (max-width:1023px){.column.is-narrow-touch{flex:none}.column.is-full-touch{flex:none;width:100%}.column.is-three-quarters-touch{flex:none;width:75%}.column.is-two-thirds-touch{flex:none;width:66.6666%}.column.is-half-touch{flex:none;width:50%}.column.is-one-third-touch{flex:none;width:33.3333%}.column.is-one-quarter-touch{flex:none;width:25%}.column.is-one-fifth-touch{flex:none;width:20%}.column.is-two-fifths-touch{flex:none;width:40%}.column.is-three-fifths-touch{flex:none;width:60%}.column.is-four-fifths-touch{flex:none;width:80%}.column.is-offset-three-quarters-touch{margin-left:75%}.column.is-offset-two-thirds-touch{margin-left:66.6666%}.column.is-offset-half-touch{margin-left:50%}.column.is-offset-one-third-touch{margin-left:33.3333%}.column.is-offset-one-quarter-touch{margin-left:25%}.column.is-offset-one-fifth-touch{margin-left:20%}.column.is-offset-two-fifths-touch{margin-left:40%}.column.is-offset-three-fifths-touch{margin-left:60%}.column.is-offset-four-fifths-touch{margin-left:80%}.column.is-0-touch{flex:none;width:0}.column.is-offset-0-touch{margin-left:0}.column.is-1-touch{flex:none;width:8.33333%}.column.is-offset-1-touch{margin-left:8.33333%}.column.is-2-touch{flex:none;width:16.66667%}.column.is-offset-2-touch{margin-left:16.66667%}.column.is-3-touch{flex:none;width:25%}.column.is-offset-3-touch{margin-left:25%}.column.is-4-touch{flex:none;width:33.33333%}.column.is-offset-4-touch{margin-left:33.33333%}.column.is-5-touch{flex:none;width:41.66667%}.column.is-offset-5-touch{margin-left:41.66667%}.column.is-6-touch{flex:none;width:50%}.column.is-offset-6-touch{margin-left:50%}.column.is-7-touch{flex:none;width:58.33333%}.column.is-offset-7-touch{margin-left:58.33333%}.column.is-8-touch{flex:none;width:66.66667%}.column.is-offset-8-touch{margin-left:66.66667%}.column.is-9-touch{flex:none;width:75%}.column.is-offset-9-touch{margin-left:75%}.column.is-10-touch{flex:none;width:83.33333%}.column.is-offset-10-touch{margin-left:83.33333%}.column.is-11-touch{flex:none;width:91.66667%}.column.is-offset-11-touch{margin-left:91.66667%}.column.is-12-touch{flex:none;width:100%}.column.is-offset-12-touch{margin-left:100%}}@media screen and (min-width:1024px){.column.is-narrow-desktop{flex:none}.column.is-full-desktop{flex:none;width:100%}.column.is-three-quarters-desktop{flex:none;width:75%}.column.is-two-thirds-desktop{flex:none;width:66.6666%}.column.is-half-desktop{flex:none;width:50%}.column.is-one-third-desktop{flex:none;width:33.3333%}.column.is-one-quarter-desktop{flex:none;width:25%}.column.is-one-fifth-desktop{flex:none;width:20%}.column.is-two-fifths-desktop{flex:none;width:40%}.column.is-three-fifths-desktop{flex:none;width:60%}.column.is-four-fifths-desktop{flex:none;width:80%}.column.is-offset-three-quarters-desktop{margin-left:75%}.column.is-offset-two-thirds-desktop{margin-left:66.6666%}.column.is-offset-half-desktop{margin-left:50%}.column.is-offset-one-third-desktop{margin-left:33.3333%}.column.is-offset-one-quarter-desktop{margin-left:25%}.column.is-offset-one-fifth-desktop{margin-left:20%}.column.is-offset-two-fifths-desktop{margin-left:40%}.column.is-offset-three-fifths-desktop{margin-left:60%}.column.is-offset-four-fifths-desktop{margin-left:80%}.column.is-0-desktop{flex:none;width:0}.column.is-offset-0-desktop{margin-left:0}.column.is-1-desktop{flex:none;width:8.33333%}.column.is-offset-1-desktop{margin-left:8.33333%}.column.is-2-desktop{flex:none;width:16.66667%}.column.is-offset-2-desktop{margin-left:16.66667%}.column.is-3-desktop{flex:none;width:25%}.column.is-offset-3-desktop{margin-left:25%}.column.is-4-desktop{flex:none;width:33.33333%}.column.is-offset-4-desktop{margin-left:33.33333%}.column.is-5-desktop{flex:none;width:41.66667%}.column.is-offset-5-desktop{margin-left:41.66667%}.column.is-6-desktop{flex:none;width:50%}.column.is-offset-6-desktop{margin-left:50%}.column.is-7-desktop{flex:none;width:58.33333%}.column.is-offset-7-desktop{margin-left:58.33333%}.column.is-8-desktop{flex:none;width:66.66667%}.column.is-offset-8-desktop{margin-left:66.66667%}.column.is-9-desktop{flex:none;width:75%}.column.is-offset-9-desktop{margin-left:75%}.column.is-10-desktop{flex:none;width:83.33333%}.column.is-offset-10-desktop{margin-left:83.33333%}.column.is-11-desktop{flex:none;width:91.66667%}.column.is-offset-11-desktop{margin-left:91.66667%}.column.is-12-desktop{flex:none;width:100%}.column.is-offset-12-desktop{margin-left:100%}}@media screen and (min-width:1216px){.column.is-narrow-widescreen{flex:none}.column.is-full-widescreen{flex:none;width:100%}.column.is-three-quarters-widescreen{flex:none;width:75%}.column.is-two-thirds-widescreen{flex:none;width:66.6666%}.column.is-half-widescreen{flex:none;width:50%}.column.is-one-third-widescreen{flex:none;width:33.3333%}.column.is-one-quarter-widescreen{flex:none;width:25%}.column.is-one-fifth-widescreen{flex:none;width:20%}.column.is-two-fifths-widescreen{flex:none;width:40%}.column.is-three-fifths-widescreen{flex:none;width:60%}.column.is-four-fifths-widescreen{flex:none;width:80%}.column.is-offset-three-quarters-widescreen{margin-left:75%}.column.is-offset-two-thirds-widescreen{margin-left:66.6666%}.column.is-offset-half-widescreen{margin-left:50%}.column.is-offset-one-third-widescreen{margin-left:33.3333%}.column.is-offset-one-quarter-widescreen{margin-left:25%}.column.is-offset-one-fifth-widescreen{margin-left:20%}.column.is-offset-two-fifths-widescreen{margin-left:40%}.column.is-offset-three-fifths-widescreen{margin-left:60%}.column.is-offset-four-fifths-widescreen{margin-left:80%}.column.is-0-widescreen{flex:none;width:0}.column.is-offset-0-widescreen{margin-left:0}.column.is-1-widescreen{flex:none;width:8.33333%}.column.is-offset-1-widescreen{margin-left:8.33333%}.column.is-2-widescreen{flex:none;width:16.66667%}.column.is-offset-2-widescreen{margin-left:16.66667%}.column.is-3-widescreen{flex:none;width:25%}.column.is-offset-3-widescreen{margin-left:25%}.column.is-4-widescreen{flex:none;width:33.33333%}.column.is-offset-4-widescreen{margin-left:33.33333%}.column.is-5-widescreen{flex:none;width:41.66667%}.column.is-offset-5-widescreen{margin-left:41.66667%}.column.is-6-widescreen{flex:none;width:50%}.column.is-offset-6-widescreen{margin-left:50%}.column.is-7-widescreen{flex:none;width:58.33333%}.column.is-offset-7-widescreen{margin-left:58.33333%}.column.is-8-widescreen{flex:none;width:66.66667%}.column.is-offset-8-widescreen{margin-left:66.66667%}.column.is-9-widescreen{flex:none;width:75%}.column.is-offset-9-widescreen{margin-left:75%}.column.is-10-widescreen{flex:none;width:83.33333%}.column.is-offset-10-widescreen{margin-left:83.33333%}.column.is-11-widescreen{flex:none;width:91.66667%}.column.is-offset-11-widescreen{margin-left:91.66667%}.column.is-12-widescreen{flex:none;width:100%}.column.is-offset-12-widescreen{margin-left:100%}}@media screen and (min-width:1408px){.column.is-narrow-fullhd{flex:none}.column.is-full-fullhd{flex:none;width:100%}.column.is-three-quarters-fullhd{flex:none;width:75%}.column.is-two-thirds-fullhd{flex:none;width:66.6666%}.column.is-half-fullhd{flex:none;width:50%}.column.is-one-third-fullhd{flex:none;width:33.3333%}.column.is-one-quarter-fullhd{flex:none;width:25%}.column.is-one-fifth-fullhd{flex:none;width:20%}.column.is-two-fifths-fullhd{flex:none;width:40%}.column.is-three-fifths-fullhd{flex:none;width:60%}.column.is-four-fifths-fullhd{flex:none;width:80%}.column.is-offset-three-quarters-fullhd{margin-left:75%}.column.is-offset-two-thirds-fullhd{margin-left:66.6666%}.column.is-offset-half-fullhd{margin-left:50%}.column.is-offset-one-third-fullhd{margin-left:33.3333%}.column.is-offset-one-quarter-fullhd{margin-left:25%}.column.is-offset-one-fifth-fullhd{margin-left:20%}.column.is-offset-two-fifths-fullhd{margin-left:40%}.column.is-offset-three-fifths-fullhd{margin-left:60%}.column.is-offset-four-fifths-fullhd{margin-left:80%}.column.is-0-fullhd{flex:none;width:0}.column.is-offset-0-fullhd{margin-left:0}.column.is-1-fullhd{flex:none;width:8.33333%}.column.is-offset-1-fullhd{margin-left:8.33333%}.column.is-2-fullhd{flex:none;width:16.66667%}.column.is-offset-2-fullhd{margin-left:16.66667%}.column.is-3-fullhd{flex:none;width:25%}.column.is-offset-3-fullhd{margin-left:25%}.column.is-4-fullhd{flex:none;width:33.33333%}.column.is-offset-4-fullhd{margin-left:33.33333%}.column.is-5-fullhd{flex:none;width:41.66667%}.column.is-offset-5-fullhd{margin-left:41.66667%}.column.is-6-fullhd{flex:none;width:50%}.column.is-offset-6-fullhd{margin-left:50%}.column.is-7-fullhd{flex:none;width:58.33333%}.column.is-offset-7-fullhd{margin-left:58.33333%}.column.is-8-fullhd{flex:none;width:66.66667%}.column.is-offset-8-fullhd{margin-left:66.66667%}.column.is-9-fullhd{flex:none;width:75%}.column.is-offset-9-fullhd{margin-left:75%}.column.is-10-fullhd{flex:none;width:83.33333%}.column.is-offset-10-fullhd{margin-left:83.33333%}.column.is-11-fullhd{flex:none;width:91.66667%}.column.is-offset-11-fullhd{margin-left:91.66667%}.column.is-12-fullhd{flex:none;width:100%}.column.is-offset-12-fullhd{margin-left:100%}}.columns{margin-left:-.75rem;margin-right:-.75rem;margin-top:-.75rem}.columns:last-child{margin-bottom:-.75rem}.columns:not(:last-child){margin-bottom:0.75rem}.columns.is-centered{justify-content:center}.columns.is-gapless{margin-left:0;margin-right:0;margin-top:0}.columns.is-gapless>.column{margin:0;padding:0!important}.columns.is-gapless:not(:last-child){margin-bottom:1.5rem}.columns.is-gapless:last-child{margin-bottom:0}.columns.is-mobile{display:flex}.columns.is-multiline{flex-wrap:wrap}.columns.is-vcentered{align-items:center}@media print,screen and (min-width:769px){.columns:not(.is-desktop){display:flex}}@media screen and (min-width:1024px){.columns.is-desktop{display:flex}}.columns.is-variable{--columnGap:0.75rem;margin-left:calc(-1 * var(--columnGap));margin-right:calc(-1 * var(--columnGap))}.columns.is-variable .column{padding-left:var(--columnGap);padding-right:var(--columnGap)}.columns.is-variable.is-0{--columnGap:0rem}@media screen and (max-width:768px){.columns.is-variable.is-0-mobile{--columnGap:0rem}}@media print,screen and (min-width:769px){.columns.is-variable.is-0-tablet{--columnGap:0rem}}@media screen and (min-width:769px) and (max-width:1023px){.columns.is-variable.is-0-tablet-only{--columnGap:0rem}}@media screen and (max-width:1023px){.columns.is-variable.is-0-touch{--columnGap:0rem}}@media screen and (min-width:1024px){.columns.is-variable.is-0-desktop{--columnGap:0rem}}@media screen and (min-width:1024px) and (max-width:1215px){.columns.is-variable.is-0-desktop-only{--columnGap:0rem}}@media screen and (min-width:1216px){.columns.is-variable.is-0-widescreen{--columnGap:0rem}}@media screen and (min-width:1216px) and (max-width:1407px){.columns.is-variable.is-0-widescreen-only{--columnGap:0rem}}@media screen and (min-width:1408px){.columns.is-variable.is-0-fullhd{--columnGap:0rem}}.columns.is-variable.is-1{--columnGap:0.25rem}@media screen and (max-width:768px){.columns.is-variable.is-1-mobile{--columnGap:0.25rem}}@media print,screen and (min-width:769px){.columns.is-variable.is-1-tablet{--columnGap:0.25rem}}@media screen and (min-width:769px) and (max-width:1023px){.columns.is-variable.is-1-tablet-only{--columnGap:0.25rem}}@media screen and (max-width:1023px){.columns.is-variable.is-1-touch{--columnGap:0.25rem}}@media screen and (min-width:1024px){.columns.is-variable.is-1-desktop{--columnGap:0.25rem}}@media screen and (min-width:1024px) and (max-width:1215px){.columns.is-variable.is-1-desktop-only{--columnGap:0.25rem}}@media screen and (min-width:1216px){.columns.is-variable.is-1-widescreen{--columnGap:0.25rem}}@media screen and (min-width:1216px) and (max-width:1407px){.columns.is-variable.is-1-widescreen-only{--columnGap:0.25rem}}@media screen and (min-width:1408px){.columns.is-variable.is-1-fullhd{--columnGap:0.25rem}}.columns.is-variable.is-2{--columnGap:0.5rem}@media screen and (max-width:768px){.columns.is-variable.is-2-mobile{--columnGap:0.5rem}}@media print,screen and (min-width:769px){.columns.is-variable.is-2-tablet{--columnGap:0.5rem}}@media screen and (min-width:769px) and (max-width:1023px){.columns.is-variable.is-2-tablet-only{--columnGap:0.5rem}}@media screen and (max-width:1023px){.columns.is-variable.is-2-touch{--columnGap:0.5rem}}@media screen and (min-width:1024px){.columns.is-variable.is-2-desktop{--columnGap:0.5rem}}@media screen and (min-width:1024px) and (max-width:1215px){.columns.is-variable.is-2-desktop-only{--columnGap:0.5rem}}@media screen and (min-width:1216px){.columns.is-variable.is-2-widescreen{--columnGap:0.5rem}}@media screen and (min-width:1216px) and (max-width:1407px){.columns.is-variable.is-2-widescreen-only{--columnGap:0.5rem}}@media screen and (min-width:1408px){.columns.is-variable.is-2-fullhd{--columnGap:0.5rem}}.columns.is-variable.is-3{--columnGap:0.75rem}@media screen and (max-width:768px){.columns.is-variable.is-3-mobile{--columnGap:0.75rem}}@media print,screen and (min-width:769px){.columns.is-variable.is-3-tablet{--columnGap:0.75rem}}@media screen and (min-width:769px) and (max-width:1023px){.columns.is-variable.is-3-tablet-only{--columnGap:0.75rem}}@media screen and (max-width:1023px){.columns.is-variable.is-3-touch{--columnGap:0.75rem}}@media screen and (min-width:1024px){.columns.is-variable.is-3-desktop{--columnGap:0.75rem}}@media screen and (min-width:1024px) and (max-width:1215px){.columns.is-variable.is-3-desktop-only{--columnGap:0.75rem}}@media screen and (min-width:1216px){.columns.is-variable.is-3-widescreen{--columnGap:0.75rem}}@media screen and (min-width:1216px) and (max-width:1407px){.columns.is-variable.is-3-widescreen-only{--columnGap:0.75rem}}@media screen and (min-width:1408px){.columns.is-variable.is-3-fullhd{--columnGap:0.75rem}}.columns.is-variable.is-4{--columnGap:1rem}@media screen and (max-width:768px){.columns.is-variable.is-4-mobile{--columnGap:1rem}}@media print,screen and (min-width:769px){.columns.is-variable.is-4-tablet{--columnGap:1rem}}@media screen and (min-width:769px) and (max-width:1023px){.columns.is-variable.is-4-tablet-only{--columnGap:1rem}}@media screen and (max-width:1023px){.columns.is-variable.is-4-touch{--columnGap:1rem}}@media screen and (min-width:1024px){.columns.is-variable.is-4-desktop{--columnGap:1rem}}@media screen and (min-width:1024px) and (max-width:1215px){.columns.is-variable.is-4-desktop-only{--columnGap:1rem}}@media screen and (min-width:1216px){.columns.is-variable.is-4-widescreen{--columnGap:1rem}}@media screen and (min-width:1216px) and (max-width:1407px){.columns.is-variable.is-4-widescreen-only{--columnGap:1rem}}@media screen and (min-width:1408px){.columns.is-variable.is-4-fullhd{--columnGap:1rem}}.columns.is-variable.is-5{--columnGap:1.25rem}@media screen and (max-width:768px){.columns.is-variable.is-5-mobile{--columnGap:1.25rem}}@media print,screen and (min-width:769px){.columns.is-variable.is-5-tablet{--columnGap:1.25rem}}@media screen and (min-width:769px) and (max-width:1023px){.columns.is-variable.is-5-tablet-only{--columnGap:1.25rem}}@media screen and (max-width:1023px){.columns.is-variable.is-5-touch{--columnGap:1.25rem}}@media screen and (min-width:1024px){.columns.is-variable.is-5-desktop{--columnGap:1.25rem}}@media screen and (min-width:1024px) and (max-width:1215px){.columns.is-variable.is-5-desktop-only{--columnGap:1.25rem}}@media screen and (min-width:1216px){.columns.is-variable.is-5-widescreen{--columnGap:1.25rem}}@media screen and (min-width:1216px) and (max-width:1407px){.columns.is-variable.is-5-widescreen-only{--columnGap:1.25rem}}@media screen and (min-width:1408px){.columns.is-variable.is-5-fullhd{--columnGap:1.25rem}}.columns.is-variable.is-6{--columnGap:1.5rem}@media screen and (max-width:768px){.columns.is-variable.is-6-mobile{--columnGap:1.5rem}}@media print,screen and (min-width:769px){.columns.is-variable.is-6-tablet{--columnGap:1.5rem}}@media screen and (min-width:769px) and (max-width:1023px){.columns.is-variable.is-6-tablet-only{--columnGap:1.5rem}}@media screen and (max-width:1023px){.columns.is-variable.is-6-touch{--columnGap:1.5rem}}@media screen and (min-width:1024px){.columns.is-variable.is-6-desktop{--columnGap:1.5rem}}@media screen and (min-width:1024px) and (max-width:1215px){.columns.is-variable.is-6-desktop-only{--columnGap:1.5rem}}@media screen and (min-width:1216px){.columns.is-variable.is-6-widescreen{--columnGap:1.5rem}}@media screen and (min-width:1216px) and (max-width:1407px){.columns.is-variable.is-6-widescreen-only{--columnGap:1.5rem}}@media screen and (min-width:1408px){.columns.is-variable.is-6-fullhd{--columnGap:1.5rem}}.columns.is-variable.is-7{--columnGap:1.75rem}@media screen and (max-width:768px){.columns.is-variable.is-7-mobile{--columnGap:1.75rem}}@media print,screen and (min-width:769px){.columns.is-variable.is-7-tablet{--columnGap:1.75rem}}@media screen and (min-width:769px) and (max-width:1023px){.columns.is-variable.is-7-tablet-only{--columnGap:1.75rem}}@media screen and (max-width:1023px){.columns.is-variable.is-7-touch{--columnGap:1.75rem}}@media screen and (min-width:1024px){.columns.is-variable.is-7-desktop{--columnGap:1.75rem}}@media screen and (min-width:1024px) and (max-width:1215px){.columns.is-variable.is-7-desktop-only{--columnGap:1.75rem}}@media screen and (min-width:1216px){.columns.is-variable.is-7-widescreen{--columnGap:1.75rem}}@media screen and (min-width:1216px) and (max-width:1407px){.columns.is-variable.is-7-widescreen-only{--columnGap:1.75rem}}@media screen and (min-width:1408px){.columns.is-variable.is-7-fullhd{--columnGap:1.75rem}}.columns.is-variable.is-8{--columnGap:2rem}@media screen and (max-width:768px){.columns.is-variable.is-8-mobile{--columnGap:2rem}}@media print,screen and (min-width:769px){.columns.is-variable.is-8-tablet{--columnGap:2rem}}@media screen and (min-width:769px) and (max-width:1023px){.columns.is-variable.is-8-tablet-only{--columnGap:2rem}}@media screen and (max-width:1023px){.columns.is-variable.is-8-touch{--columnGap:2rem}}@media screen and (min-width:1024px){.columns.is-variable.is-8-desktop{--columnGap:2rem}}@media screen and (min-width:1024px) and (max-width:1215px){.columns.is-variable.is-8-desktop-only{--columnGap:2rem}}@media screen and (min-width:1216px){.columns.is-variable.is-8-widescreen{--columnGap:2rem}}@media screen and (min-width:1216px) and (max-width:1407px){.columns.is-variable.is-8-widescreen-only{--columnGap:2rem}}@media screen and (min-width:1408px){.columns.is-variable.is-8-fullhd{--columnGap:2rem}}.tile{align-items:stretch;display:block;flex-basis:0;flex-grow:1;flex-shrink:1;min-height:min-content}.tile.is-ancestor{margin-left:-.75rem;margin-right:-.75rem;margin-top:-.75rem}.tile.is-ancestor:last-child{margin-bottom:-.75rem}.tile.is-ancestor:not(:last-child){margin-bottom:.75rem}.tile.is-child{margin:0!important}.tile.is-parent{padding:.75rem}.tile.is-vertical{flex-direction:column}.tile.is-vertical>.tile.is-child:not(:last-child){margin-bottom:1.5rem!important}@media print,screen and (min-width:769px){.tile:not(.is-child){display:flex}.tile.is-1{flex:none;width:8.33333%}.tile.is-2{flex:none;width:16.66667%}.tile.is-3{flex:none;width:25%}.tile.is-4{flex:none;width:33.33333%}.tile.is-5{flex:none;width:41.66667%}.tile.is-6{flex:none;width:50%}.tile.is-7{flex:none;width:58.33333%}.tile.is-8{flex:none;width:66.66667%}.tile.is-9{flex:none;width:75%}.tile.is-10{flex:none;width:83.33333%}.tile.is-11{flex:none;width:91.66667%}.tile.is-12{flex:none;width:100%}}.hero{align-items:stretch;display:flex;flex-direction:column;justify-content:space-between}.hero .navbar{background:none}.hero .tabs ul{border-bottom:none}.hero.is-white{background-color:#fff;color:#0a0a0a}.hero.is-white a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.hero.is-white strong{color:inherit}.hero.is-white .title{color:#0a0a0a}.hero.is-white .subtitle{color:hsla(0,0%,4%,.9)}.hero.is-white .subtitle a:not(.button),.hero.is-white .subtitle strong{color:#0a0a0a}@media screen and (max-width:1023px){.hero.is-white .navbar-menu{background-color:#fff}}.hero.is-white .navbar-item,.hero.is-white .navbar-link{color:hsla(0,0%,4%,.7)}.hero.is-white .navbar-link.is-active,.hero.is-white .navbar-link:hover,.hero.is-white a.navbar-item.is-active,.hero.is-white a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.hero.is-white .tabs a{color:#0a0a0a;opacity:.9}.hero.is-white .tabs a:hover,.hero.is-white .tabs li.is-active a{opacity:1}.hero.is-white .tabs.is-boxed a,.hero.is-white .tabs.is-toggle a{color:#0a0a0a}.hero.is-white .tabs.is-boxed a:hover,.hero.is-white .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-white .tabs.is-boxed li.is-active a,.hero.is-white .tabs.is-boxed li.is-active a:hover,.hero.is-white .tabs.is-toggle li.is-active a,.hero.is-white .tabs.is-toggle li.is-active a:hover{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.hero.is-white.is-bold{background-image:linear-gradient(141deg,#e6e6e6,#fff 71%,#fff)}@media screen and (max-width:768px){.hero.is-white.is-bold .navbar-menu{background-image:linear-gradient(141deg,#e6e6e6,#fff 71%,#fff)}}.hero.is-black{background-color:#0a0a0a;color:#fff}.hero.is-black a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.hero.is-black strong{color:inherit}.hero.is-black .title{color:#fff}.hero.is-black .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-black .subtitle a:not(.button),.hero.is-black .subtitle strong{color:#fff}@media screen and (max-width:1023px){.hero.is-black .navbar-menu{background-color:#0a0a0a}}.hero.is-black .navbar-item,.hero.is-black .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-black .navbar-link.is-active,.hero.is-black .navbar-link:hover,.hero.is-black a.navbar-item.is-active,.hero.is-black a.navbar-item:hover{background-color:#000;color:#fff}.hero.is-black .tabs a{color:#fff;opacity:.9}.hero.is-black .tabs a:hover,.hero.is-black .tabs li.is-active a{opacity:1}.hero.is-black .tabs.is-boxed a,.hero.is-black .tabs.is-toggle a{color:#fff}.hero.is-black .tabs.is-boxed a:hover,.hero.is-black .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-black .tabs.is-boxed li.is-active a,.hero.is-black .tabs.is-boxed li.is-active a:hover,.hero.is-black .tabs.is-toggle li.is-active a,.hero.is-black .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#0a0a0a}.hero.is-black.is-bold{background-image:linear-gradient(141deg,#000,#0a0a0a 71%,#181616)}@media screen and (max-width:768px){.hero.is-black.is-bold .navbar-menu{background-image:linear-gradient(141deg,#000,#0a0a0a 71%,#181616)}}.hero.is-light{background-color:#f5f5f5;color:#363636}.hero.is-light a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.hero.is-light strong{color:inherit}.hero.is-light .title{color:#363636}.hero.is-light .subtitle{color:rgba(54,54,54,.9)}.hero.is-light .subtitle a:not(.button),.hero.is-light .subtitle strong{color:#363636}@media screen and (max-width:1023px){.hero.is-light .navbar-menu{background-color:#f5f5f5}}.hero.is-light .navbar-item,.hero.is-light .navbar-link{color:rgba(54,54,54,.7)}.hero.is-light .navbar-link.is-active,.hero.is-light .navbar-link:hover,.hero.is-light a.navbar-item.is-active,.hero.is-light a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.hero.is-light .tabs a{color:#363636;opacity:.9}.hero.is-light .tabs a:hover,.hero.is-light .tabs li.is-active a{opacity:1}.hero.is-light .tabs.is-boxed a,.hero.is-light .tabs.is-toggle a{color:#363636}.hero.is-light .tabs.is-boxed a:hover,.hero.is-light .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-light .tabs.is-boxed li.is-active a,.hero.is-light .tabs.is-boxed li.is-active a:hover,.hero.is-light .tabs.is-toggle li.is-active a,.hero.is-light .tabs.is-toggle li.is-active a:hover{background-color:#363636;border-color:#363636;color:#f5f5f5}.hero.is-light.is-bold{background-image:linear-gradient(141deg,#dfd8d9,#f5f5f5 71%,#fff)}@media screen and (max-width:768px){.hero.is-light.is-bold .navbar-menu{background-image:linear-gradient(141deg,#dfd8d9,#f5f5f5 71%,#fff)}}.hero.is-dark{background-color:#363636;color:#f5f5f5}.hero.is-dark a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.hero.is-dark strong{color:inherit}.hero.is-dark .title{color:#f5f5f5}.hero.is-dark .subtitle{color:hsla(0,0%,96%,.9)}.hero.is-dark .subtitle a:not(.button),.hero.is-dark .subtitle strong{color:#f5f5f5}@media screen and (max-width:1023px){.hero.is-dark .navbar-menu{background-color:#363636}}.hero.is-dark .navbar-item,.hero.is-dark .navbar-link{color:hsla(0,0%,96%,.7)}.hero.is-dark .navbar-link.is-active,.hero.is-dark .navbar-link:hover,.hero.is-dark a.navbar-item.is-active,.hero.is-dark a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.hero.is-dark .tabs a{color:#f5f5f5;opacity:.9}.hero.is-dark .tabs a:hover,.hero.is-dark .tabs li.is-active a{opacity:1}.hero.is-dark .tabs.is-boxed a,.hero.is-dark .tabs.is-toggle a{color:#f5f5f5}.hero.is-dark .tabs.is-boxed a:hover,.hero.is-dark .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-dark .tabs.is-boxed li.is-active a,.hero.is-dark .tabs.is-boxed li.is-active a:hover,.hero.is-dark .tabs.is-toggle li.is-active a,.hero.is-dark .tabs.is-toggle li.is-active a:hover{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.hero.is-dark.is-bold{background-image:linear-gradient(141deg,#1f191a,#363636 71%,#46403f)}@media screen and (max-width:768px){.hero.is-dark.is-bold .navbar-menu{background-image:linear-gradient(141deg,#1f191a,#363636 71%,#46403f)}}.hero.is-primary{background-color:#7957d5;color:#fff}.hero.is-primary a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.hero.is-primary strong{color:inherit}.hero.is-primary .title{color:#fff}.hero.is-primary .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-primary .subtitle a:not(.button),.hero.is-primary .subtitle strong{color:#fff}@media screen and (max-width:1023px){.hero.is-primary .navbar-menu{background-color:#7957d5}}.hero.is-primary .navbar-item,.hero.is-primary .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-primary .navbar-link.is-active,.hero.is-primary .navbar-link:hover,.hero.is-primary a.navbar-item.is-active,.hero.is-primary a.navbar-item:hover{background-color:#6943d0;color:#fff}.hero.is-primary .tabs a{color:#fff;opacity:.9}.hero.is-primary .tabs a:hover,.hero.is-primary .tabs li.is-active a{opacity:1}.hero.is-primary .tabs.is-boxed a,.hero.is-primary .tabs.is-toggle a{color:#fff}.hero.is-primary .tabs.is-boxed a:hover,.hero.is-primary .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-primary .tabs.is-boxed li.is-active a,.hero.is-primary .tabs.is-boxed li.is-active a:hover,.hero.is-primary .tabs.is-toggle li.is-active a,.hero.is-primary .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#7957d5}.hero.is-primary.is-bold{background-image:linear-gradient(141deg,#3725d4,#7957d5 71%,#9b67df)}@media screen and (max-width:768px){.hero.is-primary.is-bold .navbar-menu{background-image:linear-gradient(141deg,#3725d4,#7957d5 71%,#9b67df)}}.hero.is-link{background-color:#7957d5;color:#fff}.hero.is-link a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.hero.is-link strong{color:inherit}.hero.is-link .title{color:#fff}.hero.is-link .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-link .subtitle a:not(.button),.hero.is-link .subtitle strong{color:#fff}@media screen and (max-width:1023px){.hero.is-link .navbar-menu{background-color:#7957d5}}.hero.is-link .navbar-item,.hero.is-link .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-link .navbar-link.is-active,.hero.is-link .navbar-link:hover,.hero.is-link a.navbar-item.is-active,.hero.is-link a.navbar-item:hover{background-color:#6943d0;color:#fff}.hero.is-link .tabs a{color:#fff;opacity:.9}.hero.is-link .tabs a:hover,.hero.is-link .tabs li.is-active a{opacity:1}.hero.is-link .tabs.is-boxed a,.hero.is-link .tabs.is-toggle a{color:#fff}.hero.is-link .tabs.is-boxed a:hover,.hero.is-link .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-link .tabs.is-boxed li.is-active a,.hero.is-link .tabs.is-boxed li.is-active a:hover,.hero.is-link .tabs.is-toggle li.is-active a,.hero.is-link .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#7957d5}.hero.is-link.is-bold{background-image:linear-gradient(141deg,#3725d4,#7957d5 71%,#9b67df)}@media screen and (max-width:768px){.hero.is-link.is-bold .navbar-menu{background-image:linear-gradient(141deg,#3725d4,#7957d5 71%,#9b67df)}}.hero.is-info{background-color:#167df0;color:#fff}.hero.is-info a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.hero.is-info strong{color:inherit}.hero.is-info .title{color:#fff}.hero.is-info .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-info .subtitle a:not(.button),.hero.is-info .subtitle strong{color:#fff}@media screen and (max-width:1023px){.hero.is-info .navbar-menu{background-color:#167df0}}.hero.is-info .navbar-item,.hero.is-info .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-info .navbar-link.is-active,.hero.is-info .navbar-link:hover,.hero.is-info a.navbar-item.is-active,.hero.is-info a.navbar-item:hover{background-color:#0e71de;color:#fff}.hero.is-info .tabs a{color:#fff;opacity:.9}.hero.is-info .tabs a:hover,.hero.is-info .tabs li.is-active a{opacity:1}.hero.is-info .tabs.is-boxed a,.hero.is-info .tabs.is-toggle a{color:#fff}.hero.is-info .tabs.is-boxed a:hover,.hero.is-info .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-info .tabs.is-boxed li.is-active a,.hero.is-info .tabs.is-boxed li.is-active a:hover,.hero.is-info .tabs.is-toggle li.is-active a,.hero.is-info .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#167df0}.hero.is-info.is-bold{background-image:linear-gradient(141deg,#0286d1,#167df0 71%,#2868f7)}@media screen and (max-width:768px){.hero.is-info.is-bold .navbar-menu{background-image:linear-gradient(141deg,#0286d1,#167df0 71%,#2868f7)}}.hero.is-success{background-color:#23d160;color:#fff}.hero.is-success a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.hero.is-success strong{color:inherit}.hero.is-success .title{color:#fff}.hero.is-success .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-success .subtitle a:not(.button),.hero.is-success .subtitle strong{color:#fff}@media screen and (max-width:1023px){.hero.is-success .navbar-menu{background-color:#23d160}}.hero.is-success .navbar-item,.hero.is-success .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-success .navbar-link.is-active,.hero.is-success .navbar-link:hover,.hero.is-success a.navbar-item.is-active,.hero.is-success a.navbar-item:hover{background-color:#20bc56;color:#fff}.hero.is-success .tabs a{color:#fff;opacity:.9}.hero.is-success .tabs a:hover,.hero.is-success .tabs li.is-active a{opacity:1}.hero.is-success .tabs.is-boxed a,.hero.is-success .tabs.is-toggle a{color:#fff}.hero.is-success .tabs.is-boxed a:hover,.hero.is-success .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-success .tabs.is-boxed li.is-active a,.hero.is-success .tabs.is-boxed li.is-active a:hover,.hero.is-success .tabs.is-toggle li.is-active a,.hero.is-success .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#23d160}.hero.is-success.is-bold{background-image:linear-gradient(141deg,#12af2f,#23d160 71%,#2ce28a)}@media screen and (max-width:768px){.hero.is-success.is-bold .navbar-menu{background-image:linear-gradient(141deg,#12af2f,#23d160 71%,#2ce28a)}}.hero.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.hero.is-warning a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.hero.is-warning strong{color:inherit}.hero.is-warning .title{color:rgba(0,0,0,.7)}.hero.is-warning .subtitle{color:rgba(0,0,0,.9)}.hero.is-warning .subtitle a:not(.button),.hero.is-warning .subtitle strong{color:rgba(0,0,0,.7)}@media screen and (max-width:1023px){.hero.is-warning .navbar-menu{background-color:#ffdd57}}.hero.is-warning .navbar-item,.hero.is-warning .navbar-link{color:rgba(0,0,0,.7)}.hero.is-warning .navbar-link.is-active,.hero.is-warning .navbar-link:hover,.hero.is-warning a.navbar-item.is-active,.hero.is-warning a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.hero.is-warning .tabs a{color:rgba(0,0,0,.7);opacity:.9}.hero.is-warning .tabs a:hover,.hero.is-warning .tabs li.is-active a{opacity:1}.hero.is-warning .tabs.is-boxed a,.hero.is-warning .tabs.is-toggle a{color:rgba(0,0,0,.7)}.hero.is-warning .tabs.is-boxed a:hover,.hero.is-warning .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-warning .tabs.is-boxed li.is-active a,.hero.is-warning .tabs.is-boxed li.is-active a:hover,.hero.is-warning .tabs.is-toggle li.is-active a,.hero.is-warning .tabs.is-toggle li.is-active a:hover{background-color:rgba(0,0,0,.7);border-color:rgba(0,0,0,.7);color:#ffdd57}.hero.is-warning.is-bold{background-image:linear-gradient(141deg,#ffaf24,#ffdd57 71%,#fffa70)}@media screen and (max-width:768px){.hero.is-warning.is-bold .navbar-menu{background-image:linear-gradient(141deg,#ffaf24,#ffdd57 71%,#fffa70)}}.hero.is-danger{background-color:#ff3860;color:#fff}.hero.is-danger a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.hero.is-danger strong{color:inherit}.hero.is-danger .title{color:#fff}.hero.is-danger .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-danger .subtitle a:not(.button),.hero.is-danger .subtitle strong{color:#fff}@media screen and (max-width:1023px){.hero.is-danger .navbar-menu{background-color:#ff3860}}.hero.is-danger .navbar-item,.hero.is-danger .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-danger .navbar-link.is-active,.hero.is-danger .navbar-link:hover,.hero.is-danger a.navbar-item.is-active,.hero.is-danger a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.hero.is-danger .tabs a{color:#fff;opacity:.9}.hero.is-danger .tabs a:hover,.hero.is-danger .tabs li.is-active a{opacity:1}.hero.is-danger .tabs.is-boxed a,.hero.is-danger .tabs.is-toggle a{color:#fff}.hero.is-danger .tabs.is-boxed a:hover,.hero.is-danger .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-danger .tabs.is-boxed li.is-active a,.hero.is-danger .tabs.is-boxed li.is-active a:hover,.hero.is-danger .tabs.is-toggle li.is-active a,.hero.is-danger .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#ff3860}.hero.is-danger.is-bold{background-image:linear-gradient(141deg,#ff0561,#ff3860 71%,#ff5257)}@media screen and (max-width:768px){.hero.is-danger.is-bold .navbar-menu{background-image:linear-gradient(141deg,#ff0561,#ff3860 71%,#ff5257)}}.hero.is-small .hero-body{padding-bottom:1.5rem;padding-top:1.5rem}@media print,screen and (min-width:769px){.hero.is-medium .hero-body{padding-bottom:9rem;padding-top:9rem}}@media print,screen and (min-width:769px){.hero.is-large .hero-body{padding-bottom:18rem;padding-top:18rem}}.hero.is-fullheight-with-navbar .hero-body,.hero.is-fullheight .hero-body,.hero.is-halfheight .hero-body{align-items:center;display:flex}.hero.is-fullheight-with-navbar .hero-body>.container,.hero.is-fullheight .hero-body>.container,.hero.is-halfheight .hero-body>.container{flex-grow:1;flex-shrink:1}.hero.is-halfheight{min-height:50vh}.hero.is-fullheight{min-height:100vh}.hero-video{overflow:hidden}.hero-video video{left:50%;min-height:100%;min-width:100%;position:absolute;top:50%;transform:translate3d(-50%,-50%,0)}.hero-video.is-transparent{opacity:.3}@media screen and (max-width:768px){.hero-video{display:none}}.hero-buttons{margin-top:1.5rem}@media screen and (max-width:768px){.hero-buttons .button{display:flex}.hero-buttons .button:not(:last-child){margin-bottom:.75rem}}@media print,screen and (min-width:769px){.hero-buttons{display:flex;justify-content:center}.hero-buttons .button:not(:last-child){margin-right:1.5rem}}.hero-foot,.hero-head{flex-grow:0;flex-shrink:0}.hero-body{flex-grow:1;flex-shrink:0}.hero-body,.section{padding:3rem 1.5rem}@media screen and (min-width:1024px){.section.is-medium{padding:9rem 1.5rem}.section.is-large{padding:18rem 1.5rem}}.footer{background-color:#fafafa;padding:3rem 1.5rem 6rem}.is-noscroll{position:fixed;overflow-y:hidden;width:100%;bottom:0}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{animation-name:fadeOut}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;transform:translate3d(0,100%,0)}}.fadeOutDown{animation-name:fadeOutDown}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;transform:translate3d(0,-100%,0)}}.fadeOutUp{animation-name:fadeOutUp}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{animation-name:fadeIn}@keyframes fadeInDown{0%{opacity:0;transform:translate3d(0,-100%,0)}to{opacity:1;transform:none}}.fadeInDown{animation-name:fadeInDown}@keyframes fadeInUp{0%{opacity:0;transform:translate3d(0,100%,0)}to{opacity:1;transform:none}}.fadeInUp{animation-name:fadeInUp}.fade-enter-active,.fade-leave-active{transition:opacity .15s ease-out}.fade-enter,.fade-leave-to{opacity:0}.zoom-in-enter-active,.zoom-in-leave-active{transition:opacity .15s ease-out}.zoom-in-enter-active .animation-content,.zoom-in-leave-active .animation-content{transition:transform .15s ease-out}.zoom-in-enter,.zoom-in-leave-active{opacity:0}.zoom-in-enter .animation-content,.zoom-in-leave-active .animation-content{transform:scale(.95)}.zoom-out-enter-active,.zoom-out-leave-active{transition:opacity .15s ease-out}.zoom-out-enter-active .animation-content,.zoom-out-leave-active .animation-content{transition:transform .15s ease-out}.zoom-out-enter,.zoom-out-leave-active{opacity:0}.zoom-out-enter .animation-content,.zoom-out-leave-active .animation-content{transform:scale(1.05)}.slide-next-enter-active,.slide-next-leave-active,.slide-prev-enter-active,.slide-prev-leave-active{transition:transform .25s cubic-bezier(.785,.135,.15,.86)}.slide-next-enter,.slide-prev-leave-to{transform:translate3d(-100%,0,0);position:absolute;width:100%}.slide-next-leave-to,.slide-prev-enter{transform:translate3d(100%,0,0);position:absolute;width:100%}.autocomplete{position:relative}.autocomplete .dropdown-menu{display:block;min-width:100%;max-width:100%}.autocomplete .dropdown-menu.is-opened-top{top:auto;bottom:100%}.autocomplete .dropdown-content{overflow:auto;max-height:200px}.autocomplete .dropdown-item,.autocomplete .dropdown .dropdown-menu .has-link a,.dropdown .dropdown-menu .has-link .autocomplete a{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.autocomplete .dropdown-item.is-hovered,.autocomplete .dropdown .dropdown-menu .has-link a.is-hovered,.dropdown .dropdown-menu .has-link .autocomplete a.is-hovered{background:#f5f5f5;color:#0a0a0a}.autocomplete .dropdown-item.is-disabled,.autocomplete .dropdown .dropdown-menu .has-link a.is-disabled,.dropdown .dropdown-menu .has-link .autocomplete a.is-disabled{opacity:.5;cursor:not-allowed}.autocomplete.is-small{border-radius:2px;font-size:.75rem}.autocomplete.is-medium{font-size:1.25rem}.autocomplete.is-large{font-size:1.5rem}.b-checkbox.checkbox{outline:none;display:inline-flex;align-items:center;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.b-checkbox.checkbox+.checkbox{margin-left:.5em}.b-checkbox.checkbox input[type=checkbox]{position:absolute;left:0;opacity:0;outline:none;z-index:-1}.b-checkbox.checkbox input[type=checkbox]+.check{width:1.25em;height:1.25em;flex-shrink:0;border-radius:4px;border:2px solid #7a7a7a;transition:background .15s ease-out}.b-checkbox.checkbox input[type=checkbox]:checked+.check{background:#7957d5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#7957d5}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-white{background:#fff url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%230a0a0a'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#fff}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-black{background:#0a0a0a url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#0a0a0a}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-light{background:#f5f5f5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23363636'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#f5f5f5}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-dark{background:#363636 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23f5f5f5'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#363636}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-link,.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-primary{background:#7957d5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#7957d5}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-info{background:#167df0 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#167df0}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-success{background:#23d160 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#23d160}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-warning{background:#ffdd57 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='rgba(0,0,0,.7)'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#ffdd57}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-danger{background:#ff3860 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#ff3860}.b-checkbox.checkbox input[type=checkbox]:indeterminate+.check{background:#7957d5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#7957d5}.b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-white{background:#fff url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%230a0a0a' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#fff}.b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-black{background:#0a0a0a url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#0a0a0a}.b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-light{background:#f5f5f5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23363636' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#f5f5f5}.b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-dark{background:#363636 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23f5f5f5' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#363636}.b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-primary{background:#7957d5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#7957d5}.b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-link{background:#7957d5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#7957d5}.b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-info{background:#167df0 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#167df0}.b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-success{background:#23d160 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#23d160}.b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-warning{background:#ffdd57 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='rgba(0,0,0,.7)' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#ffdd57}.b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-danger{background:#ff3860 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#ff3860}.b-checkbox.checkbox input[type=checkbox]:focus+.check{box-shadow:0 0 .5em hsla(0,0%,48%,.8)}.b-checkbox.checkbox input[type=checkbox]:focus:checked+.check{box-shadow:0 0 .5em rgba(121,87,213,.8)}.b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-white{box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-black{box-shadow:0 0 .5em hsla(0,0%,4%,.8)}.b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-light{box-shadow:0 0 .5em hsla(0,0%,96%,.8)}.b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-dark{box-shadow:0 0 .5em rgba(54,54,54,.8)}.b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-link,.b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-primary{box-shadow:0 0 .5em rgba(121,87,213,.8)}.b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-info{box-shadow:0 0 .5em rgba(22,125,240,.8)}.b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-success{box-shadow:0 0 .5em rgba(35,209,96,.8)}.b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-warning{box-shadow:0 0 .5em rgba(255,221,87,.8)}.b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-danger{box-shadow:0 0 .5em rgba(255,56,96,.8)}.b-checkbox.checkbox .control-label{padding-left:.5em}.b-checkbox.checkbox[disabled]{opacity:.5}.b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check{border-color:#7957d5}.b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-white{border-color:#fff}.b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-black{border-color:#0a0a0a}.b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-light{border-color:#f5f5f5}.b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-dark{border-color:#363636}.b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-link,.b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-primary{border-color:#7957d5}.b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-info{border-color:#167df0}.b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-success{border-color:#23d160}.b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-warning{border-color:#ffdd57}.b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-danger{border-color:#ff3860}.b-checkbox.checkbox.is-small{border-radius:2px;font-size:.75rem}.b-checkbox.checkbox.is-medium{font-size:1.25rem}.b-checkbox.checkbox.is-large{font-size:1.5rem}.b-clockpicker .card-header{background-color:#7957d5;color:#fff}.b-clockpicker .b-clockpicker-face:after{background-color:#7957d5}.b-clockpicker .b-clockpicker-face-hand{background-color:#7957d5;border-color:#7957d5}.b-clockpicker .b-clockpicker-face-number.active{background-color:#7957d5;color:#fff}.b-clockpicker.is-white .card-header{background-color:#fff;color:#0a0a0a}.b-clockpicker.is-white .b-clockpicker-face:after{background-color:#fff}.b-clockpicker.is-white .b-clockpicker-face-hand{background-color:#fff;border-color:#fff}.b-clockpicker.is-white .b-clockpicker-face-number.active{background-color:#fff;color:#0a0a0a}.b-clockpicker.is-black .card-header{background-color:#0a0a0a;color:#fff}.b-clockpicker.is-black .b-clockpicker-face:after{background-color:#0a0a0a}.b-clockpicker.is-black .b-clockpicker-face-hand{background-color:#0a0a0a;border-color:#0a0a0a}.b-clockpicker.is-black .b-clockpicker-face-number.active{background-color:#0a0a0a;color:#fff}.b-clockpicker.is-light .card-header{background-color:#f5f5f5;color:#363636}.b-clockpicker.is-light .b-clockpicker-face:after{background-color:#f5f5f5}.b-clockpicker.is-light .b-clockpicker-face-hand{background-color:#f5f5f5;border-color:#f5f5f5}.b-clockpicker.is-light .b-clockpicker-face-number.active{background-color:#f5f5f5;color:#363636}.b-clockpicker.is-dark .card-header{background-color:#363636;color:#f5f5f5}.b-clockpicker.is-dark .b-clockpicker-face:after{background-color:#363636}.b-clockpicker.is-dark .b-clockpicker-face-hand{background-color:#363636;border-color:#363636}.b-clockpicker.is-dark .b-clockpicker-face-number.active{background-color:#363636;color:#f5f5f5}.b-clockpicker.is-primary .card-header{background-color:#7957d5;color:#fff}.b-clockpicker.is-primary .b-clockpicker-face:after{background-color:#7957d5}.b-clockpicker.is-primary .b-clockpicker-face-hand{background-color:#7957d5;border-color:#7957d5}.b-clockpicker.is-link .card-header,.b-clockpicker.is-primary .b-clockpicker-face-number.active{background-color:#7957d5;color:#fff}.b-clockpicker.is-link .b-clockpicker-face:after{background-color:#7957d5}.b-clockpicker.is-link .b-clockpicker-face-hand{background-color:#7957d5;border-color:#7957d5}.b-clockpicker.is-link .b-clockpicker-face-number.active{background-color:#7957d5;color:#fff}.b-clockpicker.is-info .card-header{background-color:#167df0;color:#fff}.b-clockpicker.is-info .b-clockpicker-face:after{background-color:#167df0}.b-clockpicker.is-info .b-clockpicker-face-hand{background-color:#167df0;border-color:#167df0}.b-clockpicker.is-info .b-clockpicker-face-number.active{background-color:#167df0;color:#fff}.b-clockpicker.is-success .card-header{background-color:#23d160;color:#fff}.b-clockpicker.is-success .b-clockpicker-face:after{background-color:#23d160}.b-clockpicker.is-success .b-clockpicker-face-hand{background-color:#23d160;border-color:#23d160}.b-clockpicker.is-success .b-clockpicker-face-number.active{background-color:#23d160;color:#fff}.b-clockpicker.is-warning .card-header{background-color:#ffdd57;color:rgba(0,0,0,.7)}.b-clockpicker.is-warning .b-clockpicker-face:after{background-color:#ffdd57}.b-clockpicker.is-warning .b-clockpicker-face-hand{background-color:#ffdd57;border-color:#ffdd57}.b-clockpicker.is-warning .b-clockpicker-face-number.active{background-color:#ffdd57;color:rgba(0,0,0,.7)}.b-clockpicker.is-danger .card-header{background-color:#ff3860;color:#fff}.b-clockpicker.is-danger .b-clockpicker-face:after{background-color:#ff3860}.b-clockpicker.is-danger .b-clockpicker-face-hand{background-color:#ff3860;border-color:#ff3860}.b-clockpicker.is-danger .b-clockpicker-face-number.active{background-color:#ff3860;color:#fff}.b-clockpicker .dropdown-menu{min-width:0}.b-clockpicker .dropdown,.b-clockpicker .dropdown-trigger{width:100%}.b-clockpicker .dropdown-item,.b-clockpicker .dropdown .dropdown-menu .has-link a,.dropdown .dropdown-menu .has-link .b-clockpicker a{font-size:inherit;padding:0}.b-clockpicker .dropdown-content{padding-top:0;padding-bottom:0}.b-clockpicker .card{border-radius:4px}.b-clockpicker .card-header{border-top-left-radius:4px;border-top-right-radius:4px}.b-clockpicker .card-content{padding:12px}.b-clockpicker-btn{cursor:pointer;opacity:.6}.b-clockpicker-btn.active,.b-clockpicker-btn:hover{opacity:1}.b-clockpicker-period .b-clockpicker-btn{font-size:16px;text-transform:uppercase}.b-clockpicker-time span{align-items:center;display:inline-flex;justify-content:center}.b-clockpicker-header{display:flex;line-height:1;justify-content:flex-end;color:inherit}.b-clockpicker-header .b-clockpicker-time{white-space:nowrap}.b-clockpicker-header .b-clockpicker-time span{height:60px;font-size:60px}.b-clockpicker-header .b-clockpicker-period{align-self:flex-end;display:flex;flex-direction:column;margin:8px 0 6px 8px}.b-clockpicker-body{transition:.9s cubic-bezier(.25,.8,.5,1)}.b-clockpicker-body .b-clockpicker-btn{padding:0 8px;border-radius:290486px;margin-bottom:2px}.b-clockpicker-body .b-clockpicker-btn.active,.b-clockpicker-body .b-clockpicker-btn:hover{background-color:#7957d5;color:#fff}.b-clockpicker-body .b-clockpicker-period{position:absolute;top:5px;right:5px}.b-clockpicker-body .b-clockpicker-time{position:absolute;top:5px;left:5px;font-size:16px}.b-clockpicker-body .b-clockpicker-face{border-radius:50%;position:relative;background-color:#dbdbdb;width:100%;height:100%;align-items:center;display:flex;justify-content:center}.b-clockpicker-body .b-clockpicker-face:after{border-radius:50%;content:\"\";position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:12px;height:12px;z-index:10}.b-clockpicker-body .b-clockpicker-face-outer-ring{user-select:none;height:calc(100% - 50px);width:calc(100% - 50px);position:relative;border-radius:50%}.b-clockpicker-body .b-clockpicker-face-number{align-items:center;border-radius:100%;cursor:default;display:flex;font-size:18px;text-align:center;justify-content:center;position:absolute;width:40px;height:40px;left:calc(50% - 40px / 2);top:calc(50% - 40px / 2);user-select:none}.b-clockpicker-body .b-clockpicker-face-number>span{z-index:1}.b-clockpicker-body .b-clockpicker-face-number:after,.b-clockpicker-body .b-clockpicker-face-number:before{content:\"\";height:40px;width:40px;border-radius:100%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.b-clockpicker-body .b-clockpicker-face-number.active{cursor:default;z-index:2}.b-clockpicker-body .b-clockpicker-face-number.disabled{pointer-events:none;opacity:.25}.b-clockpicker-body .b-clockpicker-face-hand{height:calc(50% - 6px);width:2px;bottom:50%;left:calc(50% - 1px);transform-origin:center bottom;position:absolute;will-change:transform;z-index:1}.b-clockpicker-body .b-clockpicker-face-hand:before{background:transparent;border-width:2px;border-style:solid;border-color:inherit;border-radius:100%;width:12px;height:12px;content:\"\";position:absolute;top:-6px;left:50%;transform:translate(-50%,-50%)}.b-clockpicker-footer{display:block;padding:12px}.b-clockpicker.is-small{border-radius:2px;font-size:.75rem}.b-clockpicker.is-medium{font-size:1.25rem}.b-clockpicker.is-large{font-size:1.5rem}.collapse .collapse-trigger{display:inline;cursor:pointer}.collapse .collapse-content{display:inherit}.datepicker{font-size:.875rem}.datepicker .dropdown,.datepicker .dropdown-trigger{width:100%}.datepicker .dropdown-item,.datepicker .dropdown .dropdown-menu .has-link a,.dropdown .dropdown-menu .has-link .datepicker a{font-size:inherit}.datepicker .datepicker-header{padding-bottom:.875rem;margin-bottom:.875rem;border-bottom:1px solid #dbdbdb}.datepicker .datepicker-content{height:16.25rem}.datepicker .datepicker-footer{margin-top:.875rem;padding-top:.875rem;border-top:1px solid #dbdbdb}.datepicker .datepicker-table{display:table;margin:0 auto}.datepicker .datepicker-table .datepicker-cell{text-align:center;vertical-align:middle;display:table-cell;border-radius:4px;padding:.5rem .75rem}.datepicker .datepicker-table .datepicker-header{display:table-header-group}.datepicker .datepicker-table .datepicker-header .datepicker-cell{color:#7a7a7a;font-weight:600}.datepicker .datepicker-table .datepicker-body{display:table-row-group}.datepicker .datepicker-table .datepicker-body .datepicker-row{display:table-row}.datepicker .datepicker-table .datepicker-body .datepicker-months{display:inline-flex;flex-wrap:wrap;flex-direction:row;width:17rem}.datepicker .datepicker-table .datepicker-body .datepicker-months .datepicker-cell{display:flex;align-items:center;justify-content:center;width:33.33%;height:2.5rem}.datepicker .datepicker-table .datepicker-body .datepicker-cell.is-unselectable{color:#b5b5b5}.datepicker .datepicker-table .datepicker-body .datepicker-cell.is-today{border:1px solid rgba(121,87,213,.5)}.datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selectable{color:#4a4a4a}.datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selectable:focus:not(.is-selected),.datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selectable:hover:not(.is-selected){background-color:#f5f5f5;color:#0a0a0a;cursor:pointer}.datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selected{background-color:#7957d5;color:#fff}.datepicker .datepicker-table .datepicker-body .datepicker-cell.is-nearby:not(.is-selected){color:#b5b5b5}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell{padding:.3rem .75rem .75rem}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event{position:relative}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events{bottom:.425rem;display:flex;justify-content:center;left:0;padding:0 .35rem;position:absolute;width:100%}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-white{background-color:#fff}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-black{background-color:#0a0a0a}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-light{background-color:#f5f5f5}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-dark{background-color:#363636}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-link,.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-primary{background-color:#7957d5}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-info{background-color:#167df0}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-success{background-color:#23d160}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-warning{background-color:#ffdd57}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-danger{background-color:#ff3860}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event.dots .event{border-radius:50%;height:.35em;margin:0 .1em;width:.35em}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event.bars .event{height:.25em;width:100%}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.is-selected{overflow:hidden}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.is-selected .events .event.is-primary{background-color:#aa94e4}.datepicker.is-small{border-radius:2px;font-size:.75rem}.datepicker.is-medium{font-size:1.25rem}.datepicker.is-large{font-size:1.5rem}.dialog .modal-card{max-width:460px;width:auto}.dialog .modal-card .modal-card-head{font-size:1.25rem;font-weight:600}.dialog .modal-card .modal-card-body .field{margin-top:16px}.dialog .modal-card .modal-card-body.is-titleless{border-top-left-radius:6px;border-top-right-radius:6px}.dialog .modal-card .modal-card-foot{justify-content:flex-end}.dialog .modal-card .modal-card-foot .button{display:inline;min-width:5em;font-weight:600}@media print,screen and (min-width:769px){.dialog .modal-card{min-width:320px}}.dialog.is-small .button,.dialog.is-small .input,.dialog.is-small .modal-card,.dialog.is-small .taginput .taginput-container.is-focusable,.taginput .dialog.is-small .taginput-container.is-focusable{border-radius:2px;font-size:.75rem}.dialog.is-medium .button,.dialog.is-medium .input,.dialog.is-medium .modal-card,.dialog.is-medium .taginput .taginput-container.is-focusable,.taginput .dialog.is-medium .taginput-container.is-focusable{font-size:1.25rem}.dialog.is-large .button,.dialog.is-large .input,.dialog.is-large .modal-card,.dialog.is-large .taginput .taginput-container.is-focusable,.taginput .dialog.is-large .taginput-container.is-focusable{font-size:1.5rem}.dropdown+.dropdown{margin-left:.5em}.dropdown .background{bottom:0;left:0;position:absolute;right:0;top:0;position:fixed;background-color:hsla(0,0%,4%,.86);z-index:40;cursor:pointer}@media screen and (min-width:1024px){.dropdown .background{display:none}}.dropdown .dropdown-menu .dropdown-item.is-disabled,.dropdown .dropdown-menu .has-link a.is-disabled{cursor:not-allowed}.dropdown .dropdown-menu .dropdown-item.is-disabled:hover,.dropdown .dropdown-menu .has-link a.is-disabled:hover{background:inherit;color:inherit}.dropdown .dropdown-menu .has-link a{padding-right:3rem;white-space:nowrap}.dropdown:not(.is-disabled) .dropdown-menu .dropdown-item.is-disabled,.dropdown:not(.is-disabled) .dropdown-menu .has-link a.is-disabled{opacity:.5}.dropdown .navbar-item{height:100%}.dropdown.is-disabled{opacity:.5;cursor:not-allowed}.dropdown.is-disabled .dropdown-trigger{pointer-events:none}.dropdown.is-inline .dropdown-menu{position:static;display:inline-block;padding:0}.dropdown.is-top-right .dropdown-menu{top:auto;bottom:100%}.dropdown.is-top-left .dropdown-menu{top:auto;bottom:100%;right:0;left:auto}.dropdown.is-bottom-left .dropdown-menu{right:0;left:auto}@media screen and (max-width:1023px){.dropdown.is-mobile-modal .dropdown-menu{position:fixed;width:calc(100vw - 40px);max-width:460px;max-height:calc(100vh - 120px);top:25%!important;left:50%!important;bottom:auto!important;right:auto!important;transform:translate3d(-50%,-25%,0);white-space:normal;overflow-y:auto;z-index:50}.dropdown.is-mobile-modal .dropdown-menu .dropdown-item,.dropdown.is-mobile-modal .dropdown-menu .has-link a{padding:1rem 1.5rem}}.field.is-grouped .field{flex-shrink:0}.field.is-grouped .field:not(:last-child){margin-right:.75rem}.field.is-grouped .field.is-expanded{flex-grow:1;flex-shrink:1}.field.has-addons .control:first-child .control .button,.field.has-addons .control:first-child .control .input,.field.has-addons .control:first-child .control .select select,.field.has-addons .control:first-child .control .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:first-child .control .taginput-container.is-focusable{border-bottom-left-radius:4px;border-top-left-radius:4px}.field.has-addons .control:last-child .control .button,.field.has-addons .control:last-child .control .input,.field.has-addons .control:last-child .control .select select,.field.has-addons .control:last-child .control .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:last-child .control .taginput-container.is-focusable{border-bottom-right-radius:4px;border-top-right-radius:4px}.field.has-addons .control .control .button,.field.has-addons .control .control .input,.field.has-addons .control .control .select select,.field.has-addons .control .control .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control .control .taginput-container.is-focusable{border-radius:0}.field.is-floating-label{position:relative}.field.is-floating-label .label{position:absolute;top:-.775em;left:1em;font-size:0.75rem;background-color:transparent;padding-left:.125em;padding-right:.125em;z-index:5}.field.is-floating-label .label:before{content:\"\";display:block;position:absolute;top:.775em;left:0;right:0;height:.375em;background-color:#fff;z-index:-1}.field.is-floating-label .label.is-small{font-size:0.5625rem}.field.is-floating-label .label.is-medium{font-size:0.9375rem}.field.is-floating-label .label.is-large{font-size:1.125rem}.field.is-floating-label .input:focus,.field.is-floating-label .select select:focus,.field.is-floating-label .taginput .taginput-container.is-focusable:focus,.field.is-floating-label .textarea:focus,.taginput .field.is-floating-label .taginput-container.is-focusable:focus{box-shadow:none}.field.is-floating-label .taginput .taginput-container.is-focusable{padding-top:.475em}.field.is-floating-label .taginput .taginput-container.is-focusable.is-focused{box-shadow:none}.field.is-floating-in-label{position:relative}.field.is-floating-in-label .label{position:absolute;top:.25em;left:1em;font-size:0.75rem;background-color:transparent;z-index:5}.field.is-floating-in-label .label.is-small{font-size:0.5625rem}.field.is-floating-in-label .label.is-medium{font-size:0.9375rem}.field.is-floating-in-label .label.is-large{font-size:1.125rem}.field.is-floating-in-label>.datepicker .input,.field.is-floating-in-label>.datepicker .taginput .taginput-container.is-focusable,.field.is-floating-in-label>.timepicker .input,.field.is-floating-in-label>.timepicker .taginput .taginput-container.is-focusable,.field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .input,.field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .taginput .taginput-container.is-focusable,.field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .textarea,.field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) select,.taginput .field.is-floating-in-label>.datepicker .taginput-container.is-focusable,.taginput .field.is-floating-in-label>.timepicker .taginput-container.is-focusable,.taginput .field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .taginput-container.is-focusable{padding-top:calc(3.25em / 2 - 1.125rem / 2);padding-bottom:1px;height:3.25em}.field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .select:not(multiple){height:3.25em}.field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .select:not(multiple).is-loading:after{margin-top:calc(3.25em / 2 - 1.125rem / 2)}.field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .select:not(multiple):after{margin-top:1px}.field.is-floating-in-label>:not(.taginput) .is-left.icon,.field.is-floating-in-label>:not(.taginput) .is-right.icon{height:3.25em}.field.is-floating-in-label>:not(.taginput) .is-left.icon{padding-top:calc(3.25em / 2 - 1.125rem / 2)}.field.is-floating-in-label .control.is-loading:after{margin-top:calc(3.25em / 2 - 1.125rem / 2)}.field.is-floating-in-label .taginput .taginput-container.is-focusable{padding-top:calc(3.25em / 2 - 1.125rem / 2 + (.275em - 1px))}.control .help.counter{float:right;margin-left:.5em}.control .icon.is-clickable{pointer-events:auto;cursor:pointer}.icon{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:inherit}.icon svg{background-color:transparent;fill:currentColor;stroke-width:0;stroke:currentColor;pointer-events:none;width:1.5rem;height:1.5rem}.loading-overlay{bottom:0;left:0;position:absolute;right:0;top:0;align-items:center;display:none;justify-content:center;overflow:hidden}.loading-overlay.is-active{display:flex}.loading-overlay.is-full-page{z-index:999;position:fixed}.loading-overlay.is-full-page .loading-icon:after{top:calc(50% - 2.5em);left:calc(50% - 2.5em);width:5em;height:5em}.loading-overlay .loading-background{bottom:0;left:0;position:absolute;right:0;top:0;background:#7f7f7f;background:hsla(0,0%,100%,.5)}.loading-overlay .loading-icon{position:relative}.loading-overlay .loading-icon:after{animation:spinAround .5s infinite linear;border:2px solid #dbdbdb;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:1em;position:relative;width:1em;position:absolute;top:calc(50% - 1.5em);left:calc(50% - 1.5em);width:3em;height:3em;border-width:.25em}.menu .menu-list li>a.is-disabled{pointer-events:none;cursor:not-allowed;opacity:.5}.message .media,.notification .media{padding-top:0;border:0}.notification>.delete{right:.5rem!important;top:.5rem!important}.modal.is-full-screen>.animation-content,.modal.is-full-screen>.animation-content>.modal-card{width:100%;height:100%;max-height:100vh;margin:0;background-color:#fff}.modal .animation-content{margin:0 20px}.modal .animation-content .modal-card{margin:0}@media screen and (max-width:768px){.modal .animation-content{width:100%}}.modal .modal-content{width:100%}.notices{position:fixed;display:flex;top:0;bottom:0;left:0;right:0;padding:2em;overflow:hidden;z-index:1000;pointer-events:none}.notices .toast{display:inline-flex;animation-duration:.15s;margin:.5em 0;text-align:center;box-shadow:0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);border-radius:2em;padding:.75em 1.5em;pointer-events:auto;opacity:.92}.notices .toast.is-white{color:#0a0a0a;background:#fff}.notices .toast.is-black{color:#fff;background:#0a0a0a}.notices .toast.is-light{color:#363636;background:#f5f5f5}.notices .toast.is-dark{color:#f5f5f5;background:#363636}.notices .toast.is-link,.notices .toast.is-primary{color:#fff;background:#7957d5}.notices .toast.is-info{color:#fff;background:#167df0}.notices .toast.is-success{color:#fff;background:#23d160}.notices .toast.is-warning{color:rgba(0,0,0,.7);background:#ffdd57}.notices .toast.is-danger{color:#fff;background:#ff3860}.notices .snackbar{display:inline-flex;align-items:center;justify-content:space-around;animation-duration:.15s;margin:.5em 0;box-shadow:0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);border-radius:4px;pointer-events:auto;background:#363636;color:#f5f5f5;min-height:3em}.notices .snackbar .text{padding:.5em 1em}.notices .snackbar .action{margin-left:auto;padding:.5em;padding-left:0}.notices .snackbar .action .button{font-weight:600;text-transform:uppercase;background:#363636;border:transparent}.notices .snackbar .action .button:active,.notices .snackbar .action .button:hover{background:#292929}.notices .snackbar .action.is-white .button{color:#fff}.notices .snackbar .action.is-black .button{color:#0a0a0a}.notices .snackbar .action.is-light .button{color:#f5f5f5}.notices .snackbar .action.is-dark .button{color:#363636}.notices .snackbar .action.is-link .button,.notices .snackbar .action.is-primary .button{color:#7957d5}.notices .snackbar .action.is-info .button{color:#167df0}.notices .snackbar .action.is-success .button{color:#23d160}.notices .snackbar .action.is-warning .button{color:#ffdd57}.notices .snackbar .action.is-danger .button{color:#ff3860}@media screen and (max-width:768px){.notices .snackbar{width:100%;margin:0;border-radius:0}}@media print,screen and (min-width:769px){.notices .snackbar{min-width:350px;max-width:600px;overflow:hidden}}.notices .notification{max-width:600px}.notices .notification.is-bottom,.notices .notification.is-top,.notices .snackbar.is-bottom,.notices .snackbar.is-top,.notices .toast.is-bottom,.notices .toast.is-top{align-self:center}.notices .notification.is-bottom-right,.notices .notification.is-top-right,.notices .snackbar.is-bottom-right,.notices .snackbar.is-top-right,.notices .toast.is-bottom-right,.notices .toast.is-top-right{align-self:flex-end}.notices .notification.is-bottom-left,.notices .notification.is-top-left,.notices .snackbar.is-bottom-left,.notices .snackbar.is-top-left,.notices .toast.is-bottom-left,.notices .toast.is-top-left{align-self:flex-start}.notices .notification.is-toast,.notices .snackbar.is-toast,.notices .toast.is-toast{opacity:.92}.notices.is-top{flex-direction:column}.notices.is-bottom{flex-direction:column-reverse}.notices.has-custom-container{position:absolute}@media screen and (max-width:768px){.notices{padding:0;position:fixed!important}}.b-numberinput.field{margin-bottom:0}.b-numberinput.field.is-grouped div.control{flex-grow:1;flex-shrink:1}.b-numberinput input[type=number]::-webkit-inner-spin-button,.b-numberinput input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none}.b-numberinput input[type=number]{-moz-appearance:textfield;text-align:center}.b-numberinput .button.is-rounded{padding-left:.75em;padding-right:.75em}.pagination .pagination-next,.pagination .pagination-previous{padding-left:.25em;padding-right:.25em}.pagination .pagination-next.is-disabled,.pagination .pagination-previous.is-disabled{pointer-events:none;cursor:not-allowed;opacity:.5}.pagination.is-simple{justify-content:normal}.pagination.is-simple.is-centered{justify-content:center}.pagination.is-simple.is-right{justify-content:flex-end}.pagination .is-current{pointer-events:none;cursor:not-allowed}.b-radio.radio{outline:none;display:inline-flex;align-items:center;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.b-radio.radio+.radio{margin-left:.5em}.b-radio.radio input[type=radio]{position:absolute;left:0;opacity:0;outline:none;z-index:-1}.b-radio.radio input[type=radio]+.check{display:flex;flex-shrink:0;position:relative;cursor:pointer;width:1.25em;height:1.25em;transition:background .15s ease-out;border-radius:50%;border:2px solid #7a7a7a}.b-radio.radio input[type=radio]+.check:before{content:\"\";display:flex;position:absolute;left:50%;margin-left:-0.625em;bottom:50%;margin-bottom:-0.625em;width:1.25em;height:1.25em;transition:transform .15s ease-out;border-radius:50%;transform:scale(0);background-color:#7957d5}.b-radio.radio input[type=radio]+.check.is-white:before{background:#fff}.b-radio.radio input[type=radio]+.check.is-black:before{background:#0a0a0a}.b-radio.radio input[type=radio]+.check.is-light:before{background:#f5f5f5}.b-radio.radio input[type=radio]+.check.is-dark:before{background:#363636}.b-radio.radio input[type=radio]+.check.is-link:before,.b-radio.radio input[type=radio]+.check.is-primary:before{background:#7957d5}.b-radio.radio input[type=radio]+.check.is-info:before{background:#167df0}.b-radio.radio input[type=radio]+.check.is-success:before{background:#23d160}.b-radio.radio input[type=radio]+.check.is-warning:before{background:#ffdd57}.b-radio.radio input[type=radio]+.check.is-danger:before{background:#ff3860}.b-radio.radio input[type=radio]:checked+.check{border-color:#7957d5}.b-radio.radio input[type=radio]:checked+.check.is-white{border-color:#fff}.b-radio.radio input[type=radio]:checked+.check.is-black{border-color:#0a0a0a}.b-radio.radio input[type=radio]:checked+.check.is-light{border-color:#f5f5f5}.b-radio.radio input[type=radio]:checked+.check.is-dark{border-color:#363636}.b-radio.radio input[type=radio]:checked+.check.is-link,.b-radio.radio input[type=radio]:checked+.check.is-primary{border-color:#7957d5}.b-radio.radio input[type=radio]:checked+.check.is-info{border-color:#167df0}.b-radio.radio input[type=radio]:checked+.check.is-success{border-color:#23d160}.b-radio.radio input[type=radio]:checked+.check.is-warning{border-color:#ffdd57}.b-radio.radio input[type=radio]:checked+.check.is-danger{border-color:#ff3860}.b-radio.radio input[type=radio]:checked+.check:before{transform:scale(.5)}.b-radio.radio .control-label{padding-left:.5em}.b-radio.radio[disabled]{opacity:.5}.b-radio.radio:hover input[type=radio]:not(:disabled)+.check{border-color:#7957d5}.b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-white{border-color:#fff}.b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-black{border-color:#0a0a0a}.b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-light{border-color:#f5f5f5}.b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-dark{border-color:#363636}.b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-link,.b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-primary{border-color:#7957d5}.b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-info{border-color:#167df0}.b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-success{border-color:#23d160}.b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-warning{border-color:#ffdd57}.b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-danger{border-color:#ff3860}.b-radio.radio:focus input[type=radio]+.check{box-shadow:0 0 .5em hsla(0,0%,48%,.8)}.b-radio.radio:focus input[type=radio]:checked+.check{box-shadow:0 0 .5em rgba(121,87,213,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-white{box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-black{box-shadow:0 0 .5em hsla(0,0%,4%,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-light{box-shadow:0 0 .5em hsla(0,0%,96%,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-dark{box-shadow:0 0 .5em rgba(54,54,54,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-link,.b-radio.radio:focus input[type=radio]:checked+.check.is-primary{box-shadow:0 0 .5em rgba(121,87,213,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-info{box-shadow:0 0 .5em rgba(22,125,240,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-success{box-shadow:0 0 .5em rgba(35,209,96,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-warning{box-shadow:0 0 .5em rgba(255,221,87,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-danger{box-shadow:0 0 .5em rgba(255,56,96,.8)}.b-radio.radio.is-small{border-radius:2px;font-size:.75rem}.b-radio.radio.is-medium{font-size:1.25rem}.b-radio.radio.is-large{font-size:1.5rem}.select select{padding-right:2.5em}.select select option{color:#4a4a4a;padding:.25em .5em}.select select option:disabled{cursor:not-allowed;opacity:.5}.select select optgroup{color:#b5b5b5;font-weight:400;font-style:normal;padding:.25em 0}.select.is-empty select{color:hsla(0,0%,48%,.7)}.b-steps .steps{font-size:1rem;min-height:2rem}.b-steps .steps .step-items{display:flex;flex-wrap:wrap}.b-steps .steps .step-items .step-item{margin-top:0;position:relative;flex-grow:1;flex-basis:0}.b-steps .steps .step-items .step-item .step-link{color:#4a4a4a}.b-steps .steps .step-items .step-item .step-link:not(.is-clickable){cursor:not-allowed}.b-steps .steps .step-items .step-item .step-marker{align-items:center;display:flex;border-radius:50%;font-weight:700;justify-content:center;background:#b5b5b5;border:.2em solid #fff;z-index:1}.b-steps .steps .step-items .step-item.is-white:before{background:linear-gradient(270deg,#dbdbdb 50%,#fff 0);background-size:200% 100%;background-position:100% 100%}.b-steps .steps .step-items .step-item.is-white.is-active .step-marker{background-color:#fff;border-color:#fff;color:#fff}.b-steps .steps .step-items .step-item.is-white.is-active:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-white.is-completed .step-marker{color:#0a0a0a;background-color:#fff}.b-steps .steps .step-items .step-item.is-white.is-completed:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-black:before{background:linear-gradient(270deg,#dbdbdb 50%,#0a0a0a 0);background-size:200% 100%;background-position:100% 100%}.b-steps .steps .step-items .step-item.is-black.is-active .step-marker{background-color:#fff;border-color:#0a0a0a;color:#0a0a0a}.b-steps .steps .step-items .step-item.is-black.is-active:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-black.is-completed .step-marker{color:#fff;background-color:#0a0a0a}.b-steps .steps .step-items .step-item.is-black.is-completed:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-light:before{background:linear-gradient(270deg,#dbdbdb 50%,#f5f5f5 0);background-size:200% 100%;background-position:100% 100%}.b-steps .steps .step-items .step-item.is-light.is-active .step-marker{background-color:#fff;border-color:#f5f5f5;color:#f5f5f5}.b-steps .steps .step-items .step-item.is-light.is-active:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-light.is-completed .step-marker{color:#363636;background-color:#f5f5f5}.b-steps .steps .step-items .step-item.is-light.is-completed:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-dark:before{background:linear-gradient(270deg,#dbdbdb 50%,#363636 0);background-size:200% 100%;background-position:100% 100%}.b-steps .steps .step-items .step-item.is-dark.is-active .step-marker{background-color:#fff;border-color:#363636;color:#363636}.b-steps .steps .step-items .step-item.is-dark.is-active:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-dark.is-completed .step-marker{color:#f5f5f5;background-color:#363636}.b-steps .steps .step-items .step-item.is-dark.is-completed:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-primary:before{background:linear-gradient(270deg,#dbdbdb 50%,#7957d5 0);background-size:200% 100%;background-position:100% 100%}.b-steps .steps .step-items .step-item.is-primary.is-active .step-marker{background-color:#fff;border-color:#7957d5;color:#7957d5}.b-steps .steps .step-items .step-item.is-primary.is-active:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-primary.is-completed .step-marker{color:#fff;background-color:#7957d5}.b-steps .steps .step-items .step-item.is-primary.is-completed:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-link:before{background:linear-gradient(270deg,#dbdbdb 50%,#7957d5 0);background-size:200% 100%;background-position:100% 100%}.b-steps .steps .step-items .step-item.is-link.is-active .step-marker{background-color:#fff;border-color:#7957d5;color:#7957d5}.b-steps .steps .step-items .step-item.is-link.is-active:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-link.is-completed .step-marker{color:#fff;background-color:#7957d5}.b-steps .steps .step-items .step-item.is-link.is-completed:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-info:before{background:linear-gradient(270deg,#dbdbdb 50%,#167df0 0);background-size:200% 100%;background-position:100% 100%}.b-steps .steps .step-items .step-item.is-info.is-active .step-marker{background-color:#fff;border-color:#167df0;color:#167df0}.b-steps .steps .step-items .step-item.is-info.is-active:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-info.is-completed .step-marker{color:#fff;background-color:#167df0}.b-steps .steps .step-items .step-item.is-info.is-completed:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-success:before{background:linear-gradient(270deg,#dbdbdb 50%,#23d160 0);background-size:200% 100%;background-position:100% 100%}.b-steps .steps .step-items .step-item.is-success.is-active .step-marker{background-color:#fff;border-color:#23d160;color:#23d160}.b-steps .steps .step-items .step-item.is-success.is-active:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-success.is-completed .step-marker{color:#fff;background-color:#23d160}.b-steps .steps .step-items .step-item.is-success.is-completed:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-warning:before{background:linear-gradient(270deg,#dbdbdb 50%,#ffdd57 0);background-size:200% 100%;background-position:100% 100%}.b-steps .steps .step-items .step-item.is-warning.is-active .step-marker{background-color:#fff;border-color:#ffdd57;color:#ffdd57}.b-steps .steps .step-items .step-item.is-warning.is-active:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-warning.is-completed .step-marker{color:rgba(0,0,0,.7);background-color:#ffdd57}.b-steps .steps .step-items .step-item.is-warning.is-completed:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-danger:before{background:linear-gradient(270deg,#dbdbdb 50%,#ff3860 0);background-size:200% 100%;background-position:100% 100%}.b-steps .steps .step-items .step-item.is-danger.is-active .step-marker{background-color:#fff;border-color:#ff3860;color:#ff3860}.b-steps .steps .step-items .step-item.is-danger.is-active:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-danger.is-completed .step-marker{color:#fff;background-color:#ff3860}.b-steps .steps .step-items .step-item.is-danger.is-completed:before{background-position:0 100%}.b-steps .steps .step-items .step-item .step-marker{color:#fff}.b-steps .steps .step-items .step-item .step-details{text-align:center}.b-steps .steps .step-items .step-item:not(:first-child){flex-basis:1em;flex-grow:1;flex-shrink:1}.b-steps .steps .step-items .step-item:not(:first-child):before{content:\" \";display:block;position:absolute}.b-steps .steps .step-items .step-item:before{background:linear-gradient(270deg,#dbdbdb 50%,#7957d5 0);background-size:200% 100%;background-position:100% 100%}.b-steps .steps .step-items .step-item.is-active .step-link{cursor:default}.b-steps .steps .step-items .step-item.is-active .step-marker{background-color:#fff;border-color:#7957d5;color:#7957d5}.b-steps .steps .step-items .step-item.is-active:before{background-position:0 100%}.b-steps .steps .step-items .step-item.is-completed .step-marker{color:#fff;background-color:#7957d5}.b-steps .steps .step-items .step-item.is-completed:before{background-position:0 100%}.b-steps .steps+.step-content{position:relative;overflow:visible;display:flex;flex-direction:column;padding:1rem}.b-steps .steps+.step-content .step-item{flex-shrink:0;flex-basis:auto}.b-steps .steps+.step-content.is-transitioning{overflow:hidden}.b-steps .steps .step-items .step-item .step-marker{height:2rem;width:2rem;position:absolute;left:calc(50% - 1rem)}.b-steps .steps .step-items .step-item .step-marker .icon *,.b-steps .steps .step-items .step-item .step-marker .icon :before{font-size:1rem}.b-steps .steps .step-items .step-item .step-details{margin-top:2rem;margin-left:.5em;margin-right:.5em;padding-top:.2em}.b-steps .steps .step-items .step-item .step-details .step-title{font-size:1.2rem;font-weight:600}.b-steps .steps .step-items .step-item:not(:first-child):before{height:.2em;width:100%;bottom:0;left:-50%;top:1rem}.b-steps .steps.is-small{font-size:.75rem;min-height:1.5rem}.b-steps .steps.is-small .step-items .step-item .step-marker{height:1.5rem;width:1.5rem;position:absolute;left:calc(50% - .75rem)}.b-steps .steps.is-small .step-items .step-item .step-marker .icon *,.b-steps .steps.is-small .step-items .step-item .step-marker .icon :before{font-size:.75rem}.b-steps .steps.is-small .step-items .step-item .step-details{margin-top:1.5rem;margin-left:.5em;margin-right:.5em;padding-top:.2em}.b-steps .steps.is-small .step-items .step-item .step-details .step-title{font-size:.9rem;font-weight:600}.b-steps .steps.is-small .step-items .step-item:not(:first-child):before{height:.2em;width:100%;bottom:0;left:-50%;top:.75rem}.b-steps .steps.is-medium{font-size:1.25rem;min-height:2.5rem}.b-steps .steps.is-medium .step-items .step-item .step-marker{height:2.5rem;width:2.5rem;position:absolute;left:calc(50% - 1.25rem)}.b-steps .steps.is-medium .step-items .step-item .step-marker .icon *,.b-steps .steps.is-medium .step-items .step-item .step-marker .icon :before{font-size:1.25rem}.b-steps .steps.is-medium .step-items .step-item .step-details{margin-top:2.5rem;margin-left:.5em;margin-right:.5em;padding-top:.2em}.b-steps .steps.is-medium .step-items .step-item .step-details .step-title{font-size:1.5rem;font-weight:600}.b-steps .steps.is-medium .step-items .step-item:not(:first-child):before{height:.2em;width:100%;bottom:0;left:-50%;top:1.25rem}.b-steps .steps.is-large{font-size:1.5rem;min-height:3rem}.b-steps .steps.is-large .step-items .step-item .step-marker{height:3rem;width:3rem;position:absolute;left:calc(50% - 1.5rem)}.b-steps .steps.is-large .step-items .step-item .step-marker .icon *,.b-steps .steps.is-large .step-items .step-item .step-marker .icon :before{font-size:1.5rem}.b-steps .steps.is-large .step-items .step-item .step-details{margin-top:3rem;margin-left:.5em;margin-right:.5em;padding-top:.2em}.b-steps .steps.is-large .step-items .step-item .step-details .step-title{font-size:1.8rem;font-weight:600}.b-steps .steps.is-large .step-items .step-item:not(:first-child):before{height:.2em;width:100%;bottom:0;left:-50%;top:1.5rem}.switch{cursor:pointer;display:inline-flex;align-items:center;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.switch+.switch{margin-left:.5em}.switch input[type=checkbox]{position:absolute;left:0;opacity:0;outline:none;z-index:-1}.switch input[type=checkbox]+.check{display:flex;align-items:center;flex-shrink:0;width:2.75em;height:1.575em;padding:.2em;background:#b5b5b5;border-radius:1em;transition:background .15s ease-out}.switch input[type=checkbox]+.check:before{content:\"\";display:block;border-radius:1em;width:1.175em;height:1.175em;background:#f5f5f5;box-shadow:0 3px 1px 0 rgba(0,0,0,.05),0 2px 2px 0 rgba(0,0,0,.1),0 3px 3px 0 rgba(0,0,0,.05);transition:transform .15s ease-out,width .15s ease-out;will-change:transform}.switch input[type=checkbox]+.check.is-elastic:before{width:1.75em}.switch input[type=checkbox]:checked+.check{background:#7957d5}.switch input[type=checkbox]:checked+.check.is-white{background:#fff}.switch input[type=checkbox]:checked+.check.is-black{background:#0a0a0a}.switch input[type=checkbox]:checked+.check.is-light{background:#f5f5f5}.switch input[type=checkbox]:checked+.check.is-dark{background:#363636}.switch input[type=checkbox]:checked+.check.is-link,.switch input[type=checkbox]:checked+.check.is-primary{background:#7957d5}.switch input[type=checkbox]:checked+.check.is-info{background:#167df0}.switch input[type=checkbox]:checked+.check.is-success{background:#23d160}.switch input[type=checkbox]:checked+.check.is-warning{background:#ffdd57}.switch input[type=checkbox]:checked+.check.is-danger{background:#ff3860}.switch input[type=checkbox]:checked+.check:before{transform:translate3d(100%,0,0)}.switch input[type=checkbox]:checked+.check.is-elastic:before{transform:translate3d(36.36364%,0,0)}.switch input[type=checkbox]:focus{outline:none}.switch input[type=checkbox]:focus+.check{box-shadow:0 0 .5em hsla(0,0%,48%,.6)}.switch input[type=checkbox]:focus:checked+.check{box-shadow:0 0 .5em rgba(121,87,213,.8)}.switch input[type=checkbox]:focus:checked+.check.is-white{box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.switch input[type=checkbox]:focus:checked+.check.is-black{box-shadow:0 0 .5em hsla(0,0%,4%,.8)}.switch input[type=checkbox]:focus:checked+.check.is-light{box-shadow:0 0 .5em hsla(0,0%,96%,.8)}.switch input[type=checkbox]:focus:checked+.check.is-dark{box-shadow:0 0 .5em rgba(54,54,54,.8)}.switch input[type=checkbox]:focus:checked+.check.is-link,.switch input[type=checkbox]:focus:checked+.check.is-primary{box-shadow:0 0 .5em rgba(121,87,213,.8)}.switch input[type=checkbox]:focus:checked+.check.is-info{box-shadow:0 0 .5em rgba(22,125,240,.8)}.switch input[type=checkbox]:focus:checked+.check.is-success{box-shadow:0 0 .5em rgba(35,209,96,.8)}.switch input[type=checkbox]:focus:checked+.check.is-warning{box-shadow:0 0 .5em rgba(255,221,87,.8)}.switch input[type=checkbox]:focus:checked+.check.is-danger{box-shadow:0 0 .5em rgba(255,56,96,.8)}.switch .control-label{padding-left:.5em}.switch:hover input[type=checkbox]+.check{background:hsla(0,0%,71%,.9)}.switch:hover input[type=checkbox]:checked+.check{background:rgba(121,87,213,.9)}.switch:hover input[type=checkbox]:checked+.check.is-white{background:hsla(0,0%,100%,.9)}.switch:hover input[type=checkbox]:checked+.check.is-black{background:hsla(0,0%,4%,.9)}.switch:hover input[type=checkbox]:checked+.check.is-light{background:hsla(0,0%,96%,.9)}.switch:hover input[type=checkbox]:checked+.check.is-dark{background:rgba(54,54,54,.9)}.switch:hover input[type=checkbox]:checked+.check.is-link,.switch:hover input[type=checkbox]:checked+.check.is-primary{background:rgba(121,87,213,.9)}.switch:hover input[type=checkbox]:checked+.check.is-info{background:rgba(22,125,240,.9)}.switch:hover input[type=checkbox]:checked+.check.is-success{background:rgba(35,209,96,.9)}.switch:hover input[type=checkbox]:checked+.check.is-warning{background:rgba(255,221,87,.9)}.switch:hover input[type=checkbox]:checked+.check.is-danger{background:rgba(255,56,96,.9)}.switch.is-small{border-radius:2px;font-size:.75rem}.switch.is-medium{font-size:1.25rem}.switch.is-large{font-size:1.5rem}.switch[disabled]{opacity:.5;cursor:not-allowed;color:#7a7a7a}.table-wrapper .table{margin-bottom:0}.table-wrapper:not(:last-child){margin-bottom:1.5rem}@media screen and (max-width:1023px){.table-wrapper{overflow-x:auto}}.b-table{transition:opacity 86ms ease-out}@media print,screen and (min-width:769px){.b-table .table-mobile-sort{display:none}}.b-table .icon{transition:transform .15s ease-out,opacity 86ms ease-out}.b-table .icon.is-desc{transform:rotate(180deg)}.b-table .icon.is-expanded{transform:rotate(90deg)}.b-table .table{width:100%;border:1px solid transparent;border-radius:4px;border-collapse:separate}.b-table .table th{font-weight:600}.b-table .table th .th-wrap{display:flex;align-items:center}.b-table .table th .th-wrap .icon{margin-left:.5rem;margin-right:0;font-size:1rem}.b-table .table th .th-wrap.is-numeric{flex-direction:row-reverse;text-align:right}.b-table .table th .th-wrap.is-numeric .icon{margin-left:0;margin-right:.5rem}.b-table .table th .th-wrap.is-centered{justify-content:center;text-align:center}.b-table .table th.is-current-sort{border-color:#7a7a7a;font-weight:700}.b-table .table th.is-sortable:hover{border-color:#7a7a7a}.b-table .table th.is-sortable,.b-table .table th.is-sortable .th-wrap{cursor:pointer}.b-table .table tr.is-selected .checkbox input:checked+.check{background:#fff url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%237957d5'/%3E%3C/svg%3E\") no-repeat 50%}.b-table .table tr.is-selected .checkbox input+.check{border-color:#fff}.b-table .table tr.is-empty:hover{background-color:transparent}.b-table .table .chevron-cell{vertical-align:middle}.b-table .table .checkbox-cell{width:40px}.b-table .table .checkbox-cell .checkbox{vertical-align:middle}.b-table .table .checkbox-cell .checkbox .check{transition:none}.b-table .table tr.detail{box-shadow:inset 0 1px 3px #dbdbdb;background:#fafafa}.b-table .table tr.detail .detail-container{padding:1rem}.b-table .table:focus{border-color:#7957d5;box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.b-table .table.is-bordered th.is-current-sort,.b-table .table.is-bordered th.is-sortable:hover{border-color:#dbdbdb;background:#f5f5f5}@media screen and (max-width:768px){.b-table .table.has-mobile-cards thead{display:none}.b-table .table.has-mobile-cards tfoot th{border:0;display:inherit}.b-table .table.has-mobile-cards tr{box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);max-width:100%;position:relative;display:block}.b-table .table.has-mobile-cards tr td{border:0;display:inherit}.b-table .table.has-mobile-cards tr td:last-child{border-bottom:0}.b-table .table.has-mobile-cards tr:not(:last-child){margin-bottom:1rem}.b-table .table.has-mobile-cards tr:not([class*=is-]){background:inherit}.b-table .table.has-mobile-cards tr:not([class*=is-]):hover{background-color:inherit}.b-table .table.has-mobile-cards tr.detail{margin-top:-1rem}.b-table .table.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td{display:flex;width:auto;justify-content:space-between;text-align:right;border-bottom:1px solid #f5f5f5}.b-table .table.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td:before{content:attr(data-label);font-weight:600;padding-right:.5em;text-align:left}}.b-table .level:not(.top){padding-bottom:1.5rem}.b-table.is-loading{position:relative;pointer-events:none;opacity:.5}.b-table.is-loading:after{animation:spinAround .5s infinite linear;border:2px solid #dbdbdb;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:1em;position:relative;width:1em;position:absolute;top:4em;left:calc(50% - 2.5em);width:5em;height:5em;border-width:.25em}.b-tabs .tabs{margin-bottom:0;flex-shrink:0}.b-tabs .tabs li.is-disabled{pointer-events:none;cursor:not-allowed;opacity:.5}.b-tabs .tab-content{position:relative;overflow:visible;display:flex;flex-direction:column;padding:1rem}.b-tabs .tab-content .tab-item{flex-shrink:0;flex-basis:auto}.b-tabs .tab-content.is-transitioning{overflow:hidden}.b-tabs:not(:last-child){margin-bottom:1.5rem}.b-tabs.is-fullwidth{width:100%}.tag .has-ellipsis{max-width:10em;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.taginput .taginput-container.is-focusable{padding-bottom:0;padding-top:calc(.275em - 1px);padding-left:0;align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start;height:auto;cursor:text}.taginput .taginput-container>.tag,.taginput .taginput-container>.tags{margin-bottom:calc(.275em - 1px);font-size:.9em;height:1.7em}.taginput .taginput-container>.tag .tag,.taginput .taginput-container>.tags .tag{margin-bottom:0;font-size:.9em;height:1.7em}.taginput .taginput-container>.tag:not(:last-child),.taginput .taginput-container>.tags:not(:last-child){margin-left:.275rem}.taginput .taginput-container .autocomplete{flex:1}.taginput .taginput-container .autocomplete input{height:1.7em;margin-bottom:calc(.275em - 1px);padding-top:0;padding-bottom:0;border:none;box-shadow:none;min-width:8em}.taginput .taginput-container .autocomplete input:focus{box-shadow:none!important}.taginput .taginput-container .autocomplete .icon{height:1.7em}.taginput .taginput-container .autocomplete>.control.is-loading:after{top:.375em}.timepicker .dropdown-menu{min-width:0}.timepicker .dropdown,.timepicker .dropdown-trigger{width:100%}.dropdown .dropdown-menu .has-link .timepicker a,.timepicker .dropdown-item,.timepicker .dropdown .dropdown-menu .has-link a{font-size:inherit;padding:0}.timepicker .timepicker-footer{padding:0 .5rem}.timepicker .dropdown-content .control{font-size:1.25em;margin-right:0!important}.timepicker .dropdown-content .control .select select{font-weight:600;padding-right:calc(.625em - 1px);border:0}.timepicker .dropdown-content .control .select select option:disabled{color:hsla(0,0%,48%,.7)}.timepicker .dropdown-content .control .select:after{display:none}.timepicker .dropdown-content .control.is-colon{font-size:1.7em}.timepicker.is-small{border-radius:2px;font-size:.75rem}.timepicker.is-medium{font-size:1.25rem}.timepicker.is-large{font-size:1.5rem}.b-tooltip{position:relative;display:inline-flex}.b-tooltip.is-top:after,.b-tooltip.is-top:before{top:auto;right:auto;bottom:calc(100% + 5px + 2px);left:50%;transform:translateX(-50%)}.b-tooltip.is-top.is-white:before{border-top:5px solid #fff}.b-tooltip.is-top.is-black:before,.b-tooltip.is-top.is-white:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.b-tooltip.is-top.is-black:before{border-top:5px solid #0a0a0a}.b-tooltip.is-top.is-light:before{border-top:5px solid #f5f5f5}.b-tooltip.is-top.is-dark:before,.b-tooltip.is-top.is-light:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.b-tooltip.is-top.is-dark:before{border-top:5px solid #363636}.b-tooltip.is-top.is-link:before,.b-tooltip.is-top.is-primary:before{border-top:5px solid #7957d5;border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.b-tooltip.is-top.is-info:before{border-top:5px solid #167df0}.b-tooltip.is-top.is-info:before,.b-tooltip.is-top.is-success:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.b-tooltip.is-top.is-success:before{border-top:5px solid #23d160}.b-tooltip.is-top.is-warning:before{border-top:5px solid #ffdd57}.b-tooltip.is-top.is-danger:before,.b-tooltip.is-top.is-warning:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.b-tooltip.is-top.is-danger:before{border-top:5px solid #ff3860}.b-tooltip.is-top.is-multiline.is-small:after{width:180px}.b-tooltip.is-top.is-multiline.is-medium:after{width:240px}.b-tooltip.is-top.is-multiline.is-large:after{width:300px}.b-tooltip.is-right:after,.b-tooltip.is-right:before{top:50%;right:auto;bottom:auto;left:calc(100% + 5px + 2px);transform:translateY(-50%)}.b-tooltip.is-right.is-white:before{border-right:5px solid #fff}.b-tooltip.is-right.is-black:before,.b-tooltip.is-right.is-white:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.b-tooltip.is-right.is-black:before{border-right:5px solid #0a0a0a}.b-tooltip.is-right.is-light:before{border-right:5px solid #f5f5f5}.b-tooltip.is-right.is-dark:before,.b-tooltip.is-right.is-light:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.b-tooltip.is-right.is-dark:before{border-right:5px solid #363636}.b-tooltip.is-right.is-link:before,.b-tooltip.is-right.is-primary:before{border-top:5px solid transparent;border-right:5px solid #7957d5;border-bottom:5px solid transparent;left:calc(100% + 2px)}.b-tooltip.is-right.is-info:before{border-right:5px solid #167df0}.b-tooltip.is-right.is-info:before,.b-tooltip.is-right.is-success:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.b-tooltip.is-right.is-success:before{border-right:5px solid #23d160}.b-tooltip.is-right.is-warning:before{border-right:5px solid #ffdd57}.b-tooltip.is-right.is-danger:before,.b-tooltip.is-right.is-warning:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.b-tooltip.is-right.is-danger:before{border-right:5px solid #ff3860}.b-tooltip.is-right.is-multiline.is-small:after{width:180px}.b-tooltip.is-right.is-multiline.is-medium:after{width:240px}.b-tooltip.is-right.is-multiline.is-large:after{width:300px}.b-tooltip.is-bottom:after,.b-tooltip.is-bottom:before{top:calc(100% + 5px + 2px);right:auto;bottom:auto;left:50%;transform:translateX(-50%)}.b-tooltip.is-bottom.is-white:before{border-bottom:5px solid #fff}.b-tooltip.is-bottom.is-black:before,.b-tooltip.is-bottom.is-white:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.b-tooltip.is-bottom.is-black:before{border-bottom:5px solid #0a0a0a}.b-tooltip.is-bottom.is-light:before{border-bottom:5px solid #f5f5f5}.b-tooltip.is-bottom.is-dark:before,.b-tooltip.is-bottom.is-light:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.b-tooltip.is-bottom.is-dark:before{border-bottom:5px solid #363636}.b-tooltip.is-bottom.is-link:before,.b-tooltip.is-bottom.is-primary:before{border-right:5px solid transparent;border-bottom:5px solid #7957d5;border-left:5px solid transparent;top:calc(100% + 2px)}.b-tooltip.is-bottom.is-info:before{border-bottom:5px solid #167df0}.b-tooltip.is-bottom.is-info:before,.b-tooltip.is-bottom.is-success:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.b-tooltip.is-bottom.is-success:before{border-bottom:5px solid #23d160}.b-tooltip.is-bottom.is-warning:before{border-bottom:5px solid #ffdd57}.b-tooltip.is-bottom.is-danger:before,.b-tooltip.is-bottom.is-warning:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.b-tooltip.is-bottom.is-danger:before{border-bottom:5px solid #ff3860}.b-tooltip.is-bottom.is-multiline.is-small:after{width:180px}.b-tooltip.is-bottom.is-multiline.is-medium:after{width:240px}.b-tooltip.is-bottom.is-multiline.is-large:after{width:300px}.b-tooltip.is-left:after,.b-tooltip.is-left:before{top:50%;right:calc(100% + 5px + 2px);bottom:auto;left:auto;transform:translateY(-50%)}.b-tooltip.is-left.is-white:before{border-left:5px solid #fff}.b-tooltip.is-left.is-black:before,.b-tooltip.is-left.is-white:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.b-tooltip.is-left.is-black:before{border-left:5px solid #0a0a0a}.b-tooltip.is-left.is-light:before{border-left:5px solid #f5f5f5}.b-tooltip.is-left.is-dark:before,.b-tooltip.is-left.is-light:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.b-tooltip.is-left.is-dark:before{border-left:5px solid #363636}.b-tooltip.is-left.is-link:before,.b-tooltip.is-left.is-primary:before{border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #7957d5;right:calc(100% + 2px)}.b-tooltip.is-left.is-info:before{border-left:5px solid #167df0}.b-tooltip.is-left.is-info:before,.b-tooltip.is-left.is-success:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.b-tooltip.is-left.is-success:before{border-left:5px solid #23d160}.b-tooltip.is-left.is-warning:before{border-left:5px solid #ffdd57}.b-tooltip.is-left.is-danger:before,.b-tooltip.is-left.is-warning:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.b-tooltip.is-left.is-danger:before{border-left:5px solid #ff3860}.b-tooltip.is-left.is-multiline.is-small:after{width:180px}.b-tooltip.is-left.is-multiline.is-medium:after{width:240px}.b-tooltip.is-left.is-multiline.is-large:after{width:300px}.b-tooltip:after,.b-tooltip:before{position:absolute;content:\"\";opacity:0;visibility:hidden;pointer-events:none}.b-tooltip:before{z-index:889}.b-tooltip:after{content:attr(data-label);width:auto;padding:.35rem .75rem;border-radius:6px;font-size:.85rem;font-weight:400;box-shadow:0 1px 2px 1px rgba(0,1,0,.2);z-index:888;white-space:nowrap}.b-tooltip:not([data-label=\"\"]):hover:after,.b-tooltip:not([data-label=\"\"]):hover:before{transition-delay:inherit;opacity:1;visibility:visible}.b-tooltip.is-white:after{background:#fff;color:#0a0a0a}.b-tooltip.is-black:after{background:#0a0a0a;color:#fff}.b-tooltip.is-light:after{background:#f5f5f5;color:#363636}.b-tooltip.is-dark:after{background:#363636;color:#f5f5f5}.b-tooltip.is-link:after,.b-tooltip.is-primary:after{background:#7957d5;color:#fff}.b-tooltip.is-info:after{background:#167df0;color:#fff}.b-tooltip.is-success:after{background:#23d160;color:#fff}.b-tooltip.is-warning:after{background:#ffdd57;color:rgba(0,0,0,.7)}.b-tooltip.is-danger:after{background:#ff3860;color:#fff}.b-tooltip:not([data-label=\"\"]).is-always:after,.b-tooltip:not([data-label=\"\"]).is-always:before{opacity:1;visibility:visible}.b-tooltip.is-multiline:after{display:flex-block;text-align:center;white-space:normal}.b-tooltip.is-dashed{border-bottom:1px dashed #b5b5b5;cursor:default}.b-tooltip.is-square:after{border-radius:0}.b-tooltip.is-animated:after,.b-tooltip.is-animated:before{transition:opacity 86ms ease-out,visibility 86ms ease-out}.upload{position:relative;display:inline-flex}.upload input[type=file]{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;outline:none;cursor:pointer}.upload input[type=file].file-draggable{z-index:-1}.upload .upload-draggable{cursor:pointer;padding:.25em;border:1px dashed #b5b5b5;border-radius:6px}.upload .upload-draggable.is-disabled{opacity:.5;cursor:not-allowed}.upload .upload-draggable.is-loading{position:relative;pointer-events:none;opacity:.5}.upload .upload-draggable.is-loading:after{animation:spinAround .5s infinite linear;border:2px solid #dbdbdb;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:1em;position:relative;width:1em;top:0;left:calc(50% - 1.5em);width:3em;height:3em;border-width:.25em}.upload .upload-draggable.is-hovered.is-white,.upload .upload-draggable:hover.is-white{border-color:#fff;background:hsla(0,0%,100%,.05)}.upload .upload-draggable.is-hovered.is-black,.upload .upload-draggable:hover.is-black{border-color:#0a0a0a;background:hsla(0,0%,4%,.05)}.upload .upload-draggable.is-hovered.is-light,.upload .upload-draggable:hover.is-light{border-color:#f5f5f5;background:hsla(0,0%,96%,.05)}.upload .upload-draggable.is-hovered.is-dark,.upload .upload-draggable:hover.is-dark{border-color:#363636;background:rgba(54,54,54,.05)}.upload .upload-draggable.is-hovered.is-link,.upload .upload-draggable.is-hovered.is-primary,.upload .upload-draggable:hover.is-link,.upload .upload-draggable:hover.is-primary{border-color:#7957d5;background:rgba(121,87,213,.05)}.upload .upload-draggable.is-hovered.is-info,.upload .upload-draggable:hover.is-info{border-color:#167df0;background:rgba(22,125,240,.05)}.upload .upload-draggable.is-hovered.is-success,.upload .upload-draggable:hover.is-success{border-color:#23d160;background:rgba(35,209,96,.05)}.upload .upload-draggable.is-hovered.is-warning,.upload .upload-draggable:hover.is-warning{border-color:#ffdd57;background:rgba(255,221,87,.05)}.upload .upload-draggable.is-hovered.is-danger,.upload .upload-draggable:hover.is-danger{border-color:#ff3860;background:rgba(255,56,96,.05)}", ""]);

// exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (global, factory) {
    ( false ? 'undefined' : _typeof2(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.vueMoment = {});
})(this, function (exports) {
    'use strict';

    var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function commonjsRequire() {
        throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
    }

    function createCommonjsModule(fn, module) {
        return module = { exports: {} }, fn(module, module.exports), module.exports;
    }

    var moment = createCommonjsModule(function (module, exports) {
        var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
            return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
        } : function (obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
        };

        //! moment.js

        (function (global, factory) {
            _typeof(exports) === 'object' && 'object' !== 'undefined' ? module.exports = factory() :  false ? undefined(factory) : global.moment = factory();
        })(commonjsGlobal, function () {
            var hookCallback;

            function hooks() {
                return hookCallback.apply(null, arguments);
            }

            // This is done to register the method called with moment()
            // without creating circular dependencies.
            function setHookCallback(callback) {
                hookCallback = callback;
            }

            function isArray(input) {
                return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
            }

            function isObject(input) {
                // IE8 will treat undefined and null as object if it wasn't for
                // input != null
                return input != null && Object.prototype.toString.call(input) === '[object Object]';
            }

            function isObjectEmpty(obj) {
                if (Object.getOwnPropertyNames) {
                    return Object.getOwnPropertyNames(obj).length === 0;
                } else {
                    var k;
                    for (k in obj) {
                        if (obj.hasOwnProperty(k)) {
                            return false;
                        }
                    }
                    return true;
                }
            }

            function isUndefined(input) {
                return input === void 0;
            }

            function isNumber(input) {
                return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
            }

            function isDate(input) {
                return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
            }

            function map(arr, fn) {
                var res = [],
                    i;
                for (i = 0; i < arr.length; ++i) {
                    res.push(fn(arr[i], i));
                }
                return res;
            }

            function hasOwnProp(a, b) {
                return Object.prototype.hasOwnProperty.call(a, b);
            }

            function extend(a, b) {
                for (var i in b) {
                    if (hasOwnProp(b, i)) {
                        a[i] = b[i];
                    }
                }

                if (hasOwnProp(b, 'toString')) {
                    a.toString = b.toString;
                }

                if (hasOwnProp(b, 'valueOf')) {
                    a.valueOf = b.valueOf;
                }

                return a;
            }

            function createUTC(input, format, locale, strict) {
                return createLocalOrUTC(input, format, locale, strict, true).utc();
            }

            function defaultParsingFlags() {
                // We need to deep clone this object.
                return {
                    empty: false,
                    unusedTokens: [],
                    unusedInput: [],
                    overflow: -2,
                    charsLeftOver: 0,
                    nullInput: false,
                    invalidMonth: null,
                    invalidFormat: false,
                    userInvalidated: false,
                    iso: false,
                    parsedDateParts: [],
                    meridiem: null,
                    rfc2822: false,
                    weekdayMismatch: false
                };
            }

            function getParsingFlags(m) {
                if (m._pf == null) {
                    m._pf = defaultParsingFlags();
                }
                return m._pf;
            }

            var some;
            if (Array.prototype.some) {
                some = Array.prototype.some;
            } else {
                some = function some(fun) {
                    var t = Object(this);
                    var len = t.length >>> 0;

                    for (var i = 0; i < len; i++) {
                        if (i in t && fun.call(this, t[i], i, t)) {
                            return true;
                        }
                    }

                    return false;
                };
            }

            function isValid(m) {
                if (m._isValid == null) {
                    var flags = getParsingFlags(m);
                    var parsedParts = some.call(flags.parsedDateParts, function (i) {
                        return i != null;
                    });
                    var isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

                    if (m._strict) {
                        isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
                    }

                    if (Object.isFrozen == null || !Object.isFrozen(m)) {
                        m._isValid = isNowValid;
                    } else {
                        return isNowValid;
                    }
                }
                return m._isValid;
            }

            function createInvalid(flags) {
                var m = createUTC(NaN);
                if (flags != null) {
                    extend(getParsingFlags(m), flags);
                } else {
                    getParsingFlags(m).userInvalidated = true;
                }

                return m;
            }

            // Plugins that add properties should also add the key here (null value),
            // so we can properly clone ourselves.
            var momentProperties = hooks.momentProperties = [];

            function copyConfig(to, from) {
                var i, prop, val;

                if (!isUndefined(from._isAMomentObject)) {
                    to._isAMomentObject = from._isAMomentObject;
                }
                if (!isUndefined(from._i)) {
                    to._i = from._i;
                }
                if (!isUndefined(from._f)) {
                    to._f = from._f;
                }
                if (!isUndefined(from._l)) {
                    to._l = from._l;
                }
                if (!isUndefined(from._strict)) {
                    to._strict = from._strict;
                }
                if (!isUndefined(from._tzm)) {
                    to._tzm = from._tzm;
                }
                if (!isUndefined(from._isUTC)) {
                    to._isUTC = from._isUTC;
                }
                if (!isUndefined(from._offset)) {
                    to._offset = from._offset;
                }
                if (!isUndefined(from._pf)) {
                    to._pf = getParsingFlags(from);
                }
                if (!isUndefined(from._locale)) {
                    to._locale = from._locale;
                }

                if (momentProperties.length > 0) {
                    for (i = 0; i < momentProperties.length; i++) {
                        prop = momentProperties[i];
                        val = from[prop];
                        if (!isUndefined(val)) {
                            to[prop] = val;
                        }
                    }
                }

                return to;
            }

            var updateInProgress = false;

            // Moment prototype object
            function Moment(config) {
                copyConfig(this, config);
                this._d = new Date(config._d != null ? config._d.getTime() : NaN);
                if (!this.isValid()) {
                    this._d = new Date(NaN);
                }
                // Prevent infinite loop in case updateOffset creates new moment
                // objects.
                if (updateInProgress === false) {
                    updateInProgress = true;
                    hooks.updateOffset(this);
                    updateInProgress = false;
                }
            }

            function isMoment(obj) {
                return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
            }

            function absFloor(number) {
                if (number < 0) {
                    // -0 -> 0
                    return Math.ceil(number) || 0;
                } else {
                    return Math.floor(number);
                }
            }

            function toInt(argumentForCoercion) {
                var coercedNumber = +argumentForCoercion,
                    value = 0;

                if (coercedNumber !== 0 && isFinite(coercedNumber)) {
                    value = absFloor(coercedNumber);
                }

                return value;
            }

            // compare two arrays, return the number of differences
            function compareArrays(array1, array2, dontConvert) {
                var len = Math.min(array1.length, array2.length),
                    lengthDiff = Math.abs(array1.length - array2.length),
                    diffs = 0,
                    i;
                for (i = 0; i < len; i++) {
                    if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
                        diffs++;
                    }
                }
                return diffs + lengthDiff;
            }

            function warn(msg) {
                if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
                    console.warn('Deprecation warning: ' + msg);
                }
            }

            function deprecate(msg, fn) {
                var firstTime = true;

                return extend(function () {
                    if (hooks.deprecationHandler != null) {
                        hooks.deprecationHandler(null, msg);
                    }
                    if (firstTime) {
                        var args = [];
                        var arg;
                        for (var i = 0; i < arguments.length; i++) {
                            arg = '';
                            if (_typeof(arguments[i]) === 'object') {
                                arg += '\n[' + i + '] ';
                                for (var key in arguments[0]) {
                                    arg += key + ': ' + arguments[0][key] + ', ';
                                }
                                arg = arg.slice(0, -2); // Remove trailing comma and space
                            } else {
                                arg = arguments[i];
                            }
                            args.push(arg);
                        }
                        warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                        firstTime = false;
                    }
                    return fn.apply(this, arguments);
                }, fn);
            }

            var deprecations = {};

            function deprecateSimple(name, msg) {
                if (hooks.deprecationHandler != null) {
                    hooks.deprecationHandler(name, msg);
                }
                if (!deprecations[name]) {
                    warn(msg);
                    deprecations[name] = true;
                }
            }

            hooks.suppressDeprecationWarnings = false;
            hooks.deprecationHandler = null;

            function isFunction(input) {
                return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
            }

            function set(config) {
                var prop, i;
                for (i in config) {
                    prop = config[i];
                    if (isFunction(prop)) {
                        this[i] = prop;
                    } else {
                        this['_' + i] = prop;
                    }
                }
                this._config = config;
                // Lenient ordinal parsing accepts just a number in addition to
                // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
                // TODO: Remove "ordinalParse" fallback in next major release.
                this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
            }

            function mergeConfigs(parentConfig, childConfig) {
                var res = extend({}, parentConfig),
                    prop;
                for (prop in childConfig) {
                    if (hasOwnProp(childConfig, prop)) {
                        if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                            res[prop] = {};
                            extend(res[prop], parentConfig[prop]);
                            extend(res[prop], childConfig[prop]);
                        } else if (childConfig[prop] != null) {
                            res[prop] = childConfig[prop];
                        } else {
                            delete res[prop];
                        }
                    }
                }
                for (prop in parentConfig) {
                    if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
                        // make sure changes to properties don't modify parent config
                        res[prop] = extend({}, res[prop]);
                    }
                }
                return res;
            }

            function Locale(config) {
                if (config != null) {
                    this.set(config);
                }
            }

            var keys;

            if (Object.keys) {
                keys = Object.keys;
            } else {
                keys = function keys(obj) {
                    var i,
                        res = [];
                    for (i in obj) {
                        if (hasOwnProp(obj, i)) {
                            res.push(i);
                        }
                    }
                    return res;
                };
            }

            var defaultCalendar = {
                sameDay: '[Today at] LT',
                nextDay: '[Tomorrow at] LT',
                nextWeek: 'dddd [at] LT',
                lastDay: '[Yesterday at] LT',
                lastWeek: '[Last] dddd [at] LT',
                sameElse: 'L'
            };

            function calendar(key, mom, now) {
                var output = this._calendar[key] || this._calendar['sameElse'];
                return isFunction(output) ? output.call(mom, now) : output;
            }

            var defaultLongDateFormat = {
                LTS: 'h:mm:ss A',
                LT: 'h:mm A',
                L: 'MM/DD/YYYY',
                LL: 'MMMM D, YYYY',
                LLL: 'MMMM D, YYYY h:mm A',
                LLLL: 'dddd, MMMM D, YYYY h:mm A'
            };

            function longDateFormat(key) {
                var format = this._longDateFormat[key],
                    formatUpper = this._longDateFormat[key.toUpperCase()];

                if (format || !formatUpper) {
                    return format;
                }

                this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
                    return val.slice(1);
                });

                return this._longDateFormat[key];
            }

            var defaultInvalidDate = 'Invalid date';

            function invalidDate() {
                return this._invalidDate;
            }

            var defaultOrdinal = '%d';
            var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

            function ordinal(number) {
                return this._ordinal.replace('%d', number);
            }

            var defaultRelativeTime = {
                future: 'in %s',
                past: '%s ago',
                s: 'a few seconds',
                ss: '%d seconds',
                m: 'a minute',
                mm: '%d minutes',
                h: 'an hour',
                hh: '%d hours',
                d: 'a day',
                dd: '%d days',
                M: 'a month',
                MM: '%d months',
                y: 'a year',
                yy: '%d years'
            };

            function relativeTime(number, withoutSuffix, string, isFuture) {
                var output = this._relativeTime[string];
                return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
            }

            function pastFuture(diff, output) {
                var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
                return isFunction(format) ? format(output) : format.replace(/%s/i, output);
            }

            var aliases = {};

            function addUnitAlias(unit, shorthand) {
                var lowerCase = unit.toLowerCase();
                aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
            }

            function normalizeUnits(units) {
                return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
            }

            function normalizeObjectUnits(inputObject) {
                var normalizedInput = {},
                    normalizedProp,
                    prop;

                for (prop in inputObject) {
                    if (hasOwnProp(inputObject, prop)) {
                        normalizedProp = normalizeUnits(prop);
                        if (normalizedProp) {
                            normalizedInput[normalizedProp] = inputObject[prop];
                        }
                    }
                }

                return normalizedInput;
            }

            var priorities = {};

            function addUnitPriority(unit, priority) {
                priorities[unit] = priority;
            }

            function getPrioritizedUnits(unitsObj) {
                var units = [];
                for (var u in unitsObj) {
                    units.push({ unit: u, priority: priorities[u] });
                }
                units.sort(function (a, b) {
                    return a.priority - b.priority;
                });
                return units;
            }

            function zeroFill(number, targetLength, forceSign) {
                var absNumber = '' + Math.abs(number),
                    zerosToFill = targetLength - absNumber.length,
                    sign = number >= 0;
                return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
            }

            var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

            var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

            var formatFunctions = {};

            var formatTokenFunctions = {};

            // token:    'M'
            // padded:   ['MM', 2]
            // ordinal:  'Mo'
            // callback: function () { this.month() + 1 }
            function addFormatToken(token, padded, ordinal, callback) {
                var func = callback;
                if (typeof callback === 'string') {
                    func = function func() {
                        return this[callback]();
                    };
                }
                if (token) {
                    formatTokenFunctions[token] = func;
                }
                if (padded) {
                    formatTokenFunctions[padded[0]] = function () {
                        return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
                    };
                }
                if (ordinal) {
                    formatTokenFunctions[ordinal] = function () {
                        return this.localeData().ordinal(func.apply(this, arguments), token);
                    };
                }
            }

            function removeFormattingTokens(input) {
                if (input.match(/\[[\s\S]/)) {
                    return input.replace(/^\[|\]$/g, '');
                }
                return input.replace(/\\/g, '');
            }

            function makeFormatFunction(format) {
                var array = format.match(formattingTokens),
                    i,
                    length;

                for (i = 0, length = array.length; i < length; i++) {
                    if (formatTokenFunctions[array[i]]) {
                        array[i] = formatTokenFunctions[array[i]];
                    } else {
                        array[i] = removeFormattingTokens(array[i]);
                    }
                }

                return function (mom) {
                    var output = '',
                        i;
                    for (i = 0; i < length; i++) {
                        output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
                    }
                    return output;
                };
            }

            // format date using native date object
            function formatMoment(m, format) {
                if (!m.isValid()) {
                    return m.localeData().invalidDate();
                }

                format = expandFormat(format, m.localeData());
                formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

                return formatFunctions[format](m);
            }

            function expandFormat(format, locale) {
                var i = 5;

                function replaceLongDateFormatTokens(input) {
                    return locale.longDateFormat(input) || input;
                }

                localFormattingTokens.lastIndex = 0;
                while (i >= 0 && localFormattingTokens.test(format)) {
                    format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
                    localFormattingTokens.lastIndex = 0;
                    i -= 1;
                }

                return format;
            }

            var match1 = /\d/; //       0 - 9
            var match2 = /\d\d/; //      00 - 99
            var match3 = /\d{3}/; //     000 - 999
            var match4 = /\d{4}/; //    0000 - 9999
            var match6 = /[+-]?\d{6}/; // -999999 - 999999
            var match1to2 = /\d\d?/; //       0 - 99
            var match3to4 = /\d\d\d\d?/; //     999 - 9999
            var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999
            var match1to3 = /\d{1,3}/; //       0 - 999
            var match1to4 = /\d{1,4}/; //       0 - 9999
            var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999

            var matchUnsigned = /\d+/; //       0 - inf
            var matchSigned = /[+-]?\d+/; //    -inf - inf

            var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
            var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

            var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

            // any word (or two) characters or numbers including two/three word month in arabic.
            // includes scottish gaelic two word and hyphenated months
            var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

            var regexes = {};

            function addRegexToken(token, regex, strictRegex) {
                regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
                    return isStrict && strictRegex ? strictRegex : regex;
                };
            }

            function getParseRegexForToken(token, config) {
                if (!hasOwnProp(regexes, token)) {
                    return new RegExp(unescapeFormat(token));
                }

                return regexes[token](config._strict, config._locale);
            }

            // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
            function unescapeFormat(s) {
                return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
                    return p1 || p2 || p3 || p4;
                }));
            }

            function regexEscape(s) {
                return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            }

            var tokens = {};

            function addParseToken(token, callback) {
                var i,
                    func = callback;
                if (typeof token === 'string') {
                    token = [token];
                }
                if (isNumber(callback)) {
                    func = function func(input, array) {
                        array[callback] = toInt(input);
                    };
                }
                for (i = 0; i < token.length; i++) {
                    tokens[token[i]] = func;
                }
            }

            function addWeekParseToken(token, callback) {
                addParseToken(token, function (input, array, config, token) {
                    config._w = config._w || {};
                    callback(input, config._w, config, token);
                });
            }

            function addTimeToArrayFromToken(token, input, config) {
                if (input != null && hasOwnProp(tokens, token)) {
                    tokens[token](input, config._a, config, token);
                }
            }

            var YEAR = 0;
            var MONTH = 1;
            var DATE = 2;
            var HOUR = 3;
            var MINUTE = 4;
            var SECOND = 5;
            var MILLISECOND = 6;
            var WEEK = 7;
            var WEEKDAY = 8;

            // FORMATTING

            addFormatToken('Y', 0, 0, function () {
                var y = this.year();
                return y <= 9999 ? '' + y : '+' + y;
            });

            addFormatToken(0, ['YY', 2], 0, function () {
                return this.year() % 100;
            });

            addFormatToken(0, ['YYYY', 4], 0, 'year');
            addFormatToken(0, ['YYYYY', 5], 0, 'year');
            addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

            // ALIASES

            addUnitAlias('year', 'y');

            // PRIORITIES

            addUnitPriority('year', 1);

            // PARSING

            addRegexToken('Y', matchSigned);
            addRegexToken('YY', match1to2, match2);
            addRegexToken('YYYY', match1to4, match4);
            addRegexToken('YYYYY', match1to6, match6);
            addRegexToken('YYYYYY', match1to6, match6);

            addParseToken(['YYYYY', 'YYYYYY'], YEAR);
            addParseToken('YYYY', function (input, array) {
                array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
            });
            addParseToken('YY', function (input, array) {
                array[YEAR] = hooks.parseTwoDigitYear(input);
            });
            addParseToken('Y', function (input, array) {
                array[YEAR] = parseInt(input, 10);
            });

            // HELPERS

            function daysInYear(year) {
                return isLeapYear(year) ? 366 : 365;
            }

            function isLeapYear(year) {
                return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
            }

            // HOOKS

            hooks.parseTwoDigitYear = function (input) {
                return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
            };

            // MOMENTS

            var getSetYear = makeGetSet('FullYear', true);

            function getIsLeapYear() {
                return isLeapYear(this.year());
            }

            function makeGetSet(unit, keepTime) {
                return function (value) {
                    if (value != null) {
                        set$1(this, unit, value);
                        hooks.updateOffset(this, keepTime);
                        return this;
                    } else {
                        return get(this, unit);
                    }
                };
            }

            function get(mom, unit) {
                return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
            }

            function set$1(mom, unit, value) {
                if (mom.isValid() && !isNaN(value)) {
                    if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
                    } else {
                        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
                    }
                }
            }

            // MOMENTS

            function stringGet(units) {
                units = normalizeUnits(units);
                if (isFunction(this[units])) {
                    return this[units]();
                }
                return this;
            }

            function stringSet(units, value) {
                if ((typeof units === 'undefined' ? 'undefined' : _typeof(units)) === 'object') {
                    units = normalizeObjectUnits(units);
                    var prioritized = getPrioritizedUnits(units);
                    for (var i = 0; i < prioritized.length; i++) {
                        this[prioritized[i].unit](units[prioritized[i].unit]);
                    }
                } else {
                    units = normalizeUnits(units);
                    if (isFunction(this[units])) {
                        return this[units](value);
                    }
                }
                return this;
            }

            function mod(n, x) {
                return (n % x + x) % x;
            }

            var indexOf;

            if (Array.prototype.indexOf) {
                indexOf = Array.prototype.indexOf;
            } else {
                indexOf = function indexOf(o) {
                    // I know
                    var i;
                    for (i = 0; i < this.length; ++i) {
                        if (this[i] === o) {
                            return i;
                        }
                    }
                    return -1;
                };
            }

            function daysInMonth(year, month) {
                if (isNaN(year) || isNaN(month)) {
                    return NaN;
                }
                var modMonth = mod(month, 12);
                year += (month - modMonth) / 12;
                return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
            }

            // FORMATTING

            addFormatToken('M', ['MM', 2], 'Mo', function () {
                return this.month() + 1;
            });

            addFormatToken('MMM', 0, 0, function (format) {
                return this.localeData().monthsShort(this, format);
            });

            addFormatToken('MMMM', 0, 0, function (format) {
                return this.localeData().months(this, format);
            });

            // ALIASES

            addUnitAlias('month', 'M');

            // PRIORITY

            addUnitPriority('month', 8);

            // PARSING

            addRegexToken('M', match1to2);
            addRegexToken('MM', match1to2, match2);
            addRegexToken('MMM', function (isStrict, locale) {
                return locale.monthsShortRegex(isStrict);
            });
            addRegexToken('MMMM', function (isStrict, locale) {
                return locale.monthsRegex(isStrict);
            });

            addParseToken(['M', 'MM'], function (input, array) {
                array[MONTH] = toInt(input) - 1;
            });

            addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
                var month = config._locale.monthsParse(input, token, config._strict);
                // if we didn't find a month name, mark the date as invalid.
                if (month != null) {
                    array[MONTH] = month;
                } else {
                    getParsingFlags(config).invalidMonth = input;
                }
            });

            // LOCALES

            var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
            var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
            function localeMonths(m, format) {
                if (!m) {
                    return isArray(this._months) ? this._months : this._months['standalone'];
                }
                return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
            }

            var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
            function localeMonthsShort(m, format) {
                if (!m) {
                    return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
                }
                return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
            }

            function handleStrictParse(monthName, format, strict) {
                var i,
                    ii,
                    mom,
                    llc = monthName.toLocaleLowerCase();
                if (!this._monthsParse) {
                    // this is not used
                    this._monthsParse = [];
                    this._longMonthsParse = [];
                    this._shortMonthsParse = [];
                    for (i = 0; i < 12; ++i) {
                        mom = createUTC([2000, i]);
                        this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                        this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
                    }
                }

                if (strict) {
                    if (format === 'MMM') {
                        ii = indexOf.call(this._shortMonthsParse, llc);
                        return ii !== -1 ? ii : null;
                    } else {
                        ii = indexOf.call(this._longMonthsParse, llc);
                        return ii !== -1 ? ii : null;
                    }
                } else {
                    if (format === 'MMM') {
                        ii = indexOf.call(this._shortMonthsParse, llc);
                        if (ii !== -1) {
                            return ii;
                        }
                        ii = indexOf.call(this._longMonthsParse, llc);
                        return ii !== -1 ? ii : null;
                    } else {
                        ii = indexOf.call(this._longMonthsParse, llc);
                        if (ii !== -1) {
                            return ii;
                        }
                        ii = indexOf.call(this._shortMonthsParse, llc);
                        return ii !== -1 ? ii : null;
                    }
                }
            }

            function localeMonthsParse(monthName, format, strict) {
                var i, mom, regex;

                if (this._monthsParseExact) {
                    return handleStrictParse.call(this, monthName, format, strict);
                }

                if (!this._monthsParse) {
                    this._monthsParse = [];
                    this._longMonthsParse = [];
                    this._shortMonthsParse = [];
                }

                // TODO: add sorting
                // Sorting makes sure if one month (or abbr) is a prefix of another
                // see sorting in computeMonthsParse
                for (i = 0; i < 12; i++) {
                    // make the regex if we don't have it already
                    mom = createUTC([2000, i]);
                    if (strict && !this._longMonthsParse[i]) {
                        this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                        this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
                    }
                    if (!strict && !this._monthsParse[i]) {
                        regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                        this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
                    }
                    // test the regex
                    if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                        return i;
                    } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                        return i;
                    } else if (!strict && this._monthsParse[i].test(monthName)) {
                        return i;
                    }
                }
            }

            // MOMENTS

            function setMonth(mom, value) {
                var dayOfMonth;

                if (!mom.isValid()) {
                    // No op
                    return mom;
                }

                if (typeof value === 'string') {
                    if (/^\d+$/.test(value)) {
                        value = toInt(value);
                    } else {
                        value = mom.localeData().monthsParse(value);
                        // TODO: Another silent failure?
                        if (!isNumber(value)) {
                            return mom;
                        }
                    }
                }

                dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
                return mom;
            }

            function getSetMonth(value) {
                if (value != null) {
                    setMonth(this, value);
                    hooks.updateOffset(this, true);
                    return this;
                } else {
                    return get(this, 'Month');
                }
            }

            function getDaysInMonth() {
                return daysInMonth(this.year(), this.month());
            }

            var defaultMonthsShortRegex = matchWord;
            function monthsShortRegex(isStrict) {
                if (this._monthsParseExact) {
                    if (!hasOwnProp(this, '_monthsRegex')) {
                        computeMonthsParse.call(this);
                    }
                    if (isStrict) {
                        return this._monthsShortStrictRegex;
                    } else {
                        return this._monthsShortRegex;
                    }
                } else {
                    if (!hasOwnProp(this, '_monthsShortRegex')) {
                        this._monthsShortRegex = defaultMonthsShortRegex;
                    }
                    return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
                }
            }

            var defaultMonthsRegex = matchWord;
            function monthsRegex(isStrict) {
                if (this._monthsParseExact) {
                    if (!hasOwnProp(this, '_monthsRegex')) {
                        computeMonthsParse.call(this);
                    }
                    if (isStrict) {
                        return this._monthsStrictRegex;
                    } else {
                        return this._monthsRegex;
                    }
                } else {
                    if (!hasOwnProp(this, '_monthsRegex')) {
                        this._monthsRegex = defaultMonthsRegex;
                    }
                    return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
                }
            }

            function computeMonthsParse() {
                function cmpLenRev(a, b) {
                    return b.length - a.length;
                }

                var shortPieces = [],
                    longPieces = [],
                    mixedPieces = [],
                    i,
                    mom;
                for (i = 0; i < 12; i++) {
                    // make the regex if we don't have it already
                    mom = createUTC([2000, i]);
                    shortPieces.push(this.monthsShort(mom, ''));
                    longPieces.push(this.months(mom, ''));
                    mixedPieces.push(this.months(mom, ''));
                    mixedPieces.push(this.monthsShort(mom, ''));
                }
                // Sorting makes sure if one month (or abbr) is a prefix of another it
                // will match the longer piece.
                shortPieces.sort(cmpLenRev);
                longPieces.sort(cmpLenRev);
                mixedPieces.sort(cmpLenRev);
                for (i = 0; i < 12; i++) {
                    shortPieces[i] = regexEscape(shortPieces[i]);
                    longPieces[i] = regexEscape(longPieces[i]);
                }
                for (i = 0; i < 24; i++) {
                    mixedPieces[i] = regexEscape(mixedPieces[i]);
                }

                this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
                this._monthsShortRegex = this._monthsRegex;
                this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
                this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
            }

            function createDate(y, m, d, h, M, s, ms) {
                // can't just apply() to create a date:
                // https://stackoverflow.com/q/181348
                var date;
                // the date constructor remaps years 0-99 to 1900-1999
                if (y < 100 && y >= 0) {
                    // preserve leap years using a full 400 year cycle, then reset
                    date = new Date(y + 400, m, d, h, M, s, ms);
                    if (isFinite(date.getFullYear())) {
                        date.setFullYear(y);
                    }
                } else {
                    date = new Date(y, m, d, h, M, s, ms);
                }

                return date;
            }

            function createUTCDate(y) {
                var date;
                // the Date.UTC function remaps years 0-99 to 1900-1999
                if (y < 100 && y >= 0) {
                    var args = Array.prototype.slice.call(arguments);
                    // preserve leap years using a full 400 year cycle, then reset
                    args[0] = y + 400;
                    date = new Date(Date.UTC.apply(null, args));
                    if (isFinite(date.getUTCFullYear())) {
                        date.setUTCFullYear(y);
                    }
                } else {
                    date = new Date(Date.UTC.apply(null, arguments));
                }

                return date;
            }

            // start-of-first-week - start-of-year
            function firstWeekOffset(year, dow, doy) {
                var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
                fwd = 7 + dow - doy,


                // first-week day local weekday -- which local weekday is fwd
                fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

                return -fwdlw + fwd - 1;
            }

            // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
            function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
                var localWeekday = (7 + weekday - dow) % 7,
                    weekOffset = firstWeekOffset(year, dow, doy),
                    dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
                    resYear,
                    resDayOfYear;

                if (dayOfYear <= 0) {
                    resYear = year - 1;
                    resDayOfYear = daysInYear(resYear) + dayOfYear;
                } else if (dayOfYear > daysInYear(year)) {
                    resYear = year + 1;
                    resDayOfYear = dayOfYear - daysInYear(year);
                } else {
                    resYear = year;
                    resDayOfYear = dayOfYear;
                }

                return {
                    year: resYear,
                    dayOfYear: resDayOfYear
                };
            }

            function weekOfYear(mom, dow, doy) {
                var weekOffset = firstWeekOffset(mom.year(), dow, doy),
                    week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
                    resWeek,
                    resYear;

                if (week < 1) {
                    resYear = mom.year() - 1;
                    resWeek = week + weeksInYear(resYear, dow, doy);
                } else if (week > weeksInYear(mom.year(), dow, doy)) {
                    resWeek = week - weeksInYear(mom.year(), dow, doy);
                    resYear = mom.year() + 1;
                } else {
                    resYear = mom.year();
                    resWeek = week;
                }

                return {
                    week: resWeek,
                    year: resYear
                };
            }

            function weeksInYear(year, dow, doy) {
                var weekOffset = firstWeekOffset(year, dow, doy),
                    weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
                return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
            }

            // FORMATTING

            addFormatToken('w', ['ww', 2], 'wo', 'week');
            addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

            // ALIASES

            addUnitAlias('week', 'w');
            addUnitAlias('isoWeek', 'W');

            // PRIORITIES

            addUnitPriority('week', 5);
            addUnitPriority('isoWeek', 5);

            // PARSING

            addRegexToken('w', match1to2);
            addRegexToken('ww', match1to2, match2);
            addRegexToken('W', match1to2);
            addRegexToken('WW', match1to2, match2);

            addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
                week[token.substr(0, 1)] = toInt(input);
            });

            // HELPERS

            // LOCALES

            function localeWeek(mom) {
                return weekOfYear(mom, this._week.dow, this._week.doy).week;
            }

            var defaultLocaleWeek = {
                dow: 0, // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.
            };

            function localeFirstDayOfWeek() {
                return this._week.dow;
            }

            function localeFirstDayOfYear() {
                return this._week.doy;
            }

            // MOMENTS

            function getSetWeek(input) {
                var week = this.localeData().week(this);
                return input == null ? week : this.add((input - week) * 7, 'd');
            }

            function getSetISOWeek(input) {
                var week = weekOfYear(this, 1, 4).week;
                return input == null ? week : this.add((input - week) * 7, 'd');
            }

            // FORMATTING

            addFormatToken('d', 0, 'do', 'day');

            addFormatToken('dd', 0, 0, function (format) {
                return this.localeData().weekdaysMin(this, format);
            });

            addFormatToken('ddd', 0, 0, function (format) {
                return this.localeData().weekdaysShort(this, format);
            });

            addFormatToken('dddd', 0, 0, function (format) {
                return this.localeData().weekdays(this, format);
            });

            addFormatToken('e', 0, 0, 'weekday');
            addFormatToken('E', 0, 0, 'isoWeekday');

            // ALIASES

            addUnitAlias('day', 'd');
            addUnitAlias('weekday', 'e');
            addUnitAlias('isoWeekday', 'E');

            // PRIORITY
            addUnitPriority('day', 11);
            addUnitPriority('weekday', 11);
            addUnitPriority('isoWeekday', 11);

            // PARSING

            addRegexToken('d', match1to2);
            addRegexToken('e', match1to2);
            addRegexToken('E', match1to2);
            addRegexToken('dd', function (isStrict, locale) {
                return locale.weekdaysMinRegex(isStrict);
            });
            addRegexToken('ddd', function (isStrict, locale) {
                return locale.weekdaysShortRegex(isStrict);
            });
            addRegexToken('dddd', function (isStrict, locale) {
                return locale.weekdaysRegex(isStrict);
            });

            addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
                var weekday = config._locale.weekdaysParse(input, token, config._strict);
                // if we didn't get a weekday name, mark the date as invalid
                if (weekday != null) {
                    week.d = weekday;
                } else {
                    getParsingFlags(config).invalidWeekday = input;
                }
            });

            addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
                week[token] = toInt(input);
            });

            // HELPERS

            function parseWeekday(input, locale) {
                if (typeof input !== 'string') {
                    return input;
                }

                if (!isNaN(input)) {
                    return parseInt(input, 10);
                }

                input = locale.weekdaysParse(input);
                if (typeof input === 'number') {
                    return input;
                }

                return null;
            }

            function parseIsoWeekday(input, locale) {
                if (typeof input === 'string') {
                    return locale.weekdaysParse(input) % 7 || 7;
                }
                return isNaN(input) ? null : input;
            }

            // LOCALES
            function shiftWeekdays(ws, n) {
                return ws.slice(n, 7).concat(ws.slice(0, n));
            }

            var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
            function localeWeekdays(m, format) {
                var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
                return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
            }

            var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
            function localeWeekdaysShort(m) {
                return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
            }

            var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
            function localeWeekdaysMin(m) {
                return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
            }

            function handleStrictParse$1(weekdayName, format, strict) {
                var i,
                    ii,
                    mom,
                    llc = weekdayName.toLocaleLowerCase();
                if (!this._weekdaysParse) {
                    this._weekdaysParse = [];
                    this._shortWeekdaysParse = [];
                    this._minWeekdaysParse = [];

                    for (i = 0; i < 7; ++i) {
                        mom = createUTC([2000, 1]).day(i);
                        this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                        this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                        this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
                    }
                }

                if (strict) {
                    if (format === 'dddd') {
                        ii = indexOf.call(this._weekdaysParse, llc);
                        return ii !== -1 ? ii : null;
                    } else if (format === 'ddd') {
                        ii = indexOf.call(this._shortWeekdaysParse, llc);
                        return ii !== -1 ? ii : null;
                    } else {
                        ii = indexOf.call(this._minWeekdaysParse, llc);
                        return ii !== -1 ? ii : null;
                    }
                } else {
                    if (format === 'dddd') {
                        ii = indexOf.call(this._weekdaysParse, llc);
                        if (ii !== -1) {
                            return ii;
                        }
                        ii = indexOf.call(this._shortWeekdaysParse, llc);
                        if (ii !== -1) {
                            return ii;
                        }
                        ii = indexOf.call(this._minWeekdaysParse, llc);
                        return ii !== -1 ? ii : null;
                    } else if (format === 'ddd') {
                        ii = indexOf.call(this._shortWeekdaysParse, llc);
                        if (ii !== -1) {
                            return ii;
                        }
                        ii = indexOf.call(this._weekdaysParse, llc);
                        if (ii !== -1) {
                            return ii;
                        }
                        ii = indexOf.call(this._minWeekdaysParse, llc);
                        return ii !== -1 ? ii : null;
                    } else {
                        ii = indexOf.call(this._minWeekdaysParse, llc);
                        if (ii !== -1) {
                            return ii;
                        }
                        ii = indexOf.call(this._weekdaysParse, llc);
                        if (ii !== -1) {
                            return ii;
                        }
                        ii = indexOf.call(this._shortWeekdaysParse, llc);
                        return ii !== -1 ? ii : null;
                    }
                }
            }

            function localeWeekdaysParse(weekdayName, format, strict) {
                var i, mom, regex;

                if (this._weekdaysParseExact) {
                    return handleStrictParse$1.call(this, weekdayName, format, strict);
                }

                if (!this._weekdaysParse) {
                    this._weekdaysParse = [];
                    this._minWeekdaysParse = [];
                    this._shortWeekdaysParse = [];
                    this._fullWeekdaysParse = [];
                }

                for (i = 0; i < 7; i++) {
                    // make the regex if we don't have it already

                    mom = createUTC([2000, 1]).day(i);
                    if (strict && !this._fullWeekdaysParse[i]) {
                        this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                        this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                        this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
                    }
                    if (!this._weekdaysParse[i]) {
                        regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                        this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
                    }
                    // test the regex
                    if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                        return i;
                    } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                        return i;
                    } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                        return i;
                    } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                        return i;
                    }
                }
            }

            // MOMENTS

            function getSetDayOfWeek(input) {
                if (!this.isValid()) {
                    return input != null ? this : NaN;
                }
                var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                if (input != null) {
                    input = parseWeekday(input, this.localeData());
                    return this.add(input - day, 'd');
                } else {
                    return day;
                }
            }

            function getSetLocaleDayOfWeek(input) {
                if (!this.isValid()) {
                    return input != null ? this : NaN;
                }
                var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
                return input == null ? weekday : this.add(input - weekday, 'd');
            }

            function getSetISODayOfWeek(input) {
                if (!this.isValid()) {
                    return input != null ? this : NaN;
                }

                // behaves the same as moment#day except
                // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
                // as a setter, sunday should belong to the previous week.

                if (input != null) {
                    var weekday = parseIsoWeekday(input, this.localeData());
                    return this.day(this.day() % 7 ? weekday : weekday - 7);
                } else {
                    return this.day() || 7;
                }
            }

            var defaultWeekdaysRegex = matchWord;
            function weekdaysRegex(isStrict) {
                if (this._weekdaysParseExact) {
                    if (!hasOwnProp(this, '_weekdaysRegex')) {
                        computeWeekdaysParse.call(this);
                    }
                    if (isStrict) {
                        return this._weekdaysStrictRegex;
                    } else {
                        return this._weekdaysRegex;
                    }
                } else {
                    if (!hasOwnProp(this, '_weekdaysRegex')) {
                        this._weekdaysRegex = defaultWeekdaysRegex;
                    }
                    return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
                }
            }

            var defaultWeekdaysShortRegex = matchWord;
            function weekdaysShortRegex(isStrict) {
                if (this._weekdaysParseExact) {
                    if (!hasOwnProp(this, '_weekdaysRegex')) {
                        computeWeekdaysParse.call(this);
                    }
                    if (isStrict) {
                        return this._weekdaysShortStrictRegex;
                    } else {
                        return this._weekdaysShortRegex;
                    }
                } else {
                    if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                        this._weekdaysShortRegex = defaultWeekdaysShortRegex;
                    }
                    return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
                }
            }

            var defaultWeekdaysMinRegex = matchWord;
            function weekdaysMinRegex(isStrict) {
                if (this._weekdaysParseExact) {
                    if (!hasOwnProp(this, '_weekdaysRegex')) {
                        computeWeekdaysParse.call(this);
                    }
                    if (isStrict) {
                        return this._weekdaysMinStrictRegex;
                    } else {
                        return this._weekdaysMinRegex;
                    }
                } else {
                    if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                        this._weekdaysMinRegex = defaultWeekdaysMinRegex;
                    }
                    return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
                }
            }

            function computeWeekdaysParse() {
                function cmpLenRev(a, b) {
                    return b.length - a.length;
                }

                var minPieces = [],
                    shortPieces = [],
                    longPieces = [],
                    mixedPieces = [],
                    i,
                    mom,
                    minp,
                    shortp,
                    longp;
                for (i = 0; i < 7; i++) {
                    // make the regex if we don't have it already
                    mom = createUTC([2000, 1]).day(i);
                    minp = this.weekdaysMin(mom, '');
                    shortp = this.weekdaysShort(mom, '');
                    longp = this.weekdays(mom, '');
                    minPieces.push(minp);
                    shortPieces.push(shortp);
                    longPieces.push(longp);
                    mixedPieces.push(minp);
                    mixedPieces.push(shortp);
                    mixedPieces.push(longp);
                }
                // Sorting makes sure if one weekday (or abbr) is a prefix of another it
                // will match the longer piece.
                minPieces.sort(cmpLenRev);
                shortPieces.sort(cmpLenRev);
                longPieces.sort(cmpLenRev);
                mixedPieces.sort(cmpLenRev);
                for (i = 0; i < 7; i++) {
                    shortPieces[i] = regexEscape(shortPieces[i]);
                    longPieces[i] = regexEscape(longPieces[i]);
                    mixedPieces[i] = regexEscape(mixedPieces[i]);
                }

                this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
                this._weekdaysShortRegex = this._weekdaysRegex;
                this._weekdaysMinRegex = this._weekdaysRegex;

                this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
                this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
                this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
            }

            // FORMATTING

            function hFormat() {
                return this.hours() % 12 || 12;
            }

            function kFormat() {
                return this.hours() || 24;
            }

            addFormatToken('H', ['HH', 2], 0, 'hour');
            addFormatToken('h', ['hh', 2], 0, hFormat);
            addFormatToken('k', ['kk', 2], 0, kFormat);

            addFormatToken('hmm', 0, 0, function () {
                return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
            });

            addFormatToken('hmmss', 0, 0, function () {
                return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
            });

            addFormatToken('Hmm', 0, 0, function () {
                return '' + this.hours() + zeroFill(this.minutes(), 2);
            });

            addFormatToken('Hmmss', 0, 0, function () {
                return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
            });

            function meridiem(token, lowercase) {
                addFormatToken(token, 0, 0, function () {
                    return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
                });
            }

            meridiem('a', true);
            meridiem('A', false);

            // ALIASES

            addUnitAlias('hour', 'h');

            // PRIORITY
            addUnitPriority('hour', 13);

            // PARSING

            function matchMeridiem(isStrict, locale) {
                return locale._meridiemParse;
            }

            addRegexToken('a', matchMeridiem);
            addRegexToken('A', matchMeridiem);
            addRegexToken('H', match1to2);
            addRegexToken('h', match1to2);
            addRegexToken('k', match1to2);
            addRegexToken('HH', match1to2, match2);
            addRegexToken('hh', match1to2, match2);
            addRegexToken('kk', match1to2, match2);

            addRegexToken('hmm', match3to4);
            addRegexToken('hmmss', match5to6);
            addRegexToken('Hmm', match3to4);
            addRegexToken('Hmmss', match5to6);

            addParseToken(['H', 'HH'], HOUR);
            addParseToken(['k', 'kk'], function (input, array, config) {
                var kInput = toInt(input);
                array[HOUR] = kInput === 24 ? 0 : kInput;
            });
            addParseToken(['a', 'A'], function (input, array, config) {
                config._isPm = config._locale.isPM(input);
                config._meridiem = input;
            });
            addParseToken(['h', 'hh'], function (input, array, config) {
                array[HOUR] = toInt(input);
                getParsingFlags(config).bigHour = true;
            });
            addParseToken('hmm', function (input, array, config) {
                var pos = input.length - 2;
                array[HOUR] = toInt(input.substr(0, pos));
                array[MINUTE] = toInt(input.substr(pos));
                getParsingFlags(config).bigHour = true;
            });
            addParseToken('hmmss', function (input, array, config) {
                var pos1 = input.length - 4;
                var pos2 = input.length - 2;
                array[HOUR] = toInt(input.substr(0, pos1));
                array[MINUTE] = toInt(input.substr(pos1, 2));
                array[SECOND] = toInt(input.substr(pos2));
                getParsingFlags(config).bigHour = true;
            });
            addParseToken('Hmm', function (input, array, config) {
                var pos = input.length - 2;
                array[HOUR] = toInt(input.substr(0, pos));
                array[MINUTE] = toInt(input.substr(pos));
            });
            addParseToken('Hmmss', function (input, array, config) {
                var pos1 = input.length - 4;
                var pos2 = input.length - 2;
                array[HOUR] = toInt(input.substr(0, pos1));
                array[MINUTE] = toInt(input.substr(pos1, 2));
                array[SECOND] = toInt(input.substr(pos2));
            });

            // LOCALES

            function localeIsPM(input) {
                // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
                // Using charAt should be more compatible.
                return (input + '').toLowerCase().charAt(0) === 'p';
            }

            var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
            function localeMeridiem(hours, minutes, isLower) {
                if (hours > 11) {
                    return isLower ? 'pm' : 'PM';
                } else {
                    return isLower ? 'am' : 'AM';
                }
            }

            // MOMENTS

            // Setting the hour should keep the time, because the user explicitly
            // specified which hour they want. So trying to maintain the same hour (in
            // a new timezone) makes sense. Adding/subtracting hours does not follow
            // this rule.
            var getSetHour = makeGetSet('Hours', true);

            var baseConfig = {
                calendar: defaultCalendar,
                longDateFormat: defaultLongDateFormat,
                invalidDate: defaultInvalidDate,
                ordinal: defaultOrdinal,
                dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
                relativeTime: defaultRelativeTime,

                months: defaultLocaleMonths,
                monthsShort: defaultLocaleMonthsShort,

                week: defaultLocaleWeek,

                weekdays: defaultLocaleWeekdays,
                weekdaysMin: defaultLocaleWeekdaysMin,
                weekdaysShort: defaultLocaleWeekdaysShort,

                meridiemParse: defaultLocaleMeridiemParse
            };

            // internal storage for locale config files
            var locales = {};
            var localeFamilies = {};
            var globalLocale;

            function normalizeLocale(key) {
                return key ? key.toLowerCase().replace('_', '-') : key;
            }

            // pick the locale from the array
            // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
            // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
            function chooseLocale(names) {
                var i = 0,
                    j,
                    next,
                    locale,
                    split;

                while (i < names.length) {
                    split = normalizeLocale(names[i]).split('-');
                    j = split.length;
                    next = normalizeLocale(names[i + 1]);
                    next = next ? next.split('-') : null;
                    while (j > 0) {
                        locale = loadLocale(split.slice(0, j).join('-'));
                        if (locale) {
                            return locale;
                        }
                        if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                            //the next array item is better than a shallower substring of this one
                            break;
                        }
                        j--;
                    }
                    i++;
                }
                return globalLocale;
            }

            function loadLocale(name) {
                var oldLocale = null;
                // TODO: Find a better way to register and load all the locales in Node
                if (!locales[name] && 'object' !== 'undefined' && module && module.exports) {
                    try {
                        oldLocale = globalLocale._abbr;
                        var aliasedRequire = commonjsRequire;
                        aliasedRequire('./locale/' + name);
                        getSetGlobalLocale(oldLocale);
                    } catch (e) {}
                }
                return locales[name];
            }

            // This function will load locale and then set the global locale.  If
            // no arguments are passed in, it will simply return the current global
            // locale key.
            function getSetGlobalLocale(key, values) {
                var data;
                if (key) {
                    if (isUndefined(values)) {
                        data = getLocale(key);
                    } else {
                        data = defineLocale(key, values);
                    }

                    if (data) {
                        // moment.duration._locale = moment._locale = data;
                        globalLocale = data;
                    } else {
                        if (typeof console !== 'undefined' && console.warn) {
                            //warn user if arguments are passed but the locale could not be set
                            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
                        }
                    }
                }

                return globalLocale._abbr;
            }

            function defineLocale(name, config) {
                if (config !== null) {
                    var locale,
                        parentConfig = baseConfig;
                    config.abbr = name;
                    if (locales[name] != null) {
                        deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                        parentConfig = locales[name]._config;
                    } else if (config.parentLocale != null) {
                        if (locales[config.parentLocale] != null) {
                            parentConfig = locales[config.parentLocale]._config;
                        } else {
                            locale = loadLocale(config.parentLocale);
                            if (locale != null) {
                                parentConfig = locale._config;
                            } else {
                                if (!localeFamilies[config.parentLocale]) {
                                    localeFamilies[config.parentLocale] = [];
                                }
                                localeFamilies[config.parentLocale].push({
                                    name: name,
                                    config: config
                                });
                                return null;
                            }
                        }
                    }
                    locales[name] = new Locale(mergeConfigs(parentConfig, config));

                    if (localeFamilies[name]) {
                        localeFamilies[name].forEach(function (x) {
                            defineLocale(x.name, x.config);
                        });
                    }

                    // backwards compat for now: also set the locale
                    // make sure we set the locale AFTER all child locales have been
                    // created, so we won't end up with the child locale set.
                    getSetGlobalLocale(name);

                    return locales[name];
                } else {
                    // useful for testing
                    delete locales[name];
                    return null;
                }
            }

            function updateLocale(name, config) {
                if (config != null) {
                    var locale,
                        tmpLocale,
                        parentConfig = baseConfig;
                    // MERGE
                    tmpLocale = loadLocale(name);
                    if (tmpLocale != null) {
                        parentConfig = tmpLocale._config;
                    }
                    config = mergeConfigs(parentConfig, config);
                    locale = new Locale(config);
                    locale.parentLocale = locales[name];
                    locales[name] = locale;

                    // backwards compat for now: also set the locale
                    getSetGlobalLocale(name);
                } else {
                    // pass null for config to unupdate, useful for tests
                    if (locales[name] != null) {
                        if (locales[name].parentLocale != null) {
                            locales[name] = locales[name].parentLocale;
                        } else if (locales[name] != null) {
                            delete locales[name];
                        }
                    }
                }
                return locales[name];
            }

            // returns locale data
            function getLocale(key) {
                var locale;

                if (key && key._locale && key._locale._abbr) {
                    key = key._locale._abbr;
                }

                if (!key) {
                    return globalLocale;
                }

                if (!isArray(key)) {
                    //short-circuit everything else
                    locale = loadLocale(key);
                    if (locale) {
                        return locale;
                    }
                    key = [key];
                }

                return chooseLocale(key);
            }

            function listLocales() {
                return keys(locales);
            }

            function checkOverflow(m) {
                var overflow;
                var a = m._a;

                if (a && getParsingFlags(m).overflow === -2) {
                    overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

                    if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                        overflow = DATE;
                    }
                    if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                        overflow = WEEK;
                    }
                    if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                        overflow = WEEKDAY;
                    }

                    getParsingFlags(m).overflow = overflow;
                }

                return m;
            }

            // Pick the first defined of two or three arguments.
            function defaults(a, b, c) {
                if (a != null) {
                    return a;
                }
                if (b != null) {
                    return b;
                }
                return c;
            }

            function currentDateArray(config) {
                // hooks is actually the exported moment object
                var nowValue = new Date(hooks.now());
                if (config._useUTC) {
                    return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
                }
                return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
            }

            // convert an array to a date.
            // the array should mirror the parameters below
            // note: all values past the year are optional and will default to the lowest possible value.
            // [year, month, day , hour, minute, second, millisecond]
            function configFromArray(config) {
                var i,
                    date,
                    input = [],
                    currentDate,
                    expectedWeekday,
                    yearToUse;

                if (config._d) {
                    return;
                }

                currentDate = currentDateArray(config);

                //compute day of the year from weeks and weekdays
                if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
                    dayOfYearFromWeekInfo(config);
                }

                //if the day of the year is set, figure out what it is
                if (config._dayOfYear != null) {
                    yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

                    if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                        getParsingFlags(config)._overflowDayOfYear = true;
                    }

                    date = createUTCDate(yearToUse, 0, config._dayOfYear);
                    config._a[MONTH] = date.getUTCMonth();
                    config._a[DATE] = date.getUTCDate();
                }

                // Default to current date.
                // * if no year, month, day of month are given, default to today
                // * if day of month is given, default month and year
                // * if month is given, default only year
                // * if year is given, don't default anything
                for (i = 0; i < 3 && config._a[i] == null; ++i) {
                    config._a[i] = input[i] = currentDate[i];
                }

                // Zero out whatever was not defaulted, including time
                for (; i < 7; i++) {
                    config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
                }

                // Check for 24:00:00.000
                if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
                    config._nextDay = true;
                    config._a[HOUR] = 0;
                }

                config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
                expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

                // Apply timezone offset from input. The actual utcOffset can be changed
                // with parseZone.
                if (config._tzm != null) {
                    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
                }

                if (config._nextDay) {
                    config._a[HOUR] = 24;
                }

                // check for mismatching day of week
                if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
                    getParsingFlags(config).weekdayMismatch = true;
                }
            }

            function dayOfYearFromWeekInfo(config) {
                var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

                w = config._w;
                if (w.GG != null || w.W != null || w.E != null) {
                    dow = 1;
                    doy = 4;

                    // TODO: We need to take the current isoWeekYear, but that depends on
                    // how we interpret now (local, utc, fixed offset). So create
                    // a now version of current config (take local/utc/offset flags, and
                    // create now).
                    weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
                    week = defaults(w.W, 1);
                    weekday = defaults(w.E, 1);
                    if (weekday < 1 || weekday > 7) {
                        weekdayOverflow = true;
                    }
                } else {
                    dow = config._locale._week.dow;
                    doy = config._locale._week.doy;

                    var curWeek = weekOfYear(createLocal(), dow, doy);

                    weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

                    // Default to current week.
                    week = defaults(w.w, curWeek.week);

                    if (w.d != null) {
                        // weekday -- low day numbers are considered next week
                        weekday = w.d;
                        if (weekday < 0 || weekday > 6) {
                            weekdayOverflow = true;
                        }
                    } else if (w.e != null) {
                        // local weekday -- counting starts from beginning of week
                        weekday = w.e + dow;
                        if (w.e < 0 || w.e > 6) {
                            weekdayOverflow = true;
                        }
                    } else {
                        // default to beginning of week
                        weekday = dow;
                    }
                }
                if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
                    getParsingFlags(config)._overflowWeeks = true;
                } else if (weekdayOverflow != null) {
                    getParsingFlags(config)._overflowWeekday = true;
                } else {
                    temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
                    config._a[YEAR] = temp.year;
                    config._dayOfYear = temp.dayOfYear;
                }
            }

            // iso 8601 regex
            // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
            var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
            var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

            var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

            var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/],
            // YYYYMM is NOT allowed by the standard
            ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/]];

            // iso time formats and regexes
            var isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]];

            var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

            // date from iso format
            function configFromISO(config) {
                var i,
                    l,
                    string = config._i,
                    match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
                    allowTime,
                    dateFormat,
                    timeFormat,
                    tzFormat;

                if (match) {
                    getParsingFlags(config).iso = true;

                    for (i = 0, l = isoDates.length; i < l; i++) {
                        if (isoDates[i][1].exec(match[1])) {
                            dateFormat = isoDates[i][0];
                            allowTime = isoDates[i][2] !== false;
                            break;
                        }
                    }
                    if (dateFormat == null) {
                        config._isValid = false;
                        return;
                    }
                    if (match[3]) {
                        for (i = 0, l = isoTimes.length; i < l; i++) {
                            if (isoTimes[i][1].exec(match[3])) {
                                // match[2] should be 'T' or space
                                timeFormat = (match[2] || ' ') + isoTimes[i][0];
                                break;
                            }
                        }
                        if (timeFormat == null) {
                            config._isValid = false;
                            return;
                        }
                    }
                    if (!allowTime && timeFormat != null) {
                        config._isValid = false;
                        return;
                    }
                    if (match[4]) {
                        if (tzRegex.exec(match[4])) {
                            tzFormat = 'Z';
                        } else {
                            config._isValid = false;
                            return;
                        }
                    }
                    config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
                    configFromStringAndFormat(config);
                } else {
                    config._isValid = false;
                }
            }

            // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
            var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

            function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
                var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

                if (secondStr) {
                    result.push(parseInt(secondStr, 10));
                }

                return result;
            }

            function untruncateYear(yearStr) {
                var year = parseInt(yearStr, 10);
                if (year <= 49) {
                    return 2000 + year;
                } else if (year <= 999) {
                    return 1900 + year;
                }
                return year;
            }

            function preprocessRFC2822(s) {
                // Remove comments and folding whitespace and replace multiple-spaces with a single space
                return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
            }

            function checkWeekday(weekdayStr, parsedInput, config) {
                if (weekdayStr) {
                    // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
                    var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                        weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
                    if (weekdayProvided !== weekdayActual) {
                        getParsingFlags(config).weekdayMismatch = true;
                        config._isValid = false;
                        return false;
                    }
                }
                return true;
            }

            var obsOffsets = {
                UT: 0,
                GMT: 0,
                EDT: -4 * 60,
                EST: -5 * 60,
                CDT: -5 * 60,
                CST: -6 * 60,
                MDT: -6 * 60,
                MST: -7 * 60,
                PDT: -7 * 60,
                PST: -8 * 60
            };

            function calculateOffset(obsOffset, militaryOffset, numOffset) {
                if (obsOffset) {
                    return obsOffsets[obsOffset];
                } else if (militaryOffset) {
                    // the only allowed military tz is Z
                    return 0;
                } else {
                    var hm = parseInt(numOffset, 10);
                    var m = hm % 100,
                        h = (hm - m) / 100;
                    return h * 60 + m;
                }
            }

            // date and time from ref 2822 format
            function configFromRFC2822(config) {
                var match = rfc2822.exec(preprocessRFC2822(config._i));
                if (match) {
                    var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
                    if (!checkWeekday(match[1], parsedArray, config)) {
                        return;
                    }

                    config._a = parsedArray;
                    config._tzm = calculateOffset(match[8], match[9], match[10]);

                    config._d = createUTCDate.apply(null, config._a);
                    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

                    getParsingFlags(config).rfc2822 = true;
                } else {
                    config._isValid = false;
                }
            }

            // date from iso format or fallback
            function configFromString(config) {
                var matched = aspNetJsonRegex.exec(config._i);

                if (matched !== null) {
                    config._d = new Date(+matched[1]);
                    return;
                }

                configFromISO(config);
                if (config._isValid === false) {
                    delete config._isValid;
                } else {
                    return;
                }

                configFromRFC2822(config);
                if (config._isValid === false) {
                    delete config._isValid;
                } else {
                    return;
                }

                // Final attempt, use Input Fallback
                hooks.createFromInputFallback(config);
            }

            hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged and will be removed in an upcoming major release. Please refer to ' + 'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
                config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
            });

            // constant that refers to the ISO standard
            hooks.ISO_8601 = function () {};

            // constant that refers to the RFC 2822 form
            hooks.RFC_2822 = function () {};

            // date from string and format string
            function configFromStringAndFormat(config) {
                // TODO: Move this to another part of the creation flow to prevent circular deps
                if (config._f === hooks.ISO_8601) {
                    configFromISO(config);
                    return;
                }
                if (config._f === hooks.RFC_2822) {
                    configFromRFC2822(config);
                    return;
                }
                config._a = [];
                getParsingFlags(config).empty = true;

                // This array is used to make a Date, either with `new Date` or `Date.UTC`
                var string = '' + config._i,
                    i,
                    parsedInput,
                    tokens,
                    token,
                    skipped,
                    stringLength = string.length,
                    totalParsedInputLength = 0;

                tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

                for (i = 0; i < tokens.length; i++) {
                    token = tokens[i];
                    parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
                    // console.log('token', token, 'parsedInput', parsedInput,
                    //         'regex', getParseRegexForToken(token, config));
                    if (parsedInput) {
                        skipped = string.substr(0, string.indexOf(parsedInput));
                        if (skipped.length > 0) {
                            getParsingFlags(config).unusedInput.push(skipped);
                        }
                        string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                        totalParsedInputLength += parsedInput.length;
                    }
                    // don't parse if it's not a known token
                    if (formatTokenFunctions[token]) {
                        if (parsedInput) {
                            getParsingFlags(config).empty = false;
                        } else {
                            getParsingFlags(config).unusedTokens.push(token);
                        }
                        addTimeToArrayFromToken(token, parsedInput, config);
                    } else if (config._strict && !parsedInput) {
                        getParsingFlags(config).unusedTokens.push(token);
                    }
                }

                // add remaining unparsed input length to the string
                getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
                if (string.length > 0) {
                    getParsingFlags(config).unusedInput.push(string);
                }

                // clear _12h flag if hour is <= 12
                if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
                    getParsingFlags(config).bigHour = undefined;
                }

                getParsingFlags(config).parsedDateParts = config._a.slice(0);
                getParsingFlags(config).meridiem = config._meridiem;
                // handle meridiem
                config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

                configFromArray(config);
                checkOverflow(config);
            }

            function meridiemFixWrap(locale, hour, meridiem) {
                var isPm;

                if (meridiem == null) {
                    // nothing to do
                    return hour;
                }
                if (locale.meridiemHour != null) {
                    return locale.meridiemHour(hour, meridiem);
                } else if (locale.isPM != null) {
                    // Fallback
                    isPm = locale.isPM(meridiem);
                    if (isPm && hour < 12) {
                        hour += 12;
                    }
                    if (!isPm && hour === 12) {
                        hour = 0;
                    }
                    return hour;
                } else {
                    // this is not supposed to happen
                    return hour;
                }
            }

            // date from string and array of format strings
            function configFromStringAndArray(config) {
                var tempConfig, bestMoment, scoreToBeat, i, currentScore;

                if (config._f.length === 0) {
                    getParsingFlags(config).invalidFormat = true;
                    config._d = new Date(NaN);
                    return;
                }

                for (i = 0; i < config._f.length; i++) {
                    currentScore = 0;
                    tempConfig = copyConfig({}, config);
                    if (config._useUTC != null) {
                        tempConfig._useUTC = config._useUTC;
                    }
                    tempConfig._f = config._f[i];
                    configFromStringAndFormat(tempConfig);

                    if (!isValid(tempConfig)) {
                        continue;
                    }

                    // if there is any input that was not parsed add a penalty for that format
                    currentScore += getParsingFlags(tempConfig).charsLeftOver;

                    //or tokens
                    currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

                    getParsingFlags(tempConfig).score = currentScore;

                    if (scoreToBeat == null || currentScore < scoreToBeat) {
                        scoreToBeat = currentScore;
                        bestMoment = tempConfig;
                    }
                }

                extend(config, bestMoment || tempConfig);
            }

            function configFromObject(config) {
                if (config._d) {
                    return;
                }

                var i = normalizeObjectUnits(config._i);
                config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
                    return obj && parseInt(obj, 10);
                });

                configFromArray(config);
            }

            function createFromConfig(config) {
                var res = new Moment(checkOverflow(prepareConfig(config)));
                if (res._nextDay) {
                    // Adding is smart enough around DST
                    res.add(1, 'd');
                    res._nextDay = undefined;
                }

                return res;
            }

            function prepareConfig(config) {
                var input = config._i,
                    format = config._f;

                config._locale = config._locale || getLocale(config._l);

                if (input === null || format === undefined && input === '') {
                    return createInvalid({ nullInput: true });
                }

                if (typeof input === 'string') {
                    config._i = input = config._locale.preparse(input);
                }

                if (isMoment(input)) {
                    return new Moment(checkOverflow(input));
                } else if (isDate(input)) {
                    config._d = input;
                } else if (isArray(format)) {
                    configFromStringAndArray(config);
                } else if (format) {
                    configFromStringAndFormat(config);
                } else {
                    configFromInput(config);
                }

                if (!isValid(config)) {
                    config._d = null;
                }

                return config;
            }

            function configFromInput(config) {
                var input = config._i;
                if (isUndefined(input)) {
                    config._d = new Date(hooks.now());
                } else if (isDate(input)) {
                    config._d = new Date(input.valueOf());
                } else if (typeof input === 'string') {
                    configFromString(config);
                } else if (isArray(input)) {
                    config._a = map(input.slice(0), function (obj) {
                        return parseInt(obj, 10);
                    });
                    configFromArray(config);
                } else if (isObject(input)) {
                    configFromObject(config);
                } else if (isNumber(input)) {
                    // from milliseconds
                    config._d = new Date(input);
                } else {
                    hooks.createFromInputFallback(config);
                }
            }

            function createLocalOrUTC(input, format, locale, strict, isUTC) {
                var c = {};

                if (locale === true || locale === false) {
                    strict = locale;
                    locale = undefined;
                }

                if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
                    input = undefined;
                }
                // object construction must be done this way.
                // https://github.com/moment/moment/issues/1423
                c._isAMomentObject = true;
                c._useUTC = c._isUTC = isUTC;
                c._l = locale;
                c._i = input;
                c._f = format;
                c._strict = strict;

                return createFromConfig(c);
            }

            function createLocal(input, format, locale, strict) {
                return createLocalOrUTC(input, format, locale, strict, false);
            }

            var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            });

            var prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            });

            // Pick a moment m from moments so that m[fn](other) is true for all
            // other. This relies on the function fn to be transitive.
            //
            // moments should either be an array of moment objects or an array, whose
            // first element is an array of moment objects.
            function pickBy(fn, moments) {
                var res, i;
                if (moments.length === 1 && isArray(moments[0])) {
                    moments = moments[0];
                }
                if (!moments.length) {
                    return createLocal();
                }
                res = moments[0];
                for (i = 1; i < moments.length; ++i) {
                    if (!moments[i].isValid() || moments[i][fn](res)) {
                        res = moments[i];
                    }
                }
                return res;
            }

            // TODO: Use [].sort instead?
            function min() {
                var args = [].slice.call(arguments, 0);

                return pickBy('isBefore', args);
            }

            function max() {
                var args = [].slice.call(arguments, 0);

                return pickBy('isAfter', args);
            }

            var now = function now() {
                return Date.now ? Date.now() : +new Date();
            };

            var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

            function isDurationValid(m) {
                for (var key in m) {
                    if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                        return false;
                    }
                }

                var unitHasDecimal = false;
                for (var i = 0; i < ordering.length; ++i) {
                    if (m[ordering[i]]) {
                        if (unitHasDecimal) {
                            return false; // only allow non-integers for smallest unit
                        }
                        if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                            unitHasDecimal = true;
                        }
                    }
                }

                return true;
            }

            function isValid$1() {
                return this._isValid;
            }

            function createInvalid$1() {
                return createDuration(NaN);
            }

            function Duration(duration) {
                var normalizedInput = normalizeObjectUnits(duration),
                    years = normalizedInput.year || 0,
                    quarters = normalizedInput.quarter || 0,
                    months = normalizedInput.month || 0,
                    weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
                    days = normalizedInput.day || 0,
                    hours = normalizedInput.hour || 0,
                    minutes = normalizedInput.minute || 0,
                    seconds = normalizedInput.second || 0,
                    milliseconds = normalizedInput.millisecond || 0;

                this._isValid = isDurationValid(normalizedInput);

                // representation for dateAddRemove
                this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
                minutes * 6e4 + // 1000 * 60
                hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
                // Because of dateAddRemove treats 24 hours as different from a
                // day when working around DST, we need to store them separately
                this._days = +days + weeks * 7;
                // It is impossible to translate months into days without knowing
                // which months you are are talking about, so we have to store
                // it separately.
                this._months = +months + quarters * 3 + years * 12;

                this._data = {};

                this._locale = getLocale();

                this._bubble();
            }

            function isDuration(obj) {
                return obj instanceof Duration;
            }

            function absRound(number) {
                if (number < 0) {
                    return Math.round(-1 * number) * -1;
                } else {
                    return Math.round(number);
                }
            }

            // FORMATTING

            function offset(token, separator) {
                addFormatToken(token, 0, 0, function () {
                    var offset = this.utcOffset();
                    var sign = '+';
                    if (offset < 0) {
                        offset = -offset;
                        sign = '-';
                    }
                    return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
                });
            }

            offset('Z', ':');
            offset('ZZ', '');

            // PARSING

            addRegexToken('Z', matchShortOffset);
            addRegexToken('ZZ', matchShortOffset);
            addParseToken(['Z', 'ZZ'], function (input, array, config) {
                config._useUTC = true;
                config._tzm = offsetFromString(matchShortOffset, input);
            });

            // HELPERS

            // timezone chunker
            // '+10:00' > ['10',  '00']
            // '-1530'  > ['-15', '30']
            var chunkOffset = /([\+\-]|\d\d)/gi;

            function offsetFromString(matcher, string) {
                var matches = (string || '').match(matcher);

                if (matches === null) {
                    return null;
                }

                var chunk = matches[matches.length - 1] || [];
                var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
                var minutes = +(parts[1] * 60) + toInt(parts[2]);

                return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
            }

            // Return a moment from input, that is local/utc/zone equivalent to model.
            function cloneWithOffset(input, model) {
                var res, diff;
                if (model._isUTC) {
                    res = model.clone();
                    diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
                    // Use low-level api, because this fn is low-level api.
                    res._d.setTime(res._d.valueOf() + diff);
                    hooks.updateOffset(res, false);
                    return res;
                } else {
                    return createLocal(input).local();
                }
            }

            function getDateOffset(m) {
                // On Firefox.24 Date#getTimezoneOffset returns a floating point.
                // https://github.com/moment/moment/pull/1871
                return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
            }

            // HOOKS

            // This function will be called whenever a moment is mutated.
            // It is intended to keep the offset in sync with the timezone.
            hooks.updateOffset = function () {};

            // MOMENTS

            // keepLocalTime = true means only change the timezone, without
            // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
            // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
            // +0200, so we adjust the time as needed, to be valid.
            //
            // Keeping the time actually adds/subtracts (one hour)
            // from the actual represented time. That is why we call updateOffset
            // a second time. In case it wants us to change the offset again
            // _changeInProgress == true case, then we have to adjust, because
            // there is no such time in the given timezone.
            function getSetOffset(input, keepLocalTime, keepMinutes) {
                var offset = this._offset || 0,
                    localAdjust;
                if (!this.isValid()) {
                    return input != null ? this : NaN;
                }
                if (input != null) {
                    if (typeof input === 'string') {
                        input = offsetFromString(matchShortOffset, input);
                        if (input === null) {
                            return this;
                        }
                    } else if (Math.abs(input) < 16 && !keepMinutes) {
                        input = input * 60;
                    }
                    if (!this._isUTC && keepLocalTime) {
                        localAdjust = getDateOffset(this);
                    }
                    this._offset = input;
                    this._isUTC = true;
                    if (localAdjust != null) {
                        this.add(localAdjust, 'm');
                    }
                    if (offset !== input) {
                        if (!keepLocalTime || this._changeInProgress) {
                            addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                        } else if (!this._changeInProgress) {
                            this._changeInProgress = true;
                            hooks.updateOffset(this, true);
                            this._changeInProgress = null;
                        }
                    }
                    return this;
                } else {
                    return this._isUTC ? offset : getDateOffset(this);
                }
            }

            function getSetZone(input, keepLocalTime) {
                if (input != null) {
                    if (typeof input !== 'string') {
                        input = -input;
                    }

                    this.utcOffset(input, keepLocalTime);

                    return this;
                } else {
                    return -this.utcOffset();
                }
            }

            function setOffsetToUTC(keepLocalTime) {
                return this.utcOffset(0, keepLocalTime);
            }

            function setOffsetToLocal(keepLocalTime) {
                if (this._isUTC) {
                    this.utcOffset(0, keepLocalTime);
                    this._isUTC = false;

                    if (keepLocalTime) {
                        this.subtract(getDateOffset(this), 'm');
                    }
                }
                return this;
            }

            function setOffsetToParsedOffset() {
                if (this._tzm != null) {
                    this.utcOffset(this._tzm, false, true);
                } else if (typeof this._i === 'string') {
                    var tZone = offsetFromString(matchOffset, this._i);
                    if (tZone != null) {
                        this.utcOffset(tZone);
                    } else {
                        this.utcOffset(0, true);
                    }
                }
                return this;
            }

            function hasAlignedHourOffset(input) {
                if (!this.isValid()) {
                    return false;
                }
                input = input ? createLocal(input).utcOffset() : 0;

                return (this.utcOffset() - input) % 60 === 0;
            }

            function isDaylightSavingTime() {
                return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
            }

            function isDaylightSavingTimeShifted() {
                if (!isUndefined(this._isDSTShifted)) {
                    return this._isDSTShifted;
                }

                var c = {};

                copyConfig(c, this);
                c = prepareConfig(c);

                if (c._a) {
                    var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
                    this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
                } else {
                    this._isDSTShifted = false;
                }

                return this._isDSTShifted;
            }

            function isLocal() {
                return this.isValid() ? !this._isUTC : false;
            }

            function isUtcOffset() {
                return this.isValid() ? this._isUTC : false;
            }

            function isUtc() {
                return this.isValid() ? this._isUTC && this._offset === 0 : false;
            }

            // ASP.NET json date format regex
            var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

            // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
            // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
            // and further modified to allow for strings containing both week and day
            var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

            function createDuration(input, key) {
                var duration = input,


                // matching against regexp is expensive, do it on demand
                match = null,
                    sign,
                    ret,
                    diffRes;

                if (isDuration(input)) {
                    duration = {
                        ms: input._milliseconds,
                        d: input._days,
                        M: input._months
                    };
                } else if (isNumber(input)) {
                    duration = {};
                    if (key) {
                        duration[key] = input;
                    } else {
                        duration.milliseconds = input;
                    }
                } else if (!!(match = aspNetRegex.exec(input))) {
                    sign = match[1] === '-' ? -1 : 1;
                    duration = {
                        y: 0,
                        d: toInt(match[DATE]) * sign,
                        h: toInt(match[HOUR]) * sign,
                        m: toInt(match[MINUTE]) * sign,
                        s: toInt(match[SECOND]) * sign,
                        ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
                    };
                } else if (!!(match = isoRegex.exec(input))) {
                    sign = match[1] === '-' ? -1 : 1;
                    duration = {
                        y: parseIso(match[2], sign),
                        M: parseIso(match[3], sign),
                        w: parseIso(match[4], sign),
                        d: parseIso(match[5], sign),
                        h: parseIso(match[6], sign),
                        m: parseIso(match[7], sign),
                        s: parseIso(match[8], sign)
                    };
                } else if (duration == null) {
                    // checks for null or undefined
                    duration = {};
                } else if ((typeof duration === 'undefined' ? 'undefined' : _typeof(duration)) === 'object' && ('from' in duration || 'to' in duration)) {
                    diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

                    duration = {};
                    duration.ms = diffRes.milliseconds;
                    duration.M = diffRes.months;
                }

                ret = new Duration(duration);

                if (isDuration(input) && hasOwnProp(input, '_locale')) {
                    ret._locale = input._locale;
                }

                return ret;
            }

            createDuration.fn = Duration.prototype;
            createDuration.invalid = createInvalid$1;

            function parseIso(inp, sign) {
                // We'd normally use ~~inp for this, but unfortunately it also
                // converts floats to ints.
                // inp may be undefined, so careful calling replace on it.
                var res = inp && parseFloat(inp.replace(',', '.'));
                // apply sign while we're at it
                return (isNaN(res) ? 0 : res) * sign;
            }

            function positiveMomentsDifference(base, other) {
                var res = {};

                res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
                if (base.clone().add(res.months, 'M').isAfter(other)) {
                    --res.months;
                }

                res.milliseconds = +other - +base.clone().add(res.months, 'M');

                return res;
            }

            function momentsDifference(base, other) {
                var res;
                if (!(base.isValid() && other.isValid())) {
                    return { milliseconds: 0, months: 0 };
                }

                other = cloneWithOffset(other, base);
                if (base.isBefore(other)) {
                    res = positiveMomentsDifference(base, other);
                } else {
                    res = positiveMomentsDifference(other, base);
                    res.milliseconds = -res.milliseconds;
                    res.months = -res.months;
                }

                return res;
            }

            // TODO: remove 'name' arg after deprecation is removed
            function createAdder(direction, name) {
                return function (val, period) {
                    var dur, tmp;
                    //invert the arguments, but complain about it
                    if (period !== null && !isNaN(+period)) {
                        deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                        tmp = val;val = period;period = tmp;
                    }

                    val = typeof val === 'string' ? +val : val;
                    dur = createDuration(val, period);
                    addSubtract(this, dur, direction);
                    return this;
                };
            }

            function addSubtract(mom, duration, isAdding, updateOffset) {
                var milliseconds = duration._milliseconds,
                    days = absRound(duration._days),
                    months = absRound(duration._months);

                if (!mom.isValid()) {
                    // No op
                    return;
                }

                updateOffset = updateOffset == null ? true : updateOffset;

                if (months) {
                    setMonth(mom, get(mom, 'Month') + months * isAdding);
                }
                if (days) {
                    set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
                }
                if (milliseconds) {
                    mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
                }
                if (updateOffset) {
                    hooks.updateOffset(mom, days || months);
                }
            }

            var add = createAdder(1, 'add');
            var subtract = createAdder(-1, 'subtract');

            function getCalendarFormat(myMoment, now) {
                var diff = myMoment.diff(now, 'days', true);
                return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
            }

            function calendar$1(time, formats) {
                // We want to compare the start of today, vs this.
                // Getting start-of-today depends on whether we're local/utc/offset or not.
                var now = time || createLocal(),
                    sod = cloneWithOffset(now, this).startOf('day'),
                    format = hooks.calendarFormat(this, sod) || 'sameElse';

                var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

                return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
            }

            function clone() {
                return new Moment(this);
            }

            function isAfter(input, units) {
                var localInput = isMoment(input) ? input : createLocal(input);
                if (!(this.isValid() && localInput.isValid())) {
                    return false;
                }
                units = normalizeUnits(units) || 'millisecond';
                if (units === 'millisecond') {
                    return this.valueOf() > localInput.valueOf();
                } else {
                    return localInput.valueOf() < this.clone().startOf(units).valueOf();
                }
            }

            function isBefore(input, units) {
                var localInput = isMoment(input) ? input : createLocal(input);
                if (!(this.isValid() && localInput.isValid())) {
                    return false;
                }
                units = normalizeUnits(units) || 'millisecond';
                if (units === 'millisecond') {
                    return this.valueOf() < localInput.valueOf();
                } else {
                    return this.clone().endOf(units).valueOf() < localInput.valueOf();
                }
            }

            function isBetween(from, to, units, inclusivity) {
                var localFrom = isMoment(from) ? from : createLocal(from),
                    localTo = isMoment(to) ? to : createLocal(to);
                if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
                    return false;
                }
                inclusivity = inclusivity || '()';
                return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
            }

            function isSame(input, units) {
                var localInput = isMoment(input) ? input : createLocal(input),
                    inputMs;
                if (!(this.isValid() && localInput.isValid())) {
                    return false;
                }
                units = normalizeUnits(units) || 'millisecond';
                if (units === 'millisecond') {
                    return this.valueOf() === localInput.valueOf();
                } else {
                    inputMs = localInput.valueOf();
                    return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
                }
            }

            function isSameOrAfter(input, units) {
                return this.isSame(input, units) || this.isAfter(input, units);
            }

            function isSameOrBefore(input, units) {
                return this.isSame(input, units) || this.isBefore(input, units);
            }

            function diff(input, units, asFloat) {
                var that, zoneDelta, output;

                if (!this.isValid()) {
                    return NaN;
                }

                that = cloneWithOffset(input, this);

                if (!that.isValid()) {
                    return NaN;
                }

                zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

                units = normalizeUnits(units);

                switch (units) {
                    case 'year':
                        output = monthDiff(this, that) / 12;break;
                    case 'month':
                        output = monthDiff(this, that);break;
                    case 'quarter':
                        output = monthDiff(this, that) / 3;break;
                    case 'second':
                        output = (this - that) / 1e3;break; // 1000
                    case 'minute':
                        output = (this - that) / 6e4;break; // 1000 * 60
                    case 'hour':
                        output = (this - that) / 36e5;break; // 1000 * 60 * 60
                    case 'day':
                        output = (this - that - zoneDelta) / 864e5;break; // 1000 * 60 * 60 * 24, negate dst
                    case 'week':
                        output = (this - that - zoneDelta) / 6048e5;break; // 1000 * 60 * 60 * 24 * 7, negate dst
                    default:
                        output = this - that;
                }

                return asFloat ? output : absFloor(output);
            }

            function monthDiff(a, b) {
                // difference in months
                var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),


                // b is in (anchor - 1 month, anchor + 1 month)
                anchor = a.clone().add(wholeMonthDiff, 'months'),
                    anchor2,
                    adjust;

                if (b - anchor < 0) {
                    anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
                    // linear across the month
                    adjust = (b - anchor) / (anchor - anchor2);
                } else {
                    anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
                    // linear across the month
                    adjust = (b - anchor) / (anchor2 - anchor);
                }

                //check for negative zero, return zero if negative zero
                return -(wholeMonthDiff + adjust) || 0;
            }

            hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
            hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

            function toString() {
                return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
            }

            function toISOString(keepOffset) {
                if (!this.isValid()) {
                    return null;
                }
                var utc = keepOffset !== true;
                var m = utc ? this.clone().utc() : this;
                if (m.year() < 0 || m.year() > 9999) {
                    return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
                }
                if (isFunction(Date.prototype.toISOString)) {
                    // native implementation is ~50x faster, use it when we can
                    if (utc) {
                        return this.toDate().toISOString();
                    } else {
                        return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
                    }
                }
                return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
            }

            /**
             * Return a human readable representation of a moment that can
             * also be evaluated to get a new moment which is the same
             *
             * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
             */
            function inspect() {
                if (!this.isValid()) {
                    return 'moment.invalid(/* ' + this._i + ' */)';
                }
                var func = 'moment';
                var zone = '';
                if (!this.isLocal()) {
                    func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
                    zone = 'Z';
                }
                var prefix = '[' + func + '("]';
                var year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
                var datetime = '-MM-DD[T]HH:mm:ss.SSS';
                var suffix = zone + '[")]';

                return this.format(prefix + year + datetime + suffix);
            }

            function format(inputString) {
                if (!inputString) {
                    inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
                }
                var output = formatMoment(this, inputString);
                return this.localeData().postformat(output);
            }

            function from(time, withoutSuffix) {
                if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
                    return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
                } else {
                    return this.localeData().invalidDate();
                }
            }

            function fromNow(withoutSuffix) {
                return this.from(createLocal(), withoutSuffix);
            }

            function to(time, withoutSuffix) {
                if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
                    return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
                } else {
                    return this.localeData().invalidDate();
                }
            }

            function toNow(withoutSuffix) {
                return this.to(createLocal(), withoutSuffix);
            }

            // If passed a locale key, it will set the locale for this
            // instance.  Otherwise, it will return the locale configuration
            // variables for this instance.
            function locale(key) {
                var newLocaleData;

                if (key === undefined) {
                    return this._locale._abbr;
                } else {
                    newLocaleData = getLocale(key);
                    if (newLocaleData != null) {
                        this._locale = newLocaleData;
                    }
                    return this;
                }
            }

            var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
                if (key === undefined) {
                    return this.localeData();
                } else {
                    return this.locale(key);
                }
            });

            function localeData() {
                return this._locale;
            }

            var MS_PER_SECOND = 1000;
            var MS_PER_MINUTE = 60 * MS_PER_SECOND;
            var MS_PER_HOUR = 60 * MS_PER_MINUTE;
            var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

            // actual modulo - handles negative numbers (for dates before 1970):
            function mod$1(dividend, divisor) {
                return (dividend % divisor + divisor) % divisor;
            }

            function localStartOfDate(y, m, d) {
                // the date constructor remaps years 0-99 to 1900-1999
                if (y < 100 && y >= 0) {
                    // preserve leap years using a full 400 year cycle, then reset
                    return new Date(y + 400, m, d) - MS_PER_400_YEARS;
                } else {
                    return new Date(y, m, d).valueOf();
                }
            }

            function utcStartOfDate(y, m, d) {
                // Date.UTC remaps years 0-99 to 1900-1999
                if (y < 100 && y >= 0) {
                    // preserve leap years using a full 400 year cycle, then reset
                    return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
                } else {
                    return Date.UTC(y, m, d);
                }
            }

            function startOf(units) {
                var time;
                units = normalizeUnits(units);
                if (units === undefined || units === 'millisecond' || !this.isValid()) {
                    return this;
                }

                var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

                switch (units) {
                    case 'year':
                        time = startOfDate(this.year(), 0, 1);
                        break;
                    case 'quarter':
                        time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                        break;
                    case 'month':
                        time = startOfDate(this.year(), this.month(), 1);
                        break;
                    case 'week':
                        time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                        break;
                    case 'isoWeek':
                        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                        break;
                    case 'day':
                    case 'date':
                        time = startOfDate(this.year(), this.month(), this.date());
                        break;
                    case 'hour':
                        time = this._d.valueOf();
                        time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                        break;
                    case 'minute':
                        time = this._d.valueOf();
                        time -= mod$1(time, MS_PER_MINUTE);
                        break;
                    case 'second':
                        time = this._d.valueOf();
                        time -= mod$1(time, MS_PER_SECOND);
                        break;
                }

                this._d.setTime(time);
                hooks.updateOffset(this, true);
                return this;
            }

            function endOf(units) {
                var time;
                units = normalizeUnits(units);
                if (units === undefined || units === 'millisecond' || !this.isValid()) {
                    return this;
                }

                var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

                switch (units) {
                    case 'year':
                        time = startOfDate(this.year() + 1, 0, 1) - 1;
                        break;
                    case 'quarter':
                        time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                        break;
                    case 'month':
                        time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                        break;
                    case 'week':
                        time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                        break;
                    case 'isoWeek':
                        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                        break;
                    case 'day':
                    case 'date':
                        time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                        break;
                    case 'hour':
                        time = this._d.valueOf();
                        time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                        break;
                    case 'minute':
                        time = this._d.valueOf();
                        time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                        break;
                    case 'second':
                        time = this._d.valueOf();
                        time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                        break;
                }

                this._d.setTime(time);
                hooks.updateOffset(this, true);
                return this;
            }

            function valueOf() {
                return this._d.valueOf() - (this._offset || 0) * 60000;
            }

            function unix() {
                return Math.floor(this.valueOf() / 1000);
            }

            function toDate() {
                return new Date(this.valueOf());
            }

            function toArray() {
                var m = this;
                return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
            }

            function toObject() {
                var m = this;
                return {
                    years: m.year(),
                    months: m.month(),
                    date: m.date(),
                    hours: m.hours(),
                    minutes: m.minutes(),
                    seconds: m.seconds(),
                    milliseconds: m.milliseconds()
                };
            }

            function toJSON() {
                // new Date(NaN).toJSON() === null
                return this.isValid() ? this.toISOString() : null;
            }

            function isValid$2() {
                return isValid(this);
            }

            function parsingFlags() {
                return extend({}, getParsingFlags(this));
            }

            function invalidAt() {
                return getParsingFlags(this).overflow;
            }

            function creationData() {
                return {
                    input: this._i,
                    format: this._f,
                    locale: this._locale,
                    isUTC: this._isUTC,
                    strict: this._strict
                };
            }

            // FORMATTING

            addFormatToken(0, ['gg', 2], 0, function () {
                return this.weekYear() % 100;
            });

            addFormatToken(0, ['GG', 2], 0, function () {
                return this.isoWeekYear() % 100;
            });

            function addWeekYearFormatToken(token, getter) {
                addFormatToken(0, [token, token.length], 0, getter);
            }

            addWeekYearFormatToken('gggg', 'weekYear');
            addWeekYearFormatToken('ggggg', 'weekYear');
            addWeekYearFormatToken('GGGG', 'isoWeekYear');
            addWeekYearFormatToken('GGGGG', 'isoWeekYear');

            // ALIASES

            addUnitAlias('weekYear', 'gg');
            addUnitAlias('isoWeekYear', 'GG');

            // PRIORITY

            addUnitPriority('weekYear', 1);
            addUnitPriority('isoWeekYear', 1);

            // PARSING

            addRegexToken('G', matchSigned);
            addRegexToken('g', matchSigned);
            addRegexToken('GG', match1to2, match2);
            addRegexToken('gg', match1to2, match2);
            addRegexToken('GGGG', match1to4, match4);
            addRegexToken('gggg', match1to4, match4);
            addRegexToken('GGGGG', match1to6, match6);
            addRegexToken('ggggg', match1to6, match6);

            addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
                week[token.substr(0, 2)] = toInt(input);
            });

            addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
                week[token] = hooks.parseTwoDigitYear(input);
            });

            // MOMENTS

            function getSetWeekYear(input) {
                return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
            }

            function getSetISOWeekYear(input) {
                return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
            }

            function getISOWeeksInYear() {
                return weeksInYear(this.year(), 1, 4);
            }

            function getWeeksInYear() {
                var weekInfo = this.localeData()._week;
                return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
            }

            function getSetWeekYearHelper(input, week, weekday, dow, doy) {
                var weeksTarget;
                if (input == null) {
                    return weekOfYear(this, dow, doy).year;
                } else {
                    weeksTarget = weeksInYear(input, dow, doy);
                    if (week > weeksTarget) {
                        week = weeksTarget;
                    }
                    return setWeekAll.call(this, input, week, weekday, dow, doy);
                }
            }

            function setWeekAll(weekYear, week, weekday, dow, doy) {
                var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
                    date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

                this.year(date.getUTCFullYear());
                this.month(date.getUTCMonth());
                this.date(date.getUTCDate());
                return this;
            }

            // FORMATTING

            addFormatToken('Q', 0, 'Qo', 'quarter');

            // ALIASES

            addUnitAlias('quarter', 'Q');

            // PRIORITY

            addUnitPriority('quarter', 7);

            // PARSING

            addRegexToken('Q', match1);
            addParseToken('Q', function (input, array) {
                array[MONTH] = (toInt(input) - 1) * 3;
            });

            // MOMENTS

            function getSetQuarter(input) {
                return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
            }

            // FORMATTING

            addFormatToken('D', ['DD', 2], 'Do', 'date');

            // ALIASES

            addUnitAlias('date', 'D');

            // PRIORITY
            addUnitPriority('date', 9);

            // PARSING

            addRegexToken('D', match1to2);
            addRegexToken('DD', match1to2, match2);
            addRegexToken('Do', function (isStrict, locale) {
                // TODO: Remove "ordinalParse" fallback in next major release.
                return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
            });

            addParseToken(['D', 'DD'], DATE);
            addParseToken('Do', function (input, array) {
                array[DATE] = toInt(input.match(match1to2)[0]);
            });

            // MOMENTS

            var getSetDayOfMonth = makeGetSet('Date', true);

            // FORMATTING

            addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

            // ALIASES

            addUnitAlias('dayOfYear', 'DDD');

            // PRIORITY
            addUnitPriority('dayOfYear', 4);

            // PARSING

            addRegexToken('DDD', match1to3);
            addRegexToken('DDDD', match3);
            addParseToken(['DDD', 'DDDD'], function (input, array, config) {
                config._dayOfYear = toInt(input);
            });

            // HELPERS

            // MOMENTS

            function getSetDayOfYear(input) {
                var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
                return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
            }

            // FORMATTING

            addFormatToken('m', ['mm', 2], 0, 'minute');

            // ALIASES

            addUnitAlias('minute', 'm');

            // PRIORITY

            addUnitPriority('minute', 14);

            // PARSING

            addRegexToken('m', match1to2);
            addRegexToken('mm', match1to2, match2);
            addParseToken(['m', 'mm'], MINUTE);

            // MOMENTS

            var getSetMinute = makeGetSet('Minutes', false);

            // FORMATTING

            addFormatToken('s', ['ss', 2], 0, 'second');

            // ALIASES

            addUnitAlias('second', 's');

            // PRIORITY

            addUnitPriority('second', 15);

            // PARSING

            addRegexToken('s', match1to2);
            addRegexToken('ss', match1to2, match2);
            addParseToken(['s', 'ss'], SECOND);

            // MOMENTS

            var getSetSecond = makeGetSet('Seconds', false);

            // FORMATTING

            addFormatToken('S', 0, 0, function () {
                return ~~(this.millisecond() / 100);
            });

            addFormatToken(0, ['SS', 2], 0, function () {
                return ~~(this.millisecond() / 10);
            });

            addFormatToken(0, ['SSS', 3], 0, 'millisecond');
            addFormatToken(0, ['SSSS', 4], 0, function () {
                return this.millisecond() * 10;
            });
            addFormatToken(0, ['SSSSS', 5], 0, function () {
                return this.millisecond() * 100;
            });
            addFormatToken(0, ['SSSSSS', 6], 0, function () {
                return this.millisecond() * 1000;
            });
            addFormatToken(0, ['SSSSSSS', 7], 0, function () {
                return this.millisecond() * 10000;
            });
            addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
                return this.millisecond() * 100000;
            });
            addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
                return this.millisecond() * 1000000;
            });

            // ALIASES

            addUnitAlias('millisecond', 'ms');

            // PRIORITY

            addUnitPriority('millisecond', 16);

            // PARSING

            addRegexToken('S', match1to3, match1);
            addRegexToken('SS', match1to3, match2);
            addRegexToken('SSS', match1to3, match3);

            var token;
            for (token = 'SSSS'; token.length <= 9; token += 'S') {
                addRegexToken(token, matchUnsigned);
            }

            function parseMs(input, array) {
                array[MILLISECOND] = toInt(('0.' + input) * 1000);
            }

            for (token = 'S'; token.length <= 9; token += 'S') {
                addParseToken(token, parseMs);
            }
            // MOMENTS

            var getSetMillisecond = makeGetSet('Milliseconds', false);

            // FORMATTING

            addFormatToken('z', 0, 0, 'zoneAbbr');
            addFormatToken('zz', 0, 0, 'zoneName');

            // MOMENTS

            function getZoneAbbr() {
                return this._isUTC ? 'UTC' : '';
            }

            function getZoneName() {
                return this._isUTC ? 'Coordinated Universal Time' : '';
            }

            var proto = Moment.prototype;

            proto.add = add;
            proto.calendar = calendar$1;
            proto.clone = clone;
            proto.diff = diff;
            proto.endOf = endOf;
            proto.format = format;
            proto.from = from;
            proto.fromNow = fromNow;
            proto.to = to;
            proto.toNow = toNow;
            proto.get = stringGet;
            proto.invalidAt = invalidAt;
            proto.isAfter = isAfter;
            proto.isBefore = isBefore;
            proto.isBetween = isBetween;
            proto.isSame = isSame;
            proto.isSameOrAfter = isSameOrAfter;
            proto.isSameOrBefore = isSameOrBefore;
            proto.isValid = isValid$2;
            proto.lang = lang;
            proto.locale = locale;
            proto.localeData = localeData;
            proto.max = prototypeMax;
            proto.min = prototypeMin;
            proto.parsingFlags = parsingFlags;
            proto.set = stringSet;
            proto.startOf = startOf;
            proto.subtract = subtract;
            proto.toArray = toArray;
            proto.toObject = toObject;
            proto.toDate = toDate;
            proto.toISOString = toISOString;
            proto.inspect = inspect;
            proto.toJSON = toJSON;
            proto.toString = toString;
            proto.unix = unix;
            proto.valueOf = valueOf;
            proto.creationData = creationData;
            proto.year = getSetYear;
            proto.isLeapYear = getIsLeapYear;
            proto.weekYear = getSetWeekYear;
            proto.isoWeekYear = getSetISOWeekYear;
            proto.quarter = proto.quarters = getSetQuarter;
            proto.month = getSetMonth;
            proto.daysInMonth = getDaysInMonth;
            proto.week = proto.weeks = getSetWeek;
            proto.isoWeek = proto.isoWeeks = getSetISOWeek;
            proto.weeksInYear = getWeeksInYear;
            proto.isoWeeksInYear = getISOWeeksInYear;
            proto.date = getSetDayOfMonth;
            proto.day = proto.days = getSetDayOfWeek;
            proto.weekday = getSetLocaleDayOfWeek;
            proto.isoWeekday = getSetISODayOfWeek;
            proto.dayOfYear = getSetDayOfYear;
            proto.hour = proto.hours = getSetHour;
            proto.minute = proto.minutes = getSetMinute;
            proto.second = proto.seconds = getSetSecond;
            proto.millisecond = proto.milliseconds = getSetMillisecond;
            proto.utcOffset = getSetOffset;
            proto.utc = setOffsetToUTC;
            proto.local = setOffsetToLocal;
            proto.parseZone = setOffsetToParsedOffset;
            proto.hasAlignedHourOffset = hasAlignedHourOffset;
            proto.isDST = isDaylightSavingTime;
            proto.isLocal = isLocal;
            proto.isUtcOffset = isUtcOffset;
            proto.isUtc = isUtc;
            proto.isUTC = isUtc;
            proto.zoneAbbr = getZoneAbbr;
            proto.zoneName = getZoneName;
            proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
            proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
            proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
            proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
            proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

            function createUnix(input) {
                return createLocal(input * 1000);
            }

            function createInZone() {
                return createLocal.apply(null, arguments).parseZone();
            }

            function preParsePostFormat(string) {
                return string;
            }

            var proto$1 = Locale.prototype;

            proto$1.calendar = calendar;
            proto$1.longDateFormat = longDateFormat;
            proto$1.invalidDate = invalidDate;
            proto$1.ordinal = ordinal;
            proto$1.preparse = preParsePostFormat;
            proto$1.postformat = preParsePostFormat;
            proto$1.relativeTime = relativeTime;
            proto$1.pastFuture = pastFuture;
            proto$1.set = set;

            proto$1.months = localeMonths;
            proto$1.monthsShort = localeMonthsShort;
            proto$1.monthsParse = localeMonthsParse;
            proto$1.monthsRegex = monthsRegex;
            proto$1.monthsShortRegex = monthsShortRegex;
            proto$1.week = localeWeek;
            proto$1.firstDayOfYear = localeFirstDayOfYear;
            proto$1.firstDayOfWeek = localeFirstDayOfWeek;

            proto$1.weekdays = localeWeekdays;
            proto$1.weekdaysMin = localeWeekdaysMin;
            proto$1.weekdaysShort = localeWeekdaysShort;
            proto$1.weekdaysParse = localeWeekdaysParse;

            proto$1.weekdaysRegex = weekdaysRegex;
            proto$1.weekdaysShortRegex = weekdaysShortRegex;
            proto$1.weekdaysMinRegex = weekdaysMinRegex;

            proto$1.isPM = localeIsPM;
            proto$1.meridiem = localeMeridiem;

            function get$1(format, index, field, setter) {
                var locale = getLocale();
                var utc = createUTC().set(setter, index);
                return locale[field](utc, format);
            }

            function listMonthsImpl(format, index, field) {
                if (isNumber(format)) {
                    index = format;
                    format = undefined;
                }

                format = format || '';

                if (index != null) {
                    return get$1(format, index, field, 'month');
                }

                var i;
                var out = [];
                for (i = 0; i < 12; i++) {
                    out[i] = get$1(format, i, field, 'month');
                }
                return out;
            }

            // ()
            // (5)
            // (fmt, 5)
            // (fmt)
            // (true)
            // (true, 5)
            // (true, fmt, 5)
            // (true, fmt)
            function listWeekdaysImpl(localeSorted, format, index, field) {
                if (typeof localeSorted === 'boolean') {
                    if (isNumber(format)) {
                        index = format;
                        format = undefined;
                    }

                    format = format || '';
                } else {
                    format = localeSorted;
                    index = format;
                    localeSorted = false;

                    if (isNumber(format)) {
                        index = format;
                        format = undefined;
                    }

                    format = format || '';
                }

                var locale = getLocale(),
                    shift = localeSorted ? locale._week.dow : 0;

                if (index != null) {
                    return get$1(format, (index + shift) % 7, field, 'day');
                }

                var i;
                var out = [];
                for (i = 0; i < 7; i++) {
                    out[i] = get$1(format, (i + shift) % 7, field, 'day');
                }
                return out;
            }

            function listMonths(format, index) {
                return listMonthsImpl(format, index, 'months');
            }

            function listMonthsShort(format, index) {
                return listMonthsImpl(format, index, 'monthsShort');
            }

            function listWeekdays(localeSorted, format, index) {
                return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
            }

            function listWeekdaysShort(localeSorted, format, index) {
                return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
            }

            function listWeekdaysMin(localeSorted, format, index) {
                return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
            }

            getSetGlobalLocale('en', {
                dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                ordinal: function ordinal(number) {
                    var b = number % 10,
                        output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                    return number + output;
                }
            });

            // Side effect imports

            hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
            hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

            var mathAbs = Math.abs;

            function abs() {
                var data = this._data;

                this._milliseconds = mathAbs(this._milliseconds);
                this._days = mathAbs(this._days);
                this._months = mathAbs(this._months);

                data.milliseconds = mathAbs(data.milliseconds);
                data.seconds = mathAbs(data.seconds);
                data.minutes = mathAbs(data.minutes);
                data.hours = mathAbs(data.hours);
                data.months = mathAbs(data.months);
                data.years = mathAbs(data.years);

                return this;
            }

            function addSubtract$1(duration, input, value, direction) {
                var other = createDuration(input, value);

                duration._milliseconds += direction * other._milliseconds;
                duration._days += direction * other._days;
                duration._months += direction * other._months;

                return duration._bubble();
            }

            // supports only 2.0-style add(1, 's') or add(duration)
            function add$1(input, value) {
                return addSubtract$1(this, input, value, 1);
            }

            // supports only 2.0-style subtract(1, 's') or subtract(duration)
            function subtract$1(input, value) {
                return addSubtract$1(this, input, value, -1);
            }

            function absCeil(number) {
                if (number < 0) {
                    return Math.floor(number);
                } else {
                    return Math.ceil(number);
                }
            }

            function bubble() {
                var milliseconds = this._milliseconds;
                var days = this._days;
                var months = this._months;
                var data = this._data;
                var seconds, minutes, hours, years, monthsFromDays;

                // if we have a mix of positive and negative values, bubble down first
                // check: https://github.com/moment/moment/issues/2166
                if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
                    milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
                    days = 0;
                    months = 0;
                }

                // The following code bubbles up values, see the tests for
                // examples of what that means.
                data.milliseconds = milliseconds % 1000;

                seconds = absFloor(milliseconds / 1000);
                data.seconds = seconds % 60;

                minutes = absFloor(seconds / 60);
                data.minutes = minutes % 60;

                hours = absFloor(minutes / 60);
                data.hours = hours % 24;

                days += absFloor(hours / 24);

                // convert days to months
                monthsFromDays = absFloor(daysToMonths(days));
                months += monthsFromDays;
                days -= absCeil(monthsToDays(monthsFromDays));

                // 12 months -> 1 year
                years = absFloor(months / 12);
                months %= 12;

                data.days = days;
                data.months = months;
                data.years = years;

                return this;
            }

            function daysToMonths(days) {
                // 400 years have 146097 days (taking into account leap year rules)
                // 400 years have 12 months === 4800
                return days * 4800 / 146097;
            }

            function monthsToDays(months) {
                // the reverse of daysToMonths
                return months * 146097 / 4800;
            }

            function as(units) {
                if (!this.isValid()) {
                    return NaN;
                }
                var days;
                var months;
                var milliseconds = this._milliseconds;

                units = normalizeUnits(units);

                if (units === 'month' || units === 'quarter' || units === 'year') {
                    days = this._days + milliseconds / 864e5;
                    months = this._months + daysToMonths(days);
                    switch (units) {
                        case 'month':
                            return months;
                        case 'quarter':
                            return months / 3;
                        case 'year':
                            return months / 12;
                    }
                } else {
                    // handle milliseconds separately because of floating point math errors (issue #1867)
                    days = this._days + Math.round(monthsToDays(this._months));
                    switch (units) {
                        case 'week':
                            return days / 7 + milliseconds / 6048e5;
                        case 'day':
                            return days + milliseconds / 864e5;
                        case 'hour':
                            return days * 24 + milliseconds / 36e5;
                        case 'minute':
                            return days * 1440 + milliseconds / 6e4;
                        case 'second':
                            return days * 86400 + milliseconds / 1000;
                        // Math.floor prevents floating point math errors here
                        case 'millisecond':
                            return Math.floor(days * 864e5) + milliseconds;
                        default:
                            throw new Error('Unknown unit ' + units);
                    }
                }
            }

            // TODO: Use this.as('ms')?
            function valueOf$1() {
                if (!this.isValid()) {
                    return NaN;
                }
                return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
            }

            function makeAs(alias) {
                return function () {
                    return this.as(alias);
                };
            }

            var asMilliseconds = makeAs('ms');
            var asSeconds = makeAs('s');
            var asMinutes = makeAs('m');
            var asHours = makeAs('h');
            var asDays = makeAs('d');
            var asWeeks = makeAs('w');
            var asMonths = makeAs('M');
            var asQuarters = makeAs('Q');
            var asYears = makeAs('y');

            function clone$1() {
                return createDuration(this);
            }

            function get$2(units) {
                units = normalizeUnits(units);
                return this.isValid() ? this[units + 's']() : NaN;
            }

            function makeGetter(name) {
                return function () {
                    return this.isValid() ? this._data[name] : NaN;
                };
            }

            var milliseconds = makeGetter('milliseconds');
            var seconds = makeGetter('seconds');
            var minutes = makeGetter('minutes');
            var hours = makeGetter('hours');
            var days = makeGetter('days');
            var months = makeGetter('months');
            var years = makeGetter('years');

            function weeks() {
                return absFloor(this.days() / 7);
            }

            var round = Math.round;
            var thresholds = {
                ss: 44, // a few seconds to seconds
                s: 45, // seconds to minute
                m: 45, // minutes to hour
                h: 22, // hours to day
                d: 26, // days to month
                M: 11 // months to year
            };

            // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
            function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
                return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
            }

            function relativeTime$1(posNegDuration, withoutSuffix, locale) {
                var duration = createDuration(posNegDuration).abs();
                var seconds = round(duration.as('s'));
                var minutes = round(duration.as('m'));
                var hours = round(duration.as('h'));
                var days = round(duration.as('d'));
                var months = round(duration.as('M'));
                var years = round(duration.as('y'));

                var a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days] || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];

                a[2] = withoutSuffix;
                a[3] = +posNegDuration > 0;
                a[4] = locale;
                return substituteTimeAgo.apply(null, a);
            }

            // This function allows you to set the rounding function for relative time strings
            function getSetRelativeTimeRounding(roundingFunction) {
                if (roundingFunction === undefined) {
                    return round;
                }
                if (typeof roundingFunction === 'function') {
                    round = roundingFunction;
                    return true;
                }
                return false;
            }

            // This function allows you to set a threshold for relative time strings
            function getSetRelativeTimeThreshold(threshold, limit) {
                if (thresholds[threshold] === undefined) {
                    return false;
                }
                if (limit === undefined) {
                    return thresholds[threshold];
                }
                thresholds[threshold] = limit;
                if (threshold === 's') {
                    thresholds.ss = limit - 1;
                }
                return true;
            }

            function humanize(withSuffix) {
                if (!this.isValid()) {
                    return this.localeData().invalidDate();
                }

                var locale = this.localeData();
                var output = relativeTime$1(this, !withSuffix, locale);

                if (withSuffix) {
                    output = locale.pastFuture(+this, output);
                }

                return locale.postformat(output);
            }

            var abs$1 = Math.abs;

            function sign(x) {
                return (x > 0) - (x < 0) || +x;
            }

            function toISOString$1() {
                // for ISO strings we do not use the normal bubbling rules:
                //  * milliseconds bubble up until they become hours
                //  * days do not bubble at all
                //  * months bubble up until they become years
                // This is because there is no context-free conversion between hours and days
                // (think of clock changes)
                // and also not between days and months (28-31 days per month)
                if (!this.isValid()) {
                    return this.localeData().invalidDate();
                }

                var seconds = abs$1(this._milliseconds) / 1000;
                var days = abs$1(this._days);
                var months = abs$1(this._months);
                var minutes, hours, years;

                // 3600 seconds -> 60 minutes -> 1 hour
                minutes = absFloor(seconds / 60);
                hours = absFloor(minutes / 60);
                seconds %= 60;
                minutes %= 60;

                // 12 months -> 1 year
                years = absFloor(months / 12);
                months %= 12;

                // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
                var Y = years;
                var M = months;
                var D = days;
                var h = hours;
                var m = minutes;
                var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
                var total = this.asSeconds();

                if (!total) {
                    // this is the same as C#'s (Noda) and python (isodate)...
                    // but not other JS (goog.date)
                    return 'P0D';
                }

                var totalSign = total < 0 ? '-' : '';
                var ymSign = sign(this._months) !== sign(total) ? '-' : '';
                var daysSign = sign(this._days) !== sign(total) ? '-' : '';
                var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

                return totalSign + 'P' + (Y ? ymSign + Y + 'Y' : '') + (M ? ymSign + M + 'M' : '') + (D ? daysSign + D + 'D' : '') + (h || m || s ? 'T' : '') + (h ? hmsSign + h + 'H' : '') + (m ? hmsSign + m + 'M' : '') + (s ? hmsSign + s + 'S' : '');
            }

            var proto$2 = Duration.prototype;

            proto$2.isValid = isValid$1;
            proto$2.abs = abs;
            proto$2.add = add$1;
            proto$2.subtract = subtract$1;
            proto$2.as = as;
            proto$2.asMilliseconds = asMilliseconds;
            proto$2.asSeconds = asSeconds;
            proto$2.asMinutes = asMinutes;
            proto$2.asHours = asHours;
            proto$2.asDays = asDays;
            proto$2.asWeeks = asWeeks;
            proto$2.asMonths = asMonths;
            proto$2.asQuarters = asQuarters;
            proto$2.asYears = asYears;
            proto$2.valueOf = valueOf$1;
            proto$2._bubble = bubble;
            proto$2.clone = clone$1;
            proto$2.get = get$2;
            proto$2.milliseconds = milliseconds;
            proto$2.seconds = seconds;
            proto$2.minutes = minutes;
            proto$2.hours = hours;
            proto$2.days = days;
            proto$2.weeks = weeks;
            proto$2.months = months;
            proto$2.years = years;
            proto$2.humanize = humanize;
            proto$2.toISOString = toISOString$1;
            proto$2.toString = toISOString$1;
            proto$2.toJSON = toISOString$1;
            proto$2.locale = locale;
            proto$2.localeData = localeData;

            proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
            proto$2.lang = lang;

            // Side effect imports

            // FORMATTING

            addFormatToken('X', 0, 0, 'unix');
            addFormatToken('x', 0, 0, 'valueOf');

            // PARSING

            addRegexToken('x', matchSigned);
            addRegexToken('X', matchTimestamp);
            addParseToken('X', function (input, array, config) {
                config._d = new Date(parseFloat(input, 10) * 1000);
            });
            addParseToken('x', function (input, array, config) {
                config._d = new Date(toInt(input));
            });

            // Side effect imports


            hooks.version = '2.24.0';

            setHookCallback(createLocal);

            hooks.fn = proto;
            hooks.min = min;
            hooks.max = max;
            hooks.now = now;
            hooks.utc = createUTC;
            hooks.unix = createUnix;
            hooks.months = listMonths;
            hooks.isDate = isDate;
            hooks.locale = getSetGlobalLocale;
            hooks.invalid = createInvalid;
            hooks.duration = createDuration;
            hooks.isMoment = isMoment;
            hooks.weekdays = listWeekdays;
            hooks.parseZone = createInZone;
            hooks.localeData = getLocale;
            hooks.isDuration = isDuration;
            hooks.monthsShort = listMonthsShort;
            hooks.weekdaysMin = listWeekdaysMin;
            hooks.defineLocale = defineLocale;
            hooks.updateLocale = updateLocale;
            hooks.locales = listLocales;
            hooks.weekdaysShort = listWeekdaysShort;
            hooks.normalizeUnits = normalizeUnits;
            hooks.relativeTimeRounding = getSetRelativeTimeRounding;
            hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
            hooks.calendarFormat = getCalendarFormat;
            hooks.prototype = proto;

            // currently HTML5 input type only supports 24-hour formats
            hooks.HTML5_FMT = {
                DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
                DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
                DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
                DATE: 'YYYY-MM-DD', // <input type="date" />
                TIME: 'HH:mm', // <input type="time" />
                TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
                TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
                WEEK: 'GGGG-[W]WW', // <input type="week" />
                MONTH: 'YYYY-MM' // <input type="month" />
            };

            return hooks;
        });
    });

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    };

    function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                arr2[i] = arr[i];
            }return arr2;
        } else {
            return Array.from(arr);
        }
    }

    var vueMoment = {
        install: function install(Vue, options) {
            var moment$$1 = options && options.moment ? options.moment : moment;

            Object.defineProperties(Vue.prototype, {
                $moment: {
                    get: function get() {
                        return moment$$1;
                    }
                }
            });

            Vue.moment = moment$$1;

            Vue.filter('moment', function () {
                var arguments$1 = arguments;

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments$1[_key];
                }

                args = Array.prototype.slice.call(args);
                var input = args.shift();
                var date = void 0;

                if (Array.isArray(input) && typeof input[0] === 'string') {
                    // If input is array, assume we're being passed a format pattern to parse against.
                    // Format pattern will accept an array of potential formats to parse against.
                    // Date string should be at [0], format pattern(s) should be at [1]
                    date = moment$$1(input[0], input[1], true);
                } else if (typeof input === 'number') {
                    if (input.toString().length < 12) {
                        // If input is an integer with fewer than 12 digits, assume Unix seconds...
                        date = moment$$1.unix(input);
                    } else {
                        // ..otherwise, assume milliseconds.
                        date = moment$$1(input);
                    }
                } else {
                    // Otherwise, throw the input at moment and see what happens...
                    date = moment$$1(input);
                }

                if (!input || !date.isValid()) {
                    // Log a warning if moment couldn't reconcile the input. Better than throwing an error?
                    console.warn('Could not build a valid `moment` object from input.');
                    return input;
                }

                function parse() {
                    var arguments$1 = arguments;

                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments$1[_key2];
                    }

                    args = Array.prototype.slice.call(args);
                    var method = args.shift();

                    switch (method) {
                        case 'add':
                            {
                                /*
                                * Mutates the original moment by adding time.
                                * http://momentjs.com/docs/#/manipulating/add/
                                */

                                var addends = args.shift().split(',').map(Function.prototype.call, String.prototype.trim);
                                var obj = {};

                                for (var n = 0; n < addends.length; n++) {
                                    var addend = addends[n].split(' ');
                                    obj[addend[1]] = addend[0];
                                }
                                date.add(obj);
                                break;
                            }

                        case 'subtract':
                            {
                                /*
                                * Mutates the original moment by subtracting time.
                                * http://momentjs.com/docs/#/manipulating/subtract/
                                */

                                var subtrahends = args.shift().split(',').map(Function.prototype.call, String.prototype.trim);
                                var _obj = {};

                                for (var _n = 0; _n < subtrahends.length; _n++) {
                                    var subtrahend = subtrahends[_n].split(' ');
                                    _obj[subtrahend[1]] = subtrahend[0];
                                }
                                date.subtract(_obj);
                                break;
                            }

                        case 'from':
                            {
                                /*
                                * Display a moment in relative time, either from now or from a specified date.
                                * http://momentjs.com/docs/#/displaying/fromnow/
                                */

                                var from = 'now';
                                var removeSuffix = false;

                                if (args[0] === 'now') {
                                    args.shift();
                                }
                                // If valid, assume it is a date we want the output computed against.
                                if (moment$$1(args[0]).isValid()) {
                                    from = moment$$1(args.shift());
                                }

                                if (args[0] === true) {
                                    args.shift();
                                    removeSuffix = true;
                                }

                                if (from !== 'now') {
                                    date = date.from(from, removeSuffix);
                                } else {
                                    date = date.fromNow(removeSuffix);
                                }
                                break;
                            }

                        case 'diff':
                            {
                                /*
                                * Mutates the original moment by doing a difference with another date.
                                * http://momentjs.com/docs/#/displaying/difference/
                                */

                                var referenceTime = moment$$1();
                                var units = '';
                                var float = false;

                                if (moment$$1(args[0]).isValid()) {
                                    // If valid, assume it is a date we want the output computed against.
                                    referenceTime = moment$$1(args.shift());
                                } else if (args[0] === null || args[0] === 'now') {
                                    // If null or 'now', remove argument and proceed with default referenceTime.
                                    args.shift();
                                }

                                if (args[0]) {
                                    units = args.shift();
                                }

                                if (args[0] === true) {
                                    float = args.shift();
                                }

                                date = date.diff(referenceTime, units, float);
                                break;
                            }

                        case 'calendar':
                            {
                                /*
                                * Formats a date with different strings depending on how close
                                * to a certain date (today by default) the date is.
                                * http://momentjs.com/docs/#/displaying/calendar-time/
                                */

                                var _referenceTime = moment$$1();
                                var formats = {};

                                if (moment$$1(args[0]).isValid()) {
                                    // If valid, assume it is a date we want the output computed against.
                                    _referenceTime = moment$$1(args.shift());
                                } else if (args[0] === null || args[0] === 'now') {
                                    // If null or 'now', remove argument and proceed with default referenceTime.
                                    args.shift();
                                }

                                if (_typeof(args[0]) === 'object') {
                                    formats = args.shift();
                                }

                                date = date.calendar(_referenceTime, formats);
                                break;
                            }

                        case 'utc':
                            {
                                /*
                                * Mutates the original moment by converting to UTC
                                * https://momentjs.com/docs/#/manipulating/utc/
                                */
                                date.utc();
                                break;
                            }

                        case 'timezone':
                            {
                                /*
                                * Mutates the original moment by converting to a new timezone.
                                * https://momentjs.com/timezone/docs/#/using-timezones/converting-to-zone/
                                */
                                date.tz(args.shift());
                                break;
                            }

                        default:
                            {
                                /*
                                * Formats a date by taking a string of tokens and replacing
                                * them with their corresponding values.
                                * http://momentjs.com/docs/#/displaying/format/
                                */

                                var format = method;
                                date = date.format(format);
                            }
                    }

                    if (args.length) {
                        parse.apply(parse, args);
                    }
                }

                parse.apply(parse, args);

                return date;
            });

            Vue.filter('duration', function () {
                var arguments$1 = arguments;

                for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    args[_key3] = arguments$1[_key3];
                }

                /*
                * Basic pass-through filter for leveraging moment.js's ability
                * to manipulate and display durations.
                * https://momentjs.com/docs/#/durations/
                */
                args = Array.prototype.slice.call(args);
                var input = args.shift();
                var method = args.shift();

                function createDuration(time) {
                    if (!Array.isArray(time)) {
                        time = [time];
                    }
                    var result = moment$$1.duration.apply(moment$$1, _toConsumableArray(time));
                    if (!result.isValid()) {
                        console.warn('Could not build a valid `duration` object from input.');
                    }
                    return result;
                }
                var duration = createDuration(input);

                if (method === 'add' || method === 'subtract') {
                    // Generates a duration object and either adds or subtracts it
                    // from our original duration.
                    var durationChange = createDuration(args);
                    duration[method](durationChange);
                } else if (duration && duration[method]) {
                    var _duration;

                    // This gives a full proxy to moment.duration functions.
                    duration = (_duration = duration)[method].apply(_duration, _toConsumableArray(args));
                }

                return duration;
            });
        }
    };

    var vueMoment_1 = vueMoment.install;

    exports['default'] = vueMoment;
    exports.install = vueMoment_1;

    Object.defineProperty(exports, '__esModule', { value: true });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js